var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to2, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to2, key) && key !== except)
        __defProp(to2, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to2;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  A: () => A_default,
  AdditionalInfoSection: () => AdditionalInfoSection_default,
  AddressLabel: () => AddressLabel_default,
  Alert: () => Alert_default,
  Alerts: () => Alerts,
  AlertsContext: () => AlertsContext,
  AlertsProvider: () => AlertsProvider,
  ApiAccessChartWidget: () => ApiAccessChartWidget_default,
  Avatar: () => Avatar_default,
  AvatarUpload: () => AvatarUpload_default,
  Badge: () => Badge_default,
  Banner: () => Banner_default,
  BannerTypesEnum: () => BannerTypesEnum,
  BathsAndBedsSelect: () => BathsAndBedsSelect_default,
  Box: () => Box_default,
  Breadcrumb: () => Breadcrumb_default,
  BrokersBanner: () => BrokersBanner_default,
  BulkActionsContext: () => BulkActionsContext,
  BulkActionsProvider: () => BulkActionsProvider,
  Button: () => Button_default,
  ButtonGroups: () => ButtonGroups_default,
  Card: () => Card_default,
  CardPaymentForm: () => CardPaymentForm_default,
  Checkbox: () => Checkbox_default,
  ColorContext: () => ColorContext,
  ColorProvider: () => ColorProvider,
  CopyToClipboardButton: () => CopyToClipboardButton_default,
  DashPlaceholder: () => DashPlaceholder_default,
  DashboardBanner: () => DashboardBanner_default,
  DashboardNotificationBannerContext: () => DashboardNotificationBannerContext,
  DashboardNotificationBannerProvider: () => DashboardNotificationBannerProvider,
  DatePeriodPicker: () => DatePeriodPicker_default,
  DatePeriodTypesEnum: () => DatePeriodTypesEnum,
  DatePicker: () => DatePicker_default,
  DatePickerTimeRangeEnum: () => DatePickerTimeRangeEnum,
  DatePickerWithTimeRange: () => DatePickerWithTimeRange_default,
  DateRangePicker: () => DateRangePicker_default,
  DefaultPaginationValues: () => defaultContextValue4,
  DeleteModal: () => DeleteModal_default,
  DevelopInfoSection: () => DeveloperInfoSection_default,
  Devider: () => Devider_default,
  Drawer: () => Drawer,
  DropDown: () => DropDown_default,
  DropdownContext: () => DropdownContext,
  DropdownOptions: () => DropdownOptions_default,
  DropdownProvider: () => DropdownProvider,
  ExpandableText: () => ExpandableText_default,
  FeaturesAndAmenitiesList: () => FeaturesAndAmenitiesList_default,
  Feedback: () => Feedback_default,
  FileInput: () => FileInput_default,
  FileList: () => FileList_default,
  FilePreviewModal: () => FilePreviewModal_default,
  FileTypeIcon: () => FileTypeIcon_default,
  FileUpload: () => FileUpload_default,
  FilterContext: () => FilterContext,
  FilterProvider: () => FilterProvider,
  FlatPagination: () => FlatPagination_default,
  FlatPaginationContext: () => FlatPaginationContext,
  FlatPaginationProvider: () => FlatPaginationProvider,
  Flex: () => Flex_default,
  Form: () => Form_default,
  FormContext: () => FormContext,
  FormErrorMessages: () => FormErrorMessages,
  FormErrorTypes: () => FormErrorTypes,
  FormProvider: () => FormProvider,
  GeneralInfoSection: () => GeneralInfoSection_default,
  GoogleAutocomplete: () => GoogleAutocomplete_default,
  GoogleMap: () => GoogleMap_default,
  Group: () => Group_default,
  H: () => H_default,
  Icon: () => Icon_default,
  IconBadge: () => IconBadge_default,
  Image: () => Image_default,
  InfoCard: () => InfoCard_default,
  Input: () => Input_default,
  InputAutocomplete: () => InputAutocomplete_default,
  InputGroup: () => InputGroup_default,
  InputNumber: () => InputNumber_default,
  InputPassword: () => InputPassword_default,
  InputPercentage: () => InputPercentage_default,
  InputPhone: () => InputPhone_default,
  InputPrice: () => InputPrice_default,
  InputSearch: () => InputSearch_default,
  InventorySectionContext: () => InventorySectionContext,
  InventorySectionProvider: () => InventorySectionProvider,
  InventoryTable: () => InventoryTable_default,
  Label: () => Label_default,
  List: () => List_default,
  ListWithPagination: () => ListWithPagination_default,
  LocalCashTables: () => LocalCashTables,
  MapSection: () => MapSection_default,
  Marker: () => Marker_default,
  MarketingFiles: () => MarketingFiles_default,
  MarketingFilesContext: () => MarketingFilesContext,
  MarketingFilesProvider: () => MarketingFilesProvider,
  MediaDragAndDropContext: () => MediaDragAndDropContext,
  MediaDragAndDropProvider: () => MediaDragAndDropProvider,
  MediaFilePreviewCard: () => MediaFilePreviewCard_default,
  Modal: () => Modal3,
  ModalContext: () => ModalContext,
  ModalProvider: () => ModalProvider,
  ModalWithBrokerBanner: () => ModalWithBrokerBanner_default,
  MultiFileUploadContext: () => MultiFileUploadContext,
  MultiFileUploadProvider: () => MultiFileUploadProvider,
  NameSection: () => NameSection_default,
  NotFoundPage: () => NotFoundPage_default,
  PageViewContext: () => PageViewContext,
  PageViewProvider: () => PageViewProvider,
  PageViewToggle: () => PageViewToggle_default,
  PageViewTypeEnum: () => PageViewTypeEnum,
  Pagination: () => Pagination_default,
  PaginationContext: () => PaginationContext,
  PaginationInfoLabel: () => PaginationInfoLabel,
  PaginationLoadMore: () => PaginationLoadMore,
  PaginationPerPageSelect: () => PaginationPerPageSelect,
  PaginationProvider: () => PaginationProvider,
  PhoneInputMask: () => PhoneInputMask,
  PortfoliosTreeSelect: () => PortfoliosTreeSelect_default,
  PriceInputWithDropDown: () => PriceInputWithDropDown_default,
  PriceRange: () => PriceRange_default,
  ProgressBar: () => ProgressBar_default,
  PropertiesTable: () => PropertiesTable_default,
  PropertyHistoryModal: () => PropertyHistoryModal_default,
  PropertyMarker: () => PropertyMarker_default,
  PropertyPreviewNavigationTabs: () => PropertyNavigationTabs_default,
  RadioInput: () => RadioInput_default,
  RawNumberSelect: () => RawNumberSelect_default,
  ScrollDragable: () => ScrollDragable_default,
  SearchContext: () => SearchContext,
  SearchProvider: () => SearchProvider,
  Select: () => Select_default,
  SelectPrice: () => SelectPrice_default,
  SelectTree: () => SelectTree_default,
  SideBar: () => SideBar_default,
  Slider: () => Slider_default,
  Slideshow: () => Slideshow_default,
  SlideshowPreview: () => SlideshowPreview_default,
  SortByEnum: () => SortByEnum,
  SortContext: () => SortContext,
  SortHeader: () => SortHeader_default,
  SortProvider: () => SortProvider,
  Spinner: () => Spinner_default,
  Stepper: () => Stepper_default,
  Steps: () => Steps_default,
  SubscriptionRecurringSwitch: () => SubscriptionRecurringSwitch_default,
  Table: () => Table_default,
  TableView: () => TableView_default,
  TableViewContext: () => TableViewContext,
  TableViewProvider: () => TableViewProvider,
  TableViewToggle: () => TableViewToggle,
  TableViewType: () => TableViewType,
  TableWitPagination: () => TableWitPagination_default,
  TableWithFlatPagination: () => TableWithFlatPagination_default,
  Tabs: () => Tabs_default,
  Tag: () => Tag_default,
  TagSelect: () => TagSelect_default,
  Text: () => Text_default,
  Textarea: () => Textarea_default,
  ThemeProvider: () => theme_provider_default,
  Thumbnail: () => Thumbnail_default,
  TimePicker: () => TimePicker_default,
  ToastContainer: () => Toast_default,
  Toggle: () => Toggle_default,
  TooltipContext: () => TooltipContext,
  TooltipPopup: () => TooltipPopup_default,
  TooltipProvider: () => TooltipProvider,
  TooltipWrapper: () => TooltipWrapper_default,
  UnauthorizedPage: () => UnauthorizedPage_default,
  UpgradeSubscriptionModalType: () => UpgradeSubscriptionModalType,
  UploadMediaContainer: () => UploadMediaContainer_default,
  Video: () => Video_default,
  ViewerContext: () => ViewerContext,
  ViewerProvider: () => ViewerProvider,
  WasDeleted: () => WasDeleted_default,
  WorkingHoursInput: () => WorkingHoursInput_default,
  WorkingWeekHoursInput: () => WorkingWeekHoursInput_default,
  dictionary: () => dictionary,
  downloadFile: () => downloadFile,
  downloadMedia: () => downloadMedia,
  fetchAccessToken: () => fetchAccessToken,
  fileUploadFetch: () => fileUploadFetch,
  formatBathroomsRangeValues: () => formatBathroomsRangeValues,
  formatBedroomsRangeValues: () => formatBedroomsRangeValues,
  formatGeneralRangeValues: () => formatGeneralRangeValues,
  getPeriodRangeByPeriodType: () => getPeriodRangeByPeriodType,
  googlePlaceToAddress: () => googlePlaceToAddress,
  googleZoomLevelToMiles: () => googleZoomLevelToMiles,
  i18next: () => i18n_default,
  isAccessTokenExpired: () => isAccessTokenExpired,
  jwtDecodeSafely: () => jwtDecodeSafely,
  localStorage: () => localStorage2,
  mainTheme: () => mainTheme,
  mortgage: () => mortgage_exports,
  priceMaxRange: () => priceMaxRange,
  priceMaxRangeRent: () => priceMaxRangeRent,
  priceMinRange: () => priceMinRange,
  priceMinRangeRent: () => priceMinRangeRent,
  toast: () => toast,
  useAsyncState: () => useAsyncState,
  useCheckIfSubscriptionFeatureActiveBroker: () => useCheckIfSubscriptionFeatureActiveBroker,
  useFormState: () => useFormState,
  useFormValidation: () => useFormValidation,
  useFromNow: () => useFromNow,
  useGoogleApiLoader: () => useGoogleApiLoader,
  useIsVisible: () => useIsVisible,
  useOnClickOutside: () => useOnClickOutside,
  useScreenResolution: () => useScreenResolution,
  useServerResponseTranslation: () => useServerResponseTranslation,
  validatePrice: () => validatePrice
});
module.exports = __toCommonJS(src_exports);

// src/components/theme.provider.tsx
var import_react_modal = __toESM(require("react-modal"));
var import_react_i18next4 = require("react-i18next");
var import_styled_components12 = require("styled-components");
var import_react_dnd = require("react-dnd");
var import_react_dnd_html5_backend = require("react-dnd-html5-backend");

// src/i18n.ts
var import_react_i18next = require("react-i18next");
var import_dash_common4 = require("dash-common");
var import_i18next = __toESM(require("i18next"));

// src/assets/dictionary/index.ts
var import_dash_common3 = require("dash-common");

// src/assets/dictionary/en/common.ts
var import_dash_common = require("dash-common");
var import_lodash = require("lodash");
var common_default = {
  labels: {
    signOut: "Logout",
    account: "Account",
    apiUsers: "API Users",
    apiManagement: "API",
    settings: "Settings",
    properties: "Properties",
    propertyDetails: "Property Details",
    propertyPreview: "Property Overview",
    folderDetails: "Folder Details",
    rootMediaFolder: "Root Media Folder",
    users: "Users",
    salesTeam: "Sales Team",
    internalSaleTeam: "Internal Sales Team",
    organizations: "Organizations",
    organization: "Organization",
    organizationDetails: "Organization Details",
    featuresAndAmenities: "Features and Amenities",
    projectStatus: "Project Status",
    amenities: "Amenities",
    brokers: "Agents",
    testAccount: "Test Account",
    management: "Management",
    marketAreas: "Market Areas",
    externalSales: "External Sales",
    show: "Show",
    previous: "Previous",
    next: "Next",
    add: "Add",
    skip: "Skip",
    update: "Update",
    cancel: "Cancel",
    confirm: "Confirm",
    notFound: "Not Found",
    saveChanges: "Save Changes",
    save: "Save",
    close: "Close",
    for: "for",
    clear: "Clear",
    fullName: "Full name",
    uploadCancelled: "Upload Canceled",
    to: "To",
    edit: "Edit",
    delete: "Delete",
    view: "View",
    actions: "Actions",
    website: "Website",
    status: "Visibility Status",
    propertyStatus: "Property Status",
    notes: "Notes",
    preview: "Preview",
    name: "Name",
    phone: "Phone",
    seeMore: "See More",
    open: "Open",
    more: "More",
    private: "Private",
    public: "Public",
    draft: "Draft",
    media: "Media",
    inventory: "Inventory",
    information: "Information",
    advanced: "Advanced",
    description: "Description",
    metrics: "Metrics",
    partners: "Partners",
    companies: "Companies",
    pluginUsers: "Plugin Users",
    tracking: "Tracking",
    emptyColumn: "N/A",
    weekDays: {
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday"
    },
    today: "Today",
    dateRangePeriods: {
      currentWeek: "This Week",
      pastWeek: "Past Week",
      currentMonth: "This Month",
      pastMonth: "Past Month",
      threeMonth: "Three Months",
      custom: "Custom Time Period",
      currentYear: "This Year"
    },
    dateRangeGroups: {
      hourly: "Hourly",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly"
    },
    general: "General",
    location: "Location",
    folder: "Folder",
    folders: "Folders: ({{number}})",
    file: "File",
    files: "Files: ({{number}})",
    kBytes: "{{size}} KB",
    mBytes: "{{size}} MB",
    noOptions: "No Options",
    loading: "Loading...",
    from: "From",
    highlights: "Highlights",
    about: "About",
    archive: "Archive",
    unarchive: "Unarchive",
    rename: "Rename",
    move: "Move",
    cvv: "CVV",
    creditCardNumber: "Credit Card Number",
    expiryDate: "Expiry Date",
    fileName: "Filename",
    category: "Category",
    size: "Size",
    added: "Added",
    download: "Download",
    dashboard: "Dashboard",
    portfolios: "Portfolios",
    portfolioDetails: "Portfolio Details",
    messages: "Messages",
    resend: "Re-send",
    resendViaEmail: "Re-send Via Email",
    email: "Email",
    showMore: "Show More",
    showLess: "Show Less",
    any: "Any",
    miles: "Miles",
    subscription: "Subscription",
    payment: "Payment",
    contentCopy: "Duplicate",
    closed: "Closed",
    create: "Create",
    share: "Share",
    compare: "Compare",
    sortBy: "Sort By",
    sortAz: "Alphabetical A-Z",
    sortZa: "Alphabetical Z-A",
    sortCreatedAt: "Most Recently Added/Created",
    filterBy: "Filter By",
    selectAll: "Select All",
    change: "Change",
    state: "State",
    updated: "Updated",
    date: "Date",
    track: "Track",
    calculate: "Calculate",
    moreOptions: "More Options",
    lessOptions: "Less Options",
    remove: "Remove",
    submit: "Submit",
    verified: "Verified",
    developerVerified: "Developer Verified",
    unverified: "Unverified",
    comingSoon: "Coming Soon",
    coming_soon: "Coming Soon",
    soldOut: "Sold Out",
    sold_out: "Sold Out",
    proposed: "Proposed",
    new_construction: "New Construction",
    pre_construction: "Pre Construction",
    single_family_home: "Single Family Home",
    under_construction: "Under Construction",
    completed: "Completed",
    noValue: "N/A",
    subscriptionNotSelected: "Subscription is Not Selected",
    billingAddress: "Billing Address",
    send: "Send",
    viewEditAction: "View / Edit",
    subscriptionBanner: "You need to have a <tag>{{subscriptionType}}</tag> to get access to this page",
    newNote: "New Note",
    read: "Read",
    search: "Search",
    reactions: "Reactions",
    current: "Current",
    notBillable: "Not Billable",
    studio: "Studio",
    dashSuffix: "| DASH",
    dashCMSSuffix: "| DASH CMS",
    dashApiAdminSuffix: "| DASH API Admin",
    notWorking: "Not Working",
    browserTabTitles: {
      dashboard: "Agent Dashboard",
      properties: "Properties",
      portfolios: "Portfolios",
      unavailablePortfolioPage: "Portfolio Unavailable",
      profile: "Profile",
      tracking: "Tracked Properties",
      messages: "Messages",
      signIn: "Sign In",
      signUp: "Sign Up",
      completeSignUpCodeConfirmation: "Complete Sign Up",
      completeSignUpSSO: "Complete SSO Sign Up",
      forgotPassword: "Forgot/Lost Password",
      completeSignUpPickSubscription: "Pick Subscription",
      completeSignUpAddPayment: "Add Payment",
      stripeCheckoutResult: "Process Payment",
      completeSignUpAddAdditionalInfo: "Add Additional Info",
      resetPassword: "Reset Password",
      termConditions: "Terms and Conditions",
      privacyPolicy: "Privacy Policy",
      organizations: "Organizations",
      amenities: "Amenities",
      brokers: "Agents",
      externalSales: "External Sales",
      externalSalesUsers: "External Sales Users",
      management: "Management",
      account: "Account",
      apiUsers: "API Users",
      apiManagement: "API",
      apiDocs: "DASH API Documentation",
      settings: "Settings",
      marketAreas: "Market Areas",
      exchange: "Exchange",
      ssoCallback: "Redirecting from SSO..."
    },
    exchange: "Exchange",
    verifyAccount: "Verify Account",
    verifyAccountShort: "Verify Acc."
  },
  placeholders: {
    noSearchResults: "Your search did not return any results.",
    firstAndLastName: "First and Last Name",
    selectOption: "Select Option",
    selectProjectStatus: "Select Project Status"
  },
  serverMessages: {
    notFound: "Incorrect Email or Password.",
    uploadFail: "Something went wrong. Could not upload.",
    unknown: "Something went wrong.",
    accountNotFound: "Account Not Found",
    licenseValidationError: "Error validating license"
  },
  alerts: {
    resetPasswordEmailsSent: "If an account is found, a password reset link will be sent to the email address!",
    passwordReset: "Password has been successfully updated! ",
    changesSaved: "Changes have been saved successfully!",
    alertWasHidden: "Property was Hidden",
    alertWasShown: "Property was Unhidden",
    accountIsUpdated: "Account is Updated",
    invitationHasBeenSent: "Invitation has been sent!"
  },
  roles: {
    ORG_SALES_DIRECTOR: "Director",
    ORG_SALES_ASSOCIATE: "Sales Associate",
    ORG_DEVELOPER: "Developer",
    ORG_OWNER: "Owner"
  },
  accountStatuses: {
    [import_dash_common.AccountStatusesEnum.ACTIVE]: "Active",
    [import_dash_common.AccountStatusesEnum.ADDED]: "Added",
    [import_dash_common.AccountStatusesEnum.ARCHIVED]: "Archived",
    [import_dash_common.AccountStatusesEnum.EXPIRED]: "Expired",
    [import_dash_common.AccountStatusesEnum.INVITED]: "Invited"
  },
  brokerPortalServerErrors: {
    [import_dash_common.ServerErrors.ACCOUNT_ARCHIVED]: "User account was blocked, please contact DASH support.",
    [import_dash_common.ServerErrors.BROKER_ACCOUNT_ARCHIVED]: "Your account is blocked. {{reason}}. Please contact DASH support.",
    [import_dash_common.ServerErrors.WRONG_VERIFICATION_CODE]: "Verification Code Incorrect",
    [import_dash_common.ServerErrors.LICENSE_ALREADY_EXISTS]: "License is already associated with a DASH account.",
    [import_dash_common.ServerErrors.PORTFOLIO_CONTAIN_FOLDER]: "This property has already been added to portfolio",
    [import_dash_common.ServerErrors.INCORRECT_PASSWORD]: "Incorrect Password",
    [import_dash_common.ServerErrors.PHONE_NUMBER_IS_USED]: "Phone number is already associated with a DASH account. If you are the owner of the phone number please contact DASH Support.",
    [import_dash_common.ServerErrors.MAX_CUSTOMER_CARD_PAYMENT_METHODS]: "You have reached the limit of allowed payment methods.",
    [import_dash_common.ServerErrors.PAYMENT_METHOD_NEEDED]: "A Payment Method is needed.",
    [import_dash_common.ServerErrors.UNAVAILABLE_FOR_BROKERS]: "Property is unavailable for brokers."
  },
  serverErrors: {
    [import_dash_common.ServerErrors.PORTFOLIO_IS_EMPTY]: "Portfolio is empty",
    [import_dash_common.ServerErrors.PORTFOLIO_IS_PRIVATE]: "Portfolio is private",
    [import_dash_common.ServerErrors.PROPERTY_IS_PRIVATE]: "Property is private",
    [import_dash_common.ServerErrors.PORTFOLIO_NOT_EXISTS]: "Portfolio does not exist",
    [import_dash_common.ServerErrors.ACCOUNT_EMAIL_ALREADY_EXIST]: "There is already a DASH account with this email address. Contact DASH Support if you need to reset your password.",
    [import_dash_common.ServerErrors.ACCOUNT_ARCHIVED]: "There is an archived account with this email address. Unarchive the account to send an invitation.",
    [import_dash_common.ServerErrors.ACCOUNT_NOT_FOUND]: "Account Not Found",
    [import_dash_common.ServerErrors.INCORRECT_ACCOUNT_CREDENTIALS]: "Username or password is incorrect",
    [import_dash_common.ServerErrors.ACCOUNT_IS_NOT_RELATED_TO_APPLICATION]: "Account is not related to this application",
    [import_dash_common.ServerErrors.INVALID_PHONE_NUMBER]: "Invalid Phone Number",
    [import_dash_common.ServerErrors.ALREADY_ASSIGNED_USER_IN_SALE_TEAM]: "This user is already assigned to this sales team.",
    [import_dash_common.ServerErrors.PROPERTY_NAME_EXISTS]: "A property with this name already exists",
    [import_dash_common.ServerErrors.PORTFOLIO_FOLDER_NAME_EXISTS]: "Portfolio name must be unique",
    [import_dash_common.ServerErrors.PORTFOLIO_NAME_ROOT_FORBIDDEN]: 'Portfolio name cannot be "root"',
    [import_dash_common.ServerErrors.ALERT_CONFIG_WITH_SAME_NAME]: "There is already an alert with this name. Please give the alert a unique name.",
    [import_dash_common.ServerErrors.ALERT_CONFIG_WITH_SAME_FILTER]: "An alert with the same settings already exists. Please select unique criteria.",
    [import_dash_common.ServerErrors.FOLDER_ALREADY_EXISTS]: "Folder with the same name already exists in this directory.",
    [import_dash_common.ServerErrors.RESERVED_FOLDER]: "Folder with the same name already exists",
    [import_dash_common.ServerErrors.SALE_TEAM_PHONE_EXISTS]: "External Sales Team with this phone already exists.",
    [import_dash_common.ServerErrors.SUBSCRIPTION_ALREADY_CANCELED]: "Subscription is already canceled!",
    [import_dash_common.ServerErrors.PAYMENT_METHOD_DECLINED]: "Your card was declined. Please contact your card administrator or try a different card.",
    [import_dash_common.ServerErrors.INSUFFICIENT_FUNDS]: "Your card was declined. Reason: Insufficient funds",
    [import_dash_common.ServerErrors.STOLEN_CARD]: "Your card was declined. Reason: Stolen card",
    [import_dash_common.ServerErrors.LOST_CARD]: "Your card was declined. Reason: Lost card"
  },
  fileTypes: {
    photo: "PHOTO",
    video: "VIDEO",
    file: "FILE",
    exel: "XLS",
    doc: "DOC",
    pdf: "PDF"
  },
  subscriptionProductRecurringLabels: {
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.FREE)]: "Free",
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.MONTH)]: "Month",
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.SIXMONTH)]: "Six months",
    [(0, import_lodash.camelCase)(import_dash_common.RecurringTypesEnum.YEAR)]: "Year"
  },
  subscriptionTypes: {
    [import_dash_common.BrokerSubscriptionTypesEnum.BILLABLE]: "Billable",
    [import_dash_common.BrokerSubscriptionTypesEnum.DEMO]: "Demo"
  },
  subscriptionStatuses: {
    [import_dash_common.ProductSubscriptionStatusesEnum.ACTIVE]: "Active",
    [import_dash_common.ProductSubscriptionStatusesEnum.CANCELED]: "Canceled",
    [import_dash_common.ProductSubscriptionStatusesEnum.SCHEDULED_CANCELLATION]: "Scheduled Cancellation",
    [import_dash_common.ProductSubscriptionStatusesEnum.INCOMPLETE]: "Incomplete",
    [import_dash_common.ProductSubscriptionStatusesEnum.INCOMPLETE_EXPIRED]: "Incomplete Expired",
    [import_dash_common.ProductSubscriptionStatusesEnum.PAST_DUE]: "Past Due",
    [import_dash_common.ProductSubscriptionStatusesEnum.TRIALING]: "Trialing",
    [import_dash_common.ProductSubscriptionStatusesEnum.UNPAID]: "Unpaid"
  },
  subscriptionPlanTypes: {
    [import_dash_common.SubscriptionProductNamesEnum.PRO]: "PRO",
    [import_dash_common.SubscriptionProductNamesEnum.BASIC]: "Basic"
  },
  subscriptionBadgeTitles: {
    noCreditCard: "No credit card needed",
    trialAvailable: "{{trialDays}}-day trial available!",
    saveWithSixMonthPlan: "Save 10% with the 6-month plan",
    billedEverySixMonths: "Billed every six months"
  },
  subscriptionProductsCardsLabels: {
    basic: {
      onlyLicensedAgents: "Only for licensed agents",
      acessToDashDatabase: "Access to DASH's full database",
      dataVerification: "Data verification with timestamps",
      personalizedAlerts: "Personalized property and market alerts",
      advancedSearch: "Advanced search capabilities",
      supportAndGuides: "DASH Support and guides"
    },
    pro: {
      basicFeatures: "All features from Basic plan, plus...",
      unbrandedSales: "Unbranded sales content downloads",
      portfolioSharing: "Custom portfolio sharing",
      leadCollection: "Direct Lead collection",
      comparisonTools: "Side-by-side comparison tools",
      analyticalHighlights: "Analytical highlights"
    },
    exchange: {
      proFeatures: "All features from PRO plan, plus...",
      trial: "10-day free trial",
      websiteIntegration: "DASH Integration on your website",
      multipleFeeds: "Support for multiple feed types",
      leadGeneration: "Built in lead generation",
      simpleImplementation: "Simple implementation"
    },
    api: {
      directDataAccess: "Direct Data Access: Connect to DASH\u2019s full database of new development projects",
      flexibleDisplay: "Flexible Display: Power your own search tools, custom dashboards, or internal tools",
      apiCredentials: "Includes API key + credentials"
    }
  },
  featureLabels: {
    basic: {
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.NO_CREDIT_CARD)]: "NO CREDIT CARD REQUIRED",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.PRO_UPGRADE)]: "Upgrade to PRO anytime for advanced features",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.VIEW_ALL_PROPERTIES_IN_DATABASE)]: "Unlimited access to view DASH\u2019s new development property database",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.ACCESS_TO_PRICING_AVAILABILITY)]: "Access to view all property pricing & availability",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.ACCESS_TO_MARKETING_MATERIALS)]: "Access to view all property marketing materials",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.TRACK_UPDATES)]: "Track property updates with timestamps & verification",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.ADVANCED_FILTERS_FOR_PINPOINT_SEARCH)]: "Set advanced filters for refined inventory search",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.CUSTOM_ALERTS_NOTIFICATIONS)]: "Custom property and market alerts to your inbox",
      [(0, import_lodash.camelCase)(import_dash_common.DashBaseFeaturesEnum.DASH_SUPPORT)]: "DASH Team support whenever needed"
    },
    pro: {
      base: "Includes all features in the Basic plan, PLUS...    ",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "Share Custom Portfolios",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PROPERTY_COMPARE)]: "Side-by-side comparison tools",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "Gain insights from analytics",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "Download Unbranded Content"
    },
    idx: {
      base: "Includes all features in the PRO plan, PLUS...    ",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.EMBED_LISTINGS)]: "Embed DASH Listings on your website",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "Multiple Feed Types",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.LEAD_GENERATION)]: "Lead Generation",
      [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.IDX_INTEGRATION)]: "Easy Integration"
    },
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.LIMITED_TIME_INTRODUCTORY_PRICING)]: "LIMITED-TIME INTRODUCTORY PRICING"
  },
  featureDescriptions: {
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT)]: "unlimited access to unbranded property marketing materials, each ready-to-share with clients or on your website and social media",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PORTFOLIO_CREATION_AND_SHARING)]: "easily customize and share development content and curated groups of development properties with your contact details",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.PROPERTY_COMPARE)]: "create and share links to development comp sets with your leading prospects",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.ANALYTICS_AND_REPORTING_TOOLS)]: "gain access to reporting tools that track your marketing efforts",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.EMBED_LISTINGS)]: "a convenient IDX solution to easily showcase new development properties",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.MULTIPLE_FEED_TYPES)]: "customize how properties are showcased, with multiple options including portfolios, single-property, search and more",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.LEAD_GENERATION)]: "collect leads directly from users interested in properties you showcase",
    [(0, import_lodash.camelCase)(import_dash_common.DashFeaturesEnum.IDX_INTEGRATION)]: "DASH Exchange works with all major websites, including WordPress, Wix, Squarespace and more\u2026"
  },
  brokerLicenseStatuses: {
    [import_dash_common.BrokerLicenseStatusesEnum.ACTIVE]: "Active",
    [import_dash_common.BrokerLicenseStatusesEnum.INACTIVE]: "Inactive",
    [import_dash_common.BrokerLicenseStatusesEnum.PENDING_REVIEW]: "Pending Review"
  },
  accountPhoneNumberStatuses: {
    [import_dash_common.AccountPhoneNumberStatusesEnum.VERIFIED]: "Verified",
    [import_dash_common.AccountPhoneNumberStatusesEnum.NOT_VERIFIED]: "Not Verified"
  },
  moments: {
    year: "year",
    month: "month",
    day: "day",
    hour: "hour",
    minute: "minute",
    second: "second",
    plural: {
      year: "years",
      month: "months",
      day: "days",
      hour: "hours",
      minute: "minutes",
      second: "seconds"
    },
    short: {
      year: "yr",
      month: "mo",
      day: "d",
      hour: "hr",
      minute: "min",
      second: "sec"
    },
    shortPlural: {
      year: "yrs",
      month: "mos",
      day: "d's",
      hour: "hrs",
      minute: "min",
      second: "sec"
    },
    agoLabel: "ago",
    momentLabel: "just now"
  },
  historyTypesMessages: {
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_NAME]: "Property Name Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_PRICE]: "Pricing & Availability Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_WEBSITE]: "Property Website Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_DEVELOPER_ORGANIZATION]: "Developer Organization Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_LOCATION]: "Property Location Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_SALES_TEAMS]: "Sales Team Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_UPLOADED]: "New Marketing Files Uploaded to {{folderName}}",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_FILES_MOVED]: "Marketing Files Moved",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_RENAMED]: "Marketing Files Renamed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_MEDIA_REMOVED]: "Marketing Files Removed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_HIGHLIGHTS]: "Property Highlights Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_ABOUT]: "Property Details Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_FEATURES_AND_AMENITIES]: "Features and Amenities Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_ADDED]: "New Inventory Added",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_UPDATED]: "Inventory Updated",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_INVENTORY_UNIT_REMOVED]: "Inventory Removed",
    [import_dash_common.PropertyChangelogTypesEnum.PROPERTY_ADDITIONAL_INFORMATION]: "Additional Information Updated"
  },
  history: {
    propertyUpdates: "Property Updates",
    historyUpdates: "History of Updates"
  },
  sortOptions: {
    alphabeticalAZ: "Alphabetical A-Z",
    alphabeticalZA: "Alphabetical Z-A",
    createdAt: "Newest (Most Recently Added)",
    updatedAt: "Last Updated (default)",
    lastBrokerVisit: "Recently Visited",
    mediaSizeUp: "Size from Largest to Smallest",
    mediaSizeDown: "Size from Smallest to Largest",
    yearBuilt: "Year Built",
    isMarkedAsVerified: "Verified",
    startingPriceAsc: "Starting Price (Low to High)",
    startingPriceDesc: "Starting Price (High to Low)",
    maxPriceAsc: "Max Price (Low to High)",
    maxPriceDesc: "Max Price (High to Low)"
  },
  modalDelete: {
    title: "Delete {{entity}}",
    confirmationText: "Confirm deletion of",
    confirmationTextSecond: "Confirm deletion of {{entity}}"
  },
  modalConfirmDelete: {
    actionUnassing: "This action will unassign the ",
    propertiesCurrentAssigned: ' "{{entity}}" from the properties that currently have it assigned.',
    ProceedDeletion: "Proceed with deletion?"
  }
};

// src/assets/dictionary/en/forms.ts
var forms_default = {
  labels: {
    email: "Email",
    password: "Password",
    firstName: "First Name",
    lastName: "Last Name",
    apiReferralCode: "Referral Code",
    apiCompany: "Company",
    apiCompanyRepresentative: "Representative",
    apiClientCount: "Clients",
    apiCompanyName: "Responsible Company",
    apiMonthlyAccess: "Monthly Access",
    newPassword: "New Password",
    confirmPassword: "Confirm Password",
    signIn: "Login",
    forgotPassword: "Forgot Password?",
    sendResetInstructions: "Send Password Reset Instructions",
    resetPassword: "Reset Password",
    inventoryType: "Type",
    name: "Name",
    url: "Website URL",
    address: "Address",
    map: "Map",
    logo: "Organization Logo",
    svgIcon: "SVG Icon",
    organization: "Organization",
    primaryOrganization: "Primary Organization",
    additionalOrganizations: "Additional Organizations",
    streetName: "Street Address",
    city: "City",
    zipCode: "Zip Code",
    workingHours: "Working Hours",
    county: "County",
    radius: "Radius",
    state: "State",
    marketArea: "Market Area",
    buildingType: "Property Type",
    projectStatus: "Property Status",
    propertyTransactionType: "Transaction Type",
    teamLogo: "Team Logo",
    stories: "Stories",
    yearBuilt: "Year Built",
    leadArchitect: "Lead Architect",
    landscapeArchitect: "Landscape Architect",
    nbrOfTowers: "Number of Towers",
    constructionStartDate: "Scheduled Construction Start Date",
    nbrOfUnits: "Number of Units",
    completionDate: "Scheduled Completion Date",
    localArchitect: "Local Architect",
    interiorDesigner: "Interior Designer",
    overview: "Property Highlights",
    projectDetails: "Property Overview",
    taxInformation: "Taxes & HOA",
    websiteOfProperty: "Property Website",
    priceOfProperty: "Price",
    salesTeam: "Sales Team",
    salesDirector: "Sales Director",
    salesAssociate: "Sales Associate",
    brokerLicense: "Agent License (US only)",
    agentLicenseStatus: "Agent License Status",
    commission: "Commission %",
    contactUrl: "Contact URL",
    anyPrice: "Any Price",
    priceMin: "Price (MIN)",
    priceMax: "Price (MAX)",
    market: "Market",
    baths: "{{count}}-BTH",
    beds: "{{count}}-BR",
    share: "Share",
    link: "Link",
    customRooms: "Additional Rooms",
    inventoryInfo: "Inventory Info",
    contactInfo: "Contact Info",
    defaultInventoryDetails: "Default Inventory Details",
    averageBedroomsNumber: "Average Number of Bedrooms",
    averageBathroomsNumber: "Average Number of Bathrooms",
    averageNumbersLabels: {
      bedrooms: "Bedrooms ({{range}})",
      bathrooms: "Bathrooms ({{range}})",
      interiorSqft: "Interior SQFT ({{range}})",
      exteriorSqft: "Exterior SQFT ({{range}})"
    },
    buildingTypes: {
      activeAdult: "Active Adult",
      boutique: "Boutique",
      condo: "Condo",
      condoConversion: "Condo Conversion",
      condoHotel: "Condo Hotel",
      luxuryRental: "Luxury Rental",
      penthouse: "Penthouse",
      townhome: "Townhome",
      singleFamilyHome: "Single-Family Home",
      villa: "Villa"
    },
    projectStatuses: {
      comingSoon: "Coming Soon",
      soldOut: "Sold Out",
      developerInventory: "Developer Inventory",
      newConstruction: "New Construction",
      preConstruction: "Pre-Construction",
      underConstruction: "Under Construction",
      completed: "Completed",
      proposed: "Proposed"
    },
    propertyStatuses: {
      draft: "Draft",
      public: "Public",
      private: "Private"
    },
    propertyTransactionTypes: {
      forSale: "For Sale",
      forRent: "For Rent"
    },
    markets: {
      florida: {
        alva: "Alva",
        aveMaria: "Ave Maria",
        aventura: "Aventura",
        balHarbour: "Bal Harbour",
        bayHarborIslands: "Bay Harbor Islands",
        belleGlade: "Belle Glade",
        bocaRaton: "Boca Raton",
        bonitaSprings: "Bonita Springs",
        boyntonBeach: "Boynton Beach",
        brandon: "Brandon",
        brickell: "Brickell",
        capeCoral: "Cape Coral",
        cityOfMarco: "City of Marco",
        clearwater: "Clearwater",
        cocoaBeach: "Cocoa Beach",
        coconutGrove: "Coconut Grove",
        cooperCity: "Cooper City",
        coralGables: "Coral Gables",
        coralSprings: "Coral Springs",
        cutlerBay: "Cutler Bay",
        daniaBeach: "Dania Beach",
        davie: "Davie",
        deerfieldBeach: "Deerfield Beach",
        delrayBeach: "Delray Beach",
        doral: "Doral",
        downtownFortLauderdale: "Downtown Fort Lauderdale",
        downtownFortMyers: "Downtown Fort Myers",
        downtownMiami: "Downtown Miami",
        downtownStPetersburg: "Downtown St. Petersburg",
        dunedin: "Dunedin",
        edgewater: "Edgewater",
        esteroBay: "Estero Bay",
        esteroIsland: "Estero Island",
        evergladesCity: "Everglades City",
        fisherIsland: "Fisher Island",
        floridaCity: "Florida City",
        fortLauderdale: "Fort Lauderdale",
        fortMyers: "Fort Myers",
        fortMyersBeach: "Fort Myers Beach",
        fortPierce: "Fort Pierce",
        greenacres: "Greenacres",
        hallandaleBeach: "Hallandale Beach",
        hillsboroBeach: "Hillsboro Beach",
        hobeSound: "Hobe Sound",
        hobeSoundBeach: "Hobe Sound Beach",
        hollywood: "Hollywood",
        homestead: "Homestead",
        jupiter: "Jupiter",
        kendall: "Kendall",
        lakeland: "Lakeland",
        lakePark: "Lake Park",
        lakeWorthBeach: "Lake Worth Beach",
        lasOlas: "Las Olas",
        lauderdaleLakes: "Lauderdale Lakes",
        lauderhill: "Lauderhill",
        lehighAcres: "Lehigh Acres",
        lidoKey: "Lido Key",
        loxahatchee: "Loxahatchee",
        mangoniaPark: "Mangonia Park",
        marcoIsland: "Marco Island",
        melbourne: "Melbourne",
        melbourneBeach: "Melbourne Beach",
        miami: "Miami",
        miamiBeach: "Miami Beach",
        miamiGardens: "Miami Gardens",
        miamiRiver: "Miami River",
        midtownMiami: "Midtown Miami",
        miramar: "Miramar",
        moorings: "Moorings",
        naples: "Naples",
        naplesPark: "Naples Park",
        northBayVillage: "North Bay Village",
        northMiami: "North Miami",
        northMiamiBeach: "North Miami Beach",
        northNaples: "North Naples",
        oaklandPark: "Oakland Park",
        oldNaples: "Old Naples",
        orlando: "Orlando",
        palmBay: "Palm Bay",
        palmBeachGardens: "Palm Beach Gardens",
        palmBeachShores: "Palm Beach Shores",
        palmHarbor: "Palm Harbor",
        parkland: "Parkland",
        parkShore: "Park Shore",
        pelicanBay: "Pelican Bay",
        pembrokePines: "Pembroke Pines",
        pinecrest: "Pinecrest",
        plantation: "Plantation",
        portCharlotte: "Port Charlotte",
        portStLucie: "Port St. Lucie",
        pompanoBeach: "Pompano Beach",
        princeton: "Princeton",
        puntaGorda: "Punta Gorda",
        richmondWest: "Richmond West",
        riverview: "Riverview",
        rivieraBeach: "Riviera Beach",
        royalPalmBeach: "Royal Palm Beach",
        sanibel: "Sanibel",
        sarasota: "Sarasota",
        sarasotaBay: "Sarasota Bay",
        satelliteBeach: "Satellite Beach",
        sebastian: "Sebastian",
        springHill: "Spring Hill",
        stPeteBeach: "St. Pete Beach",
        stPetersburg: "St. Petersburg",
        stuart: "Stuart",
        sunnyIslesBeach: "Sunny Isles Beach",
        sunrise: "Sunrise",
        surfside: "Surfside",
        tamarac: "Tamarac",
        tampa: "Tampa",
        tarponSprings: "Tarpon Springs",
        titusville: "Titusville",
        veroBeach: "Vero Beach",
        victoriaPark: "Victoria Park",
        westlake: "Westlake",
        westPalmBeach: "West Palm Beach",
        weston: "Weston",
        wynwood: "Wynwood"
      }
    },
    nameOfProperty: "Property Name",
    quantity: "Quantity",
    bedrooms: "# Bedrooms",
    bathrooms: "# Bathrooms",
    totalSqft: "Total SQFT",
    interiorSqft: "Interior SQFT",
    exteriorSqft: "Exterior SQFT",
    startingPrice: "Starting Price ",
    highestPrice: "Highest Price ",
    floorplan: "Floorplan (PDF)",
    login: "Log In",
    role: "Role",
    properties: "Properties",
    brokerLicenseNumber: "Agent License Number (US only)",
    addManually: "Add Manually",
    phoneNumber: "Phone Number",
    verifyPhoneNumberCode: "Verification Code",
    shortDescription: "Short Description",
    agencyName: "Agency Name",
    agencyWebsite: "Agency Website",
    propertyType: "Property Type",
    alertName: "Alert Name",
    oldPassword: "Old Password",
    subscriptionPlanName: "Subscription Plan Name",
    subscriptionPlanStatus: "Subscription Plan Status",
    subscriptionPlanTypes: "Subscription Type",
    subscriptionType: "Subscription Type",
    userStatus: "User Status",
    mortgageTotalPrice: "Mortgage Amount",
    mortgageDownPayment: "Down Payment",
    mortgageInterestRate: "Interest Rate (%) ",
    mortgageTerm: "Mortgage Term (Years)",
    mortgageTaxRate: "Property Tax (Yearly)",
    mortgageInsuranceRate: "Property Ins. (Yearly)",
    termForTheDemo: "Term for the Demo",
    reasonUnActive: "Specify the reason for deactivation",
    note: "Notes",
    attachFiles: "Attach Files",
    min: "MIN",
    max: "MAX",
    salesWorkingHours: "Sales Gallery Working Hours",
    realUser: "Agent Account",
    testUser: "Test Account",
    accountType: "Account Type",
    excludeFromReports: "Exclude from Reports",
    isAPIUser: "API User"
  },
  messages: {
    emailBlank: "Email is blank",
    emailRequired: "Email is required",
    emailInvalid: "Invalid email format",
    passwordBlank: "Password is blank",
    passwordRequired: "Password is required",
    passwordInvalid: "Password must have at least 8 characters, 1 symbol, 1 number, 1 lowercase and 1 uppercase",
    passwordValid: "Your password is accepted",
    newPasswordValid: "Your password is accepted",
    confirmPasswordValid: "Your passwords match",
    confirmPasswordInValid: "Passwords must match",
    firstNameBlank: "First Name is blank",
    fieldLengthInvalid: "Too many characters.",
    lastNameBlank: "Last Name is blank",
    nameBlank: "Name is required",
    nameInvalid: "Name is invalid",
    iconBlank: "No uploaded icon",
    fileBlank: "No uploaded file",
    urlInvalid: "The link is not valid. Please try using the format www.website.com",
    urlBlank: "Website URL is blank",
    addressInvalid: "Address is invalid",
    mapInvalid: "Map is invalid",
    marketBlank: "Market is required",
    stateBlank: "State is required",
    countyBlank: "County is required",
    cityBlank: "City is required",
    zipCodeBlank: "Zip Code is required",
    streetBlank: "Street is required",
    organizationBlank: "Organization is required",
    addressBlank: "Address is required",
    mapBlank: "Map is required",
    sqftBlank: "SQFT is required",
    maxCharacterLimit: "Max character limit is {{number}}",
    workingHoursValidateMessage: "End time cannot be before the start time",
    priceBlank: "Price is blank",
    uploadErrors: {
      fileInvalidType: "File type must be {{type}}",
      fileTooLarge: "File must be a max of {{maxSize}}MB",
      unknown: "Something went wrong.",
      tooManyFiles: "Multiple files cannot be selected here"
    },
    minMaxMissingValueValidationError: "Min value is required",
    defaultMinMaxValidationError: "Min value should be less than Max value",
    typeInvalid: "File type is invalid",
    startingPriceMoreThanHighest: "Starting price should be less than the highest price",
    highestPriceLessThanStarting: "Highest price should be more than the starting price",
    numberOfUnitsMoreThanHighest: "Number of units (MIN) should be less than Number of units (MAX)",
    roleBlank: "Role is blank",
    roleRequired: "Role is required",
    saleTeamBlank: "Sales Team is blank",
    propertiesBlank: "Properties is blank",
    characterLengthRestriction: "You have entered too many characters ",
    fieldIsRequired: "{{fieldName}} is required",
    invalidCharacters: "You have entered invalid characters for this field",
    digitsLengthRestriction: "User cannot enter more than {{number}} digits",
    selectFolder: "Select needed folder",
    phoneNumberBlank: "Phone is blank",
    phoneNumberWrongLengthUS: "Phone number must have 10 numbers.",
    radius: "Radius",
    verificationCodeSend: "Verification code has been sent to your phone number",
    fileInvalidType: "File type must be {{type}}",
    percentageInvalid: "Percentage should be less than 100",
    mortgage: {
      totalPriceBlank: "Mortgage amount is required",
      downPaymentBlank: "Down payment is required ",
      interestRateBlank: "Interest rate is required",
      termBlank: "Mortgage term is required"
    },
    reasonBlank: "Reason is blank",
    noteBlank: "Notes is blank",
    noteInvalid: "Field does not accept more than {{length}} characters"
  },
  placeholders: {
    email: "john@dash.com",
    firstName: "Brooklyn",
    lastName: "Simmonsy",
    apiReferralCode: "company-referral-code",
    apiCompanyName: "The Reeves Group",
    password: "Enter Password",
    oldPassword: "Type Old Password",
    newPassword: "Type New Password",
    confirmPassword: "Type Password Again",
    organizationName: "Organization Name",
    saleTeamName: "Ex: Dash Inc",
    url: "https://website.com",
    address: "Enter Address",
    map: "Find on Map",
    nameOfProperty: "Name of Property",
    selectOne: "Select One",
    nameOfCity: "Name of City",
    nameOfStreet: "Number and Name of Street",
    priceRange: "Ex: $1,000,000 - $2,000,000",
    digits: "{{number}} Digits",
    nbrOfStories: "Number of Stories",
    year: "Year",
    nameOfArchitect: "Name of Architect",
    nbrOfTowers: "Number of Towers",
    nbrOfUnits: "Number of Units",
    nameOfDesigner: "Name of Designer",
    overviewPlaceholder: "Add any highlights related to the property. Max of {{number}} characters.",
    projectDetailsPlaceholder: "Add the property\u2019s Project Overview. Max {{number}} characters",
    taxInformationPlaceholder: "Add taxes/fees. Max {{number}} characters",
    websiteOfProperty: "https://website.com",
    priceOfProperty: "Price",
    salesTeam: "Select Sales Team",
    salesDirector: "Select Sales Director",
    salesAssociate: "Select Sales Associate",
    commission: "Input Commission",
    contactUrl: "Type Contact URL",
    inventoryName: "EX: B Line, Penthouse",
    ex: "EX",
    sqft: "EX: 1,234",
    totalSqft: "Auto-calculate",
    dragAndDropZone: "Drag and Drop or Click to",
    selectFiles: "Select Files",
    folderName: "Folder Name",
    role: "Select Role",
    saleTeam: "Select Sales Team",
    properties: "Select Properties",
    brokerLicenseNumber: "856456456",
    mediaName: "Media Name",
    phoneNumber: "856456456",
    verifyPhoneNumberCode: "A1B2",
    enterPasswordToOpenLink: "Enter the password to open this link",
    enterFolderName: "Enter Folder Name",
    alertName: "Enter Alert Name",
    enterDescription: "Enter Description",
    agencyName: "The Reeves Group",
    marketAreaName: "Market Area Name",
    amenityName: "Amenity Name",
    mortgageTotalPrice: "670,400.00",
    mortgageDownPayment: "20%",
    mortgageInterestRate: "4.5%",
    mortgageTerm: "30",
    mortgageTaxRate: "$3,000",
    mortgageInsuranceRate: "$1,500",
    defaultInventoryPlaceholder: "Type Default Inventory Details",
    averageBedroomsNumber: "Type Number",
    averageBathroomsNumber: "1",
    reasonUnActive: "Type the reason for deactivation.",
    note: "Enter Your Property Notes",
    salesTeamName: "Sales Team Name",
    markets: "Select Market"
  }
};

// src/assets/dictionary/en/pages.ts
var import_dash_common2 = require("dash-common");
var import_lodash2 = require("lodash");
var pages_default = {
  signInPage: {
    welcomeHeader: "Welcome to DASH!",
    welcomeSubHeader: "Sign in to your account.",
    bottomLabel: "Don\u2019t have an account?",
    bottomLabelLink: "Create an account"
  },
  brokerSignUpPage: {
    welcomeHeader: "Create a DASH Account",
    welcomeSubHeader: "Your privacy is important to us. DASH will never share your information. ",
    submitButtonLabels: "Go to the next step",
    agreeTermsLabel: "I agree to the",
    termsAndConditionsLabel: "terms and conditions,",
    termsAndConditionsLabel2: "terms and conditions.",
    termsAndConditionsError: "You must accept the terms and conditions to register an account.",
    smsTermsLabel: "and to receive a verification code via SMS (standard messaging rates may apply).",
    bottomLabel: "Already a DASH member?",
    bottomLabelLink: "Log In"
  },
  brokerCompleteSignUpPage: {
    resendCodeLabel: "Didn\u2019t receive a verification code?",
    emailResendCodeLabel: "Didn\u2019t receive a verification code?",
    submitButtonLabels: "Create an Account",
    codeResent: "SMS Verification has been sent.",
    emailSent: "Email Verification has been sent."
  },
  forgotPasswordPage: {
    welcomeHeader: "Forgot Password",
    welcomeSubHeader: "Enter your email address to receive a link to reset your password."
  },
  resetPasswordPage: {
    welcomeHeader: "Reset Password",
    welcomeSubHeader: "Input your new password"
  },
  organizationSignUpPage: {
    welcomeHeader: "Sign Up",
    welcomeSubHeader: "Please enter your password to sign up.",
    submitButtonLabel: "Sign Up"
  },
  organizationSignUpExpiredPage: {
    welcomeHeader: "Invitation Has Expired",
    welcomeSubHeader: "Please write to us at this email address so our administrators can resend your invitation."
  },
  organisationPage: {
    addOrganisationModalLabel: "Add Organization",
    editOrganizationModalLabel: "Edit Organization",
    addressUnavailable: "Address Unavailable",
    websiteUnavailable: "Website Unavailable",
    deleteOrganizationModalTitle: "Delete Organization",
    deleteOrganizationModalText: "Are you sure you want to delete this organization and all of its users? Properties associated with the organization will not be deleted."
  },
  organizationSaleTeams: {
    addOrganisationModalLabel: "Add Sales Team",
    editOrganizationModalLabel: "Edit Sales Team",
    addressUnavailable: "Address Unavailable",
    websiteUnavailable: "Website Unavailable",
    deleteOrganizationSaleTeamModalLabel: "Delete Sales Team",
    deleteOrganizationSaleTeamModalText: "Are you sure you want to delete the sales team {{saleTeamName}}?"
  },
  organizationUsers: {
    addOrganisationUserModalLabel: "Add User to Organization",
    editOrganisationUserModalLabel: "Edit User in Organization",
    inviteUserModalTitle: "Send Invite",
    inviteUserModalSubtitle: "Would you like to invite this user to DASH?",
    inviteUserModalCancelButton: "No, Thanks",
    inviteUserModalSubmitButton: "Invite",
    archiveUserModalTitle: "Archive User",
    archiveUserModalSubtitle: "Are you sure you want to archive this organization user?",
    unarchiveUserModalTitle: "Unarchive User",
    unarchiveUserModalSubtitle: "Are you sure you want to unarchive this organization user?"
  },
  amenityPage: {
    updateAmenityModalLabel: "Update Amenity",
    addAmenityModalLabel: "Add Amenity",
    deleteAmenityModalLabel: "Delete Amenity",
    deleteAmenityModalText: "Are you sure you want to delete the amenity: {{amenityName}}?"
  },
  marketAreasPage: {
    updateMarketAreaModalLabel: "Update Market Area",
    addMarketAreaModalLabel: "Add Market Area",
    deleteMarketAreaModalNote: "This may impact associated properties"
  },
  propertyPage: {
    propertyName: "Property Name",
    mediaItemsCount: "({{itemsCount}} Items)",
    propertyCreateModalTitle: "Add New Property",
    amenitiesTabLabel: "Features and Amenities",
    buildingDetails: "Property Details",
    salesGalleryHours: "Sales Gallery Hours",
    manageAmenities: "Manage Amenities",
    searchAmenities: "Search Amenities",
    propertyFeaturesAndAmenities: "Property Features and Amenities",
    removeAmenityFromPropertyModalTitle: "Remove Amenity",
    removeAmenityFromPropertyModalText: "Are you sure you want to remove the amenity {{amenityName}} from this property?",
    inventoryCreateModalTitle: "Add New Unit",
    slideshow: "Slideshow",
    main: "Main",
    inventoryEditModalTitle: "Edit Unit",
    completedIn: "Completed in {{date}}",
    estCompletion: "Est. Completion in {{date}}",
    uploadMedia: "Upload Media",
    cancelAllUpdates: "Cancel All Updates",
    clearUploadHistory: "Clear Upload History",
    floorPlan: "Floor Plan (PDF)",
    addFloorPlan: "Add Floor Plan",
    mediaFiles: "Media Files",
    searchMedia: "Search Folder and Media Files",
    allFileTypes: "All File Types",
    paginationLabel: "Showing Page {{page}} of {{total}}",
    paginationMediaLabel: "Showing Page {{page}} of {{total}}",
    noFilesPlaceholder: "There are no images or videos added to the Slideshow. You can add Slideshow content by going to the media tab and adding them to the default folder called Slideshow",
    addFolderModalLabel: "Create Folder",
    editFolderModalLabel: "Edit Folder",
    removeFolderModalLabel: "Delete Folder",
    editMediaModalLabel: "Edit File Name",
    removeFolderModalBodyLabel: "Are you sure you want to delete the folder \u201C{{folderName}}\u201D? The content in this folder will be moved to the files section.",
    removeFolderModalCheckboxLabel: "Check here to delete the folder contents as well",
    deleteFileModalTitle: "Delete File",
    deleteFileModalPlaceholder: "Are you sure you want to delete the file {{fileName}}?",
    bulkDeleteFileModalPlaceholder: "Are you sure you want to delete the {{numberOfFiles}} selected files?",
    folderDeletedMessage: "{{folderName}} was deleted successfully",
    salesTeam: "Sales Team",
    addMoreUsers: "Add More Users",
    leavePage: "Leave Page",
    goBack: "Go Back",
    confirmChangesModalTitle: "Your Changes Are Not Yet Saved",
    confirmChangesModalText: "Are you sure you want to leave this page? Your changes will not be saved.",
    confirmChangelogCreationModalTitle: "Update Property History",
    confirmChangelogCreationModalText: "Would you like to add the current changes to the Property Updates History?",
    addToChangelogButton: "Yes, Add to History",
    dontAddToChangelogButton: "No",
    addToChangelogCheckbox: "Add changes to property updates history",
    moveFileModalTitle: "Move to Folder",
    moveFileModalText: "Select the folder to which you would like to transfer this file",
    moveToFolder: "Move to Folder",
    bulkActionsText: "Selected {{quantity}} items for bulk action",
    searchProperty: "Search by Property Name",
    price: "Price",
    propertyType: "Property Type",
    advanced: "Advanced",
    bedsAndBath: "Beds & Bath",
    allListing: "All Properties",
    alertListing: "Property Alerts",
    resultsFor: "{{total}} properties found",
    resultsLimited: "Showing {{total}} out of {{totalProperties}}+ properties",
    availableUnits: "Avail. Units",
    from: "From",
    noProperties: "Your search returned no properties.",
    showFeaturesAndAmenities: "Show All Features & Amenities",
    filterTitle: "Advanced Filter",
    filterSubtitle: "Apply advanced filters to your search.",
    numberOfBedrooms: "Number of Bedrooms",
    numberOfBathrooms: "Number of Bathrooms",
    saveAndCreateAlert: "Save and Create Alert",
    clearFilter: "Clear Filter",
    goToTheClosestProperty: "Go to the Closest Property",
    noPropertiesWereFoundOnMap: "No properties were found for your query. Use the closest properties search function to view nearby properties.",
    contact: "Contact Development",
    contactLeasingOffice: "Contact Leasing Office",
    addToPortfolio: "Add to Portfolio",
    viewAsClient: "View as Client",
    contactMessage: "Questions? Contact the property developer below.",
    message: "Message",
    lastUpdated: "Last Updated",
    history: "History",
    propertyPortfolio: "Property Portfolio ({{amount}})",
    viewAll: "View All",
    presentedBy: "Presented by",
    editAmenityNameModalTitle: "Edit Amenity Name",
    deleteProperty: "Delete Property",
    deletePropertyModalConfirmationText: "Are you sure you want to delete this property?",
    appearedDate: "Date Added",
    scheduledConstruction: "Scheduled Construction",
    numberOfUnits: "Number of Units",
    yearBuilt: "Year Built",
    addToTrackToast: "Property has been added to the tracking folder",
    propertyAlreadyTracked: "You are already tracking this property.",
    propertyRemovedFromTrack: "Property has been removed from your tracking list",
    filterByTimeRange: "Filter by Time Frame",
    unavailablePropertyTitle: "Property Unavailable",
    unavailablePropertySubTitle: "This property is currently unavailable. Contact Support for more details.",
    propertyNote: "Property Notes",
    deletePropertyNote: "Delete Note",
    deletePropertyNoteModalConfirmationText: "Are you sure you want to delete the note from this property note list?",
    addSaleTeam: "Add Sales Team",
    propertySearchPlaceholder: "City, Neighborhood, Community, Building",
    allMarket: "Market Area",
    priceRange: "Price Range",
    allPropertyStatus: "Property Status",
    completionDate: "Est. Completion Year",
    mediaEmptyState: "There are no files in this folder",
    deleteSalesTeam: "Delete Sales Team",
    deleteSalesTeamText: "Are you sure you want to delete the Sales Team?",
    noPrimaryOrganizationError: "Property must have a primary organization.",
    noMarketAreaError: "Property must have a market area.",
    sort: "Sort",
    sortBy: "Sort by"
  },
  propertyMediaFolderPage: {
    noFilesPlaceholder: "This folder is empty"
  },
  propertyPreviewPage: {
    websiteLink: "Website Link",
    generalTabLabel: "Property Info",
    additionalTabLabel: "Additional Info",
    marketingTabLabel: "Marketing Files",
    developerInfoLabel: "Developer",
    salesTeamLabel: "Sales Team",
    propertyManagementLabel: "Property Management",
    additionalInformation: "Additional Information",
    additionalInformationShort: "Addl. Info",
    nbrOfStories: "Number of Stories",
    nbrOfTowers: "Number of Towers",
    constructionDate: "Construction Date",
    completionDate: "Completion Date",
    marketingFilesLabel: "Marketing Files",
    marketingFilesSecondLabel: "Below you will find all the Marketing Files related to this property.",
    noSaleTeamLabel: "No Sales Team",
    moreInformation: "More Information",
    historyLabel: "This property was last {{date}}."
  },
  wasDeleted: {
    title: "{{entityName}} was deleted"
  },
  notFoundPage: {
    title: "Not Found",
    subtitle: "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable",
    buttonLabel: "Go to Homepage",
    generalTabLabel: "Property Info",
    additionalTabLabel: "Additional Info",
    marketingTabLabel: "Marketing Files"
  },
  idx: {
    unauthorizedTitle: "Unauthorized",
    unauthorizedSubtitle: "Hey, this domain is not authorized to use our Exchange Data!",
    visitDash: "Visit DASH"
  },
  footer: {
    termsLabel: "Terms & Conditions",
    policyLabel: "Privacy Policy",
    rightLabel: "2025 DASH Inc. All Rights Reserved."
  },
  completeSignUp: {
    pickPlan: "Pick Plan",
    setupSubscriptionLabel: "Setup Subscription",
    setupSubscriptionShortLabel: "Setup",
    additionalLabel: "Additional Info",
    additionalShortLabel: "Addl. Info"
  },
  completeSignUpPickSubscription: {
    header: "Pick a Subscription",
    subheader: "Choose from the available options",
    trialLabel: "{{countOfDays}} Day Free Trial",
    noTrialLabel: "Upgrade to Pro",
    subscribe: "Subscribe",
    submitButtonLabel: "Free {{countOfDays}}-day trial",
    cancelMySubscription: "Cancel my subscription",
    couponMiddleLabel: "vs our {{recurringType}} plan",
    stayOnthisPlan: "Stay on this plan",
    subscribeBasic: "Start for Free With Basic plan",
    subscribePro: "Subscribe to PRO plan",
    subscribeIdx: "Subscribe to DASH Exchange plan",
    subscriptionProductRecurringLabels: {
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.FREE)]: "Free",
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.MONTH)]: "Monthly",
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.SIXMONTH)]: "Every six months",
      [(0, import_lodash2.camelCase)(import_dash_common2.RecurringTypesEnum.YEAR)]: "Yearly"
    }
  },
  completeSignUpAddPaymentPage: {
    header: "Start {{countOfDays}}-Day Free Trial",
    headerFree: "Start Now!",
    headerBasic: "Basic Plan",
    headerPro: "PRO Plan",
    subheader: "Cancel anytime",
    subscriptionSubHeader: "Confirm Subscription",
    subscriptionSelectLabel: "Select Billing Option",
    subscriptionInfoLabel1Head: "Your {{countOfDays}}-day trial is ",
    subscriptionInfoLabel1Midl: "100% free",
    subscriptionInfoLabel1Tail: " and will last until",
    subscriptionInfoLabel2: "Cancel anytime. Read our",
    paymentHeader: "Select Billing Details",
    orderSummaryHeader: "Order Summary",
    orderSummaryLabel1: "Today\u2019s Total:",
    orderSummaryLabel1Link: "${{price}} for {{countOfDays}} Days",
    orderSummaryLabel1LinkNoTrial: "${{price}}",
    orderSummaryLabel1Free: "$0",
    orderSummaryLabel2: "After {{countOfDays}} Days: ${{price}}",
    orderSummaryLabel2Free: "Upgrade to Pro at any time for advanced features and tools.",
    orderSummaryLabel3: "Billed annually: USD${{price}} (you get {{countOfDays}} days free)",
    orderSummaryLabel4: "Subsequent months billed at ${{price}}.",
    submitButtonLabel: "Start my Free Trial",
    subscriptionStarted: "Subscription successfully started",
    couponAdd: "Add a Promo Code",
    couponPlaceholder: "Enter promotion code",
    couponError: "Code is not valid.",
    firstTimeUser: "Coupon is only available for new users.",
    returningUser: "Coupon is only available for returning users."
  },
  completeSignUpAddAdditionalInfoPage: {
    header: "Additional Info",
    subheader: "Fill in now or later",
    profileSubHeader: "Profile",
    locationSubHeader: "2. Location",
    settingsSubHeader: "3. Property Settings"
  },
  portfoliosPage: {
    addPropertyToPortfolioModalTitle: "Add Property to a Portfolio",
    addPropertyToPortfolioModalText: "Create portfolios to organize and share property content with your clients and associates.",
    existingFolder: "Existing Portfolio",
    selectFolder: "Select Portfolio",
    createNewFolder: "Create a New Portfolio",
    folderName: "Portfolio Name",
    enterFolderName: "Enter a New Portfolio Name",
    statuses: {
      [import_dash_common2.BrokerPortfolioStatusesEnum.PRIVATE]: "Private/Draft",
      [import_dash_common2.BrokerPortfolioStatusesEnum.PUBLIC]: "Public Link",
      password: "Password-protected Link"
    },
    propertiesTotal: "{{total}} Properties",
    portfoliosTotal: "{{total}} Portfolio Items",
    totalViews: "{{total}} Views",
    views: "Views",
    portfoliosSearchPlaceholder: "Search by Portfolio Name",
    portfoliosPropertySearchPlaceholder: "Search by Property Name",
    portfoliosSearchPlaceholderShort: "Search by Portfolio",
    portfoliosPropertySearchPlaceholderShort: "Search by Property",
    sort: "Sort",
    sortBy: "Sort By",
    addNew: "Add New",
    portfolioName: "Portfolio Name",
    paginationLabel: "Showing Portfolio {{page}} of {{total}}",
    emptyPageLabel: "You don't have any portfolios yet!",
    emptyPageSubLabel: "Create portfolios to organize and share property content with your clients and associates.",
    emptyPageButtonLabel: "Start Browsing",
    createFolderModalTitle: "Add Portfolio",
    createFolderModalSubtitle: "Then add properties to your portfolio for sharing.",
    portfolioNamePlaceholder: "Enter a New Portfolio Name",
    toasts: {
      shareLinkCopied: "Copied",
      folderIsCreated: "Portfolio Created",
      folderIsUpdated: "Portfolio Updated",
      portfolioIsCreated: "Portfolio Created",
      propertyWasAdded: "Property Added to Portfolio",
      propertyAlreadyAdded: "Property already added to this portfolio"
    },
    removePropertyFromPortfolioModal: {
      header: "Delete Property from Portfolio",
      subheader: "Are you sure you want to delete this property from your portfolio?"
    },
    removeFolderFromPortfolioModal: {
      header: "Delete Portfolio",
      subheader: "Are you sure you want to delete this portfolio?"
    },
    movePropertyToPortfolioFolderModal: {
      title: "Add Property to Portfolio",
      subtitle: "Create a new Portfolio for this property, or add it to an existing portfolio?"
    },
    emptyPortfolioFolderSubtitle: "This portfolio is empty. To learn how to add properties, visit DASH Support",
    emptyPortfolioFolderTitle: "You don't have any properties yet!",
    contactMe: "Contact Me",
    availability: "Availability",
    propertiesReady: "Properties Ready",
    propertiesSold: "Properties Sold",
    propertiesReadyShort: "Props. Ready",
    propertiesSoldShort: "Props. Sold",
    customers: "Customers",
    openPortfolioWithPasswordModal: {
      title: "Open the Portfolio",
      subtitle: "Please enter the password to view this portfolio."
    },
    rootFolder: "Root Folder",
    moreAboutPresenter: "More About Presenter",
    viewPropertyPortfolio: "View Property Portfolio",
    unitSizes: "Unit Sizes",
    customize: "Customize",
    propertyComparison: "Property Comparison",
    selectItemsToCompare: "Select Items to Compare",
    viewSharedPortfolio: "View Shared Portfolio",
    unavailablePortfolioPage: {
      title: "Unavailable Portfolio",
      subtitle: "Portfolio is currently unavailable. Contact the agent who shared it for more details."
    }
  },
  portfolioDetailsPage: {
    labels: {
      properties: "{{number}} Properties",
      shared: "Shared",
      views: "{{number}} Views",
      shareFolder: "Share Portfolio",
      deleteFolder: "Delete Portfolio",
      moveProperty: "Move Property",
      removeProperty: "Remove Property",
      move: "Move"
    },
    sharePortfolioForm: {
      header: "Share Portfolio",
      subHeader: "Choose how you want to share the portfolio.",
      publicShareType: "Public Link",
      privateShareType: "Private/Draft Portfolio",
      passwordType: "Password-Protected Link",
      passwordPlaceholder: "Enter a preferred password for this portfolio link",
      alertLabel: "This Portfolio is visible only to you; no others can view it."
    }
  },
  portfolioFolderPreviewPage: {
    header: "{{totalCount}} properties are in this portfolio.",
    subHeader: "If you like these properties, please contact your agent",
    livingArea: "Living Area",
    bathrooms: "Bathrooms",
    bedrooms: "Bedrooms"
  },
  profilePage: {
    labels: {
      accountInfo: "Account Info",
      billing: "Billing",
      settings: "Settings",
      feedback: "Feedback",
      support: "Support"
    },
    billing: {
      stayOnThisPlan: "Stay on This Plan",
      subscription: "Subscription",
      active: "Active",
      deleted: "Deleted",
      cancelled: "Canceled",
      transactionHistory: "Transaction History",
      renewalDay: "Renewal Day {{date}}",
      validUntil: "Valid Until {{date}}",
      changeCurrentPlan: "Change Current Plan",
      manageSubscription: "Manage Your Subscription",
      cancelTrial: "Cancel trial",
      subscribe: "Subscribe",
      freeTrial: "Free {{trial}}-day trial",
      noTrial: "Upgrade to {{planName}}",
      seeMore: "See More",
      paymentMethod: "Payment Methods",
      upgradePlan: "Upgrade Plan",
      emptyPaymentMethodsText: "Please select another default payment method to renew your subscription",
      addPaymentMethod: "Add a Payment Method",
      default: "Default",
      expirationDate: "Expiration Date {{expiredMonth}}/{{expiredYear}}",
      subscriptionPlanDetails: "Subscription Plan Details",
      recurringTypeChangeModalTitle: "Your recurring type will change",
      downgradeModalTitle: "Your subscription will be downgraded",
      cancelModalTitle: "Please tell us why you are canceling your subscription",
      cancelModalText: "If you cancel your subscription, your plan will not renew on your next billing date. You will continue to have full access to your plan\u2019s services and features until the expiration date. You can subscribe again at any time.",
      recurringTypeChangeModalText: "Your subscription recurring type will change to {{recurringType}} {{plan}} on your next billing date.",
      downgradeModalText: "Your subscription will downgrade to {{plan}} on your next billing date.",
      downloadAll: "Download All",
      cancelReasons: {
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.I_DONT_NEED_DASH_ANYMORE]: "I no longer need DASH's tools",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.IT_DOESNT_MEET_MY_NEEDS_EXPECTATIONS]: "DASH doesn't meet my needs/expectations",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.PLANS_COST_TOO_MUCH]: "DASH's plans cost too much",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.UNADDRESSED_ERRORS_OR_BUGS]: "Unaddressed errors or bugs",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.IM_USING_DIFFERENT_SERVICE]: "I'm using a different service",
        [import_dash_common2.ProductSubscriptionCancelationReasonsEnum.OTHER]: "Other"
      },
      otherCancelReasonPlaceholder: "Additional Information (optional)",
      cancelPlan: "Cancel Plan",
      changeRecurringType: "Change recurring type",
      backToBilling: "Back to Billing",
      addPaymentModalTitle: "Add a Payment Method",
      addPaymentModalSubTitle: "All information remains confidential and will not be shared",
      deletePaymentMethod: "Delete Payment Method",
      deletePaymentMethodDescription: "Are you sure you want to delete this payment method?",
      subscriptionProductChanged: "Your subscription has been changed!",
      unsuccessfulPayment: "Unsuccessful Payment",
      changePlanConfirmationModal: {
        upgradeButton: "Upgrade",
        downgradeButton: "Downgrade",
        yesButton: "Yes",
        upgradeTitle: "Upgrade to {{name}} Plan",
        downgradeTitle: "Downgrade to {{name}} Plan",
        changeToSixMonthPlan: "Change to six-month plan",
        changeToMonthlyPlan: "Change to monthly plan",
        changeDescription: "Are you sure you want to change your subscription plan from {{old}} to {{new}}?"
      },
      changeToSixMonthPlan: "Change to six-month plan",
      changeToMonthlyPlan: "Change to monthly plan",
      upgradeDownloadPlanModalTitle: "Upgrade Your Subscription to Unlock Unbranded Downloads!",
      upgradePortfolioPlanModalTitle: "Upgrade Your Subscription to Unlock Agent Portfolios",
      upgradeCompleteAccountPlanModalTitle: "Start a Trial to Access All Properties",
      upgradePlanModalTitle: "Upgrade Subscription",
      retrySubscriptionPayment: "Retry Payment",
      renewSubscription: "Renew Subscription",
      successfulUpgradeMessage: "Your subscription was upgraded!",
      upgradePlanModalDownloadSubtitle: "With DASH Pro, you can easily download ready-to-share unbranded marketing content. Upgrade your subscription now for unlimited access to property content and other useful features.",
      upgradePlanModalPortfolioSubtitle: "With portfolios, you can easily share property details and content with others, including property inventory and downloads. Upgrade your subscription now to activate portfolios and more.",
      upgradeCompleteAccountPlanModalSubtitle: "Get access to 400+ New Developments across Florida to boost your sales!"
    },
    settings: {
      updatePassword: "Update Your Password",
      updatePasswordSubTitle: "Edit or change your password to secure your account.",
      updateEmailTitle: "Email Address",
      updateEmailSubTitle: "Edit or change the email address of your account.",
      changeEmailTile: "Change your email address",
      yourEmail: "Your email"
    },
    api: {
      tooltipMessage: "This is the information you will share with the company responsible for your API integration. To be able to use our API Plugin, you need to provide the App ID and the secret API Token.",
      apiKeys: "API Keys",
      apiUsage: "API Usage",
      apiActivity: "API Activity",
      generateNewToken: "Generate new Token",
      tokenGeneratedSuccess: "Token generated successfully. Please keep it safe.",
      tokenGeneratedError: "Failed to generate token. Please try again.",
      newToken: "Your new token is:",
      newTokenStoreSafely: "Please copy and store it in a safe place. It will not be shown again after you close this modal.",
      noAppIdFoundMessage: "No App ID found. Please refresh the page or contact support if the problem persists."
    },
    toasts: {
      updatedPassword: "Your password was successfully updated",
      updatedProfile: "Your profile was successfully updated",
      updatedEmail: "Your email was successfully updated"
    }
  },
  alertPage: {
    labels: {
      addAlert: "Add an Alert",
      alertDetails: "Alert Details",
      alertInfo: "Alert Info",
      createAlertTitle: "Create an Alert",
      createAlertSubtitle: "Create an alert for new properties that match your search criteria",
      manageAlerts: "Manage Alerts",
      addAlertSelectFilter: "Select filters for your alert",
      hiddenAlert: "Hidden Alert",
      filterByAlertPlaceholder: "Search by alert name",
      manageAlertsModalTitle: "Manage Alerts",
      manageAlertsModalSuTitle: "View a comprehensive list of your alerts, and manage them as needed.",
      deleteAlertModalTitle: "Delete Alert",
      deleteAlertModalSubTitle: "Are you sure you want to delete this alert from the alerts list?",
      noPropertiesPlaceholderTitle: "You have not created any alerts",
      noPropertiesPlaceholder: "Create an alert to be notified when a new property matches your alert criteria",
      backButtonLabel: "Back to Manage Alerts"
    },
    toasts: {
      alertIsCreated: "Alert Successfully Created",
      alertIsUpdated: "Alert Successfully Updated"
    }
  },
  brokersPage: {
    licenseInfo: "License Info",
    licenseData: "License Data:",
    markAsInvalid: "Mark as Invalid",
    markValid: "Mark as Valid",
    saveBrokerDetails: "Save agent details",
    verifyBrokerLicense: "Verify",
    licenseId: "License ID:",
    blockBroker: "Block Account",
    subscriptionStatus: "Subscription Status",
    unblockBroker: "Unblock Account",
    toast: {
      paymentMethodAdded: "Payment method successfully added",
      paymentMethodRemoved: "Payment method successfully removed",
      paymentMethodSetAsDefault: "Payment method has been set as default",
      maxPaymentMethod: "You have reached the limit of allowed payment methods."
    },
    modals: {
      deactivateBrokerLicenseTitle: "Deactivate Agent License",
      activateBrokerLicenseTitle: "Set Agent License as Active",
      deactivateBrokerLicenseSuccess: "Agent License Invalidated",
      activateBrokerLicenseSuccess: "Agent License Validated",
      activateBrokerLicenseSubTitle: "Are you sure?",
      blockBrokerSubtitle: "Are you sure you want to block this account?",
      blockBrokerReasonFieldTitle: "Specify the reason for blocking",
      blockBrokerReasonFieldPlaceholder: "Type the reason for blocking",
      unblockBrokerSubtitle: "Are you sure you want to unblock this account?"
    }
  },
  dashboardPage: {
    mortgageWidget: {
      mortgageModalTitle: "Mortgage Calculator",
      mortgageBalance: "Mortgage Balance",
      totalPayments: "Total Payments",
      monthlyPayments: "Monthly Payments",
      totalInterestPaid: "Total Interest Paid",
      propertyInsurance: "Property Insurance",
      propertyTax: "Property Tax",
      totalPropertyTax: "Total Property Tax",
      totalPropertyInsurance: "Total Property Ins."
    },
    currencyConverterWidget: {
      title: "Currency Converter",
      rate: "Rate: {{from}} / {{to}}",
      label: "For such {{amount}} you will get:",
      for: "On {{date}}",
      copied: "Copied"
    },
    propertyAlertsWidget: {
      propertiesAlertsModalTitle: "Property Alerts",
      infoPlaceholder: "New Properties",
      infoDescription: "New Property Alerts",
      infoPlaceholderDescription: "Get notifications when a new property matches your search criteria"
    },
    propertyUpdatesWidget: {
      infoPlaceholder: "Track Properties",
      infoDescription: "Property Updates",
      infoPlaceholderDescription: "Get notifications when a property in your portfolio is updated",
      noPropertyUpdatesPlaceholder: "No properties were updated during the selected time period"
    },
    reactionsWidget: {
      infoDescription: "Reactions",
      infoPlaceholderDescription: "Collect feedback from clients and colleagues on portfolios you share.",
      reactions: {
        interested: "Interested",
        notInterested: "Not Interested",
        maybeInterested: "Maybe Interested",
        dontKnow: "Don\u2019t Know"
      },
      enterYourData: "Enter Your Details",
      leaveReactionTitle: "How would you rate this property?",
      leaveReactionSuccessfulToast: "Thank You! Your agent will be notified",
      reactionsViews: "Reactions & Views",
      userView: "User View"
    },
    reactionsModal: {
      portfolioViewsLabel: "{{count}} Views",
      portfolioReactionsLabel: "{{count}} Reactions",
      noPortfoliosMessage: "No Portfolios Found",
      noPortfoliosSubMessage: "Collect feedback from clients and colleagues on portfolios you share.",
      noPortfoliosButtonMessage: "Create Your First Portfolio",
      noPublicPortfoliosMessage: "No Public Portfolios",
      noPublicPortfoliosSubMessage: "Make your portfolio public and collect feedback from clients and colleagues",
      noPublicPortfoliosButtonMessage: "Share portfolio"
    },
    viewedProperties: {
      viewed: "Viewed: {{date}}",
      unavailableProperty: "This property is unavailable right now",
      viewedProperties: "Viewed Properties",
      unavailableTitle: "Keep Track of Your Searches",
      unavailableSubtitle: "Once you start browsing properties, your history will appear here.",
      unavailableButton: "Browse"
    },
    addedToPortfolio: {
      addedToPortfolio: "Added to Portfolio",
      unavailableTitle: "Portfolio Properties",
      unavailableSubtitle: "Any properties added to a portfolio will be displayed here.",
      unavailableButton: "Create Portfolio",
      added: "Added: {{date}}",
      removed: "Removed",
      propertyNotAvailable: "Property is Not Available",
      noFolderName: "No Portfolio Name"
    },
    portfoliosWidget: {
      title: "Portfolio Views",
      titleShort: "Port. Views",
      portfoliosDropdownInput: "Manage Chart",
      portfoliosDropdownInputShort: "Chart",
      noPortfoliosPlaceholderTitle: "Analytics",
      noPortfoliosPlaceholderSubTitle: "When creating portfolios, you receive view analytics from potential buyers",
      noPublicPortfoliosPlaceholderSubTitle: "When sharing property portfolios, you receive view analytics from potential buyers",
      noPortfoliosPlaceholderMatches: "No matches were found for your query, please try again",
      noPortfoliosPlaceholderButtonLabel: "Create portfolios",
      noPublicPortfoliosPlaceholderButtonLabel: "Share portfolios",
      noPortfoliosPlaceholderNoMatches: "No matches were found for your query, please try again"
    },
    banner: {
      view: "View",
      renew: "Renew",
      dismiss: "Dismiss",
      notifications: {
        freePlanUpdate: "DASH is now FREE for Basic Plan users! Learn more about this update by clicking here.",
        upgradeSubscription: "Your subscription has limited access - upgrade your plan to gain full access.",
        brokerInfoIncomplete: "Complete your profile and provide clients with a visually enhanced property viewing experience.",
        cancelSubscription: "Please note that when your subscription expires, access to platform features will be limited. Renew today to continue enjoying the full benefits.",
        phoneVerification: "Please verify your phone number.",
        brokerLicense: "Your agent license is invalid. Please contact DASH Support.",
        trialExpired: "Your DASH Trial period will end on {{date}}. The payment method on file will be charged automatically at the end of your trial. Visit your Account Billing Settings to review your payment methods."
      }
    }
  },
  managementPage: {
    addNewUser: "Add New User",
    editUser: "Edit User",
    emptyPlaceholder: "There Are No Users",
    archiveConfirmationTitle: "Archive User",
    unarchiveConfirmationTitle: "unarchive User",
    archiveConfirmationBody: "Are you sure you want to archive this user?",
    unarchiveConfirmationBody: "Are you sure you want to unarchive this user?",
    toasts: {
      userAdded: "User was added successfully",
      userUpdated: "User was updated successfully",
      userArchived: "User was archived successfully",
      userUnarchived: "User was unarchived successfully"
    }
  },
  apiUsersPage: {
    addNewUser: "Add New API Representative",
    addNewUserButton: "Add API Representative",
    editUser: "Edit API Representative"
  },
  trackingPage: {
    noPropertiesLabelTitle: "You are not tracking any properties yet!",
    noPropertiesLabel: "Save your favorite properties in the tracking folder to easily access them.",
    noPropertiesButtonLabel: "Start Browsing",
    trackProperty: "Track Property"
  },
  externalSalesPage: {
    addUser: "Add User",
    addExternalTeam: "Add New Team",
    editExternalTeam: "Edit Team",
    toasts: {
      teamAdded: "Team was added successfully",
      teamChanged: "Team was successfully changed",
      userAdded: "User was added successfully",
      userUpdated: "User was updated successfully"
    },
    deleteSaleTeamModalLabel: "Delete Team",
    deleteSaleTeamModalText: "Are you sure you want to delete the {{teamName}} team?",
    addSaleTeamUserModalLabel: "Add Users to the Sales Team",
    editSaleTeamUserModalLabel: "Edit Sales Team User",
    deleteSaleTeamUserModalLabel: "Delete Sales Team User",
    deleteSaleTeamUserModalText: "By deleting this user from the sales team you will revoke the user\u2019s access and permissions granted within the sales team. Are you sure you want to proceed?",
    archiveUserText: "Are you sure you want to archive this sales team user?",
    unarchiveUserText: "Are you sure you want to unarchive this sales team user?"
  },
  organizationDashboardPage: {
    deleteOrganizationModalNote: "This may impact associated properties",
    mediaKitWidgetPlaceholderTitle: "File / DASH Downloads",
    propertySavesPlaceholderTitle: "Property Saves",
    propertySavesPlaceholderText: "This property has not been saved by any agents yet.",
    propertySharesPlaceholderTitle: "Property Shares",
    propertySharesPlaceholderText: "This property has not been shared by any agents yet.",
    addedToPortfoliosPlaceholderTitle: "Added to Portfolios",
    addedToPortfoliosPlaceholderText: "This property has not yet been added to a portfolio.",
    propertySavesPlaceholderTextPeriod: "This property was not added by any agents during the selected time range.",
    propertySharesPlaceholderTextPeriod: "No properties shared for the selected time range.",
    propertyAddedPortfolioPlaceholderText: "This property has not yet been added to a portfolio.",
    propertyAddedPortfolioPlaceholderTextPeriod: "This property was not added to a portfolio during the selected time range.",
    propertyMediaKitPlaceholderText: "No downloads yet.",
    propertyMediaKitPlaceholderTextPeriod: "No downloads for the selected time range.",
    viewedByAgents: "Viewed by Agents",
    viewedByAgentsNoResult: "No views for the selected time frame",
    viewedByAgentsPlaceholderTitle: "No views by agents yet",
    downloadedFilesTitle: "Most Popular Files",
    downloadedFilesPlaceholderTitle: "No files have been downloaded yet.",
    exportData: "Export Data",
    propertyName: "Property Name",
    filterByDate: "Filter by Date",
    selectRange: "Select Range",
    customRange: "Custom Range",
    totalValue: "Total Value",
    widgetsEmptyFilterTexts: {
      propertyShared: "No properties shared during the selected time period",
      addedToPortfolios: "This property was not added to any portfolios during the selected time period.",
      propertySaves: "This property was not saved by any agents during the selected time frame.",
      fileDownloads: "No downloads for the selected time period"
    }
  },
  mediaKit: {
    dashDownloads: "DASH Downloads",
    enableDashDownloads: "Enable DASH Downloads",
    mediaKitText: "Add and customize which property media files show for this property in your portfolio.",
    propertyMediaFiles: "Property Media",
    addedToDashDownloads: "{{total}} Files Added to portfolio",
    manageMediaKit: "DASH Downloads",
    numberOfAddedItems: "Added Media Files",
    addToMedia: "Add to Media",
    added: "Added",
    addTitle: "Share Your Portfolio",
    addSubtitle: "Choose how you want to share the portfolio.",
    editTitle: "Edit Media Kit",
    editSubtitle: "You can add/delete property media files to the media kit"
  }
};

// src/assets/dictionary/en/tables.ts
var tables_default = {
  organizations: {
    addNewButtonLabel: "Add New Organization",
    searchInputPlaceholder: "Search Organizations",
    organizationNameLabel: "Organization Name",
    totalPropertiesLabel: "Total Properties:",
    addedOnLabel: "Added On:",
    placeholder: "There are no properties assigned to this organization",
    paginationLabel: "Showing {{page}} of {{total}} Organizations",
    thereAreNoOrganizations: "There are no organizations"
  },
  marketAreas: {
    addNewMarket: "Add New Market",
    paginationLabel: "Showing {{page}} of {{total}} Market Areas",
    search: "Search",
    placeholder: "There are no market areas"
  },
  amenities: {
    addNewAmenity: "Add New Amenity",
    noAmenities: "No amenities are created yet",
    searchAmenities: "Search Amenities",
    paginationLabel: "Showing {{page}} of {{total}} Amenities"
  },
  organizationSaleTeams: {
    addNewButtonLabel: "Add New Sales Team",
    searchInputPlaceholder: "Search Sales Team",
    placeholder: "No Sales Teams Assigned to this Organization",
    paginationLabel: "Showing {{page}} of {{total}} Sale Teams"
  },
  organizationUsers: {
    addNewButtonLabel: "Invite New User",
    searchInputPlaceholder: "Search Users",
    placeholder: "No Users Assigned to this Organization",
    paginationLabel: "Showing {{page}} of {{total}} Users",
    sendInvitation: "Send Invitation",
    resendInvitation: "Resend Invite"
  },
  organizationProperties: {
    placeholder: "No Properties Assigned to this Organization",
    placeholderSearch: "Your search did not returned any results."
  },
  properties: {
    nameLabel: "Property Name",
    updatedAtLabel: "Last Update",
    addNewButtonLabel: "Add New Property",
    searchInputPlaceholder: "Search Properties",
    placeholder: "There are no properties.",
    placeholderSearch: "Your search did not return any results.",
    paginationLabel: "Showing {{page}} of {{total}} Properties",
    statusSelectPlaceholder: "Visibility",
    organizationSelectPlaceholder: "All Organizations",
    updatePaginationLabel: "Showing {{page}} of {{total}}"
  },
  inventory: {
    addNewButtonLabel: "Add Inventory",
    searchInputPlaceholder: "Search Inventory",
    placeholder: "There is no inventory associated with this property",
    paginationLabel: "Showing {{page}} of {{total}} Inventory",
    name: "Name",
    quantity: "Quantity",
    quantityShort: "QTY",
    bedrooms: "Beds",
    bathrooms: "Baths",
    breakdownSqft: "SQFT Breakdown",
    totalSqft: "TOTAL SQFT",
    interiorSqft: "Int. SQFT",
    exteriorSqft: "Ext. SQFT",
    inventoryType: "Type",
    priceRange: "Price range",
    floorplan: "Floorplan",
    customRooms: "Additional Rooms",
    customRoomsShortened: "Addl. Rooms",
    lastListedFrom: "Last listed from",
    lastListedFromShortened: "Priced from",
    units: "Units",
    recent: "Recent",
    priceDown: "Price (Highest to Lowest)",
    priceUp: "Price (Lowest to Highest)"
  },
  marketingFiles: {
    categoryPlaceholder: "All Categories",
    fileTypePlaceholder: "All File Types",
    totalCountLabel: "{{totalCount}} Marketing Files",
    paginationLabel: "Showing {{page}} of {{total}}",
    filesSelectedLabel: "{{totalCount}} Files Selected",
    downloadAllLabel: "Download All",
    downloadSelectedLabel: "Download Selected",
    searchInputPlaceholder: "Search",
    placeholder: "Currently there are no media files available for this property"
  },
  transactionHistory: {
    invoiceName: "Invoice Name",
    dateOfCharge: "Date of Charge",
    status: "Status",
    amount: "Amount",
    statuses: {
      draft: "Draft",
      open: "Open",
      paid: "Successful",
      uncollectible: "Uncollectible",
      void: "Void"
    }
  },
  brokers: {
    searchBrokers: "Search Agents",
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    userStatus: "User Status",
    subscriptionPlan: "Sub. Plan",
    createdAt: "Created Date",
    subStatus: "Sub. Status",
    placeholder: "There are no agents",
    viewAction: "View / Edit",
    unblockAction: "Unblock",
    blockAction: "Block",
    delete: "Delete",
    paginationLabel: "Showing {{page}} of {{total}} Agents",
    userAccountStatus: "User Account Status"
  },
  cmsUsers: {
    unarchive: "Unarchive",
    archive: "Archive",
    edit: "Edit",
    delete: "Delete"
  },
  reactions: {
    nameOrId: "Name or ID",
    email: "Email",
    properties: "Properties",
    reactions: "Reactions"
  },
  propertyNote: {
    placeholder: "This property has no notes",
    paginationLabel: "Showing {{page}} of {{total}}"
  },
  externalSales: {
    placeholder: "There is no external sales team",
    paginationLabel: "Showing {{page}} of {{total}} External Sales"
  },
  propertyComparison: {
    bedrooms: "Beds Range",
    bathrooms: "Baths Range",
    status: "Property Status",
    availableUnits: "Total Units"
  }
};

// src/assets/dictionary/index.ts
var dictionary = {
  [import_dash_common3.DashLanguages.EN]: {
    common: common_default,
    forms: forms_default,
    pages: pages_default,
    tables: tables_default
  }
};

// src/i18n.ts
import_i18next.default.use(import_react_i18next.initReactI18next).init({
  debug: false,
  defaultNS: ["common"],
  ns: Object.keys(dictionary.en),
  fallbackLng: import_dash_common4.DashLanguages.EN,
  resources: dictionary,
  returnNull: false
});
var i18n_default = import_i18next.default;

// src/themes/main.ts
function hexToRgb(hex2) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex2);
  return result ? `${parseInt(result[1], 16)} ${parseInt(result[2], 16)} ${parseInt(result[3], 16)}` : "";
}
var breakpoints = {
  xsm: 576,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280
};
var mainTheme = {
  space: 4,
  colors: {
    black: "#000000",
    white: "#FFFFFF",
    // primary
    b200: "#00278E",
    b90: "#00278E",
    b80: "#0e3979",
    b70: "#143d79",
    b60: "#004c87",
    b50: "#1B75BB",
    b50Hover: "#338ACE",
    b50Active: "#1773BA",
    b100: "#1B75BB",
    b40: "#8DBADD",
    b30: "#D4E5F3",
    b20: "#E2EDF6",
    b10: "#F8FBFD",
    b5: "#F3F7FB",
    // secondary
    g20: "#00905B",
    g20Hover: "#0E7E55",
    g20Active: "#1A6B4E",
    g10: "#F2F9F7",
    g40: "#2cf37b",
    r60: "#ED3C11",
    r20: "#D13C3C",
    r20Hover: "#CD2727",
    r20Active: "#CF1010",
    r10: "#FCF5F5",
    y20: "#FABF3F",
    y10: "#FFFAE6",
    p10: "#6F0B71",
    // naturals
    n200: "#253858",
    n90: "#191C35",
    n80: "#525569",
    n70: "#888A98",
    n60: "#BABAC0",
    n50: "#D8D8D8",
    n40: "#E6E6E6",
    n30: "#EDEDEF",
    n20: "#F8F8F9",
    n10: "#FCFCFC",
    setOpacity: (color2, opacity) => `rgb(${hexToRgb(color2)} / ${opacity}%)`
  },
  gradientColorsSet: {
    blue: ["#94D0FF", "#1B75BB"],
    red: ["#FE6C6C", "#FE464B"],
    purple: ["#FDAEFF", "#B111B5"],
    green: ["#B6FFE4", "#00905B"],
    yellow: ["#FFD572", "#FEBD38"]
  },
  typography: {
    weight: {
      bolder: 900,
      bold: 700,
      semibold: 600,
      medium: 500,
      regular: 400
    },
    fontSize: {
      // xs  sm smplus md  lg  xl  xxl
      //note: md was reduced from 15 to 14.89 due to a specific case that caused a line break on the property card
      text: [11, 12, 13, 14.89, 17, 20, 24],
      header: [28, 28, 36, 36, 36]
    },
    lineHeight: {
      text: [16, 16, 24, 28, 32, 36],
      header: [44, 44, 44, 56, 56]
    }
  },
  modalSize: {
    width: {
      // xsm  sm  md  lg  xl  xxl
      sm: [327, 432, 432, 432, 432],
      md: [327, 610, 610, 610, 610],
      lg: [343, 724, 724, 724, 724],
      xl: [463, 724, 926, 926, 926]
    }
  },
  breakpoints,
  devices: {
    mobile: `only screen and (max-width: ${breakpoints.md - 1}px)`,
    tablet: `only screen and (min-width: ${breakpoints.md}px) and (max-width: ${breakpoints.lg}px)`,
    laptop: `only screen and (min-width: ${breakpoints.lg + 1}px) and (max-width: ${breakpoints.xl - 1}px)`,
    desktop: `only screen and (min-width: ${breakpoints.xl}px)`
  },
  shadows: {
    shadow1: "0px 2px 14px rgba(0, 0, 0, 0.05)",
    shadow2: "0px 0px 8px rgba(0, 0, 0, 0.12)",
    shadow3: "0px 0px 0px 3px rgba(27, 117, 187, 0.3)",
    subscriptionCardShadow: "0 0 20px rgb(0 0 0 / 0.25)",
    sidebarShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)"
  }
};

// src/components/atoms/Form/Select/Select.styles.ts
var import_styled_components11 = __toESM(require("styled-components"));

// src/components/atoms/Flex/Flex.tsx
var import_styled_components2 = __toESM(require("styled-components"));

// src/components/atoms/Box/Box.tsx
var import_styled_components = __toESM(require("styled-components"));
var parseResponsiveProps = (box, index2, key) => (
  // @ts-ignore
  Array.isArray(box[key]) ? box[key][index2] : box[key]
);
var getBoxStyle = (box, theme, index2) => {
  const w = parseResponsiveProps(box, index2, "w");
  const h = parseResponsiveProps(box, index2, "h");
  const minWidth = parseResponsiveProps(box, index2, "minWidth");
  const minHeight = parseResponsiveProps(box, index2, "minHeight");
  const maxWidth = parseResponsiveProps(box, index2, "maxWidth");
  const maxHeight = parseResponsiveProps(box, index2, "maxHeight");
  const p = parseResponsiveProps(box, index2, "p");
  const px = parseResponsiveProps(box, index2, "px");
  const py = parseResponsiveProps(box, index2, "py");
  const pt = parseResponsiveProps(box, index2, "pt");
  const pb = parseResponsiveProps(box, index2, "pb");
  const pr = parseResponsiveProps(box, index2, "pr");
  const pl = parseResponsiveProps(box, index2, "pl");
  const m = parseResponsiveProps(box, index2, "m");
  const mx = parseResponsiveProps(box, index2, "mx");
  const my = parseResponsiveProps(box, index2, "my");
  const mt = parseResponsiveProps(box, index2, "mt");
  const mb = parseResponsiveProps(box, index2, "mb");
  const mr = parseResponsiveProps(box, index2, "mr");
  const ml = parseResponsiveProps(box, index2, "ml");
  const gap = parseResponsiveProps(box, index2, "gap");
  const pos = parseResponsiveProps(box, index2, "pos");
  const flex = parseResponsiveProps(box, index2, "flex");
  const overflow = parseResponsiveProps(box, index2, "overflow");
  return `
    ${w ? `width:${w}${typeof w === "number" ? "px" : ""};` : ""}
    ${minWidth ? `min-width:${minWidth}${typeof minWidth === "number" ? "px" : ""};` : ""}
    ${maxWidth ? `max-width:${maxWidth}${typeof maxWidth === "number" ? "px" : ""};` : ""}
    ${h ? `height:${h}${typeof h === "number" ? "px" : ""};` : ""}
    ${minHeight ? `min-height:${minHeight}${typeof minHeight === "number" ? "px" : ""};` : ""}
    ${maxHeight ? `max-height:${maxHeight}${typeof maxHeight === "number" ? "px" : ""};` : ""}
    ${typeof p === "number" ? `padding:${p * theme.space}px;` : ""}
    ${typeof py === "number" ? `padding-top:${py * theme.space}px;padding-bottom:${py * theme.space}px;` : ""}
    ${typeof px === "number" ? `padding-right:${px * theme.space}px;padding-left:${px * theme.space}px;` : ""}
    ${typeof pt === "number" ? `padding-top:${pt * theme.space}px;` : ""}
    ${typeof pb === "number" ? `padding-bottom:${pb * theme.space}px;` : ""}
    ${typeof pr === "number" ? `padding-right:${pr * theme.space}px;` : ""}
    ${typeof pl === "number" ? `padding-left:${pl * theme.space}px;` : ""}
    ${typeof m === "number" ? `margin:${m * theme.space}px;` : ""}
    ${typeof my === "number" ? `margin-top:${my * theme.space}px;margin-bottom:${my * theme.space}px;` : ""}
    ${typeof mx === "number" ? `margin-right:${mx * theme.space}px;margin-left:${mx * theme.space}px;` : ""}
    ${typeof mt === "number" ? `margin-top:${mt * theme.space}px;` : ""}
    ${typeof mb === "number" ? `margin-bottom:${mb * theme.space}px;` : ""}
    ${typeof mr === "number" ? `margin-right:${mr * theme.space}px;` : ""}
    ${typeof ml === "number" ? `margin-left:${ml * theme.space}px;` : ""}
    ${gap ? `gap:${gap}px;` : ""}
    ${pos ? `position: ${pos};` : ""}
    ${flex ? `flex: ${flex};` : ""}
    ${overflow ? `overflow: ${overflow};` : ""}
    
  `;
};
var getResponsiveStyle = (box, theme) => {
  const mobile = getBoxStyle(box, theme, 0);
  const tablet = getBoxStyle(box, theme, 1);
  const laptop = getBoxStyle(box, theme, 2);
  const desktop = getBoxStyle(box, theme, 3);
  return `
    ${mobile.trim().length ? `@media ${theme.devices.mobile} {${mobile}};` : ""}
    ${tablet.trim().length ? `@media ${theme.devices.tablet} {${tablet}};` : ""}
    ${laptop.trim().length ? `@media ${theme.devices.laptop} {${laptop}};` : ""}
    ${laptop.trim().length ? `@media ${theme.devices.desktop} {${desktop}};` : ""}
  `;
};
var boxStyle = import_styled_components.css`
  ${({ theme, ...box }) => getBoxStyle(box, theme, 3)}
  ${({ theme, ...box }) => getResponsiveStyle(box, theme)}
`;
var Box = import_styled_components.default.div`
  ${boxStyle};
  box-sizing: border-box;
`;
var Box_default = Box;

// src/components/atoms/Flex/Flex.tsx
var getFlexStyle = (box, index2) => {
  const flex = parseResponsiveProps(box, index2, "flex");
  const justifyContent = parseResponsiveProps(box, index2, "justifyContent") || "start";
  const alignItems = parseResponsiveProps(box, index2, "alignItems") || "start";
  const flexDirection = parseResponsiveProps(box, index2, "flexDirection") || "row";
  const flexWrap = parseResponsiveProps(box, index2, "flexWrap") || "nowrap";
  const flexGrow = parseResponsiveProps(box, index2, "flexGrow");
  const alignSelf = parseResponsiveProps(box, index2, "alignSelf") || "auto";
  return `
    ${flex ? `flex: ${flex};` : ""};
    justify-content: ${justifyContent};
    align-items: ${alignItems};
    flex-direction: ${flexDirection};
    flex-wrap: ${flexWrap};
    align-self: ${alignSelf};
    flex-grow: ${flexGrow !== void 0 ? flexGrow : ""};
  `;
};
var getResponsiveStyle2 = (box, theme) => {
  const mobile = getFlexStyle(box, 0);
  const tablet = getFlexStyle(box, 1);
  const laptop = getFlexStyle(box, 2);
  return `
    ${mobile.trim().length ? `@media ${theme.devices.mobile} {${mobile}};` : ""}
    ${tablet.trim().length ? `@media ${theme.devices.tablet} {${tablet}};` : ""}
    ${laptop.trim().length ? `@media ${theme.devices.laptop} {${laptop}};` : ""}
  `;
};
var flexStyle = import_styled_components2.css`
  display: flex;
  ${(props) => getFlexStyle(props, 3)}
  ${({ theme, ...box }) => getResponsiveStyle2(box, theme)}
`;
var Flex = (0, import_styled_components2.default)(Box_default)`
  ${flexStyle}
`;
var Flex_default = Flex;

// src/components/atoms/Form/Input/Input.styles.ts
var import_styled_components5 = __toESM(require("styled-components"));

// src/components/atoms/Text/Text.tsx
var import_styled_components3 = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var getSize = (theme, { xs, sm, smplus, md, lg, xl, xxl }, textFieldType, type) => {
  const sizeArray = theme.typography[textFieldType][type || "text"];
  const size = { xs, sm, smplus, md, lg, xl, xxl };
  const index2 = Object.keys(size).findIndex((key) => !!size[key]);
  return sizeArray[index2] || sizeArray[3];
};
var getFontWeight = (theme, { bolder, bold, semibold, medium, regular = true }) => {
  const {
    typography: { weight }
  } = theme;
  return bolder && weight?.bolder || bold && weight?.bold || semibold && weight?.semibold || medium && weight?.medium || regular && weight?.regular;
};
var textStyle = import_styled_components3.css`
  margin-block-start: unset;
  margin-block-end: unset;
  font-family: 'Work Sans';
  overflow-wrap: ${({ overflowWrap }) => overflowWrap || "anywhere"}};
  font-style: normal;
  font-weight: ${({ theme, bolder, bold, semibold, medium, regular = true }) => getFontWeight(theme, {
  bolder,
  bold,
  semibold,
  medium,
  regular
})};
  font-size: ${({ theme, xs, sm, smplus, md, lg, xl, xxl }) => getSize(theme, { xs, sm, smplus, md, lg, xl, xxl }, "fontSize")}px;
  line-height: ${({ theme, xs, sm, md, lg, xl, xxl }) => getSize(theme, { xs, sm, md, lg, xl, xxl }, "lineHeight")}px;
  color: ${({ color: color2, theme }) => color2 || theme.colors.n90};
  text-decoration-line: ${({ textDecoration }) => textDecoration || "none"};
  white-space: ${({ whiteSpace }) => whiteSpace || "normal"};
  ${({ cursor }) => cursor && `cursor: ${cursor}`};
`;
var ellipsisStyle = import_styled_components3.css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: ${({ clamp }) => clamp || 1};
  -webkit-box-orient: vertical;
`;
var TextPStyles = import_styled_components3.default.p`
  ${textStyle}
  ${({ ellipsis }) => ellipsis ? ellipsisStyle : ""}
`;
var TextSpamStyles = import_styled_components3.default.span`
  ${textStyle}
  ${({ ellipsis }) => ellipsis ? ellipsisStyle : ""}
`;
function Text({ id: id2, children, textRef, as = "p", ...args }) {
  const TextStyles = as === "p" ? TextPStyles : TextSpamStyles;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(TextStyles, { id: id2, ref: textRef, ...args, children });
}
var Text_default = Text;

// src/components/atoms/Icon/Icon.tsx
var import_styled_components4 = __toESM(require("styled-components"));

// src/components/atoms/Icon/Icon.generated.ts
var icons = { "account": { "viewBox": "0 0 16 16", "path": "M.62 14.667a.666.666 0 1 0 1.333 0 5.956 5.956 0 0 1 3.465-5.42 4.635 4.635 0 0 0 5.077-.006 5.962 5.962 0 0 1 3.458 5.425.666.666 0 1 0 1.333 0 7.286 7.286 0 0 0-2.148-5.184 7.384 7.384 0 0 0-1.58-1.19 4.645 4.645 0 0 0 1.061-2.959A4.672 4.672 0 0 0 7.952.667a4.672 4.672 0 0 0-4.666 4.666c0 1.12.397 2.149 1.057 2.954a7.29 7.29 0 0 0-3.723 6.38ZM7.952 2a3.337 3.337 0 0 1 3.334 3.333 3.337 3.337 0 0 1-3.334 3.334A3.337 3.337 0 0 1 4.62 5.333 3.337 3.337 0 0 1 7.952 2Z", "properties": { "fill": "currentColor" } }, "addPhoto": { "viewBox": "0 0 26 26", "path": "M21.333 7.333v3.987s-2.653.013-2.666 0V7.333h-4s.013-2.653 0-2.666h4v-4h2.666v4h4v2.666h-4Zm-4 5.334v-4h-4v-4H2.667A2.675 2.675 0 0 0 0 7.333v16C0 24.8 1.2 26 2.667 26h16c1.466 0 2.666-1.2 2.666-2.667V12.667h-4ZM2.667 23.333l4-5.333 2.666 4 4-5.333 5.334 6.666h-16Z", "properties": { "fill": "currentColor" } }, "addCircleOutline": { "viewBox": "0 0 24 24", "path": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7Zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z", "properties": { "fill": "currentColor" } }, "apps": { "viewBox": "0 0 24 24", "path": "M7 0H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3Zm11-7h-3a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3ZM7 13H4a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3Zm11-7h-3a4 4 0 0 0-4 4v3a4 4 0 0 0 4 4h3a4 4 0 0 0 4-4v-3a4 4 0 0 0-4-4Zm2 7a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3Z", "properties": { "fill": "currentColor" } }, "archive": { "viewBox": "0 0 12 12", "path": "m11.693 1.487-.926-1.12A.968.968 0 0 0 10 0H2a.99.99 0 0 0-.773.367l-.92 1.12A1.305 1.305 0 0 0 0 2.333v8.334C0 11.4.6 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V2.333c0-.32-.113-.62-.307-.846ZM6 9.667 2.333 6h2.334V4.667h2.666V6h2.334L6 9.667ZM1.413 1.333l.54-.666h8l.627.666H1.413Z", "properties": { "fill": "currentColor" } }, "arrowDown": { "viewBox": "0 0 24 24", "path": "M18.53 8.47a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 1.06-1.06L12 13.94l5.47-5.47a.75.75 0 0 1 1.06 0Z", "properties": { "fill": "currentColor" } }, "arrowUp": { "viewBox": "0 0 24 24", "path": "M5.47 15.53a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 10.06l-5.47 5.47a.75.75 0 0 1-1.06 0Z", "properties": { "fill": "currentColor" } }, "arrowLeft": { "viewBox": "0 0 24 24", "path": "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41Z", "properties": { "fill": "currentColor" } }, "arrowRight": { "viewBox": "0 0 24 24", "path": "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41Z", "properties": { "fill": "currentColor" } }, "artboard": { "viewBox": "0 0 16 14", "path": "M6 7a3.301 3.301 0 0 1-3.333-3.333A3.301 3.301 0 0 1 6 .333a3.301 3.301 0 0 1 3.333 3.334A3.301 3.301 0 0 1 6 7Zm0-5.333c-1.133 0-2 .867-2 2s.867 2 2 2 2-.867 2-2-.867-2-2-2Zm9.334 12c-.4 0-.667-.267-.667-.667v-1.333c0-.933-.6-1.733-1.533-1.933-.334-.067-.6-.467-.467-.8.067-.334.467-.6.8-.467 1.467.4 2.467 1.733 2.533 3.2V13c0 .4-.266.667-.666.667Zm-4.667-6.733c-.267 0-.6-.2-.667-.534-.067-.333.133-.733.467-.8a2.043 2.043 0 0 0 1.466-1.466c.267-1.067-.4-2.134-1.466-2.467-.334 0-.534-.4-.467-.733.067-.334.467-.6.8-.467a3.32 3.32 0 0 1 2.4 4.067c-.333 1.2-1.2 2.133-2.4 2.4h-.133Zm.666 6.733c-.4 0-.666-.267-.666-.667v-1.333c0-1.133-.867-2-2-2H3.333c-1.133 0-2 .867-2 2V13c0 .4-.266.667-.666.667S0 13.4 0 13v-1.333a3.3 3.3 0 0 1 3.333-3.333h5.334A3.301 3.301 0 0 1 12 11.667V13c0 .4-.267.667-.667.667Z", "properties": { "fill": "currentColor" } }, "at": { "viewBox": "0 0 24 24", "path": "M9.868 11.492c-.195.769-.25 1.453-.18 2.059l.001.004c.06.555.221.93.436 1.174.204.222.449.326.778.326.632 0 1.111-.169 1.482-.48.387-.332.737-.851 1.023-1.6l.36-3.766c-.277-.213-.657-.336-1.19-.336-.603 0-1.14.204-1.628.65-.488.451-.858 1.095-1.082 1.969Zm3.887 3.866c-.226.24-.477.447-.755.617-.606.37-1.307.549-2.08.549-.496 0-.957-.101-1.363-.321a2.558 2.558 0 0 1-.97-.94l-.001-.003c-.472-.792-.617-1.796-.503-2.961v-.004c.154-1.417.621-2.598 1.442-3.5.825-.912 1.86-1.4 3.081-1.4.807 0 1.53.209 2.139.638l.002.001.011.009.254.19a1 1 0 0 1 .395.894l-.417 4.413c-.059.587.05.954.226 1.178.168.2.426.329.878.329.594 0 1.08-.238 1.485-.803l.001-.001c.424-.584.695-1.442.758-2.622v-.002c.129-2.125-.345-3.63-1.306-4.612-.958-.98-2.45-1.514-4.59-1.514-1.256 0-2.385.277-3.398.827a6.133 6.133 0 0 0-2.401 2.307c-.59.995-.927 2.128-1.002 3.407-.068 1.299.14 2.434.606 3.42a5.062 5.062 0 0 0 2.086 2.258c.924.535 2.024.811 3.322.811a139.035 139.035 0 0 1 1.515.008h1.335a.734.734 0 1 1 0 1.469h-2.887c-1.594 0-2.998-.32-4.189-.982a6.25 6.25 0 0 1-2.671-2.836c-.58-1.217-.82-2.621-.745-4.197.076-1.564.465-2.96 1.183-4.174a7.332 7.332 0 0 1 2.98-2.82C9.448 4.326 10.888 4 12.48 4c2.475 0 4.428.646 5.751 2.02 1.32 1.361 1.873 3.273 1.755 5.647a6.664 6.664 0 0 1-.539 2.445c-.328.75-.775 1.355-1.361 1.779l-.004.002a3.406 3.406 0 0 1-2.014.63c-.723 0-1.36-.198-1.858-.631a2.347 2.347 0 0 1-.454-.534Z", "properties": { "fill": "currentColor" } }, "autorenew": { "viewBox": "0 0 24 24", "path": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8A5.87 5.87 0 0 1 6 12c0-3.31 2.69-6 6-6Zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26Z", "properties": { "fill": "currentColor" } }, "backupTable": { "viewBox": "0 0 24 24", "path": "M20 6v14H6v2h14c1.1 0 2-.9 2-2V6h-2Z M16 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2ZM9 16H4v-5h5v5Zm7 0h-5v-5h5v5Zm0-7H4V4h12v5Z", "properties": { "fill": "currentColor" } }, "bank": { "viewBox": "0 0 24 24", "path": "M4 11.5v4c0 .83.67 1.5 1.5 1.5S7 16.33 7 15.5v-4c0-.83-.67-1.5-1.5-1.5S4 10.67 4 11.5Zm6 0v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5ZM3.5 22h16c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-16c-.83 0-1.5.67-1.5 1.5S2.67 22 3.5 22ZM16 11.5v4c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5ZM10.57 1.49l-7.9 4.16c-.41.21-.67.64-.67 1.1C2 7.44 2.56 8 3.25 8h16.51C20.44 8 21 7.44 21 6.75c0-.46-.26-.89-.67-1.1l-7.9-4.16c-.58-.31-1.28-.31-1.86 0Z", "properties": { "fill": "currentColor" } }, "bathroom": { "viewBox": "0 0 24 24", "path": "M16.718 16.629H6.939a2.387 2.387 0 0 1-2.335-1.841l-.981-4.086a1.373 1.373 0 0 1 1.349-1.616h7.2a.343.343 0 0 1 0 .686h-7.2a.686.686 0 0 0-.686.685c0 .041.006.083.01.124l.975 4.048a1.705 1.705 0 0 0 1.668 1.314h9.779c.8 0 1.486-.54 1.669-1.313l.981-4.088c-.003-.002.003-.043.003-.085a.686.686 0 0 0-.685-.685H16.5c-.19 0-.3-.283-.3-.472s.11-.214.3-.214h2.186a1.373 1.373 0 0 1 1.355 1.578l-.987 4.125a2.39 2.39 0 0 1-2.336 1.84Z M7.371 17.998a.344.344 0 0 1-.307-.497l.686-1.37a.344.344 0 0 1 .614.306l-.686 1.371a.342.342 0 0 1-.307.19Zm8.915 0a.343.343 0 0 1-.307-.189l-.685-1.371a.343.343 0 0 1 .613-.307l.686 1.372a.344.344 0 0 1-.307.495ZM15.3 13.5h-1.8c-.827 0-1.5-.674-1.5-1.5V9.6a.9.9 0 0 1 .9-.9h3a.9.9 0 0 1 .9.9V12c0 .826-.673 1.5-1.5 1.5Zm-2.4-4.2a.3.3 0 0 0-.3.3V12c0 .495.404.9.9.9h1.8c.496 0 .9-.405.9-.9V9.6a.3.3 0 0 0-.3-.3h-3ZM9.33 7.499a.33.33 0 0 1-.66 0h.66Zm-3.66 1.8v-1.8h.66v1.8h-.66Zm0-1.8c0-.61.22-1.093.574-1.423A1.84 1.84 0 0 1 7.5 5.594c.45 0 .908.157 1.256.482.354.33.574.814.574 1.423h-.66c0-.441-.155-.745-.364-.94a1.18 1.18 0 0 0-.806-.305c-.3 0-.592.105-.806.305-.21.195-.364.499-.364.94h-.66Z M12.171 11.826H4.286a.343.343 0 0 1 0-.685h7.885a.343.343 0 0 1 0 .685Zm7.286 0h-2.85a.343.343 0 0 1 0-.685h2.85a.343.343 0 0 1 0 .685Z", "properties": { "fill": "currentColor" } }, "bathtub": { "viewBox": "0 0 24 24", "path": "M7 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm13 4V4.83C20 3.27 18.73 2 17.17 2c-.75 0-1.47.3-2 .83l-1.25 1.25c-.16-.05-.33-.08-.51-.08-.4 0-.77.12-1.08.32l2.76 2.76c.2-.31.32-.68.32-1.08 0-.18-.03-.34-.07-.51l1.25-1.25a.828.828 0 0 1 1.41.59V13h-6.85c-.3-.21-.57-.45-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5A2.251 2.251 0 0 0 5 12.25V13H2v6c0 1.1.9 2 2 2 0 .55.45 1 1 1h14c.55 0 1-.45 1-1 1.1 0 2-.9 2-2v-6h-2Z", "properties": { "fill": "currentColor" } }, "bedroom": { "viewBox": "0 0 24 24", "path": "M19.13 10.977V7.765c0-.973-.793-1.765-1.765-1.765H6.776c-.972 0-1.764.792-1.764 1.765v3.212A1.768 1.768 0 0 0 3.6 12.706v4.941a.353.353 0 0 0 .706 0v-1.059h15.53v1.059a.353.353 0 0 0 .705 0v-4.941c0-.852-.608-1.565-1.412-1.729ZM5.717 7.765a1.06 1.06 0 0 1 1.058-1.06h10.589a1.06 1.06 0 0 1 1.059 1.06v3.176h-.972a1.05 1.05 0 0 0 .035-.61l-.352-1.412a1.057 1.057 0 0 0-1.027-.801h-2.273a1.06 1.06 0 0 0-1.059 1.058v1.412c0 .125.026.242.065.353H11.3c.04-.11.065-.229.065-.353V9.176a1.06 1.06 0 0 0-1.06-1.058h-2.27c-.487 0-.91.33-1.027.801l-.353 1.412a1.05 1.05 0 0 0 .035.61h-.971V7.765Zm11.02 3.04a.35.35 0 0 1-.278.136h-2.625a.353.353 0 0 1-.353-.353V9.176c0-.194.158-.353.353-.353h2.273c.162 0 .302.11.342.268l.353 1.412a.349.349 0 0 1-.065.303Zm-6.08-1.63v1.412a.353.353 0 0 1-.353.354H7.68a.351.351 0 0 1-.342-.438L7.69 9.09a.355.355 0 0 1 .342-.267h2.272c.195 0 .353.158.353.353Zm9.177 6.707H4.305v-.705h15.53v.705Zm0-1.411H4.305v-1.765a1.06 1.06 0 0 1 1.06-1.059h13.411a1.06 1.06 0 0 1 1.06 1.059v1.765Z", "properties": { "fill": "currentColor" } }, "bookmark": { "viewBox": "0 0 24 24", "path": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2Z", "properties": { "fill": "currentColor" } }, "bookmarkBorder": { "viewBox": "0 0 24 24", "path": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2Zm0 15-5-2.18L7 18V5h10v13Z", "properties": { "fill": "currentColor" } }, "building": { "viewBox": "0 0 48 48", "path": "M43.178 45.187V10.693h-4.466v34.494h-2.814V0L12.095 6.674v9.56h10.168v28.953H19.45v-26.14H7.635v26.14H1.867V48h44.266v-2.813h-2.955ZM27.614 29.149v-5.658h2.813v5.658h-2.813Zm2.813 4.676v5.658h-2.813v-5.658h2.813Zm-2.813-15.01v-5.659h2.813v5.659h-2.813ZM12.136 23.49h2.813v5.658h-2.813V23.49Zm0 10.334h2.813v5.658h-2.813v-5.658Z", "properties": { "fill": "currentColor" } }, "calendarToday": { "viewBox": "0 0 24 24", "path": "M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2Zm0 18H4V8h16v13Z", "properties": { "fill": "currentColor" } }, "cancelCircle": { "viewBox": "0 0 16 16", "path": "M8 1.333A6.66 6.66 0 0 0 1.333 8 6.66 6.66 0 0 0 8 14.667 6.66 6.66 0 0 0 14.667 8 6.66 6.66 0 0 0 8 1.333Zm3.334 9.06-.94.94L8 8.94l-2.393 2.393-.94-.94L7.06 8 4.667 5.607l.94-.94L8 7.06l2.393-2.393.94.94L8.94 8l2.394 2.393Z", "properties": { "fill": "currentColor" } }, "cancel": { "viewBox": "0 0 17 16", "path": "M8.5 0a8 8 0 1 0 8 8 8.009 8.009 0 0 0-8-8ZM4.057 2.77A6.85 6.85 0 0 1 8.5 1.143c1.62 0 3.189.576 4.423 1.626l-9.657 9.657a6.85 6.85 0 0 1 .79-9.656Zm8.886 10.46A6.85 6.85 0 0 1 8.5 14.857a6.825 6.825 0 0 1-4.423-1.626l9.657-9.657a6.85 6.85 0 0 1-.79 9.656Z", "properties": { "fill": "currentColor" } }, "chart": { "viewBox": "0 0 16 16", "path": "M15.333 14.667h-12a2 2 0 0 1-2-2v-12A.667.667 0 1 0 0 .667v12A3.337 3.337 0 0 0 3.333 16h12a.666.666 0 1 0 0-1.333Z M4 13.333a.666.666 0 0 0 .667-.667V8a.667.667 0 1 0-1.333 0v4.666a.666.666 0 0 0 .666.667Zm2.667-6.666v6a.667.667 0 0 0 1.333 0v-6a.667.667 0 0 0-1.333 0Zm3.333 2v4a.667.667 0 1 0 1.333 0v-4a.667.667 0 1 0-1.333 0ZM13.334 6v6.666a.666.666 0 1 0 1.333 0V6a.667.667 0 1 0-1.333 0ZM4 6c.177 0 .346-.07.471-.196l2.39-2.39a.683.683 0 0 1 .943 0l1.448 1.448a2 2 0 0 0 2.828 0l3.724-3.724a.667.667 0 0 0-.942-.943l-3.724 3.723a.667.667 0 0 1-.943 0L8.747 2.471a2 2 0 0 0-2.828 0l-2.39 2.39A.667.667 0 0 0 3.998 6Z", "properties": { "fill": "currentColor" } }, "checkCircle": { "viewBox": "0 0 16 16", "path": "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333Zm-1.333 10L3.334 8l.94-.94 2.393 2.387 5.06-5.06.94.946-6 6Z", "properties": { "fill": "currentColor" } }, "check": { "viewBox": "0 0 24 24", "path": "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17Z", "properties": { "fill": "currentColor" } }, "checklist": { "viewBox": "0 0 16 16", "path": "M5.091 1.818H.728A.727.727 0 0 0 0 2.546v4.363c0 .402.326.727.728.727H5.09a.727.727 0 0 0 .728-.727V2.546a.727.727 0 0 0-.728-.728Zm-.727 4.364H1.455v-2.91h2.909v2.91ZM15.273 4H8a.727.727 0 1 0 0 1.455h7.273a.727.727 0 1 0 0-1.455Zm0 7.273H8a.727.727 0 0 0 0 1.454h7.273a.727.727 0 1 0 0-1.454ZM4.582 10.028l-2.421 2.393-.91-.946a.728.728 0 0 0-1.046 1.012l1.42 1.477a.733.733 0 0 0 .515.218h.009c.19 0 .373-.076.509-.21l2.942-2.91a.727.727 0 1 0-1.018-1.034Z", "properties": { "fill": "currentColor" } }, "chevronDown": { "viewBox": "0 0 24 24", "path": "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41Z", "properties": { "fill": "currentColor" } }, "chevronLeft": { "viewBox": "0 0 24 24", "path": "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59Z", "properties": { "fill": "currentColor" } }, "chevronRight": { "viewBox": "0 0 24 24", "path": "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6Z", "properties": { "fill": "currentColor" } }, "chevronUp": { "viewBox": "0 0 24 24", "path": "M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6 1.41 1.41Z", "properties": { "fill": "currentColor" } }, "city": { "viewBox": "0 0 126 126", "path": "M96.642 15.12v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V15.12a2.527 2.527 0 0 0-2.52-2.52H99.162a2.527 2.527 0 0 0-2.52 2.52Z M96.642 15.12v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.276a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V15.12a2.527 2.527 0 0 0-2.52-2.52H99.162a2.527 2.527 0 0 0-2.52 2.52Z M29.358 18.9v-3.78a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v9.198c0 1.008-.63 2.016-1.638 2.394l-5.292 2.142c-1.008.378-1.638 1.26-1.638 2.394v79.632a2.527 2.527 0 0 0 2.52 2.52h36.918a2.527 2.527 0 0 0 2.52-2.52v-94.5c0-1.764-1.764-3.024-3.402-2.394l-18.27 7.308c-1.386.63-3.276-.504-3.276-2.394Zm-2.52 86.058h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V65.52a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm16.884 50.4H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52V65.52A2.527 2.527 0 0 1 40.32 63h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z M29.358 18.9v-3.78a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v9.198c0 1.008-.63 2.016-1.638 2.394l-5.292 2.142c-1.008.378-1.638 1.26-1.638 2.394v79.632a2.527 2.527 0 0 0 2.52 2.52h36.918a2.527 2.527 0 0 0 2.52-2.52v-94.5c0-1.764-1.764-3.024-3.402-2.394l-18.27 7.308c-1.386.63-3.276-.504-3.276-2.394Zm-2.52 86.058h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V65.52a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm16.884 50.4H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52V65.52A2.527 2.527 0 0 1 40.32 63h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758H40.32a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z M79.758 26.838V15.12a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v11.718a2.527 2.527 0 0 1-2.52 2.52H65.52a2.527 2.527 0 0 0-2.52 2.52v79.002a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 0 2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V31.878a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 1-2.52-2.52Zm-2.52 69.804h-3.402a2.527 2.527 0 0 1-2.52-2.52V90.72a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V40.32a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z M79.758 26.838V15.12a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 0-2.52 2.52v11.718a2.527 2.527 0 0 1-2.52 2.52H65.52a2.527 2.527 0 0 0-2.52 2.52v79.002a2.527 2.527 0 0 0 2.52 2.52h3.402a2.527 2.527 0 0 0 2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 0 2.52 2.52h3.276a2.527 2.527 0 0 0 2.52-2.52V31.878a2.527 2.527 0 0 0-2.52-2.52h-3.402a2.527 2.527 0 0 1-2.52-2.52Zm-2.52 69.804h-3.402a2.527 2.527 0 0 1-2.52-2.52V90.72a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.884h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52v-3.402a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Zm0-16.758h-3.402a2.527 2.527 0 0 1-2.52-2.52V40.32a2.527 2.527 0 0 1 2.52-2.52h3.402a2.527 2.527 0 0 1 2.52 2.52v3.402a2.527 2.527 0 0 1-2.52 2.52Z", "properties": { "fill": "currentColor" } }, "close": { "viewBox": "0 0 24 24", "path": "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z", "properties": { "fill": "currentColor" } }, "comment": { "viewBox": "0 0 16 16", "path": "M16 7.498A8.008 8.008 0 1 0 8.01 16h4.655A3.337 3.337 0 0 0 16 12.667V7.498Zm-1.334 5.169a2 2 0 0 1-2 2H8.011a6.694 6.694 0 0 1-6.373-4.655 6.611 6.611 0 0 1-.262-2.783 6.695 6.695 0 0 1 5.771-5.84c.288-.037.577-.055.867-.055a6.614 6.614 0 0 1 4.252 1.533 6.692 6.692 0 0 1 2.4 4.695v5.105Z M5.333 6H8a.667.667 0 1 0 0-1.333H5.333a.667.667 0 0 0 0 1.333Zm5.333 1.333H5.333a.667.667 0 0 0 0 1.333h5.333a.667.667 0 1 0 0-1.333Zm0 2.667H5.333a.666.666 0 1 0 0 1.333h5.333a.667.667 0 1 0 0-1.333Z", "properties": { "fill": "currentColor" } }, "compareArrows": { "viewBox": "0 0 24 24", "path": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3Zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4Z", "properties": { "fill": "currentColor" } }, "condoHotels": { "viewBox": "0 0 16 16", "path": "m9.106 2.355.719-.704a.267.267 0 0 0-.148-.454l-.993-.145L8.24.15a.267.267 0 0 0-.48 0l-.444.903-.992.145a.267.267 0 0 0-.148.454l.719.704-.17.993a.267.267 0 0 0 .387.281L8 3.16c.856.452.92.496.985.5h.028c.166 0 .29-.15.263-.312l-.17-.993Zm-3.92.478.032.183a.267.267 0 0 1-.263.312c-.07 0-.107-.02-.216-.078a9.988 9.988 0 0 0-.073-.04l-.165.087a.267.267 0 0 1-.387-.28l.031-.184a.577.577 0 0 0-.044-.042c-.108-.102-.21-.198-.157-.362.054-.164.191-.181.34-.2l.06-.008.083-.167a.267.267 0 0 1 .478 0l.082.167.06.008c.148.018.287.036.34.2.053.164-.047.259-.157.361l-.044.042ZM2.853 4.165l.031.184a.267.267 0 0 1-.263.311c-.07 0-.106-.02-.215-.078l-.074-.04-.165.088a.267.267 0 0 1-.386-.281l.031-.184-.044-.042c-.109-.102-.21-.197-.157-.362.053-.164.19-.181.34-.2l.06-.008.082-.167a.267.267 0 0 1 .479 0l.082.167.06.008c.148.019.286.036.34.2.053.165-.048.26-.157.362l-.044.042Zm9.002-1.334.031.184a.267.267 0 0 1-.262.312c-.07 0-.107-.02-.216-.078a9.727 9.727 0 0 0-.073-.04l-.054.03c-.13.071-.253.138-.392.037-.14-.101-.114-.237-.086-.384l.011-.06-.133-.13a.267.267 0 0 1 .148-.455l.184-.027.026-.055c.063-.135.123-.261.296-.261.172 0 .231.125.295.26l.026.056.06.008c.148.018.286.036.34.2.053.164-.048.259-.157.361l-.044.042Zm2.333 1.334.032.184a.267.267 0 0 1-.263.311c-.07 0-.107-.02-.216-.078a9.405 9.405 0 0 0-.073-.04l-.053.03c-.131.072-.253.139-.393.037-.14-.101-.114-.237-.086-.384l.012-.06-.134-.13a.267.267 0 0 1 .148-.455l.184-.027c.01-.018.018-.036.026-.054.064-.135.123-.262.296-.262s.231.126.295.261c.009.018.017.037.027.055l.06.008c.147.019.286.036.34.2.053.165-.048.26-.158.362l-.044.042ZM3.806 16c.15 0 .27-.124.266-.274-.01-.306-.009-1.046-.007-2.984L4.067 8.8a.267.267 0 0 0-.267-.267H2.4c-.589 0-1.067.478-1.067 1.067v5.333c0 .59.478 1.067 1.067 1.067h1.406ZM2.9 10.933c.147 0 .267.12.267.267v1.133a.267.267 0 0 1-.534 0V11.2c0-.147.12-.267.267-.267Zm11.767 4V9.6c0-.59-.478-1.067-1.067-1.067h-1.4a.267.267 0 0 0-.266.267c0 1.715 0 3.012.002 3.995.001 1.9.002 2.628-.008 2.93a.266.266 0 0 0 .267.275H13.6c.59 0 1.067-.478 1.067-1.067Zm-1.567-4c.148 0 .267.12.267.267v1.133a.267.267 0 0 1-.534 0V11.2c0-.147.12-.267.267-.267ZM8.667 16H7.333a.267.267 0 0 1-.266-.267v-2.5c0-.147.12-.266.266-.266h1.334c.147 0 .266.119.266.266v2.5a.266.266 0 0 1-.266.267Zm2.733-.267V5.8c0-.59-.477-1.067-1.066-1.067H5.667c-.59 0-1.067.478-1.067 1.067v9.933c0 .148.12.267.267.267h1.4c.147 0 .266-.12.266-.267V12.7c0-.147.12-.267.267-.267h2.4c.147 0 .267.12.267.267v3.033c0 .148.12.267.266.267h1.4c.148 0 .267-.12.267-.267ZM8.794 6.667h.325c.118 0 .214.12.214.27v3.46c0 .15-.096.27-.214.27h-.325c-.118 0-.214-.12-.214-.27V9.14H7.42v1.257c0 .15-.096.27-.214.27H6.88c-.118 0-.214-.12-.214-.27v-3.46c0-.15.096-.27.214-.27h.325c.118 0 .215.12.215.27v1.257h1.16V6.936c0-.149.096-.27.214-.27Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "condominium": { "viewBox": "0 0 16 16", "path": "M15.167 14H.833a.833.833 0 0 0-.833.833v.334c0 .46.373.833.833.833h14.334c.46 0 .833-.373.833-.833v-.334a.833.833 0 0 0-.833-.833Zm-1-.333a.167.167 0 0 0 .166-.167V4.833A.834.834 0 0 0 13.5 4H7.833A.833.833 0 0 0 7 4.833V13.5a.167.167 0 0 0 .167.167H9.5v-1.334a1.167 1.167 0 0 1 2.333 0v1.334h2.334ZM9.833 9.833a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 8.5 8.5h1a.333.333 0 0 1 .333.333v1Zm0-3a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 8.5 5.5h1a.333.333 0 0 1 .333.333v1Zm1.667-1a.333.333 0 0 1 .333-.333h1a.333.333 0 0 1 .334.333v1a.333.333 0 0 1-.334.334h-1a.333.333 0 0 1-.333-.334v-1Zm0 4v-1a.333.333 0 0 1 .333-.333h1a.333.333 0 0 1 .334.333v1a.333.333 0 0 1-.334.334h-1a.333.333 0 0 1-.333-.334Z M9.833 0H2.167a.833.833 0 0 0-.834.833V13.5a.167.167 0 0 0 .167.167h5a.167.167 0 0 0 .167-.167V4.833a1.167 1.167 0 0 1 1.166-1.166H10.5a.167.167 0 0 0 .167-.167V.833A.833.833 0 0 0 9.833 0Zm-5 12.833a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 3.5 11.5h1a.333.333 0 0 1 .333.333v1Zm0-3.333a.333.333 0 0 1-.333.333h-1a.333.333 0 0 1-.333-.333v-1a.333.333 0 0 1 .333-.333h1a.333.333 0 0 1 .333.333v1Zm0-3.333A.333.333 0 0 1 4.5 6.5h-1a.333.333 0 0 1-.333-.333v-1a.333.333 0 0 1 .333-.334h1a.333.333 0 0 1 .333.334v1Zm0-3.334a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 3.5 1.5h1a.333.333 0 0 1 .333.333v1Zm4 0a.333.333 0 0 1-.333.334h-1a.333.333 0 0 1-.333-.334v-1A.333.333 0 0 1 7.5 1.5h1a.333.333 0 0 1 .333.333v1Z", "properties": { "fill": "currentColor" } }, "contentCopy": { "viewBox": "0 0 24 24", "path": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2Zm0 16H8V7h11v14Z", "properties": { "fill": "currentColor" } }, "creadit": { "viewBox": "0 0 24 24", "path": "M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2Zm1 14.915V18h-2v-1.08c-2.339-.367-3-2.002-3-2.92h2c.011.143.159 1 2 1 1.38 0 2-.585 2-1 0-.324 0-1-2-1-3.48 0-4-1.88-4-3 0-1.288 1.029-2.584 3-2.915V6.012h2v1.109c1.734.41 2.4 1.853 2.4 2.879h-1l-1 .018C13.386 9.638 13.185 9 12 9c-1.299 0-2 .516-2 1 0 .374 0 1 2 1 3.48 0 4 1.88 4 3 0 1.288-1.029 2.584-3 2.915Z", "properties": { "fill": "currentColor" } }, "creditCard": { "viewBox": "0 0 20 16", "path": "M18 0H2C.89 0 .01.89.01 2L0 14c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V2c0-1.11-.89-2-2-2Zm0 14H2V8h16v6Zm0-10H2V2h16v2Z", "properties": { "fill": "currentColor" } }, "dashExchange": { "viewBox": "0 0 16 18", "path": "M4 0H0l6 9-6 9h4l6-9-6-9Z M10.986 7.078 9.592 4.986 12.283.5h2.815l-4.112 6.578ZM12.283 17.5l-2.691-4.486 1.394-2.092 4.112 6.578h-2.815Z", "properties": { "fill": "currentColor" } }, "dashboard": { "viewBox": "0 0 24 24", "path": "M3 11h8V3H3v8Zm0 10h8v-8H3v8Zm10 0h8v-8h-8v8Zm0-18v8h8V3h-8Z", "properties": { "fill": "currentColor" } }, "domain": { "viewBox": "0 0 24 24", "path": "M12 7V3H2v18h20V7H12ZM6 19H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V9h2v2Zm0-4H4V5h2v2Zm4 12H8v-2h2v2Zm0-4H8v-2h2v2Zm0-4H8V9h2v2Zm0-4H8V5h2v2Zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10Zm-2-8h-2v2h2v-2Zm0 4h-2v2h2v-2Z", "properties": { "fill": "currentColor" } }, "domainDisabled": { "viewBox": "0 0 24 24", "path": "M8 5h2v2h-.9L12 9.9V9h8v8.9l2 2V7H12V3H5.1L8 5.9V5Zm8 6h2v2h-2v-2ZM1.3 1.8.1 3.1 2 5v16h16l3 3 1.3-1.3-21-20.9ZM6 19H4v-2h2v2Zm0-4H4v-2h2v2Zm0-4H4V9h2v2Zm4 8H8v-2h2v2Zm0-4H8v-2h2v2Zm2 4v-2h2l2 2h-4Z", "properties": { "fill": "currentColor" } }, "doneAll": { "viewBox": "0 0 24 24", "path": "m18 7-1.41-1.41-6.34 6.34 1.41 1.41L18 7Zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41ZM.41 13.41 6 19l1.41-1.41L1.83 12 .41 13.41Z", "properties": { "fill": "currentColor" } }, "dots": { "viewBox": "0 0 16 16", "path": "M8 6.5c-.827 0-1.5.673-1.5 1.5S7.173 9.5 8 9.5 9.5 8.827 9.5 8 8.827 6.5 8 6.5Zm-5 0c-.827 0-1.5.673-1.5 1.5S2.173 9.5 3 9.5 4.5 8.827 4.5 8 3.827 6.5 3 6.5Zm10 0c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5Z", "properties": { "fill": "currentColor" } }, "download": { "viewBox": "0 0 24 24", "path": "M21 18.25v-3a.75.75 0 1 0-1.5 0v3a.75.75 0 0 1-.75.75H5.25a.75.75 0 0 1-.75-.75v-3a.75.75 0 1 0-1.5 0v3a2.25 2.25 0 0 0 2.25 2.25h13.5A2.25 2.25 0 0 0 21 18.25Zm-4.785-3.915-3.75 3a.75.75 0 0 1-.93 0l-3.75-3a.75.75 0 0 1 .93-1.17l2.535 2.025V4.75a.75.75 0 1 1 1.5 0v10.44l2.535-2.025a.75.75 0 1 1 .93 1.17Z", "properties": { "fill": "currentColor" } }, "downloadSolid": { "viewBox": "0 0 18 18", "path": "M14.25 6.75h-3v-4.5h-4.5v4.5h-3L9 12l5.25-5.25ZM3.75 13.5V15h10.5v-1.5H3.75Z", "properties": { "fill": "currentColor" } }, "driveFileRenameOutline": { "viewBox": "0 0 24 24", "path": "M18.41 5.8 17.2 4.59c-.78-.78-2.05-.78-2.83 0l-2.68 2.68L3 15.96V20h4.04l8.74-8.74 2.63-2.63c.79-.78.79-2.05 0-2.83ZM6.21 18H5v-1.21l8.66-8.66 1.21 1.21L6.21 18ZM11 20l4-4h6v4H11Z", "properties": { "fill": "currentColor" } }, "driveFileMove": { "viewBox": "0 0 24 24", "path": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-6 12v-3h-4v-4h4V8l5 5-5 5Z", "properties": { "fill": "currentColor" } }, "editRoad": { "viewBox": "0 0 24 24", "path": "M18 4h-2v7.9l2-2V4ZM6 4H4v16h2V4Zm6 0h-2v4h2V4Zm0 6h-2v4h2v-4Zm0 6h-2v4h2v-4Zm10.56-3.41-1.15-1.15a1.49 1.49 0 0 0-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12Zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45Z", "properties": { "fill": "currentColor" } }, "edit": { "viewBox": "0 0 24 24", "path": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25ZM20.71 7.04a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z", "properties": { "fill": "currentColor" } }, "email": { "viewBox": "0 0 24 24", "path": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 4-8 5-8-5V6l8 5 8-5v2Z", "properties": { "fill": "currentColor" } }, "exchangeLogo": { "viewBox": "0 0 61 20", "path": "M3.778.008c0 .004.013.026.028.047a1048.675 1048.675 0 0 0 1.982 2.932c.005.009.283.42.619.914.336.494.612.902.614.907.006.01.945 1.4 1.046 1.547.108.156.922 1.36.927 1.371.002.005.279.414.615.908a123.897 123.897 0 0 1 .772 1.144c.083.12.144.223.14.235-.005.011-.282.424-.616.917l-1.12 1.656a2097.996 2097.996 0 0 1-1.32 1.953c-.01.014-.073.11-.144.212-.233.34-1.078 1.589-1.086 1.604-.004.008-.295.439-.646.957a1178.503 1178.503 0 0 0-1.45 2.14c-.035.046-.361.534-.361.542 0 .003.967.006 2.15.006h2.15l.258-.376a410.65 410.65 0 0 1 .64-.93l.202-.295a407.565 407.565 0 0 1 .974-1.415c.023-.035.255-.373.648-.943l.422-.614a333.703 333.703 0 0 1 1.212-1.76 594.23 594.23 0 0 1 1.375-2c.082-.12.159-.232.17-.25l.203-.295.68-.985c.047-.07.086-.13.086-.135 0-.008-.242-.364-.633-.93a1284.2 1284.2 0 0 1-.82-1.19 124.43 124.43 0 0 0-.476-.694 85.838 85.838 0 0 1-.558-.812 138.71 138.71 0 0 0-.693-1.007c-.25-.362-.575-.834-.603-.878a165.26 165.26 0 0 0-.612-.89 429.51 429.51 0 0 1-1.02-1.483 76.955 76.955 0 0 1-.759-1.106L8.336.376 8.077 0h-2.15C4.746 0 3.779.004 3.779.008Zm13.867.02c-.008.014-.145.21-.304.434a142.12 142.12 0 0 0-.735 1.043l-.15.212a306.989 306.989 0 0 1-.752 1.066l-.196.278A253.217 253.217 0 0 0 14.494 4.5a180.792 180.792 0 0 0-.674.96c-.003.01.053.101.126.204.073.103.18.253.235.333l.817 1.166a164.714 164.714 0 0 1 .73 1.04l.177.252a.218.218 0 0 0 .054.062c.006 0 .028-.024.048-.055a36.832 36.832 0 0 1 .5-.712 61.753 61.753 0 0 1 .722-1.022 54.26 54.26 0 0 1 .38-.541l.144-.205a92.98 92.98 0 0 0 .526-.745l.191-.27.277-.394a140.952 140.952 0 0 0 .453-.643 132.814 132.814 0 0 0 .675-.957l.31-.438a55.224 55.224 0 0 0 .459-.654 499.35 499.35 0 0 0 .952-1.348l.217-.307c.057-.08.115-.164.127-.186l.023-.04h-2.152c-2.086 0-2.152 0-2.166.027Zm7.974 3.818c-.004.01-.006 2.155-.004 4.766l.004 4.748.741.004.74.004.001-1.691c0-2.082.01-2.34.106-2.736.095-.39.212-.626.415-.838.204-.213.444-.334.804-.408.213-.043.664-.047.834-.006.272.065.42.14.574.294.192.19.3.445.352.834.025.19.027.351.027 2.377v2.173h1.49v-2.29c0-1.921-.004-2.33-.023-2.539a2.875 2.875 0 0 0-.066-.437c0-.051-.114-.376-.176-.505-.272-.563-.765-.92-1.47-1.064a4.128 4.128 0 0 0-1.221-.046 3.067 3.067 0 0 0-.738.208c-.358.166-.676.44-.883.76-.027.043-.11.06-.095.02.009-.022.033-.299.055-.634.008-.122.015-.85.015-1.617V3.828h-.738c-.576 0-.739.004-.744.018ZM2.877 6.465l-.186.021a3.06 3.06 0 0 0-1.331.46c-.209.136-.41.322-.628.579C.389 7.93.137 8.559.03 9.277c-.04.264-.04 1.202-.001 1.439.139.845.43 1.438.944 1.921.492.463 1.127.737 1.904.82.231.026.963.026 1.236.001.338-.03.59-.076.953-.17a4.745 4.745 0 0 0 .69-.261c.013-.01.018-.147.018-.596 0-.67.016-.615-.158-.537a6.595 6.595 0 0 1-.925.304 5.78 5.78 0 0 1-1.062.127c-.753.027-1.313-.189-1.678-.647-.246-.31-.39-.73-.432-1.258l-.01-.12 2.3-.004 2.3-.004-.001-.54c-.002-.67-.028-.907-.143-1.322-.252-.907-.894-1.565-1.785-1.83a3.72 3.72 0 0 0-.543-.114 7.656 7.656 0 0 0-.76-.021Zm19.287 0-.209.022c-.562.053-1.063.218-1.477.485-.564.365-.984.98-1.179 1.728-.116.444-.144.697-.144 1.3 0 .706.041 1.004.21 1.541.06.186.08.235.175.424.442.875 1.199 1.373 2.266 1.492.35.04 1.113.022 1.43-.032.347-.059.724-.184.956-.318l.072-.041.004-.64a8.346 8.346 0 0 0-.008-.634c-.007.003-.09.042-.183.088-.54.261-1.07.384-1.653.382-.317-.001-.545-.043-.761-.14-.474-.213-.774-.634-.912-1.282-.12-.561-.094-1.434.058-1.936.04-.136.11-.314.153-.394.3-.558.775-.824 1.477-.825.381 0 .834.093 1.355.282a.78.78 0 0 0 .198.055.484.484 0 0 0 .042-.09 375.204 375.204 0 0 0 .401-1.064c0-.016-.279-.129-.456-.185a4.775 4.775 0 0 0-.9-.19 9.464 9.464 0 0 0-.915-.029Zm13.739-.001c-.012.003-.11.013-.216.022-.4.035-.994.158-1.303.27l-.142.051c-.153.055-.25.096-.487.205-.04.018-.071.04-.071.05 0 .01.024.066.053.126.03.06.103.219.163.353a9.16 9.16 0 0 0 .2.425c.033.07.062.128.064.128.003 0 .082-.034.176-.075a7.054 7.054 0 0 1 .379-.151c.309-.116.55-.186.815-.236.175-.034.237-.038.54-.04.332-.001.347 0 .492.04.34.093.535.245.666.52.095.198.118.327.127.71l.007.338-.14.009c-.076.005-.434.02-.794.032-.819.028-1.152.063-1.616.168-1.237.279-1.842.946-1.839 2.023.003.83.325 1.44.938 1.777.065.036.145.076.178.088.173.068.222.085.244.085a2.433 2.433 0 0 0 .371.075c.358.05.912.028 1.262-.049.563-.124.947-.365 1.381-.87a.89.89 0 0 1 .115-.12c.013 0 .04.072.087.226a38.005 38.005 0 0 0 .179.577l.043.14h1.069v-2.39c0-1.87-.004-2.425-.02-2.556-.11-.961-.54-1.506-1.408-1.788a2.315 2.315 0 0 0-.351-.09 4.407 4.407 0 0 0-.805-.073 6.35 6.35 0 0 0-.357 0Zm8.057 0c-.012.003-.09.013-.171.022-.352.04-.726.154-.998.305a2.029 2.029 0 0 0-.674.568c-.05.064-.093.106-.11.106-.029 0-.03 0-.086-.255a24.328 24.328 0 0 0-.144-.618c-.004-.014-.134-.018-.587-.018h-.58v6.793h1.488v-1.815c0-1.037.007-1.906.015-2.027.063-.905.341-1.446.87-1.694.247-.115.47-.162.82-.171.219-.006.276-.003.41.024.372.074.595.216.756.482.107.175.166.354.208.629.02.133.025.442.03 2.363l.006 2.21h1.474l-.005-2.473c-.005-2.45-.006-2.474-.037-2.612a5.6 5.6 0 0 1-.04-.19 2.294 2.294 0 0 0-.06-.204c-.266-.814-.85-1.266-1.803-1.397a6.804 6.804 0 0 0-.782-.028Zm6.546.001c-.017.003-.11.012-.209.021-.63.058-1.181.275-1.56.615a2.63 2.63 0 0 0-.326.379 2.185 2.185 0 0 0-.33 1.293c0 .323.003.381.032.504.106.45.27.75.574 1.046.175.17.276.245.454.334.06.03.106.056.104.059l-.126.085a3.579 3.579 0 0 0-.155.107c-.308.246-.418.378-.507.613-.027.07-.034.126-.04.305-.006.205-.004.227.031.332.093.277.295.52.539.646.04.022.06.037.043.037-.063 0-.437.137-.572.21l-.112.06c-.245.136-.504.4-.628.642a1.71 1.71 0 0 0-.169.725c0 .131.039.41.073.527.135.457.494.831 1.017 1.058.29.126.606.207 1.033.266.283.038 1.337.038 1.683 0 .672-.076 1.162-.204 1.605-.42.477-.234.833-.566 1.044-.974.167-.32.241-.753.204-1.178-.04-.464-.18-.782-.463-1.064-.288-.286-.624-.442-1.154-.537-.248-.044-.618-.06-1.434-.06-.963 0-1.161-.021-1.334-.146-.187-.135-.214-.348-.076-.612.032-.06.213-.24.307-.305.066-.044.074-.046.134-.033.103.024.683.035.928.018.226-.016.372-.039.603-.093.726-.17 1.29-.587 1.562-1.153.118-.246.17-.447.197-.77.042-.49-.06-.948-.294-1.314a.87.87 0 0 1-.05-.083c0-.003.022-.008.049-.012.026-.003.105-.017.175-.03l.253-.048.555-.102.13-.024v-.815h-1.21c-.998 0-1.231-.005-1.33-.022a5.738 5.738 0 0 0-1.25-.087Zm7.081.02c-.545.066-.987.225-1.377.493a3.004 3.004 0 0 0-1.073 1.437c-.086.205-.178.622-.226 1.015a6.332 6.332 0 0 0-.007 1.081c.011.073.025.182.033.243.027.234.11.553.215.824a3.665 3.665 0 0 0 .29.556 2.98 2.98 0 0 0 1.743 1.216c.37.097.648.127 1.192.127.662 0 1.031-.044 1.578-.187.157-.041.433-.141.63-.229l.07-.031v-.59c0-.493-.003-.592-.02-.592a.821.821 0 0 0-.137.052c-.2.09-.653.239-.892.294-.186.043-.485.09-.693.11a5.376 5.376 0 0 1-.901 0c-.84-.122-1.353-.615-1.54-1.479a2.31 2.31 0 0 1-.038-.262 4.69 4.69 0 0 0-.018-.194l-.009-.07H61l-.005-.639c-.005-.533-.01-.664-.032-.792-.091-.516-.236-.9-.472-1.245-.44-.647-1.094-1.026-1.958-1.137a4.995 4.995 0 0 0-.946-.001Zm-7.089.943c-.485.075-.791.354-.932.848-.04.14-.041.16-.042.49 0 .318.002.351.034.46.114.382.288.597.6.742.181.084.348.114.636.114.441 0 .684-.083.918-.315.18-.176.27-.376.313-.686.05-.36.013-.73-.101-1.017-.069-.173-.261-.412-.38-.472a2.966 2.966 0 0 1-.093-.049 1.499 1.499 0 0 0-.406-.12 2.35 2.35 0 0 0-.547.005Zm-47.614.161c-.538.069-.947.391-1.169.92a2.66 2.66 0 0 0-.162.64l-.01.099h3.099v-.092a2.449 2.449 0 0 0-.13-.697 1.243 1.243 0 0 0-.33-.512c-.21-.203-.458-.316-.784-.358a1.785 1.785 0 0 0-.514 0Zm54.897.001c-.617.083-1.042.472-1.243 1.139a3.708 3.708 0 0 0-.097.478v.04h3.097v-.12c0-.191-.063-.503-.142-.705a1.312 1.312 0 0 0-.63-.7 1.585 1.585 0 0 0-.471-.133 1.762 1.762 0 0 0-.514.001Zm-21.2 2.579c-.512.027-.741.052-.969.104-.61.14-.912.371-1.05.808-.028.088-.033.137-.033.343 0 .225.003.249.04.349.104.283.278.44.595.54.115.035.138.037.456.037.315 0 .344-.002.493-.039.344-.085.575-.205.785-.408a1.22 1.22 0 0 0 .27-.357c.151-.297.18-.452.18-.992v-.415l-.138.002c-.076 0-.36.014-.63.028Zm-20.632 1.07a2.824 2.824 0 0 1-.089.127 141.218 141.218 0 0 0-.632.875l-.114.158a102.68 102.68 0 0 1-.72.998l-.322.45c-.14.195-.256.359-.256.364a.56.56 0 0 0 .05.083 194.496 194.496 0 0 1 .434.651 346.233 346.233 0 0 1 .73 1.096 190.242 190.242 0 0 0 .774 1.161l.398.6.283.423a315.957 315.957 0 0 1 .7 1.052l.466.7c.014.021.22.023 2.164.02l2.15-.004-.495-.73-1.198-1.769-1.454-2.147-1.554-2.294-1.031-1.523a4.432 4.432 0 0 0-.242-.34c-.007 0-.026.022-.042.048Zm33.939 2.127c-.318.054-.558.17-.736.354-.166.172-.243.347-.271.62a.99.99 0 0 0 .068.396c.145.323.565.543 1.147.602a6.723 6.723 0 0 0 1.363-.048c.897-.161 1.391-.572 1.392-1.156 0-.296-.127-.52-.361-.631a2.09 2.09 0 0 0-.532-.137c-.096-.012-.427-.02-1.028-.022-.799-.004-.901-.001-1.042.022Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "#1B75BB" } }, "filePresent": { "viewBox": "0 0 24 24", "path": "M15 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V7l-5-5ZM6 20V4h8v4h4v12H6Zm10-10v5c0 2.21-1.79 4-4 4s-4-1.79-4-4V8.5a2.5 2.5 0 0 1 2.76-2.49c1.3.13 2.24 1.32 2.24 2.63V15h-2V8.5c0-.28-.22-.5-.5-.5s-.5.22-.5.5V15c0 1.1.9 2 2 2s2-.9 2-2v-5h2Z", "properties": { "fill": "currentColor" } }, "file": { "viewBox": "0 0 21 24", "path": "M20.845 6.495 13.525.142a.61.61 0 0 0-.4-.142H2.216C.993 0 0 .827 0 1.845v20.31C0 23.172.993 24 2.215 24h16.57C20.007 24 21 23.172 21 22.155V6.815a.425.425 0 0 0-.155-.32ZM2.215 1C1.367 1 1 1.543 1 1.845v20.31c0 .302.367.845 1.215.845h16.57c.848 0 1.215-.543 1.215-.845V7.085L12.988 1H2.215Z", "properties": { "stroke": "currentColor" } }, "fileDoc": { "viewBox": "0 0 6 10", "path": "M4.875 3.021c.173 0 .313.14.313.313v3.645a2.188 2.188 0 0 1-4.375 0V2.396a1.563 1.563 0 1 1 3.125 0v3.75a.938.938 0 0 1-1.876 0V3.333a.312.312 0 1 1 .626 0v2.813a.313.313 0 0 0 .624 0v-3.75a.937.937 0 1 0-1.874 0v4.583a1.562 1.562 0 1 0 3.125 0V3.333c0-.172.14-.312.312-.312Z", "properties": { "fill": "currentColor" } }, "filePdf": { "viewBox": "0 0 8 9", "path": "M3.547.149a.9.9 0 0 0-.23.03c-.214.053-.56.263-.46 1.065.043.354.172.805.365 1.291-.104.324-.219.663-.332.996-.107.314-.217.638-.315.944-.079.245-.15.477-.219.696-.095.307-.182.586-.267.838C.623 6.842.038 7.563.002 8.007a.457.457 0 0 0 .193.43.532.532 0 0 0 .305.085c.138 0 .315-.04.54-.152.79-.396 1.164-1.05 1.497-1.983.282-.154.6-.315.962-.482a7.713 7.713 0 0 1 1.463-.521c.471.495.97.82 1.438.82.509 0 .868-.168.985-.461.086-.216.02-.457-.177-.643-.279-.265-.775-.401-1.397-.383a4.537 4.537 0 0 0-.652.069c-.517-.62-1.019-1.482-1.356-2.275.346-1.115.472-1.844.157-2.186a.55.55 0 0 0-.413-.176Zm-.004.548h.014c.01.012.11.158-.07.913a3.324 3.324 0 0 1-.087-.433c-.04-.33.018-.458.05-.467a.383.383 0 0 1 .093-.013Zm.01 2.584a9.734 9.734 0 0 0 1.013 1.64 8.705 8.705 0 0 0-1.296.486c-.17.078-.331.156-.486.232l.096-.305c.067-.218.14-.448.217-.691.097-.302.206-.624.312-.935l.145-.427Zm2.3 1.984c.493-.008.761.102.844.143.117.058.161.115.173.138-.029.032-.157.11-.47.11-.233 0-.498-.142-.771-.38.08-.007.154-.01.225-.011Zm-4.1 1.593c-.232.472-.514.799-.958 1.021a.985.985 0 0 1-.22.084c.083-.184.39-.58 1.178-1.105Z", "properties": { "fill": "currentColor" } }, "filePhoto": { "viewBox": "0 0 8 6", "path": "M7 0H1C.667 0 .333.333.333.667v4.666C.333 5.7.633 6 1 6h6c.333 0 .667-.333.667-.667V.667C7.667.333 7.333 0 7 0ZM1.667 4.667l1.166-1.5.834 1.003 1.166-1.503 1.5 2H1.667Z", "properties": { "fill": "currentColor" } }, "filePlaceholder": { "viewBox": "0 0 32 40", "path": "M21.71.31a.968.968 0 0 0-.696-.31H5.41C2.531 0 .154 2.367.154 5.246v29.507C.154 37.633 2.531 40 5.41 40h21.18c2.88 0 5.256-2.367 5.256-5.247v-23.43a1.04 1.04 0 0 0-.28-.676L21.71.31Zm.28 3.1 6.6 6.928H24.3a2.301 2.301 0 0 1-2.31-2.3V3.412Zm4.599 34.658H5.41c-1.806 0-3.323-1.498-3.323-3.315V5.246c0-1.806 1.507-3.314 3.323-3.314h14.648V8.04a4.227 4.227 0 0 0 4.241 4.232h5.614v22.482c0 1.817-1.508 3.315-3.324 3.315Z", "properties": { "fill": "currentColor" } }, "fileVideo": { "viewBox": "0 0 9 7", "path": "M6.792 2.813V1.208A.46.46 0 0 0 6.333.75h-5.5a.46.46 0 0 0-.458.458v4.584a.46.46 0 0 0 .458.458h5.5a.46.46 0 0 0 .459-.458V4.188L8.625 6.02V.979L6.792 2.812Z", "properties": { "fill": "currentColor" } }, "fileCopy": { "viewBox": "0 0 24 24", "path": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1Zm-1 4 6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7Zm-1 7h5.5L14 6.5V12Z", "properties": { "fill": "currentColor" } }, "fillTrash": { "viewBox": "0 0 24 24", "path": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4Z", "properties": { "fill": "currentColor" } }, "filterList": { "viewBox": "0 0 24 24", "path": "M10 18h4v-2h-4v2ZM3 6v2h18V6H3Zm3 7h12v-2H6v2Z", "properties": { "fill": "currentColor" } }, "folder": { "viewBox": "0 0 16 16", "path": "M12.667 2H8.315a.68.68 0 0 1-.298-.066L5.913.878a2.01 2.01 0 0 0-.894-.211H3.333A3.337 3.337 0 0 0 0 4v8a3.337 3.337 0 0 0 3.333 3.334h9.334A3.337 3.337 0 0 0 16 12V5.334A3.337 3.337 0 0 0 12.667 2ZM3.333 2H5.02a.68.68 0 0 1 .298.067L7.42 3.12c.277.14.583.212.894.214h4.352a2 2 0 0 1 1.852 1.254l-13.186.075V4a2 2 0 0 1 2-2Zm9.334 12H3.333a2 2 0 0 1-2-2V5.996l13.334-.075v6.08a2 2 0 0 1-2 2Z", "properties": { "fill": "currentColor" } }, "folderPlaceholder": { "viewBox": "0 0 48 40", "path": "M41.81 7.284H26.85c-.608 0-1.2-.25-1.61-.673l-4.668-4.917C19.45.575 17.915-.01 16.36 0H6.19A5.83 5.83 0 0 0 .368 5.824v28.352A5.83 5.83 0 0 0 6.191 40h35.645c3.21-.014 5.812-2.64 5.797-5.842v-21.05a5.83 5.83 0 0 0-5.823-5.824Zm2.262 26.882a2.264 2.264 0 0 1-2.244 2.272H6.19a2.265 2.265 0 0 1-2.262-2.262V5.824A2.268 2.268 0 0 1 6.191 3.56h10.275c.594 0 1.171.237 1.56.622l4.642 4.894a5.851 5.851 0 0 0 4.182 1.77h14.96a2.265 2.265 0 0 1 2.261 2.262v21.058Z", "properties": { "fill": "currentColor" } }, "hide": { "viewBox": "0 0 16 12", "path": "m2.853 11.854 11-11a.5.5 0 1 0-.707-.707l-1.618 1.618A8.42 8.42 0 0 0 8 1C2.766 1 .17 5.563.063 5.757a.5.5 0 0 0 0 .486c.07.128 1.22 2.138 3.483 3.504l-1.4 1.4a.5.5 0 1 0 .708.707Zm13.084-6.097c-.061-.11-.934-1.639-2.639-2.934l-.727.728A10.005 10.005 0 0 1 14.91 6c-.59.903-2.915 4-6.91 4a7.347 7.347 0 0 1-1.68-.199l-.822.822A8.47 8.47 0 0 0 8 11c5.234 0 7.83-4.563 7.937-4.757a.5.5 0 0 0 0-.486Zm-5.95.378.908-.909c.066.247.105.506.105.774 0 1.654-1.346 3-3 3a2.99 2.99 0 0 1-.774-.105l.909-.909a1.991 1.991 0 0 0 1.851-1.851ZM4.291 9l1.266-1.265A2.98 2.98 0 0 1 5 6c0-1.654 1.346-3 3-3a2.98 2.98 0 0 1 1.736.557l1.023-1.023A7.362 7.362 0 0 0 8 2C4.006 2 1.68 5.097 1.088 6c.377.57 1.458 2.012 3.204 3Zm4.717-4.718L6.283 7.01A1.977 1.977 0 0 1 6 6c0-1.103.897-2 2-2 .37 0 .712.108 1.01.283Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "home": { "viewBox": "0 0 12 13", "path": "M12 12.333a.667.667 0 0 1-.667.667H.667A.667.667 0 0 1 0 12.333V5.327A.667.667 0 0 1 .257 4.8L5.591.652a.667.667 0 0 1 .818 0L11.743 4.8a.666.666 0 0 1 .257.527v7.006Zm-1.333-.666V5.652L6 2.022l-4.667 3.63v6.015h9.334Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "home1": { "viewBox": "0 0 16 16", "path": "M15.414 6.046 10.358.99a3.339 3.339 0 0 0-4.715 0L.586 6.046A1.985 1.985 0 0 0 0 7.46v6.545a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.46a1.986 1.986 0 0 0-.586-1.414ZM10 14.672H6v-2.623a2 2 0 1 1 4 0v2.623Zm4.667-.667a.667.667 0 0 1-.667.667h-2.666v-2.623a3.333 3.333 0 0 0-6.667 0v2.623H2a.667.667 0 0 1-.666-.667V7.46c0-.176.07-.346.195-.47l5.057-5.056a2.005 2.005 0 0 1 2.829 0l5.057 5.057a.672.672 0 0 1 .195.47v6.544Z", "properties": { "fill": "currentColor" } }, "home2": { "viewBox": "0 0 12 12", "path": "M3.667 11.333a1 1 0 0 0 1-1v-2a1 1 0 0 1 1-1h.667a1 1 0 0 1 1 1v2a1 1 0 0 0 1 1h1.333a1 1 0 0 0 1-1V6.555c0-.307.248-.555.555-.555a.555.555 0 0 0 .37-.967L6.67.603a1 1 0 0 0-1.338 0L.408 5.032A.555.555 0 0 0 .778 6c.307 0 .555.248.555.555v3.778a1 1 0 0 0 1 1h1.334Z", "properties": { "fill": "currentColor" } }, "house": { "viewBox": "0 0 24 24", "path": "M19 9.3V4h-3v2.6L12 3 2 12h3v8h5v-6h4v6h5v-8h3l-3-2.7Zm-9 .7c0-1.1.9-2 2-2s2 .9 2 2h-4Z", "properties": { "fill": "currentColor" } }, "infoCircle": { "viewBox": "0 0 16 16", "path": "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.669 6.669 0 0 0 8 14.667 6.669 6.669 0 0 0 14.667 8 6.669 6.669 0 0 0 8 1.333Zm.667 10H7.334v-4h1.333v4Zm0-5.333H7.334V4.667h1.333V6Z", "properties": { "fill": "currentColor" } }, "libraryAddCheck": { "viewBox": "0 0 24 24", "path": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2Zm-7.53 12L9 10.5l1.4-1.41 2.07 2.08L17.6 6 19 7.41 12.47 14ZM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6Z", "properties": { "fill": "currentColor" } }, "listAlt": { "viewBox": "0 0 24 24", "path": "M19 5v14H5V5h14Zm1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9ZM11 7h6v2h-6V7Zm0 4h6v2h-6v-2Zm0 4h6v2h-6v-2ZM7 7h2v2H7V7Zm0 4h2v2H7v-2Zm0 4h2v2H7v-2Z", "properties": { "fill": "currentColor" } }, "listStraight": { "viewBox": "0 0 24 24", "path": "M4.668 4.5a.75.75 0 0 0 0 1.5h14.666a.75.75 0 0 0 0-1.5H4.668Zm0 13.5a.75.75 0 0 0 0 1.5h14.666a.75.75 0 0 0 0-1.5H4.668Zm-.75-3.75a.75.75 0 0 1 .75-.75h14.666a.75.75 0 0 1 0 1.5H4.668a.75.75 0 0 1-.75-.75ZM4.668 9a.75.75 0 0 0 0 1.5h14.666a.75.75 0 0 0 0-1.5H4.668Z", "properties": { "fill": "currentColor" } }, "list": { "viewBox": "0 0 24 24", "path": "M3 13h2v-2H3v2Zm0 4h2v-2H3v2Zm0-8h2V7H3v2Zm4 4h14v-2H7v2Zm0 4h14v-2H7v2ZM7 7v2h14V7H7Z", "properties": { "fill": "currentColor" } }, "liveChat": { "viewBox": "0 0 24 24", "path": "M7.4 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3.5 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm2.5 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z M10 19c.596 0 1.177-.065 1.735-.189A5.74 5.74 0 0 0 16.25 21a5.73 5.73 0 0 0 2.538-.59l2.116.527a.85.85 0 0 0 1.027-1.045l-.548-2.048a5.752 5.752 0 0 0-3.481-8.103 8 8 0 1 0-14.844 5.237.097.097 0 0 1 .012.048v2.945a.97.97 0 0 0 1.424.857l1.551-.821a.098.098 0 0 1 .093 0A7.964 7.964 0 0 0 10 19Zm0-1.454a6.51 6.51 0 0 1-3.159-.811 1.552 1.552 0 0 0-1.476-.014l-.84.445v-2.14c0-.273-.072-.54-.206-.773A6.545 6.545 0 1 1 10 17.545Zm6.25 1.954a4.235 4.235 0 0 1-2.964-1.204 8.003 8.003 0 0 0 4.705-6.924 4.252 4.252 0 0 1 1.956 5.977.835.835 0 0 0-.081.628l.33 1.238-1.29-.32a.835.835 0 0 0-.605.079 4.227 4.227 0 0 1-2.051.526Z", "properties": { "fill": "currentColor" } }, "loading": { "viewBox": "0 0 24 24", "path": "M12 22C6.49 22 2 17.51 2 12c0-1.87.52-3.69 1.5-5.27a1.003 1.003 0 0 1 1.7 1.06A8.008 8.008 0 0 0 4 12c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8c-.55 0-1-.45-1-1s.45-1 1-1c5.51 0 10 4.49 10 10s-4.49 10-10 10Z", "properties": { "fill": "currentColor" } }, "localHotel": { "viewBox": "0 0 24 24", "path": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3Zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4Z", "properties": { "fill": "currentColor" } }, "lock": { "viewBox": "0 0 24 24", "path": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2Zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2Z", "properties": { "fill": "currentColor" } }, "lockOutline": { "viewBox": "0 0 24 24", "path": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2Zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2ZM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6ZM18 20H6V10h12v10Z", "properties": { "fill": "currentColor" } }, "logout": { "viewBox": "0 0 24 24", "path": "m17 7-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5-5-5ZM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5Z", "properties": { "fill": "currentColor" } }, "luxuryEstate": { "viewBox": "0 0 16 16", "path": "M2.743 9.371H1.37v4.114H.686a.686.686 0 0 0 0 1.372H4.57V9.37H2.743Zm12.571 4.114h-.685V9.371h-3.201v5.486h3.886a.686.686 0 1 0 0-1.372Zm.626-6.45-1.828-4.114a.686.686 0 0 0-.626-.407h-2.058v-.686a.686.686 0 1 0-1.37 0v.686H2.513a.686.686 0 0 0-.626.407L.059 7.035A.686.686 0 0 0 .686 8H4.57v-.686c0-.216.102-.42.275-.549l.183-.137 2.56-1.92a.686.686 0 0 1 .822 0l2.56 1.92.183.137c.173.13.275.333.275.549V8h3.886a.686.686 0 0 0 .627-.965Z m8.686 6.629.914.685.457.343v7.2H8.686V12.8a.686.686 0 1 0-1.372 0v2.057H5.943v-7.2l.457-.343.914-.685L8 6.114l.686.515Zm-.277 2.23.22-.225a.133.133 0 0 0-.075-.225l-.298-.046-.135-.286a.133.133 0 0 0-.242 0l-.134.286-.298.046a.133.133 0 0 0-.076.225l.22.225-.052.32a.133.133 0 0 0 .196.138L8 9.17l.265.147a.132.132 0 0 0 .166-.03.133.133 0 0 0 .03-.109l-.052-.32Z", "properties": { "fill": "currentColor" } }, "mapMarker": { "viewBox": "0 0 24 24", "path": "M11.999 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm8.66 3.157-.72-.239A7.999 7.999 0 0 0 12 0a7.993 7.993 0 0 0-7.914 9.092 5.045 5.045 0 0 0-2.548 1.3A4.946 4.946 0 0 0-.001 14v4.075a5.013 5.013 0 0 0 3.6 4.8l2.87.9a5.045 5.045 0 0 0 2.844.039l5.78-1.71a2.988 2.988 0 0 1 1.573 0l2.387.8a4 4 0 0 0 4.946-3.883v-5.149a5.014 5.014 0 0 0-3.34-4.716v.001ZM7.757 3.762a5.987 5.987 0 0 1 8.484 0 6.037 6.037 0 0 1 .01 8.5L12.7 15.717a.992.992 0 0 1-1.39 0l-3.552-3.44a6.04 6.04 0 0 1 0-8.515Zm14.242 15.259a1.99 1.99 0 0 1-.764 1.572 1.97 1.97 0 0 1-1.626.395l-2.345-.788a5.023 5.023 0 0 0-2.717-.016l-5.784 1.708a3 3 0 0 1-1.694-.029l-2.894-.9a3.013 3.013 0 0 1-2.176-2.888V14a2.964 2.964 0 0 1 .92-2.163 3.025 3.025 0 0 1 1.669-.806A8.02 8.02 0 0 0 6.353 13.7l3.567 3.453a2.983 2.983 0 0 0 4.174 0l3.563-3.463a7.961 7.961 0 0 0 1.813-2.821l.537.178a3.006 3.006 0 0 1 1.992 2.825v5.149Z", "properties": { "fill": "currentColor" } }, "mediaFolderPlaceholder": { "viewBox": "0 0 124 124", "path": "M110 26H56L44 14H14C7.4 14 2 19.4 2 26v24h120V38c0-6.6-5.4-12-12-12Z M110 26H14C7.4 26 2 31.4 2 38v60c0 6.6 5.4 12 12 12h96c6.6 0 12-5.4 12-12V38c0-6.6-5.4-12-12-12Z", "properties": { "fill": "currentColor" } }, "miamiRealtorsIcon": { "viewBox": "0 0 494 497", "path": "M223 13.4c0 2.1 1.6 3.1 21.7 13 15 7.4 19.6 10.2 22.1 13.2 3.7 4.5 6.4 12.8 8.7 26.4.9 5.2 3.4 20.3 5.6 33.5 5.4 32.6 6.7 40.4 8.5 51.5 2.5 16.3 5 20.3 6.7 10.9 3.4-18.9 5.7-30.8 9-46.1.9-3.7 2.3-8.5 3.4-10.5 3.2-6.7 1.9-7.2 45.3 17.4 6.7 3.8 23.4 13 30.4 16.8 3.3 1.9 7 4.5 8 5.9 2.7 3.6 3.1 11.7 1.1 21.2-3.8 17.5-6.5 33.4-8.5 50.4-.6 4.7-1.5 12.1-2 16.5-1.5 11.9-4 58.8-4 74.4 0 42.5 9.2 131.3 13.7 132.8 1.6.6 13.8-10 25.7-22.1 13.4-13.7 24.7-28.4 34.8-45.1 3.9-6.5 14.8-27.8 14.8-29 0-.4.6-2.1 1.4-3.8 6.6-15.5 10.9-31.2 14.8-54.7 2.9-17.8 2.9-51.2 0-69-3.2-19.2-7.8-37.7-12-48-.6-1.4-2-5-3.2-8-3.9-9.7-13.9-29-19.7-37.9-13.8-21.3-34-43.9-51.3-57.6-33.2-26.4-73.1-44.3-112.5-50.5-3.8-.6-7.1-1.5-7.3-2.1-.2-.5-11.4-.9-27.8-.9-22.6 0-27.4.2-27.4 1.4zm-53 11.3c-38.7 14.8-62.2 29.4-88.8 54.8-18.8 17.9-36.5 41.8-47.6 64.4-3.4 7-6.7 13.9-7.3 15.6-.7 1.6-2.1 5.5-3.3 8.5-4.3 11.2-6.1 17.4-10 34.5-2.9 12.6-4 24.7-4 44.7 0 12.8.4 20.8 1 20.8.5 0 8.5-7.3 17.6-16.3 58.6-57.1 106.9-128.3 151.3-222.9 3.5-7.5 1.9-8.3-8.9-4.1z M208.4 122.1c-2 3.1-3.4 5.5-3.9 6.9-1.5 3.7-14.4 29.2-17.9 35.5C154.3 221.9 120 266.4 81 301.4c-15.5 14-29.3 24.9-43.3 34.4-5.9 4-10.7 8-10.7 8.7 0 3.2 15.5 31.7 23.3 42.7 39.2 55.7 94.3 90.2 162.2 101.4 15.5 2.6 54.3 2.6 70 0 20.7-3.4 42.3-9.7 61-17.8 12.1-5.3 25.5-12.7 26.2-14.4.3-.8-.8-5.8-2.5-11.2-1.6-5.3-3.7-12.6-4.7-16.2-1-3.6-2.3-8.5-3-11-7.1-25.4-16.9-70-20.5-93.5-.6-3.9-1.7-11.1-2.5-16-.8-5-2.2-15.1-3-22.5-.9-7.4-2-13.9-2.5-14.4-1.5-1.6-3.9.9-11.3 12.1-13.7 20.5-22.6 42.2-25.2 61.1-.4 2.8-1.5 6.2-2.5 7.4-1.7 2.1-2.1 2.2-7.4 1.1-7.3-1.5-27.6-11.6-50.3-25-10.4-6.2-10-5.4-12.7-21.8-4.8-28.9-9.4-69.5-11.8-105-1.7-24.6-1.6-62.1.1-70.7.8-4.4 1-7.2.3-8.3-.8-1.5-1.1-1.5-1.8-.4z" }, "mobile": { "viewBox": "0 0 24 24", "path": "M13.5 18.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z M16.5 1A2.5 2.5 0 0 1 19 3.5v17a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 20.5v-17A2.5 2.5 0 0 1 7.5 1h9ZM9 2.5H7.5a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1H15V3a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-.5Z", "properties": { "fill": "currentColor" } }, "money": { "viewBox": "0 0 24 24", "path": "M2 4v16h20V4H2Zm2 14V6h16v12H4ZM5 8h2v8H5V8Zm7 0H9c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1Zm-1 6h-1v-4h1v4Zm7-6h-3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1Zm-1 6h-1v-4h1v4Z", "properties": { "fill": "currentColor" } }, "note": { "viewBox": "0 0 17 16", "path": "M6.753 4.501c-.274 0-.5.225-.5.499s.225.5.5.5h3.5c.274 0 .5-.226.5-.5a.502.502 0 0 0-.5-.499h-3.5Zm0 2.999c-.275 0-.5.226-.5.5v.001c0 .274.225.5.5.5h3.5c.274 0 .5-.226.5-.5V8c0-.274-.226-.5-.5-.5h-3.5Zm0 3.001c-.275 0-.5.226-.5.5a.503.503 0 0 0 .5.499h3.5c.273 0 .5-.225.5-.498V11c0-.274-.226-.5-.5-.5h-3.5ZM4.002 1a1.5 1.5 0 0 0-1.5 1.501V13.5a1.504 1.504 0 0 0 1.5 1.502h9.001a1.5 1.5 0 0 0 1.5-1.502V2.501A1.501 1.501 0 0 0 13.003 1h-9Zm0 1h9.001a.499.499 0 0 1 .5.501V13.5a.499.499 0 0 1-.5.5h-9a.499.499 0 0 1-.499-.5V2.501a.5.5 0 0 1 .498-.5Z", "properties": { "fill": "currentColor" } }, "notification": { "viewBox": "0 0 24 24", "path": "M12 22c1.1 0 2-.9 2-2h-4a2 2 0 0 0 2 2Zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2Z", "properties": { "fill": "currentColor" } }, "pauseCircleOutline": { "viewBox": "0 0 24 24", "path": "M9 16h2V8H9v8Zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Zm1-4h2V8h-2v8Z", "properties": { "fill": "currentColor" } }, "penthouse": { "viewBox": "0 0 16 16", "path": "m12.48 4.868.151-.22a.83.83 0 0 0-.151-1.108L8.537.22a.833.833 0 0 0-1.074 0L3.52 3.54a.831.831 0 0 0-.151 1.108l.151.22a.839.839 0 0 0 1.225.167l3.148-2.651a.167.167 0 0 1 .214 0l3.148 2.65a.839.839 0 0 0 1.225-.166Zm2.687 2.798H.833A.833.833 0 0 0 0 8.499v1c0 .46.373.834.833.834h14.334c.46 0 .833-.373.833-.834v-1a.833.833 0 0 0-.833-.833Zm-.5 7.5v-4.333a.167.167 0 0 0-.167-.167h-13a.167.167 0 0 0-.167.167v4.333a.833.833 0 0 0 .834.833h1.666v-.833a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v.833h3.666v-.833a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v.833h1.666a.833.833 0 0 0 .834-.833Zm-8.5-2.333a.667.667 0 0 1-.667.666h-1a.667.667 0 0 1-.667-.666v-1a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v1Zm6 0a.666.666 0 0 1-.667.666h-1a.667.667 0 0 1-.667-.666v-1a.667.667 0 0 1 .667-.667h1a.667.667 0 0 1 .667.667v1Z M11.167 7.333a.167.167 0 0 0 .166-.167V5.572a.166.166 0 0 0-.088-.147 1.123 1.123 0 0 1-.204-.134l-2.934-2.47a.167.167 0 0 0-.214 0l-2.934 2.47a1.13 1.13 0 0 1-.204.134.167.167 0 0 0-.088.147v1.594a.167.167 0 0 0 .166.167h2.334v-1a.833.833 0 1 1 1.666 0v1h2.334Z", "properties": { "fill": "currentColor" } }, "personOutline": { "viewBox": "0 0 24 24", "path": "M12 5.9a2.1 2.1 0 1 1 0 4.2 2.1 2.1 0 0 1 0-4.2Zm0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1ZM12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4Zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4Z", "properties": { "fill": "currentColor" } }, "photoLibrary": { "viewBox": "0 0 24 24", "path": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2Zm-11-4 2.03 2.71L16 11l4 5H8l3-4ZM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2Z", "properties": { "fill": "currentColor" } }, "pin": { "viewBox": "0 0 24 24", "path": "M12 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0 12a5.27 5.27 0 0 1-4.311-2.2c-3.811-5.257-5.744-9.209-5.744-11.747a10.055 10.055 0 1 1 20.11 0c0 2.538-1.933 6.49-5.744 11.747A5.27 5.27 0 0 1 12 24Zm0-21.819a7.883 7.883 0 0 0-7.874 7.874c0 2.01 1.893 5.727 5.329 10.466a3.145 3.145 0 0 0 5.09 0c3.436-4.739 5.329-8.456 5.329-10.466A7.883 7.883 0 0 0 12 2.181Z", "properties": { "fill": "currentColor" } }, "playCircleOutline": { "viewBox": "0 0 24 24", "path": "m10 16.5 6-4.5-6-4.5v9ZM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8Z", "properties": { "fill": "currentColor" } }, "plus": { "viewBox": "0 0 24 24", "path": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2Z", "properties": { "fill": "currentColor" } }, "presentation": { "viewBox": "0 0 126 126", "path": "M110.25 6.563h-94.5a9.187 9.187 0 0 0-9.188 9.187v63a9.187 9.187 0 0 0 9.188 9.188h29.4l-16.905 25.41a3.935 3.935 0 0 0 1.05 5.25 4.26 4.26 0 0 0 2.205.629 3.826 3.826 0 0 0 3.255-1.732L54.6 87.728h4.462V115.5a3.936 3.936 0 1 0 7.876 0V87.937H71.4l19.845 29.768a3.833 3.833 0 0 0 3.255 1.733 4.261 4.261 0 0 0 2.205-.631 3.935 3.935 0 0 0 1.05-5.25L80.85 87.937h29.4a9.188 9.188 0 0 0 9.188-9.187v-63a9.187 9.187 0 0 0-9.188-9.188ZM42 68.25a5.25 5.25 0 1 1-10.5 0V52.5a5.25 5.25 0 1 1 10.5 0v15.75Zm26.25 0a5.25 5.25 0 1 1-10.5 0v-42a5.25 5.25 0 1 1 10.5 0v42Zm26.25 0a5.25 5.25 0 1 1-10.5 0V42a5.25 5.25 0 1 1 10.5 0v26.25Z", "properties": { "fill": "currentColor" } }, "priorityHigh": { "viewBox": "0 0 24 24", "path": "M12 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM10 3h4v12h-4V3Z", "properties": { "fill": "currentColor" } }, "reactionNeutral": { "viewBox": "0 0 24 24", "path": "M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0ZM5 9.07a2 2 0 1 1 3.999-.001A2 2 0 0 1 5 9.07Zm10.25 9.18h-6.5a1 1 0 0 1 0-2h6.5a1 1 0 0 1 0 2ZM17 11.07a2 2 0 1 1-.001-4.001A2 2 0 0 1 17 11.07Z", "properties": { "fill": "currentColor" } }, "reactionSad": { "viewBox": "0 0 24 24", "path": "M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0ZM4.656 9.547a.703.703 0 1 1 1.33-.454 1.664 1.664 0 0 0 3.15 0 .703.703 0 1 1 1.33.456 3.07 3.07 0 0 1-5.81-.002Zm11.932 7.627a.703.703 0 0 1-.964-.244A4.238 4.238 0 0 0 12 14.87a4.24 4.24 0 0 0-3.619 2.051.703.703 0 1 1-1.206-.722A5.653 5.653 0 0 1 12 13.465a5.65 5.65 0 0 1 4.832 2.745.703.703 0 0 1-.244.964Zm2.76-7.625a3.07 3.07 0 0 1-5.81-.002.703.703 0 1 1 1.33-.454 1.664 1.664 0 0 0 3.15 0 .703.703 0 0 1 1.33.456Z", "properties": { "fill": "currentColor" } }, "reactionSmile": { "viewBox": "0 0 24 24", "path": "M20.485 3.515A11.922 11.922 0 0 0 12 0a11.922 11.922 0 0 0-8.485 3.515A11.922 11.922 0 0 0 0 12c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 12 24c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 24 12c0-3.205-1.248-6.219-3.515-8.485ZM4.52 9.74a2.966 2.966 0 0 1 2.96-2.962 2.966 2.966 0 0 1 2.963 2.963.703.703 0 1 1-1.407 0c0-.859-.698-1.557-1.556-1.557-.858 0-1.556.699-1.556 1.557a.703.703 0 0 1-1.406 0Zm14.536 4.753A7.494 7.494 0 0 1 12 19.48c-3.165 0-6-2.004-7.055-4.987a.703.703 0 1 1 1.326-.469A6.085 6.085 0 0 0 12 18.075a6.085 6.085 0 0 0 5.729-4.05.703.703 0 0 1 1.326.469Zm-.277-4.05a.703.703 0 0 1-.703-.703c0-.859-.698-1.557-1.556-1.557-.858 0-1.556.699-1.556 1.557a.703.703 0 1 1-1.407 0 2.966 2.966 0 0 1 2.963-2.963 2.966 2.966 0 0 1 2.962 2.963.703.703 0 0 1-.703.703Z", "properties": { "fill": "currentColor" } }, "removeCircle": { "viewBox": "0 0 18 18", "path": "M5.25 8.25v1.5h7.5v-1.5h-7.5ZM9 1.5C4.86 1.5 1.5 4.86 1.5 9c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5 0-4.14-3.36-7.5-7.5-7.5ZM9 15c-3.308 0-6-2.693-6-6 0-3.308 2.692-6 6-6 3.307 0 6 2.692 6 6 0 3.307-2.693 6-6 6Z", "properties": { "fill": "currentColor" } }, "screenShare": { "viewBox": "0 0 24 24", "path": "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2H0v2h24v-2h-4Zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74Z", "properties": { "fill": "currentColor" } }, "search": { "viewBox": "0 0 24 24", "path": "M16.125 10.875a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0Zm-1.157 4.888a6.375 6.375 0 1 1 .795-.796l3.572 3.573a.562.562 0 1 1-.795.795l-3.572-3.572Z", "properties": { "fill": "currentColor" } }, "send": { "viewBox": "0 0 15 14", "path": "M12.333.667H1.666C.933.667.333 1.267.333 2v8c0 .733.6 1.333 1.333 1.333h6V10h-6V3.333L7 6.667l5.333-3.334v3.334h1.333V2c0-.733-.6-1.333-1.333-1.333ZM7 5.333 1.666 2h10.667L7 5.333ZM11.666 8l2.667 2.667-2.667 2.666v-2H9V10h2.666V8Z", "properties": { "fill": "currentColor" } }, "setting2": { "viewBox": "0 0 16 16", "path": "M15.333 12.667h-1.775A2.329 2.329 0 0 0 11.333 11a2.33 2.33 0 0 0-2.224 1.667H.667a.667.667 0 0 0 0 1.333h8.442a2.329 2.329 0 0 0 2.224 1.667A2.33 2.33 0 0 0 13.558 14h1.775a.667.667 0 1 0 0-1.333Zm-4 1.666a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Zm4-7H6.891a2.33 2.33 0 0 0-2.224-1.666 2.33 2.33 0 0 0-2.225 1.666H.667a.667.667 0 0 0 0 1.334h1.775a2.33 2.33 0 0 0 2.225 1.666A2.33 2.33 0 0 0 6.89 8.667h8.442a.666.666 0 1 0 0-1.334ZM4.667 9a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Zm10.666-7h-1.775A2.33 2.33 0 0 0 11.333.333 2.33 2.33 0 0 0 9.11 2H.667a.667.667 0 0 0 0 1.333h8.442A2.33 2.33 0 0 0 11.333 5a2.33 2.33 0 0 0 2.225-1.667h1.775a.666.666 0 1 0 0-1.333Zm-4 1.667a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2Z", "properties": { "fill": "currentColor" } }, "settings": { "viewBox": "0 0 24 24", "path": "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58a.49.49 0 0 0 .12-.61l-1.92-3.32a.488.488 0 0 0-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54a.484.484 0 0 0-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94 0 .31.02.64.07.94l-2.03 1.58a.49.49 0 0 0-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58ZM12 15.6A3.61 3.61 0 0 1 8.4 12c0-1.98 1.62-3.6 3.6-3.6s3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6Z", "properties": { "fill": "currentColor" } }, "share": { "viewBox": "0 0 24 24", "path": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92Z", "properties": { "fill": "currentColor" } }, "show": { "viewBox": "0 0 16 10", "path": "M.063 5.243C.171 5.437 2.766 10 8 10s7.83-4.563 7.937-4.757a.5.5 0 0 0 0-.486C15.829 4.563 13.234 0 8 0S.17 4.563.063 4.757a.5.5 0 0 0 0 .486ZM8 9C4.018 9 1.683 5.9 1.088 5 1.681 4.096 4.006 1 8 1c3.982 0 6.317 3.1 6.912 4-.593.903-2.918 4-6.912 4Zm0-1C6.346 8 5 6.654 5 5s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3ZM6 5c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2Z", "properties": { "fillRule": "evenodd", "clipRule": "evenodd", "fill": "currentColor" } }, "singleFamily": { "viewBox": "0 0 16 16", "path": "m15.731 7.284-2.424-2.425V2.058a.917.917 0 0 0-1.835 0v.967L9.667 1.219c-.893-.892-2.445-.89-3.335.002L.268 7.284A.918.918 0 0 0 1.566 8.58l6.062-6.063a.541.541 0 0 1 .742-.001l6.064 6.064a.915.915 0 0 0 1.298 0 .917.917 0 0 0 0-1.297Z M8.318 4.258a.45.45 0 0 0-.637 0L2.348 9.59a.451.451 0 0 0-.132.319v3.888c0 .913.74 1.652 1.653 1.652h2.64V11.36H9.49v4.09h2.64c.913 0 1.653-.74 1.653-1.653V9.91a.45.45 0 0 0-.132-.32L8.318 4.259Z", "properties": { "fill": "currentColor" } }, "suitcase": { "viewBox": "0 0 18 18", "path": "M12.938 4.688v10.875a.563.563 0 0 0 1.124 0V4.687a.563.563 0 0 0-1.124 0Zm-9 0v10.875a.563.563 0 0 0 1.124 0V4.687a.563.563 0 0 0-1.125 0ZM12 5.25c.31 0 .563-.252.563-.563v-.75c0-.538-.195-1.053-.533-1.433a1.82 1.82 0 0 0-1.364-.629H7.333a1.82 1.82 0 0 0-1.363.628c-.338.38-.532.896-.532 1.434v.75c0 .311.252.563.562.563h6Zm-.563-1.125H6.564v-.188c0-.257.087-.505.248-.686A.704.704 0 0 1 7.333 3h3.333c.198 0 .384.094.523.25.162.182.248.43.248.688v.187Zm5.626 2.063A2.066 2.066 0 0 0 15 4.124H3c-.547 0-1.072.218-1.459.604a2.066 2.066 0 0 0-.603 1.458v7.875c0 .547.217 1.072.603 1.46.387.386.912.603 1.459.603h12a2.066 2.066 0 0 0 2.063-2.063V6.189Zm-1.125 0v7.875A.939.939 0 0 1 15 15H3a.94.94 0 0 1-.938-.938V6.189A.94.94 0 0 1 3 5.25h12a.939.939 0 0 1 .938.938Z", "properties": { "fill": "currentColor" } }, "swapVert": { "viewBox": "0 0 24 24", "path": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3ZM9 3 5 6.99h3V14h2V6.99h3L9 3Z", "properties": { "fill": "currentColor" } }, "timelapse": { "viewBox": "0 0 16 16", "path": "M10.827 5.174A3.983 3.983 0 0 0 8 4.001v4l-2.827 2.826a4.008 4.008 0 0 0 5.66 0 3.993 3.993 0 0 0-.006-5.653ZM8 1.334a6.67 6.67 0 0 0-6.667 6.667A6.669 6.669 0 0 0 8 14.667a6.669 6.669 0 0 0 6.667-6.666A6.67 6.67 0 0 0 8 1.334Zm0 12a5.332 5.332 0 0 1-5.333-5.333A5.332 5.332 0 0 1 8 2.667a5.332 5.332 0 0 1 5.334 5.334A5.332 5.332 0 0 1 8 13.334Z", "properties": { "fill": "currentColor" } }, "townhouses": { "viewBox": "0 0 16 16", "path": "M7.059 2.353a.47.47 0 0 0-.47-.47H3.293a.47.47 0 0 0-.47.47v2.823H.94V.941c0-.52.422-.941.941-.941H8a.94.94 0 0 1 .941.941v4.235H7.06V2.353ZM10.118 16v-2.823a.47.47 0 0 0-.47-.471H6.352a.47.47 0 0 0-.47.47V16H.47a.47.47 0 0 1-.47-.47V8.94h16v6.588a.47.47 0 0 1-.47.471h-5.412Zm-6.589-4.706v-.941a.47.47 0 0 0-.94 0v.941a.47.47 0 1 0 .94 0Zm3.295 0v-.941a.47.47 0 0 0-.942 0v.941a.47.47 0 1 0 .942 0Zm3.294 0v-.941a.47.47 0 1 0-.942 0v.941a.47.47 0 1 0 .942 0Zm3.294 0v-.941a.47.47 0 0 0-.941 0v.941a.47.47 0 0 0 .94 0Zm0 2.824v-.941a.47.47 0 0 0-.941 0v.94a.47.47 0 0 0 .94 0Zm-9.883 0v-.941a.47.47 0 1 0-.94 0v.94a.47.47 0 1 0 .94 0ZM.18 8l.812-1.622a.47.47 0 0 1 .42-.26h13.177c.179 0 .341.1.421.26L15.82 8H.18Zm3.586-5.176h2.353v2.352H3.765V2.824ZM6.824 16v-2.353h2.352V16H6.824Z", "properties": { "fill": "currentColor" } }, "trash": { "viewBox": "0 0 24 24", "path": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12ZM8 9h8v10H8V9Zm7.5-5-1-1h-5l-1 1H5v2h14V4h-3.5Z", "properties": { "fill": "currentColor" } }, "trashSolid": { "viewBox": "0 0 24 24", "path": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12Zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12ZM15.5 4l-1-1h-5l-1 1H5v2h14V4h-3.5Z", "properties": { "fill": "currentColor" } }, "twinHomes": { "viewBox": "0 0 16 16", "path": "M2.375 11.781h.938v1.875h-.938v-1.875ZM.031 14.594v.937c0 .26.21.469.469.469h7.031v-1.406h-7.5Zm5.157-4.219c0-.611-.392-1.133-.938-1.326v1.795h.938v-.47ZM3.781 4.906a.469.469 0 1 0 0-.937.469.469 0 0 0 0 .937Zm.469 6.875h.938v1.875H4.25v-1.875Zm-1.875-1.406v.469h.938V9.049a1.409 1.409 0 0 0-.938 1.326Z M4.137.163a.469.469 0 0 0-.711 0L.145 3.975a.469.469 0 0 0-.114.306v9.375h1.407v-3.281A2.346 2.346 0 0 1 3.78 8.031a2.346 2.346 0 0 1 2.344 2.344v3.281H7.53V4.107L4.137.163Zm-.356 5.68a1.407 1.407 0 0 1 0-2.812 1.407 1.407 0 0 1 0 2.813Zm8.907 5.938h.937v1.875h-.938v-1.875Zm3.281 2.813v.937c0 .26-.21.469-.469.469H8.469v-1.406h7.5Zm-5.156-4.219c0-.611.391-1.133.937-1.326v1.795h-.938v-.47Zm1.406-5.469a.469.469 0 1 0 0-.937.469.469 0 0 0 0 .937Zm-1.406 6.875h.937v1.875h-.938v-1.875Zm2.812-1.406v.469h-.938V9.049c.546.193.938.715.938 1.326Z M8.469 4.107v9.55h1.406v-3.282a2.346 2.346 0 0 1 2.344-2.344 2.346 2.346 0 0 1 2.344 2.344v3.281h1.406V4.281c0-.112-.04-.22-.114-.306L12.574.163a.469.469 0 0 0-.71 0L8.469 4.107Zm2.344.33c0-.775.63-1.406 1.406-1.406a1.408 1.408 0 0 1 0 2.813 1.408 1.408 0 0 1-1.406-1.407Z", "properties": { "fill": "currentColor" } }, "unarchive": { "viewBox": "0 0 12 12", "path": "M11.7 1.48 10.773.36C10.587.14 10.313 0 10 0H2a.968.968 0 0 0-.767.367L.307 1.48A1.323 1.323 0 0 0 0 2.333v8.334C0 11.4.593 12 1.333 12h9.334C11.4 12 12 11.4 12 10.667V2.333c0-.326-.113-.62-.3-.853ZM6 4.333 9.667 8H7.333v1.333H4.667V8H2.333L6 4.333Zm-4.587-3L1.96.667h8l.62.666H1.413Z", "properties": { "fill": "currentColor" } }, "upload": { "viewBox": "0 0 25 32", "path": "M12.668 10.645a.777.777 0 0 0-.564.246l-4.53 4.861a.77.77 0 0 0 .04 1.09.789.789 0 0 0 1.105-.037l3.184-3.426v8.441c0 .425.348.774.773.774a.776.776 0 0 0 .774-.774v-8.44l3.183 3.426a.768.768 0 0 0 1.09.037.77.77 0 0 0 .04-1.09l-4.53-4.861a.778.778 0 0 0-.565-.246zM6.315 25.12a.776.776 0 0 0-.773.774c0 .425.348.773.773.773h12.73a.776.776 0 0 0 .774-.773.778.778 0 0 0-.781-.774zM17.245.247A.774.774 0 0 0 16.687 0H4.205C1.9 0 0 1.894 0 4.197v23.606C0 30.106 1.901 32 4.205 32h16.943c2.303 0 4.205-1.894 4.205-4.197V9.059a.83.83 0 0 0-.225-.541zm.224 2.482 5.279 5.542h-3.432a1.84 1.84 0 0 1-1.847-1.84zm3.679 27.725H4.205c-1.445 0-2.66-1.198-2.66-2.651V4.197c0-1.445 1.207-2.651 2.66-2.651h11.718V6.43a3.381 3.381 0 0 0 3.393 3.385h4.49v17.987c0 1.453-1.205 2.651-2.658 2.651z", "properties": { "fill": "currentColor" } }, "verified": { "viewBox": "0 0 24 24", "path": "m23 12-2.44-2.79.34-3.69-3.61-.82-1.89-3.2L12 2.96 8.6 1.5 6.71 4.69 3.1 5.5l.34 3.7L1 12l2.44 2.79-.34 3.7 3.61.82L8.6 22.5l3.4-1.47 3.4 1.46 1.89-3.19 3.61-.82-.34-3.69L23 12Zm-12.91 4.72-3.8-3.81 1.48-1.48 2.32 2.33 5.85-5.87 1.48 1.48-7.33 7.35Z", "properties": { "fill": "currentColor" } }, "viewCarousel": { "viewBox": "0 0 24 24", "path": "M7 19h10V4H7v15Zm-5-2h4V6H2v11ZM18 6v11h4V6h-4Z", "properties": { "fill": "currentColor" } }, "villa": { "viewBox": "0 0 16 16", "path": "M10.375 6.593h2.813V3.88l-2.813.703v2.009Z M15.4.018 5.962 2.831a.466.466 0 0 0-.318.58.466.466 0 0 0 .581.32L7.5 3.348v2.308H.469c-.26 0-.469.21-.469.468v2.813c0 .259.21.469.469.469H16V.468a.45.45 0 0 0-.188-.375.467.467 0 0 0-.412-.075ZM1.875 8.468H.937V6.593h.938v1.875Zm1.875 0h-.938V6.593h.938v1.875Zm1.875 0h-.938V6.593h.938v1.875Zm1.875 0h-.938V6.593H7.5v1.875Zm6.625-1.406c0 .259-.21.469-.469.469h-3.75a.468.468 0 0 1-.469-.47V4.219c0-.215.147-.402.356-.454l3.75-.938a.468.468 0 0 1 .582.455v3.78Zm-2.812 3.281h.937v5.656h-.938v-5.656Zm1.875 0h.937v5.656h-.938v-5.656ZM1.875 15.062H.469A.464.464 0 0 0 0 15.53c0 .263.206.469.469.469H3.75v-4.25c0-.26.21-.469.469-.469h3.75c.259 0 .468.21.468.469v4.25h1.938v-5.656h-8.5v4.719Zm13.188.937h.468A.464.464 0 0 0 16 15.53v-5.187h-.938v5.656Z M7.031 13.155H7.5v-.937H4.687v3.781H7.5v-1.906h-.469a.469.469 0 1 1 0-.938Z", "properties": { "fill": "currentColor" } }, "visibilityOff": { "viewBox": "0 0 24 24", "path": "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7ZM2 4.27l2.28 2.28.46.46A11.804 11.804 0 0 0 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27ZM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2Zm4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01Z", "properties": { "fill": "currentColor" } }, "visibility": { "viewBox": "0 0 24 24", "path": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5ZM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5Zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3Z", "properties": { "fill": "currentColor" } }, "warningFilled": { "viewBox": "0 0 24 24", "path": "m2.095 19.886 9.248-16.5a.753.753 0 0 1 1.313 0l9.248 16.5a.75.75 0 0 1-.656 1.116H2.752a.75.75 0 0 1-.657-1.116zm9.907-6.881a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75zm-.002-3a1 1 0 1 0 0 2 1 1 0 0 0 0-2z", "properties": { "fillRule": "nonzero" } }, "warningOutlined": { "viewBox": "0 0 24 24", "path": "m2.095 19.886 9.248-16.5a.753.753 0 0 1 1.313 0l9.248 16.5a.75.75 0 0 1-.656 1.116H2.752a.75.75 0 0 1-.657-1.116zm1.935-.384h15.939l-7.97-14.219zm7.972-6.497a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75zm-.002-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2z", "properties": { "fillRule": "nonzero" } }, "world": { "viewBox": "0 0 24 24", "path": "M3.533 11.25a8.507 8.507 0 0 1 5.68-7.283 8.903 8.903 0 0 0-.6 1.207c-.664 1.613-1.085 3.741-1.16 6.076h-3.92ZM12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm0 1.5c.261 0 .58.125.945.5.367.377.732.962 1.055 1.745.578 1.404.972 3.33 1.046 5.505H8.954c.074-2.175.468-4.101 1.046-5.505.323-.783.688-1.368 1.055-1.745.364-.375.684-.5.945-.5Zm4.547 7.75c-.075-2.335-.496-4.463-1.16-6.076a8.897 8.897 0 0 0-.6-1.207 8.507 8.507 0 0 1 5.68 7.283h-3.92Zm-1.501 1.5c-.074 2.175-.468 4.102-1.046 5.505-.323.784-.688 1.368-1.055 1.745-.364.375-.684.5-.945.5-.261 0-.58-.125-.945-.5-.367-.377-.732-.962-1.055-1.745-.578-1.403-.972-3.33-1.046-5.505h6.092Zm-.26 7.283c.222-.367.422-.773.6-1.207.665-1.613 1.086-3.741 1.16-6.076h3.921a8.507 8.507 0 0 1-5.68 7.283Zm-5.573 0a8.507 8.507 0 0 1-5.68-7.283h3.92c.075 2.335.496 4.463 1.16 6.076.179.434.379.84.6 1.207Z", "properties": { "fill": "currentColor" } } };
var Icon_generated_default = icons;

// src/components/atoms/Icon/Icon.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var SvgStyles = import_styled_components4.default.svg`
  ${boxStyle}
`;
function Icon({ name, size = 16, color: color2, onClick, fill: fill2 = "currentcolor", ...args }) {
  const icon = Icon_generated_default[name];
  return icon ? /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    SvgStyles,
    {
      ...args,
      color: color2,
      viewBox: icon.viewBox,
      w: size,
      h: size,
      fill: fill2,
      onClick: (e) => {
        if (onClick) {
          onClick(e);
        }
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)("path", { d: icon.path, ...icon.properties })
    }
  ) : null;
}
var Icon_default = Icon;

// src/common/form/constants.ts
var FormErrorMessages = {
  EMAIL_BLANK: "Email is blank",
  EMAIL_INVALID: "Email is wrong format",
  PASSWORD_BLANK: "Password is blank",
  PASSWORD_INVALID: "Too weak. Must be at least 8 characters.",
  PASSWORD_WARNING: "Could be stronger",
  PASSWORD_VALID: "Strong password",
  FIRST_NAME_BLANK: "First name is blank",
  LAST_NAME_BLANK: "Last name is blank",
  MAX_CHARACTERS: "Use maximum %n characters",
  EMAIL_NOT_UNIQUE: "Email already in use",
  EMAIL_DOMAIN_NOT_UNIQUE: "Email domain already exist in DB"
};
var FormErrorTypes = /* @__PURE__ */ ((FormErrorTypes2) => {
  FormErrorTypes2["Info"] = "info";
  FormErrorTypes2["Valid"] = "valid";
  FormErrorTypes2["Invalid"] = "invalid";
  return FormErrorTypes2;
})(FormErrorTypes || {});

// src/components/atoms/Form/Input/Input.styles.ts
var stateStyle = import_styled_components5.css`
  ${({ $errorType }) => {
  const states = {
    ["info" /* Info */]: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.n70};
      `,
    ["valid" /* Valid */]: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.g20};
      `,
    ["invalid" /* Invalid */]: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.r20};
      `
  };
  return $errorType ? states[$errorType] : "";
}}
`;
var inputVariationStyles = import_styled_components5.css`
  ${({ inputVariation = "default" }) => {
  const states = {
    default: import_styled_components5.css`
        border: 1px solid ${({ theme }) => theme.colors.n60};
        &:hover {
          border: 1px solid ${({ theme }) => theme.colors.b40};
          box-shadow: ${({ theme }) => theme.shadows.shadow3};
        }
        &:focus {
          outline-width: 0;
          border: 1px solid ${({ theme }) => theme.colors.n40};
          box-shadow: unset;
        }
        &:disabled {
          background-color: ${({ theme }) => theme.colors.n20};
          border: 1px solid ${({ theme }) => theme.colors.n70};
          color: ${({ theme }) => theme.colors.n60};
        }
      `,
    outline: import_styled_components5.css`
        outline: none;
        border: none;
      `
  };
  return inputVariation ? states[inputVariation] : "";
}}
`;
var IconStyle = (0, import_styled_components5.default)(Icon_default)`
  position: absolute;
  cursor: ${({ isPointer }) => isPointer ? "pointer" : "inherit"};
  top: 0;
  bottom: 0;
  margin: auto;
  left: 10px;
`;
var IconRightStyle = (0, import_styled_components5.default)(IconStyle)`
  right: 12px;
  left: auto;
`;
var BoxStyle = (0, import_styled_components5.default)(Box_default)`
  position: relative;
`;
var InputStyle = import_styled_components5.default.input`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid transparent;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.black};
  ${({ theme }) => `border-radius:${2 * theme.space}px;`}
  background-color: ${({ theme }) => theme.colors.white};
  ${inputVariationStyles}
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  ${boxStyle}
  ${textStyle}
  ${stateStyle}
  ${({ css: css30 }) => css30}
`;

// src/common/context/viewerContext/viewerContext.tsx
var import_react = require("react");

// src/common/localStorage/viewer.ts
var viewer_exports = {};
__export(viewer_exports, {
  getAccessToken: () => getAccessToken,
  getPortfolioPassword: () => getPortfolioPassword,
  getRefreshToken: () => getRefreshToken,
  getRefreshTokenExpiry: () => getRefreshTokenExpiry,
  setAccessToken: () => setAccessToken,
  setPortfolioPassword: () => setPortfolioPassword,
  setRefreshToken: () => setRefreshToken,
  setRefreshTokenExpiry: () => setRefreshTokenExpiry
});

// src/common/localStorage/constants.ts
var ACCESS_TOKEN = "ACCESS_TOKEN";
var REFRESH_TOKEN = "REFRESH_TOKEN";
var REFRESH_TOKEN_EXPIRY = "REFRESH_TOKEN_EXPIRY";
var PORTFOLIO_PASSWORD = "PORTFOLIO_PASSWORD";
var TABLE_PROPERTIES_FILTER = "TABLE_PROPERTIES_FILTER";
var TABLE_PROPERTIES_PAGINATION = "TABLE_PROPERTIES_PAGINATION";
var TABLE_BROKERS_FILTER = "TABLE_BROKERS_FILTER";
var TABLE_BROKERS_PAGINATION = "TABLE_BROKERS_PAGINATION";
var TABLE_ORGANIZATIONS_PAGINATION = "TABLE_ORGANIZATIONS_PAGINATION";
var TABLE_ORGANIZATIONS_PROPERTIES_PAGINATION = "TABLE_ORGANIZATIONS_PROPERTIES_PAGINATION";
var TABLE_ORGANIZATIONS_PROPERTIES_FILTER = "TABLE_ORGANIZATIONS_PROPERTIES_FILTER";
var TABLE_MARKET_AREA_FILTER = "TABLE_MARKET_AREA_FILTER";
var TABLE_MARKET_AREA_PAGINATION = "TABLE_MARKET_AREA_PAGINATION";
var PROPERTY_TRANSACTION_TYPE_USER_DEFAULT = "PROPERTY_TRANSACTION_TYPE_USER_DEFAULT";

// src/common/localStorage/viewer.ts
var setAccessToken = (value) => localStorage.setItem(ACCESS_TOKEN, value);
var setRefreshToken = (value) => localStorage.setItem(REFRESH_TOKEN, value);
var setRefreshTokenExpiry = (value) => localStorage.setItem(REFRESH_TOKEN_EXPIRY, value);
var setPortfolioPassword = (value) => localStorage.setItem(PORTFOLIO_PASSWORD, value);
var getAccessToken = () => localStorage.getItem(ACCESS_TOKEN);
var getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);
var getRefreshTokenExpiry = () => localStorage.getItem(REFRESH_TOKEN_EXPIRY);
var getPortfolioPassword = () => localStorage.getItem(PORTFOLIO_PASSWORD);

// src/common/context/viewerContext/viewerContext.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var defaultContextValue = {
  account: null,
  profile: null,
  broker: null,
  developer: null,
  subscription: null,
  userHasTrialed: false,
  canRedirect: true,
  tokens: {
    accessToken: getAccessToken() || "",
    refreshToken: getRefreshToken() || "",
    refreshTokenExpiry: getRefreshTokenExpiry() || ""
  }
};
var ViewerContext = (0, import_react.createContext)(defaultContextValue);
function ViewerProvider({ children }) {
  const [account, setAccount] = (0, import_react.useState)(
    defaultContextValue.account
  );
  const [subscription, setSubscription] = (0, import_react.useState)(
    defaultContextValue.subscription
  );
  const [profile, setProfile] = (0, import_react.useState)(defaultContextValue.profile);
  const [broker, setBroker] = (0, import_react.useState)(defaultContextValue.broker);
  const [tokens, setTokens] = (0, import_react.useState)(defaultContextValue.tokens);
  const [canRedirect, setCanRedirect] = (0, import_react.useState)(
    defaultContextValue.canRedirect
  );
  const [userHasTrialed, setUserHasTrialed] = (0, import_react.useState)(
    defaultContextValue.userHasTrialed
  );
  const [developer, setDeveloper] = (0, import_react.useState)(defaultContextValue.developer);
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(
    ViewerContext.Provider,
    {
      value: {
        account,
        profile,
        broker,
        tokens,
        subscription,
        canRedirect,
        userHasTrialed,
        developer,
        setAccount,
        setProfile,
        setBroker,
        setTokens,
        setSubscription,
        setCanRedirect,
        setUserHasTrialed,
        setDeveloper
      },
      children
    }
  );
}

// src/common/context/dropdownContext/dropdownContext.tsx
var import_react2 = require("react");
var import_lodash3 = require("lodash");
var import_dash_common5 = require("dash-common");
var import_jsx_runtime4 = require("react/jsx-runtime");
var defaultContextValue2 = {
  isOpen: false,
  setIsOpen: () => {
  },
  setItems: () => {
  },
  items: [],
  config: {
    id: "",
    variant: "light",
    trigger: "click",
    optionsStyle: {}
  },
  setConfig: () => {
  },
  children: null,
  setChildren: () => {
  },
  refOptions: null,
  handlePosition: () => {
  }
};
var DropdownContext = (0, import_react2.createContext)(defaultContextValue2);
function DropdownProvider({ children: providerChildren }) {
  const refOptions = (0, import_react2.useRef)(null);
  const [isOpen, setIsOpen] = (0, import_react2.useState)(defaultContextValue2.isOpen);
  const [config, setConfig] = (0, import_react2.useState)(defaultContextValue2.config);
  const [items, setItems] = (0, import_react2.useState)(defaultContextValue2.items);
  const [children, setChildren] = (0, import_react2.useState)(defaultContextValue2.children);
  const handlePosition = ({
    rectBox,
    rectOptions,
    placement,
    placementHorizontal,
    newItems = [],
    newChildren = null
  }) => {
    const element = refOptions.current;
    const isScreenHeightOverflow = placement === "auto" && rectBox.top + rectBox.height + rectOptions.height + 10 > window.innerHeight;
    if ((0, import_dash_common5.or)(placement === "top", isScreenHeightOverflow)) {
      element.style.top = rectBox.top - rectOptions.height + window.scrollY + "px";
    } else if ((0, import_dash_common5.or)(placement === "bottom", placement === "auto")) {
      element.style.top = rectBox.top + rectBox.height + window.scrollY + "px";
    }
    if (placementHorizontal === "right") {
      element.style.left = rectBox.left + window.scrollX + "px";
    }
    if (placementHorizontal === "left") {
      element.style.left = rectBox.left + rectBox.width - rectOptions.width + window.scrollX + "px";
    }
    if (newItems.length > 0) {
      setItems(newItems);
    }
    if (!(0, import_lodash3.isNil)(newChildren)) {
      setChildren(() => newChildren);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(
    DropdownContext.Provider,
    {
      value: {
        isOpen,
        setIsOpen,
        handlePosition,
        refOptions,
        items,
        setItems,
        config,
        setConfig,
        children,
        setChildren
      },
      children: providerChildren
    }
  );
}

// src/common/context/inventoryContext/inventoryContext.tsx
var import_dash_common6 = require("dash-common");
var import_react3 = require("react");
var import_jsx_runtime5 = require("react/jsx-runtime");
var defaultContextValue3 = {
  activeTab: import_dash_common6.InventoryTypeEnum.MODEL,
  setActiveTab: () => {
  }
};
var InventorySectionContext = (0, import_react3.createContext)(defaultContextValue3);
function InventorySectionProvider({ children: providerChildren }) {
  const [activeTab, setActiveTab] = (0, import_react3.useState)(defaultContextValue3.activeTab);
  return /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
    InventorySectionContext.Provider,
    {
      value: {
        activeTab,
        setActiveTab
      },
      children: providerChildren
    }
  );
}

// src/common/context/pagination-context/pagination-context.tsx
var import_react4 = require("react");

// src/common/localStorage/portfolio.ts
var portfolio_exports = {};
__export(portfolio_exports, {
  getPortfolioPassword: () => getPortfolioPassword2,
  setPortfolioPassword: () => setPortfolioPassword2
});
var setPortfolioPassword2 = (value) => localStorage.setItem(PORTFOLIO_PASSWORD, value);
var getPortfolioPassword2 = () => localStorage.getItem(PORTFOLIO_PASSWORD);

// src/common/localStorage/table.tsx
var table_exports = {};
__export(table_exports, {
  getTableFilter: () => getTableFilter,
  getTablePagination: () => getTablePagination,
  setTableFilter: () => setTableFilter,
  setTablePagination: () => setTablePagination
});

// src/common/localStorage/table.interfaces.tsx
var LocalCashTables = /* @__PURE__ */ ((LocalCashTables3) => {
  LocalCashTables3["PROPERTIES"] = "PROPERTIES";
  LocalCashTables3["BROKERS"] = "BROKERS";
  LocalCashTables3["ORGANIZATIONS"] = "ORGANIZATIONS";
  LocalCashTables3["ORGANIZATIONS_PROPERTIES"] = "ORGANIZATIONS_PROPERTIES";
  LocalCashTables3["MARKET_AREA"] = "MARKET_AREA";
  return LocalCashTables3;
})(LocalCashTables || {});

// src/common/localStorage/table.tsx
var PaginationMap = {
  ["PROPERTIES" /* PROPERTIES */]: TABLE_PROPERTIES_PAGINATION,
  ["BROKERS" /* BROKERS */]: TABLE_BROKERS_PAGINATION,
  ["ORGANIZATIONS" /* ORGANIZATIONS */]: TABLE_ORGANIZATIONS_PAGINATION,
  ["ORGANIZATIONS_PROPERTIES" /* ORGANIZATIONS_PROPERTIES */]: TABLE_ORGANIZATIONS_PROPERTIES_PAGINATION,
  ["MARKET_AREA" /* MARKET_AREA */]: TABLE_MARKET_AREA_PAGINATION
};
var FilterMap = {
  ["PROPERTIES" /* PROPERTIES */]: TABLE_PROPERTIES_FILTER,
  ["BROKERS" /* BROKERS */]: TABLE_BROKERS_FILTER,
  ["ORGANIZATIONS_PROPERTIES" /* ORGANIZATIONS_PROPERTIES */]: TABLE_ORGANIZATIONS_PROPERTIES_FILTER,
  ["MARKET_AREA" /* MARKET_AREA */]: TABLE_MARKET_AREA_FILTER
};
var setTableFilter = (tableName, value) => {
  const key = FilterMap[tableName];
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
var setTablePagination = (tableName, value) => {
  const key = PaginationMap[tableName];
  if (key) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
var getTableFilter = (tableName) => {
  const value = localStorage.getItem(FilterMap[tableName]);
  return value || "";
};
var getTablePagination = (tableName) => {
  const value = localStorage.getItem(PaginationMap[tableName]);
  return value || "";
};

// src/common/localStorage/general.ts
var general_exports = {};
__export(general_exports, {
  getTransactionTypeUserDefault: () => getTransactionTypeUserDefault,
  setTransactionTypeUserDefault: () => setTransactionTypeUserDefault
});
var setTransactionTypeUserDefault = (value) => localStorage.setItem(PROPERTY_TRANSACTION_TYPE_USER_DEFAULT, value);
var getTransactionTypeUserDefault = () => localStorage.getItem(PROPERTY_TRANSACTION_TYPE_USER_DEFAULT);

// src/common/localStorage/index.ts
var localStorage2 = {
  ...viewer_exports,
  ...portfolio_exports,
  ...table_exports,
  ...general_exports
};

// src/common/context/pagination-context/pagination-context.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var defaultContextValue4 = {
  total: 0,
  perPage: 10,
  currentPage: 0,
  buttons: []
};
var PaginationContext = (0, import_react4.createContext)({
  state: defaultContextValue4,
  goToPage: () => null,
  setTotal: () => null,
  setPerPage: () => null,
  getRefetchProps: () => ({ skip: 0, limit: defaultContextValue4.perPage }),
  resetPagination: () => null,
  setButtons: () => null
});
var getRefetchProps = (state) => ({
  skip: state.currentPage * state.perPage,
  limit: state.perPage
});
function PaginationProvider({
  children,
  perPage,
  storageTableName
}) {
  const defaultContext = storageTableName && localStorage2.getTablePagination(storageTableName) && JSON.parse(localStorage2.getTablePagination(storageTableName));
  const [state, setState] = (0, import_react4.useState)(
    defaultContext ? defaultContext : {
      ...defaultContextValue4,
      perPage: perPage || defaultContextValue4.perPage
    }
  );
  const goToPage = (index2) => {
    setState((currentState) => ({
      ...currentState,
      currentPage: index2
    }));
  };
  const setTotal = (total) => {
    setState((currentState) => ({
      ...currentState,
      total
    }));
  };
  const setPerPage = (perPage2) => {
    setState((currentState) => ({
      ...currentState,
      perPage: perPage2,
      currentPage: 0
    }));
  };
  const resetPagination = (total) => {
    setState((currentState) => ({
      ...defaultContextValue4,
      total: total || currentState.total,
      perPage: currentState.perPage
    }));
  };
  const setButtons = (buttons) => {
    setState((currentState) => ({
      ...currentState,
      buttons
    }));
  };
  (0, import_react4.useEffect)(() => {
    if (storageTableName) {
      localStorage2.setTablePagination(storageTableName, state);
    }
  }, [state]);
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    PaginationContext.Provider,
    {
      value: {
        state,
        goToPage,
        setTotal,
        setPerPage,
        getRefetchProps,
        resetPagination,
        setButtons
      },
      children
    }
  );
}

// src/common/context/pagination-context/flat-pagination-context.tsx
var import_react5 = require("react");
var import_jsx_runtime7 = require("react/jsx-runtime");
var defaultContextValue5 = {
  perPage: 12
};
var FlatPaginationContext = (0, import_react5.createContext)({
  state: defaultContextValue5,
  setStartingAfter: () => null,
  setEndingBefore: () => null,
  getRefetchProps: () => ({ limit: defaultContextValue5.perPage }),
  resetPagination: () => null
});
var getRefetchProps2 = ({
  perPage,
  ...state
}) => ({ limit: perPage, ...state });
function FlatPaginationProvider({ children }) {
  const [state, setState] = (0, import_react5.useState)(defaultContextValue5);
  const setStartingAfter = (startingAfter) => setState((currentState) => ({
    perPage: currentState.perPage,
    startingAfter
  }));
  const setEndingBefore = (endingBefore) => setState((currentState) => ({
    perPage: currentState.perPage,
    endingBefore
  }));
  const resetPagination = () => setState((currentState) => ({ perPage: currentState.perPage }));
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    FlatPaginationContext.Provider,
    {
      value: { state, setStartingAfter, setEndingBefore, resetPagination, getRefetchProps: getRefetchProps2 },
      children
    }
  );
}

// src/common/context/alertsContext/alertsContext.tsx
var import_react6 = require("react");

// src/common/context/alertsContext/alertsContext.interfaces.tsx
var Alerts = /* @__PURE__ */ ((Alerts2) => {
  Alerts2["ResetPasswordEmailsSent"] = "ResetPasswordEmailsSent";
  Alerts2["PasswordReset"] = "PasswordReset";
  Alerts2["ChangesSaved"] = "ChangesSaved";
  return Alerts2;
})(Alerts || {});

// src/common/context/alertsContext/alertsContext.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var defaultContextValue6 = {
  state: {
    ["ResetPasswordEmailsSent" /* ResetPasswordEmailsSent */]: false,
    ["PasswordReset" /* PasswordReset */]: false,
    ["ChangesSaved" /* ChangesSaved */]: false
  },
  toggleAlert: () => null
};
var AlertsContext = (0, import_react6.createContext)(defaultContextValue6);
function AlertsProvider({ children }) {
  const [state, setState] = (0, import_react6.useState)(defaultContextValue6.state);
  const toggleAlert = (type, value) => {
    setState({
      ...state,
      [type]: value
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(AlertsContext.Provider, { value: { state, toggleAlert }, children });
}

// src/common/context/sortContext/sortContext.tsx
var import_react7 = require("react");
var import_jsx_runtime9 = require("react/jsx-runtime");
var defaultContextValue7 = {
  fieldName: "",
  sortOrder: 0
};
var SortContext = (0, import_react7.createContext)({
  state: defaultContextValue7,
  setSortState: () => null
});
function SortProvider({ children, defaultContext }) {
  const [state, setState] = (0, import_react7.useState)(defaultContext || defaultContextValue7);
  const setSortState = (newState) => {
    setState(newState);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    SortContext.Provider,
    {
      value: { state, setSortState },
      children
    }
  );
}

// src/common/context/searchContext/searchContext.tsx
var import_react8 = require("react");
var import_use_debounce = require("use-debounce");
var import_jsx_runtime10 = require("react/jsx-runtime");
var SearchContext = (0, import_react8.createContext)({
  searchSlug: "",
  setSearchSlug: () => null
});
function SearchProvider({ children, delay = 300 }) {
  const [text, setText] = (0, import_react8.useState)("");
  const [value] = (0, import_use_debounce.useDebounce)(text, delay);
  const setSearchSlug = (value2) => {
    setText(value2);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(SearchContext.Provider, { value: { searchSlug: value, setSearchSlug }, children });
}

// src/common/context/filterContext/filterContext.tsx
var import_react9 = require("react");
var import_jsx_runtime11 = require("react/jsx-runtime");
var FilterContext = (0, import_react9.createContext)({
  state: {},
  setFilterState: () => null,
  resetFilterState: () => null
});
function FilterProvider({ children }) {
  const [state, setState] = (0, import_react9.useState)({});
  const setFilterState = (key, value) => {
    setState((currentState) => ({
      ...currentState,
      [key]: value
    }));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FilterContext.Provider, { value: { state, setFilterState, resetFilterState: () => setState({}) }, children });
}

// src/common/context/formContext/formContext.tsx
var import_react16 = require("react");

// src/common/hooks/useFormValidation/useFormValidation.ts
var import_react10 = require("react");
var useFormValidation = (fieldsList) => {
  const getErrorFields = () => fieldsList.reduce((obj, key) => ({ ...obj, [key]: null }), {});
  const [errors, setErrors] = (0, import_react10.useState)(getErrorFields());
  const [isValid, setIsValid] = (0, import_react10.useState)(false);
  const [isSetterCalls, setIsSetterCalls] = (0, import_react10.useState)(false);
  const setters = fieldsList.map((key) => (value) => {
    setIsSetterCalls(true);
    setErrors((currentState) => ({
      ...currentState,
      [key]: value
    }));
  });
  (0, import_react10.useEffect)(() => {
    if (isSetterCalls) {
      setIsValid(!fieldsList.find((key) => Boolean(errors[key]?.type === "invalid" /* Invalid */)));
    }
  }, [errors]);
  const resetFormErrors = () => {
    setIsSetterCalls(false);
    setErrors(getErrorFields());
  };
  return [errors, isValid, setters, [resetFormErrors]];
};
var useFormState = (fieldsList, defaultValue) => {
  const [defaultValues, setDefaultValues] = (0, import_react10.useState)(defaultValue || {});
  const getFormFields = () => fieldsList.reduce(
    (obj, key) => ({ ...obj, [key]: defaultValues && defaultValues[key] || null }),
    {}
  );
  const [formState, setFormState] = (0, import_react10.useState)({
    isLoading: false,
    errorSlug: "",
    ...getFormFields()
  });
  const setters = fieldsList.map((key) => (value) => {
    setFormState((currentState) => ({ ...currentState, [key]: value }));
  });
  const onSubmit = () => {
    setFormState((currentState) => ({ ...currentState, isLoading: true, errorSlug: "" }));
  };
  const onError = (message) => {
    setFormState((currentState) => ({ ...currentState, isLoading: false, errorSlug: message || "" }));
  };
  const onSuccess = () => {
    setFormState((currentState) => ({ ...currentState, isLoading: false, errorSlug: "" }));
  };
  const setFormValues = (formValue) => {
    setFormState((currentState) => ({ ...currentState, ...formValue }));
  };
  const setDefaultFormValues = (formValues) => {
    setDefaultValues(formValues);
    setFormValues(formValues);
  };
  const resetForm = () => {
    setFormState({
      isLoading: false,
      errorSlug: "",
      ...getFormFields()
    });
  };
  return [
    formState,
    setters,
    [onSubmit, onError, onSuccess, setFormValues, setDefaultFormValues, resetForm]
  ];
};

// src/common/hooks/useOnClickOutside/useOnClickOutside.ts
var import_react11 = require("react");
function useOnClickOutside(ref, handler, disablePortalTarget) {
  (0, import_react11.useEffect)(
    () => {
      const listener = (event) => {
        if ((!ref.current || ref.current.contains(event.target)) && !disablePortalTarget) {
          return;
        }
        handler(event);
      };
      document.addEventListener("mousedown", listener);
      document.addEventListener("touchstart", listener);
      return () => {
        document.removeEventListener("mousedown", listener);
        document.removeEventListener("touchstart", listener);
      };
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]
  );
}

// src/common/hooks/useIsVisible/useIsVisible.ts
var import_react12 = require("react");
function useIsVisible(ref, rootMargin) {
  const [isIntersecting, setIntersecting] = (0, import_react12.useState)(false);
  (0, import_react12.useEffect)(() => {
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
      rootMargin
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}

// src/common/hooks/useServerResponseTranslation/useServerResponseTranslation.ts
var import_react_i18next2 = require("react-i18next");
var useServerResponseTranslation = () => {
  const { t, i18n: i18nErrorSlugs } = (0, import_react_i18next2.useTranslation)(["forms", "common"]);
  const translateErrorMessage = (error, extralFields) => t(
    [
      ...(extralFields || []).map((key) => `${key}:${error.message}`),
      `common:serverErrors:${error.message}`,
      `common:brokerPortalServerErrors:${error.message}`
    ].find((key) => i18nErrorSlugs.exists(key)) || "common:serverMessages:unknown"
  );
  return translateErrorMessage;
};

// src/common/hooks/useGoogleApiLoader/useGoogleApiLoader.ts
var import_api = require("@react-google-maps/api");
var libraries = ["places", "drawing"];
var id = "google-map-script";
function useGoogleApiLoader() {
  const { isLoaded } = (0, import_api.useJsApiLoader)({
    id,
    googleMapsApiKey: process.env.REACT_APP_GOOGLE || "",
    // @ts-ignore
    libraries
  });
  return isLoaded;
}

// src/common/hooks/useScreenResolution/useScreenResolution.ts
var import_react13 = require("react");
var import_use_debounce2 = require("use-debounce");
var import_styled_components6 = require("styled-components");
var useScreenResolution = () => {
  const theme = (0, import_styled_components6.useTheme)();
  const [width, setWidth] = (0, import_react13.useState)(window.innerWidth);
  const onScreenResize = (0, import_use_debounce2.useDebouncedCallback)(() => {
    setWidth(document.documentElement.clientWidth);
  }, 100);
  (0, import_react13.useEffect)(() => {
    window.addEventListener("resize", onScreenResize, true);
    return () => window.removeEventListener("resize", onScreenResize, true);
  }, []);
  const devices = (0, import_react13.useMemo)(
    () => ({
      isMobile: width < theme.breakpoints.md,
      isTablet: width >= theme.breakpoints.md && width <= theme.breakpoints.lg,
      isLaptop: width > theme.breakpoints.lg && width <= theme.breakpoints.xl,
      isDesktop: width > theme.breakpoints.xl
    }),
    [width]
  );
  return { width, devices };
};

// src/common/hooks/useFromNow/useFromNow.ts
var import_react_i18next3 = require("react-i18next");
var import_moment = __toESM(require("moment"));
function useFromNow(settings) {
  const { t } = (0, import_react_i18next3.useTranslation)(["common"]);
  const fromNow = (date) => {
    const nowMoment = (0, import_moment.default)();
    const pastMoment = (0, import_moment.default)(date);
    const year = nowMoment.year() - pastMoment.year();
    const month = nowMoment.month() - pastMoment.month();
    const day = nowMoment.day() - pastMoment.day();
    const hour = nowMoment.hour() - pastMoment.hour();
    const minute = nowMoment.minute() - pastMoment.minute();
    const shortPrefix = settings.short ? "short" : "plural";
    const getLabel = (value, key, settings2) => {
      const shortPluralPrefix = settings2.short ? "shortPlural" : "plural";
      const pluralPrefix = value > 1 ? shortPluralPrefix : shortPrefix;
      return `${t("common:labels.updated")} ${value} ${t(
        `common:moments:${pluralPrefix}:${key}`
      )} ${t("common:moments:agoLabel")}`;
    };
    if (year > 0) {
      return getLabel(year, "year", settings);
    }
    if (month > 0) {
      return getLabel(month, "month", settings);
    }
    if (day > 0) {
      return getLabel(day, "day", settings);
    }
    if (hour > 0) {
      return getLabel(hour, "hour", settings);
    }
    if (minute > 0) {
      return getLabel(minute, "minute", settings);
    }
    return `${t("common:labels:updated")} ${t("common:moments:momentLabel")}`;
  };
  return fromNow;
}

// src/common/hooks/use-async-state/use-async-state.ts
var import_react14 = require("react");
function useAsyncState(initialState) {
  const [state, setState] = (0, import_react14.useState)(initialState);
  const resolveState = (0, import_react14.useRef)();
  const isMounted = (0, import_react14.useRef)(false);
  (0, import_react14.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  (0, import_react14.useEffect)(() => {
    if (resolveState.current) {
      resolveState.current(state);
    }
  }, [state]);
  const setAsyncState = (0, import_react14.useCallback)(
    (newState) => new Promise((resolve2) => {
      if (isMounted.current) {
        resolveState.current = resolve2;
        setState(newState);
      }
    }),
    []
  );
  return [state, setAsyncState, setState];
}

// src/common/hooks/useCheckIfSubscriptionFeatureActiveBroker/useCheckIfSubscriptionFeatureActiveBroker.ts
var import_react15 = require("react");
var import_dash_common7 = require("dash-common");
var useCheckIfSubscriptionFeatureActiveBroker = (features = []) => {
  const { subscription, broker } = (0, import_react15.useContext)(ViewerContext);
  const { toggleModal, setPayload } = (0, import_react15.useContext)(ModalContext);
  const isDemo = broker?.subscriptionType === import_dash_common7.BrokerSubscriptionTypesEnum.DEMO;
  const isSubscriptionActive = isDemo || subscription && import_dash_common7.SUBSCRIPTION_ACTIVE_STATUSES.includes(subscription.status);
  return {
    checkFeatureAccess: ({ disableModal } = {}) => {
      const isActive = isDemo || (0, import_dash_common7.checkPermissionAccessByFeatures)({
        requiredFeature: features,
        subscriptionFeatures: subscription?.subscriptionProduct?.features
      });
      if (!isActive && !disableModal)
        toggleModal(true, "UpgradeSubscriptionModal");
      return isActive;
    },
    triggerSubscriptionModal: ({
      onCompleted
    } = {}) => {
      toggleModal(true, "UpgradeSubscriptionModal");
      setPayload({ onCompleted });
    },
    isSubscriptionActive,
    subscriptionInactiveAt: subscription?.subscriptionInactiveAt,
    isSubscriptionUnpaid: subscription && subscription.status === import_dash_common7.ProductSubscriptionStatusesEnum.UNPAID
  };
};

// src/common/context/formContext/formContext.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");
var defaultContextValue8 = {
  formErrors: {},
  formState: { isLoading: false, errorSlug: "" },
  stateHandlers: {},
  errorHandlers: {},
  resetFormErrors: () => {
  },
  resetForm: () => {
  },
  formOnSubmit: () => {
  },
  formOnError: () => {
  },
  setFormValues: () => {
  },
  setDefaultFormValues: () => {
  },
  formOnSuccess: () => {
  }
};
var FormContext = (0, import_react16.createContext)(defaultContextValue8);
function FormProvider({
  children,
  fieldsList,
  defaultValues
}) {
  const [formErrors, , formErrorHandlers, [resetFormErrors]] = useFormValidation(fieldsList);
  const [
    formState,
    formStateHandlers,
    [formOnSubmit, formOnError, formOnSuccess, setFormValues, setDefaultFormValues, resetForm]
  ] = useFormState(fieldsList, defaultValues);
  const stateHandlers = fieldsList.reduce((obj, name, index2) => {
    obj[name] = formStateHandlers[index2];
    return obj;
  }, {});
  const errorHandlers = fieldsList.reduce((obj, name, index2) => {
    obj[name] = formErrorHandlers[index2];
    return obj;
  }, {});
  return /* @__PURE__ */ (0, import_jsx_runtime12.jsx)(
    FormContext.Provider,
    {
      value: {
        formErrors,
        formState,
        stateHandlers,
        errorHandlers,
        formOnSubmit,
        formOnSuccess,
        formOnError,
        resetFormErrors,
        resetForm,
        setFormValues,
        setDefaultFormValues
      },
      children
    }
  );
}

// src/common/context/modalContext/modalContext.tsx
var import_react17 = require("react");
var import_jsx_runtime13 = require("react/jsx-runtime");
var defaultContextValue9 = {
  isOpen: false,
  isOpenCurrent: {},
  payload: void 0,
  upgradeSubscriptionModal: void 0,
  toggleModal: () => null,
  setPayload: () => null,
  setUpgradeSubscriptionModal: () => null
};
var ModalContext = (0, import_react17.createContext)(defaultContextValue9);
function ModalProvider({ children }) {
  const [isOpen, setIsOpen] = (0, import_react17.useState)(defaultContextValue9.isOpen);
  const [upgradeSubscriptionModal, setUpgradeSubscriptionModal] = (0, import_react17.useState)(defaultContextValue9.upgradeSubscriptionModal);
  const [isOpenCurrent, setIsOpenCurrent] = (0, import_react17.useState)(
    defaultContextValue9.isOpenCurrent
  );
  const [payload, setPayload] = (0, import_react17.useState)(defaultContextValue9.payload);
  const toggleModal = (value, key) => {
    if (key) {
      setIsOpenCurrent((prevState) => ({ ...prevState, [key]: value }));
    } else {
      setIsOpen(value);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime13.jsx)(ModalContext.Provider, { value: { isOpen, isOpenCurrent, toggleModal, payload, setPayload, upgradeSubscriptionModal, setUpgradeSubscriptionModal }, children });
}

// src/common/context/modalContext/enum.ts
var UpgradeSubscriptionModalType = /* @__PURE__ */ ((UpgradeSubscriptionModalType2) => {
  UpgradeSubscriptionModalType2["PORTFOLIO"] = "PORTFOLIO";
  UpgradeSubscriptionModalType2["DOWNLOAD"] = "DOWNLOAD";
  UpgradeSubscriptionModalType2["BASIC"] = "BASIC";
  UpgradeSubscriptionModalType2["PRO"] = "PRO";
  UpgradeSubscriptionModalType2["IDX"] = "IDX";
  UpgradeSubscriptionModalType2["GENERAL"] = "GENERAL";
  UpgradeSubscriptionModalType2["PICK_PLAN"] = "PICK_PLAN";
  UpgradeSubscriptionModalType2["COMPLETE_ACCOUNT"] = "COMPLETE_ACCOUNT";
  return UpgradeSubscriptionModalType2;
})(UpgradeSubscriptionModalType || {});

// src/common/context/pageViewContext/constants.ts
var PageViewTypeEnum = /* @__PURE__ */ ((PageViewTypeEnum2) => {
  PageViewTypeEnum2["LIST"] = "LIST";
  PageViewTypeEnum2["MAP"] = "MAP";
  PageViewTypeEnum2["CARDS"] = "CARDS";
  return PageViewTypeEnum2;
})(PageViewTypeEnum || {});

// src/common/context/pageViewContext/context.tsx
var import_react18 = require("react");
var import_jsx_runtime14 = require("react/jsx-runtime");
var PageViewContext = (0, import_react18.createContext)({
  viewType: "LIST" /* LIST */,
  setViewType: () => null
});
var PageViewProvider = ({ children }) => {
  const [propertyViewType, setPropertyViewType] = (0, import_react18.useState)("LIST" /* LIST */);
  return /* @__PURE__ */ (0, import_jsx_runtime14.jsx)(
    PageViewContext.Provider,
    {
      value: { viewType: propertyViewType, setViewType: setPropertyViewType },
      children
    }
  );
};

// src/common/context/bulkActionsContext/bulkActionsContext.tsx
var import_react19 = require("react");
var import_jsx_runtime15 = require("react/jsx-runtime");
var defaultContextValue10 = {
  selectedItems: [],
  setSelectedItems: () => null,
  resetState: () => null
};
var BulkActionsContext = (0, import_react19.createContext)(defaultContextValue10);
var BulkActionsProvider = ({ children }) => {
  const [state, setState] = (0, import_react19.useState)(
    defaultContextValue10.selectedItems
  );
  const setSelectedItems = (checked, media) => {
    if (checked) {
      return setState((prev) => [...prev, media]);
    }
    setState((prev) => prev.filter((item) => item._id !== media._id));
  };
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    BulkActionsContext.Provider,
    {
      value: {
        selectedItems: state,
        setSelectedItems,
        resetState: () => setState([])
      },
      children
    }
  );
};

// src/common/context/multi-file-upload-context/multi-file-upload-context.tsx
var import_dash_common8 = require("dash-common");
var import_react20 = require("react");
var import_jsx_runtime16 = require("react/jsx-runtime");
var defaultContextValue11 = {
  filesToUpload: [],
  onClear: () => {
  },
  onAbort: () => {
  },
  onError: () => {
  },
  onReject: () => {
  },
  onAbortAll: () => {
  },
  onHistoryClear: () => {
  },
  onCompleted: () => {
  },
  onFileClear: () => {
  },
  setAbortHandler: () => {
  },
  setRejectedFiles: () => {
  },
  initiateAsyncFilesUpload: async () => [],
  addProgressTrackingEvent: () => {
  }
};
var MultiFileUploadContext = (0, import_react20.createContext)(defaultContextValue11);
var MultiFileUploadProvider = ({ children }) => {
  const [filesToUpload, setAsyncState, setStateSync] = useAsyncState(
    defaultContextValue11.filesToUpload
  );
  const getFileUploadStateByProgressTrackingId = (progressTrackingId) => filesToUpload.find((doc) => doc.progressTrackingId === progressTrackingId);
  const setFileStateByProgressTrackingId = (progressTrackingId, newFileState) => setAsyncState((docs) => {
    const newDocs = [...docs];
    const index2 = docs.findIndex((doc) => doc.progressTrackingId === progressTrackingId);
    newDocs[index2] = newFileState;
    return newDocs;
  });
  const initiateAsyncFilesUpload = async (files) => {
    const filesToUploads = [];
    const fileState = files.map((file) => {
      const progressTrackingId = (0, import_dash_common8.RandomId)();
      filesToUploads.push({ file, progressTrackingId, fileSize: file.size });
      return {
        progressTrackingId,
        status: import_dash_common8.ProgressTrackingFileStatusesEnum.INITIALIZATION,
        progress: 0,
        filename: file.name,
        fileSize: file.size,
        operations: {}
      };
    });
    await setAsyncState([...filesToUpload, ...fileState]);
    return filesToUploads;
  };
  const setRejectedFiles = (fileRejections) => {
    const rejectedDocs = fileRejections.map(({ file, errors }) => ({
      progressTrackingId: (0, import_dash_common8.RandomId)(),
      filename: file.name,
      fileSize: file.size,
      messages: errors,
      status: import_dash_common8.ProgressTrackingFileStatusesEnum.ERROR,
      progress: 0
    }));
    setStateSync((docs) => [...docs, ...rejectedDocs]);
  };
  const addProgressTrackingEvent = (event) => {
    const {
      expectedOperations = [],
      operation,
      status,
      type,
      progress,
      progressTrackingId
    } = event;
    let fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (!fileUploadState || type !== import_dash_common8.ProgressTrackingTypesEnum.FILE_UPLOAD)
      return;
    if (status === import_dash_common8.ProgressTrackingFileStatusesEnum.INITIALIZATION) {
      const operations = expectedOperations.reduce(
        (memo2, expectedOperation) => ({
          ...memo2,
          [expectedOperation]: { progress: 0, operationStatus: status }
        }),
        {}
      );
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.INITIALIZATION;
      fileUploadState.operations = operations;
    }
    if (operation && fileUploadState.operations && fileUploadState.operations[operation]) {
      if (status !== import_dash_common8.ProgressTrackingFileStatusesEnum.INITIALIZATION) {
        fileUploadState.operations[operation].operationStatus = status;
      }
      if (status === import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADING && progress) {
        fileUploadState.operations[operation].progress = progress;
      }
      if (status === import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADED) {
        fileUploadState.operations[operation].progress = 100;
      }
    }
    const operationsMap = Object.values(fileUploadState.operations || {});
    const isUploading = operationsMap.some(
      (doc) => doc.operationStatus === import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADING
    );
    if (isUploading) {
      const operationCount = operationsMap.length;
      const totalPercentage = operationsMap.reduce((memo2, doc) => memo2 + doc.progress || 0, 0);
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADING;
      fileUploadState.progress = Math.ceil(totalPercentage / operationCount);
    }
    const isUploaded = operationsMap.every(
      (doc) => doc.operationStatus === import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADED
    );
    if (isUploaded) {
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADED;
    }
    if (status === import_dash_common8.ProgressTrackingFileStatusesEnum.ABORTED) {
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.ABORTED;
    }
    if (status === import_dash_common8.ProgressTrackingFileStatusesEnum.ERROR) {
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.ERROR;
    }
    setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
  };
  const setAbortHandler = (progressTrackingId, abortHandler) => {
    setAsyncState((docs) => {
      const newDocs = [...docs];
      const index2 = newDocs.findIndex((doc) => doc.progressTrackingId === progressTrackingId);
      if (index2 > -1) {
        newDocs[index2].abortHandler = abortHandler;
      }
      return newDocs;
    });
  };
  const onReject = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState) {
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.ABORTED;
      setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
    }
  };
  const onAbort = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState && fileUploadState.abortHandler) {
      fileUploadState.abortHandler();
    }
    onReject(progressTrackingId);
  };
  const onAbortAll = () => setAsyncState(
    (docs) => docs.map((doc) => {
      if (doc.abortHandler) {
        doc.abortHandler();
      }
      return { ...doc, status: import_dash_common8.ProgressTrackingFileStatusesEnum.ABORTED, progress: 0 };
    })
  );
  const onCompleted = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState) {
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADED;
      setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
    }
  };
  const onClear = (progressTrackingId) => setAsyncState((prev) => prev.filter((item) => item.progressTrackingId !== progressTrackingId));
  const onError = (progressTrackingId) => {
    const fileUploadState = getFileUploadStateByProgressTrackingId(progressTrackingId);
    if (fileUploadState) {
      fileUploadState.status = import_dash_common8.ProgressTrackingFileStatusesEnum.ERROR;
      setFileStateByProgressTrackingId(progressTrackingId, fileUploadState);
    }
  };
  const onFileClear = (progressTrackingId) => setAsyncState((prev) => prev.filter((item) => item.progressTrackingId !== progressTrackingId));
  const onHistoryClear = () => setAsyncState(
    (prev) => prev.filter((item) => item.status === import_dash_common8.ProgressTrackingFileStatusesEnum.UPLOADING)
  );
  return /* @__PURE__ */ (0, import_jsx_runtime16.jsx)(
    MultiFileUploadContext.Provider,
    {
      value: {
        onClear,
        onAbort,
        onError,
        onReject,
        onAbortAll,
        onCompleted,
        onFileClear,
        onHistoryClear,
        filesToUpload,
        setAbortHandler,
        setRejectedFiles,
        addProgressTrackingEvent,
        initiateAsyncFilesUpload
      },
      children
    }
  );
};

// src/common/context/mediaDragAndDropContext/mediaDragAndDropContext.tsx
var import_react21 = require("react");
var import_jsx_runtime17 = require("react/jsx-runtime");
var MediaDragAndDropContext = (0, import_react21.createContext)({ mediaIds: [], setMediaIds: () => null, resetState: () => null });
var MediaDragAndDropProvider = ({ children }) => {
  const [mediaIds, setMediaIds] = (0, import_react21.useState)(
    []
  );
  const setCurrentMediaIds = ({
    mediaIdToMove,
    mediaIdToReplace
  }) => {
    setMediaIds((prev) => {
      const isEqual = prev.some(
        (item) => item.mediaIdToMove === mediaIdToMove && item.mediaIdToReplace === mediaIdToReplace
      );
      if (isEqual)
        return prev;
      if (mediaIdToMove === mediaIdToReplace)
        return prev;
      return [...prev, { mediaIdToMove, mediaIdToReplace }];
    });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime17.jsx)(
    MediaDragAndDropContext.Provider,
    {
      value: { mediaIds, setMediaIds: setCurrentMediaIds, resetState: () => setMediaIds([]) },
      children
    }
  );
};

// src/common/context/tooltipContext/tooltipContext.tsx
var import_react22 = require("react");
var import_dash_common9 = require("dash-common");
var import_jsx_runtime18 = require("react/jsx-runtime");
var defaultContextValue12 = {
  isOpen: false,
  setIsOpen: () => {
  },
  config: {
    id: "",
    placement: "bottom"
  },
  setConfig: () => {
  },
  children: null,
  setChildren: () => {
  },
  content: null,
  setContent: () => {
  },
  handlePosition: () => {
  },
  refModal: null
};
var TooltipContext = (0, import_react22.createContext)(defaultContextValue12);
function TooltipProvider({ children: providerChildren }) {
  const refModal = (0, import_react22.useRef)(null);
  const [isOpen, setIsOpen] = (0, import_react22.useState)(defaultContextValue12.isOpen);
  const [config, setConfig] = (0, import_react22.useState)(defaultContextValue12.config);
  const [children, setChildren] = (0, import_react22.useState)(defaultContextValue12.children);
  const [content, setContent] = (0, import_react22.useState)(defaultContextValue12.content);
  const handlePosition = ({
    rectBox,
    rectModal
  }) => {
    const element = refModal.current;
    const isScreenHeightTopOverflow = config.placement === "top" && rectBox.top - rectModal.height - 10 < 0;
    const isScreenHeightBottomOverflow = rectBox.bottom + window.scrollY + rectModal.height + 20 > screen.height;
    if (isScreenHeightTopOverflow) {
      setConfig((state) => ({
        ...state,
        placement: "bottom"
      }));
    }
    if (isScreenHeightBottomOverflow) {
      setConfig((state) => ({
        ...state,
        placement: "top"
      }));
    }
    if (config.placement === "top" && !isScreenHeightTopOverflow) {
      element.style.top = rectBox.top - rectModal.height + window.scrollY - 7 + "px";
      element.style.left = rectBox.left + window.scrollX + "px";
    } else if ((0, import_dash_common9.or)(config.placement === "bottom", isScreenHeightTopOverflow)) {
      element.style.top = rectBox.top + rectBox.height + window.scrollY + 7 + "px";
      element.style.left = rectBox.left + window.scrollX + "px";
    } else if (config.placement === "left") {
      element.style.top = rectBox.top - rectBox.height / 4 + window.scrollY + "px";
      element.style.left = rectBox.left - rectModal.width + window.scrollX - 7 + "px";
    } else if (config.placement === "right") {
      element.style.top = rectBox.top - rectBox.height / 4 + window.scrollY + "px";
      element.style.left = rectBox.left + rectModal.width + window.scrollX - 13 + "px";
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime18.jsx)(
    TooltipContext.Provider,
    {
      value: {
        isOpen,
        setIsOpen,
        handlePosition,
        config,
        setConfig,
        refModal,
        children,
        setChildren,
        content,
        setContent
      },
      children: providerChildren
    }
  );
}

// src/common/context/colorContext/colorContext.tsx
var import_react23 = require("react");
var import_styled_components7 = require("styled-components");
var import_randomcolor = __toESM(require("randomcolor"));
var import_jsx_runtime19 = require("react/jsx-runtime");
var ColorContext = (0, import_react23.createContext)({
  colorMap: {},
  setColorMap: () => null,
  getDashColor: () => "",
  getGradientColor: () => [],
  getRandomColor: () => "",
  gradientColorSets: []
});
function ColorProvider({ children }) {
  const [colorMap, setColorMap] = (0, import_react23.useState)({});
  const theme = (0, import_styled_components7.useTheme)();
  const colors2 = (0, import_react23.useMemo)(
    () => [
      theme.colors.b90,
      theme.colors.b80,
      theme.colors.b70,
      theme.colors.b60,
      theme.colors.b50,
      theme.colors.b50Hover,
      theme.colors.b50Active,
      theme.colors.b100,
      theme.colors.b40,
      theme.colors.b30,
      theme.colors.b20,
      theme.colors.g20,
      theme.colors.g20Hover,
      theme.colors.g20Active,
      theme.colors.g40,
      theme.colors.r60,
      theme.colors.r20,
      theme.colors.r20Hover,
      theme.colors.r20Active,
      theme.colors.y20,
      theme.colors.n200,
      theme.colors.n90,
      theme.colors.n80,
      theme.colors.n70,
      theme.colors.n60
    ],
    [theme]
  );
  const gradientColorSets = (0, import_react23.useMemo)(
    () => [
      theme.gradientColorsSet.blue,
      theme.gradientColorsSet.green,
      theme.gradientColorsSet.red,
      theme.gradientColorsSet.yellow,
      theme.gradientColorsSet.purple
    ],
    [theme]
  );
  const getDashColor = (0, import_react23.useCallback)(() => {
    const randomColorIndex = Math.floor(Math.random() * colors2.length);
    return colors2[randomColorIndex];
  }, [colors2]);
  const setColorMapSpy = (0, import_react23.useCallback)(
    (newState) => {
      setColorMap(newState);
    },
    [setColorMap]
  );
  const getRandomColor = () => (0, import_randomcolor.default)();
  const getGradientColor = (0, import_react23.useCallback)(() => {
    const randomColorIndex = Math.floor(Math.random() * gradientColorSets.length);
    return gradientColorSets[randomColorIndex];
  }, [gradientColorSets]);
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    ColorContext.Provider,
    {
      value: {
        colorMap,
        setColorMap: setColorMapSpy,
        getDashColor,
        getRandomColor,
        getGradientColor,
        gradientColorSets
      },
      children
    }
  );
}

// src/common/account/access-token-helpers.ts
var import_jwt_decode = __toESM(require("jwt-decode"));
var jwtDecodeSafely = (accessToken) => {
  try {
    return (0, import_jwt_decode.default)(accessToken);
  } catch {
    return null;
  }
};
var isAccessTokenExpired = (accessToken, tolerance = 5e3) => {
  if (!accessToken) {
    return true;
  }
  try {
    const decodedJwt = (0, import_jwt_decode.default)(accessToken);
    return decodedJwt.exp * 1e3 <= Date.now() + tolerance;
  } catch {
    return false;
  }
};
var fetchAccessToken = async (url, refreshToken) => {
  if (!refreshToken) {
    return Promise.reject(new Error("Refresh token not found"));
  }
  const res = await fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Refresh: refreshToken
    },
    body: JSON.stringify({
      query: `
          mutation refreshTokens {
            refreshTokens {
              accessToken
              refreshToken
              refreshTokenExpiry
            }
          }`
    })
  });
  const { data, errors } = await res.json();
  if (errors?.length) {
    return Promise.reject(errors[0]);
  }
  return data?.refreshTokens;
};

// src/common/files/file-upload-helpers.ts
var fileUploadFetch = (url, options) => new Promise((resolve2, reject) => {
  const xhr = new XMLHttpRequest();
  xhr.open(options.method, url, true);
  Object.entries(options.headers).forEach(
    ([key, value]) => xhr.setRequestHeader(key, value)
  );
  xhr.onload = ({ target: { responseText } }) => {
    resolve2({
      ok: true,
      text: () => Promise.resolve(responseText),
      json: () => Promise.resolve(JSON.parse(responseText))
    });
  };
  xhr.onerror = reject;
  xhr.ontimeout = reject;
  if (xhr.upload) {
    xhr.upload.onprogress = options.onProgress;
  }
  if (options.onAbort) {
    options.onAbort(() => xhr.abort());
  }
  xhr.send(options.body);
});

// src/common/tables/constants.ts
var SortByEnum = /* @__PURE__ */ ((SortByEnum2) => {
  SortByEnum2["SORT_AZ"] = "SORT_AZ";
  SortByEnum2["SORT_ZA"] = "SORT_ZA";
  SortByEnum2["SORT_CREATED_AT"] = "SORT_CREATED_AT";
  return SortByEnum2;
})(SortByEnum || {});

// src/common/address/googlePlaceToAddress.ts
var googlePlaceToAddress = (place) => {
  const address = {
    street: "",
    zipCode: "",
    city: "",
    county: "",
    state: ""
  };
  for (const component of place?.address_components || []) {
    const componentType = component.types[0];
    switch (componentType) {
      case "postal_code": {
        address.zipCode = component.long_name;
        break;
      }
      case "route": {
        address.street += component.long_name;
        break;
      }
      case "street_number": {
        address.street = `${component.long_name} ${address.street}`;
        break;
      }
      case "locality": {
        address.city = component.long_name;
        break;
      }
      case "administrative_area_level_2":
        address.county = component.long_name.replace(" County", "");
        break;
      case "administrative_area_level_1": {
        address.state = component.long_name;
        break;
      }
    }
  }
  return address;
};

// src/common/mortgage/mortgage.ts
var mortgage_exports = {};
__export(mortgage_exports, {
  calculateMortgage: () => calculateMortgage,
  nextPenny: () => nextPenny
});

// src/common/mortgage/mortgage-js.v1.ts
var nextPenny = (value) => Math.ceil(value * 100) / 100;
var calculateMonthlyPIPayment = (loanAmount, annualRate, termMonths) => {
  let monthlyRate = annualRate / 12;
  let payment = monthlyRate * loanAmount * Math.pow(1 + monthlyRate, termMonths) / (Math.pow(1 + monthlyRate, termMonths) - 1);
  return payment;
};
var calculatePaymentSchedule = (loanAmount, annualRate, termMonths, additionalPrincipalPayments = 0) => {
  const monthlyRate = annualRate / 12;
  const monthlyPayment = calculateMonthlyPIPayment(loanAmount, annualRate, termMonths);
  let principal = loanAmount;
  let payments = [];
  let totalInterest = 0;
  let totalPayments = 0;
  let i = 0;
  while (principal > 0 && i < termMonths) {
    let interestPayment = principal * monthlyRate;
    let principalPayment = monthlyPayment - interestPayment + additionalPrincipalPayments;
    if (principal > principalPayment) {
      principal = principal - principalPayment;
    } else {
      principalPayment = principal;
      principal = 0;
    }
    let totalPayment = interestPayment + principalPayment;
    totalInterest += interestPayment;
    totalPayments += totalPayment;
    payments[i] = {
      count: i + 1,
      interestPayment,
      totalInterest,
      principalPayment,
      totalPayment,
      totalPayments,
      balance: principal
    };
    i++;
  }
  return payments;
};
var calculatePayment = ({
  totalPrice,
  downPayment,
  interestRate,
  months,
  taxRate = 0,
  insuranceRate = 0,
  mortgageInsuranceRate = 0,
  mortgageInsuranceEnabled = false,
  mortgageInsuranceThreshold = 0,
  additionalPrincipalPayment = 0
}) => {
  let loanAmount = totalPrice - downPayment;
  let paymentSchedule = calculatePaymentSchedule(
    loanAmount,
    interestRate,
    months,
    additionalPrincipalPayment
  );
  let piPayment = paymentSchedule.length ? paymentSchedule[0].totalPayment : 0;
  let downPaymentPercentage = downPayment / totalPrice;
  let mortgageInsurance = 0;
  if (mortgageInsuranceEnabled && downPaymentPercentage < mortgageInsuranceThreshold) {
    mortgageInsurance = loanAmount * mortgageInsuranceRate / 12;
  }
  let propertyTax = totalPrice * taxRate / 12;
  let homeOwnerInsurance = totalPrice * insuranceRate / 12;
  return {
    loanAmount,
    principalAndInterest: piPayment,
    tax: propertyTax,
    insurance: homeOwnerInsurance,
    total: piPayment + propertyTax + homeOwnerInsurance + mortgageInsurance,
    termMonths: months,
    paymentSchedule,
    mortgageInsurance
  };
};

// src/common/mortgage/mortgage.ts
var calculateMortgage = (input) => {
  const { totalPrice, downPayment, interestRate, months, taxRate = 0, insuranceRate = 0 } = input;
  const taxRatePercentage = taxRate > 0 ? totalPrice / taxRate : 0;
  const insuranceRatePercentage = insuranceRate > 0 ? totalPrice / insuranceRate : 0;
  const downPaymentAmount = totalPrice * (downPayment / 100);
  return calculatePayment({
    totalPrice,
    downPayment: downPaymentAmount,
    interestRate,
    months,
    taxRate: taxRatePercentage,
    insuranceRate: insuranceRatePercentage,
    mortgageInsuranceRate: 0,
    mortgageInsuranceEnabled: false,
    mortgageInsuranceThreshold: 0,
    additionalPrincipalPayment: 0
  });
};

// src/common/googleMap/googleZoomLevelToMiles.ts
var googleZoomLevelToMiles = (lat, zoom) => 156543.03392 * Math.cos(lat * Math.PI / 180) / Math.pow(2, zoom) * 1.609;

// src/common/helpers/string.helpers.ts
var import_lodash4 = require("lodash");
var formatBedroomsRangeValues = (range, options) => {
  if (!range)
    return "";
  const { min, max } = range;
  if (min === null && max === null)
    return "";
  if (min === 0 && options && options.t && max && max > 0) {
    return `${options.t("common:labels.studio")[0]} - ${max}`;
  }
  if (options && options.isNullable && options.t) {
    return options.t("common:labels.studio");
  }
  if ((0, import_lodash4.isNumber)(min) && (0, import_lodash4.isNumber)(max) && min !== max) {
    return `${min} - ${max}`;
  }
  if (min || max) {
    return min ?? max;
  }
  return "";
};
var formatBathroomsRangeValues = (range, options) => {
  if (!range)
    return "";
  const { min, max } = range;
  if (min === 0 && options && options.t && max && max > 0) {
    return `${min} - ${max}`;
  }
  if (options && options.isNullable && options.t) {
    return "";
  }
  if ((0, import_lodash4.isNumber)(min) && (0, import_lodash4.isNumber)(max) && min !== max) {
    return `${min} - ${max}`;
  }
  if (min || max) {
    return min ?? max;
  }
  return "";
};
var formatGeneralRangeValues = (range, options) => {
  if (!range)
    return "";
  const { min, max } = range;
  if (min === 0 && options && options.t && max && max > 0) {
    return `${min.toLocaleString("en-US")} - ${max.toLocaleString("en-US")}`;
  }
  if (options && options.isNullable && options.t) {
    return "";
  }
  if ((0, import_lodash4.isNumber)(min) && (0, import_lodash4.isNumber)(max) && min !== max && max > 0) {
    return `${min.toLocaleString("en-US")} - ${max.toLocaleString("en-US")}`;
  }
  if (min || max) {
    if (min)
      return min.toLocaleString("en-US");
    else
      return max?.toLocaleString("en-US");
  }
  return "";
};

// src/common/helpers/download.helpers.ts
function downloadMedia(mediaIds) {
  window.open(
    process.env["REACT_APP_REST"] + `/media/download?accessToken=${localStorage2.getAccessToken()}&mediaIds=${JSON.stringify(
      mediaIds
    )}`
  );
}
function downloadFile(fileIds) {
  window.open(
    process.env["REACT_APP_REST"] + `/media/download-file?accessToken=${localStorage2.getAccessToken()}&fileIds=${JSON.stringify(
      fileIds
    )}`
  );
}

// src/components/atoms/Spinner/Spinner.tsx
var import_styled_components9 = require("styled-components");

// src/components/atoms/Spinner/Spinner.styles.tsx
var import_styled_components8 = __toESM(require("styled-components"));
var StyledIcon = (0, import_styled_components8.default)(Icon_default)`
  -webkit-animation: spin 1.6s ease-in-out infinite;
  -moz-animation: spin 1.6s ease-in-out infinite;
  animation: spin 1.6s ease-in-out infinite;
  @-moz-keyframes spin {
    100% {
      -moz-transform: rotate(360deg);
    }
  }
  @-webkit-keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
  @keyframes spin {
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`;
var SpinnerWrapper = (0, import_styled_components8.default)(Flex_default)`
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: inherit;
  background: ${({ theme, bgColor, opacity }) => theme.colors.setOpacity(bgColor || theme.colors.white, opacity || 80)};

  ${({ theme, ignoreResponsive }) => !ignoreResponsive && `@media ${theme.devices.mobile} {
      align-items: start;
      padding-top: ${theme.space * 8}px;
  })`}
`;

// src/components/atoms/Spinner/Spinner.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");
function Spinner({
  fullContent = false,
  ignoreResponsive = false,
  bgColor,
  color: color2,
  opacity,
  ...props
}) {
  const theme = (0, import_styled_components9.useTheme)();
  const iconProps = { size: 24, color: color2 || theme.colors.b50, ...props };
  if (!fullContent) {
    return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(StyledIcon, { ...iconProps, name: "loading" });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(
    SpinnerWrapper,
    {
      pos: "absolute",
      alignItems: "center",
      justifyContent: "center",
      w: "100%",
      bgColor,
      opacity,
      ignoreResponsive,
      children: /* @__PURE__ */ (0, import_jsx_runtime20.jsx)(StyledIcon, { ...iconProps, name: "loading" })
    }
  );
}
var Spinner_default = Spinner;

// src/components/atoms/Badge/Badge.styles.tsx
var import_styled_components10 = __toESM(require("styled-components"));
var badgeStyle = import_styled_components10.css`
  ${({ theme, type = "neutral" }) => {
  const typesStyleRelations = {
    neutral: import_styled_components10.css`
        color: ${theme.colors.b50};
        background-color: ${theme.colors.b20};
      `,
    ["neutralSolid"]: import_styled_components10.css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.b50};
      `,
    alert: import_styled_components10.css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.r20};
      `,
    active: import_styled_components10.css`
        color: ${theme.colors.g20};
        background-color: ${theme.colors.g10};
      `,
    activeSolid: import_styled_components10.css`
        color: ${theme.colors.white};
        background-color: ${theme.colors.g20};
      `,
    inactive: import_styled_components10.css`
        color: ${theme.colors.n80};
        background-color: ${theme.colors.n20};
      `,
    danger: import_styled_components10.css`
        color: ${theme.colors.r20};
        background-color: ${theme.colors.r10};
      `,
    warning: import_styled_components10.css`
        color: ${theme.colors.y20};
        background-color: ${theme.colors.y10};
      `
  };
  return typesStyleRelations[type] || "";
}}
`;
var BadgeStyle = (0, import_styled_components10.default)(Flex_default)`
  cursor: ${({ isPointer }) => isPointer ? "pointer" : "default"};
  border-radius: ${({ square, borderRadius }) => borderRadius || (square ? 4 : 16)}px;
  ${textStyle}
  ${badgeStyle}
  ${({ bgColor }) => bgColor && `background-color: ${bgColor}`};
  ${({ titleColor }) => titleColor && `color: ${titleColor}`};
`;

// src/components/atoms/Badge/Badge.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");
function Badge({
  title,
  onClick,
  iconRight,
  iconRightProps,
  iconLeft,
  iconLeftProps,
  px = 2,
  py = 1,
  sm = true,
  semibold = true,
  loading,
  renderLeftIcon,
  ...args
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(
    BadgeStyle,
    {
      onClick: (e) => {
        if (onClick) {
          e.stopPropagation();
          onClick();
        }
      },
      isPointer: !!onClick,
      alignItems: "center",
      justifyContent: "center",
      px,
      py,
      sm,
      semibold,
      ...args,
      children: loading ? /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Spinner_default, { size: 20, pos: "absolute", color: "inherit" }) : /* @__PURE__ */ (0, import_jsx_runtime21.jsxs)(import_jsx_runtime21.Fragment, { children: [
        renderLeftIcon && renderLeftIcon(),
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Icon_default, { size: 24, mr: 1, name: iconLeft, ...iconLeftProps }) }),
        title,
        iconRight && /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime21.jsx)(Icon_default, { size: 24, ml: 1, name: iconRight, ...iconRightProps }) })
      ] })
    }
  );
}
var Badge_default = Badge;

// src/components/atoms/Form/Select/Select.styles.ts
var StyledSelectWrapper = (0, import_styled_components11.default)(Flex_default)`
  cursor: pointer;
  position: relative;
  & > div:first-child {
    width: inherit;
  }
  .select__control {
    border-radius: 8px;
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.n60};
    box-shadow: none;
    height: ${({ h }) => h ? h : "40px"};
    width: inherit;
    visibility: ${({ isButtonSelect }) => isButtonSelect ? "hidden" : "visible"};

    :hover {
      background: ${({ theme }) => theme.colors.white};
      border-color: ${({ theme }) => theme.colors.b40};
      box-shadow: ${({ theme }) => theme.shadows.shadow3};
      cursor: pointer;
    }

    ${stateStyle}
  }
  .select__control--is-focused {
    background-color: ${({ theme }) => theme.colors.white};
    border-color: ${({ theme, $errorType }) => $errorType === "invalid" /* Invalid */ ? theme.colors.r20 : theme.colors.n70};
  }
  .select__indicator-separator {
    display: none;
  }

  .select__indicators {
    margin-right: 10px;
    margin-left: 2px;
    color: ${({ theme }) => theme.colors.n200};
  }

  .select__control--is-disabled {
    background-color: ${({ theme }) => theme.colors.n20};
    border-color: ${({ theme }) => theme.colors.n60};
    .select__indicators {
      color: ${({ theme }) => theme.colors.n200};
    }
  }
  .select__placeholder {
    font-size: 14px;
    line-height: 23px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ theme }) => theme.colors.n60};
  }

  .select__input {
    cursor: pointer;
  }

  .select__value-container {
    flex-wrap: nowrap;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: unset;

    -ms-overflow-style: none;
    scrollbar-width: none;
    margin-left: ${({ leftIcon }) => leftIcon ? 42 : 12}px;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  ${boxStyle}
  ${textStyle}
  ${({ css: css30 }) => css30}
`;
var SelectMenuDropdownStyles = import_styled_components11.css`
  .select__menu {
    min-width: fit-content;
    border-radius: ${({ theme }) => theme.space * 3}px !important;
  }
  .select__menu-list {
    width: inherit;
    padding: 0 !important;
    border-radius: ${({ theme }) => theme.space * 3}px !important;
    .select__option {
      width: inherit;
      cursor: pointer;
      margin-top: ${({ theme }) => theme.space}px;
      margin-bottom: ${({ theme }) => theme.space}px;
    }
    .select__option--is-focused {
      background-color: ${({ theme }) => theme.colors.b10};
      border-radius: ${({ theme }) => theme.space * 2}px;
      &:active {
        background-color: ${({ theme }) => theme.colors.b10};
      }
    }
    .select__option--is-selected {
      background-color: ${({ theme }) => theme.colors.b20};
      &:active {
        background-color: ${({ theme }) => theme.colors.b20};
      }
    }
    .hover-disable {
      :hover {
        background: transparent;
      }
    }
    .hover-disable.select__option--is-focused,
    .hover-disable.select__option--is-selected {
      background: transparent;
    }
  }
`;
var StyledLeftIconContainer = (0, import_styled_components11.default)(Flex_default)`
  position: absolute;
  left: ${({ theme }) => theme.space * 3}px;
  width: ${({ theme }) => theme.space * 6}px;
  height: ${({ theme }) => theme.space * 6}px;
  z-index: 2;
  cursor: pointer;
`;
var StyledValueText = (0, import_styled_components11.default)(Box_default)`
  ${textStyle}
`;
var StyledBadge = (0, import_styled_components11.default)(Badge_default)`
  z-index: 1;
  :hover {
    background-color: ${({ theme }) => theme.colors.b30};
  }
`;

// src/components/theme.provider.tsx
var import_jsx_runtime22 = require("react/jsx-runtime");
var GlobalStyles = import_styled_components12.createGlobalStyle`
  ${SelectMenuDropdownStyles}

  html {
    overflow-y: overlay;
  }
`;
var ThemeProvider = ({ children }) => {
  import_react_modal.default.setAppElement("#root");
  return /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(import_styled_components12.ThemeProvider, { theme: mainTheme, children: /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(import_react_dnd.DndProvider, { backend: import_react_dnd_html5_backend.HTML5Backend, children: /* @__PURE__ */ (0, import_jsx_runtime22.jsxs)(import_react_i18next4.I18nextProvider, { i18n: i18n_default, children: [
    /* @__PURE__ */ (0, import_jsx_runtime22.jsx)(GlobalStyles, {}),
    children
  ] }) }) });
};
var theme_provider_default = ThemeProvider;

// src/components/atoms/H/H.tsx
var import_styled_components13 = __toESM(require("styled-components"));
var import_jsx_runtime23 = require("react/jsx-runtime");
var textStyle2 = import_styled_components13.css`
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  margin-block-start: unset;
  margin-block-end: unset;
  font-weight: ${({ theme, bold, semibold, medium, regular = true }) => getFontWeight(theme, {
  bold,
  semibold,
  medium,
  regular
})};
  font-size: ${({ theme, md, lg, sm, xs }) => getSize(theme, { md, lg, sm, xs }, "fontSize", "header")}px;
  line-height: ${({ theme, md, lg, sm, xs }) => getSize(theme, { md, lg, sm, xs }, "lineHeight", "header")}px;
  color: ${({ color: color2, theme }) => color2 || theme.colors.n90};
`;
var h3 = import_styled_components13.default.h3`
  ${textStyle2}
`;
var h4 = import_styled_components13.default.h4`
  ${textStyle2}
`;
function H({ children, as = 1, ...args }) {
  const H2 = [h3, h4][as - 1] || h3;
  return /* @__PURE__ */ (0, import_jsx_runtime23.jsx)(H2, { ...args, children });
}
var H_default = H;

// src/components/atoms/Banner/Banner.styles.tsx
var import_styled_components14 = __toESM(require("styled-components"));
var BannerContainer = (0, import_styled_components14.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

// src/components/atoms/Banner/Banner.interfaces.ts
var BannerTypesEnum = /* @__PURE__ */ ((BannerTypesEnum2) => {
  BannerTypesEnum2["SUCCESS"] = "success";
  BannerTypesEnum2["WARNING"] = "warning";
  BannerTypesEnum2["ERROR"] = "error";
  return BannerTypesEnum2;
})(BannerTypesEnum || {});

// src/components/atoms/Banner/Banner.constants.ts
var BANNER_OPTIONS = {
  ["success" /* SUCCESS */]: {
    background: mainTheme.colors.g10,
    color: mainTheme.colors.g20
  },
  ["warning" /* WARNING */]: {
    background: mainTheme.colors.y20,
    color: mainTheme.colors.n90
  },
  ["error" /* ERROR */]: {
    background: mainTheme.colors.r10,
    color: mainTheme.colors.r20
  }
};
var BANNER_SORT_ORDER = {
  ["error" /* ERROR */]: 1,
  ["warning" /* WARNING */]: 2,
  ["success" /* SUCCESS */]: 3
};

// src/components/molecules/DashboardBanner/DashboardBanner.styles.ts
var import_styled_components16 = __toESM(require("styled-components"));

// src/components/atoms/Button/Button.tsx
var import_styled_components15 = __toESM(require("styled-components"));

// src/components/atoms/Button/Button.helpers.ts
var getButtonColors = ({
  colorVariation = "default",
  theme
}) => {
  const variation = {
    danger: {
      color: theme.colors.r20,
      hoverColor: theme.colors.r20Hover,
      outlineColor: theme.colors.r10
    },
    success: {
      color: theme.colors.g20,
      hoverColor: theme.colors.g20Hover,
      outlineColor: theme.colors.g10
    },
    default: {
      color: theme.colors.b50,
      hoverColor: theme.colors.b50Hover,
      outlineColor: theme.colors.b10
    },
    light: {
      color: theme.colors.white,
      hoverColor: theme.colors.setOpacity(theme.colors.white, 20),
      outlineColor: theme.colors.white
    }
  };
  return variation[colorVariation];
};

// src/components/atoms/Button/components/ButtonIcon/ButtonIcon.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");
function ButtonIcon({
  left,
  right,
  hasContent,
  icon,
  iconProps,
  regular,
  medium,
  small
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
    Flex_default,
    {
      w: regular && 24 || medium && 18 || small && 16 || 24,
      alignItems: "center",
      justifyContent: "center",
      ...hasContent && left && { mr: 1 },
      ...hasContent && right && { ml: 1.5 },
      children: /* @__PURE__ */ (0, import_jsx_runtime24.jsx)(
        Icon_default,
        {
          name: icon,
          size: regular && 24 || medium && 18 || small && 16 || 16,
          ...iconProps
        }
      )
    }
  );
}
var ButtonIcon_default = ButtonIcon;

// src/components/atoms/Button/Button.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");
var getButtonHeight = ({ regular, medium, small }) => regular && 40 || medium && 32 || small && 24 || 40;
var getScale = ({ regular, medium, small }) => regular && 3 || medium && 2 || small && 1 || 3;
var variationsStyle = import_styled_components15.css`
  ${(props) => {
  const { theme, variation = "primary", colorVariation } = props;
  const { color: color2, outlineColor, hoverColor } = getButtonColors(props);
  const variations = {
    primary: import_styled_components15.css`
        background-color: ${color2};
        border: 1px solid ${color2};
        color: ${theme.colors.white};
        &:hover {
          background-color: ${hoverColor};
          border: 1px solid ${hoverColor};
          & p {
            color: ${colorVariation === "light" ? color2 : "inherit"};
          }
        }
        &:disabled {
          background-color: ${theme.colors.n60};
          border: 1px solid ${theme.colors.n60};
          cursor: not-allowed;
          color: ${theme.colors.white};
          & p {
            color: ${theme.colors.white};
          }
        }
        & p {
          color: ${colorVariation === "light" ? theme.colors.b50 : theme.colors.white};
        }
      `,
    outline: import_styled_components15.css`
        background-color: transparent;
        border: 1px solid ${color2};
        color: ${color2};
        &:hover {
          background-color: ${colorVariation === "light" ? hoverColor : outlineColor};
        }
        &:disabled {
          color: ${theme.colors.n60};
          border: 1px solid ${theme.colors.n60};
          cursor: not-allowed;
          & p {
            color: ${theme.colors.n60};
          }
        }
        & p {
          color: ${color2};
        }
      `,
    flat: import_styled_components15.css`
        background-color: transparent;
        color: ${color2};
        &:hover {
          background-color: ${outlineColor};
          color: ${color2};
          & p {
            color: ${color2};
          }
        }
        &:disabled {
          color: ${theme.colors.n60};
          cursor: not-allowed;
          & p {
            color: ${theme.colors.n60};
          }
        }
        & p {
          color: ${color2};
        }
      `
  };
  return variations[variation] || "";
}}
`;
var roundStyle = import_styled_components15.css`
  border-radius: 50%;
`;
var ButtonStyle = import_styled_components15.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  ${textStyle}
  ${boxStyle}
  display: flex;
  align-items: center;
  justify-content: ${({ contentCentered }) => contentCentered ? "center" : "flex-start"};
  ${variationsStyle}
  ${({ theme }) => `border-radius:${2 * theme.space}px;`}
  ${({ round: round2 }) => round2 ? roundStyle : ""}
  border-radius: ${({ borderRadius }) => borderRadius}px;
  padding: ${({ theme, round: round2, square, ...props }) => round2 || square ? "unset" : `${theme.space}px ${theme.space * (1 + getScale(props))}px`};
`;
var ContentContainer = (0, import_styled_components15.default)(Flex_default)`
  max-width: 100%;
  visibility: ${({ isLoading }) => isLoading ? "collapse" : "inherit"};
  justify-content: ${({ contentCentered }) => contentCentered ? "center" : "flex-start"};
`;
var TextLabel = (0, import_styled_components15.default)(Text_default)`
  line-height: normal;
  font-size: inherit;
`;
function Button({
  children,
  w,
  h,
  square,
  variation = "primary",
  icon,
  iconProps,
  iconRight,
  iconRightProps,
  round: round2,
  regular,
  medium,
  small,
  onClick,
  isLoading,
  contentCentered = true,
  colorVariation,
  className,
  textLabelClassName,
  ...args
}) {
  const buttonSizes = { regular, medium, small };
  const height = h || getButtonHeight(buttonSizes);
  return /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)(
    ButtonStyle,
    {
      w: square || round2 ? height : w,
      h: height,
      square,
      variation,
      round: round2,
      icon,
      onClick,
      contentCentered,
      colorVariation,
      sm: small,
      className,
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime25.jsxs)(
          ContentContainer,
          {
            alignItems: "center",
            contentCentered,
            isLoading,
            children: [
              icon && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
                ButtonIcon_default,
                {
                  left: true,
                  icon,
                  iconProps,
                  hasContent: !!children,
                  ...buttonSizes
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(TextLabel, { ellipsis: true, className: textLabelClassName, children }),
              iconRight && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
                ButtonIcon_default,
                {
                  right: true,
                  icon: iconRight,
                  iconProps: iconRightProps,
                  hasContent: !!children,
                  ...buttonSizes
                }
              )
            ]
          }
        ),
        isLoading && /* @__PURE__ */ (0, import_jsx_runtime25.jsx)(
          Spinner_default,
          {
            pos: "absolute",
            color: `${colorVariation === "light" ? "#004c87" : "inherit"}`,
            size: regular && 20 || medium && 15 || small && 14 || 20
          }
        )
      ]
    }
  );
}
var Button_default = Button;

// src/components/molecules/DashboardBanner/DashboardBanner.styles.ts
var BannerContainer2 = (0, import_styled_components16.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
`;
var PaginationButton = (0, import_styled_components16.default)(Button_default)`
  background-color: ${({ background }) => background};
  color: ${({ color: color2 }) => color2};
  & p {
    color: ${({ color: color2 }) => color2};
  }

  :hover:not(:disabled) {
    background-color: ${({ background }) => background};
  }
`;
var PaginationDot = (0, import_styled_components16.default)(Box_default)`
  cursor: pointer;
  border-radius: 100%;
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b40 : theme.colors.b20};
`;
var ActionButton = (0, import_styled_components16.default)(Box_default)`
  cursor: pointer;

  p {
    white-space: nowrap;
  }
`;

// src/components/atoms/Banner/Banner.tsx
var import_styled_components17 = require("styled-components");
var import_react_i18next5 = require("react-i18next");
var import_jsx_runtime26 = require("react/jsx-runtime");
function Banner({
  message,
  type,
  onViewClick,
  onDismissClick,
  submitButtonLabel,
  ...args
}) {
  const theme = (0, import_styled_components17.useTheme)();
  const { t } = (0, import_react_i18next5.useTranslation)("pages");
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { background, color: color2 } = BANNER_OPTIONS[type || "success" /* SUCCESS */];
  return /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(
    BannerContainer,
    {
      w: "100%",
      p: 3,
      backgroundColor: background,
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      justifyContent: isMobile ? "center" : "space-between",
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(Text_default, { color: color2, sm: true, semibold: true, children: message }),
        /* @__PURE__ */ (0, import_jsx_runtime26.jsxs)(Flex_default, { alignItems: "center", mt: [3, 0, 0, 0], children: [
          onViewClick && /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            ActionButton,
            {
              mr: 3,
              ml: [0, 3, 3, 3],
              onClick: () => onViewClick(),
              h: "fit-content",
              children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(Text_default, { color: color2, children: submitButtonLabel || t("dashboardPage.banner.view") })
            }
          ),
          onDismissClick && /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
            ActionButton,
            {
              onClick: () => onDismissClick(),
              h: "fit-content",
              children: /* @__PURE__ */ (0, import_jsx_runtime26.jsx)(
                Text_default,
                {
                  color: type === "warning" /* WARNING */ ? theme.colors.white : theme.colors.n70,
                  children: t("dashboardPage.banner.dismiss")
                }
              )
            }
          )
        ] })
      ]
    }
  );
}
var Banner_default = Banner;

// src/components/atoms/ButtonGroups/ButtonGroups.tsx
var import_styled_components18 = __toESM(require("styled-components"));
var orientationStyle = import_styled_components18.css`
  ${({ orientation }) => {
  const variations = {
    horizontal: import_styled_components18.css`
        &:last-child {
          border-right-width: 1px;
          border-top-right-radius: ${({ theme }) => `${2 * theme.space}px;`}
          border-bottom-right-radius: ${({ theme }) => `${2 * theme.space}px;`}
        }
        &:first-child {
          border-right-width: 1px;
          border-top-left-radius: ${({ theme }) => `${2 * theme.space}px;`}
          border-bottom-left-radius: ${({ theme }) => `${2 * theme.space}px;`}
        }
      `,
    vertical: import_styled_components18.css`
        &:first-child {
          border-bottom-width: 1px;
          border-top-right-radius: ${({ theme }) => `${2 * theme.space}px;`}
          border-top-left-radius: ${({ theme }) => `${2 * theme.space}px;`}
        }
        &:last-child {
          border-top-width: 1px;
          border-bottom-left-radius:   ${({ theme }) => `${2 * theme.space}px;`}
          border-bottom-right-radius:   ${({ theme }) => `${2 * theme.space}px;`}
        }
      `
  };
  return variations[orientation] || "";
}}
`;
var ButtonGroups = (0, import_styled_components18.default)(Flex_default)`
  border-radius: ${({ theme }) => `${2 * theme.space}px;`} 
  & button {
    border-right-width: 0;
    border-radius: 0;
    ${orientationStyle}
  }
`;
var ButtonGroups_default = ButtonGroups;

// src/components/atoms/Form/Form/Form.tsx
var import_styled_components51 = __toESM(require("styled-components"));

// src/components/atoms/Form/Input/Input.tsx
var import_react24 = __toESM(require("react"));
var import_styled_components19 = require("styled-components");
var import_jsx_runtime27 = require("react/jsx-runtime");
var Input = import_react24.default.forwardRef(
  ({
    children,
    disabled,
    icon,
    iconRight,
    iconRightProps,
    iconLeftProps,
    w = "inherit",
    onClick,
    ...args
  }, forwardRef4) => {
    const theme = (0, import_styled_components19.useTheme)();
    const pl = icon ? 9 : 2;
    const pr = iconRight ? 9 : 2;
    const width = typeof w === "number" ? w - theme.space * pl - theme.space * pr : w;
    return /* @__PURE__ */ (0, import_jsx_runtime27.jsxs)(BoxStyle, { onClick, w, children: [
      icon && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
        IconStyle,
        {
          isPointer: Boolean(iconRightProps?.onClick),
          size: 16,
          ...iconLeftProps ? iconLeftProps : {},
          name: icon
        }
      ),
      iconRight && /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
        IconRightStyle,
        {
          isPointer: Boolean(iconRightProps?.onClick),
          size: 16,
          ...iconRightProps ? iconRightProps : {},
          name: iconRight
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime27.jsx)(
        InputStyle,
        {
          p: 2,
          disabled,
          ...args,
          pl,
          pr,
          w: width,
          ref: forwardRef4
        }
      )
    ] });
  }
);
var Input_default = Input;

// src/components/atoms/Form/Label/Label.tsx
var import_styled_components20 = __toESM(require("styled-components"));
var import_jsx_runtime28 = require("react/jsx-runtime");
var LabelStyle = import_styled_components20.default.label`
  ${textStyle};
  color: ${({ color: color2, theme }) => color2 || theme.colors.n80};
  width: 100%;
`;
function Label({ children, sm = true, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime28.jsxs)(LabelStyle, { sm, ...args, children: [
    children,
    args.required && "*"
  ] });
}
var Label_default = Label;

// src/components/atoms/Form/Select/Select.tsx
var import_react27 = require("react");
var import_react_select2 = __toESM(require("react-select"));
var import_async = __toESM(require("react-select/async"));
var import_react_i18next6 = require("react-i18next");
var import_styled_components26 = require("styled-components");
var import_lodash5 = require("lodash");

// src/components/atoms/Form/Select/components/Menu.tsx
var import_react26 = require("react");
var import_styled_components24 = __toESM(require("styled-components"));

// src/components/atoms/Devider/Devider.tsx
var import_styled_components21 = __toESM(require("styled-components"));
var Devider = (0, import_styled_components21.default)(Box_default)`
  ${({ size = 1, orientation = "horizontal", theme, color: color2 }) => `
    border-bottom: ${orientation === "horizontal" ? size : 0}px solid  ${color2 || theme.colors.n20};
    border-right: ${orientation === "vertical" ? size : 0}px solid  ${color2 || theme.colors.n20};
  `}
`;
var Devider_default = Devider;

// src/components/atoms/Form/Checkbox/Checkbox.tsx
var import_react25 = require("react");
var import_styled_components23 = require("styled-components");

// src/components/atoms/Form/Checkbox/Checkbox.styles.ts
var import_styled_components22 = __toESM(require("styled-components"));
var disabledStyles = import_styled_components22.css`
  cursor: not-allowed;
  border: 1px solid ${({ theme }) => theme.colors.n50};
  background: ${({ theme }) => theme.colors.n20};
  :hover {
    border: 1px solid ${({ theme }) => theme.colors.n50};
  }
`;
var checkedStyles = import_styled_components22.css`
  background: ${({ theme }) => theme.colors.b50};
  border: none;
  :hover {
    background: ${({ theme }) => theme.colors.b50Hover};
  }
`;
var checkedDisabledStyles = import_styled_components22.css`
  background: ${({ theme }) => theme.colors.n60};
  border: none;
  :hover {
    background: ${({ theme }) => theme.colors.n60};
    border: none;
  }
`;
var CheckboxWrapper = (0, import_styled_components22.default)(Flex_default)`
  cursor: pointer;
`;
var StyledCheckbox = (0, import_styled_components22.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.n60};
  background: ${({ theme }) => theme.colors.white};

  :hover {
    border-color: ${({ theme }) => theme.colors.n70};
  }

  ${({ disabled }) => disabled && disabledStyles}
  ${({ checked }) => checked && checkedStyles}
  ${({ checked, disabled }) => checked && disabled && checkedDisabledStyles}  
  ${stateStyle}
`;
var StyledLabel = (0, import_styled_components22.default)(Text_default)`
  white-space: nowrap;
  color: ${({ theme, disabled }) => disabled ? theme.colors.n60 : theme.colors.n90};
`;

// src/components/atoms/Form/Checkbox/Checkbox.tsx
var import_jsx_runtime29 = require("react/jsx-runtime");
var Checkbox = ({
  disabled = false,
  label,
  checked = false,
  onChange,
  $errorType,
  size,
  ...args
}) => {
  const [isChecked, setIsChecked] = (0, import_react25.useState)(checked);
  const theme = (0, import_styled_components23.useTheme)();
  const onClick = (e) => {
    e.stopPropagation();
    const newIsChecked = !isChecked;
    if (!disabled) {
      setIsChecked(newIsChecked);
      if (onChange) {
        onChange(newIsChecked);
      }
    }
  };
  (0, import_react25.useEffect)(() => {
    setIsChecked(checked);
  }, [checked]);
  return /* @__PURE__ */ (0, import_jsx_runtime29.jsxs)(CheckboxWrapper, { alignItems: "center", onClick, ...args, "data-testid": "checkbox", children: [
    /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(
      StyledCheckbox,
      {
        mr: label ? 2 : 0,
        alignItems: "center",
        justifyContent: "center",
        checked: isChecked,
        disabled,
        $errorType,
        w: size || [18, 18, 24, 24],
        h: size || [18, 18, 24, 24],
        children: isChecked && /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(Icon_default, { size: [12, 12, 14, 14], name: "check", color: theme.colors.white })
      }
    ),
    label && /* @__PURE__ */ (0, import_jsx_runtime29.jsx)(StyledLabel, { disabled, children: label })
  ] });
};
var Checkbox_default = Checkbox;

// src/components/atoms/Form/Select/components/Menu.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");
var Container = (0, import_styled_components24.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 8px 24px -6px rgba(0, 0, 0, 0.09), 0px 0px 1px rgba(0, 0, 0, 0.4);
  border-radius: ${({ theme }) => theme.space * 3}px;
  overflow-x: ${({ menuFixedWidth }) => menuFixedWidth ? "hidden" : "auto"};
  @media ${({ theme }) => theme.devices.mobile} {
    min-width: 160px;
    max-width: 100%;
  }
`;
var InputContainer = (0, import_styled_components24.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  top: 0;
`;
var inputCSS = import_styled_components24.css`
  border: unset;
  &:hover {
    border: unset;
    box-shadow: unset;
  }
  &:focus {
    border: unset;
    box-shadow: unset;
  }
`;
var Menu = ({
  setSearchSlug,
  searchSlug,
  isSearchable,
  children,
  selectInputRef,
  inputPlaceholder,
  menuFixedWidth,
  isSelectAll,
  onSelectAll,
  isSelected,
  ...rest
}) => {
  const inputRef = (0, import_react26.useRef)(null);
  const theme = (0, import_styled_components24.useTheme)();
  (0, import_react26.useEffect)(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [searchSlug]);
  return /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(Container, { menuFixedWidth, flexDirection: "column", ...rest, children: [
    isSearchable && /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(InputContainer, { w: "100%", flexDirection: "column", pos: "sticky", children: [
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(
        Input_default,
        {
          w: "100%",
          h: 48,
          icon: "search",
          iconLeftProps: {
            color: theme.colors.n200,
            size: 24
          },
          ref: inputRef,
          value: searchSlug,
          placeholder: inputPlaceholder,
          onChange: (e) => {
            setSearchSlug(e.target.value);
            if (selectInputRef.current) {
              const valueSetter = Object.getOwnPropertyDescriptor(
                selectInputRef.current,
                "value"
              )?.set;
              const prototype = Object.getPrototypeOf(selectInputRef.current);
              const prototypeValueSetter = Object.getOwnPropertyDescriptor(
                prototype,
                "value"
              )?.set;
              if (valueSetter && valueSetter !== prototypeValueSetter) {
                prototypeValueSetter?.call(selectInputRef.current, e.target.value);
              } else {
                valueSetter?.call(selectInputRef.current, e.target.value);
              }
              selectInputRef.current.dispatchEvent(new Event("input", { bubbles: true }));
            }
          },
          css: inputCSS
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Devider_default, { w: "100%" })
    ] }),
    isSelectAll && /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(import_jsx_runtime30.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime30.jsxs)(Flex_default, { px: 3, py: 2, alignItems: "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Checkbox_default, { size: 18, mr: 2, onChange: onSelectAll, checked: isSelected }),
        /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Text_default, { children: "Select all" })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Devider_default, { w: "100%" })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime30.jsx)(Flex_default, { flexDirection: "column", w: "100%", children })
  ] });
};
var Menu_default = Menu;

// src/components/atoms/Form/Select/components/SelectOption.tsx
var import_react_select = require("react-select");
var import_styled_components25 = __toESM(require("styled-components"));
var import_jsx_runtime31 = require("react/jsx-runtime");
var { Option } = import_react_select.components;
var TextContainer = (0, import_styled_components25.default)(Flex_default)`
  flex-grow: 0;
  overflow: hidden;
`;
var SelectOption = ({
  data,
  setValue,
  innerProps,
  isSelected,
  isMulti,
  closeDropdown,
  withCheckbox,
  ...props
}) => {
  const theme = (0, import_styled_components25.useTheme)();
  const { label } = data;
  return /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
    Option,
    {
      data,
      innerProps: {
        ...innerProps,
        ...!isMulti ? {
          onClick: () => {
            if (!props.isDisabled) {
              setValue(data, "select-option");
              closeDropdown();
            }
          }
        } : {}
      },
      setValue,
      isSelected,
      isMulti,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime31.jsxs)(Flex_default, { flex: 1, flexDirection: "row", alignItems: "center", children: [
        withCheckbox && isMulti && /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(Flex_default, { mr: 2.5, children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
          Checkbox_default,
          {
            size: 18,
            onClick: innerProps.onClick,
            checked: isSelected,
            disabled: props.isDisabled
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(TextContainer, { overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime31.jsx)(
          Text_default,
          {
            className: "select__option__value",
            ellipsis: true,
            ...props.isDisabled && {
              color: theme.colors.n60,
              cursor: "not-allowed"
            },
            children: label
          }
        ) })
      ] })
    }
  );
};
var SelectOption_default = SelectOption;

// src/components/atoms/Form/Select/Select.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");
var { Input: Input2, SingleValue, MenuPortal, MenuList, ClearIndicator } = import_react_select2.components;
var ChevronUp = () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: "chevronUp", size: 24 });
var ChevronDown = () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: "chevronDown", size: 24 });
var ReactSelect = ({
  isClearable = false,
  $errorType,
  valuePrefix = "",
  onChanged,
  options,
  disabled,
  value,
  defaultValue,
  isMulti = false,
  withCheckbox = true,
  isAsync = false,
  components: components7 = {},
  placeholder,
  isSearchable = true,
  leftIcon,
  leftIconColor,
  onMouseDown,
  inputValue,
  onMenuClose,
  loadOptions,
  inputPlaceholder,
  menuPortalTarget,
  menuPlacementHorizontal,
  menuFixedWidth = true,
  menuPosition = "absolute",
  menuPortalZIndex = 150,
  onClear,
  styles,
  w,
  h,
  disablePortalTarget,
  defaultOptions: defaultOptions2,
  isButtonSelect,
  strictMenuWidth,
  isSelectAll,
  valueContainerMaxWidth,
  buttonSelectType = "badge",
  ...props
}) => {
  const { t } = (0, import_react_i18next6.useTranslation)("common", { keyPrefix: "labels" });
  const theme = (0, import_styled_components26.useTheme)();
  const [isOpen, setIsOpen] = (0, import_react27.useState)(false);
  const [selectedValue, setSelectedValue] = (0, import_react27.useState)(null);
  const [searchSlug, setSearchSlug] = (0, import_react27.useState)("");
  const boxProps = props;
  const [isClosable, setIsClosable] = (0, import_react27.useState)(false);
  const ref = (0, import_react27.useRef)(null);
  const refSelect = (0, import_react27.useRef)(null);
  const inputRef = (0, import_react27.useRef)(null);
  const menuPortalScrollTopRef = (0, import_react27.useRef)(0);
  const containerRef = (0, import_react27.useRef)(null);
  const [isAllOptionsSelected, setIsAllOptionsSelected] = (0, import_react27.useState)(false);
  const getSelectValue = (0, import_react27.useCallback)(
    (currentValue) => {
      if (currentValue === void 0) {
        return selectedValue;
      }
      let _options = options;
      if (!options?.length && Array.isArray(defaultOptions2))
        _options = defaultOptions2;
      if (isMulti) {
        return selectedValue || _options?.filter(
          (item) => (currentValue || []).includes(item.value)
        );
      }
      return _options?.find((item) => item.value === currentValue);
    },
    [options, defaultOptions2, selectedValue]
  );
  const selectValue = getSelectValue(value);
  const selectDefaultValue = getSelectValue(defaultValue);
  useOnClickOutside(
    ref,
    (event) => {
      const elemId = event.target?.getAttribute("id");
      const isDropdownOption = elemId?.includes("price-range-option");
      if (isClosable && !isDropdownOption) {
        setIsOpen(false);
        setIsClosable(false);
        onMenuClose && onMenuClose();
      }
    },
    disablePortalTarget
  );
  (0, import_react27.useEffect)(() => {
    if (defaultValue === void 0 || value === void 0) {
      setSelectedValue(null);
    }
  }, [defaultValue, value]);
  (0, import_react27.useEffect)(() => {
    if (isOpen) {
      setIsClosable(true);
    }
  }, [isOpen]);
  const handleSelectValues = (record) => {
    setSelectedValue(record);
    refSelect.current?.blur();
    if (onChanged) {
      if (isMulti) {
        return onChanged(
          "",
          record.map((item) => item.value)
        );
      }
      onChanged(record?.value);
      if ((0, import_lodash5.isNil)(record?.value)) {
        setSelectedValue(null);
      }
    }
  };
  const Select2 = isAsync ? import_async.default : import_react_select2.default;
  const {
    Option: OverwriteOption,
    DropdownIndicator: OverwriteDropdownIndicator,
    ...overwriteComponents
  } = components7;
  (0, import_react27.useLayoutEffect)(() => {
    const onMenuPortalScroll = (e) => {
      menuPortalScrollTopRef.current = e.target.scrollTop;
    };
    if (isOpen && isMulti) {
      setTimeout(() => {
        if (ref.current?.firstChild?.firstChild) {
          ref.current.firstChild.firstChild.addEventListener("scroll", onMenuPortalScroll);
        }
      });
    }
    return () => {
      if (ref.current?.firstChild?.firstChild) {
        ref.current.firstChild.firstChild.removeEventListener("scroll", onMenuPortalScroll);
      }
    };
  }, [ref, isOpen, isMulti, selectedValue]);
  (0, import_react27.useEffect)(() => {
    if (isMulti) {
      setTimeout(() => {
        if (ref.current?.firstChild?.firstChild) {
          ref.current.firstChild.firstChild.scrollTop = menuPortalScrollTopRef?.current || 0;
        }
      });
    }
  }, [selectedValue, isMulti]);
  const isSelectAllOption = (0, import_react27.useMemo)(
    () => isMulti && (value || defaultValue) && (options || defaultOptions2).every(
      (item) => (value || defaultValue)?.includes(item.value)
    ),
    [options, value, defaultValue]
  );
  const placeholderValue = (0, import_react27.useMemo)(() => {
    if (!disabled || !selectValue || Array.isArray(selectValue) && !selectValue?.length)
      return placeholder;
    if (isMulti)
      return selectValue.map((sv) => sv?.label).join(", ");
    return selectValue?.label;
  }, [options, selectedValue, isMulti]);
  const onSelectAll = (0, import_react27.useCallback)(
    (selected) => {
      setIsAllOptionsSelected(selected);
      setSelectedValue(selected ? options || defaultOptions2 : []);
      if (onChanged) {
        onChanged(
          "",
          selected ? (options || (Array.isArray(defaultOptions2) ? defaultOptions2 : [])).map(
            (item) => item.value
          ) : []
        );
      }
    },
    [options, defaultOptions2, onChanged]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(
    StyledSelectWrapper,
    {
      leftIcon,
      ref: containerRef,
      alignItems: "center",
      isMulti,
      $errorType,
      isButtonSelect,
      onMouseDown: (e) => {
        if (!disabled) {
          if (onMouseDown) {
            onMouseDown(e);
          }
          setIsOpen(true);
        }
      },
      w,
      h,
      ...boxProps,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          Select2,
          {
            ref: refSelect,
            filterOption: (0, import_react_select2.createFilter)({ matchFrom: "any", stringify: (option) => `${option.label}` }),
            options,
            menuPortalTarget: disablePortalTarget ? void 0 : menuPortalTarget || document.body,
            menuPlacement: "auto",
            menuPosition,
            placeholder: placeholderValue,
            ...props,
            isMulti,
            isClearable,
            defaultValue: selectDefaultValue,
            value: !disabled ? selectValue : null,
            inputValue: inputValue || searchSlug,
            classNamePrefix: "select",
            isDisabled: disabled,
            onChange: handleSelectValues,
            closeMenuOnSelect: !isMulti,
            hideSelectedOptions: false,
            styles: {
              menuPortal: (base) => ({
                ...base,
                zIndex: menuPortalZIndex,
                ...menuPlacementHorizontal === "right" ? { display: "flex", justifyContent: "end" } : {}
              }),
              valueContainer: (base) => ({
                ...base,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: valueContainerMaxWidth
              }),
              ...styles
            },
            menuIsOpen: isOpen,
            onFocus: () => !disabled && setIsOpen(true),
            isSearchable,
            components: {
              DropdownIndicator: () => {
                if (OverwriteDropdownIndicator) {
                  return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(OverwriteDropdownIndicator, { isOpen });
                }
                return isOpen ? /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(ChevronUp, {}) : /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(ChevronDown, {});
              },
              ClearIndicator: ({ innerProps, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
                ClearIndicator,
                {
                  innerProps: { ...innerProps, onMouseDown: onClear || innerProps.onMouseDown },
                  ...props2,
                  children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: "close", size: 20, color: theme.colors.r20 })
                }
              ),
              MenuList: ({ children, ...props2 }) => {
                return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(MenuList, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
                  Menu_default,
                  {
                    w: strictMenuWidth ? containerRef.current?.clientWidth : void 0,
                    menuFixedWidth,
                    isSearchable,
                    searchSlug,
                    setSearchSlug,
                    selectInputRef: inputRef,
                    inputPlaceholder,
                    isSelectAll,
                    isSelected: isAllOptionsSelected || isSelectAllOption,
                    onSelectAll,
                    children
                  }
                ) });
              },
              MenuPortal: ({ children, innerProps, ...rest }) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(MenuPortal, { innerProps: { ...innerProps, ref }, ...rest, children }),
              Option: OverwriteOption ? (props2) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
                OverwriteOption,
                {
                  ...props2,
                  closeDropdown: () => {
                    setIsOpen(false);
                    setIsClosable(false);
                    setSearchSlug("");
                  }
                }
              ) : (props2) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
                SelectOption_default,
                {
                  ...props2,
                  withCheckbox,
                  closeDropdown: () => {
                    setIsOpen(false);
                    setIsClosable(false);
                    setSearchSlug("");
                  }
                }
              ),
              Input: (props2) => {
                return /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
                  Input2,
                  {
                    ...props2,
                    value: inputValue ? props2.value : "",
                    innerRef: (ref2) => {
                      if (props2.innerRef) {
                        props2.innerRef(ref2);
                      }
                      if (isAsync) {
                        inputRef.current = ref2;
                      }
                    }
                  }
                );
              },
              MultiValue: ({ data, index: index2 }) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(import_jsx_runtime32.Fragment, { children: `${index2 !== 0 ? " / " : ""}${data.label}` }),
              SingleValue: (props2) => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(SingleValue, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime32.jsxs)(Text_default, { ellipsis: true, children: [
                valuePrefix,
                " ",
                props2.data.label
              ] }) }),
              LoadingIndicator: () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Spinner_default, { size: 14 }),
              NoOptionsMessage: () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Flex_default, { h: 42, w: "100%", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Text_default, { color: theme.colors.n70, children: t`noOptions` }) }),
              LoadingMessage: () => /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Flex_default, { h: 42, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Text_default, { color: theme.colors.n70, children: t`loading` }) }),
              ...overwriteComponents
            },
            loadOptions,
            defaultOptions: defaultOptions2
          }
        ),
        leftIcon && /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(StyledLeftIconContainer, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Icon_default, { name: leftIcon, color: leftIconColor, size: 24 }) }),
        isButtonSelect && /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Box_default, { pos: "absolute", w: w || "100%", children: buttonSelectType === "badge" ? /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          StyledBadge,
          {
            h: boxProps.h || 40,
            title: (placeholder || "").toString(),
            sm: false,
            py: 2,
            px: 4,
            w: "100%",
            whiteSpace: "nowrap",
            iconRight: isOpen ? "arrowUp" : "arrowDown",
            cursor: "pointer"
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(
          Button_default,
          {
            variation: "outline",
            w,
            iconRight: isOpen ? "arrowUp" : "arrowDown",
            iconRightProps: { size: 20 },
            children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Box_default, { w: w ? +w - 50 : "100%", overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime32.jsx)(Text_default, { color: "inherit", ellipsis: true, children: placeholder }) })
          }
        ) })
      ]
    }
  );
};
var Select_default = ReactSelect;

// src/components/atoms/Form/InputPassword/InputPassword.tsx
var import_react28 = require("react");
var import_jsx_runtime33 = require("react/jsx-runtime");
function InputPassword({ onChange, value, ...args }) {
  const inputRef = (0, import_react28.useRef)(null);
  const [isShow, setIsShow] = (0, import_react28.useState)(false);
  const [isWithValue, setIsWithValue] = (0, import_react28.useState)(false);
  const onIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsShow(!isShow);
    if (inputRef.current) {
      setTimeout(() => {
        if (inputRef.current) {
          const end = inputRef.current.value.length || 0;
          inputRef.current.setSelectionRange(end, end);
          inputRef.current.focus();
        }
      }, 0);
    }
  };
  const onChangeSpy = (e) => {
    setIsWithValue(Boolean(e.target.value.length));
    if (onChange) {
      onChange(e);
    }
  };
  const iconName = isShow ? "hide" : "show";
  return /* @__PURE__ */ (0, import_jsx_runtime33.jsx)(
    Input_default,
    {
      ref: inputRef,
      type: isShow ? "text" : "password",
      iconRight: value || isWithValue ? iconName : void 0,
      value,
      iconRightProps: value || isWithValue ? {
        onClick: onIconClick
      } : void 0,
      onChange: onChangeSpy,
      ...args
    }
  );
}
var InputPassword_default = InputPassword;

// src/components/atoms/Form/InputPrice/InputPrice.tsx
var import_react29 = __toESM(require("react"));
var import_dash_common10 = require("dash-common");
var import_react_text_mask = __toESM(require("react-text-mask"));
var import_text_mask_addons = require("text-mask-addons");
var import_lodash6 = require("lodash");
var import_jsx_runtime34 = require("react/jsx-runtime");
var defaultMaskOptions = {
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: import_dash_common10.DashValidation.CurrencyDecimalLimit,
  // how many digits allowed after the decimal
  allowNegative: false,
  allowLeadingZeroes: false
};
var InputPrice = import_react29.default.forwardRef(
  ({
    onChangeValue,
    value,
    maskOptions = {},
    innerRef,
    onChange,
    disabled,
    label = "max",
    anyPrice = false,
    ...args
  }, forwardRef4) => {
    const currencyMask = (0, import_text_mask_addons.createNumberMask)({
      prefix: "$",
      ...defaultMaskOptions,
      ...maskOptions
    });
    const getMask = () => {
      if (disabled)
        return false;
      if (label === "max" && value === "Any Price")
        return false;
      return currencyMask;
    };
    const getValue = () => {
      if (anyPrice)
        return "Any Price";
      if (label === "max" && value === "Any Price")
        return "Any Price";
      return value;
    };
    const getNewValue = (v) => {
      if ((0, import_lodash6.isNil)(v))
        return void 0;
      if (v === "Any Price")
        return "Any Price";
      const newValue = parseFloat(v.replace(/[^0-9.]/g, ""));
      if (isNaN(newValue))
        return void 0;
      return newValue;
    };
    return /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
      import_react_text_mask.default,
      {
        ref: (_ref) => {
          if (forwardRef4) {
            forwardRef4.current = _ref?.inputElement;
          }
          if (innerRef) {
            innerRef.current = _ref;
          }
        },
        mask: getMask(),
        disabled,
        render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime34.jsx)(
          Input_default,
          {
            ref,
            ...props,
            ...args,
            value: getValue(),
            onChange: (event) => {
              const newValue = getNewValue(event.target.value);
              if (onChangeValue) {
                onChangeValue(newValue);
              }
              props.onChange && props.onChange(event);
              onChange && onChange(event);
            }
          }
        )
      }
    );
  }
);
var InputPrice_default = InputPrice;

// src/components/atoms/Form/Group/Group.tsx
var import_styled_components27 = __toESM(require("styled-components"));
var Group = (0, import_styled_components27.default)(Box_default)``;
var Group_default = Group;

// src/components/atoms/Form/Feedback/Feedback.tsx
var import_styled_components28 = __toESM(require("styled-components"));
var import_jsx_runtime35 = require("react/jsx-runtime");
var stateStyle2 = import_styled_components28.css`
  ${({ theme, $errorType }) => {
  const states = {
    ["info" /* Info */]: import_styled_components28.css`
        color: ${theme.colors.b50};
      `,
    ["valid" /* Valid */]: import_styled_components28.css`
        color: ${theme.colors.g20};
      `,
    ["invalid" /* Invalid */]: import_styled_components28.css`
        color: ${theme.colors.r20};
      `
  };
  return $errorType ? states[$errorType] : "display: none;";
}}
`;
var FeedbackStyle = import_styled_components28.default.div`
  ${boxStyle};
  ${textStyle};
  ${stateStyle2};
  width: 100%;
`;
function Label2({ children, sm = true, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime35.jsx)(FeedbackStyle, { sm, ...args, children });
}
var Feedback_default = Label2;

// src/components/atoms/Form/InputSearch/InputSearch.tsx
var import_react30 = __toESM(require("react"));
var import_styled_components30 = require("styled-components");

// src/components/atoms/Form/InputSearch/InputSearch.styles.tsx
var import_styled_components29 = __toESM(require("styled-components"));
var SearchContainer = (0, import_styled_components29.default)(Flex_default)`
  .clear-icon {
    border: 1px solid ${({ theme }) => theme.colors.b50};
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
  }
`;

// src/components/atoms/Form/InputSearch/InputSearch.tsx
var import_jsx_runtime36 = require("react/jsx-runtime");
var InputSearch = import_react30.default.forwardRef(({
  onChange,
  onClear,
  value,
  placeholder,
  css: css30,
  inputVariation,
  ...args
}, forwardRef4) => {
  const theme = (0, import_styled_components30.useTheme)();
  const [isValue, setIsValue] = (0, import_react30.useState)(false);
  const onSearchChange = (event) => {
    setIsValue(!!event.target.value.length);
    if (onChange)
      onChange(event);
  };
  const onClearClick = () => {
    setIsValue(false);
    onClear();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(SearchContainer, { ...args, children: /* @__PURE__ */ (0, import_jsx_runtime36.jsx)(
    Input_default,
    {
      ref: forwardRef4,
      icon: "search",
      inputVariation,
      iconLeftProps: {
        color: isValue ? theme.colors.black : theme.colors.n70,
        size: 24
      },
      ...isValue && {
        iconRight: "close",
        iconRightProps: {
          onClick: onClearClick,
          color: theme.colors.b50,
          className: "clear-icon",
          p: 1
        }
      },
      value,
      onChange: onSearchChange,
      placeholder,
      css: css30
    }
  ) });
});
var InputSearch_default = InputSearch;

// src/components/atoms/Form/InputGroup/InputGroup.tsx
var import_react31 = __toESM(require("react"));
var import_styled_components31 = __toESM(require("styled-components"));
var import_jsx_runtime37 = require("react/jsx-runtime");
var LeftContainer = (0, import_styled_components31.default)(Flex_default)`
  position: absolute;
  cursor: default;
  top: 0;
  bottom: 0;
  margin: auto;
  background-color: ${({ theme }) => theme.colors.n20};
  color: ${({ theme }) => theme.colors.n80};
  height: calc(100% - 2px);
  left: 1px;
  border-top-left-radius: ${({ theme }) => theme.space * 2}px;
  border-bottom-left-radius: ${({ theme }) => theme.space * 2}px;
  border-right: 1px solid ${({ theme }) => theme.colors.n60};
`;
var BoxStyle2 = (0, import_styled_components31.default)(Box_default)`
  position: relative;
  &:hover {
    & > div {
      border-right: 1px solid ${({ theme }) => theme.colors.b40};
    }
  }
  &:has(input:focus) {
    & > div {
      border-right: 1px solid ${({ theme }) => theme.colors.n40};
    }
  }
`;
var InputGroup = import_react31.default.forwardRef(
  ({ children, disabled, w = "inherit", onClick, LeftGroup, ...args }, forwardRef4) => {
    const theme = (0, import_styled_components31.useTheme)();
    const leftContainerWidth = 80;
    const width = typeof w === "number" ? w - leftContainerWidth : w;
    return /* @__PURE__ */ (0, import_jsx_runtime37.jsxs)(BoxStyle2, { onClick, w, children: [
      /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(LeftContainer, { w: leftContainerWidth, children: LeftGroup }),
      /* @__PURE__ */ (0, import_jsx_runtime37.jsx)(
        InputStyle,
        {
          p: 2,
          disabled,
          ...args,
          pl: leftContainerWidth / theme.space + 2,
          w: width,
          ref: forwardRef4
        }
      )
    ] });
  }
);
var InputGroup_default = InputGroup;

// src/components/atoms/Form/InputPhone/InputPhone.tsx
var import_react35 = require("react");
var import_react_text_mask2 = __toESM(require("react-text-mask"));
var import_country_list_with_dial_code_and_flag = require("country-list-with-dial-code-and-flag");

// src/components/atoms/DropDown/DropDown.tsx
var import_react32 = require("react");
var import_styled_components32 = __toESM(require("styled-components"));
var import_jsx_runtime38 = require("react/jsx-runtime");
var import_react33 = require("react");
var Container2 = (0, import_styled_components32.default)(Box_default)`
  display:inline-block;
  cursor: pointer;
  height: inherit;
`;
var ButtonItemStyle = import_styled_components32.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  ${textStyle}
  ${boxStyle}
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  width: max-content;

  ${({ theme, disabled }) => disabled && `
    color: ${theme.colors.n60};
    cursor: not-allowed;
  `}
`;
var StyleButtonLight = (0, import_styled_components32.default)(Button_default)`
    & > div {
      width: 100%;
    }
  `;
function Dropdown({
  Anchor,
  children,
  onToggle,
  variant = "light",
  trigger = "click",
  placement = "auto",
  placementHorizontal = "right",
  items = [],
  optionsStyle = {},
  rerender,
  ...args
}) {
  const id2 = (0, import_react32.useId)();
  const refBox = (0, import_react32.useRef)(null);
  const { isOpen, setIsOpen, refOptions, handlePosition, setConfig, config, setChildren, setItems } = (0, import_react32.useContext)(DropdownContext);
  (0, import_react32.useEffect)(() => {
    setConfig((state) => ({
      ...state,
      id: id2,
      variant,
      trigger,
      optionsStyle
    }));
  }, []);
  useOnClickOutside(refOptions, (e) => {
    if (e.target.matches(".select__option__value"))
      return;
    if (trigger === "click")
      setIsOpen(false);
  });
  const LightContainerItems = () => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Box_default, { children: items.map(({ key, icon, onClick, children: itemChildren, ...rest }) => /* @__PURE__ */ (0, import_react33.createElement)(
    StyleButtonLight,
    {
      w: 124,
      medium: true,
      ...rest,
      variation: "flat",
      minWidth: "unset",
      key,
      icon,
      onClick: (e) => {
        if (onClick) {
          onClick(e);
          setIsOpen(false);
        }
      }
    },
    itemChildren
  )) });
  const DarkContainerItems = () => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Box_default, { children: items.map(({ key, icon, onClick, children: itemChildren, disabled }) => /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(
    ButtonItemStyle,
    {
      px: 4,
      py: 2,
      disabled,
      onClick: (e) => {
        if (!disabled && onClick) {
          onClick(e);
          setIsOpen(false);
        }
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime38.jsxs)("div", { style: { display: "flex", alignItems: "center" }, children: [
        icon && /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Icon_default, { name: icon, mr: 2, size: 22 }),
        itemChildren
      ] })
    },
    key
  )) });
  const ItemsMap = {
    light: LightContainerItems,
    dark: DarkContainerItems
  };
  const Items = ItemsMap[config.variant];
  const handleOpenDropdown = () => {
    setConfig((state) => ({
      ...state,
      id: id2,
      variant,
      trigger,
      optionsStyle
    }));
    if (items.length > 0) {
      setChildren(() => Items);
    } else {
      setItems([]);
      setChildren(() => children);
    }
    setIsOpen(true);
  };
  const thisHandlePosition = (0, import_react32.useCallback)(() => {
    const elemBox = refBox.current;
    const rectBox = elemBox.getBoundingClientRect();
    const elemOptions = refOptions.current;
    const rectOptions = elemOptions.getBoundingClientRect();
    handlePosition({
      rectBox,
      rectOptions,
      placement,
      placementHorizontal,
      newItems: items
    });
  }, [items]);
  (0, import_react32.useEffect)(() => {
    if (isOpen && config.id === id2) {
      handleOpenDropdown();
    }
  }, [rerender]);
  (0, import_react32.useLayoutEffect)(() => {
    if (isOpen && config.id === id2) {
      thisHandlePosition();
    }
  }, [isOpen]);
  const onContainerClick = (e) => {
    e.stopPropagation();
    handleOpenDropdown();
  };
  const containerProps = trigger === "click" || trigger === "none" ? { onClick: onContainerClick } : { onMouseEnter: () => {
    handleOpenDropdown();
    thisHandlePosition();
  } };
  return /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Flex_default, { w: "100%", justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Container2, { ref: refBox, ...containerProps, ...args, children: /* @__PURE__ */ (0, import_jsx_runtime38.jsx)(Anchor, { isOpen: isOpen && config.id === id2, onClick: () => handleOpenDropdown() }) }) });
}
var DropDown_default = Dropdown;

// src/components/atoms/DropDown/DropdownOptions.tsx
var import_react34 = require("react");
var import_styled_components33 = __toESM(require("styled-components"));
var import_lodash7 = require("lodash");
var import_jsx_runtime39 = require("react/jsx-runtime");
var OptionsContainer = (0, import_styled_components33.default)(Box_default)`
  position: absolute;
  z-index: 120;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: white;
  border-radius: ${({ theme }) => theme.space * 2}px;
  overflow-y: auto;
`;
function DropdownOptions() {
  const { refOptions, isOpen, setIsOpen, children, config } = (0, import_react34.useContext)(DropdownContext);
  const contentTypeMap = () => {
    if (!(0, import_lodash7.isNil)(children)) {
      return children({ closeDropdown: () => setIsOpen(false) });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime39.jsx)("div", {});
  };
  const containerProps = config.trigger === "hover" ? { onMouseLeave: () => setIsOpen(false) } : {};
  return /* @__PURE__ */ (0, import_jsx_runtime39.jsx)(
    OptionsContainer,
    {
      ...containerProps,
      style: { display: isOpen ? "flex" : "none", ...config.optionsStyle },
      py: 2,
      ref: refOptions,
      children: contentTypeMap()
    }
  );
}
var DropdownOptions_default = DropdownOptions;

// src/components/atoms/Form/InputPhone/InputPhone.constants.ts
var PhoneInputMask = [
  "(",
  /[1-9]/,
  /\d/,
  /\d/,
  ")",
  " ",
  /\d/,
  /\d/,
  /\d/,
  "-",
  /\d/,
  /\d/,
  /\d/,
  /\d/
];

// src/components/atoms/Form/InputPhone/components/FlagCodeItem.component.tsx
var import_styled_components34 = require("styled-components");
var import_jsx_runtime40 = require("react/jsx-runtime");
var FlagCodeItem = ({ country }) => {
  const theme = (0, import_styled_components34.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime40.jsxs)(Flex_default, { alignItems: "center", justifyContent: "center", h: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Box_default, { ml: 2, children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Text_default, { md: true, children: country.flag }) }),
    /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime40.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.n80, children: country.code }) })
  ] });
};
var FlagCodeItem_component_default = FlagCodeItem;

// src/components/atoms/Form/InputPhone/InputPhone.tsx
var import_jsx_runtime41 = require("react/jsx-runtime");
var countyLists = (0, import_country_list_with_dial_code_and_flag.getList)();
var defaultCounty = (0, import_country_list_with_dial_code_and_flag.findFlagByDialCode)("+1");
var InputPhone = ({ onChangePhoneValue, dialCode, number, ...args }) => {
  const [numberValue, setNumberValue] = (0, import_react35.useState)(number);
  const [selectedCountry, setSelectedCountry] = (0, import_react35.useState)(defaultCounty);
  const [rawEntry, setRawEntry] = (0, import_react35.useState)(number);
  (0, import_react35.useEffect)(() => {
    if (onChangePhoneValue && (numberValue || numberValue === "")) {
      onChangePhoneValue({
        dialCode: selectedCountry.dial_code,
        number: numberValue,
        isUSCodeSelected: selectedCountry.dial_code === defaultCounty.dial_code
      });
    }
  }, [numberValue, selectedCountry, rawEntry]);
  (0, import_react35.useEffect)(() => {
    if (number || number === "") {
      setNumberValue(number);
    }
  }, [number]);
  (0, import_react35.useEffect)(() => {
    if (dialCode) {
      const country = (0, import_country_list_with_dial_code_and_flag.findFlagByDialCode)(dialCode);
      setSelectedCountry(country);
    }
  }, [dialCode]);
  const onItemClick = (0, import_react35.useCallback)(
    (country) => {
      setSelectedCountry(country);
      if (country.dial_code !== selectedCountry.dial_code) {
        setNumberValue("");
      }
    },
    [setSelectedCountry, selectedCountry]
  );
  const items = (0, import_react35.useMemo)(
    () => countyLists.map((country) => ({
      w: 80,
      minHeight: 40,
      key: country.code,
      type: "button",
      children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(FlagCodeItem_component_default, { country }),
      onClick: () => onItemClick(country)
    })),
    []
  );
  return /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
    import_react_text_mask2.default,
    {
      mask: PhoneInputMask,
      value: numberValue,
      guide: false,
      render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
        InputGroup_default,
        {
          ref,
          LeftGroup: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(Flex_default, { h: "inherit", w: "inherit", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(
            DropDown_default,
            {
              placement: "bottom",
              Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime41.jsx)(FlagCodeItem_component_default, { country: selectedCountry }),
              items,
              optionsStyle: {
                maxHeight: "35vh"
              }
            }
          ) }),
          ...props,
          ...args,
          onChange: (event) => {
            const rawValue = event.target.value;
            setRawEntry(rawValue);
            const numericValue = rawValue.replace(/\D+/g, "");
            setNumberValue(numericValue);
          }
        }
      )
    }
  );
};
var InputPhone_default = InputPhone;

// src/components/atoms/Form/FileUpload/FileUpload.tsx
var import_styled_components42 = __toESM(require("styled-components"));

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.tsx
var import_react37 = require("react");
var import_dash_common15 = require("dash-common");

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.tsx
var import_lodash8 = require("lodash");
var import_styled_components37 = require("styled-components");
var import_react_i18next7 = require("react-i18next");
var import_dash_common13 = require("dash-common");

// src/components/atoms/ProgressBar/ProgressBar.styles.tsx
var import_styled_components35 = __toESM(require("styled-components"));
var ProgressContainer = (0, import_styled_components35.default)(Box_default)`
  flex: 1;
  overflow: hidden;
`;
var ProgressLineContainer = (0, import_styled_components35.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;
var Progress = import_styled_components35.default.div`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background-color: ${({ theme }) => theme.colors.b50};
  border-radius: inherit;
  text-align: right;
  transition: width 1s ease-in-out;
`;
var ProgressLabel = (0, import_styled_components35.default)(Box_default)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${textStyle}
  color: ${({ theme, color: color2 }) => color2 || theme.colors.b50};
`;
var ProgressWrapper = (0, import_styled_components35.default)(Flex_default)`
  overflow: hidden;
  flex: 1;
`;

// src/components/atoms/ProgressBar/ProgressBar.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");
function ProgressBar({ progress, label, labelColor, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(ProgressWrapper, { alignItems: "center", ...args, style: { overflow: "hidden", flex: 1 }, children: [
    /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(ProgressContainer, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(ProgressLabel, { title: label, color: labelColor, mb: 1, children: label }),
      /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(ProgressLineContainer, { w: "100%", h: 4, children: /* @__PURE__ */ (0, import_jsx_runtime42.jsx)(Progress, { progress }) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime42.jsxs)(ProgressLabel, { ml: 4, children: [
      progress.toFixed(2),
      "%"
    ] })
  ] });
}
var ProgressBar_default = ProgressBar;

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.constants.ts
var import_dash_common11 = require("dash-common");
var STATUS_TO_ICON_RELATIONS = {
  [import_dash_common11.ProgressTrackingFileStatusesEnum.INITIALIZATION]: "close",
  [import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADING]: "close",
  [import_dash_common11.ProgressTrackingFileStatusesEnum.UPLOADED]: "check",
  [import_dash_common11.ProgressTrackingFileStatusesEnum.ABORTED]: "cancel",
  [import_dash_common11.ProgressTrackingFileStatusesEnum.ERROR]: "close"
};

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.styles.tsx
var import_dash_common12 = require("dash-common");
var import_styled_components36 = __toESM(require("styled-components"));
var iconWrapperStyle = import_styled_components36.css`
  ${({ theme, status }) => {
  const statusStyleRelations = {
    [import_dash_common12.ProgressTrackingFileStatusesEnum.INITIALIZATION]: import_styled_components36.css`
        color: ${theme.colors.b50};
        border: 1px solid ${theme.colors.b50};
        background-color: ${theme.colors.white};
      `,
    [import_dash_common12.ProgressTrackingFileStatusesEnum.UPLOADING]: import_styled_components36.css`
        color: ${theme.colors.b50};
        border: 1px solid ${theme.colors.b50};
        background-color: ${theme.colors.white};
      `,
    [import_dash_common12.ProgressTrackingFileStatusesEnum.UPLOADED]: import_styled_components36.css`
        color: ${theme.colors.g20};
        cursor: default;
      `,
    [import_dash_common12.ProgressTrackingFileStatusesEnum.ABORTED]: import_styled_components36.css`
        color: ${theme.colors.n70};
        cursor: default;
      `,
    [import_dash_common12.ProgressTrackingFileStatusesEnum.ERROR]: import_styled_components36.css`
        color: ${theme.colors.r20};
        border: 1px solid ${theme.colors.r20};
        background-color: ${theme.colors.white};
      `
  };
  return statusStyleRelations[status] || "";
}}
`;
var ItemUploadWrapper = (0, import_styled_components36.default)(Flex_default)`
  overflow: hidden;
  position: relative;
  border-top: ${({ multiple, theme }) => multiple ? `1px solid ${theme.colors.n20}` : "none"};

  ${({ isHovered, theme }) => isHovered && `
    :hover {
      background-color: ${theme.colors.g10};
      & > div > button {
        display: flex;
      }
    }
  `};
`;
var IconWrapper = import_styled_components36.default.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  padding: 7px;
  cursor: pointer;
  margin-right: 16px;
  ${iconWrapperStyle}
`;
var OverflowContainer = (0, import_styled_components36.default)(Flex_default)`
  overflow: hidden;
`;
var FileLabel = (0, import_styled_components36.default)(Text_default)`
  color: ${({ theme, status }) => {
  if (status === import_dash_common12.ProgressTrackingFileStatusesEnum.ERROR)
    return theme.colors.r20;
  if (status === import_dash_common12.ProgressTrackingFileStatusesEnum.UPLOADED)
    return theme.colors.g20;
  return theme.colors.black;
}};
`;
var ClearButton = (0, import_styled_components36.default)(Button_default)`
  display: none;
`;

// src/components/atoms/Form/FileUpload/components/ItemUpload/ItemUpload.tsx
var import_jsx_runtime43 = require("react/jsx-runtime");
function ItemUpload({
  multiple,
  progress,
  filename,
  status,
  messages,
  onAbort,
  onReject,
  onClear
}) {
  const { t, i18n } = (0, import_react_i18next7.useTranslation)(["common", "forms"]);
  const theme = (0, import_styled_components37.useTheme)();
  const isError = multiple && status === import_dash_common13.ProgressTrackingFileStatusesEnum.ERROR;
  const isUploading = multiple && status !== import_dash_common13.ProgressTrackingFileStatusesEnum.UPLOADING;
  const isInitialization = status === import_dash_common13.ProgressTrackingFileStatusesEnum.INITIALIZATION;
  const iconName = STATUS_TO_ICON_RELATIONS[status];
  return /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
    ItemUploadWrapper,
    {
      w: "100%",
      py: status === import_dash_common13.ProgressTrackingFileStatusesEnum.ABORTED || status === import_dash_common13.ProgressTrackingFileStatusesEnum.ERROR ? 4 : 5.5,
      px: 4.25,
      alignItems: "center",
      justifyContent: "space-between",
      isHovered: isUploading && !isInitialization,
      multiple,
      children: /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(Flex_default, { w: "inherit", flex: 1, alignItems: "center", children: [
        isInitialization ? /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Box_default, { mr: 1, children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Spinner_default, {}) }) : /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          IconWrapper,
          {
            status,
            onClick: (e) => {
              e.stopPropagation();
              if (isError) {
                onReject();
              }
              if (status === import_dash_common13.ProgressTrackingFileStatusesEnum.UPLOADING) {
                onAbort();
              }
            },
            children: /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Icon_default, { name: iconName, size: 16 })
          }
        ),
        isInitialization || status === import_dash_common13.ProgressTrackingFileStatusesEnum.UPLOADING ? /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          ProgressBar_default,
          {
            label: filename,
            progress,
            labelColor: multiple ? theme.colors.black : theme.colors.b50
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime43.jsxs)(OverflowContainer, { alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(FileLabel, { ellipsis: true, title: filename, status, children: filename }),
          status === import_dash_common13.ProgressTrackingFileStatusesEnum.ABORTED && /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.n70, children: t("common:labels.uploadCancelled") }),
          isError && /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.r20, children: messages && messages.length ? messages.map(({ code, message }) => {
            const errorLabel = `forms:messages.uploadErrors.${(0, import_lodash8.camelCase)(code)}`;
            return i18n.exists(errorLabel) ? t(errorLabel) : message;
          }) : t("common:serverMessages.uploadFail") })
        ] }),
        isUploading && /* @__PURE__ */ (0, import_jsx_runtime43.jsx)(
          ClearButton,
          {
            minWidth: 73,
            ml: theme.space,
            medium: true,
            variation: "outline",
            onClick: (e) => {
              e.stopPropagation();
              if (onClear) {
                onClear();
              }
            },
            children: t("common:labels.clear")
          }
        )
      ] })
    }
  );
}
var ItemUpload_default = ItemUpload;

// src/components/atoms/Form/FileUpload/components/FilesDropzone/FilesDropzone.tsx
var import_react_dropzone = __toESM(require("react-dropzone"));
var import_react_i18next8 = require("react-i18next");

// src/components/atoms/Form/FileUpload/components/FilesDropzone/FilesDropzone.styles.tsx
var import_styled_components38 = __toESM(require("styled-components"));
var SelectFileLabel = import_styled_components38.default.a`
  text-decoration: underline;
  cursor: pointer;
  margin-left: 5px;
`;

// src/components/atoms/Form/FileUpload/components/FilesDropzone/FilesDropzone.tsx
var import_jsx_runtime44 = require("react/jsx-runtime");
function FilesDropzone({
  accept,
  minSize,
  maxSize,
  disabled,
  validator,
  multiple = false,
  onFilesUpload,
  onFilesUploadError,
  onDropRejected,
  isFilesExists,
  children
}) {
  const { t } = (0, import_react_i18next8.useTranslation)("forms");
  return /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(
    import_react_dropzone.default,
    {
      validator,
      multiple,
      accept,
      minSize,
      maxSize,
      disabled,
      onDrop: onFilesUpload,
      onError: onFilesUploadError,
      onDropRejected,
      children: ({ getRootProps, getInputProps }) => /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(Box_default, { ...getRootProps(), h: isFilesExists || !multiple ? void 0 : 168, children: [
        /* @__PURE__ */ (0, import_jsx_runtime44.jsx)("input", { ...getInputProps() }),
        /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(Box_default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(Flex_default, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(Icon_default, { color: mainTheme.colors.n90, name: "upload", size: 32, pb: 2 }) }),
          /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(Flex_default, { pl: 2, pr: 2, justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime44.jsxs)(Text_default, { color: mainTheme.colors.n80, children: [
            t`placeholders.dragAndDropZone`,
            /* @__PURE__ */ (0, import_jsx_runtime44.jsx)(SelectFileLabel, { children: t`placeholders.selectFiles` })
          ] }) })
        ] }),
        children
      ] })
    }
  );
}
var FilesDropzone_default = FilesDropzone;

// src/components/atoms/Form/FileUpload/FileUpload.styles.tsx
var import_dash_common14 = require("dash-common");
var import_styled_components39 = __toESM(require("styled-components"));
var fileUploadStyle = import_styled_components39.css`
  ${({
  theme,
  uploadStatus
}) => {
  const statusStyleRelations = {
    [import_dash_common14.ProgressTrackingFileStatusesEnum.UPLOADING]: import_styled_components39.css`
        border: none;
        background-color: ${theme.colors.b20};
      `,
    [import_dash_common14.ProgressTrackingFileStatusesEnum.UPLOADED]: import_styled_components39.css`
        border: none;
        background-color: ${({ theme: theme2 }) => theme2.colors.n20};
        min-height: 160px;
      `,
    [import_dash_common14.ProgressTrackingFileStatusesEnum.ERROR]: import_styled_components39.css`
        background-color: ${theme.colors.white};
        border: 1px solid ${theme.colors.r20};
      `
  };
  return uploadStatus && statusStyleRelations[uploadStatus] || "";
}}
`;
var FileUploadContainer = import_styled_components39.default.div`
  border: 1px solid ${({ theme }) => theme.colors.n50};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: 96px;
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ multiple }) => multiple ? 0 : "8px"};
  ${fileUploadStyle}
  ${stateStyle}
  ${boxStyle}
`;

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.styles.tsx
var import_styled_components41 = __toESM(require("styled-components"));

// src/components/atoms/Image/Image.tsx
var import_styled_components40 = __toESM(require("styled-components"));

// src/common/hooks/usePermission/usePermission.tsx
var import_react36 = require("react");
var usePermission = () => {
  const { subscription } = (0, import_react36.useContext)(ViewerContext);
  (0, import_react36.useLayoutEffect)(() => {
    if (subscription?.subscriptionProduct?.name.toLowerCase() === "basic") {
      const blockedTags = ["img", "video"];
      document.addEventListener(
        "contextmenu",
        function(e) {
          const clickedTag = e.target?.tagName;
          if (blockedTags.includes(clickedTag.toLowerCase()))
            e.preventDefault();
        },
        false
      );
      document.addEventListener(
        "dragover",
        (e) => {
          const clickedTag = e.target?.tagName;
          if (blockedTags.includes(clickedTag.toLowerCase()))
            e.preventDefault();
        },
        false
      );
      document.addEventListener("dragstart", (e) => {
        const clickedTag = e.target?.tagName;
        if (blockedTags.includes(clickedTag.toLowerCase()))
          e.preventDefault();
      });
      document.addEventListener(
        "drop",
        (e) => {
          const clickedTag = e.target?.tagName;
          if (blockedTags.includes(clickedTag.toLowerCase()))
            e.preventDefault();
        },
        false
      );
    }
  }, []);
};

// src/components/atoms/Image/Image.tsx
var import_jsx_runtime45 = require("react/jsx-runtime");
var ImgStyle = import_styled_components40.default.img`
  ${boxStyle}
  ${({ size }) => size ? `width:${size}${typeof size === "number" ? "px" : ""};` : ""}
  ${({ size }) => size ? `height:${size}${typeof size === "number" ? "px" : ""};` : ""}
  border-radius: ${({ borderRadius, theme }) => borderRadius || theme.space * 2}px;
  object-fit: ${({ fit }) => fit};
  object-position: ${({ position }) => position};
`;
function Image({
  src,
  alt,
  size = 48,
  fit = "cover",
  position = "50% 50%",
  borderRadius,
  ...args
}) {
  usePermission();
  return /* @__PURE__ */ (0, import_jsx_runtime45.jsx)(
    ImgStyle,
    {
      src,
      alt,
      size,
      borderRadius,
      fit,
      position,
      ...args
    }
  );
}
var Image_default = Image;

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.styles.tsx
var UploadResultWrapper = (0, import_styled_components41.default)(Flex_default)`
  border-top: 1px solid
    ${({ theme, withBorder }) => withBorder ? theme.colors.n20 : "transparent"};
  padding: 12px 12px 0;
`;
var UploadedImageViewContainer = (0, import_styled_components41.default)(Image_default)`
  max-width: 88px;
  margin: auto;
`;
var IconWrapper2 = import_styled_components41.default.div`
  width: 16px;
  height: 16px;
  border-radius: 16px;
  padding: 7px;
  cursor: pointer;
  margin-left: 16px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.b50};
`;

// src/components/atoms/Form/FileUpload/SingleUpload/SingleUpload.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");
function SingleUpload({
  initialFile,
  accept,
  minSize,
  maxSize,
  disabled,
  onUpload,
  onChanged,
  onDropRejected,
  defaultValue,
  ...args
}) {
  const [progress, setProgress] = (0, import_react37.useState)(0);
  const [uploadStatus, setUploadStatus] = (0, import_react37.useState)(
    import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADING
  );
  const [fileToUploadInfo, setFileToUploadInfo] = (0, import_react37.useState)(null);
  const [uploadedFileDoc, setUploadedFileDoc] = (0, import_react37.useState)(initialFile || null);
  (0, import_react37.useEffect)(() => {
    if (defaultValue && Object.keys(defaultValue).length) {
      setUploadedFileDoc(defaultValue);
      setUploadStatus(import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADED);
    }
  }, [defaultValue]);
  (0, import_react37.useEffect)(() => {
    if (!uploadedFileDoc && initialFile) {
      setUploadedFileDoc(initialFile);
    }
  }, [initialFile]);
  const onReject = () => {
    setProgress(0);
    setUploadStatus(import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADING);
    setFileToUploadInfo(null);
    setUploadedFileDoc(null);
    onChanged && onChanged("");
  };
  const onAbort = () => {
    if (fileToUploadInfo?.abortHandler) {
      fileToUploadInfo.abortHandler();
    }
    onReject();
  };
  const onProgress = (progress2) => setProgress(progress2);
  const onCompleted = (uploadedFileDoc2) => {
    setUploadedFileDoc(uploadedFileDoc2);
    setUploadStatus(import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADED);
    onChanged && onChanged(uploadedFileDoc2._id);
  };
  const onError = () => {
    setUploadStatus(import_dash_common15.ProgressTrackingFileStatusesEnum.ERROR);
  };
  const onFileUpload = ([file]) => {
    if (file) {
      setUploadStatus(import_dash_common15.ProgressTrackingFileStatusesEnum.UPLOADING);
      setFileToUploadInfo({ filename: file?.name });
      onUpload(file, { onProgress, setAbortHandler, onCompleted, onError });
    }
  };
  const setAbortHandler = (abortHandler) => setFileToUploadInfo((doc) => ({ ...doc, abortHandler }));
  return /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(FileUploadContainer, { ...args, uploadStatus: fileToUploadInfo && uploadStatus, children: [
    !fileToUploadInfo && !uploadedFileDoc && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
      FilesDropzone_default,
      {
        accept,
        minSize,
        maxSize,
        disabled,
        multiple: false,
        onFilesUpload: onFileUpload,
        onFilesUploadError: onError,
        onDropRejected: (fileRejections) => {
          const { errors } = fileRejections[0];
          if (onDropRejected) {
            onDropRejected(errors[0]);
          }
        }
      }
    ),
    fileToUploadInfo && !uploadedFileDoc && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(
      ItemUpload_default,
      {
        progress,
        filename: fileToUploadInfo?.filename || "",
        status: uploadStatus,
        onReject,
        onAbort
      }
    ),
    uploadedFileDoc && /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(import_jsx_runtime46.Fragment, { children: [
      uploadedFileDoc.type?.includes("image") && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(UploadedImageViewContainer, { src: uploadedFileDoc.publicUrl, alt: "upload" }),
      /* @__PURE__ */ (0, import_jsx_runtime46.jsxs)(
        UploadResultWrapper,
        {
          alignItems: "center",
          justifyContent: "center",
          withBorder: uploadedFileDoc.type?.includes("image"),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(Text_default, { ellipsis: true, title: uploadedFileDoc.name, children: uploadedFileDoc.name }),
            !disabled && /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(IconWrapper2, { onClick: onReject, children: /* @__PURE__ */ (0, import_jsx_runtime46.jsx)(Icon_default, { name: "trash", size: 16 }) })
          ]
        }
      )
    ] })
  ] });
}
var SingleUpload_default = SingleUpload;

// src/components/atoms/Form/FileUpload/MultiUpload/MultiUpload.tsx
var import_react38 = require("react");
var import_jsx_runtime47 = require("react/jsx-runtime");
function MultiUpload({
  accept,
  minSize,
  maxSize,
  disabled,
  onUpload,
  validator,
  onDropRejected,
  onFilesUploadError,
  isInContainer,
  onAbortManually
}) {
  const { filesToUpload, onAbort, onClear, onReject, setRejectedFiles, initiateAsyncFilesUpload } = (0, import_react38.useContext)(MultiFileUploadContext);
  const onFileUpload = async (files) => {
    if (files.length) {
      const filesToUpload2 = await initiateAsyncFilesUpload(files);
      onUpload(filesToUpload2);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(FileUploadContainer, { uploadStatus: null, multiple: true, children: /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
    FilesDropzone_default,
    {
      multiple: true,
      accept,
      minSize,
      maxSize,
      disabled,
      validator,
      onFilesUpload: onFileUpload,
      onFilesUploadError,
      isFilesExists: filesToUpload.length > 0,
      onDropRejected: (fileRejections) => {
        if (isInContainer) {
          setRejectedFiles(fileRejections);
        }
        if (onDropRejected) {
          onDropRejected(fileRejections);
        }
      },
      children: filesToUpload.map(({ progressTrackingId, progress, status, filename, messages }) => /* @__PURE__ */ (0, import_jsx_runtime47.jsx)(
        ItemUpload_default,
        {
          multiple: true,
          progress,
          messages,
          filename,
          status,
          onReject: () => onReject(progressTrackingId),
          onAbort: () => {
            if (onAbortManually) {
              onAbortManually(progressTrackingId);
            }
            onAbort(progressTrackingId);
          },
          onClear: () => onClear(progressTrackingId)
        },
        progressTrackingId
      ))
    }
  ) });
}
var MultiUpload_default = MultiUpload;

// src/components/atoms/Form/FileUpload/FileUpload.tsx
var FileUpload2 = import_styled_components42.default.div`
  ${boxStyle}
`;
var Extends = {
  Single: SingleUpload_default,
  Multi: MultiUpload_default
};
var FileUpload_default = Object.assign(FileUpload2, Extends);

// src/components/atoms/Form/Textarea/Textarea.tsx
var import_styled_components43 = __toESM(require("styled-components"));
var import_react39 = require("react");
var import_jsx_runtime48 = require("react/jsx-runtime");
var stateStyle3 = import_styled_components43.css`
  ${({ $errorType }) => {
  const states = {
    ["info" /* Info */]: import_styled_components43.css`
        border: 1px solid ${({ theme }) => theme.colors.n70};
      `,
    ["valid" /* Valid */]: import_styled_components43.css`
        border: 1px solid ${({ theme }) => theme.colors.g20};
      `,
    ["invalid" /* Invalid */]: import_styled_components43.css`
        border: 1px solid ${({ theme }) => theme.colors.r20};
      `
  };
  return $errorType ? states[$errorType] : "";
}}
`;
var StyledTextarea = import_styled_components43.default.textarea`
  -webkit-appearance: none;
  -moz-appearance: none;
  overflow: hidden;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.white};
  resize: ${({ resizable }) => resizable ? "both" : "none"};
  border: 1px solid ${({ theme }) => theme.colors.n60};
  min-height: ${({ minHeight }) => minHeight || 0};
  color: ${({ theme }) => theme.colors.black};
  border-radius: ${({ theme }) => theme.space * 2}px;
  color: ${({ theme }) => theme.colors.n90};
  &:hover {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.b40};
    box-shadow: ${({ theme }) => theme.shadows.shadow3};
  }
  &:focus {
    outline-width: 0;
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.n70};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.colors.n20};
    color: ${({ theme }) => theme.colors.n60};
    border: 1px solid ${({ theme }) => theme.colors.n60};
    cursor: not-allowed;
  }
  &::placeholder {
    color: ${({ theme }) => theme.colors.n60};
  }
  ${boxStyle}
  ${textStyle}
  ${stateStyle3}
  ${({ css: css30 }) => css30}
`;
var Textarea = ({ w, minHeight, value, defaultValue, ...args }) => {
  const ref = (0, import_react39.useRef)(null);
  const adjustHeight = (event) => {
    event.currentTarget.style.height = "inherit";
    event.currentTarget.style.height = `${event.currentTarget.scrollHeight}px`;
  };
  (0, import_react39.useEffect)(() => {
    if (ref.current) {
      ref.current.style.height = "inherit";
      ref.current.style.height = `${ref.current.scrollHeight}px`;
    }
  }, [value, defaultValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(Box_default, { w, children: /* @__PURE__ */ (0, import_jsx_runtime48.jsx)(
    StyledTextarea,
    {
      w: w || "100%",
      value,
      defaultValue,
      ref,
      minHeight,
      onKeyUp: adjustHeight,
      p: 2,
      ...args
    }
  ) });
};
var Textarea_default = Textarea;

// src/components/atoms/Form/DatePicker/DatePicker.tsx
var import_react40 = require("react");
var import_react_datepicker = __toESM(require("react-datepicker"));
var import_styled_components45 = require("styled-components");
var import_react_text_mask3 = __toESM(require("react-text-mask"));
var import_dash_common16 = require("dash-common");
var import_react_datepicker2 = require("react-datepicker/dist/react-datepicker.css");

// src/components/atoms/Form/DatePicker/DatePicker.styles.ts
var import_styled_components44 = __toESM(require("styled-components"));
var IconWrapper3 = (0, import_styled_components44.default)(Flex_default)`
  top: 0;
  bottom: 0;
  right: 0;
`;
var InputWrapper = (0, import_styled_components44.default)(Box_default)`
  input {
    padding-right: ${({ theme }) => theme.space * 12}px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;
var DatePickerWrapper = import_styled_components44.default.div`
  .react-datepicker-wrapper {
    width: 100%;
  }
`;

// src/components/atoms/Form/DatePicker/DatePicker.constants.ts
var monthPickerMask = [/\d/, /\d/];
var yearPickerMask = [/\d/, /\d/, /\d/, /\d/];
var datePickerMask = [/\d/, /\d/, "/", ...monthPickerMask, "/", ...yearPickerMask];

// src/components/atoms/Form/DatePicker/DatePicker.tsx
var import_jsx_runtime49 = require("react/jsx-runtime");
var CustomInput = (0, import_react40.forwardRef)(
  ({
    showYearPicker,
    showMonthYearPicker,
    customInputProps,
    ...datePickerProps
  }, forwardRef4) => {
    const theme = (0, import_styled_components45.useTheme)();
    const maskY = showYearPicker && yearPickerMask;
    const maskM = showMonthYearPicker && monthPickerMask;
    const mask = maskY || maskM || datePickerMask;
    return /* @__PURE__ */ (0, import_jsx_runtime49.jsxs)(InputWrapper, { pos: "relative", children: [
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
        import_react_text_mask3.default,
        {
          mask: customInputProps?.mask || mask || "",
          render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
            Input_default,
            {
              w: "100%",
              ref: (_ref) => {
                ref(_ref);
                forwardRef4(_ref);
              },
              ...props,
              ...datePickerProps,
              onChange: (e) => {
                if (props.onChange) {
                  props.onChange(e);
                }
                if (datePickerProps.onChange) {
                  datePickerProps.onChange(e);
                }
              },
              onClick: (e) => {
                if (datePickerProps.onClick) {
                  datePickerProps.onClick(e);
                }
                if (customInputProps?.onClick) {
                  customInputProps.onClick(e);
                }
              }
            }
          )
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(IconWrapper3, { pos: "absolute", alignItems: "center", pr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
        Icon_default,
        {
          color: theme.colors.n200,
          onClick: datePickerProps.onClick,
          size: 22,
          name: "calendarToday"
        }
      ) })
    ] });
  }
);
var DatePicker = ({ selected, customInputProps, ...args }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(DatePickerWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
    import_react_datepicker.default,
    {
      selected: selected ? new Date(selected) : null,
      dateFormat: import_dash_common16.DATE_FORMAT,
      customInput: (
        // @ts-ignore
        /* @__PURE__ */ (0, import_jsx_runtime49.jsx)(
          CustomInput,
          {
            showYearPicker: args.showYearPicker,
            showMonthYearPicker: args.showMonthYearPicker,
            customInputProps
          }
        )
      ),
      showPopperArrow: false,
      ...args
    }
  ) });
};
var DatePicker_default = DatePicker;

// src/components/atoms/Form/CardCvvInput/CardCvvInput.tsx
var import_react_stripe_js = require("@stripe/react-stripe-js");
var import_styled_components46 = __toESM(require("styled-components"));
var import_jsx_runtime50 = require("react/jsx-runtime");
var stripeElementsStyles = import_styled_components46.css`
  border: 1px solid ${({ theme }) => theme.colors.n60};
  border-radius: ${({ theme }) => theme.space + 2}px;
  display: flex;
  align-items: center;
  :focus,
  :hover {
    border: 1px solid ${({ theme }) => theme.colors.b50};
  }
  & > div {
    width: 100%;
  }
`;
var StyledCardCvcElement = (0, import_styled_components46.default)(import_react_stripe_js.CardCvcElement)`
  ${stripeElementsStyles}
  ${boxStyle}
`;
var InputWrapper2 = (0, import_styled_components46.default)(Flex_default)`
  position: relative;

  svg {
    position: absolute;
    right: 14px;
  }
`;
var CardCvvInput = ({ ...props }) => {
  const theme = (0, import_styled_components46.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime50.jsxs)(InputWrapper2, { w: "100%", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(StyledCardCvcElement, { ...props, w: "100%", px: 3, h: 40 }),
    /* @__PURE__ */ (0, import_jsx_runtime50.jsx)(Icon_default, { name: "creditCard", size: 20, color: theme.colors.n200 })
  ] });
};
var CardCvvInput_default = CardCvvInput;

// src/components/atoms/Form/ExpiryDateInput/ExpiryDateInput.tsx
var import_react_stripe_js2 = require("@stripe/react-stripe-js");
var import_styled_components47 = __toESM(require("styled-components"));
var import_jsx_runtime51 = require("react/jsx-runtime");
var StyledCardExpiryElement = (0, import_styled_components47.default)(import_react_stripe_js2.CardExpiryElement)`
  ${stripeElementsStyles}
  ${boxStyle}
  box-sizing: border-box;
`;
var ExpiryDateInput = ({ ...props }) => /* @__PURE__ */ (0, import_jsx_runtime51.jsx)(StyledCardExpiryElement, { ...props, px: 3, h: 40 });
var ExpiryDateInput_default = ExpiryDateInput;

// src/components/atoms/Form/CardNumberInput/CardNumberInput.tsx
var import_react_stripe_js3 = require("@stripe/react-stripe-js");
var import_styled_components48 = __toESM(require("styled-components"));
var import_jsx_runtime52 = require("react/jsx-runtime");
var StyledCardNumberElement = (0, import_styled_components48.default)(import_react_stripe_js3.CardNumberElement)`
  ${stripeElementsStyles}
  ${boxStyle}
`;
var CardNumberInput = ({ ...props }) => /* @__PURE__ */ (0, import_jsx_runtime52.jsx)(
  StyledCardNumberElement,
  {
    ...props,
    px: 3,
    h: 40,
    options: { showIcon: true }
  }
);
var CardNumberInput_default = CardNumberInput;

// src/components/atoms/Form/Slider/Slider.tsx
var import_rc_slider = __toESM(require("rc-slider"));
var import_styled_components49 = __toESM(require("styled-components"));
var import_assets = require("rc-slider/assets/index.css");
var import_jsx_runtime53 = require("react/jsx-runtime");
var SliderWrapper = (0, import_styled_components49.default)(Box_default)`
  .rc-slider-rail {
    background-color: ${({ theme }) => theme.colors.n20};
    border-radius: ${({ theme }) => theme.space * 4};
  }
  .rc-slider-track {
    border: 2px solid ${({ theme }) => theme.colors.b50};
    border-radius: ${({ theme }) => theme.space * 4};
  }
  .rc-slider-handle {
    border: 2px solid ${({ theme }) => theme.colors.b50};
    background-color: ${({ theme }) => theme.colors.b50};
    opacity: 1;
    width: 17px;
    height: 17px;
    margin-top: -7px;
  }
  .rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
    border-color: ${({ theme }) => theme.colors.b50};
    box-shadow: 0 0 0 5px ${({ theme }) => theme.colors.b20};
  }
  .rc-slider-disabled {
    background-color: inherit;
    opacity: 0.5;
  }
`;
function Slider(props) {
  return /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(SliderWrapper, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime53.jsx)(import_rc_slider.default, { ...props }) });
}
var Slider_default = Slider;

// src/components/atoms/Form/DateRangePicker/DateRangePicker.tsx
var import_moment2 = __toESM(require("moment"));
var import_react_datepicker3 = __toESM(require("react-datepicker"));
var import_styled_components50 = __toESM(require("styled-components"));
var import_react41 = require("react");
var import_react_datepicker4 = require("react-datepicker/dist/react-datepicker.css");
var import_jsx_runtime54 = require("react/jsx-runtime");
var CustomInput2 = (0, import_react41.forwardRef)(({ iconProps, onClear, ...props }, ref) => {
  const theme = (0, import_styled_components50.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsxs)(InputWrapper, { w: "100%", pos: "relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
      Input_default,
      {
        ref,
        w: "100%",
        ...props,
        onChange: (e) => {
          if (!e.target.value) {
            setTimeout(() => {
              onClear();
            });
          }
          props.onChange(e);
        }
      }
    ),
    iconProps && /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(IconWrapper3, { pos: "absolute", alignItems: "center", pr: 8, children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(Icon_default, { color: theme.colors.r20, size: 22, name: "close", ...iconProps }) }),
    /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(IconWrapper3, { pos: "absolute", alignItems: "center", pr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(Icon_default, { color: theme.colors.n200, onClick: props.onClick, size: 22, name: "calendarToday" }) })
  ] });
});
var StyledBox = (0, import_styled_components50.default)(Box_default)`
  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }

  .datepicker {
    width: 100%;
  }
`;
var DateRangePicker = ({
  onChange,
  onClear,
  startDate: initialStartDate,
  endDate: initialEndDate,
  isClearable,
  ...props
}) => {
  const [startDate, setStartDate] = (0, import_react41.useState)(/* @__PURE__ */ new Date());
  const [endDate, setEndDate] = (0, import_react41.useState)(null);
  (0, import_react41.useEffect)(() => {
    if (startDate && endDate) {
      onChange({ startDate, endDate });
    }
  }, [startDate, endDate]);
  (0, import_react41.useEffect)(() => {
    setStartDate(
      (prevDate) => ((0, import_moment2.default)(prevDate).isSame(initialStartDate) ? prevDate : initialStartDate) || null
    );
  }, [initialStartDate]);
  (0, import_react41.useEffect)(() => {
    setEndDate(
      (prevDate) => ((0, import_moment2.default)(prevDate).isSame(initialEndDate) ? prevDate : initialEndDate) || null
    );
  }, [initialEndDate]);
  const onValueChange = (dates) => {
    const [startDate2, endDate2] = dates;
    setStartDate(startDate2);
    setEndDate(endDate2);
    if (onClear && !startDate2 && !endDate2) {
      onClear();
    }
  };
  const handleClear = (0, import_react41.useCallback)(() => {
    setStartDate(null);
    setEndDate(null);
    if (onClear) {
      onClear();
    }
  }, [setStartDate, setEndDate, onClear]);
  const customInputIconProps = (0, import_react41.useMemo)(() => {
    return isClearable && (startDate || endDate) ? { onClick: handleClear } : void 0;
  }, [isClearable, startDate, endDate, handleClear]);
  return /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(StyledBox, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(
    import_react_datepicker3.default,
    {
      wrapperClassName: "datepicker",
      popperPlacement: "top",
      dateFormat: "MM/dd/yyyy",
      selected: startDate,
      onChange: onValueChange,
      startDate,
      endDate,
      selectsRange: true,
      customInput: /* @__PURE__ */ (0, import_jsx_runtime54.jsx)(CustomInput2, { iconProps: customInputIconProps, onClear: handleClear }),
      ...props
    }
  ) });
};
var DateRangePicker_default = DateRangePicker;

// src/components/atoms/Form/Form/Form.tsx
var Form = import_styled_components51.default.form`
  ${boxStyle}
  ${({ isFlex }) => isFlex ? flexStyle : ""}
`;
var Extends2 = {
  Input: Input_default,
  Label: Label_default,
  Group: Group_default,
  FileUpload: FileUpload_default,
  Feedback: Feedback_default,
  Select: Select_default,
  InputPassword: InputPassword_default,
  InputSearch: InputSearch_default,
  InputGroup: InputGroup_default,
  InputPhone: InputPhone_default,
  Checkbox: Checkbox_default,
  Textarea: Textarea_default,
  InputPrice: InputPrice_default,
  DatePicker: DatePicker_default,
  CardCvvInput: CardCvvInput_default,
  DateRangePicker: DateRangePicker_default,
  ExpiryDateInput: ExpiryDateInput_default,
  CardNumberInput: CardNumberInput_default,
  Slider: Slider_default
};
var Form_default = Object.assign(Form, Extends2);

// src/components/atoms/Form/FileInput/FileInput.tsx
var import_react42 = require("react");
var import_styled_components52 = __toESM(require("styled-components"));
var import_react_i18next9 = require("react-i18next");
var import_jsx_runtime55 = require("react/jsx-runtime");
var StyledInput = import_styled_components52.default.input`
  display: none;
`;
var FileInput = ({ label, accept, multiple, onFilesUpload, ...args }) => {
  const { t } = (0, import_react_i18next9.useTranslation)(["forms"]);
  const inputRef = (0, import_react42.useRef)(null);
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsxs)(import_jsx_runtime55.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
      Button_default,
      {
        onClick: () => {
          if (inputRef.current) {
            inputRef.current.click();
          }
        },
        variation: "flat",
        icon: "filePresent",
        bold: true,
        ...args,
        children: label || t("forms:labels:attachFiles")
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
      StyledInput,
      {
        ref: inputRef,
        type: "file",
        multiple,
        accept,
        onChange: (e) => {
          if (onFilesUpload) {
            onFilesUpload(Object.values(e.target.files || {}));
          }
        }
      }
    )
  ] });
};
var FileInput_default = FileInput;

// src/components/atoms/Form/InputNumber/InputNumber.tsx
var import_react43 = __toESM(require("react"));
var import_dash_common17 = require("dash-common");
var import_react_text_mask4 = __toESM(require("react-text-mask"));
var import_text_mask_addons2 = require("text-mask-addons");
var import_jsx_runtime56 = require("react/jsx-runtime");
var defaultMaskOptions2 = {
  suffix: "",
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ",",
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: import_dash_common17.DashValidation.CurrencyDecimalLimit,
  // how many digits allowed after the decimal
  allowNegative: false,
  allowLeadingZeroes: false
};
var InputPrice2 = import_react43.default.forwardRef(
  ({
    onChangeValue,
    value,
    maskOptions = {},
    innerRef,
    onChange,
    disabled,
    ...args
  }, forwardRef4) => {
    const currencyMask = (0, import_text_mask_addons2.createNumberMask)({
      prefix: "$",
      ...defaultMaskOptions2,
      ...maskOptions
    });
    const handleNewValue = (eventValue) => {
      if (eventValue === "")
        return eventValue;
      const options = { ...defaultMaskOptions2, ...maskOptions };
      const { allowDecimal, decimalLimit } = options;
      if (allowDecimal) {
        if (eventValue === ".")
          return eventValue;
        let formattedValue = eventValue.replace(/[^0-9.]/g, "");
        if (decimalLimit > 0) {
          const parts = formattedValue.split(".");
          if (parts.length > 1) {
            const fractionalPart = parts[1].substring(0, decimalLimit);
            if (fractionalPart) {
              formattedValue = parts[0] + (fractionalPart ? "." + fractionalPart : "");
            } else
              formattedValue = parts[0] + ".";
          }
        }
        if (formattedValue.includes("."))
          return formattedValue;
        return `${+formattedValue}`;
      }
      return parseFloat(eventValue.replace(/[^0-9.]/g, ""));
    };
    return /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
      import_react_text_mask4.default,
      {
        ref: (_ref) => {
          if (forwardRef4) {
            forwardRef4.current = _ref?.inputElement;
          }
          if (innerRef) {
            innerRef.current = _ref;
          }
        },
        mask: disabled ? () => false : currencyMask,
        disabled,
        render: (ref, props) => /* @__PURE__ */ (0, import_jsx_runtime56.jsx)(
          Input_default,
          {
            ref,
            ...props,
            ...args,
            value,
            onChange: (event) => {
              const newValue = handleNewValue(event.target.value);
              if (onChangeValue) {
                if (value || value === "") {
                  value !== newValue && onChangeValue(newValue.toString());
                } else {
                  onChangeValue(newValue.toString());
                }
              }
              props.onChange && props.onChange(event);
              onChange && onChange(event);
            }
          }
        )
      }
    );
  }
);
var InputNumber_default = InputPrice2;

// src/components/atoms/Form/InputPercentage/InputPercentage.tsx
var import_react44 = __toESM(require("react"));
var import_jsx_runtime57 = require("react/jsx-runtime");
var InputPercentage = import_react44.default.forwardRef(
  ({ maskOptions = {}, ...args }, forwardRef4) => {
    return /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
      InputNumber_default,
      {
        ...args,
        ref: forwardRef4,
        maskOptions: {
          prefix: "",
          suffix: "%",
          includeThousandsSeparator: false,
          ...maskOptions
        }
      }
    );
  }
);
var InputPercentage_default = InputPercentage;

// src/components/atoms/Form/DatePickerWithTimeRange/DatePickerWithTimeRange.tsx
var import_react45 = require("react");

// src/components/atoms/Form/DatePickerWithTimeRange/DatePickerWithTimeRange.interfaces.tsx
var DatePickerTimeRangeEnum = /* @__PURE__ */ ((DatePickerTimeRangeEnum2) => {
  DatePickerTimeRangeEnum2["YEAR"] = "year";
  DatePickerTimeRangeEnum2["MONTH"] = "month";
  DatePickerTimeRangeEnum2["Day"] = "date";
  return DatePickerTimeRangeEnum2;
})(DatePickerTimeRangeEnum || {});

// src/components/atoms/Form/DatePickerWithTimeRange/DatePickerWithTimeRange.tsx
var import_jsx_runtime58 = require("react/jsx-runtime");
var DatePickerWithTimeRange = ({
  selected,
  timeRangePickerType = "date" /* Day */,
  onClickOutside,
  onSelect,
  ...args
}) => {
  const [timeRangeState, setTimeRangeState] = (0, import_react45.useState)(timeRangePickerType);
  const [isOpen, setIsOpen] = (0, import_react45.useState)(false);
  const timeRange = (0, import_react45.useMemo)(
    () => [
      timeRangePickerType === "year" /* YEAR */ && "year" /* YEAR */,
      ["year" /* YEAR */, "month" /* MONTH */].includes(
        timeRangePickerType
      ) && "month" /* MONTH */,
      [
        "year" /* YEAR */,
        "month" /* MONTH */,
        "date" /* Day */
      ].includes(timeRangePickerType) && "date" /* Day */
    ].filter(Boolean),
    [timeRangePickerType]
  );
  const onSelectSpy = (0, import_react45.useCallback)(
    (date, e) => {
      const currentIndex = timeRange.indexOf(timeRangeState);
      const nextIndex = currentIndex >= 0 && currentIndex + 1 < timeRange.length ? currentIndex + 1 : 0;
      setTimeRangeState(timeRange[nextIndex] || timeRange[0]);
      setIsOpen(nextIndex !== 0);
      if (onSelect) {
        onSelect(date, e);
      }
    },
    [onSelect, setIsOpen, setTimeRangeState, timeRange, timeRangeState]
  );
  const onClickOutsideSpy = (e) => {
    setIsOpen(false);
    if (onClickOutside) {
      onClickOutside(e);
    }
  };
  (0, import_react45.useEffect)(() => {
    if (!isOpen) {
      setTimeRangeState(timeRangePickerType);
    }
  }, [isOpen, setTimeRangeState, timeRangePickerType]);
  return /* @__PURE__ */ (0, import_jsx_runtime58.jsx)(
    DatePicker_default,
    {
      ...args,
      open: isOpen,
      selected: selected ? new Date(selected) : null,
      showYearPicker: timeRangeState === "year" /* YEAR */,
      showMonthYearPicker: timeRangeState === "month" /* MONTH */,
      showFullMonthYearPicker: true,
      onSelect: onSelectSpy,
      onClickOutside: onClickOutsideSpy,
      customInputProps: {
        onClick: () => setIsOpen(true),
        mask: datePickerMask
      }
    }
  );
};
var DatePickerWithTimeRange_default = DatePickerWithTimeRange;

// src/components/atoms/Form/GoogleAutocomplete/GoogleAutocomplete.tsx
var import_react_google_autocomplete = require("react-google-autocomplete");
var import_react46 = require("react");
var import_styled_components53 = require("styled-components");
var import_jsx_runtime59 = require("react/jsx-runtime");
var ContainerStyle = import_styled_components53.createGlobalStyle`
  body {
    .pac-container {
      border-radius: 8px;
      padding-top: ${({ theme }) => theme.space}px;
      padding-bottom: ${({ theme }) => theme.space}px;;
      overflow: hidden;
      .pac-item {
        display: flex;
        align-items: center;
        border: unset;
        padding-top: ${({ theme }) => theme.space * 2}px;
        padding-bottom: ${({ theme }) => theme.space * 2}px;
        padding-left: ${({ theme }) => theme.space * 3}px;
        padding-right: ${({ theme }) => theme.space * 3}px;
        margin-top: ${({ theme }) => theme.space}px;
        margin-bottom: ${({ theme }) => theme.space}px;
        ${textStyle};
        cursor: pointer;
      }
      .pac-icon-marker {
        display: none;
      }
      .pac-item:hover {
        background: ${({ theme }) => theme.colors.b20};
      }
    }
    .pac-logo::after {
      display: none;
    }
  }
`;
var defaultOptions = {
  componentRestrictions: { country: "us" },
  fields: ["address_components", "geometry", "formatted_address", "place_id"],
  types: []
};
var GoogleAutocomplete = ({
  options,
  // <- see more https://developers.google.com/maps/documentation/javascript/place-autocomplete#set-options-at-construction
  onPlaceSelected,
  onChange,
  menuPortalTarget,
  ...args
}) => {
  const { ref, autocompleteRef } = (0, import_react_google_autocomplete.usePlacesWidget)({
    options: {
      ...options || {},
      ...defaultOptions
    }
  });
  (0, import_react46.useEffect)(() => {
    if (autocompleteRef.current) {
      autocompleteRef.current.addListener("place_changed", () => {
        if (onPlaceSelected && autocompleteRef && autocompleteRef.current) {
          onPlaceSelected(autocompleteRef.current.getPlace(), ref.current, autocompleteRef.current);
        }
      });
    }
  }, [autocompleteRef, onPlaceSelected]);
  const onChangeSpy = (event) => {
    onChange && onChange(event);
    const dropdownElement = document.querySelector(".pac-container");
    if (dropdownElement && menuPortalTarget && !menuPortalTarget.querySelector(".pac-container")) {
      menuPortalTarget.appendChild(dropdownElement);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime59.jsxs)(import_jsx_runtime59.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(Input_default, { icon: "search", ref, onChange: onChangeSpy, ...args }),
    /* @__PURE__ */ (0, import_jsx_runtime59.jsx)(ContainerStyle, {})
  ] });
};
var GoogleAutocomplete_default = GoogleAutocomplete;

// src/components/atoms/Form/SelectTree/SelectTree.tsx
var import_react_select3 = require("react-select");
var import_styled_components54 = __toESM(require("styled-components"));
var import_jsx_runtime60 = require("react/jsx-runtime");
var { Option: Option2 } = import_react_select3.components;
var GlobalStyles2 = import_styled_components54.createGlobalStyle`
  .select__menu-list {
    padding: ${({ theme }) => theme.space}px;
    .select__option {
      border-radius: ${({ theme }) => theme.space}px;
    }
  }
`;
var TextSelect = (0, import_styled_components54.default)(Text_default)`
  white-space: nowrap;
`;
var SelectTree = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)(import_jsx_runtime60.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(
      Select_default,
      {
        isMulti: true,
        components: {
          Option: ({ isSelected, data, ...props2 }) => {
            const { isVisible = true, treeIndex, label } = data;
            return isVisible && /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(Option2, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime60.jsxs)(Flex_default, { flexDirection: "row", ml: treeIndex * 8, alignItems: "center", children: [
              /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(Checkbox_default, { onClick: props2.innerProps.onClick, checked: isSelected, mr: 2 }) }),
              /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(TextSelect, { children: label }) })
            ] }) });
          }
        },
        ...props,
        menuFixedWidth: false
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime60.jsx)(GlobalStyles2, {})
  ] });
};
var SelectTree_default = SelectTree;

// src/components/atoms/Form/SelectPrice/service.ts
var import_dash_common18 = require("dash-common");
var import_lodash9 = require("lodash");
var priceMaxRange = (min) => [
  "Any Price",
  ...import_dash_common18.PRICE_MAX_SELECT_OPTIONS.filter((p) => p >= (min || 0))
];
var priceMinRange = (max) => (0, import_lodash9.isNil)(max) || max === "Any Price" ? import_dash_common18.PRICE_MIN_SELECT_OPTIONS : import_dash_common18.PRICE_MIN_SELECT_OPTIONS.filter((p) => p <= max);
var priceMaxRangeRent = (min) => [
  "Any Price",
  ...import_dash_common18.PRICE_MAX_SELECT_OPTIONS_RENT.filter((p) => p >= (min || 0))
];
var priceMinRangeRent = (max) => (0, import_lodash9.isNil)(max) || max === "Any Price" ? import_dash_common18.PRICE_MIN_SELECT_OPTIONS_RENT : import_dash_common18.PRICE_MIN_SELECT_OPTIONS_RENT.filter((p) => p <= max);
var validatePrice = (min, max) => {
  if (max === "Any Price")
    return true;
  if ((0, import_lodash9.isNil)(min) || (0, import_lodash9.isNil)(max))
    return true;
  if (isNaN(min) || isNaN(max))
    return true;
  return min <= max;
};

// src/components/atoms/Form/SelectPrice/components/PriceRange/PriceRange.tsx
var import_react48 = require("react");
var import_styled_components56 = require("styled-components");
var import_react_i18next10 = require("react-i18next");

// src/components/atoms/Form/SelectPrice/components/PriceInputWithDropDown/PriceInputWithDropDown.tsx
var import_react47 = require("react");
var import_styled_components55 = __toESM(require("styled-components"));
var import_jsx_runtime61 = require("react/jsx-runtime");
var Option3 = (0, import_styled_components55.default)(Box_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  :hover {
    background-color: ${({ theme }) => theme.colors.b20};
  }
`;
var PriceInputWithDropDown = ({
  onChangeValue,
  placeholder,
  value,
  autoFocus,
  range,
  disableDropdown,
  placement = "bottom",
  inputRef,
  label
}) => {
  const containerRef = (0, import_react47.useRef)(null);
  const getLabel = (item) => item === void 0 || item === "Any Price" ? item : `$${Number(item)?.toLocaleString("en")}`;
  return /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
    DropDown_default,
    {
      trigger: "hover",
      placement,
      optionsStyle: { zIndex: 160 },
      Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(Box_default, { ref: containerRef, children: /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        InputPrice_default,
        {
          innerRef: inputRef,
          autoFocus,
          w: "100%",
          value,
          onChangeValue,
          placeholder,
          autoComplete: "off",
          maskOptions: {
            includeThousandsSeparator: true
          },
          label
        }
      ) }),
      children: !disableDropdown ? ({ closeDropdown }) => /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
        Box_default,
        {
          maxHeight: 300,
          w: containerRef.current?.offsetWidth,
          onClick: closeDropdown,
          children: range.map((item, index2) => /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(
            Option3,
            {
              m: 1,
              p: 3,
              onClick: () => {
                onChangeValue(item);
                inputRef.current?.inputElement?.blur();
              },
              children: /* @__PURE__ */ (0, import_jsx_runtime61.jsx)(Text_default, { id: "price-range-option", children: getLabel(item) })
            },
            index2
          ))
        }
      ) : void 0
    }
  );
};
var PriceInputWithDropDown_default = PriceInputWithDropDown;

// src/components/atoms/Form/SelectPrice/components/PriceRange/PriceRange.tsx
var import_jsx_runtime62 = require("react/jsx-runtime");
var PriceRange = ({
  price,
  setNodeKey,
  nodeKey,
  minLabel,
  maxLabel,
  disableRangeDropdown,
  isRent,
  handlePrice
}) => {
  const theme = (0, import_styled_components56.useTheme)();
  const { t } = (0, import_react_i18next10.useTranslation)("forms");
  const minRef = (0, import_react48.useRef)(null);
  const maxRef = (0, import_react48.useRef)(null);
  const thisHandlePrice = (field) => (value) => {
    handlePrice(field)(value);
    setNodeKey(field);
  };
  (0, import_react48.useLayoutEffect)(() => {
    const inputRef = nodeKey === "min" ? minRef : maxRef;
    setTimeout(() => {
      if (inputRef.current) {
        const inputElement = inputRef.current.inputElement;
        inputElement.focus();
      }
    }, 1);
  }, [price]);
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Box_default, { p: 4, children: /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(Flex_default, { alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(Form_default.Group, { w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Form_default.Label, { children: minLabel || t("labels.priceMin") }),
      /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
        PriceInputWithDropDown_default,
        {
          placement: "bottom",
          value: price?.min,
          onChangeValue: thisHandlePrice("min"),
          placeholder: "$0",
          inputRef: minRef,
          range: isRent ? priceMinRangeRent(price?.max) : priceMinRange(price?.max),
          disableDropdown: disableRangeDropdown,
          label: "min"
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Devider_default, { mx: 2, mt: 4, minWidth: 17, h: 1, color: theme.colors.n80 }),
    /* @__PURE__ */ (0, import_jsx_runtime62.jsxs)(Form_default.Group, { w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(Form_default.Label, { children: maxLabel || t("labels.priceMax") }),
      /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
        PriceInputWithDropDown_default,
        {
          placement: "bottom",
          value: price?.max,
          onChangeValue: thisHandlePrice("max"),
          placeholder: "Any Price",
          inputRef: maxRef,
          range: isRent ? priceMaxRangeRent(price?.min) : priceMaxRange(price?.min),
          disableDropdown: disableRangeDropdown,
          label: "max"
        }
      )
    ] })
  ] }) });
};
var PriceRange_default = PriceRange;

// src/components/atoms/Form/SelectPrice/SelectPrice.tsx
var import_react51 = require("react");

// src/components/atoms/Form/SelectPrice/SelectPrice.styles.ts
var import_styled_components57 = __toESM(require("styled-components"));
var StyledBox2 = (0, import_styled_components57.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 2px 14px rgba(0, 0, 0, 0.05);
  border-radius: 8px;

  .select__menu {
    min-width: fit-content;
  }
  .select__menu-list {
    padding: 4px;

    .select__option {
      cursor: pointer;
      border-radius: 8px;
      height: 48px;
      display: flex;
      align-items: center;
    }
    .select__option--is-selected {
      background-color: ${({ theme }) => theme.colors.b20};
      color: ${({ theme }) => theme.colors.b50};
    }
    .hover-disable {
      padding: 2px 4px;
      :hover {
        background: transparent;
      }
    }
    .hover-disable.select__option--is-focused,
    .hover-disable.select__option--is-selected {
      background: transparent;
    }
  }
`;

// src/components/atoms/Form/SelectPrice/SelectPrice.helpers.ts
var formatSelectPriceValue = (price, { disablePriceMask } = {}) => {
  const pMin = price?.min ?? 0;
  const pMax = price?.max === "Any Price" ? 0 : price?.max ?? 0;
  const min = `$${pMin.toLocaleString("en")}`;
  const max = `$${pMax.toLocaleString("en")}`;
  if (pMin && pMax) {
    return `${min} - ${max}`;
  }
  if (pMax) {
    const maxMask = "<";
    return `${!disablePriceMask ? maxMask : ""} ${max}`;
  }
  if (pMin) {
    const minMask = "+";
    return `${min}${!disablePriceMask ? minMask : ""}`;
  }
  return "";
};

// src/components/atoms/Tooltip/TooltipWrapper.tsx
var import_react49 = require("react");
var import_styled_components58 = __toESM(require("styled-components"));
var import_jsx_runtime63 = require("react/jsx-runtime");
var Container3 = (0, import_styled_components58.default)(Box_default)`
  display:inline-block;
  cursor: pointer;
  height: inherit;
  max-width: 100%;
`;
function TooltipWrapper({
  placement = "top",
  children,
  content,
  rerender,
  delay = 400,
  ...args
}) {
  const id2 = (0, import_react49.useId)();
  const refBox = (0, import_react49.useRef)(null);
  const { refModal, isOpen, setIsOpen, handlePosition, setConfig, config, setContent } = (0, import_react49.useContext)(TooltipContext);
  const handleOpenTooltip = () => {
    setConfig((state) => ({
      ...state,
      id: id2,
      placement
    }));
    setContent(() => content);
    setIsOpen(true);
  };
  const thisHandlePosition = () => {
    const elemBox = refBox.current;
    const rectBox = elemBox.getBoundingClientRect();
    const elemModal = refModal.current;
    const rectModal = elemModal.getBoundingClientRect();
    handlePosition({ rectBox, rectModal });
  };
  (0, import_react49.useEffect)(() => {
    if (isOpen && config.id === id2) {
      handleOpenTooltip();
    }
  }, [rerender]);
  (0, import_react49.useLayoutEffect)(() => {
    if (isOpen && config.id === id2) {
      thisHandlePosition();
    }
  }, [isOpen]);
  const containerProps = {
    onMouseEnter: () => {
      handleOpenTooltip();
      thisHandlePosition();
    },
    onMouseLeave: () => {
      setIsOpen(false);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
    Container3,
    {
      id: id2,
      ref: refBox,
      ...containerProps,
      ...args,
      children
    }
  );
}
var TooltipWrapper_default = TooltipWrapper;

// src/components/atoms/Tooltip/TooltipPopup.tsx
var import_react50 = require("react");
var import_styled_components59 = __toESM(require("styled-components"));
var import_lodash10 = require("lodash");
var import_jsx_runtime64 = require("react/jsx-runtime");
var tooltipBackgroundColor = "black";
var tooltipArrowSize = "6";
var ContainerS = import_styled_components59.default.div`
  position: absolute;
  z-index: 120;
  margin-right: 10px;

  .Tooltip-Tip {
    ${boxStyle}
    ${textStyle}
    padding: 6px 14px;
    background: ${({ theme }) => theme.colors.setOpacity(theme.colors.n200, 90)};
    color: ${({ theme }) => theme.colors.white};
    border-radius: ${({ theme }) => `${theme.space / 2}px`};
  }

  .Tooltip-Tip::before {
    position: absolute;
    content: ' ';
    border: solid transparent;
    height: 0;
    width: 0;
    pointer-events: none;
    border-width: ${tooltipArrowSize}px;
    border-top-color: ${tooltipBackgroundColor};
  }

  .Tooltip-Tip.top::before {
    top: 100%;
  }

  .Tooltip-Tip.bottom::before {
    bottom: 100%;
    transform: rotate(180deg);
  }

  .Tooltip-Tip.left::before {
    left: 100%;
    transform: rotate(0) rotate(-90deg);
  }

  .Tooltip-Tip.right::before {
    right: 100%;
    transform: rotate(0) rotate(90deg);
  }
`;
function TooltipPopup() {
  const { refModal, isOpen, content, config } = (0, import_react50.useContext)(TooltipContext);
  const display = !(0, import_lodash10.isNil)(content) && (typeof content === "string" ? content.length > 0 : true);
  return /* @__PURE__ */ (0, import_jsx_runtime64.jsx)(
    ContainerS,
    {
      style: { display: isOpen && display ? "flex" : "none" },
      ref: refModal,
      children: /* @__PURE__ */ (0, import_jsx_runtime64.jsx)("div", { className: `Tooltip-Tip ${config.placement}`, children: content })
    }
  );
}
var TooltipPopup_default = TooltipPopup;

// src/components/atoms/Form/SelectPrice/constants.ts
var PriceRangeInt = {
  min: 0,
  max: void 0
};

// src/components/atoms/Form/SelectPrice/SelectPrice.tsx
var import_jsx_runtime65 = require("react/jsx-runtime");
var SelectPrice = ({
  onChange,
  defaultValue,
  placeholder,
  menuProps = {},
  $errorType,
  disableRangeDropdown,
  onMenuClose,
  onClear,
  menuPortalZIndex = 150,
  isButtonSelect,
  hasInput,
  isRent,
  ...props
}) => {
  const [price, setPrice] = (0, import_react51.useState)(PriceRangeInt);
  const [nodeKey, setNodeKey] = (0, import_react51.useState)("min");
  const { min, max } = price || {};
  (0, import_react51.useEffect)(() => {
    if (defaultValue?.max === void 0 && max === "Any Price") {
      return;
    }
    if (defaultValue) {
      setPrice(defaultValue);
    }
  }, [defaultValue]);
  (0, import_react51.useEffect)(() => {
    const isDefault = price.min === 0 && price.max === void 0;
    if (!isDefault) {
      onChange({ min, max: max === "Any Price" ? void 0 : max });
    }
  }, [min, max]);
  const handlePrice = (field) => (value) => {
    if (value === "Any Price") {
      setPrice((prev) => ({ ...prev, [field]: "Any Price" }));
      return;
    }
    const isValueNaN = value !== void 0 && isNaN(value);
    setPrice((prev) => ({
      ...prev,
      [field]: isValueNaN ? void 0 : value
    }));
  };
  const inputValue = (0, import_react51.useMemo)(() => formatSelectPriceValue(price), [price]);
  return /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(Box_default, { pos: "relative", w: "fit-content", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(TooltipWrapper_default, { w: "100%", content: inputValue, children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
    Select_default,
    {
      w: "100%",
      isClearable: true,
      isButtonSelect,
      placeholder,
      onMenuClose,
      inputValue,
      options: [{ value: inputValue, label: inputValue }],
      value: inputValue || void 0,
      styles: {
        menuPortal: (base) => ({ ...base, zIndex: menuPortalZIndex })
      },
      onClear: () => {
        setPrice(PriceRangeInt);
        onChange(PriceRangeInt);
        onClear && onClear();
      },
      components: {
        Menu: () => /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(StyledBox2, { mt: 1, minWidth: 311, children: /* @__PURE__ */ (0, import_jsx_runtime65.jsx)(
          PriceRange_default,
          {
            ...menuProps,
            nodeKey,
            setNodeKey,
            price,
            disableRangeDropdown,
            handlePrice,
            isRent
          }
        ) })
      },
      $errorType
    }
  ) }) });
};
var SelectPrice_default = SelectPrice;

// src/components/atoms/Form/RawNumberSelect/RawNumberSelect.tsx
var import_react52 = require("react");
var import_styled_components61 = require("styled-components");
var import_react_i18next11 = require("react-i18next");

// src/components/atoms/Form/RawNumberSelect/RawNumberSelect.styles.ts
var import_styled_components60 = __toESM(require("styled-components"));
var StyledBox3 = (0, import_styled_components60.default)(Flex_default)`
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b50 : theme.colors.white};
  cursor: pointer;
`;
var StyledWrapper = (0, import_styled_components60.default)(Flex_default)`
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.n40};

  & > div:not(:last-child) {
    border-right: 1px solid ${({ theme }) => theme.colors.n40};
  }

  & > div:last-child {
    border-radius: 0 6px 6px 0;
  }

  & > div:first-child {
    border-radius: 6px 0 0 6px;
  }
`;

// src/components/atoms/Form/RawNumberSelect/RawNumberSelect.tsx
var import_jsx_runtime66 = require("react/jsx-runtime");
var RawNumberSelect = ({
  onChange,
  value = null,
  options = [1, 2, 3, 4, 5]
}) => {
  const theme = (0, import_styled_components61.useTheme)();
  const { t } = (0, import_react_i18next11.useTranslation)("common");
  const [itemValue, setItemValue] = (0, import_react52.useState)(value);
  const rawOptions = (0, import_react52.useMemo)(
    () => [
      { label: t("labels.any"), value: null },
      ...options.map((item) => ({ label: item, value: item }))
    ],
    [options]
  );
  (0, import_react52.useEffect)(() => {
    if (itemValue !== value) {
      setItemValue(value);
    }
  }, [value, itemValue, setItemValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(StyledWrapper, { w: "fit-content", children: rawOptions.map((item, index2) => {
    const isActive = item.value === itemValue;
    const isLastIndex = index2 === rawOptions.length - 1;
    return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
      StyledBox3,
      {
        onClick: () => {
          setItemValue(item.value);
          onChange(item.value);
        },
        w: 41,
        h: 32,
        alignItems: "center",
        justifyContent: "center",
        isActive,
        children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(Text_default, { color: isActive ? theme.colors.white : theme.colors.n90, children: isLastIndex ? `${item.label}+` : item.label })
      },
      `${item.value}-${index2}`
    );
  }) });
};
var RawNumberSelect_default = RawNumberSelect;

// src/components/atoms/Form/BathsAndBedsSelect/BathsAndBedsSelect.tsx
var import_react53 = require("react");
var import_react_select4 = require("react-select");
var import_react_i18next12 = require("react-i18next");

// src/components/atoms/Form/BathsAndBedsSelect/BathsAndBedsSelect.helpers.ts
var formatValue = (units, t) => {
  const arr = [];
  const { unitNumberOfBathrooms, unitNumberOfBedrooms } = units;
  if (unitNumberOfBedrooms || unitNumberOfBathrooms) {
    arr.push(t("forms:labels.beds", { count: unitNumberOfBedrooms || 0 }));
    arr.push(t("forms:labels.baths", { count: unitNumberOfBathrooms || 0 }));
  }
  return arr.join(", ");
};

// src/components/atoms/Form/BathsAndBedsSelect/BathsAndBedsSelect.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
var { Menu: Menu2 } = import_react_select4.components;
var Component = ({ setUnits, units }) => {
  const { t } = (0, import_react_i18next12.useTranslation)("pages");
  const handleInputs = (key) => (value) => {
    setUnits({ ...units, [key]: value });
  };
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)(Box_default, { p: 4, minWidth: 272, children: [
    /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)(Form_default.Group, { mb: 6, children: [
      /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(Form_default.Label, { children: t("propertyPage.numberOfBedrooms") }),
      /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
        RawNumberSelect_default,
        {
          value: units?.unitNumberOfBedrooms,
          onChange: handleInputs("unitNumberOfBedrooms")
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime67.jsxs)(Form_default.Group, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(Form_default.Label, { children: t("propertyPage.numberOfBathrooms") }),
      /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
        RawNumberSelect_default,
        {
          value: units?.unitNumberOfBathrooms,
          onChange: handleInputs("unitNumberOfBathrooms")
        }
      )
    ] })
  ] });
};
var BathsAndBedsSelect = ({
  onSelectChanged,
  unitsValue,
  ...props
}) => {
  const [units, setUnits] = (0, import_react53.useState)({});
  const { t } = (0, import_react_i18next12.useTranslation)();
  (0, import_react53.useEffect)(() => {
    setUnits(unitsValue || {});
  }, [unitsValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
    Select_default,
    {
      ...props,
      inputValue: formatValue(units, t),
      isClearable: true,
      components: {
        Menu: (args) => /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(Menu2, { ...args, children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
          Component,
          {
            units,
            setUnits: (value) => {
              setUnits(value);
              if (onSelectChanged) {
                onSelectChanged(value);
              }
            }
          }
        ) })
      }
    }
  );
};
var BathsAndBedsSelect_default = BathsAndBedsSelect;

// src/components/atoms/Form/TagSelect/TagSelect.tsx
var import_react54 = require("react");
var import_styled_components63 = __toESM(require("styled-components"));
var import_lodash11 = require("lodash");

// src/components/atoms/Tag/Tag.tsx
var import_styled_components62 = __toESM(require("styled-components"));
var import_jsx_runtime68 = require("react/jsx-runtime");
var disabledStyle = import_styled_components62.css`
  cursor: not-allowed;
  background-color: ${({ theme }) => theme.colors.n20};
  &:hover {
    background-color: ${({ theme }) => theme.colors.n20};
  }
`;
var TagStyle = (0, import_styled_components62.default)(Flex_default)`
  cursor: pointer;
  border-radius: ${({ theme }) => theme.space * 4}px;
  background-color: ${({ theme, active }) => active ? theme.colors.b100 : theme.colors.n40};
  &:hover {
    background-color: ${({ theme, active }) => active ? theme.colors.b50Hover : theme.colors.n50};
  }
  ${({ disabled }) => disabled && disabledStyle}
`;
var Tag = ({ active, disabled, iconLeft, iconRight, children, ...args }) => {
  const theme = (0, import_styled_components62.useTheme)();
  const mainColor = active ? theme.colors.white : theme.colors.n70;
  const color2 = disabled ? theme.colors.n60 : mainColor;
  return /* @__PURE__ */ (0, import_jsx_runtime68.jsxs)(
    TagStyle,
    {
      active,
      disabled,
      alignItems: "center",
      justifyContent: "center",
      px: 3,
      py: 1,
      ...args,
      children: [
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(Icon_default, { color: color2, mr: 2, name: iconLeft, size: 9 }),
        /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(Text_default, { semibold: true, color: color2, children }),
        iconRight && /* @__PURE__ */ (0, import_jsx_runtime68.jsx)(Icon_default, { color: color2, ml: 2, name: iconRight, size: 9 })
      ]
    }
  );
};
var Tag_default = Tag;

// src/components/atoms/Form/TagSelect/TagSelect.tsx
var import_jsx_runtime69 = require("react/jsx-runtime");
var TagSelectWrapper = (0, import_styled_components63.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  background-color: ${({ theme }) => theme.colors.n20};
`;
var TagSelect = ({ options, defaultValue, onChange, value, gap, ...props }) => {
  const [selectedValue, setSelectedValue] = (0, import_react54.useState)([]);
  const [isSelectedValueChanged, setIsSelectedValueChanged] = (0, import_react54.useState)(false);
  const handleTagValue = (value2, action) => {
    setIsSelectedValueChanged(true);
    if (action === "add") {
      return setSelectedValue((prev) => [...prev, value2]);
    }
    setSelectedValue((prev) => prev.filter((item) => item !== value2));
  };
  (0, import_react54.useEffect)(() => {
    setSelectedValue(defaultValue || []);
  }, [defaultValue]);
  (0, import_react54.useEffect)(() => {
    if (onChange && isSelectedValueChanged) {
      onChange(selectedValue);
    }
  }, [selectedValue, isSelectedValueChanged]);
  (0, import_react54.useEffect)(() => {
    if (value && (0, import_lodash11.difference)(value, selectedValue).length) {
      setSelectedValue(value);
    }
  }, [value, setSelectedValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(TagSelectWrapper, { p: 2, flexWrap: "wrap", gap: gap || 8, ...props, children: options.map((item) => {
    const isActive = !!selectedValue.find((value2) => value2 === item.value);
    return /* @__PURE__ */ (0, import_jsx_runtime69.jsx)(
      Tag_default,
      {
        active: isActive,
        iconRight: isActive ? "close" : "plus",
        onClick: () => handleTagValue(item.value, isActive ? "remove" : "add"),
        children: item.label
      },
      item.value
    );
  }) });
};
var TagSelect_default = TagSelect;

// src/components/atoms/Form/RadioInput/RadioInput.styles.tsx
var import_styled_components64 = __toESM(require("styled-components"));
var StyledRadio = import_styled_components64.default.input`
  -webkit-appearance: none;
  appearance: none;
  margin: 0;
  width: 18px;
  height: 18px;
  border: 1px solid ${({ theme }) => theme.colors.n60};
  border-radius: 50%;

  ::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 8px;
    height: 8px;
    margin: 3px;
  }
  :checked {
    border: 2px solid ${({ theme }) => theme.colors.b50} !important;
    ::after {
      background-color: ${({ theme }) => theme.colors.b50};
    }
  }
  :hover {
    border-color: ${({ theme }) => theme.colors.n70};
  }
  :disabled {
    border: 1px solid ${({ theme }) => theme.colors.n50};
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.n20};

    :checked {
      border: 2px solid ${({ theme }) => theme.colors.n50} !important;
      ::after {
        background-color: ${({ theme }) => theme.colors.n50};
      }
    }
  }
`;

// src/components/atoms/Form/RadioInput/RadioInput.tsx
var import_jsx_runtime70 = require("react/jsx-runtime");
function RadioInput({ onChange, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(Flex_default, { alignItems: "center", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime70.jsx)(StyledRadio, { type: "radio", onChange, ...args }) });
}
var RadioInput_default = RadioInput;

// src/components/atoms/Form/InputAutocomplete/InputAutocomplete.tsx
var import_react55 = require("react");
var import_styled_components66 = require("styled-components");
var import_react_i18next13 = require("react-i18next");
var import_react_select5 = __toESM(require("react-select"));

// src/components/atoms/Form/InputAutocomplete/InputAutocomplete.styles.ts
var import_styled_components65 = __toESM(require("styled-components"));
var OptionContainer = (0, import_styled_components65.default)(Flex_default)`
  cursor: ${({ isDisabled }) => isDisabled ? "not-allowed" : "pointer"};
`;
var DisabledBoxWrapper = (0, import_styled_components65.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space}px;
  min-width: fit-content;
`;

// src/components/atoms/Form/InputAutocomplete/InputAutocomplete.tsx
var import_jsx_runtime71 = require("react/jsx-runtime");
var { Option: Option4 } = import_react_select5.components;
var InputAutocomplete = ({
  options,
  onChange,
  placeholder,
  ...props
}) => {
  const theme = (0, import_styled_components66.useTheme)();
  const { t } = (0, import_react_i18next13.useTranslation)("common", { keyPrefix: "labels" });
  const [inputValue, setInputValue] = (0, import_react55.useState)("");
  const handleInputValue = (value, { action }) => {
    if (action !== "input-blur" && action !== "menu-close") {
      setInputValue(value);
      if (onChange)
        onChange(value);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(StyledSelectWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(
    import_react_select5.default,
    {
      isSearchable: true,
      menuPortalTarget: document.body,
      menuPlacement: "auto",
      filterOption: (0, import_react_select5.createFilter)({ matchFrom: "any", stringify: (option) => `${option.label}` }),
      inputValue,
      backspaceRemovesValue: true,
      isClearable: true,
      placeholder,
      defaultInputValue: inputValue,
      onChange: (option) => onChange && onChange(option?.value || ""),
      styles: { menuPortal: (base) => ({ ...base, zIndex: 150 }) },
      blurInputOnSelect: false,
      onInputChange: handleInputValue,
      classNamePrefix: "select",
      options,
      components: {
        DropdownIndicator: () => null,
        ClearIndicator: () => null,
        NoOptionsMessage: () => /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(Flex_default, { h: 42, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(Text_default, { color: theme.colors.n70, children: t`noOptions` }) }),
        Option: ({ children, ...props2 }) => /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(Option4, { ...props2, children: /* @__PURE__ */ (0, import_jsx_runtime71.jsxs)(
          OptionContainer,
          {
            justifyContent: "space-between",
            alignItems: "center",
            isDisabled: props2.isDisabled,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(Text_default, { color: props2.isDisabled ? theme.colors.n80 : theme.colors.n90, children }),
              props2.isDisabled && /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(DisabledBoxWrapper, { px: 2, py: 1, children: /* @__PURE__ */ (0, import_jsx_runtime71.jsx)(Text_default, { semibold: true, sm: true, color: theme.colors.n80, children: t`added` }) })
            ]
          }
        ) })
      }
    }
  ) });
};
var InputAutocomplete_default = InputAutocomplete;

// src/components/atoms/Form/WorkingWeekHoursInput/WorkingWeekHoursInput.tsx
var import_moment5 = __toESM(require("moment"));
var import_react57 = require("react");
var import_styled_components69 = __toESM(require("styled-components"));
var import_react_i18next15 = require("react-i18next");
var import_dash_common19 = require("dash-common");

// src/components/organisms/WorkingHoursInput/WorkingHoursInput.tsx
var import_moment4 = __toESM(require("moment"));
var import_styled_components68 = __toESM(require("styled-components"));
var import_react_i18next14 = require("react-i18next");
var import_react56 = require("react");

// src/components/molecules/TimePicker/TimePicker.helpers.ts
var import_moment3 = __toESM(require("moment"));
var createValueByHours = (hours) => (0, import_moment3.default)(`${(/* @__PURE__ */ new Date()).toDateString()}, ${hours}`).toISOString();

// src/components/molecules/TimePicker/TimePicker.tsx
var import_jsx_runtime72 = require("react/jsx-runtime");
var OPTIONS = [
  { label: "12:00 AM", value: "12:00 AM" },
  { label: "12:30 AM", value: "12:30 AM" },
  { label: "01:00 AM", value: "01:00 AM" },
  { label: "01:30 AM", value: "01:30 AM" },
  { label: "02:00 AM", value: "02:00 AM" },
  { label: "02:30 AM", value: "02:30 AM" },
  { label: "03:00 AM", value: "03:00 AM" },
  { label: "03:30 AM", value: "03:30 AM" },
  { label: "04:00 AM", value: "04:00 AM" },
  { label: "04:30 AM", value: "04:30 AM" },
  { label: "05:00 AM", value: "05:00 AM" },
  { label: "05:30 AM", value: "05:30 AM" },
  { label: "06:00 AM", value: "06:00 AM" },
  { label: "06:30 AM", value: "06:30 AM" },
  { label: "07:00 AM", value: "07:00 AM" },
  { label: "07:30 AM", value: "07:30 AM" },
  { label: "08:00 AM", value: "08:00 AM" },
  { label: "08:30 AM", value: "08:30 AM" },
  { label: "09:00 AM", value: "09:00 AM" },
  { label: "09:30 AM", value: "09:30 AM" },
  { label: "10:00 AM", value: "10:00 AM" },
  { label: "10:30 AM", value: "10:30 AM" },
  { label: "11:00 AM", value: "11:00 AM" },
  { label: "11:30 AM", value: "11:30 AM" },
  { label: "12:00 PM", value: "12:00 PM" },
  { label: "12:30 PM", value: "12:30 PM" },
  { label: "01:00 PM", value: "01:00 PM" },
  { label: "01:30 PM", value: "01:30 PM" },
  { label: "02:00 PM", value: "02:00 PM" },
  { label: "02:30 PM", value: "02:30 PM" },
  { label: "03:00 PM", value: "03:00 PM" },
  { label: "03:30 PM", value: "03:30 PM" },
  { label: "04:00 PM", value: "04:00 PM" },
  { label: "04:30 PM", value: "04:30 PM" },
  { label: "05:00 PM", value: "05:00 PM" },
  { label: "05:30 PM", value: "05:30 PM" },
  { label: "06:00 PM", value: "06:00 PM" },
  { label: "06:30 PM", value: "06:30 PM" },
  { label: "07:00 PM", value: "07:00 PM" },
  { label: "07:30 PM", value: "07:30 PM" },
  { label: "08:00 PM", value: "08:00 PM" },
  { label: "08:30 PM", value: "08:30 PM" },
  { label: "09:00 PM", value: "09:00 PM" },
  { label: "09:30 PM", value: "09:30 PM" },
  { label: "10:00 PM", value: "10:00 PM" },
  { label: "10:30 PM", value: "10:30 PM" },
  { label: "11:00 PM", value: "11:00 PM" },
  { label: "11:30 PM", value: "11:30 PM" }
];
var TimePicker = ({ onChanged, minValue, ...args }) => {
  const minIndex = minValue && OPTIONS.findIndex((item) => item.value === minValue);
  const options = minIndex ? OPTIONS.slice(minIndex, OPTIONS.length) : OPTIONS;
  return /* @__PURE__ */ (0, import_jsx_runtime72.jsx)(
    Select_default,
    {
      ...args,
      options,
      onChanged: (value) => onChanged && onChanged(createValueByHours(value))
    }
  );
};
var TimePicker_default = TimePicker;

// src/components/atoms/Toggle/Toggle.styles.ts
var import_styled_components67 = __toESM(require("styled-components"));
var import_react_toggle = __toESM(require("react-toggle"));
var ToggleStyle = (0, import_styled_components67.default)(import_react_toggle.default)`
  &.react-toggle {
    touch-action: pan-x;

    display: inline-block;
    position: relative;
    cursor: pointer;
    background-color: transparent;
    border: 0;
    padding: 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    -webkit-tap-highlight-color: transparent;
  }

  & .react-toggle-screenreader-only {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }

  & .react-toggle-track {
    width: ${({ width }) => width || 48}px;
    height: ${({ height }) => height || 24}px;
    padding: 0;
    border-radius: 24px;
    background-color: ${({ theme }) => theme.colors.n40};
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    transition: all 0.2s ease;
  }
  // hover state
  &.react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${({ theme }) => theme.colors.n50};
  }

  &.react-toggle--checked .react-toggle-track {
    background-color: ${({ theme, color: color2 }) => color2 || theme.colors.b50Active};
  }

  &.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${({ theme, color: color2 }) => color2 || theme.colors.b50Hover};
  }
  // disabled state
  &.react-toggle--checked.react-toggle--disabled .react-toggle-track {
    background-color: ${({ theme }) => theme.colors.n60};
  }
  &.react-toggle--disabled .react-toggle-track {
    background-color: ${({ theme }) => theme.colors.n30};
  }

  & .react-toggle-track-check {
    position: absolute;
    width: 14px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    left: 8px;
    opacity: 0;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  &.react-toggle--checked .react-toggle-track-check {
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  & .react-toggle-track-x {
    position: absolute;
    width: 10px;
    height: 10px;
    top: 0px;
    bottom: 0px;
    margin-top: auto;
    margin-bottom: auto;
    line-height: 0;
    right: 10px;
    opacity: 1;
    -webkit-transition: opacity 0.25s ease;
    -moz-transition: opacity 0.25s ease;
    transition: opacity 0.25s ease;
  }

  &.react-toggle--checked .react-toggle-track-x {
    opacity: 0;
  }

  & .react-toggle-thumb {
    transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    position: absolute;
    top: 4px;
    left: 4px;
    width: ${({ theme, thumbsize }) => thumbsize || theme.space * 4}px;
    height: ${({ theme, thumbsize }) => thumbsize || theme.space * 4}px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.white};

    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    -webkit-transition: all 0.25s ease;
    -moz-transition: all 0.25s ease;
    transition: all 0.25s ease;
  }

  &.react-toggle--checked .react-toggle-thumb {
    left: 28px;
  }
`;
var Toggle_styles_default = ToggleStyle;

// src/components/atoms/Toggle/Toggle.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");
function Toggle({ type = "checkbox", label, labelProps = {}, flexProps, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime73.jsxs)(Flex_default, { ...flexProps, children: [
    /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(Toggle_styles_default, { icons: false, type, ...args }),
    label && /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(Box_default, { ml: 1, children: /* @__PURE__ */ (0, import_jsx_runtime73.jsx)(Text_default, { ...labelProps, children: label }) })
  ] });
}
var Toggle_default = Toggle;

// src/components/organisms/WorkingHoursInput/WorkingHoursInput.tsx
var import_jsx_runtime74 = require("react/jsx-runtime");
var TextWrapper = (0, import_styled_components68.default)(Box_default)`
  white-space: nowrap;
`;
var WorkingHoursInput = ({
  onChange,
  onSwitch,
  defaultValue,
  $errorType,
  label,
  withRightIcon = true,
  disabled = false,
  ...args
}) => {
  const theme = (0, import_styled_components68.useTheme)();
  const { t } = (0, import_react_i18next14.useTranslation)("common");
  const [checked, setChecked] = (0, import_react56.useState)(false);
  const [timeStripe, setTimeStripe] = (0, import_react56.useState)({});
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const timerPickerWidth = isMobile ? "100%" : withRightIcon ? 128 : 104;
  const handleTimeSelector = (value, type) => {
    if (type === "from" /* From */) {
      setTimeStripe((prev) => ({
        from: value,
        to: new Date(value).getTime() < new Date(prev?.to || "").getTime() ? prev.to : value
      }));
    }
    setTimeStripe((prev) => ({ ...prev, [type]: value }));
  };
  (0, import_react56.useEffect)(() => {
    if (timeStripe?.from || timeStripe?.to) {
      onChange(timeStripe);
    }
  }, [timeStripe]);
  (0, import_react56.useLayoutEffect)(() => {
    if (defaultValue) {
      setTimeStripe(defaultValue);
      setChecked(true);
    } else {
      setTimeStripe({});
      setChecked(false);
    }
  }, [defaultValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(
    Flex_default,
    {
      flexDirection: isMobile ? "column" : "row",
      alignItems: isMobile ? "flex-start" : "center",
      ...args,
      w: "100%",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(Flex_default, { alignItems: "center", mb: [3, 0, 0, 0], children: [
          label && /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Box_default, { mr: 3, w: 48, children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Text_default, { children: label }) }),
          /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
            Toggle_default,
            {
              color: theme.colors.g20,
              width: 60,
              height: 32,
              thumbsize: 24,
              icons: {
                checked: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Icon_default, { name: "check", color: theme.colors.white, size: 12 }),
                unchecked: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Icon_default, { name: "close", color: theme.colors.white, size: 12 })
              },
              checked,
              onChange: (e) => {
                setChecked(e.target.checked);
                if (!e.target.checked) {
                  setTimeStripe({});
                }
                if (onSwitch) {
                  onSwitch(e.target.checked);
                }
              },
              disabled
            }
          )
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime74.jsxs)(Flex_default, { w: "100%", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
            TimePicker_default,
            {
              ml: [0, 3, 3, 3],
              placeholder: "00:00 AM",
              w: timerPickerWidth,
              minValue: "05:00 AM",
              value: timeStripe.from ? (0, import_moment4.default)(timeStripe.from).format("hh:mm A") : void 0,
              disabled: disabled || !checked,
              onChanged: (value) => handleTimeSelector(value, "from" /* From */),
              isSearchable: false,
              $errorType,
              components: withRightIcon ? {} : { DropdownIndicator: () => null }
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(TextWrapper, { mx: isMobile ? 1 : 5, children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(Text_default, { whiteSpace: "nowrap", children: t("labels.to").toUpperCase() }) }),
          /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
            TimePicker_default,
            {
              placeholder: "00:00 PM",
              w: timerPickerWidth,
              value: timeStripe.to ? (0, import_moment4.default)(timeStripe.to).format("hh:mm A") : void 0,
              minValue: timeStripe.from ? (0, import_moment4.default)(defaultValue?.from || timeStripe.from).format("hh:mm A") : "05:00 AM",
              disabled: disabled || !checked,
              onChanged: (value) => handleTimeSelector(value, "to" /* To */),
              isSearchable: false,
              $errorType,
              components: withRightIcon ? {} : { DropdownIndicator: () => null }
            }
          )
        ] })
      ]
    }
  );
};
var WorkingHoursInput_default = WorkingHoursInput;

// src/components/atoms/Form/WorkingWeekHoursInput/WorkingWeekHoursInput.tsx
var import_jsx_runtime75 = require("react/jsx-runtime");
var StyledWrapper2 = (0, import_styled_components69.default)(Flex_default)`
  max-width: 966px;
`;
var WorkingWeekHoursInput = ({
  formField,
  disabled
}) => {
  const { stateHandlers, formState } = (0, import_react57.useContext)(FormContext);
  const { t } = (0, import_react_i18next15.useTranslation)(["forms", "common"]);
  const handleTimePickerValue = (day) => (value) => {
    stateHandlers[formField]({
      ...formState.workingHours,
      [day]: value
    });
  };
  const setDefaultWorkingHours = (day) => (checked) => {
    if (!checked) {
      stateHandlers[formField]({
        ...formState.workingHours,
        [day]: null
      });
    } else {
      const [defaultFrom, defaultTo] = [
        (0, import_moment5.default)().set({ hour: 5, minute: 0, second: 0, millisecond: 0 }).toISOString(),
        (0, import_moment5.default)().set({ hour: 22, minute: 0, second: 0, millisecond: 0 }).toISOString()
      ];
      stateHandlers[formField]({
        ...formState.workingHours,
        [day]: { from: defaultFrom, to: defaultTo }
      });
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(StyledWrapper2, { flexWrap: "wrap", justifyContent: "space-between", children: Object.values(import_dash_common19.WeekDays).map((day) => {
    const date = formState.workingHours && formState.workingHours[day];
    return /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(Box_default, { w: "100%", mb: 9, children: /* @__PURE__ */ (0, import_jsx_runtime75.jsx)(
      WorkingHoursInput_default,
      {
        disabled,
        label: t(`common:labels.weekDays.${day}`).slice(0, day === import_dash_common19.WeekDays.Tuesday ? 4 : 3).toUpperCase(),
        onChange: handleTimePickerValue(day),
        onSwitch: setDefaultWorkingHours(day),
        ...date && { defaultValue: date }
      }
    ) }, day);
  }) });
};
var WorkingWeekHoursInput_default = WorkingWeekHoursInput;

// src/components/atoms/Steps/Steps.helpers.ts
var getStepStatus = (stepIndex, activeStep) => {
  if (Number.isInteger(activeStep)) {
    if (activeStep === stepIndex) {
      return "ACTIVE" /* ACTIVE */;
    }
    if (activeStep && activeStep > stepIndex) {
      return "PASSED" /* PASSED */;
    }
  }
  return "DISABLED" /* DISABLED */;
};

// src/components/atoms/Steps/Steps.styles.ts
var import_styled_components70 = __toESM(require("styled-components"));
var stepStyle = import_styled_components70.css`
  ${({ theme, status }) => {
  const statusStyleRelations = {
    ["ACTIVE" /* ACTIVE */]: import_styled_components70.css`
        color: ${theme.colors.black};
        border-bottom: 1px solid ${theme.colors.g20};
      `,
    ["DISABLED" /* DISABLED */]: import_styled_components70.css`
        color: ${theme.colors.n70};
        cursor: default;
      `,
    ["PASSED" /* PASSED */]: import_styled_components70.css`
        color: ${theme.colors.g20};
        padding: 8px 10px;
      `
  };
  return statusStyleRelations[status] || "";
}}
`;
var StepButtonStyle = import_styled_components70.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  background-color: transparent;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  ${textStyle}
  ${stepStyle}
`;

// src/components/atoms/Steps/Steps.tsx
var import_jsx_runtime76 = require("react/jsx-runtime");
function Steps({ steps: steps2, activeStep, onClick, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(Flex_default, { ...args, children: steps2.map(({ label, icon }, index2) => {
    const stepStatus = getStepStatus(index2, activeStep);
    const isPassed = stepStatus === "PASSED" /* PASSED */;
    return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(
      StepButtonStyle,
      {
        onClick: () => isPassed && onClick(index2),
        status: stepStatus,
        children: [
          isPassed && /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(Icon_default, { name: icon || "check", size: 14, mr: 2 }),
          label
        ]
      },
      index2 + label
    );
  }) });
}
var Steps_default = Steps;

// src/components/atoms/Breadcrumb/Breadcrumb.helpers.ts
var cutBreadcrumbItemsByLimit = (items, limit) => {
  const withLimit = items.length > limit && limit > 3;
  if (withLimit) {
    const limitedItems = [...items];
    const startFrom = limit - 3;
    const endTo = items.length - limit + 1;
    limitedItems.splice(startFrom, endTo, { label: "..." });
    return limitedItems;
  }
  return items;
};

// src/components/atoms/Breadcrumb/Breadcrumb.styles.ts
var import_styled_components71 = __toESM(require("styled-components"));
var InlineFlexBox = import_styled_components71.default.span`
  ${textStyle};
  display: inline-flex;
  color: ${({ theme }) => theme.colors.n70};
`;
var BreadcrumbItemStyle = import_styled_components71.default.a`
  ${textStyle};
  display: inline-flex;
  align-items: center;
  cursor: ${({ enabledNavigation }) => enabledNavigation ? "pointer" : "default"};
  ${({ enabledNavigation }) => enabledNavigation && "&:hover { text-decoration: underline;}"};
  color: ${({ theme, active }) => active ? theme.colors.n90 : theme.colors.n70};
`;

// src/components/atoms/Breadcrumb/Breadcrumb.tsx
var import_jsx_runtime77 = require("react/jsx-runtime");
function Breadcrumb({
  items,
  limit = 20,
  onNavigate,
  withIcon = true,
  ...args
}) {
  const breadcrumbItems = cutBreadcrumbItemsByLimit(items, limit);
  return /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Box_default, { ...args, children: breadcrumbItems.map(({ label, icon, path }, index2) => {
    const isFirst = index2 === 0;
    const isLast = index2 === breadcrumbItems.length - 1;
    const enabledNavigation = !isLast && !!path;
    return /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(InlineFlexBox, { children: [
      !isFirst && /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Flex_default, { ml: 2, mr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Text_default, { md: true, children: "/" }) }),
      /* @__PURE__ */ (0, import_jsx_runtime77.jsxs)(
        BreadcrumbItemStyle,
        {
          onClick: () => enabledNavigation && onNavigate(path),
          enabledNavigation,
          active: isLast,
          children: [
            isFirst && withIcon && /* @__PURE__ */ (0, import_jsx_runtime77.jsx)(Icon_default, { name: icon || "home1", size: 14, mr: 2 }),
            label
          ]
        }
      )
    ] }, `${path}-${index2}`);
  }) });
}
var Breadcrumb_default = Breadcrumb;

// src/components/atoms/Tabs/Tabs.tsx
var import_react58 = require("react");
var import_styled_components73 = require("styled-components");

// src/components/atoms/Tabs/Tabs.styles.ts
var import_styled_components72 = __toESM(require("styled-components"));
var tabStyle = import_styled_components72.css`
  ${({
  theme,
  variation,
  active,
  activeButtonColor
}) => {
  const basePrimaryStyle = import_styled_components72.css`
      background-color: ${active ? theme.colors.b50 : theme.colors.b20};
      & p {
        color: ${active && theme.colors.white};
      }

      &:hover {
        & p {
          color: ${!active && theme.colors.b50};
        }
      }
      &:disabled {
        background-color: ${theme.colors.n20};
      }
    `;
  const statusStyleRelations = {
    primary: basePrimaryStyle,
    secondary: import_styled_components72.css`
        background-color: transparent;
        color: ${active && (activeButtonColor || theme.colors.g20)};
        & p {
          color: ${active && (activeButtonColor || theme.colors.g20)};
          font-weight: ${active ? "bold" : "normal"};
        }
        border-bottom: 1px solid
          ${active ? activeButtonColor || theme.colors.g20 : theme.colors.n30};
        &:hover {
          color: ${activeButtonColor || theme.colors.g20};
          & p {
            color: ${activeButtonColor || theme.colors.g20};
          }
        }
      `,
    primaryRounded: import_styled_components72.css`
        ${basePrimaryStyle}
        border-radius: 8px;
      `
  };
  return statusStyleRelations[variation] || "";
}}
`;
var TabButtonStyle = import_styled_components72.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  padding: 8px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: ${({ isFullWidthTabs, tabsLength, withScrollButtons }) => !isFullWidthTabs || withScrollButtons ? "fit-content" : `calc(${100 / tabsLength}%)`};

  &:disabled {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.n70};
  }

  ${textStyle}
  ${tabStyle}
  @media ${({ theme }) => theme.devices.mobile} {
    padding: 8px 12px;
    ${({ adaptiveFullWidthTabs }) => adaptiveFullWidthTabs && "width: 100%"};
  }

  @media ${({ theme }) => theme.devices.tablet} {
    ${({ adaptiveFullWidthTabs }) => adaptiveFullWidthTabs && "width: 100%"};
  }
`;
var TabsWrapperStyle = (0, import_styled_components72.default)(Flex_default)`
  ${({
  variation,
  theme,
  withScrollButtons
}) => import_styled_components72.css`
    ${withScrollButtons && import_styled_components72.css`
      max-width: 100%;

      ::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;

      button {
        white-space: nowrap;
      }
    `}
    @media ${({ theme: theme2 }) => theme2.devices.mobile} {
      & button {
        flex-shrink: 2;
        min-width: ${withScrollButtons ? "fit-content" : "auto"};
        &:last-child {
          flex-shrink: 1;
          min-width: ${withScrollButtons ? "fit-content" : "auto"};
        }
        &:first-child {
          flex-shrink: 1;
          min-width: ${withScrollButtons ? "fit-content" : "auto"};
        }
      }
    }
    ${variation === "primary" && import_styled_components72.css`
      & button {
        &:last-child {
          border-right-width: 1px;
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
        }
        &:first-child {
          border-right-width: 1px;
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
      }
    `}

    ${variation === "primaryRounded" && import_styled_components72.css`
      background-color: ${theme.colors.b20};
      border-radius: ${({ theme: theme2 }) => theme2.space}px;

      & button {
        border-radius: ${({ theme: theme2 }) => theme2.space}px;
      }
    `}
  `}
`;
var ArrowContainer = (0, import_styled_components72.default)(Box_default)`
  cursor: pointer;
  display: ${({ isVisible }) => isVisible ? "block" : "none"};
`;

// src/components/atoms/Tabs/Tabs.tsx
var import_jsx_runtime78 = require("react/jsx-runtime");
function Tabs({
  tabs,
  activeTab,
  onClick,
  variation = "primary",
  isFullWidthTabs = false,
  adaptiveFullWidthTabs = false,
  withScrollButtons = false,
  activeButtonColor,
  ...args
}) {
  const containerRef = (0, import_react58.useRef)(null);
  const [scrollX, setScrollX] = (0, import_react58.useState)(0);
  const [scrollEnd, setScrollEnd] = (0, import_react58.useState)(false);
  const theme = (0, import_styled_components73.useTheme)();
  (0, import_react58.useEffect)(() => {
    if (containerRef.current && activeTab) {
      if (containerRef.current.scrollWidth > containerRef.current.clientWidth) {
        setScrollEnd(true);
      }
    }
  }, [activeTab]);
  const slide = (shift) => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += shift;
      if (Math.floor(containerRef.current.scrollWidth - containerRef.current.scrollLeft) <= containerRef.current.offsetWidth) {
        setScrollEnd(false);
      } else {
        setScrollEnd(true);
      }
    }
  };
  const scrollCheck = () => {
    if (containerRef.current) {
      setScrollX(containerRef.current.scrollLeft);
      if (Math.floor(containerRef.current.scrollWidth - containerRef.current.scrollLeft) <= containerRef.current.offsetWidth) {
        setScrollEnd(false);
      } else {
        setScrollEnd(true);
      }
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime78.jsxs)(import_jsx_runtime78.Fragment, { children: [
    withScrollButtons && /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(ArrowContainer, { isVisible: scrollX !== 0, children: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(Icon_default, { name: "arrowLeft", color: theme.colors.b50, onClick: () => slide(-100), size: 24 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
      TabsWrapperStyle,
      {
        ...withScrollButtons && {
          mx: 2,
          overflow: "auto",
          ref: containerRef,
          withScrollButtons,
          onScroll: scrollCheck
        },
        variation,
        ...args,
        children: tabs.map(({ label, key, disabled, children }) => /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(
          TabButtonStyle,
          {
            withScrollButtons,
            tabsLength: tabs.length,
            disabled,
            variation,
            semibold: activeTab === key,
            active: activeTab === key,
            isFullWidthTabs,
            adaptiveFullWidthTabs,
            activeButtonColor,
            onClick: () => !disabled && onClick(key),
            type: "button",
            children: children ? children : /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(Text_default, { ellipsis: true, children: label })
          },
          key
        ))
      }
    ),
    withScrollButtons && /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(ArrowContainer, { isVisible: scrollEnd, children: /* @__PURE__ */ (0, import_jsx_runtime78.jsx)(Icon_default, { name: "arrowRight", color: theme.colors.b50, onClick: () => slide(100), size: 24 }) })
  ] });
}
var Tabs_default = Tabs;

// src/components/atoms/Alert/Alert.tsx
var import_react59 = require("react");
var import_styled_components74 = __toESM(require("styled-components"));
var import_jsx_runtime79 = require("react/jsx-runtime");
var AlertStyle = (0, import_styled_components74.default)(Flex_default)`
  border-radius: ${({ theme }) => 2 * theme.space}px;
  ${({ type }) => {
  const states = {
    ["info" /* Info */]: import_styled_components74.css`
        color: ${({ theme }) => theme.colors.b50};
        border: 1px solid ${({ theme }) => theme.colors.b40};
        background-color: ${({ theme }) => theme.colors.b40};
      `,
    ["valid" /* Valid */]: import_styled_components74.css`
        color: ${({ theme }) => theme.colors.g20};
        border: 1px solid ${({ theme }) => theme.colors.g10};
        background-color: ${({ theme }) => theme.colors.g10};
      `,
    ["invalid" /* Invalid */]: import_styled_components74.css`
        color: ${({ theme }) => theme.colors.r20};
        border: 1px solid ${({ theme }) => theme.colors.r20};
        background-color: ${({ theme }) => theme.colors.r20};
      `
  };
  return type ? states[type] : "";
}}
`;
function Alert({ children, type, duration = 3e3, alertType, ...args }) {
  const { toggleAlert } = (0, import_react59.useContext)(AlertsContext);
  (0, import_react59.useEffect)(() => {
    const timeoutId = setTimeout(() => {
      if (alertType) {
        toggleAlert(alertType, false);
      }
    }, duration);
    return () => clearTimeout(timeoutId);
  }, [alertType]);
  return /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(AlertStyle, { px: 3, py: 2, type, ...args, children: /* @__PURE__ */ (0, import_jsx_runtime79.jsx)(Text_default, { color: "inherit", children }) });
}
var Alert_default = Alert;

// src/components/atoms/A/A.tsx
var import_styled_components75 = __toESM(require("styled-components"));
var import_jsx_runtime80 = require("react/jsx-runtime");
var ellipsisStyle2 = import_styled_components75.css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-line-clamp: ${({ clamp }) => clamp || 1};
  -webkit-box-orient: vertical;
`;
var textStyle3 = import_styled_components75.css`
  margin-block-start: unset;
  margin-block-end: unset;
  font-family: 'Work Sans';
  font-style: normal;
  font-weight: ${({ theme, bold, semibold, medium, regular = true }) => getFontWeight(theme, {
  bold,
  semibold,
  medium,
  regular
})};
  font-size: ${({ theme, xs, sm, md, lg, xl }) => getSize(theme, { xs, sm, md, lg, xl }, "fontSize")}px;
  line-height: ${({ theme, xs, sm, md, lg, xl }) => getSize(theme, { xs, sm, md, lg, xl }, "lineHeight")}px;
  color: ${({ color: color2 }) => color2 || mainTheme.colors.b50};
  cursor: pointer;
  text-decoration-line: ${({ textDecoration }) => textDecoration || "underline"};
  ${({ ellipsis }) => ellipsis ? ellipsisStyle2 : ""}
`;
var AnchorStyles = import_styled_components75.default.a`
  ${textStyle3}
`;
function A({ children, ...args }) {
  return /* @__PURE__ */ (0, import_jsx_runtime80.jsx)(AnchorStyles, { ...args, children });
}
var A_default = A;

// src/components/atoms/Stepper/Stepper.tsx
var import_react60 = require("react");
var import_styled_components76 = __toESM(require("styled-components"));
var import_jsx_runtime81 = require("react/jsx-runtime");
var Line = (0, import_styled_components76.default)(Flex_default)`
  background: ${({ theme, isActive }) => isActive ? theme.colors.b100 : theme.colors.n30};
`;
var Dot = (0, import_styled_components76.default)(Flex_default)`
  background-color: ${({ theme, isComplete }) => isComplete ? theme.colors.b100 : "transpared"};
  border-radius: 50%;
  position: relative;
  border: 2px solid
    ${({ theme, isComplete, isActive }) => isComplete || isActive ? theme.colors.b100 : theme.colors.n30}; ;
`;
var TextBoxStyle = (0, import_styled_components76.default)(Box_default)`
  position: absolute;
  width: max-content;
  top: ${({ theme }) => theme.space * 4}px;
  ${({ isLast, isMiddle }) => isLast ? "right: 0px" : !isMiddle && "left: 0"}
`;
function Stepper({ steps: steps2, activeStep, ...args }) {
  const theme = (0, import_styled_components76.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Flex_default, { flex: 1, ...args, children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Flex_default, { pb: 6, flex: 1, alignItems: "center", ...args, children: steps2.map(({ label, value }, index2) => {
    const isActive = index2 === activeStep;
    const isComplete = index2 < (activeStep || 0);
    const isLastItem = index2 === steps2.length - 1;
    return /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)(import_react60.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime81.jsxs)(
        Dot,
        {
          alignItems: "center",
          justifyContent: "center",
          isActive,
          isComplete,
          flexGrow: 0,
          w: 14,
          h: 14,
          children: [
            isComplete && /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Icon_default, { color: theme.colors.white, size: 8, name: "check" }),
            /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(TextBoxStyle, { isLast: isLastItem, isMiddle: !isLastItem && index2 !== 0, children: /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Text_default, { color: isComplete ? theme.colors.b50 : theme.colors.n70, children: label }) })
          ]
        }
      ),
      !isLastItem && /* @__PURE__ */ (0, import_jsx_runtime81.jsx)(Line, { isActive: isComplete, flex: 1, flexGrow: 1, h: 2 })
    ] }, value);
  }) }) });
}
var Stepper_default = Stepper;

// src/components/atoms/Card/Card.tsx
var import_styled_components77 = __toESM(require("styled-components"));
var Card = (0, import_styled_components77.default)(Flex_default)`
  min-width: 0;
  border-radius: ${({ theme, borderRadius }) => borderRadius || theme.space * 2}px;
  box-shadow: ${({ theme, shadow }) => shadow || theme.shadows.shadow2};
  background-color: ${({ theme, bgColor }) => bgColor || theme.colors.white};
`;
var Card_default = Card;

// src/components/atoms/Video/Video.tsx
var import_styled_components78 = __toESM(require("styled-components"));
var import_jsx_runtime82 = require("react/jsx-runtime");
var IconWrapper4 = (0, import_styled_components78.default)(Flex_default)`
  z-index: 1;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.black, 20)};
  cursor: pointer;
`;
var Video = ({
  src,
  controlsList,
  controls,
  autoPlay,
  withPlayIcon = true,
  maxHeight,
  w,
  h,
  fit = "cover",
  ...props
}) => {
  const theme = (0, import_styled_components78.useTheme)();
  usePermission();
  const resolvedMaxHeight = typeof maxHeight === "object" ? maxHeight[0] : maxHeight;
  return /* @__PURE__ */ (0, import_jsx_runtime82.jsxs)(Box_default, { w: w || "100%", h: h || "100%", pos: "relative", ...props, children: [
    withPlayIcon && /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
      IconWrapper4,
      {
        justifyContent: "center",
        alignItems: "center",
        pos: "absolute",
        w: "100%",
        h: "100%",
        children: /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(Icon_default, { name: "playCircleOutline", size: 46, color: theme.colors.white })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime82.jsx)(
      "video",
      {
        width: "100%",
        height: "100%",
        src,
        controls,
        autoPlay,
        controlsList: "nodownload",
        style: {
          objectFit: fit,
          ...resolvedMaxHeight != null && { maxHeight: resolvedMaxHeight }
        }
      }
    )
  ] });
};
var Video_default = Video;

// src/components/atoms/FileList/FileList.tsx
var import_styled_components79 = __toESM(require("styled-components"));
var import_jsx_runtime83 = require("react/jsx-runtime");
var StyledBadge2 = (0, import_styled_components79.default)(Badge_default)`
  & svg {
    cursor: pointer;
  }
`;
var FileList = ({ files, ...args }) => {
  const theme = (0, import_styled_components79.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(Flex_default, { ...args, children: files.map((fileItem) => /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(
    StyledBadge2,
    {
      square: true,
      my: 1,
      mr: 2,
      onClick: () => {
        if (fileItem.onClick) {
          fileItem.onClick(fileItem._id);
        }
      },
      title: fileItem.name,
      renderLeftIcon: fileItem.isLoading ? () => /* @__PURE__ */ (0, import_jsx_runtime83.jsx)(Spinner_default, { size: 16, mr: 1, color: "inherit" }) : void 0,
      iconRight: Boolean(fileItem.onRemoveIconClick) ? "close" : void 0,
      iconRightProps: {
        onClick: () => {
          if (fileItem.onRemoveIconClick) {
            fileItem.onRemoveIconClick(fileItem._id);
          }
        },
        size: 16,
        color: theme.colors.r20
      }
    },
    fileItem._id
  )) });
};
var FileList_default = FileList;

// src/components/molecules/Avatar/Avatar.tsx
var import_styled_components80 = __toESM(require("styled-components"));
var import_jsx_runtime84 = require("react/jsx-runtime");
var getTextSize = (theme, { xs, sm, md, lg, xl, xxl }, textFieldType) => {
  const sizeArray = theme.typography[textFieldType][xxl ? "header" : "text"];
  const size = { xs, sm, md, lg, xl, xxl };
  const index2 = Object.keys(size).findIndex((key) => !!size[key]);
  return sizeArray[index2 === 0 ? index2 + 1 : index2] || sizeArray[2];
};
var getSize2 = ({ size, xs, sm, md, lg, xl, xxl }) => {
  return size ? size : xs && 24 || sm && 32 || md && 44 || lg && 48 || xl && 56 || xxl && 96 || 44;
};
var avatarStyle = import_styled_components80.css`
  border-radius: 50%;
  background-color: unset;
`;
var ButtonStyle2 = import_styled_components80.default.button`
  -webkit-appearance: none;
  -moz-appearance: none;
  border: unset;
  cursor: pointer;
  ${avatarStyle}
  ${boxStyle};
`;
var BoxStyle3 = (0, import_styled_components80.default)(Box_default)`
  ${avatarStyle}
`;
var ImgStyle2 = import_styled_components80.default.img`
  ${avatarStyle}
  ${({ size }) => size ? `width:${size}${typeof size === "number" ? "px" : ""};` : ""}
  ${({ size }) => size ? `height:${size}${typeof size === "number" ? "px" : ""};` : ""}
  object-fit: cover;
`;
var AvatarPlaceholderStyle = (0, import_styled_components80.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.b20};
  color: ${({ theme }) => theme.colors.b50};
  border-radius: 50%;
`;
var LabelStyle2 = (0, import_styled_components80.default)(Text_default)`
  color: ${({ theme }) => theme.colors.b50};
  font-size: ${({ theme, xs, sm, md, lg, xl, xxl }) => getTextSize(theme, { xs, sm, md, lg, xl, xxl }, "fontSize")}px;
  line-height: ${({ theme, xs, sm, md, lg, xl, xxl }) => getTextSize(theme, { xs, sm, md, lg, xl, xxl }, "lineHeight")}px;
`;
function AvatarPlaceholder({
  firstName = "",
  lastName = "",
  size,
  ...textSize
}) {
  const first = firstName?.toUpperCase()[0] || "";
  const last = lastName?.toUpperCase()[0] || "";
  const slag = `${first}${last}`;
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(AvatarPlaceholderStyle, { w: size, h: size, alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(LabelStyle2, { ...textSize, children: slag || "D" }) });
}
function AvatarImage({ url, size }) {
  return /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(ImgStyle2, { src: url, size });
}
function Avatar({ firstName, lastName, url, onClick, ...args }) {
  const size = getSize2(args);
  const Content = url ? /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(AvatarImage, { url, size }) : /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(AvatarPlaceholder, { firstName, lastName, ...args, size });
  return onClick ? /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(ButtonStyle2, { w: size, h: size, onClick, ...args, children: Content }) : /* @__PURE__ */ (0, import_jsx_runtime84.jsx)(BoxStyle3, { w: size, h: size, ...args, children: Content });
}
var Avatar_default = Avatar;

// src/components/molecules/Table/Table.tsx
var import_react_table = require("react-table");
var import_react_table_sticky = require("react-table-sticky");
var import_styled_components81 = __toESM(require("styled-components"));
var import_jsx_runtime85 = require("react/jsx-runtime");
var TableStyle = import_styled_components81.default.table`
  ${boxStyle}
  ${textStyle}
  color: ${({ theme }) => theme.colors.n80};
  border-spacing: 0;
  width: 100%;
  text-align: left;
  border-radius: ${({ theme }) => theme.space}px;
  & thead {
    position: ${({ stickyHeader }) => stickyHeader ? "sticky" : "static"};
    top: ${({ stickyHeader }) => stickyHeader ? 0 : "unset"};
    & tr {
      min-height: 48px;
      & th {
        white-space: nowrap;
        padding: unset;
        font-weight: normal;
        border: unset;
        vertical-align: ${({ isSticky }) => isSticky ? "top" : "middle"};
        padding-left: ${({ theme }) => theme.space * 2}px;
        padding-top: ${({ theme, isSticky }) => theme.space * (isSticky ? 3 : 0)}px;
        &:first-child {
          padding-left: ${({ theme }) => theme.space * 6}px;
        }
        &:last-child {
          padding-right: ${({ theme }) => theme.space * 6}px;
        }
        background-color: ${({ theme }) => theme.colors.white};
      }
    }
  }
  & tbody {
    & tr {
      cursor: pointer;
      & td {
        white-space: nowrap;
        border: unset;
        vertical-align: ${({ isSticky }) => isSticky ? "top" : "middle"};
        padding-left: ${({ theme }) => theme.space * 2}px;
        padding-top: ${({ theme }) => theme.space * 3}px;
        padding-bottom: ${({ theme }) => theme.space * 3}px;
        &:first-child {
          padding-left: ${({ theme }) => theme.space * 6}px;
        }
        &:last-child {
          padding-right: ${({ theme }) => theme.space * 6}px;
        }
        background-color: ${({ theme }) => theme.colors.white};
      }
      &:nth-child(odd) td {
        background-color: ${({ theme }) => theme.colors.b10};
      }
      &:last-child > td {
        border-bottom: 1px solid ${({ theme }) => theme.colors.n20};
      }
    }
  }
  & {
    [data-sticky-td] {
      // to fix shadow when more then one columns are sticked
      z-index: 4 !important;
    }
    [data-sticky-last-left-td] {
      box-shadow: ${({ theme }) => theme.shadows.shadow1};
      z-index: 3 !important;
    }

    [data-sticky-first-right-td] {
      box-shadow: ${({ theme }) => theme.shadows.shadow1};
      z-index: 3;
    }
  }
`;
var PlaceholderStyle = (0, import_styled_components81.default)(Flex_default)`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  color: ${({ theme }) => theme.colors.n80};
`;
function Table({
  columns,
  data,
  placeholder,
  placeholderProps,
  renderBody,
  defaultColumn,
  layouts: layouts2 = [],
  loading = false,
  loadingProps = {},
  withHeader = true,
  stickyHeader = false,
  onRowClick,
  ...boxArgs
}) {
  const theme = (0, import_styled_components81.useTheme)();
  const tableProps = (0, import_react_table.useTable)(
    {
      columns,
      data,
      defaultColumn
    },
    ...layouts2
  );
  const stickyTableProps = (0, import_react_table.useTable)(
    {
      columns,
      data,
      defaultColumn
    },
    import_react_table.useBlockLayout,
    import_react_table_sticky.useSticky
  );
  const isSticky = columns.find(({ sticky }) => !!sticky);
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } = isSticky ? stickyTableProps : tableProps;
  return /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)(Box_default, { pos: "relative", ...boxArgs, children: [
    /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)(TableStyle, { ...getTableProps(), isSticky, stickyHeader, children: [
      withHeader && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("thead", { children: headerGroups.map(
        (headerGroup) => /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("tr", { ...headerGroup.getHeaderGroupProps(), children: headerGroup.headers.map((column) => /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("th", { ...column.getHeaderProps(), children: column.render("Header") })) })
      ) }),
      !renderBody && Boolean(data.length) && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("tbody", { ...getTableBodyProps(), children: rows.map(
        (row) => {
          prepareRow(row);
          return /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(
            "tr",
            {
              ...row.getRowProps(),
              onClick: () => {
                if (onRowClick) {
                  onRowClick(row.original);
                }
              },
              children: row.cells.map((cell) => {
                return /* @__PURE__ */ (0, import_jsx_runtime85.jsx)("td", { ...cell.getCellProps(), children: cell.render("Cell") });
              })
            }
          );
        }
      ) }),
      renderBody ? renderBody(getTableBodyProps()) : null
    ] }),
    (placeholderProps || placeholder) && !data.length && /* @__PURE__ */ (0, import_jsx_runtime85.jsxs)(
      PlaceholderStyle,
      {
        py: 45,
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        children: [
          placeholderProps?.image && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(Image_default, { src: placeholderProps.image, w: 180, h: 180, mb: 8 }),
          placeholderProps?.title && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(Text_default, { children: placeholderProps.title }),
          placeholderProps?.label || placeholder && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(Text_default, { children: placeholderProps?.label || placeholder }),
          placeholderProps?.buttonProps && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(Button_default, { ...placeholderProps.buttonProps })
        ]
      }
    ),
    loading && /* @__PURE__ */ (0, import_jsx_runtime85.jsx)(Spinner_default, { size: 32, color: theme.colors.b50, fullContent: true, ...loadingProps })
  ] });
}
var Table_default = Table;

// src/components/molecules/Table/components/SortHeader/SortHeader.tsx
var import_styled_components82 = __toESM(require("styled-components"));
var import_react61 = require("react");
var import_jsx_runtime86 = require("react/jsx-runtime");
var FlexStyle = (0, import_styled_components82.default)(Flex_default)`
  cursor: pointer;
`;
function SortHeader({
  children,
  accessor,
  isDefault = false,
  sortOrder: sortOrderProp = 1,
  variation = "blue",
  reversed = false
}) {
  const { state, setSortState } = (0, import_react61.useContext)(SortContext);
  const [sortOrder, setSortOrder] = (0, import_react61.useState)(sortOrderProp);
  const theme = (0, import_styled_components82.useTheme)();
  const onClickSpy = (0, import_react61.useCallback)(() => {
    setSortOrder(sortOrder * -1);
    setSortState({
      fieldName: accessor,
      sortOrder: sortOrder * -1
    });
  }, [sortOrder]);
  (0, import_react61.useEffect)(() => {
    if (isDefault) {
      setSortState({
        fieldName: accessor,
        sortOrder: sortOrderProp
      });
    }
  }, [accessor, isDefault, sortOrderProp]);
  const isActive = state.fieldName === accessor;
  const iconColor = variation === "blue" ? theme.colors.b50 : theme.colors.g20;
  return /* @__PURE__ */ (0, import_jsx_runtime86.jsxs)(FlexStyle, { alignItems: "center", onClick: onClickSpy, children: [
    children,
    /* @__PURE__ */ (0, import_jsx_runtime86.jsx)(
      Icon_default,
      {
        size: 19,
        name: sortOrder === (reversed ? -1 : 1) ? "arrowUp" : "arrowDown",
        color: isActive ? iconColor : "inherit",
        ml: 2
      }
    )
  ] });
}
var SortHeader_default = SortHeader;

// src/components/molecules/Pagination/Pagination.tsx
var import_styled_components83 = __toESM(require("styled-components"));
var import_react62 = require("react");

// src/components/molecules/Pagination/helper.ts
var pageButtons = ({ isMobile, currentPage, countOfPage }) => {
  const limit = isMobile ? 3 : 7;
  if ([1, 2, 3].includes(countOfPage)) {
    return Array.from(Array(countOfPage).keys());
  }
  const isExtremeLeft = currentPage <= Math.floor(limit / 2) - 1;
  if (isExtremeLeft) {
    const pages = countOfPage < limit ? countOfPage : limit;
    return Array.from(Array(pages).keys());
  }
  const isExtremeRight = currentPage >= countOfPage - Math.floor(limit / 2);
  if (isExtremeRight) {
    return Array.from(Array(countOfPage).keys()).slice(-limit);
  }
  return Array.from(Array(countOfPage).keys()).slice(currentPage - Math.floor(limit / 2), currentPage + Math.floor(limit / 2) + 1);
};

// src/components/molecules/Pagination/Pagination.tsx
var import_jsx_runtime87 = require("react/jsx-runtime");
var PaginationWrapper = (0, import_styled_components83.default)(Flex_default)`
  button > div {
    white-space: nowrap;
  }
`;
var StyledButton = (0, import_styled_components83.default)(Button_default)`
  * {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
`;
function Pagination({
  previousButtonLabel,
  nextButtonLabel,
  countPerPage = 7,
  paginationAction,
  ...args
}) {
  const { state, goToPage, setButtons } = (0, import_react62.useContext)(PaginationContext);
  const { currentPage, total, perPage, buttons } = state;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const onGoBack = (0, import_react62.useCallback)(() => {
    goToPage(currentPage - 1);
  }, [currentPage, goToPage]);
  const onGoForward = (0, import_react62.useCallback)(() => {
    goToPage(currentPage + 1);
  }, [currentPage, goToPage]);
  const countOfPage = Math.ceil(total / perPage);
  (0, import_react62.useEffect)(() => {
    const array = pageButtons({ isMobile, currentPage, countOfPage });
    setButtons(array);
  }, [countOfPage, currentPage, isMobile]);
  return countOfPage > 1 ? /* @__PURE__ */ (0, import_jsx_runtime87.jsxs)(PaginationWrapper, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime87.jsxs)(
      StyledButton,
      {
        disabled: currentPage === 0,
        mr: 1,
        px: 4,
        w: "unset",
        medium: true,
        variation: "flat",
        onClick: () => {
          if (paginationAction) {
            paginationAction();
          } else
            onGoBack();
        },
        minWidth: "unset",
        type: "button",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(Icon_default, { name: "chevronLeft", size: 16, mr: 2 }),
          previousButtonLabel
        ]
      }
    ),
    buttons.map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
      Button_default,
      {
        mr: 1,
        variation: buttons[index2] === currentPage ? "primary" : "flat",
        medium: true,
        square: true,
        onClick: () => {
          if (paginationAction) {
            paginationAction();
          } else
            goToPage(buttons[index2]);
        },
        type: "button",
        children: buttons[index2] + 1
      },
      `pagination-button-${buttons[index2]}`
    )),
    /* @__PURE__ */ (0, import_jsx_runtime87.jsxs)(
      StyledButton,
      {
        px: 4,
        w: "unset",
        medium: true,
        variation: "flat",
        onClick: () => {
          if (paginationAction) {
            paginationAction();
          } else
            onGoForward();
        },
        disabled: currentPage + 1 === countOfPage,
        minWidth: "unset",
        type: "button",
        children: [
          nextButtonLabel,
          /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(Icon_default, { name: "chevronRight", size: 16, ml: 2 })
        ]
      }
    )
  ] }) : null;
}
function PaginationPerPageSelect({
  options = [10, 25, 50, 100],
  label = "",
  defaultValue,
  menuPosition,
  ...args
}) {
  const { state, setPerPage } = (0, import_react62.useContext)(PaginationContext);
  (0, import_react62.useEffect)(() => {
    if (defaultValue) {
      setPerPage(defaultValue);
    }
  }, [defaultValue]);
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
    Select_default,
    {
      menuPosition,
      options: options.map((value) => ({
        value: value.toString(),
        label: value.toString()
      })),
      onChanged: (value) => {
        if (value) {
          setPerPage(parseInt(value));
        }
      },
      withCheckbox: false,
      isSearchable: false,
      leftIcon: null,
      valuePrefix: label,
      value: state.perPage.toString(),
      ...args
    }
  );
}
function PaginationInfoLabel({ label = "", ...args }) {
  const { state } = (0, import_react62.useContext)(PaginationContext);
  const { currentPage, total, perPage } = state;
  const page = perPage * (currentPage + 1);
  return /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(Text_default, { ...args, children: label?.replace("{{page}}", (total && total > page ? page : total).toString()).replace("{{total}}", total.toString()) });
}
function PaginationLoadMore({
  onClick,
  fetchMoreProps,
  isLoading,
  ...args
}) {
  const { state, goToPage } = (0, import_react62.useContext)(PaginationContext);
  const { currentPage, total, perPage } = state;
  const [isFetchingMore, setIsFetchingMore] = (0, import_react62.useState)(false);
  const countOfPage = Math.ceil(total / perPage);
  const onGoForward = (0, import_react62.useCallback)(
    (e) => {
      if (fetchMoreProps) {
        const { fetchMore, queryName, variables, collectionName } = fetchMoreProps;
        const collection = collectionName || "collection";
        setIsFetchingMore(true);
        fetchMore({
          variables: {
            ...variables,
            pagination: {
              skip: (currentPage + 1) * perPage,
              limit: perPage
            }
          },
          updateQuery: (previousResult, { fetchMoreResult }) => ({
            [queryName]: {
              // @ts-ignore
              ...previousResult[queryName],
              [collection]: [
                // @ts-ignore
                ...previousResult[queryName][collection] || [],
                // @ts-ignore
                ...fetchMoreResult[queryName][collection] || []
              ]
            }
          })
        }).then(() => {
          setIsFetchingMore(false);
          goToPage(currentPage + 1);
        }).catch(() => setIsFetchingMore(false));
      } else {
        goToPage(currentPage + 1);
      }
      if (onClick) {
        onClick(e);
      }
    },
    [currentPage, onClick, perPage, goToPage]
  );
  const isShow = countOfPage > 1 && currentPage + 1 < countOfPage;
  return isShow ? /* @__PURE__ */ (0, import_jsx_runtime87.jsx)(
    Button_default,
    {
      isLoading: isFetchingMore || isLoading,
      variation: "outline",
      onClick: onGoForward,
      ...args
    }
  ) : null;
}
var Pagination_default = Pagination;

// src/components/molecules/Modal/Modal.styles.tsx
var import_styled_components85 = __toESM(require("styled-components"));

// src/components/molecules/Modal/Modal.tsx
var import_react_modal2 = __toESM(require("react-modal"));
var import_styled_components84 = require("styled-components");
var import_jsx_runtime88 = require("react/jsx-runtime");
function Modal2({
  submitButton,
  cancelButton,
  children,
  AdditionalHeader,
  title,
  className,
  isOpen,
  onRequestClose,
  closeIcon,
  withDevider,
  ...args
}) {
  const theme = (0, import_styled_components84.useTheme)();
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  return /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(
    import_react_modal2.default,
    {
      className: contentClassName,
      overlayClassName: {
        base: overlayClassName,
        afterOpen: `${overlayClassName}--after-open`,
        beforeClose: `${overlayClassName}--before-close`
      },
      isOpen,
      onRequestClose,
      ...args,
      children: /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)(Box_default, { children: [
        title && /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
          /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Text_default, { lg: true, semibold: true, color: theme.colors.n90, children: title }) }),
          AdditionalHeader && AdditionalHeader(),
          closeIcon && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Icon_default, { className: "close-icon", name: "close", size: 18, onClick: onRequestClose })
        ] }),
        withDevider && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Devider_default, { mt: 4, mx: -6 }),
        children,
        (submitButton || cancelButton) && /* @__PURE__ */ (0, import_jsx_runtime88.jsxs)(Flex_default, { mt: 3, children: [
          submitButton && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Button_default, { variation: "primary", minWidth: 90, h: 40, mr: 2, ...submitButton, children: submitButton.title }),
          cancelButton && /* @__PURE__ */ (0, import_jsx_runtime88.jsx)(Button_default, { variation: "outline", minWidth: 90, h: 40, ...cancelButton, children: cancelButton.title })
        ] })
      ] })
    }
  );
}
var Modal_default = Modal2;

// src/components/molecules/Modal/Modal.styles.tsx
var getModalSize = (theme, modalSize, deviceSize) => {
  const targetSizeKey = Object.entries(modalSize).reduceRight(
    (size, [nextSize, enabled]) => size || enabled && nextSize,
    ""
  ) || "sm";
  const widthArray = theme.modalSize.width[targetSizeKey];
  const deviceIndex = Object.values(theme.breakpoints).findIndex(
    (item) => item === deviceSize
  );
  return `width: ${widthArray[deviceIndex]}px`;
};
var commonModalStyles = import_styled_components85.css`
  &${({ className }) => className ? `.${className}` : ""}__overlay {
    position: fixed;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: ${(props) => props.isCentered ? "center" : "start"};
    z-index: ${({ viewHierarchy }) => 100 - (viewHierarchy || 0)};
    ${({ blur }) => blur && `backdrop-filter: blur(25px)`};
    padding-top: ${({ theme, isCentered }) => !isCentered ? "80" : theme.space * 2}px;
    padding-bottom: ${({ theme }) => theme.space * 2}px;
    @media ${({ theme }) => theme.devices.tablet} {
      inset: ${(props) => !props.isExchange && "0px 0px 56px 0px"}; // 56px is the size of bottom navbar on mobile
    }
    @media ${({ theme }) => theme.devices.mobile} {
      inset: ${(props) => !props.isExchange && "0px 0px 56px 0px"}; // 56px is the size of bottom navbar on mobile
    }
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--after-open {
    opacity: 1;
    transition: opacity 150ms ease-out;
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--before-close {
    opacity: 0;
  }
`;
var Modal3 = (0, import_styled_components85.default)(Modal_default)`
  ${commonModalStyles}
  &${({ className }) => className ? `.${className}` : ""}__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 8px;
    outline: none;
    padding: 24px;
    margin: auto;
    box-sizing: border-box;
    ${({ theme, md, lg, xl, w }) => w ? `width: ${w}px` : getModalSize(theme, { md, lg, xl }, theme.breakpoints.xl)};
    ${boxStyle}

    @media ${({ theme }) => theme.devices.mobile} {
      ${({ theme, md, lg, xl, w }) => w ? `width: ${w}px` : getModalSize(theme, { md, lg, xl }, theme.breakpoints.xsm)};

      h2 {
        font-size: 20px;
        line-height: 32px;
      }
      padding: ${({ theme }) => theme.space * 4}px;
    }

    .close-icon:hover {
      cursor: pointer;
    }
  }
`;

// src/components/molecules/List/List.tsx
var import_react64 = require("react");
var import_styled_components88 = require("styled-components");

// src/components/molecules/List/List.styles.ts
var import_styled_components86 = __toESM(require("styled-components"));
var getMaxWidth = (itemsLength, maxWidth, isMobile) => {
  if (isMobile)
    return "1fr";
  if (itemsLength < 3 && itemsLength >= 1)
    return `${maxWidth}px`;
  return "1fr";
};
var getMediaQueries = (itemsLength, minWidth, breakpoint, isMobile) => {
  const maxWidth = getMaxWidth(itemsLength, minWidth, isMobile);
  return import_styled_components86.css`
    @media ${({ theme }) => theme.devices[breakpoint]} {
      grid-template-columns: repeat(auto-fit, minmax(${minWidth}px, ${maxWidth}));
    }
  `;
};
var getGridStyles = (itemsLength, grid, isMobile) => {
  if (!grid)
    return null;
  if (typeof grid === "number") {
    return import_styled_components86.css`
      display: grid;
      grid-template-columns: repeat(
        auto-fit,
        minmax(${grid}px, ${getMaxWidth(itemsLength, grid, isMobile)})
      );
    `;
  }
  const [mobile, tablet, laptop, desktop] = grid;
  return import_styled_components86.css`
    display: grid;

    ${getMediaQueries(itemsLength, +mobile, "mobile", isMobile)}
    ${getMediaQueries(itemsLength, +tablet, "tablet")}
    ${getMediaQueries(itemsLength, +laptop, "laptop")}
    ${getMediaQueries(itemsLength, +desktop, "desktop")}
  `;
};
var ListWrapper = (0, import_styled_components86.default)(Flex_default)`
  ${({ grid, itemsLength, isMobile }) => grid && getGridStyles(itemsLength, grid, isMobile)}
`;
var TextAligned = (0, import_styled_components86.default)(Text_default)`
  text-align: center;
`;

// src/components/molecules/List/components/ListItem/ListItem.tsx
var import_react63 = require("react");
var import_react_dnd2 = require("react-dnd");
var import_styled_components87 = __toESM(require("styled-components"));
var import_jsx_runtime89 = require("react/jsx-runtime");
var DragBackground = (0, import_styled_components87.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n20};
  border-radius: ${({ theme }) => theme.space * 2}px;
  z-index: 2;
  top: 0;
`;
var ListItem = ({ item, index: index2, children, moveItem, onDrop }) => {
  const ref = (0, import_react63.useRef)(null);
  const theme = (0, import_styled_components87.useTheme)();
  const [, drop] = (0, import_react_dnd2.useDrop)({
    accept: "CARD" /* CARD */,
    hover: (entry, monitor) => {
      if (!ref.current)
        return;
      const dragIndex = entry.index;
      const hoverIndex = index2;
      if (dragIndex === hoverIndex)
        return;
      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      if (!clientOffset)
        return;
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY)
        return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY)
        return;
      moveItem(dragIndex, hoverIndex);
      entry.index = hoverIndex;
      entry._id = item._id;
    },
    drop: (entry) => {
      if (onDrop) {
        onDrop(item._id, entry._id);
      }
    }
  });
  const [{ isDragging }, drag] = (0, import_react_dnd2.useDrag)({
    type: "CARD" /* CARD */,
    item: () => ({ _id: item._id, index: index2 }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging()
    })
  });
  drag(drop(ref));
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsxs)(Box_default, { pos: "relative", ref, children: [
    isDragging && /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
      DragBackground,
      {
        justifyContent: "center",
        alignItems: "center",
        w: "100%",
        h: "100%",
        pos: "absolute",
        children: /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(Icon_default, { name: "plus", color: theme.colors.n70, size: 14 })
      }
    ),
    children && children(item, index2)
  ] });
};
var ListItem_default = ListItem;

// src/components/molecules/List/List.tsx
var import_jsx_runtime90 = require("react/jsx-runtime");
var List = ({
  children,
  data,
  placeholder,
  containerClassName,
  placeholderProps,
  loading,
  loadingProps = {},
  isDraggable = false,
  onItemDrop,
  ...args
}) => {
  const theme = (0, import_styled_components88.useTheme)();
  const [orderedFiles, setOrderedFiles] = (0, import_react64.useState)([]);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const moveItem = (0, import_react64.useCallback)(
    (dragIndex, hoverIndex) => {
      const filesCopy = [...orderedFiles];
      const dragItem = filesCopy[dragIndex];
      const filteredFiles = filesCopy.filter((f) => f._id !== dragItem._id);
      filteredFiles.splice(hoverIndex, 0, dragItem);
      setOrderedFiles(filteredFiles);
    },
    [orderedFiles]
  );
  (0, import_react64.useEffect)(() => {
    setOrderedFiles(data);
  }, [data]);
  return /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)(
    ListWrapper,
    {
      className: containerClassName,
      isMobile,
      w: "100%",
      pos: "relative",
      itemsLength: data.length,
      ...args,
      children: [
        orderedFiles.map(
          (item, index2) => isDraggable ? /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(
            ListItem_default,
            {
              onDrop: onItemDrop,
              item,
              index: index2,
              moveItem,
              children
            },
            item._id
          ) : /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(import_react64.Fragment, { children: children && children(item, index2) }, item._id)
        ),
        (placeholderProps || placeholder) && !data.length && /* @__PURE__ */ (0, import_jsx_runtime90.jsxs)(Flex_default, { w: "100%", my: 45, justifyContent: "center", alignItems: "center", flexDirection: "column", children: [
          placeholderProps?.image && /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Image_default, { src: placeholderProps.image, w: 180, h: 180, mb: 8 }),
          placeholderProps?.title && /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Text_default, { semibold: true, children: placeholderProps.title }),
          Boolean(placeholderProps?.label || placeholder) && /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(TextAligned, { children: placeholderProps?.label || placeholder }),
          placeholderProps?.buttonProps && /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Button_default, { mt: 4, ...placeholderProps.buttonProps })
        ] }),
        loading && /* @__PURE__ */ (0, import_jsx_runtime90.jsx)(Spinner_default, { size: 32, color: theme.colors.b50, fullContent: true, ...loadingProps })
      ]
    }
  );
};
var List_default = List;

// src/components/molecules/DashPlaceholder/DashPlaceholder.tsx
var import_styled_components89 = __toESM(require("styled-components"));
var import_jsx_runtime91 = require("react/jsx-runtime");
var FlexStyle2 = (0, import_styled_components89.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n30};
  border-radius: ${({ borderRadius }) => typeof borderRadius === "number" ? borderRadius : borderRadius.join("px ")}px;
`;
function DashPlaceholder({
  size = 48,
  variation = "primary",
  borderRadius = 4,
  icon,
  iconProps,
  ...args
}) {
  const theme = (0, import_styled_components89.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
    FlexStyle2,
    {
      w: size,
      h: size,
      alignItems: "center",
      borderRadius,
      justifyContent: "center",
      ...args,
      children: variation === "primary" && !icon ? /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(
        "img",
        {
          width: "70%",
          src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAB/MAAAYOCAYAAACwEQpBAAAgAElEQVR4nOzd3Wtcd2IG4N/5mpEjKanZQru3Wwjsli6OY1hqDCWQi/ayd77qTSEXpX9O6R/gS9+YbdLFu6m9lb0e40SOBaEQRCKWSEupI3s80nydM3POKaOMseSPxJu1JY3meUAgD0LWOWfkEX71njcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwNwDAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABg7gEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADwsiJnCgBmW13Xe1//vXv3vK6/Bu+880594g7qmHqVz+HJ90VZlmE8HseT9x9/nzA7osg/aQAnRT114cIFL8gAh8jP1AAw+7yaA8CMm4SU//HLX/5VHcLfu5av3uLi4tX333//q5N2XMfFf3744SRsT6qqWqyj6J0Qws9exZcWhZCGyVsUNU/EiZo3dV2FECZvQh+AYyqO4+d+YXFy8PFJkJQk6RdJHK8mSbKTpGlIkiQ/f/782LUFeL2E+QAw+7yaA8CM++yzz6Kvv/76X6Io+jfX8tXL0vRf//LHP/53Df1XbxrkL9d1/RdVCL+IouifQwh/d9KOEwDmXl3fDiFcCiGsT0/FVhzHm1EcF2mSfPvIJPSf/oLA5BcFkunjWaPxwrOn8Q/w3YT5ADD7UtcQAICjMGnkT4L8Oor+MQrhH0IIf+1CAMAJFEU/DXX9T3UInenBtcuq2oiqqlOOX66gPwmk9kKp6MldAdI022v8t1qtnemHafwDAAAnijAfAIAjMb21/i+mQb5GPgCcXH8Wouhv/5R+aD2dl5q8U1Xl3mPj0Xiv8d/r9fYa/2kSb1391a820ywrojgKaZKGOI5CkmYHP5dGPwAAMCOE+QAAHLp79+5Fk4386a31NfIBgD/eU43/UVm1Q1ltFKNR5+nPFcXx3tbkZNM/iZMv0jTV6AcAAI49YT4AAEflZxr5AMCf4KUb/5NW/6SGX43LMK7Ht/M832v0T0L+JApbH3/8m80kTorJVv/TO/2a/AAAwFER5gMAAAAwP/Y1+uuqClUI7VF/sBE92fT/dqM/jvb2+Sfb/FmmyQ8AABw+YT4AAAAA8+R7G/17G/1VvbfPP9nmHw7CpW7UXZ9u8G9dv3ZtM8vSYrLHr7kPAAC8LsJ8AAAAAHiRaZO/qutOVdZhXObtPM+/bfJHUUiT+IskSVf/+7e/3UnSNCRJorkPAAC8EsJ8AAAAAHix72zyj8fl7fG4vJTn+frkz3Ecb/3m17/eTNO0yLJ00uTf+zgNfgAA4I8lzAcAAACAH2rfBv/kM5RV1R4Mh082+KPJ9n4U0jT9otFo2t4HAABemjAfAAAAAH64793gr6o6FHlxu8iLS71udz1J4km4v7WysrKZZVkRNPcBAIDnEOYDAAAAwOu2f3t/XIbRuGwPhvlGFEWdx839ZlNzHwAAeEKYDwAAAACv3wsb/Pub+924t54kSciybOvmzZubcRznGvsAADCfhPkAAAAAcNQeN/erqlNVVRiNRu1+v7+RxPGdLMtWV1ZWdrIsCxr7AAAwP4T5AAAAAHD0ntvcr6rqdp7nl/I8X4+ivdvxb12/dm2z0WwWcRzb2gcAgBNMmA8AAAAAx9W0sV+H0KnrOhSjUbsYjTaibrcTJ7GtfQAAOMGE+QAAAABwfL3U1n4v7q2naRKyRnPr1q1bm5NQX2MfAABmmzAfAAAAAGbVtLlfVlWnLKqQF6N2v9fbSNL0zsLCgsY+AADMMGE+AAAAAMyuZ5r7kyr+eDS63R2NLvV6vfU0SUKjqbEPAACzRpgPAAAAACfNtLFfVVWnqKq9rX2NfQAAmC3CfAAAAAA4eb6zsd/v9dazLAuNRvZVq9XaOn/+fOk5AAAAx4swHwAAAADmxf6N/TwPeZ5fH/QHl69f+6/trNEMSZJo6gMAwDEhzAcAAACA+XGwsV/Xb43Lcrfb7a2H0AtZlm1dv3Zts7mwYFsfAACOmDAfAAAAAObVtKlfh9CZnIHJtn4xGm30+r07WZqt3rixspOmWbCtDwAAh0+YDwAAAADz65lt/Ym6qm8XRXGpKIr1JIlDo9Hcunnz5mYcxxr7AABwSIT5AAAAAMBB+xr747IK48GgPRgMNtIsu7OwsLDaarV2ph+vsQ8AAK+JMB8AAAAAeNpzG/vj0eh2dzS61O/11rNGFprNha9ardbW+fPnS2cQAABeLWE+AAAAAPBypo39sqo65TAPeV5cb2TZ5Rs3VrZt6wMAwKslzAcA4EhEIcTOPADAzDnY2K/rt4qi2H28ra+pDwAAr44wHwCAQ1fX9eSvFOYDAMy6p7b1y37/+jDPL1/7+OPtxsJCSJJEUx8AAH4gYT4AAIeuqqrgZ1EAgBPhmaZ+VZa7vX5/vT8YhCzLtm7cWNlMkjSv67q+cOFC7bIDAMDL8R+oAAAcuqqqohBFTWceAOCE2dfUn9yNKS+Kdl4UG1mW3Wk2GqutVmtnesAa+wAA8D2E+QAAHLqyLCNnHQDgRDrY1J8aj0a3x6PRpeFwsJ5mWTh16g3b+gAA8D2E+QAAHLrpZj4AAPNi2tgfl1VnXOahyIvrCwsLl1ut1vb0DGjqAwDAU4T5AAAcOmE+AMDcOdDYr+v6rcFgsDvM8/UsTcKCpj4AADxDmA8AAAAAHK5pU7+qqk5eVKEY7VxvNhqXb968uZ0kSWg0GoNz585VrgoAAPNMmA8AAAAAHLaD2/p1/Vae57tFUaxnWRoWl5b/Z21t7f6ZM2fc0gkAgLklzAcAAAAAjtbjpn5dd/JiFIp2+8PhYHD5k08+6Uya+kmSjAX7AADMG2E+AAAAAHDUnm7qL/YHg4fD4fDLRrMRlpaWf7+2tvZAoA8AwDwR5gMAAAAAx0sU/TSq6w+qum4Ph3nIh/nVfq93RVMfAIB5IswHAAAAAI6bPw9R9N6+pv7p/mCwq6kPAMA8EeYDAAAAAMdbFP2Npj4AAPNGmA8AAAAAHHcvbOovnFrQ1AcA4EQS5gMAAAAAs2VfU7/fH4ThcHh18Y3FK6urq504jsuzZ89WrigAALNOmA8AAAAAzJoDTf26qk/vdru7w3x4d2lpeXt1dbV77ty5kasKAMAsi109AAAAAGCmTZr6IXwwHo0vdtrtt7e/+eZ069bvTq2trUUuLAAAs0ozHwAAAACYdXtN/VDXP6pDGOdF8fmD7QcPu93e+t27dx+8++67tvQBAJg5wnwAAAAA4GSIop+Eur4YhfBeFcJgMBh89L9/+MOVld2dztLymyFJkvGZM2cE+wAAzARhPgAAAABwUiyFKPr55Fim99dfLut6t9PZ+XJ3txuWl5d/v7a29kCgDwDALBDmAwAAAAAn02RLv64/qENol1UVHj16dLXf614ZDgedLGto6gMAcKwJ8wEAAACAk2pvSz96cnCni3G5e///7n/ZXGiGpSVNfQAAji9hPgAAAAAwH/Y19YfDPBRFcbXI8yurq6udOI7Ls2fPVp4JAAAcF8J8AAAAAGBeHGjq11V9emd3d3cwHNx98803t1dXV7vnzp0beTYAAHAcxK4CAAAAADCXJk39ED4Yj8YX2w8evv3oUfv0p59+emptbS3yhAAA4Khp5gMAAAAA82qvqR/q+kd1CONer//5cDh8uLy0vG5LHwCAoybMBwAAAADmWxT9JNT1xSiE98qyGjx69Oij4XB45c6dO50sy2zpAwBwJIT5AAAAAMC8WwpR9PPJOZjeX395mOe79+/fv7u0uGhLHwCAI2EzHwAAAABgv+mWfl1VF7u7u29/8803p1u3fmdLHwCAQ6WZDwAAAABw0IEt/aIoPn/wsP1wMBjY0gcA4NAI8wEAAAAAnmffln5VVYNut/dRkedXBv1ep7lwypY+AACvlTAfAAAAAOD5ntnSL8bl7vaDh3ffOLVgSx8AgNfKZj4AAAAAwMvYt6Xf7/Vt6QMA8Fpp5gMAAAAAvBxb+gAAHBphPgAAAADw/+zd25Oc530n9t/zvt09gEwQoMiV1itSssk1RLoklyTTUkii7MLuykqqvFpbtVGxfMGrlG6Sq/wBqVQu81couUilfBGnZDul00qWa9Ay5QGF3UgmRQeUxJMpHGeIOXT3e3hS72BAgSAB4jCHPnw+VRBIihLefp6enp7+vt/nx50wSx8AgH0gzAcAAAAAuDM3naV/32/8hln6AADsCjPzAQAAAADuxXWz9NevXDl+4fz5B/7+7//eLH0AAO6JMB8AAAAA4N5cnaUf8R9zxL8ZTyafP3/+/GfXVlcfFOgDAHC3HLMPAAAAALAbbpilv7q6+tfj8fgvV1ZW1oqiMEsfAIA7IswHAAAAANgd75mlvzUaXTn31lunjxw9apY+AAB3xDH7AAAAAAB7YWeWft00z66urh6/srZ2ZGVlpW+tAQC4HZr5AAAAAAB74+os/ZwfzG1br6+vp/Fkcvb5559f/cIXvqChDwDALWnmAwAAAADspW6WfsSzbc5fqSaTxy6cP//A8vLy4TNnziTrDgDAzWjmAwAAAADsre1Z+l1ynyMu103z0OWLFy+NR1svnzlz5uJnPvOZbP0BALiRMB8AAAAAYD90Df2cn00RJ9uIrfX1jb+uquovnx+P1/r9fvO5z32utQ8AAFwjzAcAAAAA2B/bDf3uT9o5X//IeFJdOX/+3OmjR49dWFlZWX/yySfN0gcAYJuZ+QAAAAAAByGlT6eIr7VN++zq6urxK2trR1ZWVvr2AgCA0MwHAAAAADgwD0VKJyPnB3Pb1uvr66mqqrMrKyurGvoAAGjmAwAAAAAcpG6WfsSzbc5fGY/Hj53/1a8eGJ5aPnzmzJlkXwAAFpdmPgAAAADAwdqepd8l9zni8qSuH7p46fKlqqpfPnPmzMXPfOYz2f4AACweYT4AAAAAwDToGvo5P5siTrZtu7W6uvrXdV395crKylpRFM3nPve51j4BACwOYT4AAAAAwHTYbuh3V7Jzvv6R9Y3NK3XdnD5y//0XVlZW1s3SBwBYHGbmAwAAAABMo5Q+nSK+Nh6Pn7186dLxyWRyZGVlpW+vAAAWg2Y+AMy4z372s/lXb731zaZt/gd7ufuWlpa+2a3xvD2ug5Zzbnu93jfbtlnsheAdKaU2RWquVdCmSc7xiaZp/l1EfNKOAQD77KFI6WTk/GDTNPXFixfT0aNHz66srKxq6AMAzL8p/KgMALgTOV/NmX/84x/7vr4HBPl7Z3l5OaWUnBTFO1KazpexnPMDFy5c+J9TSv/9FFwOALCY1iPnV3LO3ypS+r/uu+++l48cPXpFoM+tTOv7awDg9vluDgAz7lqYD8DeGA6H5YXz5//HSOl/tcQAwIHK+b9ExP+ZIr5/6PDhsw98+MMa+tyUMB8AZp8mFAAAAADALEjp0Yh4ts35K6Otrccunj9/5PnnnzdDHwBgTgnzAQAAPpifnQCAaXBfpPR7KaUv5YiTk8nk+KXz548J9AEA5pMPpAAAAG6hbdvufNKBNQIApsZ1Df26aR47f+7cA8vLy4fPnDnjXHUAgDnSs5kAAAA31zRN8rMTADBlrjb0uzH6EZfbtn3o8uXLl6rJ5OUzZ85c/MxnPpNtGADA7POBFAAAwC3knJ1oBgBMp66hn/OzKeJk27Zbb7/99l/nnP9yZWVlrSiK5nOf+1xr5wAAZpcwHwAA4BZyVmwDAKbWdkO/u7id8/WPXFlfv1LV9eljx45dWFlZWX/yyScr2wcAMJs0TAAAAAAA5kFKn04RXxuPRs+uXrp0vGmaIysrK317CwAwm4T5AAAAAADz4aFI6WRE/MfxZPJvLl64cHw0Gh0T6AMAzCZhPgAAAADAPOlm6Uc8W1XVV9ZWVx+bTCYa+gAAM0iYDwAAAAAwX7Zn6aeUvtQ0zcnLly4d39zc1NAHAJgxwnwAAAAAgHm009Cv6/ora2trj21tbWnoAwDMEGE+AAAAAMB8eqehn9v25OrqqoY+AMAMEeYDAAAAAMyznYZ+2zTbDf0ra2sa+gAAM6BnkwAAAAAA5trVhn5E5La9vL6+3j3WsysrK6tPPvlkZesBAKaTZj4AAAAAwCK41tDP+Svr6+sa+gAAU04zHwAAAABgMfy6oR+hoQ8AMOU08wEAAAAAFskNDf01DX0AgKmkmQ8AAAAAsFje1dDfXF+Ppqo09AEApoxmPgAAAADAIrquoT8ejx+7dPGihj4AwBQR5gMAAAAALKarDf2UvpQjTo5Ho+OXLlw4JtAHAJgOwnwAAAAAgEWmoQ8AMJWE+QAAAAAAi01DHwBgCgnzAQAAAADQ0AcAmDLCfAAAAAAAQkMfAGC6CPMBAAAAAPg1DX0AgKkgzAcAAAAA4Hoa+gAAU0CYDwAAAADAe2noAwAcKGE+AAAAAADv5z0N/Straxr6AAD7RJgPAAAAAMDNXdfQX19ff+zK2pqGPgDAPuhZZAAAAAAAbuFqQz8icsTl9fX17t88u7Kysvrkk09WFg4AYG9o5gMAAAAA8ME09AEA9pUwHwAAAACA2/GuGfrr6+vH19fXzdAHANgjwnwAAAAAAG7fdQ39K1euPLa1taWhDwCwB4T5AAAAAADciV839Nv25Orq6vHNzU0NfQCAXSbMBwAAAADgzl1r6DfNV9bW1h6bTCYa+gAAu0iYDwAAAADA3XhXQ//ypUvHR6ORhj4AwC4R5gMAAAAAcPd2Gvp1XX9lbXVVQx8AYJcI8wEAAAAAuBfvNPSbpjm5trr6O03T3PfCCy/4/BkA4B70LB4AAAAAAPesa+jn/GxVVb3Vy5cvPfjQQ+sR0VpYAIC7485IAAAAAAB2w3ZDPyJOjsbj319bvXz0zJkzycoCANwdYT4AAAAAALsnpeGik7IAACAASURBVE+niK+tr2/82aWLFx8U6AMA3B3H7AMAAAAAsJseipRORsSVjfX1nw6Wln4cEVtWGADgzmjmAwAAAACw61LE4Tbiw6uXLx85depU3woDANwZYT4AAAAAAHvhoyni07ltH3378uVjzz//vEAfAOAOCPMBAAAAANh9KT0aEc+2OX+lbprHLl24cGRlZUWgDwBwm4T5AAAAAADshfsipd9LKX0pR5ys6/r4pQsXjgn0AQBujzAfAAAAAIC9c11DfzweP7a2tqahDwBwG4T5AAAAAADspXc19DfX14+vX7mioQ8A8AGE+QAAAAAA7L3rGvpX1tcf29ra0tAHALgFYT4AAAAAAPvh1w39tj25trb6O5PJ5L4XXnjB59QAAO/DmyQAAAAAAPbPtYZ+0/7x6qVLD7VtW1p9AID3EuYDAAAAALCfthv6EXGyaprfv3jhwtEzZ84kOwAA8G7CfAAAAAAA9l9Kn04RXxuNRn926eLFBwX6AADv1rMeAAAAAAAcgIcipZMRcWVjff2ng6WlH0fElo0AALhKMx8AAAAAgAOTIg63ER9evXz5yPPPP9+3EwAAVwnzAQAAAAA4SB9NEZ/ObfvopUsXj62srAj0AYCFF8J8AAAAAAAOVEqPRsSzbc5fqSfVY6uXLh0R6AMACPMBAAAAADhY90VKv5dS+lKOOLm1tXV8/coVDX0AYOEJ8wEAAAAAOHjXNfSvrK8/trW1paEPACw0YT4AAAAAANPg1w39tj359tra70wmk/teeOEFn2MDAAupZ9sBAAAAAJgaXUM/52ebpuldefvtS4PBYD0iWhsEACwadzQCAAAAADBNthv6EXFyNB7//ttra0fPnDmT7BAAsGiE+QAAAAAATJ+UPp0ivra+vv5na2trDwr0AYBF45h9AAAAAACm0UOR0smc85X1K1d+urS09OOI2LJTAMCi0MwHAAAAAGBqpYjDddN8+O3V1SMrKyt9OwUALAphPgAAAAAA0+yjKeLT4/H4t6+8/fZ9L7zwgs+1AYCF4Jh9AAAAAACmV0qPRs5/niMG6xsbq4cOLa1HRGvHAIB55w5GAAAAAACm2X2R0qci4ktt2z516dLlD58+fTrZMQBg3gnzAQAAAACYfik9kSK+1jTNn184f/5jzz//fGnXAIB5JswHAAAAAGAWHIuUnoqI/2YyHn96Y2Pj/uXlZQ19AGBuCfMBAAAAAJglh9qIBzc3No7lnA+fOnXK59wAwFzyJgcAAAAAgNmR0kdSxKdy2z5+5cqVj+aclzT0AYB5JMwHAAAAAGCWfCxS+tM24t83VfX4aHPzwa6tr6EPAMybnh0FAAAAAGCG3BcRn0wpRc757a3xuOkN+v84GCydi4iJjQQA5oUwHwAAAACAWbTd0M9tW2xsbFzs9foX7SIAME8cOwQAAAAAwCzabuhHxImmbv5gc3PjI8PhsLSTAMC8EOYDAAAAADC7UnoiIp4bbY2+urW19fBwOHQiLQAwF4T5AAAAAADMsmOR0lMR8cWtzc3fbdv2yPLycrKjAMCsE+YDAAAAADAPDjVt++DGxsaxiDh86tQpn38DADPNcUMAAHdgp92ROtbt7uWc2xMnTuRZvf5ZcSfP1/16Srdtm6qqmqk5pimlf5kjPuGLHgBgyqX0kZTzpyaj0bnBYFAtLS2di4iJbQMAZpUwHwDgA3znO98ucpt7EbnXtvmBpmk+nyM/Yd3uXlGU3/zBD37w4z/6oz8S6O+yv/3b7xeT8eS2n68pUptSaiPFfuxFkXMMZu7nkJw/kVI6MQVXAgDArX0sUvrTnHOxub5+sd/vX7ReAMAsE+YDAHyA8Wjci5wfzDk/nCP+q0jpz6P7nbvWtnXktv3PEdFYxd3V3XgyGY/v4PnqfgoAAObGfRHxyYg40bTtKxvr6xeGw+HrTz/9tJ87AICZZGYQAMAHyDn3toPRlP7DTjD6uDVjWrWerwAALLqUupOpnhuPx1/d2tp6eDgcKrUBADNJmA8AcAt//Vd/lXLbPpCvNpv/7U7D+Zg1Yxp1M/LbpvF8BQBg0R2LlJ6KiC+OtrZ+t23bI9175UVfFABg9gjzAQBuIUWknNLnNZyZEaluGs9XAAC46lDdNA9ubm50N7gePnXqlM/DAYCZ4nghAIBbS+nqEY1m5DP1uidr27aerwAAENtvkD+Scv7UeDw5NxgMqsFg6VxETKwNADArhPkAAAAAAMyjj0VKf5rbttjY2LjY6/Uv2mUAYJY4VggAAAAAgHl0X0R8MiJONHXzB6OtrY8Mh8PSTgMAs0KYDwAAAADA/Lo6Ou25za2tr04mk4eHw6ETawGAmSDMBwAAAABgnh2LlJ7KOf+brc3NxyJiyW4DALNAmA8AAAAAwEKoqiom47HNBgBmgjAfAAAAAIC5lyKORsTx9Y2Nh8zOBwBmgTAfAAAAAID5tzM7v22ar66vXzE7HwCYesJ8AAAAAAAWwfbs/Ij44ng8+d1qMj6yvLyc7DwAMK2E+QAAAAAALJJDbds+uLG5dSwiDp86dcrn5ADAVHKMEAAAAMyf9Yi4GBFrkfOo+z1HvJkiVu313OnliI+kiId3HlgZKf2r+PXfA3CjlD6Scv5UU1XnJpNJdejQoXMRMbFOAMC0EeYDAADA/LmYUvrbiDgbKV1MES+llF6KlNbt9fzIbRs55yLl/Ikc8dnugaWIfs75TyIlYT7AzX0sUvrT7jV0Y2Pj4mAwuGitAIBpJMwHAIA5klJq7SeQUlrr9/tny7L8YVEUb+ac/7mu6yuTyaRZ+MWZM0VRxNLS0stFUWyfulDXdZFzPt+27c+7v885d/+x/aDbnd9j50aAG3QN/99MEb+58481/IF5dl9EfDIiTuS2fWVjff3CcDh8/emnn/Z9EgCYKsJ8AACYI0VRCPOBLswfpZQudkF+27avNk0zaprG68Mc6sL6uq7HKaU34+reR6/Xeyvn/L3bebTXwv66aYoU8YmmbT8bkSM3rYY/MP9SeiJyfm48mRxZmkz+YjgcvvH000/Xdh4AmBbCfAAAmC/ZfgLdjPyiKF7qGvldkK+RP7+6ML6qqu61//rwqfvr0Z086GsN/8FOw787erppmvNN0/y8+zO2j/R/d9Nfkx+YB8cipadyzmubm5unB4PBhRteTwEADpQwHwAA5kTXxgSIq68Hb3Yz8ruj9TXyuR3v1/Avy/Ktoijet+Hftm3RNs12k3874G81+YHZVldVTMZjuwgATBVhPgAAAMyZlNJqznldI5/bdacN/y7sP3To0DtN/i7c327y1/XPu9n8OedezllzH5gJKeJoRBzf3Ng4OxwOR2bnAwDTQpgPAAAAwB17v1n9ZVl+b+fvi7ZtP1HX9Wfb7oj+nPu5bTX3gem0Mzu/bpojG+vrZucDAFNDmA8AAADAHfmgJv+15v7S0tI7M/jrut6ewb8d7retmfvANHlndv5oPD596PBhs/MBgKkgzAcAAABg131Qc7+u6080TbPd3N+Zuf8fNPeBg5bbNkajLfsAAEwFYT4AAAAAu+p2m/v9fn+7ud80da+p6wt10/6ibVuNfeBAXJudP94anV1eXh6dOHHC7HwA4EAJ8wEAAADYdzc29/uDpTf7Ed9/16z9ptHYB/bPzuz8NucjV65cMTsfADhwwnwAAAAA9tXNmvsppdGhQ4f+6dez9tteVdUX6rrW2Af2w/bs/Mh5vZ5MflJNxm8vLy+vnjhxIlt9AOAgCPMBAAAAmBrvaez3+2/2+/1fN/abpptprbEP7KVDbcSDG5tbx+6/vz8+derU6JlnnmmtOACw34T5AAAAAEyFncZ+F5hdH5q9p7Ff13WvrusLTdP8IuessQ/srpQ+knL+VFNV5yaTSXXo0KFzETGxygDAfhPmAwAAADD1bmzsLy0tdX/9/bqqPlE3XWO/jRShsQ/sho9FSn+acy62tjYvDgaDi1YVADgIwnwAAAAAptoHNfb7g8Fq0zRd4N9v6rrMOX9459/R1Afuxn0R8cmIONHUzStbm5sXhsPh608//XRjNQGA/STMBwAAAGBmXd/YL8syDQaD704mk1EX7ofZ+sC9SOmJyPm50Wh0ZOnQob8YDodvPP3007U1BQD2izAfAAAAgJl0Y2O/O37/0KFDby4tLX0/rgb9/clkUua21dQH7saxSOmpNue1ra3N00eO3H+he2mxkgDAfhHmAwAAADA3bpitnw4fPvzduq5HTV1H2zSa+sBdmUwqCwcA7DthPgAAAABz4WZN/X6///1+vx9N0/SryaRsmkZTH7htKeJobtvj6+tXzg6Hw5HZ+QDAfhHmAwAAADC3bmzqLx06pKkP3Jl3ZuePjwwGS2bnAwD7RpgPAAAAwFy6jab+oJpMDjdN8y+2PydLqfusrPvr3/SMAK6zPTs/57w22to8PRgMzM4HAPaFMB8AAACAhXF9U7/7bKw/GPxdUdddsB9tzocj5y9FSsJ84H1V1dXXCwCA/SDMBwAAAGAh3NDU707dz4PB4NWy1/te2etF27ZLdV0XbdMc3V4PTX3gOtuz83M+vrmxYXY+ALAvhPkAAAAALJq086tr2G5ExCvdXxdFUWwfv18UG13zNmvqA9fbmZ0/nkyOLE0mZucDAHtOmA8AAADAokg7j7OInaZ+Xddds3a7XdtV9QeDwc97vd641+t1Qf92Uz/n/ODO/+ZwRDy4PT8bWERm5wMA+0qYDwAAAMAieFeQfxP5xqb+YDCIuqpGbdven3P+aER8IVL6nGcMLDaz8wGA/SDMBwAAAGBR3CrIv2lTvz8Y1G3bPljX9cfbq+GdWfqwwMzOBwD2yy1/gAEAAACAGXdtPv7dfA623dSv6/psURRnB4PB2V6//7cppf8jcn7JEwMWVDc7P6Kbnf/VyWTy8HA4VJoDAPaENxkAAAAAzLu7KrRca+qnlNqiKC4VRRFlWb5VluXZuqqKpm3N0ofFZHY+ALAvhPkAAAAAzKu7beTfKNd1PS6K4lxcnaVf9vr9KNpmVNfN/bltzdKHBdXNzgcA2CvCfAAAAADm0W4F+dsN/Zxz24mrs/TrbpZ+WfbqoigfbOr647VZ+rBwrs3O31hfNzsfANgTZuYDAAAAMG92Lci/iXdm6aeUujn63Tx9s/Rh0ezMzh+NRl+t69rsfABg13lzAQAAAMA82esg/31n6aeU3hoMBmfrui6apjFLHxbD9uz8Nue1ra3N00eO3G92PgCwq4T5AAAAAMyLPQ/yb/DeWfq9XhRFMksfFsxkUtlyAGDXCfMBAAAAmHVp5/r3daTkB83Sr+v64029XdI1Sx/m2Pbs/LY9vrmx8eLy8vLmiRMnsv0GAHaDMB8AAACAWXYgQf5NbM/Sj4izvV5vtd/vV0VRbNZ1/cvctl+KlIT5MI+62fk5Pzcej944/KEP/U33WmCfAYDdIMwHAAAAYFZNU5D/vrP0i6LYnqVfTSZFm7NZ+jCftmfn1037hWoy+W5EbNlnAGA3CPMBAAAAmGVTEeTf4D2z9PuDQRf0j5qmuT9yNksf5tOjW1tbjwyHw1eefvrp2h4DAPdKmA8AAADALEpTGuTfdJZ+v9+vy7J8sKqqj+e2/VBEHNXQh7nyQFVVD9d19UZECPMBgHsmzAcAAABg1kxtkH8T75mlX9d1v22aTQ19mD+jrZFdBQB2xSz90AMAAAAA6bpZ+TPh2iz9pmnGbdt2s/RfHQwGPy17vR9FxP/bhfwRsb7wOwszLl09beP4ZDx+aHl5ubSfAMC9EuYDAAAAMCvSLIb519mepV/XdTdL/9V+v3+21++fiohvR8QrU3OVwN1J6YmIeK7N+asb6+sPD4dDJ+MCAPfEmwkAAAAAZsGsB/nvzNLPOeeiKNa6hn6v12tSSt2x+9v/fUT8i4j4zYO/WuAuHIuUnso5r02q6nREXDA7HwC4F8J8AAAAAKbdzAf5N9hu6BdFca4L88uyLFNKm1VVvZbb9ouRkjAfZlxu2xhtbdpGAOCeOGYfAAAAgGk3T0H+dgO/bdu2aZq6bdu17sj9lNKPB4PBt1NRfD8i/ktE/MQsfZhN12bnj7ZGDw2HQ7PzAYC7ppkPAAAAwDSbqyD/Bu809Lt/XBRFbzAYRF3X603T3B85fzRSeiYifm+aLhr4AN3s/Jyfq5vmyNbW1l8Mh8M3nn76acftAwB3TJgPAAAAwLRK83yy5LUZ+p3Yzv9SPRgMftHv9+uU0oNNVX085/yhSOk3IuKjEXHfwV81cBvemZ0/Ho9PHz582Ox8AOCuCPMBAAAAmEbz3Mi/mdw0zXpK6Wyv11stiqKqJpN+znlTQx9mU11V0TSN3QMA7oqZ+QAAAABMm7SIYX7X1K/ruumO3m/b9lJRFK/2B4OfpqL4UeT8YzP0Yba8Mzt/c/P+5eXlRbs5CQDYBZr5AAAAAEyThQzyb9A19LtA/1yv12v6/X5ZVVU/t62GPsySndn5o8n4jQ/dd9/fdF/b9g8AuBPCfAAAAACmyaIH+dsN/aZp2pRSLopirWvoDwaDpppMqrZtzdCH2bE9O79t8xfGo9F3I2LL3gEAd8Ix+wAAAABMA43899pu6Nd1fS6l9Gqv3z+biuJU5PztiHhl2i4WuKlHR+PRI8PhULkOALgj3jwAAAAAMC0UT66joQ9z44G6qh+u6+qNiKhtKwBwu4T5AAAAABw0jfxbe9cM/Z4Z+jCTxuOxjQMA7oi7nQEAAAA4SI7X/wDXGvpN09Rt215r6P+0KIofRc4/joizEbE+1Q8CFliKOBoRx8fjyUPD4bD0XAAAbpcwHwAAAICDIsi/M2bowyxK6YmIeK5tmq9ubmw8bHY+AHC7vGkAAAAA4CAJ8m+TGfows45FSk/lnNcmk/HpD/3Gb1wwOx8AuB3CfAAAAAAOgkb+3TNDH2ZUXTdR15XtAwBui2P2AQAAANhvjte/B7c5Q391Zh8gzKl3Zudvje5fXl72+gcAfCDNfAAAAAD2myB/d9y8oR/xhUjpc/PwIGFudLPzc35uNBm/8aH77vub7mvY5gIAtyLMBwAAAGA/CfJ3yfvN0O/3+01VVVVu2+4PuTZD/9g8PF6YA9uz89s2f6Gu6+9GxJZNBQBuxTH7AAAAAOwXQf7e2G7o13V9bifQP5tSGkbO34icX57HBwwz7tHNjY1HhsOhsh0AcEveLAAAcBCOtjkPNFEAYKGYk79H3q+hP1ha2ppMJmVu20/O5YOG2fZAXdcPR8QbEVHbSwDgZjTzAQA4CL9VV9VvnTp1ys2lALA4BPl7752GflmWv+qV5aWIuDLvDxpmUXcTzmhr094BALckzAcA4CA81Ob8O03THPu7v/u70g4AwNwT5O+Daw39pmnqnPNqfzB4qdfvPR85/ygiXp/7BYAZkSKORsTx8Xj80HA49PMQAHBTwnwAAA7CUtu2D1ZV9ZHuiEkNfQCYa4L8/Zfrut5q2/bVwWDpm2VZ/m85558s2iLA1ErpiYh4rqrqr45HWw+bnQ8A3Iw3CQAAt5BTaqNtvxnJ58/3qGue/FbXyO+C/Ii42Lbtb43H46iq6mKR0j9973vf+0WR0uT6PyZZ9zvStu0DbdN84rr/zfr2HM6cz0XEKEdciIhXUsTaPf5R3c8Rh/bpYe27HPFgRDySIh7Yfr6m1P39RyPivnl9zAfslznnH6WINxd6FXZZURT/KSKquXpQzDrf1PdR19CvqqrtLC0tnV86dOhMu7X10Zzzb+98Tzu2MIsB0+lYpPRUznltMqlOLx06fMHsfADg/QjzAQBu4U/+5E/y8vLyj1NK/9k63b22bQeTyeS3mqb5na6R3wX5TdN8pq7rfxsR4+hC5vH4F5Hz6tUs9V2/uE054hMppX937d8uy/KNfr//f5dl+ZOiKC4WRXG21+u9lm64aeJONU1T1HU9t6d8pZQON03zr3POx3eer5+cTCb/tTB/b5Rl+aNDhw79L117dB4f3wGq6roeL+yjZ5po5R+gLtTPOddFUVweDAZnJpPJ4dy2fxQpfX5hFwWmTFW59w4AuDlhPgDABzhx4kQXKDfW6Z5snTp16p+apjnfHa3ffWC1E+Q/867/U038e3Ld6q13QX6v1/tev9//Qa/XeymltFoUxZWnn356Nxo/c/318J3vfGfS7/d/GhG/aprmX27/w5z/IFJ67MAvbg6llN7sgvytra0ri74WMIeSEY8HayfM75LC871eb3su93g8/tDOqUka+nDAutn5bdseH49HLy4vL2/u/OwJAPAOP1ABALAvnnnmmS5Evtzv9891LfF0tZHP3thu5A8Gg78qy7IL8n8VEau7FOTPvS9+8Yu5qqpR27a/Ksvyre75Gp6vAHfDXXoHr5udX1VVtZZzfqMsy1cGg8HfRc7fiJxfXvTFgQO3Mzt/a2v0ZDJjDAB4H8J8AAD2zR/+4R82ZVmu9nq9f4qUzlv5vZEiznVH63eN/KIofpVSGmn53Jku0G+apmsyXkgpvZwjLs/S9QNMAcfrT4GumV/XdXeTWt227WZKqbvh7x/7g/4PI+IfIuJn3Q1/i75OcIC2Z+c3df2FiFiyEQDAjRyzDwDAvuoa+qdOnfrF1ubm2SbLl/fIaPv0g5S6D+e3nnnmGQt9F7pA/zvf+c6o3+//fxHx2sw9AJgTX/7yl/f0Newb3/iGwHn3CfKnUNfQb9t2rdfrNf3+oGybtt80zWZEmKEPB6zN+dHRaPTIcDh8xWlaAMD1hPkAAOy7lNIkFWk1Wmu/J1K6UBTF2Z0Z+YL8e9AF+t///ve3UsTFmX0QMKP2OsS/Zr/+nLsx4zcaCPOnyLWGfkqpLopisyzLN/qDQeTx+HDbtp9c9PWBKfDAZDx++PDhw290997YEADgGmE+AADMn1d6vd5rWj3ArJrmgJ0PpJU/5a5r6A96/f6lyWRyZdHXBKZB3TT2AQB4DzPzAQBgzqSIte70A/sKzCJB/q91azGD6yHMn2LXGvp1XXepYRfov9Tr9Z6PnF+IiNcXfX3goKSIo7ltj49Go/uXl5e9hgIA7xDmAwAAAFNBkP/+ZmhdBPkzIuecq6oatW376mAw+GZRll+PnF9c9HWBA5PSExHx3Gg0ejKl5HUUAHiHMB8AAAA4cIL8W5uB9RHkz5CuoV9VVVtVVRUR55eWlk6novhRRPwsIlYXfX3gAByLlJ5q6voLEbFkAwCAa4T5AAAAwIES5N+eGQn0mR4f+HzpQv2cc10UxeV+v386Ir4ROb9sD+FgtDk/OhqNHhkOhz1bAACEMB8AAAA4SIL8OzOl65V8xjSb8lXb7fyyLP+p3+8/HxH/oKEPB+aByXj8sHY+AHCNH7QAAACAAyHIvztTtm6O159Ot/0cqeu6O21/LaX0Vr/fP1uW5XLkrKEPB6RuGksPALxDmA8AAADsO0H+vZnCQJ8Z1B2zX9d1rqqqbtv2Skrp9cHS0ksR8Y8R8ZY9hf2VIo7mtj0+Go3uX15e9toKAAjzAQAAgP0lyN8dU7COjtefI9c19M8NlpYuRsTGoq8J7LuUnoiI5yaT8ZMpJWE+AOAHLgAAAGD/CPJ31wGvp6BpTlxr6Nd13Z3vvVaW5c+Ksvxh5PxCRLy+6OsD++hYpPRUVdWPC/MBgBDmAwAAAPtFkL83DmhdzcqfQznn7sj9Uc75l4PB4Fsppa9Hzi8u+rrAfsttG01dWXcAQJgPAAAA7D1B/t46gPUV5M+hrqFfVVXbnbdfFMX5/mDQBflvLvq6wH7LEUcnk8nAwgMAwnwAAABgTwny98c+rrNW/vTbledCWZZRFD4+hAPw6HgyeWQ4HPYsPgAsNu/GAQAAgD0jyN9f+7DegvwF0DX0I2ISEa/2+v3TEWF2PuyvB+qqfrhpmiXrDgCLTZgPAAAA7AlB/sHYp0CfOXb97PyyLL/V6/XMzocDUFXm5gPAohPmAwAAAMyZPQr0tfIXxPWz81NK5/v9/umiKH4UET+LiNVFXx/YayniaEQcH4/H9y8vL3vdBYAFJswHAAAAdp1W/sHbw0CfBZJzrouiuNwfDLrj9r8ROb9s/2GPpfRERDxX19WTKSWvuwCwwIT5AAAAAHNqFwP95HOkxdO2bXfifjc7/3xZlj/v9Xr/GBFvLfq6wD44Fik91bb5C3Vdm5sPAAvMD2EAAAAAc2yXAn3N0Nmya6cy1HXdnba/FhHner3exVQUGwuyhjANHt3a2npkOBz27AYALCZhPgAAAMCcu8dA36z82bJrQX43O7+u61zXdRMRaymln/XK8oeR8wsR8fqCrCccpAeauno4IrTzAWBBCfMBAAAAFsA9BPqC/AXXnbVfVdUo5/zLXr//raIsvx45v7jo6wL7oWnaaJrGWgPAghLmAwAAACyILtC/w1BfK5/thn5VVW133n5K6Xy/33sxUnrTysDeShFHI+L4eDS6f3l52WsxACwgYT4AAADAgtmlOfpMpz3f26Iooyh8rAh7LqUnIuK5SVU9mVIS5gPAAvKuGwAAAGAB3Uagn3x2xPW6hn5ETCLi1X6/fzoizM6HvXUsUnqqqevHhfkAsJj8QAYAAACwoDT0uRPXz84viuJbvZ7Z+bAfuhtpmrqy1gCwgIT5AAAAAAvsJoG+Vj7v8d7Z+YPTqSh+FBE/i4hVKwZ7I0ccnVT1wPICwOLxQxkAAAAAcEdyznVRFJe3j9vP+RuR88tWEPbMo+Px6JHhcNizxACwWIT5AAAAAAvuhnZ+2vnFbNrz0Qlt23Yn7nez88/3er2fF2XxjxHxlucL7JkHmrp5OCKWLDEALBZhPgAAAADvF+gze/Y8yL+mruvutP21iDjX6/UvRsSG5wvsnZ0xF1YYABaMMB8AAACAbTuBviCfW+pCxbquc13XTUSslWX5s6Isfxg5vxARr1s92F0p4mhEHJ+MRvcvLy97jQaABSLMBwAAAOB67c4vuKXurP2qqkY5518OBv1vRcTXI+cX2tYYwwAAIABJREFUrRrsspSeiIjnqrp6MqUkzAeABSLMBwAAAOAdXTv/y1/+crufR7aza/Z1z3aO/W678/aLojxflmUX5L9pO2HXHYuUnqqb9nFhPgAsFmE+AAAAAO9HQ5870uv3LBjsJXPzAWDhCPMBAAAAeA8NfW5X19CPiElZ9l4ryvItCwd7I0ccravJwPICwOIQ5gMAAABwKxr6syEf1I0X183Of7XX6700g2sHs+LR8WTyyHA4dAwGACwIYT4AAAAAN6Whzwe5Nju/rutxr9d7OaX0QkS8buFg1z3Q1M3DEbFkaQFgMQjzAQAAALgdGvrT7cBvttg5bv/VXll+PXJ+cbqXC2ZT93VW1+bmA8CiEOYDAAAA8IE09PkgO2H+Rq/ffzEVxZsWDHZXijgaEcfH4/H9y8vLyfICwPwT5gMAAABwJzT0+UBF4WNH2HUpPRERz1VV/WRKSZgPAAvAu2oAAAAAbpuGPjez08yfbB+13+udjgiz82F3HYuUnmqa5nFhPgAshp59BgAAAOAutFdPfVYWmRLTMDM/V1U1Ksvyl0VRfKvXK6Ou6n8fKT08LYsE8yC3bbStA1IAYBH4YQsAAACAO6ahP1WmYg+6Zn5VVW1VVVVK6Xy/P3gxUjI7H3ZZjjhaV9XAugLA/BPmAwAAAHAvzNA/eFN7Q4XZ+bAnHh2Nx48Mh0Mn7wLAnPNuGgAAAIC7pqHPjd41O78sT0fOZufD7nqgqatufMWSdQWA+ebOPQAAAAB2gxn6bLt+dn7Z632raJpom8bsfNhFbev+KQBYBH64AgAAAOCeaegfmDxta37j7Pxer/diRJidD7skRRzNOR8fj0f3Ly8vJ+sKAPNLmA8AAADAbjJDn3cpyzJSkjfCrknpiYh4bjKpnky+uABgrgnzAQAAANg1Gvr7bmrX+drs/JTSa0VZvnXwVwRz41ik9FTT1I8L8wFgvgnzAQAAANgLGvoL7trs/Jzzq71e76VFXw/YbW3jJRYA5p0wHwAAAIBdp6HPtdn5dV2Py7J8OaX0QkS8vvALA7ukzV5eAWDeCfMBAAAA2Esa+nsnz8LNEjvH7b9aluXXI+cXD/6KYE7kHE1d2U0AmGPCfAAAAAD2jIb+npqJNd0J8zf6/f6LKaU3D/6KYH7UdWM3AWCOCfMBAACAXfeNb3wjWVVuoKFPpOSlAXZT0wjzAWCeCfMBAAAA2HMa+ntilpr5k5TSa2WvfOvgrwjmQ444WlfVwHYCwPwS5gMAAAB7Qjufm9DQ3x0zc1NEzjlXVTXKOb9aFOVLU3BJMC8erZrmkeFw2LOjADCfhPkAAADAnhHocyMN/V0zS2F+VFXV1nU9Lsvy5ZTSCxHx+hRcGsy6B3LbPtw0zZKdBID5JMwHAAAA9pRAn5vQ0F8wO8ftv9rv9b4eOb+46OsBu6Wpa2sJAHNKmA8AAADsOYE+N9LQvyczuWY7Yf5G2eu9mIrizYO/IphtKeJoRByvJpP7l5eXfZ8FgDkkzAcAAAD2hUCfm9DQvzszfRNEkbwcwD1L6YmIeK5qmidT8kUFAPNImA8AAADsG4E+N9LQvyuz3MyfpJReK8rirYO/Iph5xyKlp9qmeVyYDwDzSZgPAAAA7CuBPjehoT/ncs65qqpRzvnVoihfWvT1gN3Stl46AWBeCfMBAACAfSfQ50Ya+ndkZpv5VVW1dV2Py7J8OaX0QkS8PgWXBjOvqSubCABzSJgPAAAAHAiBPjehoX9rM3+zw85x+6/2e72vR84vHvwVwexrW/dBAcA8EuYDAAAAB0agz4009D/QvIT5G2Wv92JK6c2DvyKYfVWlmQ8A80iYDwAAABwogT43oaG/AFLy5Q+7YecmGQBgzgjzAQAAgAMn0OdGGvrvK89RM3+SUnqtKMu3Dv6KYLbliKNNXQ9sIwDMH2E+AAAAMBUE+tyEhv6vzcWNDTnnXFXVKOf8almWL03BJcGse7Sq60eGw2HPTgLAfBHmAwAAAFNDoM+NNPTnT9fMr6qqret6XJblyymlFyLinxd9XeAePJBzfjgiliwiAMwXYT4AAAAwVQT63MSiN/Tn4oj96+0ct/9qWRZfj5x/MjUXBjNqMh7bOgCYM8J8AAAAYOoI9LmRhv78Pe6dMH+jLHs/i4g3D/6KYDaliKMRcbyu6/uXl5d9/wSAOSLMBwAAAKaSQJ+bWPSG/txJKW3/Au5SSk9ExHNVVT2ZfDEBwFwR5gMAAABTS6DPjRa0oT93R+zHr5v5k7IsX0tFce7grwhm1rFI6am2bR8X5gPAfBHmAwAAAFNNoM9NLFJDfy5vXMg556qqRjnnX5RF8dIUXBLMtJ0bZACAOSLMBwBg33Uf3KZIL0XOP4yIVTvAlGtzxCuR8wsRsW6z4GAI9LmRGfqzrwseq6pqq6qaFGV5adHXA+6VMB8A5o8wHwCAfdeF+UVRrETE/x45v2gHmGZt2zYpYhgRfxE5v2yz4OAI9LmJeW/oL0Q652RwuHfCfACYP8J8AAD23YkTJ3JRpNUU8aNI6Vsa+kyz7ZMkUrqw83z9gYb+7koRZ1NK9w0Gg35ZlpIcPpBAnxstQEN/Lufl3yildD6l1H2P/efpujKYLVVV2TEAmCPCfAAADkhqUkpvpJz/SkOfadY1BVNKVaT02s7zVUN/F6Wi+ElEPN7r9X67LMve3Dww9pRAn5tYpBn6c6Vt2+7GuV+WZfH1yPkni74ecE+08wFgrvigBACAA9Hr9+uIuByR327b/M9t276RIz9uN+5dr9f/ds5ZmLFLmqbpnq/jFPFWRL7Ytvn1nPNbOeLRuXiAuyovRY7B7dw4nnP+Vznnz9dV9a/rqnorUvpYirhSlqVTD3ZBWZZVznlcVdXcfqLfBfpdI3sKLoUpsfN8yDs3e8zLDR8L0crfMSrL3s/qqv79qbgamFF1U9s6AJgjwnwAAA7EyZMnu7B50v3Zy8vLo5TS36SU/h+7ce+6IP+ZZ54RcO2SP/7jP87f/va367Is624OaS+ltaIofuGks/dI3USCtm173e8f9C8XRfHx8Xj8P9VV9d9FxD90nz13Wdz+X/Z8KsvyP/V6ve9WVTWa58cp0Ocm2p0wfx5epxfq+b09N9/sfLgnufVtEQDmiTAfAIAD183QX7QPq5ktXaB/3QVnxzjf3O0ef3748OFXU0pvRkr/bUR8/oAud261bdsF+j/omq7z/lgF+txoThv6i2CrLMvXUkrnsmPC4a517wEAgPmhSQIAAADMNDP0uYlZn6G/MDc75pxzXdejnPMvyqJ4aQouCWaWm2EAYL4I8wEAAICZJ9DnRl1D/8tf/nI7w4H4wiRyXZN4Mpm0VVVNirK8NAWXBDMpRxxt2nZg9wBgfgjzAQAAAJhns9jQX9hqbTIzH+7Fo3VVPTIcDo3XBYA5IcwHAAAA5oJ2Pu9nRhv6C3PE/o2E+XBPHoiIhyNiyTICwHwQ5gMAAABzQ6DPLcz6DH34/9m72x7JzvNO7Nd9Hqr6aTiUtJQoUiJtLSyS8nojUzQD1oxkey2ahiMzQbB5EcCQlRfJJ0je5CPk7X6BBYEAgZMXykgAbdGmLIuwIIjYF2uGQ9MRoQWHCUiL4vAhnu6uc84dnJ5uqjkazlNXd1ed8/tBgx5xhsOq61RX99S//vcFt2R3Z8egAGAghPkAAAAADN6hhv6yG20rP6428/8ppfQfIuL/XYKbAyslRZyNiC+2bXvXCy+84M1tADAAwnwAAAAWpg/LTJPTpp3PTbRLPqDRPo92XZdTSv+pLMt/Hzm/tAQ3CVZLSo9ExDebpnks2VkBAIMgzAcAAABgNPbfdLSsgb43REVsF0XxDxHx/yzBbYFVc3ek9ETbtQ8L8wFgGIT5AAAAwOBo57OiRn3E/oGi8JIlAACEMB8AAAAAWCJXyrJ8PRXFWy4K3Jmu60wOAAZCmA8AAAAMknY+K2b0rfycc26aZjvn/LMipVeW4CbBahr9+R4AMByVawkAAAAAp2708VvfJt7d3e1yzruR0i+W4CYBAMCp0swHAABgoZ5++unRB1IAt2n0rfxrFcnBGnCnHLMPAMMhzAcAAACA0yXIv0YqvGwJAAC+KwYAAACA0yPIv46kmQ8AAMJ8AAAAADhFjti/DmE+HM18PjdBABgAYT4AAAAwWBcuXJAIssyE+MDxyJ5eAGAIhPkAAAAAjMb+GzzKJbm/WvkAAMDHEuYDAACwcE8//bRwClhWyxLkAwAA3JAwHwAAABg0R+0T+4+DCxcuLNNrYZ1WPnBc7MwHgGGoXEcAAAAARqAP8r2xAwAAWBnCfAAAAAAGa/9khrRkQb5d+QAAwE05Zh8AAIBjYW8+sCSKJXwNzPMjAABwU5r5AAAAwKB5Y8k4LWkjP7Tyb01K6Z/KsvwPbdt+NiI+uwq3GZZJ23WuBwAMgGY+AAAAAEO0jI38EOTfXNd1OaX0n6qq+veR80vLfnthKWVPNQAwBJr5AAAAAAzGEjfyQyv/tmynlP4hIr6yQrcZAAAWSjMfAAAAgCFZ1kZ+CPJvXyq8fAkAwHj5bhgAAIBjY1c5cFL6Rv6FCxeKJW3kh1b+bbtSluXrEfHWit1uAABYGGE+AAAAMGj7x64zfMvcyA9B/q3LOeemabZzzj9LKV5ZldsNAACLZmc+AAAAMHh9oO+kiGFa8h35B7Tyb0PXdbG7u9vlnHcjxy9W5obDEmnmc5cDAAZAMx8AAAAYBQ39wVr2Rn4I8u+cnfkAAIyZ74YBAAA4VtrQLBOB/nCswI78A1r5AADAHRHmAwAAAKMi0B+MVWjkhyAfAAC4U8J8AAAAYHQE+qtrhRr5oZUPAAAchTAfAAAAGCWB/spalUZ+CPIBAICjEOYDAABw7OzNZ1ntt7yF+itgxRr5vU6YDwAAHIUwHwAAABg9of5K0MgfobLw8iUAAOPlu2EAAACAfQL95bOCjfywK3+Bkk9JAADGS5gPAADAiXDUPqtCoL90VqmRH4J8AABgUYT5AAAAANcQ6J++FW3khyAfAABYFGE+AAAAwHUI9E/dqjXyQysfAABYJGE+AAAAJ8ZR+6wagf7JW/FGfrcEtwMAABgIYT4AAADADQj0T9wqNvJDIx8AAFg0YT4AAADATQj0j98KN/Jjv5EvzAcAABZKmA8AAMCJSykJvVg5Av1jp5HPdaZrvAAAjJcwHwAAgBO1vzdfOsNKEugv3oo38mP/+cxz2jFpu26Q9wsAAG6FMB8AAIATp5nPKhPoL9yqNvJDkA8AABwnYT4AAACnoUspqVuysgT6RzeARn4I8gEAgOMkzAcAAODEpSQHZfUJ9I9slRv5vU6YDwAAHKfKdAEAADgFfQDWGDyr7iDQf/rpp4W6t2h/Zhr5AAAANyHMBwAA4MTtN/Mdsw/jVA7gXtuVDwAAHDthPgAAAKcipaSZz2Bo6N/chQsXyhVv4x8Q5J+kbNQAAIyXnfkAAACcBukMjMj+mx2GEuQ7VeQEZWE+AAAjppkPAADAaWlNnqE5aOifgHQMJY38MT9PH/PzsdHIBwAATpQwHwAAAIAQ2t+UMB8AADhRjtkHAAAAgBsT4p+goihiMpkUdV1Puq775GjuOAAAXEMzHwAAAAA+XtbKP1kppVRV1VpK6YGIeHhM9x0WpSj1+ABgCHxFBwAAAICPJ8g/Hett234+Ij49xjsPR1UUpRkCwAAI8wEAAADg+jpB/unpum6sdx0AAPYI8wEAAADgVwnxT9da7rqHIuK+MQ8BAIBxszMfAAAAYPUImo+XPfmnqCiKlHN+sGnbb0VKnx3tIAAAGD1hPgAAAAB8lCD/lOWc78k5PzrqIQAAMHqO2QcAAABYTcLm4yHIB1ZeWZYuIgAMgDAfAAAAAK4S5AMAAEtDmA8AAAAA9uSfqpTS3g8AAOCXhPkAAAAAIMgHAACWTOWCAAAAADBygvxTlvNHx3/t/wduT1Ho8QHAEPiKDgAAAMCYCfKXkDAfjqYsSxMEgAEQ5gMAAAAwVvbkL6ncdWMfAQAACPMBAAAAVpQA+mgE+UumPxZ8MpkUdV1Pcs6fHPs8AADAznwAAAAAxkiQv2RSSqmqqrWU0gNd1z089nnAUdSTifkBwABo5gMAAAAwNoL85bXetu3nc8Snxz4IAAAQ5gMAAAAwJt3+D5aYnfkAACDMBwAAAGA8tPGX31rbtg9FxH1jHwTcqVR42R8AhsLOfAAAAADGIDtef7kVRZFyzg82TfOtSOmzY58H3KlkcgAwGMJ8AAAAAIZOkL8ics735JwfHfscAAAgHLMPAAAAsLKE07fOrIDRKByzDwCDoZkPAHAbXnjhhXTA3O5czrk7d+6cF9QBgJPQCfKBUfG3VQAYDGE+AMBNfP/73y9SRNXlXOauu7vtuse6rnvY3O5cVVXf++EPf/gfv/rVr3phHQA4ToL8FZNzN/YRwJElaT4ADIYwHwDgJv6/Dz6oIudP5JzvzxGPR8Q3I6UnzO3O7e7sRF1VL0VEu6r3gXH6/ve/n/a7TqW1ZUeTUro35/xg5PzDiPjbW3w+mEbExOxvriiKv46I+bLfThYi62B+LKnwiuiPBK+qqqiqajLf3f3k2OcBR3A5cr5YVtUrOWdvZAKAARDmAwDcRM65jD7IT+lPIuenIqVHzAzG5bnnvldE7v/+lMuuy59s2/Z3c8RDHgZHkPODXc7nJ9PJ/1yW1XeKlG4ldEtd15V7z8vceFBFMW+aZseUGDE78ldIv8Wqqqq1lNIDrROw4M7lfDEinimL4kVhPgAMgzAfAOAGvvud76T+aP1I6fH9IF8jH0ZoZ3vHCR3HpCjK//vJJ5+8cqt/+oULFzSQgZvJWvkrab1t28/nnD899kHAncoR76aIVyfT6Xvnz58X5gPAADiaEADgBlJEyik9th/caeTDSPVN8HxwQofng1P19NNPe2EauBGN/BWXO+/DgKMqS4cYAcBQaOYDANxYShEPa+DCeL3wwgtO6ABYDVmYv9LW2qbpV9jcN/ZBwBG8k4riUn+wlCECwDBo5gMAANxAv8fXCR3LRTsfuA5B/opJKe39iL2VK0XKOT/YtO23IqV/NfbZwBG8Vpfl67PZrDFEABgGYT4AAMAN9GH+oRM67jar5SDQhw8JsAX5g5Bzvifn/GhEfHbss4A7lfqd+WW5a4AAMByO2QcAAABgVQnyV1TOLhkch7LQ3wOAIfGVHQAAgJWknQ+jJ8hfcf3ZN3VdF3VdT7qu++TY5wEAANfSzAcAAABYbfnq6cqjIsgfgH6TTV3XaymlB9q2fXjs84BFqOvaHAFgQDTzAQAAWFna+TBKgvyB6Jv5ETFp2/bzXdd9euzzgIVIY3tvFwAMmzAfAAAAgFUhyB+o3HVjHwEshGY+AAyLMB8AAICVpp0Powm2BfkDs9/M32yb5qGIuG/s84Aj08oHgMGxMx8AAABg9Q19b74gf4D2w/wHmrb9VqT02bHPA46qEOYDwOBo5gMAALDytPNh0AT5w5X6Xfk550cjQpgPR5SE+QAwOMJ8AAAAgNU31KBbkD9wduXD4qRCmA8AQyPMBwAAYBC082Fw+s/pTpA/PH17uK7roqqqSdt1d499HrAAlyPnH5Vl9UrO2XMmAAyIMB8AAIDBEOjDYHT7PxiIPsA/OAI8pZTqul5LKT3Qte3DrjEcUc4XI+KZqixfFOYDwLBUricAAADAyhtSeCPEH7j9UH/Sdd3nu667N+z5hiPJEe+miFfXNzbem81mwnwAGBDNfAAAAAZFO58RW/XH/uFj9X0eD0xfFr62MNw2zdjHAguTvCkGAAZJmA8AAMDgCPRh5WQh/njsh46bbds+EhH3jX0esADvlEW6FBE7hgkAw+KYfQAAAIBh6IPwVaxmCvJHpg/zc+4e6LruW5HSp8c+D1iA1+rJ9PXZbOa4CwAYGM18AAAABkk7H1aCIH9E+hC/ruuiqqrpfN58MVJ6NCI+N/a5wFGlfmd+SrsGCQDDo5kPAAAAMAx5xdr53f5HQf5IpJRSXddrfYDfte3DY58HLFJd1+YJAAOkmQ8AAMBgaefDUsoa+eO0vyt/0nXd57uuu3fs84BFKopV3LICANyMMB8AAIBBE+gzMqvweM+HWvmMUNtY6w0LlVKUlWY+AAyRY/YBAAAAOAna+CPVN/KrqirKsqxyzvc0bftIRNw39rnAohRJKx8AhkozHwAAgMHTzodTJ8gfsYNd+SmlB9umeSp33bcipUfGPhdYlKLwMj8ADJWv8gAAAIyCQJ+RWLbHuf34I7a/I//DXfkR8UDTtl+JlB6NiM+NfT6wAJcj5x8VZfFKztlzLAAMkDAfAAAAYFiWaR/9wX58IdPIXBPkfyh3y/TwhBWX88WIeKau6heF+QAwTMJ8AAAARkM7H06MEJ8P7Qf6m818/kjO2a58WJAc8W5EvLq+sfHe+fPnPd8CwAAJ8wEAABgVgT4cq8Mhvs+1ETsoCfcf98P8/oh9u/JhwZJ9+QAwaJXLCwAAADAoB0F6OuE7ZTc+v6Ku66Kqqknbtl/MOT9qQrBQ75RlcSkidowVAIbJ2/YAAAAYHe18WDhBPr8ipZTqul5LKT3QzOcPmxAs3Gt1Xb8+m80aowWAYRLmAwAAMEoCfQbupB7fjtXnY+0frz/JOX++67p7TQoWK0W8O6knu8YKAMMlzAcAAGC0BPpwJFkjn1vRNs2HO/SBxSorm3QBYMh8pQcAAAAYnuPemy/E51f0Tfw+tO8/VlVVlGVZ5ZzvmTfNIxFxn4nBYvWfa0WhrwcAQ+YrPQAAAKOmnc+AHcdj27H6XNf+kfp7Hw/tyn+wbZqnctd9K1J6xORgsVJxXO/XAgCWhTAfAACA0RPowy3pNPK5FQe78iPigXnTfCVSejQiPmd4sDCXI+cflUX5SrbDAgAGTZgPAAAAwM0I8bmhgzzxcK7YdW3krjM4WLScL0bEM5PJ5EVhPgAMmzAfAAAAtPMZpkWE7wfH6ktkuSV1XRd1Xdf9rvxmblc+HIcc8W5EvDqZTt87f/68718AYMCE+QAAALBPoM8A3elj2m58bttHduW37VOtXflwbIqiiLIsDRgABk6YDwAAAIcI9Bm5fJ0fcEsO78pv+l35EXblw/F4pyzLSxGxY74AMGyV6wsAAAAwWAfhfLqFO2gvPgvRr/Du7MqH4/TaZDp9fTabNaYMAMOmmQ8AAADX0M5nYG72eHakPndkv4m/9/Eju/Kb+SORs135cExSxLtVVe2aLwAMnzAfAAAArkOgz0hce6w+3JLDQf7hXfld1z3VNK1d+XCcrr6BxogBYASE+QAAAPAxBPoM2EEbvxPic1Qf3ZU/tysfjs/lyPlHZZFeyf0+CwBg8IT5AAAAcAMCfQbg2ta9Jj5HdpAjHs4T93blt3blw7HJ+WJEPFNV9YvCfAAYB2E+AAAA3IRAnwHI2vgch8O78ue7u49ku/Lh2OSIdyPi1el0+t758+c9jwPACAjzAQAA4BYI9FlxWYjPoh3eld+27VNt19mVDydgMp0aMwCMhDAfAAAAYOC8GYXj8NFd+Y1d+XD83qnK4lJE7Jg1AIyDMB8AAABukUCUVdM/Zj1uOW57u/I7u/LhBLxWT6evz2azxrABYBwq1xkAAABuXR+MXrhwIRkZy0yAz3Hom/h9cN9/rKqqKMuy6nfl7+7uPhL9rvzkqRGOU4p4d1JPdg0ZAMZDMx8AAABuk6CUZXWjJr7HLUexf6T+3seP7Mpvmqe6trUrH05IPZkYNQCMiGY+AAAA3AENfZaJoJ6TdHhX/rzflZ/Soy4AHKvLkfPFsixeyf3xGADAaGjmAwAAwB0SoHKaDlr4t/M49JjlTh3kh4dzxLZtI9uVD8cv54sR8UxV1S8K8wFgXDTzAQAAAFaIQJ7TVNf1h7vy5/2u/Ij7XBA4Xjni3RTx6nQ6fe/8+fO+BgDAiAjzAQAA4Agct89JEeJz2g525eec75/v7j6Vc+535X/ahYGTMZlOTRoARsYx+wAAAHBEQlaO0+0epX8zHq/crn5HflVVqaqqMiLO5pwfatr2if1d+Z8zUDh271R1dSkidowaAMZFMx8AAAAWQEOfRRO6s0yqqqrLsjyTc/707u7upyLnzUie8uCEvDadTF6fzWaNgQPAuGjmAwAAcGpSSu2Qpi98ZREW3cSHO5X2w/qiKPoT9icRcU/TNL/ete2XIuJeg4WTkSLererJrnEDwPgI8wEAADg1RVFcGdr0hbDcqZMM8T1OuZmDIP/Qx6rruk/Md3e/Eik9HSl90RDhZPSfh3VdmzYAjJBj9gEAADhN3RCn78h9bpVQnWVX13VRFEWVc75nd2fnKznnxyOlh1w4OBGXI+eLZV2/knP29QIARkgzHwAAAI6BkJYbWYaj9D1GuZE+N+zP1q+qaq0oigeapnmqbdtvRUqPGByckJwvRsQzk7p+UZgPAOOkmQ8AAADHREOfawnQWWb9Ud77IX6UZZmKoigj4mzXdQ83TfNEpPSoCwgnJ0e8myJena6tvXf+/HlfPwBghIT5AAAAcIwE+gjwWQXX7sivqqouy/JMzvnTTdN8KnfdZiRPZXDSyrLo31xj7gAwUo7ZBwAAgGMmzB2fg2P0l/3ae2xyPUVR9CfsTyLinrZtf71pmi9FxL2GBSfunbquL0XEjtEDwDhp5gMAAMAJ0NAfPsE4q+zgeP2Dtdz9uvyu6z6xu7v7lf7hHSl9xgWGE/fadG399dls1hg9AIyTZj4AAACcEGHvMK1CA/9GPC7HqQ/u03WOza/ruqjrus4537O7s/OV3HWPR8RDEXH32GcGJ+hy5Pyjokg/rqpKKx8ARkwzHwAAAE6Qhv7qE34zJNe08VNd12s55/ubpnmqbdtvRUqfdsHhhOV8MSKeqav6xXzwCQoAjJIwHwAAAE6YQH/1CPAZsj7QL8syFUVRRsTZnPNDTdM8ESk96sLDycsR76aIVyfT6XsXFt23AAAgAElEQVTnz5/39QcARswx+wAAAHAKhMPL7+D4/DFcK4/H8Too/VZV1Z+ufzYiPj3f3f1U7rrNsc8GTlP/Jpu1tTXXAABGTjMfAAAATomG/nIRaDMmh0/uLoqiP2F/EhH3NPP5r7dt+6WIuNcDAk7NO1VVXYoI+/IBYOSE+QAAAHCKDgJkof7pEOD/kjeXjFtKqWqb+Sd25/OvREpPR8Rnxj4TOEWvTafT12ezWeMiAMC4CfMBAACAURDcw0f1x3hXVVWUZVnlnO/Z2Z1/JXJ+PFJ6yKjgVFyOnC9GxI/ryUQrHwAQ5gMAAMAy0NA/HgL826OdPy792fp1Xa/lnO/f2dl5KnfdtyKlT499LnBqrgb5z0zq6sWUkq9fAIAwHwAAAJaJMPXOCO3hxvoWfuzvyu9/XpZlKoqijIizTdM81LXtE5HSo8YIpydHvJsiXp1Op++dP3/e1zUAQJgPAAAAy0agf3PC++Pj8TdsB6F+VVV1WZZn2ra9Z767+6mI2Bz7bGBZ1JOpawEA7BHmAwAAwBISqArs4TgcNPKLotho27Y/Xr/fj/+liLjXwOHUvVPV1aWyLO3LBwD2CPMBAABgSY1hj77Afjl5M8lw9Y38oijOpJTunc/nX8hd97VI6esR8ZmxzwaWwGvT6drrs9mscTEAgBDmAwAAwPI7HHivUsAqqIfT83E78vtGfkTcv7Oz/VDbNI9FxO9ExEMuFZyqy5HzxYj48WQy0coHAD4kzAcAAIAVIiDnpGjnD8O1O/L74/T7Rn4zbzTyYVlcDfKfmdTViyklX+cBgA8J8wEAbiCn1EXE9yJ7PWXBvpcjukHdIwCAJXS4kZ9zvr9pmod2d3c18mGJ5Ih3U8Sr0+n0vfPnz/vLJwDwIWE+AMANfOMb38h//dxz/zFHvGROi5Miut/7vd/zIhUALDnt/NV3eEd+0zRfmM/nX4uIr0dKGvmwZOrJ1CUBAD5CmA8AcBN/8OSTfejcmhOr5G/+5m/6Q3ULF+3ouq77RI54UJJ1PHZ3dr7w3Pf+8mcpFd7gcxtyRMo5p8i5P4s3XXuCTFEU8yf/8A+dgAIjcnhH/sHHoihSSqlOKf2Ltm1/Y3d394ncdb8TKWnkw3J5p67rS2VZ2pcPAHyEMB8AAAbmL//iL9LOzs6/jog/dG2Pbi/Iv7pTmGMwn8//x/l8/tth9cad6t+0M7n27/cbm5v/LiJ+vlL3BFiIPtQ/CPT3A/4q5/zJ3d3dL+ecn9bIh6X02nQ6fX02mzUuDwBwmDAfAACGp9gL8lP6X1zbo9PIP2YpPRkRTw76Pp6Cruv+d2E+i+Ko/dXTh/hVVRVlWVYppXt2dna+3Lbt40kjH5bN5cj5Yor48XRtTSsfAPgVjt0EAAAA4Ib6QN+EVkPfyt87W7+u14qieGB3d+eP2qb5s5TSvxr7bGDp5HwxIp6pJ5MXc86eZwGAX6GZDwAAAAOTUrK2AAbuejvy9xv5qSiKMiLOznd3H27mzX8eKT3u8QDLJ0e8myJe3djYeO/8+fPCfADgV2jmAwAAwPDYucvCaecvp4NQ/0BVVXVd12e7rrunadtPRsSZsc8Illkqiqjr2jUCAK5LMx8AAAAGJqU0d01hPPpAvyzLvUZ+URQbbdvev7O9/VDO+Tcj4l4PBVha79R1fSki7MsHAK5LMx8AAAAGxjH7HBft/OVzcMz+oUb+/Ts7O1/IOX8tUno6Uvri2GcES+y1jY3112ezmRN1AIDr0swHAAAAgCV3sx351zTyH4uI34mIh1xXWEqXI+eLVVn8uCwrrXwA4GNp5gMAAABwy7TzT9fH7cjPOd+/q5EPqyHnixHxzGQ6fTEfvEMHAOA6NPMBAAAAYIVcd0f+zs5Dues08mEF5Ih3i5Re3dzcem82mwnzAYCPpZkPAAAAwG3Rzj891+7I/7CR33Ua+bBCykrPDgC4Od8xAAAAAMCSueUd+Rr5sEr2duWniOen0+lPI8K+fADghjTzAQAAALht2vkn46Y78jXyYXXs78ovyvLP19fXL81ms8bVAwBuRJgPAAAAwB0R6J+Mg0Z+XdfVQSN/e3v7S13XPXGokX/3GGYBq6zflR8Rr26sr/18Npu1LiYAcDOO2QcAAACAJXXoeP26LMszbdvee6iR//WI+IxrB6uj/3yuJ1NXDAC4JZr5AAAAANwx7fzF6AO+w0fqH+zKv7aRv6ORD6vsnaqqLpVlaVc+AHBLhPkAAAAAHIlAf3E+bkd+13X37/SN/JztyIfV9drG5ubrduUDALfKMfsAAAAAsET2j9UviqIo94/W7xv5D+WcHzvUyAdWx+XI+WJVFj+uqkorHwC4ZZr5AAAAAByZdv5i7O/I74/WXyvL8v757u6v7Vy5opEPqyznixHxzGQ6fTEf7NAAALgFmvkAAAAAcMIOjtPfD++jLMvUV/H7X9r/eN/u7u5Xm6Y5GxGf1ciH1ZUj3i1SenVzc+u92WwmzAcAbpkwHwAAAICF6Nv5Fy5cSKZ56w5C/X43flEUZyKijoit7e3tP+ra9k/3Xr9LaTMiPrMa9wi4nrr2UjwAcPscsw8AAADAwjhu//b0jfy6rvsF+RsRcX/Xdb+1feXKk23b/nGk9Hik9Oh+I//uVbpfwJ5+V/6PUsTz0+n0pxFhXz4AcFu8HRAAAAAATslBIz+ldG/TzL+wuzt/Infd76aU7nNNYMXt78qvJ5Nnp2vrl2azWeuSAgC3QzMfAAAAgIXSzr96fP7BEfrX+7WiKD7SyJ/P51/a2dndC/L3GvkRnzvxGw0sVL8rPyJeXV9b+7kgHwC4E8J8AAAAABZOoH/VxwX6dZ/kV9XZlFIf5H9hd2fna/3YIqUvnvytBI5LURQxmU7NFwC4I47ZBwAAAIAT0Af7VVUVKaWyP1q/b+RvX7nyUNu2j0XE7+zvxgdWX78r/6Jd+QDAUWnmAwAAAHAstPP7ldkfHUFVVdOqqu7vuu7Xtq9c+ULbtl+LlDTyYUj2d+UXZfnnm1tb/a78xvUFAO6EMB8AAACAYzOWQP/aHfkHIX5ZlmkymZSTyaSaTqd1f6x+M5///s729le7rnsiIh7db+TffYo3H1igg1350+nErnwA4Egcsw8AAAAAC9IH+ofb+P1u/P0j9euI2NrZ2XmybZo/23tdLqXNiPiU2cPw9M8Fa2vrriwAcCSa+QAAAAAcq7Edt9+HeH0jv67rqiiKjX43ftd1v3XlypU/aJvmjyOlxyOlg0b+v1iCmwwsRr8r/0f9rvy6rn9alqVd+QDAkQjzAQAAADh2Ywn0D1r5fSO/qqqze8fqN80Xtre3v5677r+LlP6zU7+RwPHY35UfOf/55uaGXfkAwJEJ8wEAAAA4Easc6B/sxD+8F/+wQyF+ceho/fu3t7e/tLuz80TkfH6vkR/xudO5B8BxO9iVv7a+/vOvfu137coHAI7MznwAAAAAuAXX7sO/nqqqpimlz7Rt+6n57u7nu677WqT0dbvxYTzW1tdcbQBgITTzAQAAADgxQzpu/2A3/mQyKSeTSTWdTuv+WP3dnZ3f39nZ+WrXdU9EhN34MB7vVHV1qapqu/IBgIXQzAcAAADgRPWB/oULF65/Xv0Su14r/9CR+nXXdVtXrlx5Mnfdn+297pbSpkY+jMprG+sbr9uVDwAsimY+AAAAACdu2Rv61+7I74P8gx/9P7t2N/7u7u5vbW9v/0Huuj/e242fkkY+jMflyPlHVVn8uJ5MtPIBgIXRzAcAAACA67jRjvzr7Mbvj9T/3UjpPrOEkcn5YkQ8s7a2/mL+uCcNAIA7oJkPAAAAwKlYlf35B038fi/+4d34Ox/djX9+r5Ef8bkluMnACcoR75Zl8er6xsZ758+fF+YDAAujmQ8AAAAA13G4YNs38YuiuKf/edM0E7vxgcMm0zXzAAAWTpgPAAAAwKnp2/kXLlxIJ/3fP9iFH9eE9ge/VlVVkVLaO9WyKPqfpvvn8/m5pplH1+W1yPmP95v4wHj1u/IvlkXx/HQ6/WlE2JcPACyUMB8AAACAU3Wagf6NduIfNPFzzpOdnZ0n26b50/1fLu3GBw525a9vbDxbVdWl2WzWGgoAsEjCfAAAAABO3WkF+nGDJn7btueapom2adby1Sb+Ex4pwIF+V37V78pfX/+5IB8AOA7CfAAAAACWwkkH+h+3E79v4s93d5+c9038q79HEx+4LrvyAYDjJMwHAAAAYGksKtC/k534fRO/a9uY9038rrvaxE+nclgAsNzsygcAToQwHwAAAIBBup2d+PP5/MlmPv/TrIkP3Ixd+QDACRHmAwAAALBUFn3c/rVN/HTVfW3bntfEB27DBxHxRkS8UFblT6bT6VuCfADgOAnzAQAAAFg6iwj0b7ATv57P519v5vNvauIDt+GNyPnbKeL59fWNN4uiEOQDAMdKmA8AAADAUjoc6N9oB/61btbEb9q27tr2G5r4wG3J+a0c8VJV1/84mUx+kXNuDBAAOE7CfAAAAACW1rWB/s2C/APXNvF3d3e/3jTNN0MTH7hz20XE2+vr65cj4sq5c+du7QkJAOAOCfMBAAAAWGkf18RvmuZ82zTRdl2du04TH7hTlyPnixHxXDWZvDydTt+fzWaCfADg2AnzAQAAAFhqfTv/O9/5TrpRK/9wE79pmnpne/vrbdt+c/+XNfGBO3c1yH8mcn52a3Pj0mw2sysfADgRwnwAAAAAlt6f/Mmf5O9+97upqqq0F87vN/LLsuxf35p2Xffgzs7Ob/c78XPfxI+42sQHOKIc8W6KeHV9Y+PnX/3a7wryAYATI8wHAAAAYCV84xvfyH/1V3816Rv4Oecy51w1TfOv5/P5H+Su+2xEfHb/fmjiAwvVv3lobX3dUAGAEyXMBwAAAGBpfe9730tFUXy46L4oik/N5/N+F/7a/i78/zJS+i/swgeOwd6u/BTx/GQy+WlZljuGDACcJGE+AAAAAEurqqqqLMuzXdfFfHe33L5y5Wtd1/0P+69rTTXwgWOzvyu/KMtnN7e27MoHAE6cMB8AAACAU3dtA7+qqqJt27ppmnuv/PM/f7lt20gR/S78/zpS+n1XDDhuB7vyN9bXfn7+/HlBPgBw4oT5AAAAAJy6gwZ+0zTRNE25vX3lN7u2+zc54tdSxF77PvevZaX0gKsFnJSiKGJtfcO8AYBTIcwHAAAA4Nhdr3mfcy77n7dtW8x3d+9t2/bL/XH6+w38fxsp/Tc24QOn4MNd+esbGz+NCLvyAYBTIcwHAAAA4NgdNO/7/858Pi92trd/c940v9eH95FzqYEPLI39Xfl1XT27vr5uVz4AcGqE+QAAAAAc2Y2a913XFW3T3Lt95cpe8z53Xd+8/68ipf927zenFBr4wLI42JW/ubX1c0E+AHCahPkAAAAAHNmvNO93dn6zmc9/r8u5D+8/0rwPzXtgyU0mdVRV7TIBAKdKmA8AAADAx7pR4/5A0zRF17X3Xvnn5st9eB+a98BqurorP6Xn19btygcATp8wHwAAAICPdbhx3x+X3zfu237Xfd+4v9q6739J8x5Yffu78tfX1p6dTCZ25QMAp06YDwAAADBSf/u3f5t6XX8Mfs5F7GVZeW8Y/W77g133bdt+eT+4/2jjPq627vc+eBABq+uDiHgjIl4oq/In6xsbbwnyAYBlIMwHAAAAGJEf/vCHqSzLjf173Dftf2M+330yd7nocjfJOYr9tn1o3AMj8Ubk/O0U8fzGxuabRVEI8gGApSDMBwAAAFhBf/d3f9eX4Yub3fL57u7Vj/N537RPTdt+Inftb7Vt17fpqxzxbyOl//4j/1L6Zc9e4x4YvJzfyhEvTafTf6zr+hc558ZFBwCWgTAfAAAAYAUcbtQ3TVPs7u7+RtM0f5Bz95Gj8SPv/S8OtesPK3LE5yPiX+7/szJS+oLrD4zcdlEUb69vbFyOiCvnzp3LYx8IALAchPkAAAAwMFf++Z//5V/+xV9cWsi9SinK4qbl748oyzKKW/x3yqq65d87NAeN+cP69vxhbXv1pOcud6ltu090bftbcbUtf/1G/WHp+p16TXuAD12OnC9GxHNr0+nLVVW9P5vNBPkAwNIQ5gMAAMDAtF33P3U7O18Z3B1LKYqPCahv1d4bB+70j8j7zffb0PWN+byQXEijHmDRrgb5z1Rl+ezm1tal2WxmVz4AsFSE+QAAADAwKaU/iog/GuJ17Y4YjHftKeQ0R3wDwod/zEL+FAAO5Ih3U8Srm2fO/FyQDwAso3GeYwcAAAAAwOhNJnXUdT32MQAAS0ozHwAAAACAMdnblV+k9Pza+sZPI2LH1QcAlpEwHwAAAACA8djflb+xufnsZDKxKx8AWFrCfAAAAAAAxuCDiHgjIl6oJ5OfTKfTtwT5AMAyE+YDAAAAADAGb0TO305F8fzGxsabRVEI8gGApVa4PAAAAAAADF7Ob+WIl9bX1/+xLMtf5JwbFx0AWGaa+QAAAAAAjMF2VZZvr62tXY6IK+fOncuuOgCwzIT5AAAAAAAM2eXI+WKk9NzGxvrLRVG8P5vNBPkAwNIT5gMAAAAAMFx9kB/xzNra9Nnp2vql2WxmVz4AsBKE+QAAAAAADNEHEfFGRLxQVuVPNjY23xLkAwCrRJgPAAAAAMAQvRE5fzsVxfObm5tvFkUhyAcAVoowHwCApfHCCy+kA67Knctd94kc8aAhAgAwajm/lSNeWptO/rGq6l/knJuxjwQAWC3CfAAATtVzz32viNx/X5rLrst3d133WI78sKty59qmfTCl9PVVvf0AALAg21VZvr2xsXk5Iq6cO3cuGywAsEqE+QAAnKqd7Z0qcv5Ezvn+HPF4RHwzUnrCVblzKaXvV0Xxv0aK7VW9D8uk6/L5ruv+MCLWxj4LAIAVcTlyvhgpPbexsf5yURTvz2YzQT4AsHKE+QAAnKqccxl9kJ/Sn0TOT0VKj7giR7M2nf679Y2N7xZF0a3y/VgWOzs7f/v+++//m7HPAQBgZfRBfsQzG+vrz07X1i/NZjO78gGAlSTMBwDg1Hz3O99JuevujpQe3w/yNfIXIBXFaxHRaB8txg9/+MOfRcT7EbE1hPsDADBgH0TEGxHxQl1VP1lbX39LkA8ArLLC1QMA4LSkiJRTemz/aH2N/AXpuu6BlFIaxJ0BAIBb90bk/O1UFH+1sbX1ZlEUgnwAYKUJ8wEAOE194vzwfiP/bldiMbque1iYDwDAiPSN/H/IOT+fIn6wubn5clmWb+ecGw8CAGCVOWYfAAAAAIBVttfILyJ+MJlOX5lMJm9HxPa5c+esnQIAVpowHwAAAACA1ZXzWznipaosX9nY3HwzpbQjyAcAhkCYDwAAAADAKtsuIt5e39y8nFK6IsgHAIZCmA8AAAAAwCq6HDlfjIjnputrL0+n0/dns5kgHwAYDGE+AAAAAACr52qQ/0xdV89ubZ25NJvNWlcRABgSYT4AAAAAAKvkg4h4IyJeSEXxk60zd70lyAcAhkiYDwAAAADAKnkjcv52inh+c3PzzbIsBfkAwCAJ8wEAAAAAWAV7jfyc8/NFxA/6PfmTyeTtnHPj6gEAQyTMBwAAAABgFew18vsgv6yrVzY2Nt+OiO1z585lVw8AGCJhPgAAAAAAyy/nt3LES6koXjlz5q43U0o7gnwAYMiE+QAAAAAArILtIuLtzc3NyymlK4J8AGDohPkAAAAAACyzy5HzxYh4bjKdvry2tvb+bDYT5AMAgyfMBwAAAABgeV0N8p+pyvLZM3fddWk2m7WuFgAwBsJ8AAAAAACW0QcR8UZEvJCK4idnzp59S5APAIyJMB8AAAAAgGX0RuT87RTx/NbW1ptlWQryAYBREeYDAAAAALBM9hr5Oefni4gfrK+vv1zX9ds558ZVAgDGRJgPAAAAAMAy2Wvk90F+XdevrG1svB0R2+fOncuuEgAwJsJ8AAAAAACWR85v5YiXqrJ8Zeuuu95MKe0I8gGAMRLmAwAAAACwTLaLonh7c2vzckRcEeQDAGMlzAcAAAAAYBlcjpwvRsRzGxsbL9eT6fuz2UyQDwCMljAfAAAAAIDTdzXIf2Z9ff3Z9fX1S7PZrHVVAIAxE+YDAAAAAHCaPoiINyLihXoy+cn6xsZbgnwAAGE+AAAAAACn643I+dtFUTy/tbX1ZlEUgnwAYPRCmA8AAAAAwCnZa+TnnJ8viuIHZ+666+WU0ts558YFAQAQ5gMAAAAAcDoOGvk/2NzcfKUsy7cjYvvcuXPZ9QAAEOYDAAAAAHCyftnIj/jBxvr6308mk7dTSjuCfACAXxLmAwAAAABwkq428iN+MF1be2W6tqaRDwBwHcJ8AAAAAABOwkca+fVk8vcbm5sa+QAAH0OYDwAAAADASfiwkV/W1StbZ85o5AMA3IAwHwAAAACA4/SRRn5Zln9/5sxdGvkAADchzAcAAAAA4Dh92MiPonhlc2urD/I18gEAbkKYDwAAAADA8cn5rRzxUiqKV86cOfNmVdca+QAAt0CYDwAAAADAcdouIt7e3Ni4XFXVFUE+AMCtEeYDAAAAAHAcLkfOFyPiubX19ZfX1tffn81mgnwAgFskzAcAAAAAYPGuBvnPTKfTZze3ti7NZrPWlAEAbp0wHwAAAACARfogIt6IiBfqyeQnm1tbbwnyAQBunzAfAAAAAIBFeiNy/nZd189vbW29WRSFIB8A4A4I8wEAAAAAWIS9Rn7O+fmyKH6wsbn5ckrp7ZxzY7oAALdPmA8AAAAAwCLsNfL7IH9za+uVsizfjojtc+fOZdMFALh9wnwAAAAAAI7iI438M3fd9fdVVb1dFMX2E088IcgHALhDwnwAAAAAAI7iZ5Hz/1kUxfObW1uvTqfTfyqKYvfxxx8X5AMAHIEwHwAAAACAO/FB5PyzHPHXRVE8d/bs2f9rfX393aqqmt/+7d8W5AMAHJEwHwAAAACA25fzaxHxfxRF8ddnz579x42NjXcfe+yxuUkCACyGMB8AAAAAgNvRN/Jfyzn/ZVGWz919992vrq+vvy/IBwBYLGE+AAAAAAC37moj/38rUvr+ma2tnwryAQCOhzAfAAAAAIBb8ctGfkrf39raenXrzBlBPgDAMRHmAwAAAABwc4ca+VtbWz89c/asIB8A4BgJ8wEAAAAAuJFfaeQL8gEAjp8wHwAAAACAj6eRDwBwKoT5AAAAAABcj0Y+AMApEuYDAAAAAPCrNPIBAE6VMB8AAAAAgMM08gEAloAwHwAAAACAX9LIBwBYCsJ8AAAAAABCIx8AYLkI8wEAAAAA0MgHAFgywnwAAAAAgHHTyAcAWELCfAAAAACAMdPIBwBYSsJ8AAAAAIBx+mUjvyy/f9fW1qubZ84I8gEAloQwHwAAAABgjA4a+WX5/bNnz/50Y2NDkA8AsESE+QAAAAAA4/KRRv7dd9/96vr6uiAf4P9n72524yj7NA4/9dlVXVVdHSesZzTLWVmOJRbAbjQHNEcw6zkEjoDVrLIIr6x4Q7LLJpZGkbEhejeWJSdg2fkQxH5G7bQhzhcEYru7fV0SQrEUSHdFAvzj7j/AjBHzAQAAAACukjcW+UI+AMBsEvMBAAAAAK6G3xb5eZ6vj/reIh8AYIaJ+QAAAAAAV8F0kT8J+f14vF1VlZAPADDDxHwAAAAAgMW2F2LcCCGsZ1l259rS0vdlWQr5AAAzTswHAAAAAFhkMW7EEL6uBoP742vX9rIsOxTyAQBmn5gPAAAAALBYDqcfqb8bQ3geYrxVVdXa9Rs39tM0PVpZWTn2vAEAZp+YDwAAAACwSKa38WMIG2kIT4Zts3n9xmePl5eXo+cMADA/xHwAAAAAgMVwssiPMX6bJsl6EsIPo1F30F9beiHkAwDMHzEfAAAAAGARTBf5JyE/Tbf78fjnr776ym18AIA5JeYDAAAAAMy3s4v8NN28trR08MUXXwj5AABzTMwHAAAAAJhnry3y8yzbXvrss4PPP/9cyAcAmHNiPgAAAADAfDqzyC/LcnO8tCTkAwAsCDEfAAAAAGAevbbIHwwG20s3bhysrq4K+QAAC0LMBwCABZOm6cMYY/RcAQAW1plFftu2m13fC/kAAAtGzAcAgAWTpuk/xXwAgAV2usjPsvWu67bbthXyAQAWkJgPAAAL6MsvvxTzAQAWz16IcSOEsJ5l2Z1R339f17WQDwCwoMR8AAAAAIB5EONGDOHrQVHcH43He2VZHgr5AACLS8wHAODSVFV1/OvR0T+Oj488hE8gxvAvx8fH/xFC/Lfvvvvu/9I0PZ77FzUDXr58+a8hhO6qvw8AwKU4nH6k/m4M4XmI8VZd12tL16/vp2l6tLKy4t/3AAAWWOLhAsB8cxabeXf37t0kSZLUg/z7YozXnj59+t+//PLLv6dJsh6S8GLeX9MsOD6OXx4fH//n5P8/uervBQBwwWJ8MLmNH0PYSNP0STMcbi5dv/54eXnZfwjyh5LEt/8BYN75pzkAzDkxHzh179697OnTp//1/Pnz//GmAADMtZNFfozx2zRJ/jfNsh/68figbdsXQj5/lpgPAPPPx+wDAAAAAMySVx+t/83k05bystheWrr+8+eff+42PgDAFSPmAwAAAADMhtcX+et1XW+Ol5YOVldXhXwAgCtIzAcAAAAAmAWni/wsW+/adrvtOiEfAOAKE/MBAAAAAC7XXohxI4SwnmXZnVHff1/XtZAPAHDFifkAAAAAAJcpxo0YwtfVYHC/G432yrI8FPIBABDzAQAAAAAu1uH0I/V3YwjPkxBudW27Nur7/TRNj1ZWVo49DwAAxHwAAAAAgIs0vY0fQ9jIs+xJ23Wbfd8/Xl5ejp4DAACnxHwAAAAAgItxssiPMX6bJsl6NRj8MBqPD6qqeiHkAwDwJjEfAAAAAOAiTBf5aZatt8Phdtf3P7uNDwDA+4j5AAAAAADnay/EuBFCWM+y7DZ/BjoAABVbSURBVM6o77+v6/pAyAcA4EPEfAAAAACA8xTjRgzh66qq7nddt1eW5aGQDwDAHxHzAQAAAAA+rcPpR+rvxhCeJyHcGnXdWjca7adperSysnLs/QYA4I+I+QAAAAAAn9L0Nn4MYaPI8yf9eLzZNM3j5eXl6H0GAODPEvMBAAAAAD6N327jJ2l6pxnWP45G/UFRFC+EfAAAPpaYDwAAAADwKUxv4xdZdr/r+726rt3GBwDgLxPzAQAAAAD+mjO38UOMt4bD4dq1pSW38QEA+NvEfAAAAACAv+K12/hZlj7putFm3/du4wMA8EmI+QAAAAAAH+f32/gh3BnW9Y/taHRQVZXb+AAAfDJiPgAAAADAx5jexs+y9P5o1O8Nh0O38QEA+OTEfAAAAACAD3vrNn5d12v9eLxfFIXb+AAAnAsxHwAAAADgQ968jd92m/147DY+AADnSswHAAAAAHi3s7fxm+GPbdu5jQ8AwIUQ8wEAAAAA3mV6G7/Isvtd3+/Vde02PgAAF0bMBwAAAAB4ZW8a8H+a/CgJ4fawrteuLS3tp2nqNj4AABdKzAcAAAAACL8v8ZMQtvI8C13XPepGvdv4AABcCjEfAAAAALiqDkOMP4QQdmMIz0OMt7I0XevH4/1h04Qsy14K+QAAXBYxHwAAAAC4ml6F/G9iCBtpCE8Gdb15/caNxzdv3hTwAQC4dGI+AAAAAHDVnNzGDyGsJyHcKfL8x67vD9q2fWGJDwDArBDzAQAAAICrZXobP03T+00z3BuN+sPV1dVf/S4AAGCWiPkAAAAAwKLbmwb8n05eZ4y367o+uY1fFMXRysrKsd8BAADMGjEfAAAAAFhs0yV+EsJWnmehabtHfd8/9pH6AADMMjEfAAAAAFg0hyHGH0IIuzGE5yHGW1mer426br9p25Bl2UshHwCAWSfmAwAAAACL5VXI/yaGsJGm6ZNqMNhcun798c2bNwV8AADmhpgPAAAAACyKk9v4IYT1JIQ71WDwY9u1B8OmfWGJDwDAvBHzAQAAAIDFML2NXxT5/bbt9obD4eHq6uqvni4AAPNIzAcAAAAA5tXeNOD/NPn1p2lyu2vatW402k/T9GhlZeXYkwUAYF6J+QAAAADAfJou8dMk2arqKrRt96iu68c+Uh8AgEUg5gMAAAAA8+LMEj8J4fawrtf68Xg/y7KQZdlLIR8AgEUh5gMAAAAA82G6xE9C2BpUg5MlftM0lvgAACwkMR8AAAAAmFVnlvghxttVVa31436/KEpLfAAAFpqYDwAAAADMpteW+EVZhrYZPupGvSU+AABXgpgPAAAAAMwKS3wAAJgS8wEAAACA2WCJDwAAvxHzAQAAAIDLYokPAADvIeYDAAAAAJfDEh8AAN5LzAcAAAAALsqZJX4Swu1qMLDEBwCAdxDzAQAAAICLMV3ip0myVQ7K0Lbdo6ZpLPEBAOAdxHwAAAAA4LycWeKnaXK7qeu1btTvZ1lmiQ8AAB8g5gMAAAAA52O6xM+z7Lclfl3XlvgAAPAniPkAAAAAwN91ZoEfQngcYtwuyuJeM2wetF33bPJFS3wAAPjzxHwAAAAA4O+ZLvCTELaSJAllWe704363quoj8R4AAP4aMR8AAAAA+Fhnl/gx3s7yfK1rm/162ExivgU+AAD8TWI+AAAAAPBxXlvi53kW6nr46NrSklv4AADwCYn5AAAAAMAfObPET0K4XVfV2qgf7RdF6RY+AACcAzEfAAAAAPiw6RI/z7KtclCG4bB51DSNJT4AAJwjMR8AAAAAOHX2Fn4Ij5MQtvOiuNe27YOmaZ5NvmiJDwAA50/MBwAAAABeeeMWflVVO2032i3L8ki8BwCAiyXmAwAAAMDV89YCP8S4nWbpvWpQPRiNumdu4QMAwOUS8wEAAADgqnltgT955YPBYKdpmt226yzwAQBgRoj5AAAAALD4zi7xY7xdFvla03b7VV2Hsiwt8AEAYMaI+QAAAACw6KZL/DzLtsqymNzCf9SN+scCPgAAzC4xHwAAAAAWx1u38NMk2S6K4l7btQ/qYfNs8kW38AEAYPaJ+QAAAACwKKYL/CxNt4o8D9VwuNN13W6apm7hAwDAnBHzAQAAAGD+vHeBP2zbB01jgQ8AAPNOzAcAAACAefPGDfxBVe20rQU+AAAsEjEfAAAAAGbPW8v7EON2COFJXuShKIqHw7p2Ax8AABaYmA8AAAAAs2a6vE9C2EqSJJRludM0zW49HB5lWXbyixXvAQBgsYn5AAAAAHB53rnAz7PsXjkYPGi77llZlpb3AABwBYn5AAAAAHBZpgv8LE23sjwPg8Fgp23b3bIs3b4HAIArTswHAAAAgPPzzuV9kiRPsjxz+x4AAHgvMR8AAAAAzst0eZ8myVaeZ6Esyp1h2+7WdX10+ncU7wEAgHcR8wEAAADg471zcR9CeDL5QZIk4XR5X1X1g6axvAcAAD6OmA8AAAAAH2u6uE9C2Jr8zDTLduqq2h0MyqO8KENVVb/9BcV7AADgrxDzAQAAAOBt713eT1b3eZ49LIryQVVVzwZVFcqytLgHAAA+KTEfAAAAAN702vJ+cus+z4uduq52i3JwdLq6F+8BAIDzJOYDAAAAcBV88MZ9OL1zn2Uhy9JJvH9YDgZu3QMAAJdGzAcAAABg8b1x477Is51yUO3meX40GAxCUZYnIf914j0AAHCZxHwAAAAA5skfLuxPnS7t0zQNaZo8rKr6waAaPCuK0tIeAACYeWI+AAAAAPPjjYV9mmU7ZZ7vFkVxlGZZKPJ88rVQ1fVbL0m8BwAA5omYDwAAAMB5+tNL+neZLOsnC/vJH2k6WdrnD8uyfFAOBs/K0sIeAABYXGI+AAAAAOfnjSV9iHEnL4rdsiyPwvSj8PP81beoTlf1E+9a1p8S7wEAgKtAzAcAgAURYzwuiuIfz58980iBD3kZQphE1Jcxxl+9U3ysNEtDmqRv/azJXfokee0LSRqyk1v16cM8z92qBwAA+EiJNwwA5luMvg8K/O7u3btJkryjsABXWvKqsMbJn7Msi5OPLZ+EV7go4j3AxUsS3/4HAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAK48AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArjwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4//bggAAAAABBkP9XNyQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOBDNQJ75E2RuWS4AAAADmVYSWZNTQAqAAAACAAAAAAAAADSU5MAAAAASUVORK5CYII=",
          alt: ""
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime91.jsx)(Icon_default, { name: icon || "filePhoto", color: theme.colors.n60, size: 24, ...iconProps })
    }
  );
}
var DashPlaceholder_default = DashPlaceholder;

// src/components/molecules/IconBadge/IconBadge.tsx
var import_styled_components90 = __toESM(require("styled-components"));
var import_jsx_runtime92 = require("react/jsx-runtime");
var getIconsSize = ({ regular, medium, small }, theme) => regular && theme.space * 6 || medium && theme.space * 5 || small && theme.space * 4 || theme.space * 6;
var variationsStyle2 = import_styled_components90.css`
  ${({ theme, variation }) => {
  const variations = {
    primary: import_styled_components90.css`
        background-color: ${theme.colors.white};
        color: ${theme.colors.black};
        border: 1px solid ${theme.colors.black};
      `,
    outline: import_styled_components90.css`
        background-color: ${theme.colors.g20};
        color: ${theme.colors.white};
        border: 1px solid ${theme.colors.g20};
      `
  };
  return variations[variation] || "";
}}
`;
var BadgeStyle2 = (0, import_styled_components90.default)(Flex_default)`
  border-radius: 50%;
  ${variationsStyle2}
`;
function IconBadge({
  icon,
  regular,
  medium,
  small,
  size,
  iconProps = {},
  ...args
}) {
  const theme = (0, import_styled_components90.useTheme)();
  const sizeBadge = size || getButtonHeight({ regular, medium, small });
  const sizeIcon = iconProps?.size || getIconsSize({ regular, medium, small }, theme);
  return /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(BadgeStyle2, { w: sizeBadge, h: sizeBadge, alignItems: "center", justifyContent: "center", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime92.jsx)(Icon_default, { name: icon, size: sizeIcon, ...iconProps }) });
}
var IconBadge_default = IconBadge;

// src/components/molecules/UploadMediaContainer/UploadMediaContainer.tsx
var import_dash_common20 = require("dash-common");
var import_styled_components92 = require("styled-components");
var import_react_i18next16 = require("react-i18next");
var import_react65 = require("react");

// src/components/molecules/UploadMediaContainer/UploadMediaContainer.styles.ts
var import_styled_components91 = __toESM(require("styled-components"));
var MainContainer = (0, import_styled_components91.default)(Flex_default)`
  position: fixed;
  bottom: 0;
  right: 18px;
  min-height: ${({ toggle }) => toggle ? "244px" : 0};
  max-height: 528px;
  z-index: 99;
  filter: drop-shadow(0px 2px 14px ${({ theme }) => theme.colors.black}40);
`;
var HeaderContainer = (0, import_styled_components91.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.b50};
  border-radius: 8px 8px 0 0;
  min-height: 76px;

  p {
    font-size: 20px;
    line-height: 24px;
  }
`;
var ContentContainer2 = (0, import_styled_components91.default)(Flex_default)`
  display: ${({ toggle }) => toggle ? "block" : "none"};
  background-color: ${({ theme }) => theme.colors.white};
  overflow: auto;

  & > div:first-child {
    border: none;
    width: 100%;
    height: 100%;
    padding-bottom: 0;
  }
`;
var IconWrapper5 = (0, import_styled_components91.default)(Flex_default)`
  cursor: pointer;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.colors.white};
`;

// src/components/molecules/UploadMediaContainer/UploadMediaContainer.tsx
var import_jsx_runtime93 = require("react/jsx-runtime");
var UploadMediaContainer = ({
  visible,
  onClose,
  onUpload,
  cancelUpload,
  cancelAllUploads,
  ...props
}) => {
  const { t } = (0, import_react_i18next16.useTranslation)("pages");
  const theme = (0, import_styled_components92.useTheme)();
  const [toggle, setToggle] = (0, import_react65.useState)(true);
  const { onHistoryClear, filesToUpload } = (0, import_react65.useContext)(MultiFileUploadContext);
  const fileTypeValidator = (file) => {
    const maxSizeInMb = import_dash_common20.MEDIA_SIZE_LIMITATION_EXCEPTIONS_BY_MIME_TYPES_IN_MB[file.type] || import_dash_common20.MEDIA_SIZE_LIMITATION_IN_MB;
    const maxSizeInBytes = (0, import_dash_common20.mBytesToBytes)(maxSizeInMb);
    if (file.size >= maxSizeInBytes) {
      return {
        code: "file-size-limitation",
        message: t("forms:messages.uploadErrors.fileTooLarge", { maxSize: maxSizeInMb })
      };
    }
    return null;
  };
  return visible ? /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)(MainContainer, { w: 412, toggle, flexDirection: "column", ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)(HeaderContainer, { px: 5, alignItems: "center", justifyContent: "space-between", w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Text_default, { color: theme.colors.white, children: t("propertyPage.uploadMedia") }),
      filesToUpload.some((item) => item.status === import_dash_common20.ProgressTrackingFileStatusesEnum.UPLOADING) || !toggle ? /* @__PURE__ */ (0, import_jsx_runtime93.jsxs)(Flex_default, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(IconWrapper5, { px: 2, py: 2, mr: 4, onClick: () => setToggle(!toggle), children: /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Icon_default, { name: toggle ? "chevronDown" : "chevronUp", color: theme.colors.white }) }),
        /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
          DropDown_default,
          {
            items: [
              {
                children: t("propertyPage.cancelAllUpdates"),
                key: "cancel",
                w: 200,
                onClick: (e) => {
                  e.stopPropagation();
                  if (cancelAllUploads) {
                    cancelAllUploads();
                  }
                }
              },
              {
                children: t("propertyPage.clearUploadHistory"),
                key: "clear",
                w: 200,
                onClick: (e) => {
                  e.stopPropagation();
                  onHistoryClear();
                }
              }
            ],
            Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(IconWrapper5, { px: 2, py: 2, children: /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Icon_default, { name: "dots", color: theme.colors.white }) })
          }
        )
      ] }) : /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
        IconWrapper5,
        {
          px: 2,
          py: 2,
          onClick: () => {
            if (onClose) {
              onClose();
            }
            onHistoryClear();
          },
          children: /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(Icon_default, { name: "close", color: theme.colors.white })
        }
      )
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(ContentContainer2, { toggle, w: "100%", flex: 1, alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime93.jsx)(
      FileUpload_default.Multi,
      {
        isInContainer: true,
        accept: Object.values(import_dash_common20.AllowedMediaFileExtensionsEnum).reduce(
          (memo2, value) => ({ ...memo2, [import_dash_common20.ALLOWED_MEDIA_TYPE_MIMES[value]]: [`.${value}`] }),
          {}
        ),
        validator: fileTypeValidator,
        onAbortManually: cancelUpload,
        onUpload
      }
    ) })
  ] }) : null;
};
var UploadMediaContainer_default = UploadMediaContainer;

// src/components/molecules/FilePreviewModal/FilePreviewModal.tsx
var import_dash_common21 = require("dash-common");
var import_lodash12 = require("lodash");
var import_react69 = require("react");
var import_react_i18next17 = require("react-i18next");
var import_styled_components95 = require("styled-components");

// src/components/molecules/FilePreviewModal/FilePreviewModal.styles.ts
var import_styled_components93 = __toESM(require("styled-components"));
var StyledModal = (0, import_styled_components93.default)(Modal3)`
  ${commonModalStyles}
  &__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    border-radius: 8px;
    outline: none;
    padding: 24px;
    max-height: 828px;
    max-width: 1368px;
    width: 100%;
    height: 100%;
    margin-left: 36px;
    margin-right: 36px;

    h2 {
      line-height: 36px;
      font-size: 24px;
      margin-bottom: 12px;
    }

    & > div {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    @media ${({ theme }) => theme.devices.mobile} {
      max-height: 500px;

      h2 {
        font-size: 18px;
        line-height: 28px;
      }
    }
  }
`;
var ImageWrapper = (0, import_styled_components93.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n20};
  border-radius: 8px;
  max-height: 670px;
`;
var StyledImage = (0, import_styled_components93.default)(Image_default)`
  height: 100%;
  max-width: 100%;
  width: fit-content;
  border-radius: 0;
`;
var StyledVideo = (0, import_styled_components93.default)(Video_default)`
  height: 100%;
  max-width: 100%;
  border-radius: 0;
`;

// src/components/atoms/PDFViewer/PDFViewer.tsx
var import_react66 = require("react");
var import_AnnotationLayer = require("react-pdf/dist/Page/AnnotationLayer.css");
var import_TextLayer = require("react-pdf/dist/Page/TextLayer.css");

// src/components/atoms/PDFViewer/PDFViewer.styles.ts
var import_styled_components94 = __toESM(require("styled-components"));
var StyledWrapper3 = import_styled_components94.default.div`
  height: 100%;
  max-width: 100%;
  width: 100%;
  border-radius: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border: 2px solid ${({ theme }) => theme.colors.n20};
  border-top: 0px;

  .sticky-header {
    position: sticky;
    top: 0;
    background-color: ${({ theme }) => theme.colors.n20};
    padding: 5px;
    z-index: 100; /* Ensure the header is above the PDF content */
  }
`;

// src/components/atoms/PDFViewer/PDFViewer.tsx
var import_core = require("@react-pdf-viewer/core");
var import_zoom = require("@react-pdf-viewer/zoom");
var import_styles = require("@react-pdf-viewer/core/lib/styles/index.css");
var import_jsx_runtime94 = require("react/jsx-runtime");
function PDFViewer({
  url,
  s3Key,
  name
}) {
  const zoomPluginInstance = (0, import_zoom.zoomPlugin)();
  const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
  const [fileUrl, setFileUrl] = (0, import_react66.useState)(url);
  const [loading, setLoading] = (0, import_react66.useState)(true);
  const [triedFetching, setTriedFetching] = (0, import_react66.useState)(false);
  const filteredFileName = (0, import_react66.useMemo)(() => {
    const regex = /^[a-f0-9-]+-(?:[a-f0-9-]+.pdf|(.+))$/;
    const match = name.match(regex);
    if (!match)
      return name;
    const restOfFilename = match[1] || match[0];
    return restOfFilename;
  }, [name]);
  const handleRenderError = () => {
    if (!triedFetching)
      fetchDocument();
    return /* @__PURE__ */ (0, import_jsx_runtime94.jsx)("p", { style: { textAlign: "center" }, children: "Sorry, an error occurred loading this document..." });
  };
  (0, import_react66.useEffect)(() => {
    let counter = 0;
    const interval = setInterval(() => {
      const layer = document.querySelectorAll(
        '[data-testid="core__annotation-layer-0"]'
      )[0];
      if (layer || counter >= 200) {
        setLoading(false);
        clearInterval(interval);
      }
      counter += 1;
    }, 100);
    return () => clearInterval(interval);
  }, []);
  const fetchDocument = async () => {
    setLoading(true);
    const data = { s3Key };
    const apiKey = process.env.REACT_APP_API_KEY;
    setTriedFetching(true);
    await fetch(`${process.env.REACT_APP_REST}/files/aws-file`, {
      method: "POST",
      headers: {
        api_key: apiKey || "",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    }).then((res) => res.json()).then((jsonResponse) => {
      setFileUrl(jsonResponse.data);
    });
    setLoading(false);
  };
  return !fileUrl ? /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(Spinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime94.jsxs)(StyledWrapper3, { id: "pdfDocument", children: [
    /* @__PURE__ */ (0, import_jsx_runtime94.jsxs)(Flex_default, { h: "10%", flexDirection: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(Text_default, { bold: true, lg: true, className: "sticky-header", ellipsis: true, children: filteredFileName }),
      /* @__PURE__ */ (0, import_jsx_runtime94.jsxs)(Flex_default, { flexDirection: "row", children: [
        /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(ZoomOutButton, {}),
        /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(ZoomPopover, {}),
        /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(ZoomInButton, {})
      ] })
    ] }),
    loading ? /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(Flex_default, { w: "100%", h: "90%", alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(Spinner_default, {}) }) : null,
    /* @__PURE__ */ (0, import_jsx_runtime94.jsx)("div", { style: { height: loading ? "1%" : "90%", opacity: loading ? 0 : 1 }, children: /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(import_core.Worker, { workerUrl: "https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js", children: /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(
      import_core.Viewer,
      {
        fileUrl,
        httpHeaders: {
          "Cache-Control": "no-cache",
          "Access-Control-Allow-Origin": "*",
          crossOrigin: "anonymous",
          Vary: "origin"
        },
        renderError: handleRenderError,
        plugins: [zoomPluginInstance],
        renderLoader: (percentages) => /* @__PURE__ */ (0, import_jsx_runtime94.jsx)("div", { style: { width: "240px" }, children: /* @__PURE__ */ (0, import_jsx_runtime94.jsx)(import_core.ProgressBar, { progress: Math.round(percentages) }) }),
        defaultScale: import_core.SpecialZoomLevel.PageWidth
      }
    ) }) })
  ] });
}
var PDFViewer_default = PDFViewer;

// src/components/molecules/FilePreviewModal/FilePreviewModal.tsx
var import_dash_common22 = require("dash-common");

// src/components/molecules/FilePreviewModal/components/ImagePreview/ImagePreview.tsx
var import_react67 = require("react");
var import_jsx_runtime95 = require("react/jsx-runtime");
function ImagePreview({
  publicUrl,
  name
}) {
  const filteredFileName = (0, import_react67.useMemo)(() => {
    const regex = /^[a-f0-9-]+-(?:[a-f0-9-]+.pdf|(.+))$/;
    const match = name.match(regex);
    if (!match)
      return name;
    const restOfFilename = match[1] || match[0];
    return restOfFilename;
  }, [name]);
  return !publicUrl ? /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(Spinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime95.jsxs)(Flex_default, { flexDirection: "column", h: "100%", w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(
      Flex_default,
      {
        h: "10%",
        flexDirection: "row",
        justifyContent: "space-between",
        pl: 2,
        pt: 1,
        w: "100%",
        children: /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(Text_default, { bold: true, lg: true, className: "sticky-header", ellipsis: true, children: filteredFileName })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(Flex_default, { h: "90%", w: "100%", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime95.jsx)(StyledImage, { src: publicUrl, alt: name, fit: "cover" }) })
  ] });
}
var ImagePreview_default = ImagePreview;

// src/components/molecules/FilePreviewModal/components/VideoPreview/VideoPreview.tsx
var import_react68 = require("react");
var import_jsx_runtime96 = require("react/jsx-runtime");
function VideoPreview({
  publicUrl,
  name
}) {
  const filteredFileName = (0, import_react68.useMemo)(() => {
    const regex = /^[a-f0-9-]+-(?:[a-f0-9-]+.mp4|(.+))$/;
    const match = name.match(regex);
    if (!match)
      return name;
    const restOfFilename = match[1] || match[0];
    return restOfFilename;
  }, [name]);
  return !publicUrl ? /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Spinner_default, {}) : /* @__PURE__ */ (0, import_jsx_runtime96.jsxs)(Flex_default, { flexDirection: "column", h: "100%", w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Flex_default, { h: "10%", w: "100%", pl: 2, pt: 1, children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Text_default, { bold: true, lg: true, className: "sticky-header", ellipsis: true, children: filteredFileName }) }),
    /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(Flex_default, { h: "90%", w: "100%", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime96.jsx)(
      StyledVideo,
      {
        withPlayIcon: false,
        controls: true,
        src: publicUrl,
        autoPlay: true,
        controlsList: "nodownload",
        maxHeight: "100%"
      }
    ) })
  ] });
}
var VideoPreview_default = VideoPreview;

// src/components/molecules/FilePreviewModal/FilePreviewModal.tsx
var import_jsx_runtime97 = require("react/jsx-runtime");
var FilePreviewModal = ({
  isOpened,
  onClose,
  files,
  defaultIndex,
  onDownloadButtonClick,
  isDownloadButtonVisible = true,
  isPortfolioView = false,
  isCentered = true,
  isExchange = false
}) => {
  const { t } = (0, import_react_i18next17.useTranslation)("common");
  const [index2, setIndex] = (0, import_react69.useState)(0);
  const theme = (0, import_styled_components95.useTheme)();
  const {
    devices: { isMobile, isTablet }
  } = useScreenResolution();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    import_dash_common21.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT
  ]);
  const { setUpgradeSubscriptionModal } = (0, import_react69.useContext)(ModalContext);
  (0, import_react69.useEffect)(() => {
    if ((0, import_lodash12.isNumber)(defaultIndex) && defaultIndex >= 0) {
      setIndex(defaultIndex);
    }
  }, [defaultIndex]);
  const file = files[index2];
  const Component2 = (0, import_react69.useCallback)(() => {
    if (import_dash_common21.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER[import_dash_common21.MediaFileTypesFilterEnum.IMAGES].includes(file.type)) {
      return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(ImagePreview_default, { publicUrl: file.publicUrl, name: file.name });
    }
    if (import_dash_common21.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER[import_dash_common21.MediaFileTypesFilterEnum.VIDEOS].includes(file.type)) {
      return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(VideoPreview_default, { publicUrl: file.publicUrl, name: file.name });
    }
    if (import_dash_common21.ALLOWED_MEDIA_TYPE_MIMES.pdf === file.type) {
      return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(PDFViewer_default, { url: file.publicUrl, s3Key: file.s3Key, name: file.name });
    }
    return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Icon_default, { name: "filePlaceholder", color: theme.colors.n20, size: 200 });
  }, [file]);
  if (!file) {
    return null;
  }
  const modalClose = () => {
    onClose();
  };
  return /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
    StyledModal,
    {
      isOpen: isOpened,
      onRequestClose: modalClose,
      title: t("labels.preview") || "",
      viewHierarchy: 2,
      AdditionalHeader: () => /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Flex_default, { justifyContent: "end", children: `${index2 + 1}/${files.length}` }),
      isCentered,
      isExchange,
      children: /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(Flex_default, { h: "92%", flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
          ImageWrapper,
          {
            w: "100%",
            h: "90%",
            mb: 3,
            mt: 2,
            justifyContent: "center",
            alignItems: "center",
            children: /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Component2, {})
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(Flex_default, { h: "10%", justifyContent: "space-between", w: "100%", children: [
          /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
            Button_default,
            {
              variation: "outline",
              onClick: modalClose,
              square: isMobile,
              minWidth: isTablet ? 113 : void 0,
              icon: isMobile ? "close" : void 0,
              children: !isMobile && t("labels.close")
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime97.jsxs)(Flex_default, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
              Button_default,
              {
                mr: 4,
                px: [0, 20, 20, 20],
                variation: "outline",
                disabled: !index2 || !files[index2 - 1],
                square: isMobile,
                icon: isMobile ? "chevronLeft" : void 0,
                onClick: () => setIndex(index2 - 1),
                children: !isMobile && t("labels.previous")
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
              Button_default,
              {
                variation: "primary",
                px: [0, 20, 20, 20],
                disabled: index2 === files.length - 1,
                onClick: () => setIndex(index2 + 1),
                square: isMobile,
                icon: isMobile ? "chevronRight" : void 0,
                children: !isMobile && t("labels.next")
              }
            )
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(Flex_default, { w: isMobile || isTablet ? 0 : 200, justifyContent: "flex-end", children: isDownloadButtonVisible && /* @__PURE__ */ (0, import_jsx_runtime97.jsx)(
            Button_default,
            {
              square: true,
              variation: "primary",
              icon: "download",
              onClick: () => {
                setUpgradeSubscriptionModal({
                  type: "DOWNLOAD" /* DOWNLOAD */
                });
                const isActive = checkFeatureAccess({
                  disableModal: isPortfolioView
                });
                if ((0, import_dash_common22.nor)(isActive, isPortfolioView))
                  return;
                if (onDownloadButtonClick) {
                  onDownloadButtonClick(file._id);
                } else {
                  downloadMedia([file._id]);
                }
              }
            }
          ) })
        ] })
      ] })
    }
  );
};
var FilePreviewModal_default = FilePreviewModal;

// src/components/molecules/NotFoundPage/NotFoundPage.tsx
var import_styled_components97 = require("styled-components");
var import_react_i18next18 = require("react-i18next");

// src/components/molecules/NotFoundPage/NotFoundPage.styles.ts
var import_styled_components96 = __toESM(require("styled-components"));
var PageWrapper = (0, import_styled_components96.default)(Flex_default)`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
var VerticalDevider = (0, import_styled_components96.default)(Box_default)`
  background: ${({ theme }) => theme.colors.n90};
  border-radius: ${({ theme }) => theme.space * 2}px;
`;
var StyledHeading = (0, import_styled_components96.default)(H_default)`
  display: flex;
  align-items: center;
`;

// src/components/molecules/NotFoundPage/NotFoundPage.tsx
var import_jsx_runtime98 = require("react/jsx-runtime");
var NotFoundPage = ({ onRedirect }) => {
  const theme = (0, import_styled_components97.useTheme)();
  const { t } = (0, import_react_i18next18.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(PageWrapper, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)(Flex_default, { w: 443, flexDirection: "column", justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime98.jsxs)(StyledHeading, { lg: true, bold: true, color: theme.colors.n90, children: [
      "404",
      /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(VerticalDevider, { h: 38, w: 4, mx: 8 }),
      t("notFoundPage.title")
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(Box_default, { mb: 4, mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(Text_default, { color: theme.colors.n80, children: t("notFoundPage.subtitle") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime98.jsx)(Button_default, { h: 40, minWidth: 153, onClick: onRedirect, children: t("notFoundPage.buttonLabel") })
  ] }) });
};
var NotFoundPage_default = NotFoundPage;

// src/components/molecules/Toast/Toast.tsx
var import_react_toastify = require("react-toastify");
var import_styled_components98 = __toESM(require("styled-components"));
var import_jsx_runtime99 = require("react/jsx-runtime");
var StyledContainer = (0, import_styled_components98.default)(import_react_toastify.ToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
    top: ${({ theme, shiftTop }) => shiftTop ? shiftTop + theme.space * 3 : theme.space * 3}px;
    right: ${({ theme, shiftRight }) => shiftRight ? shiftRight + theme.space * 3 : theme.space * 3}px;
    padding: unset;
  }
  .Toastify__toast {
    min-height: 40px;
    box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1), 0px 2px 4px -1px rgba(0, 0, 0, 0.06);
    padding: ${({ theme }) => theme.space * 2}px;
  }
  .Toastify__toast-icon {
    margin-right: ${({ theme }) => theme.space * 2};
  }
  .Toastify__toast-body {
    padding: unset;
    width: unset;
    ${textStyle}
  }
  .Toastify__progress-bar {
    visibility: hidden;
  }
  .close-button {
    margin-right: ${({ theme }) => theme.space}px;
    color: ${({ theme }) => theme.colors.n200};
  }
  .Toastify__toast--info {
    .Toastify__toast-body {
      color: ${({ theme }) => theme.colors.b50};
    }
  }
  .Toastify__toast--success {
    .Toastify__toast-body {
      color: ${({ theme }) => theme.colors.g20};
    }
  }
  .Toastify__toast--error {
    .Toastify__toast-body {
      color: ${({ theme }) => theme.colors.r20};
    }
  }
`;
var toast = {
  info: (message, options) => {
    import_react_toastify.toast.info(message, {
      // @ts-ignore
      icon: () => /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Icon_default, { name: "infoCircle" }),
      ...options
    });
  },
  success: (message, options) => {
    import_react_toastify.toast.success(message, {
      // @ts-ignore
      icon: () => /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Icon_default, { name: "checkCircle" }),
      ...options
    });
  },
  error: (message, options) => {
    import_react_toastify.toast.error(message, {
      // @ts-ignore
      icon: () => /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Icon_default, { name: "cancelCircle" }),
      ...options
    });
  }
};
function Toast({
  shiftTop,
  shiftRight,
  semibold = true,
  autoClose = 3e3,
  ...args
}) {
  return /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(
    StyledContainer,
    {
      shiftTop,
      shiftRight,
      semibold,
      autoClose,
      ...args,
      closeButton: ({ closeToast }) => /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Flex_default, { alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime99.jsx)(Icon_default, { name: "close", className: "close-button", onClick: () => closeToast() }) })
    }
  );
}
var Toast_default = Toast;

// src/components/molecules/GoogleMap/GoogleMap.tsx
var import_react70 = __toESM(require("react"));
var import_api2 = require("@react-google-maps/api");
var import_dash_common23 = require("dash-common");

// src/components/molecules/GoogleMap/GoogleMap.constants.tsx
var DEFAULT_GOOGLE_MAP_OPTIONS = {
  styles: [
    { featureType: "all", stylers: [{ visibility: "off" }] },
    { featureType: "road", stylers: [{ visibility: "on" }] },
    { featureType: "administrative", stylers: [{ visibility: "on" }] },
    { featureType: "landscape", stylers: [{ visibility: "on" }] },
    { featureType: "water", stylers: [{ visibility: "on" }] }
  ],
  zoomControl: true,
  fullscreenControl: false,
  streetViewControl: false,
  draggableCursor: "pointer",
  mapTypeControl: true,
  mapTypeControlOptions: { mapTypeIds: ["roadmap", "satellite"] }
};

// src/components/molecules/GoogleMap/GoogleMap.tsx
var import_jsx_runtime100 = require("react/jsx-runtime");
var GoogleMapComponent = import_react70.default.forwardRef(
  ({
    // see all possible props https://react-google-maps-api-docs.netlify.app/#googlemap
    children,
    h = "inherit",
    w = "inherit",
    center = import_dash_common23.DEFAULT_GOOGLE_MAP_CENTER,
    zoom = 12,
    options,
    // <- see more https://developers.google.com/maps/documentation/javascript/reference?csw=1#MapOptions
    ...googleMapProps
  }, forwardRef4) => {
    const containerStyle = (0, import_react70.useMemo)(
      () => ({
        width: `${w}${typeof w === "number" ? "px" : ""}`,
        height: `${h}${typeof h === "number" ? "px" : ""}`
      }),
      [w, h]
    );
    return /* @__PURE__ */ (0, import_jsx_runtime100.jsx)(
      import_api2.GoogleMap,
      {
        ref: forwardRef4,
        ...googleMapProps,
        mapContainerStyle: containerStyle,
        center,
        zoom,
        options: {
          ...DEFAULT_GOOGLE_MAP_OPTIONS,
          ...options
        },
        children
      }
    );
  }
);
var GoogleMap_default = (0, import_react70.memo)(GoogleMapComponent);

// src/components/molecules/GoogleMap/components/Marker/Marker.tsx
var import_api3 = require("@react-google-maps/api");
var Marker_default = import_api3.MarkerF;

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.tsx
var import_api4 = require("@react-google-maps/api");
var import_styled_components100 = require("styled-components");

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.styles.ts
var import_styled_components99 = __toESM(require("styled-components"));
var MarkerBackground = (0, import_styled_components99.default)(Box_default)`
  transform: rotate(-45deg);
  border-radius: 100% 100% 100% 0;
  background-color: ${({ theme }) => theme.colors.white};

  :hover {
    background-color: ${({ color: color2 }) => color2};

    & > div {
      background-color: ${({ theme }) => theme.colors.white};

      svg {
        color: ${({ color: color2 }) => color2};
      }
    }
  }
`;
var MarkerInnerBackground = (0, import_styled_components99.default)(Flex_default)`
  transform: rotate(45deg);
  border-radius: 100%;
  background-color: ${({ color: color2 }) => color2};
`;

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.constants.ts
var import_dash_common24 = require("dash-common");
var MARKER_ICONS_MAP = {
  [import_dash_common24.BuildingTypesEnum.CONDO]: {
    name: "condominium",
    color: mainTheme.colors.n80
  },
  [import_dash_common24.BuildingTypesEnum.CONDO_HOTEL]: {
    name: "condoHotels",
    color: mainTheme.colors.n90
  },
  [import_dash_common24.BuildingTypesEnum.PENTHOUSE]: {
    name: "penthouse",
    color: mainTheme.colors.y20
  },
  [import_dash_common24.BuildingTypesEnum.TOWNHOME]: {
    name: "townhouses",
    color: mainTheme.colors.b40
  },
  [import_dash_common24.BuildingTypesEnum.SINGLE_FAMILY_HOME]: {
    name: "singleFamily",
    color: mainTheme.colors.g20
  }
};
var DEFAULT_MARKER_ICON = {
  name: "house",
  color: mainTheme.colors.n30,
  iconColor: mainTheme.colors.n90,
  hoverColor: mainTheme.colors.n80
};

// src/components/molecules/GoogleMap/components/PropertyMarker/PropertyMarker.tsx
var import_jsx_runtime101 = require("react/jsx-runtime");
var PropertyMarker = ({
  buildingTypes,
  children,
  onClick,
  onMouseOnMarker,
  onMouseOutMarker,
  mapPaneName = "overlayMouseTarget",
  getPixelPositionOffset = (width, height) => ({
    x: -(width / 2),
    y: -((height + 55) / 2)
  }),
  ...props
}) => {
  const iconProps = buildingTypes?.length && MARKER_ICONS_MAP[buildingTypes[0]] ? MARKER_ICONS_MAP[buildingTypes[0]] : DEFAULT_MARKER_ICON;
  const theme = (0, import_styled_components100.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
    import_api4.OverlayViewF,
    {
      mapPaneName,
      getPixelPositionOffset,
      ...props,
      children: /* @__PURE__ */ (0, import_jsx_runtime101.jsxs)(
        MarkerBackground,
        {
          w: 40,
          h: 40,
          p: 1,
          color: iconProps.hoverColor || iconProps.color,
          onMouseOver: onMouseOnMarker,
          onMouseOut: onMouseOutMarker,
          onClick,
          children: [
            children,
            /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(
              MarkerInnerBackground,
              {
                w: "100%",
                h: "100%",
                justifyContent: "center",
                alignItems: "center",
                color: iconProps.color,
                children: /* @__PURE__ */ (0, import_jsx_runtime101.jsx)(Icon_default, { name: iconProps.name, color: iconProps.iconColor || theme.colors.white })
              }
            )
          ]
        }
      )
    }
  );
};
var PropertyMarker_default = PropertyMarker;

// src/components/molecules/CardPaymentForm/CardPaymentForm.tsx
var import_react73 = require("react");
var import_react_i18next21 = require("react-i18next");
var import_styled_components102 = __toESM(require("styled-components"));
var import_react_stripe_js4 = require("@stripe/react-stripe-js");

// src/components/molecules/CardPaymentForm/constants/constants.ts
var FormFieldsList = [
  "fullName" /* FullName */,
  "county" /* County */,
  "state" /* State */,
  "city" /* City */,
  "street" /* Street */,
  "zipCode" /* ZipCode */
];

// src/components/molecules/CardPaymentForm/components/AddressSection/AddressSection.tsx
var import_react72 = require("react");
var import_react_i18next20 = require("react-i18next");
var import_styled_components101 = __toESM(require("styled-components"));
var import_dash_common26 = require("dash-common");

// src/components/molecules/CardPaymentForm/hooks/useValidation.ts
var import_react71 = require("react");
var import_react_i18next19 = require("react-i18next");
var import_dash_common25 = require("dash-common");
var useValidation = () => {
  const { errorHandlers } = (0, import_react71.useContext)(FormContext);
  const { t } = (0, import_react_i18next19.useTranslation)(["forms", "common", "pages"]);
  const validateFieldByName = (fieldName, value) => {
    const setInvalid = (message) => {
      errorHandlers[fieldName]({
        type: "invalid" /* Invalid */,
        message: t(message)
      });
    };
    switch (fieldName) {
      case "fullName" /* FullName */: {
        if ((0, import_dash_common25.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.nameBlank"));
          return false;
        }
        if (!(0, import_dash_common25.isNameLengthValid)(value)) {
          setInvalid(t("forms:messages.nameInvalid"));
          return false;
        }
        break;
      }
      case "street" /* Street */: {
        if ((0, import_dash_common25.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.streetBlank"));
          return false;
        }
        break;
      }
      case "city" /* City */: {
        if ((0, import_dash_common25.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.cityBlank"));
          return false;
        }
        break;
      }
      case "zipCode" /* ZipCode */: {
        if ((0, import_dash_common25.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.zipCodeBlank"));
          return false;
        }
        break;
      }
      case "state" /* State */: {
        if ((0, import_dash_common25.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.stateBlank"));
          return false;
        }
        break;
      }
      case "county" /* County */: {
        if ((0, import_dash_common25.isEmptyOrNil)(value)) {
          setInvalid(t("forms:messages.countyBlank"));
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };
  return validateFieldByName;
};
var useValidation_default = useValidation;

// src/components/molecules/CardPaymentForm/components/AddressSection/AddressSection.tsx
var import_jsx_runtime102 = require("react/jsx-runtime");
var NumberInput = (0, import_styled_components101.default)(Input_default)`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
var GeneralInputs = ({ statesOptions }) => {
  const { t } = (0, import_react_i18next20.useTranslation)(["forms", "common"]);
  const theme = (0, import_styled_components101.useTheme)();
  const { formState, formErrors, stateHandlers } = (0, import_react72.useContext)(FormContext);
  const validateFieldByName = useValidation_default();
  const handleTextInputs = (fieldName) => (e) => {
    const { value } = e.target;
    if (fieldName === "zipCode" /* ZipCode */) {
      if (value.length <= import_dash_common26.DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](value);
        validateFieldByName(fieldName, value);
      }
      return;
    }
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleSelectInputs = (fieldName) => (value) => {
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
    if (fieldName === "state" /* State */) {
      stateHandlers["county" /* County */]("");
      stateHandlers["county" /* County */](null);
    }
  };
  const stateName = formState.state || "";
  const countiesOptions = (0, import_react72.useMemo)(() => {
    const counties = (0, import_dash_common26.getCountiesByStateName)(stateName);
    return counties.map((value) => ({
      label: value,
      value
    }));
  }, [stateName]);
  const handleCountySelect = (value) => {
    if (value) {
      stateHandlers["county" /* County */](value);
      validateFieldByName("county" /* County */, value);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(import_jsx_runtime102.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Flex_default, { mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Text_default, { semibold: true, color: theme.colors.n90, children: t("common:labels:billingAddress") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Flex_default, { flex: 1, flexDirection: "row", children: [
      /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Flex_default, { flex: 1, flexDirection: "column", mr: 4, children: [
        /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Label, { required: true, children: t("forms:labels.state") }),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
            Form_default.Select,
            {
              options: statesOptions,
              menuPlacement: "top",
              placeholder: t("forms:placeholders.selectOne"),
              w: "100%",
              onChanged: handleSelectInputs("state" /* State */),
              $errorType: formErrors["state" /* State */]?.type,
              value: formState.state
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Feedback, { $errorType: formErrors["state" /* State */]?.type, children: formErrors["state" /* State */]?.message })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Label, { required: true, children: t("forms:labels.city") }),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
            Form_default.Input,
            {
              placeholder: t("forms:placeholders.nameOfCity") || "",
              onChange: handleTextInputs("city" /* City */),
              $errorType: formErrors["city" /* City */]?.type,
              value: formState.city || ""
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Feedback, { $errorType: formErrors["city" /* City */]?.type, children: formErrors["city" /* City */]?.message })
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Label, { required: true, children: t("forms:labels.county") }),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
            Form_default.Select,
            {
              disabled: !formState.state || !countiesOptions.length,
              options: countiesOptions,
              value: formState.county,
              menuPlacement: "top",
              placeholder: t("forms:placeholders.selectOne"),
              onChanged: handleCountySelect,
              w: "100%",
              $errorType: formErrors["county" /* County */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Feedback, { $errorType: formErrors["county" /* County */]?.type, children: formErrors["county" /* County */]?.message })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Label, { required: true, children: t("forms:labels.zipCode") }),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
            NumberInput,
            {
              value: formState.zipCode || "",
              placeholder: t("forms:placeholders.digits", { number: 5 }) || "",
              type: "number",
              onChange: handleTextInputs("zipCode" /* ZipCode */),
              $errorType: formErrors["zipCode" /* ZipCode */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Feedback, { $errorType: formErrors["zipCode" /* ZipCode */]?.type, children: formErrors["zipCode" /* ZipCode */]?.message })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Flex_default, { flex: 1, flexDirection: "row", children: /* @__PURE__ */ (0, import_jsx_runtime102.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Label, { required: true, children: t("forms:labels.streetName") }),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(
        Form_default.Input,
        {
          placeholder: t("forms:placeholders.nameOfStreet") || "",
          onChange: handleTextInputs("street" /* Street */),
          value: formState.street || "",
          $errorType: formErrors["street" /* Street */]?.type
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime102.jsx)(Form_default.Feedback, { $errorType: formErrors["street" /* Street */]?.type, children: formErrors["street" /* Street */]?.message })
    ] }) })
  ] });
};
var AddressSection_default = GeneralInputs;

// src/components/molecules/CardPaymentForm/CardPaymentForm.tsx
var import_jsx_runtime103 = require("react/jsx-runtime");
var StyledInput2 = (0, import_styled_components102.default)(Input_default)`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.n60};
`;
var InputsContainer = (0, import_styled_components102.default)(Flex_default)`
  align-items: center;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: flex-start;
  }
`;
var ExpInputsContainer = (0, import_styled_components102.default)(Flex_default)`
  margin-left: ${({ theme }) => theme.space * 4}px;
  margin-top: 0px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin-left: 0px;
    margin-top: ${({ theme }) => theme.space * 4}px;
  }
`;
var CardPaymentForm = ({
  stripe,
  elements,
  formRef,
  handleSubmit,
  withAddress = false,
  statesOptions,
  ...args
}) => {
  const { t } = (0, import_react_i18next21.useTranslation)(["common"]);
  const { formErrors, formState, formOnSubmit, resetFormErrors, stateHandlers } = (0, import_react73.useContext)(FormContext);
  const valid = useValidation_default();
  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    formOnSubmit();
    const { fullName, isLoading, errorSlug, ...address } = formState;
    if (!valid("fullName" /* FullName */, fullName))
      return;
    if (withAddress) {
      const invalidFields = Object.entries(address).map(([name, value]) => !valid(name, value) && name).filter(Boolean);
      if (invalidFields.length)
        return;
    }
    const cardElement = elements?.getElement(import_react_stripe_js4.CardNumberElement);
    if (!cardElement)
      return;
    const stripeAddress = {
      country: "US",
      city: address.city,
      line1: address.street,
      line2: address.county,
      postal_code: address.zipCode,
      state: address.state
    };
    const stripeResponse = await stripe?.createPaymentMethod({
      type: "card",
      card: cardElement,
      billing_details: {
        name: fullName,
        ...withAddress ? { address: stripeAddress } : {}
      }
    });
    resetFormErrors();
    if (stripe && stripeResponse && stripeResponse.paymentMethod) {
      return handleSubmit(stripeResponse.paymentMethod.id, stripe.confirmCardPayment);
    }
    return;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(Form_default, { onSubmit, ref: formRef, ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(Form_default.Group, { mb: 4, children: [
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.Label, { required: true, children: t("common:labels.creditCardNumber") }),
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.CardNumberInput, { options: { placeholder: "xxxx xxxx xxxx xxxx" } })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(InputsContainer, { w: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Flex_default, { flex: 2, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.Label, { required: true, children: t("common:labels.fullName") }),
        /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(
          StyledInput2,
          {
            w: "100%",
            placeholder: t("common:placeholders.firstAndLastName") || "",
            onChange: (e) => {
              const value = e.target.value;
              stateHandlers["fullName" /* FullName */](value);
              valid("fullName" /* FullName */, value);
            },
            $errorType: formErrors["fullName" /* FullName */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.Feedback, { $errorType: formErrors["fullName" /* FullName */]?.type, children: formErrors["fullName" /* FullName */]?.message })
      ] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(ExpInputsContainer, { w: "100%", flex: 1, children: [
        /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
          /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.Label, { required: true, children: t("common:labels.expiryDate") }),
          /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.ExpiryDateInput, { w: "100%", options: { placeholder: "mm/yy" } })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime103.jsxs)(Flex_default, { flex: 1, flexDirection: "column", ml: 4, children: [
          /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.Label, { required: true, children: t("common:labels.cvv") }),
          /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(Form_default.CardCvvInput, { w: "100%", options: { placeholder: "123" } })
        ] })
      ] })
    ] }),
    withAddress && /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(AddressSection_default, { statesOptions })
  ] });
};
var CardPaymentForm_default = ({ ...args }) => /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(FormProvider, { fieldsList: FormFieldsList, children: /* @__PURE__ */ (0, import_jsx_runtime103.jsx)(CardPaymentForm, { ...args }) });

// src/components/molecules/CopyToClipboardButton/CopyToClipboardButton.tsx
var import_styled_components103 = __toESM(require("styled-components"));
var import_jsx_runtime104 = require("react/jsx-runtime");
var PointerWrapper = (0, import_styled_components103.default)(Box_default)`
  cursor: pointer;
`;
var CopyToClipboardButton = ({
  textToCopy,
  successMessage,
  size = 20,
  ml = 2,
  mr = 2
}) => {
  const theme = (0, import_styled_components103.useTheme)();
  const copyToClipboard = () => {
    if (textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      toast.success(successMessage);
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(PointerWrapper, { onClick: copyToClipboard, ml, mr, children: /* @__PURE__ */ (0, import_jsx_runtime104.jsx)(Icon_default, { name: "contentCopy", size, color: theme.colors.b50 }) });
};
var CopyToClipboardButton_default = CopyToClipboardButton;

// src/components/molecules/FileTypeIcon/FileTypeIcon.tsx
var import_styled_components104 = __toESM(require("styled-components"));
var import_dash_common27 = require("dash-common");
var import_react_i18next22 = require("react-i18next");
var import_jsx_runtime105 = require("react/jsx-runtime");
var iconsMap = {
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.doc]: "fileDoc",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.docx]: "fileDoc",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.avi]: "fileVideo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.mov]: "fileVideo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.mp4]: "fileVideo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.xls]: "fileDoc",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.xlsx]: "fileDoc",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.pdf]: "filePdf",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.jpeg]: "filePhoto",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.jpg]: "filePhoto",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.png]: "filePhoto",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.svg]: "filePhoto",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.csv]: "filePhoto"
};
var textMap = {
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.doc]: "doc",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.docx]: "doc",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.avi]: "video",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.mov]: "video",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.mp4]: "video",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.xls]: "exel",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.xlsx]: "exel",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.pdf]: "pdf",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.jpeg]: "photo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.jpg]: "photo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.png]: "photo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.svg]: "photo",
  [import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.csv]: "photo"
};
var IconMask = (0, import_styled_components104.default)(Icon_default)`
  position: absolute;
`;
var TextStyled = (0, import_styled_components104.default)(Text_default)`
  font-size: ${({ size }) => size}px;
  line-height: ${({ size }) => size + 2}px;
`;
var sizeMap = {
  sm: {
    containerW: 21,
    containerH: 24,
    textFontSize: 3,
    iconSize: 9
  },
  md: {
    containerW: 30,
    containerH: 33,
    textFontSize: 6,
    iconSize: 12
  },
  lg: {
    containerW: 68,
    containerH: 82,
    textFontSize: 14,
    iconSize: 24
  }
};
var FileTypeIcon = ({ file, md, sm, lg, ...args }) => {
  const { type } = file;
  const theme = (0, import_styled_components104.useTheme)();
  const { t, i18n: i18nErrorSlugs } = (0, import_react_i18next22.useTranslation)(["common"]);
  const label = i18nErrorSlugs.exists(`common:fileTypes:${textMap[type]}`) ? t(`common:fileTypes:${textMap[type]}`) : t("common:fileTypes:file");
  const mdSize = md && sizeMap.md;
  const smSize = sm && sizeMap.sm;
  const lgSize = lg && sizeMap.lg;
  const size = smSize || mdSize || lgSize || sizeMap.md;
  return /* @__PURE__ */ (0, import_jsx_runtime105.jsxs)(
    Flex_default,
    {
      w: size.containerW,
      h: size.containerH,
      justifyContent: "center",
      alignItems: "center",
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(IconMask, { color: theme.colors.b20, size: size.containerH, name: "file", fill: "none" }),
        /* @__PURE__ */ (0, import_jsx_runtime105.jsxs)(Flex_default, { flexDirection: "column", alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(
            Icon_default,
            {
              color: type === import_dash_common27.ALLOWED_MEDIA_TYPE_MIMES.pdf ? theme.colors.r20 : theme.colors.n80,
              size: size.iconSize,
              name: iconsMap[type]
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(Flex_default, { mt: smSize ? 0.5 : 1, children: /* @__PURE__ */ (0, import_jsx_runtime105.jsx)(TextStyled, { bold: true, size: size.textFontSize, children: label }) })
        ] })
      ]
    }
  );
};
var FileTypeIcon_default = FileTypeIcon;

// src/components/molecules/ExpandableText/ExpandableText.tsx
var import_styled_components105 = __toESM(require("styled-components"));
var import_react_i18next23 = require("react-i18next");
var import_react74 = require("react");
var import_jsx_runtime106 = require("react/jsx-runtime");
var StyledButton2 = (0, import_styled_components105.default)(Button_default)`
  padding: 0;
`;
var StyledText = (0, import_styled_components105.default)(Text_default)`
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  ${({ isOpened, lineClamp }) => !isOpened && `-webkit-line-clamp: ${lineClamp}`};
`;
var ExpandableText = ({
  children,
  lineClamp = 0,
  withButton = true,
  ...rest
}) => {
  const [isOpened, setIsOpened] = (0, import_react74.useState)(false);
  const [isOverflowing, setIsOverflowing] = (0, import_react74.useState)(false);
  const { t } = (0, import_react_i18next23.useTranslation)("common");
  const textRef = (0, import_react74.useRef)(null);
  (0, import_react74.useEffect)(() => {
    if (textRef.current) {
      const { clientHeight, scrollHeight } = textRef.current;
      if (clientHeight < scrollHeight) {
        setIsOverflowing(true);
      }
    }
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime106.jsxs)(import_jsx_runtime106.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(StyledText, { textRef, isOpened, lineClamp, ...rest, children }),
    isOverflowing && withButton && /* @__PURE__ */ (0, import_jsx_runtime106.jsx)(
      StyledButton2,
      {
        variation: "flat",
        onClick: () => setIsOpened(!isOpened),
        minWidth: "fit-content",
        h: "fit-content",
        children: t(`labels.${isOpened ? "showLess" : "showMore"}`)
      }
    )
  ] });
};
var ExpandableText_default = ExpandableText;

// src/components/molecules/SubscriptionRecurringSwitch/SubscriptionRecurringSwitch.tsx
var import_styled_components106 = __toESM(require("styled-components"));
var import_lodash13 = require("lodash");
var import_react75 = require("react");
var import_react_i18next24 = require("react-i18next");
var import_dash_common28 = require("dash-common");
var import_jsx_runtime107 = require("react/jsx-runtime");
var Container4 = (0, import_styled_components106.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 8}px;
  border: 1px solid ${({ theme }) => theme.colors.n50};
`;
var ButtonStyle3 = (0, import_styled_components106.default)(Badge_default)`
  background-color: ${({ isActive, theme }) => isActive ? theme.colors.g20 : "transparent"};
  color: ${({ isActive, theme }) => isActive ? theme.colors.white : theme.colors.n70};
  border-radius: ${({ theme }) => theme.space * 8}px;
`;
function SubscriptionRecurringSwitch({
  defaultRecurringType,
  onToggle
}) {
  const { t } = (0, import_react_i18next24.useTranslation)(["pages"]);
  const [type, setType] = (0, import_react75.useState)(
    defaultRecurringType || import_dash_common28.RecurringTypesEnum.MONTH
  );
  (0, import_react75.useEffect)(() => {
    if (onToggle) {
      onToggle(type);
    }
  }, [type, onToggle]);
  return /* @__PURE__ */ (0, import_jsx_runtime107.jsxs)(Container4, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
      ButtonStyle3,
      {
        sm: true,
        px: 6.5,
        py: 2,
        isActive: type === import_dash_common28.RecurringTypesEnum.MONTH,
        onClick: () => setType(import_dash_common28.RecurringTypesEnum.MONTH),
        title: t(
          `pages:completeSignUpPickSubscription:subscriptionProductRecurringLabels:${(0, import_lodash13.camelCase)(
            import_dash_common28.RecurringTypesEnum.MONTH
          )}`
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime107.jsx)(
      ButtonStyle3,
      {
        sm: true,
        px: 6.5,
        py: 2,
        isActive: type === import_dash_common28.RecurringTypesEnum.YEAR,
        onClick: () => setType(import_dash_common28.RecurringTypesEnum.YEAR),
        title: t(
          `pages:completeSignUpPickSubscription:subscriptionProductRecurringLabels:${(0, import_lodash13.camelCase)(
            import_dash_common28.RecurringTypesEnum.YEAR
          )}`
        )
      }
    )
  ] });
}
var SubscriptionRecurringSwitch_default = SubscriptionRecurringSwitch;

// src/components/molecules/Drawer/Drawer.styles.ts
var import_styled_components108 = __toESM(require("styled-components"));

// src/components/molecules/Drawer/Drawer.tsx
var import_react_modal3 = __toESM(require("react-modal"));
var import_styled_components107 = __toESM(require("styled-components"));
var import_jsx_runtime108 = require("react/jsx-runtime");
var Footer = (0, import_styled_components107.default)(Flex_default)`
  border-top: 1px solid ${({ theme }) => theme.colors.n30};

  button > div {
    white-space: nowrap;
  }
`;
function UnstyledDrawer({
  submitButton,
  cancelButton,
  backButton,
  children,
  title,
  className,
  isOpen,
  onRequestClose,
  closeIcon = true,
  subtitle,
  ...args
}) {
  const theme = (0, import_styled_components107.useTheme)();
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  return /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
    import_react_modal3.default,
    {
      className: contentClassName,
      overlayClassName: {
        base: overlayClassName,
        afterOpen: `${overlayClassName}--after-open`,
        beforeClose: `${overlayClassName}--before-close`
      },
      isOpen,
      onRequestClose,
      ...args,
      children: /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(
        Flex_default,
        {
          flexDirection: "column",
          h: "100%",
          w: "100%",
          justifyContent: "space-between",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Box_default, { w: "100%", ...submitButton || cancelButton ? {} : { h: "100%" }, children: [
              /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Box_default, { children: [
                /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
                  backButton && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Button_default, { icon: "chevronLeft", variation: "flat", ...backButton }),
                  title && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Text_default, { lg: true, semibold: true, children: title }),
                  closeIcon && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Icon_default, { name: "close", size: 20, onClick: onRequestClose })
                ] }),
                subtitle && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(Text_default, { color: theme.colors.n70, children: subtitle })
              ] }),
              children
            ] }),
            (submitButton || cancelButton) && /* @__PURE__ */ (0, import_jsx_runtime108.jsxs)(Footer, { pt: 6, pb: 4, w: "100%", children: [
              submitButton && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
                Button_default,
                {
                  minWidth: 120,
                  h: 40,
                  onClick: submitButton.onClick,
                  isLoading: submitButton.isLoading,
                  disabled: submitButton.disabled,
                  mr: 2,
                  children: submitButton.title
                }
              ),
              cancelButton && /* @__PURE__ */ (0, import_jsx_runtime108.jsx)(
                Button_default,
                {
                  h: 40,
                  variation: "outline",
                  minWidth: 120,
                  onClick: cancelButton.onClick,
                  isLoading: cancelButton.isLoading,
                  disabled: cancelButton.disabled,
                  children: cancelButton.title
                }
              )
            ] })
          ]
        }
      )
    }
  );
}
var Drawer_default = UnstyledDrawer;

// src/components/molecules/Drawer/Drawer.styles.ts
var Drawer = (0, import_styled_components108.default)(Drawer_default)`
  &__overlay {
    position: fixed;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0;
    overflow: auto;
    display: flex;
    justify-content: flex-end;
    z-index: 100;
    height: 100%;
  }

  &__overlay--after-open {
    opacity: 1;
    transition: opacity 150ms ease-in-out;
  }

  &__overlay--before-close {
    opacity: 0;
  }

  &__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
    outline: none;
    padding: 24px 16px;
    width: 410px;
    height: 100%;
  }

  @media ${({ theme }) => theme.devices.mobile} {
    &__content {
      width: 330px;
    }
  }
`;

// src/components/molecules/AvatarUpload/AvatarUpload.tsx
var import_react76 = require("react");
var import_styled_components109 = __toESM(require("styled-components"));
var import_dash_common29 = require("dash-common");
var import_react_i18next25 = require("react-i18next");
var import_jsx_runtime109 = require("react/jsx-runtime");
var Container5 = (0, import_styled_components109.default)(Flex_default)`
  position: relative;
  min-width: max-content;

  ${({ isDeletable }) => isDeletable && import_styled_components109.css`
      &:hover {
        & > div:last-child {
          display: flex;
        }
      }
    `}
`;
var InputStyle2 = (0, import_styled_components109.default)(Box_default)`
  display: none;
`;
var DeleteButtonWrapper = (0, import_styled_components109.default)(Flex_default)`
  display: none;
  width: 100%;
  height: 100%;
  border-radius: 30px;
  cursor: pointer;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.black, 20)};
`;
var ImgStyle3 = import_styled_components109.default.img`
  background-color: unset;
  border-radius: 10px;
  ${({ size }) => size ? `width:${size}${typeof size === "number" ? "px" : ""};` : ""}
  object-fit: cover;
`;
var AvatarPlaceholderStyle2 = (0, import_styled_components109.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n20};
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  color: ${({ theme }) => theme.colors.n60};
`;
var ButtonContainer = (0, import_styled_components109.default)(Box_default)`
  position: absolute;
  top: ${({ offsetTop }) => offsetTop}px;
  right: ${({ offsetLeft }) => offsetLeft}px;
  border: 2px solid ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  z-index: 1;
`;
function AvatarUpload({
  url,
  medium,
  small,
  large,
  isLoading,
  onChange,
  isDeletable,
  onDelete,
  allowedMimeTypes = import_dash_common29.ALLOWED_AVATAR_MIME_TYPES
}) {
  const size = large && 212 || medium && 136 || small && 88 || 88;
  const buttonOffset = -10;
  const buttonSize = large && 40 || medium && 32 || small && 24 || 24;
  const iconSize = large && 34 || medium && 25 || small && 16 || 16;
  const [avatarUrl, setAvatarUrl] = (0, import_react76.useState)(null);
  const inputRef = (0, import_react76.useRef)(null);
  const theme = (0, import_styled_components109.useTheme)();
  const { t } = (0, import_react_i18next25.useTranslation)("common");
  const { toggleModal, setPayload } = (0, import_react76.useContext)(ModalContext);
  const handleFileChange = (e) => {
    if (onChange && e.target.files) {
      const file = e.target.files[0];
      setPayload({
        file,
        onComplete: (croppedFile) => {
          onChange(croppedFile);
          setAvatarUrl(URL.createObjectURL(croppedFile));
        }
      });
      toggleModal(true, "CropImageModal");
    }
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };
  (0, import_react76.useEffect)(() => {
    if (url) {
      setAvatarUrl(url);
    }
  }, [url]);
  return /* @__PURE__ */ (0, import_jsx_runtime109.jsxs)(Container5, { isDeletable: isDeletable && !!avatarUrl, children: [
    avatarUrl ? /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(ImgStyle3, { src: avatarUrl, size }) : /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
      AvatarPlaceholderStyle2,
      {
        w: size,
        alignItems: "center",
        justifyContent: "center",
        children: isLoading ? /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(Spinner_default, { size: iconSize }) : /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(Icon_default, { size: iconSize, name: "addPhoto" })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(ButtonContainer, { offsetTop: buttonOffset, offsetLeft: buttonOffset, children: /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
      Button_default,
      {
        type: "button",
        onClick: () => {
          if (inputRef.current) {
            inputRef.current.click();
          }
        },
        h: buttonSize,
        round: true,
        icon: "edit",
        iconProps: { size: 12 }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(InputStyle2, { children: /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
      "input",
      {
        ref: inputRef,
        type: "file",
        accept: allowedMimeTypes.join(","),
        onChange: handleFileChange
      }
    ) }),
    isDeletable && avatarUrl && /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
      DeleteButtonWrapper,
      {
        onClick: () => {
          if (onDelete) {
            onDelete();
            setAvatarUrl(null);
          }
        },
        justifyContent: "center",
        alignItems: "center",
        pos: "absolute",
        w: "70%",
        h: "70%",
        children: /* @__PURE__ */ (0, import_jsx_runtime109.jsxs)(Flex_default, { w: 50, flexDirection: "column", alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(
            Icon_default,
            {
              mb: 3,
              name: "trashSolid",
              color: theme.colors.white,
              size: 20
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime109.jsx)(Text_default, { color: theme.colors.white, children: t("common:labels.delete") })
        ] })
      }
    )
  ] });
}
var AvatarUpload_default = AvatarUpload;

// src/components/molecules/PageViewToggle/PageViewToggle.tsx
var import_react77 = require("react");
var import_styled_components110 = __toESM(require("styled-components"));
var import_jsx_runtime110 = require("react/jsx-runtime");
var StyledWrapper4 = (0, import_styled_components110.default)(Flex_default)`
  background: ${({ theme }) => theme.colors.white};
`;
var PropertiesViewToggle = ({
  buttons,
  defaultButton
}) => {
  const theme = (0, import_styled_components110.useTheme)();
  const { viewType, setViewType } = (0, import_react77.useContext)(PageViewContext);
  const [firstButton, secondButton] = buttons;
  const isSecondButton = viewType === secondButton.viewType;
  const isFirstButton = viewType === firstButton.viewType;
  (0, import_react77.useEffect)(() => {
    if (defaultButton) {
      setViewType(defaultButton);
    }
  }, [defaultButton]);
  return /* @__PURE__ */ (0, import_jsx_runtime110.jsxs)(StyledWrapper4, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
      Button_default,
      {
        square: true,
        icon: firstButton.icon,
        iconProps: { size: 24, color: isFirstButton ? theme.colors.white : theme.colors.n80 },
        disabled: firstButton.disabled,
        borderRadius: 4,
        variation: isFirstButton ? "primary" : "flat",
        onClick: () => setViewType(firstButton.viewType)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime110.jsx)(
      Button_default,
      {
        square: true,
        disabled: secondButton.disabled,
        icon: secondButton.icon,
        borderRadius: 4,
        iconProps: { size: 24, color: isSecondButton ? theme.colors.white : theme.colors.n80 },
        variation: isSecondButton ? "primary" : "flat",
        onClick: () => setViewType(secondButton.viewType)
      }
    )
  ] });
};
var PageViewToggle_default = PropertiesViewToggle;

// src/components/molecules/FlatPagination/FlatPagination.tsx
var import_react78 = require("react");
var import_jsx_runtime111 = require("react/jsx-runtime");
function FlatPagination({
  currentStartingAfter,
  currentEndingBefore,
  hasMore,
  ...args
}) {
  const { state, setStartingAfter, setEndingBefore } = (0, import_react78.useContext)(FlatPaginationContext);
  const onGoForward = (0, import_react78.useCallback)(() => {
    currentStartingAfter && setStartingAfter(currentStartingAfter);
  }, [currentStartingAfter, setStartingAfter]);
  const onGoBack = (0, import_react78.useCallback)(() => {
    currentEndingBefore && setEndingBefore(currentEndingBefore);
  }, [currentEndingBefore, setEndingBefore]);
  const isFirstPage = !state.startingAfter && !state.endingBefore;
  const hasPreviousPage = state.endingBefore && hasMore || !isFirstPage && state.startingAfter;
  const hasNextPage = state.startingAfter && hasMore || state.endingBefore || isFirstPage && hasMore;
  if (isFirstPage && !hasMore) {
    return null;
  }
  return /* @__PURE__ */ (0, import_jsx_runtime111.jsxs)(Flex_default, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
      Button_default,
      {
        disabled: !hasPreviousPage,
        mr: 1,
        square: true,
        small: true,
        variation: "outline",
        onClick: onGoBack,
        icon: "chevronLeft"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime111.jsx)(
      Button_default,
      {
        disabled: !hasNextPage,
        mr: 1,
        square: true,
        small: true,
        variation: "outline",
        onClick: onGoForward,
        icon: "chevronRight"
      }
    )
  ] });
}
var FlatPagination_default = FlatPagination;

// src/components/molecules/BrokersBanner/BrokersBanner.tsx
var import_styled_components113 = require("styled-components");
var import_dash_common31 = require("dash-common");

// src/components/molecules/BrokersBanner/BrokersBanner.styles.ts
var import_styled_components111 = __toESM(require("styled-components"));
var hiddenDivStyles = import_styled_components111.css`
  ${({ isVertical }) => isVertical && `display: none`}
`;
var BannerWrapper = (0, import_styled_components111.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b60};
  position: relative;
  color: ${({ theme }) => theme.colors.white};
  height: ${({ isVertical }) => isVertical ? "100%" : "384px"};
  width: ${({ isVertical }) => isVertical ? "255px" : "100%"};
  border-radius: ${({ theme }) => theme.space * 4}px;
  @media ${({ theme }) => theme.devices.tablet} {
    width: ${({ isVertical }) => isVertical ? "215px" : "100%"};
  }
  @media ${({ theme }) => theme.devices.mobile} {
    height: fit-content;
    width: 100%;
    background-color: unset;
  }
`;
var OuterCircle = (0, import_styled_components111.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b70};
  width: 669px;
  height: 669px;
  border-radius: 100%;
  position: absolute;
  bottom: -23px;
  right: 183px;
  ${hiddenDivStyles}
`;
var InnerCircle = (0, import_styled_components111.default)(Box_default)`
  background-color: ${({ theme }) => theme.colors.b80};
  position: absolute;
  width: 100%;
  height: 572px;
  border-radius: 0 255px 255px 0;
  right: calc(183px + 195px);
  bottom: -79px;
  z-index: 1;
  ${hiddenDivStyles}
  @media ${({ theme }) => theme.devices.tablet} {
    border-radius: 0 215px 215px 0;
  }
`;
var AvatarCircleWrapper = (0, import_styled_components111.default)(Box_default)`
  overflow: hidden;
  position: relative;
  border-radius: ${({ theme }) => theme.space * 4}px;
  min-width: ${({ isVertical }) => isVertical ? "255px" : "332px"};
  height: ${({ isVertical }) => isVertical ? "270px" : "384px"};
  @media ${({ theme }) => theme.devices.tablet} {
    min-width: ${({ isVertical }) => isVertical ? "215px" : "332px"};
  }
  @media ${({ theme }) => theme.devices.mobile} {
    height: 230px;
    width: 100%;
  }
`;
var AvatarCircle = (0, import_styled_components111.default)(Box_default)`
  border-radius: ${({ isVertical }) => isVertical ? "0 0 196px 196px" : "0 251px 251px 0"};
  width: ${({ isVertical }) => isVertical ? "358px" : "332px"};
  height: ${({ isVertical }) => isVertical ? "270px" : "502px"};
  overflow: hidden;
  position: absolute;
  top: ${({ isVertical }) => isVertical ? 0 : "-59px"};
  left: ${({ isVertical }) => isVertical ? "-55px" : 0};
  background-color: ${({ theme }) => theme.colors.n30};

  & img {
    border-radius: ${({ isVertical }) => isVertical ? "0 0 196px 196px" : "0 251px 251px 0"};
  }
  @media ${({ theme }) => theme.devices.tablet} {
    width: ${({ isVertical }) => isVertical ? "338px" : "332px"};
  }
  @media ${({ theme }) => theme.devices.mobile} {
    border-radius: unset;
    & img {
      border-radius: unset;
    }
    height: inherit;
    width: 100%;
    left: unset;
    position: relative;
  }
`;
var InfoWrapper = (0, import_styled_components111.default)(Flex_default)`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 2;
  border-radius: ${({ theme }) => theme.space * 5}px;
  @media ${({ theme }) => theme.devices.mobile} {
    position: relative;
    background-color: ${({ theme }) => theme.colors.b60};
    border-radius: ${({ theme }) => theme.space * 5}px;
  }
`;
var BackgroundWrapper = (0, import_styled_components111.default)(Box_default)`
  position: absolute;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.space * 4}px;
  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

// src/components/molecules/BrokersBanner/components/ButtonsSection.tsx
var import_moment6 = __toESM(require("moment"));
var import_styled_components112 = __toESM(require("styled-components"));
var import_react_i18next26 = require("react-i18next");
var import_dash_common30 = require("dash-common");
var import_jsx_runtime112 = require("react/jsx-runtime");
var StyledContainer2 = (0, import_styled_components112.default)(Flex_default)`
  flex-direction: ${({ isVertical }) => isVertical ? "column" : "row"};
  @media ${({ theme }) => theme.devices.tablet} {
    flex-direction: row;
  }
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: row;
  }
`;
var ButtonContainer2 = (0, import_styled_components112.default)(Flex_default)`
  flex: ${({ isVertical }) => isVertical ? 1 : "unset"};
  width: ${({ isVertical }) => isVertical ? "100%" : "unset"};
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }
`;
var StyledButton3 = (0, import_styled_components112.default)(Button_default)`
  background-color: ${({ theme }) => theme.colors.b10};

  :hover {
    & p {
      color: ${({ theme }) => theme.colors.white};
    }
  }
  & p {
    color: ${({ theme }) => theme.colors.b50};
  }
  width: ${({ isVertical }) => isVertical ? "100%" : "unset"};
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
  }
`;
var ButtonsSection = ({
  broker,
  isVertical,
  onAvailabilityClick
}) => {
  const theme = (0, import_styled_components112.useTheme)();
  const { t } = (0, import_react_i18next26.useTranslation)(["pages", "common"]);
  const { account, agencyWebsite } = broker;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(StyledContainer2, { flex: 1, flexWrap: "wrap", isVertical, mt: 6, children: [
    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
      ButtonContainer2,
      {
        isVertical,
        mr: [3, isVertical ? 0 : 3, isVertical ? 0 : 3, isVertical ? 0 : 3],
        children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
          DropDown_default,
          {
            placement: "bottom",
            placementHorizontal: (0, import_dash_common30.or)(!isVertical, isMobile) ? "right" : "left",
            w: isVertical ? "100%" : "fit-content",
            Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(StyledButton3, { px: [0, 10, 10, 10], isVertical, children: t("pages:portfoliosPage.contactMe") }),
            children: () => /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(
              Flex_default,
              {
                px: 4,
                py: 5,
                minWidth: isMobile ? "83vw" : 350,
                maxWidth: isMobile ? "83vw" : 473,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Flex_default, { flex: 1, mr: 2, flexDirection: "column", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Text_default, { color: theme.colors.n70, children: [
                      t("common:labels.phone").toUpperCase(),
                      ":"
                    ] }),
                    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(Box_default, { my: 5.5, children: /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Text_default, { color: theme.colors.n70, children: [
                      t("forms:labels.email").toUpperCase(),
                      ":"
                    ] }) }),
                    !!agencyWebsite && /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Text_default, { color: theme.colors.n70, children: [
                      t("common:labels.website").toUpperCase(),
                      ":"
                    ] })
                  ] }),
                  /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Flex_default, { overflow: "auto", flex: 2, flexDirection: "column", children: [
                    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(Flex_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
                      A_default,
                      {
                        href: `tel:${account.phone?.dialCode}${account.phone?.number}`,
                        children: `${account.phone?.dialCode} ${account.phone?.number}`
                      }
                    ) }),
                    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(Flex_default, { my: 5.5, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(A_default, { href: `mailto:${account.email}`, children: account.email }) }),
                    !!agencyWebsite && /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(Flex_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(A_default, { ellipsis: true, href: agencyWebsite, children: agencyWebsite }) })
                  ] })
                ]
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
      ButtonContainer2,
      {
        isVertical,
        mt: [0, isVertical ? 3 : 0, isVertical ? 3 : 0, isVertical ? 3 : 0],
        children: !onAvailabilityClick ? /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
          DropDown_default,
          {
            placement: "bottom",
            w: isVertical ? "100%" : "fit-content",
            Anchor: () => /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(StyledButton3, { px: [0, 9, 9, 9], isVertical, children: t("pages:portfoliosPage.availability") }),
            children: () => /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(Box_default, { p: 4, w: "100%", children: Object.values(import_dash_common30.WeekDays).map((day, index2) => {
              const range = (broker.workingHours || {})[day];
              const from2 = (0, import_moment6.default)(range?.from).format("hh:mm A");
              const to2 = (0, import_moment6.default)(range?.to).format("hh:mm A");
              return /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Flex_default, { alignItems: "center", mt: index2 === 0 ? 0 : 3.5, children: [
                /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(Box_default, { mr: 2, w: 40, children: /* @__PURE__ */ (0, import_jsx_runtime112.jsxs)(Text_default, { whiteSpace: "nowrap", children: [
                  t(`common:labels.weekDays.${day}`).slice(
                    0,
                    day === import_dash_common30.WeekDays.Tuesday ? 4 : 3
                  ),
                  ":"
                ] }) }),
                /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(
                  Text_default,
                  {
                    whiteSpace: "nowrap",
                    sm: true,
                    color: !range ? theme.colors.r20 : theme.colors.b50,
                    children: !range ? t("common:labels.notWorking") : `${from2} - ${to2}`
                  }
                )
              ] }, day);
            }) })
          }
        ) : /* @__PURE__ */ (0, import_jsx_runtime112.jsx)(StyledButton3, { px: [0, 9, 9, 9], isVertical, onClick: onAvailabilityClick, children: t("pages:portfoliosPage.availability") })
      }
    )
  ] });
};
var ButtonsSection_default = ButtonsSection;

// src/components/molecules/BrokersBanner/BrokersBanner.tsx
var import_jsx_runtime113 = require("react/jsx-runtime");
var BrokersBanner = ({
  broker,
  h,
  variation = "horizontal",
  maxWidth,
  onAvailabilityClick,
  ...props
}) => {
  const theme = (0, import_styled_components113.useTheme)();
  const { profile, description } = broker;
  const isVertical = variation === "vertical";
  const BrokerName = isVertical ? Text_default : H_default;
  const isVerifiedBroker = broker.account.phone?.status === import_dash_common31.AccountPhoneNumberStatusesEnum.VERIFIED && broker.license.licenseStatus === import_dash_common31.BrokerLicenseStatusesEnum.ACTIVE;
  return /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(BannerWrapper, { isVertical, maxWidth: maxWidth || 1100, ...props, children: [
    /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(BackgroundWrapper, { w: "100%", h: "100%", children: [
      /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(OuterCircle, { isVertical }),
      /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(InnerCircle, { isVertical })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(InfoWrapper, { alignItems: "center", flexDirection: isVertical ? "column" : "row", children: [
      /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(AvatarCircleWrapper, { isVertical, children: /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(AvatarCircle, { id: "avatar-cicle", isVertical, children: profile.avatarFile ? /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Image_default, { src: profile.avatarFile.publicUrl, size: "100%", position: "50% 35%", fit: "cover" }) : /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(DashPlaceholder_default, { w: "100%", h: "100%" }) }) }),
      /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(Box_default, { w: "100%", ml: isVertical ? 0 : 6.5, px: isVertical ? 4 : 0, pb: 4, children: [
        /* @__PURE__ */ (0, import_jsx_runtime113.jsxs)(Flex_default, { mb: 1, alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(BrokerName, { sm: !isVertical, xxl: isVertical, bold: true, color: theme.colors.white, children: `${profile.firstName} ${profile.lastName}` }),
          isVerifiedBroker && /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Icon_default, { name: "verified", color: theme.colors.g40, size: 20, ml: 3 })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(Box_default, { maxWidth: 672, children: /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(ExpandableText_default, { lineClamp: 3, withButton: false, color: theme.colors.n30, children: description }) }),
        /* @__PURE__ */ (0, import_jsx_runtime113.jsx)(
          ButtonsSection_default,
          {
            broker,
            isVertical,
            onAvailabilityClick
          }
        )
      ] })
    ] })
  ] });
};
var BrokersBanner_default = BrokersBanner;

// src/components/molecules/PropertyPreviewComponents/AdditionalInfoSection/AdditionalInfoSection.tsx
var import_lodash14 = require("lodash");
var import_react_i18next28 = require("react-i18next");
var import_dash_common32 = require("dash-common");
var import_styled_components116 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/AdditionalInfoSection/components/TextBlock.tsx
var import_styled_components114 = require("styled-components");
var import_react_i18next27 = require("react-i18next");
var import_styled_components115 = __toESM(require("styled-components"));
var import_jsx_runtime114 = require("react/jsx-runtime");
var StyledText2 = (0, import_styled_components115.default)(Text_default)`
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`;
var TextBlock = ({
  title,
  description,
  children,
  disableDefaultNoValueLabel = false
}) => {
  const theme = (0, import_styled_components114.useTheme)();
  const { t } = (0, import_react_i18next27.useTranslation)(["common"]);
  const value = description || !disableDefaultNoValueLabel && t("common:labels.noValue");
  return /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(TooltipWrapper_default, { content: value, children: /* @__PURE__ */ (0, import_jsx_runtime114.jsxs)(Box_default, { maxWidth: "100%", mr: 2, mb: 2, children: [
    /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(Text_default, { sm: true, color: theme.colors.n80, children: title }),
    children || /* @__PURE__ */ (0, import_jsx_runtime114.jsx)(StyledText2, { color: theme.colors.n90, children: value })
  ] }) });
};
var TextBlock_default = TextBlock;

// src/components/molecules/PropertyPreviewComponents/AdditionalInfoSection/AdditionalInfoSection.tsx
var import_jsx_runtime115 = require("react/jsx-runtime");
var StyledGrid = (0, import_styled_components116.default)(Box_default)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(max(150px, calc(100%/4)), 1fr));
`;
var AdditionalInfoSection = ({
  property,
  containerRef,
  isViewAsClient = false
}) => {
  const { t } = (0, import_react_i18next28.useTranslation)(["forms", "pages"]);
  const {
    numberOfUnits,
    numberOfTowers,
    stories,
    // todo: hiden for now
    // constructionStartDate,
    yearBuilt,
    // completionDate,
    taxInformation,
    location,
    buildingTypes,
    website,
    projectStatus,
    leadArchitect,
    landscapeArchitect,
    interiorDesigner
  } = property;
  return /* @__PURE__ */ (0, import_jsx_runtime115.jsxs)(Box_default, { mt: 8, mb: 2, ref: containerRef, maxWidth: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(Text_default, { semibold: true, xl: true, children: t("pages:propertyPreviewPage.additionalInformation") }),
    /* @__PURE__ */ (0, import_jsx_runtime115.jsxs)(StyledGrid, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.nbrOfUnits"),
          description: numberOfUnits
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.projectStatus"),
          description: projectStatus ? t(`forms:labels.projectStatuses.${(0, import_lodash14.camelCase)(projectStatus)}`) : ""
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.yearBuilt"),
          description: yearBuilt
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.address"),
          description: (0, import_dash_common32.formatAddress)(location.address)
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("pages:propertyPreviewPage.nbrOfStories"),
          description: stories
        }
      ),
      !!numberOfTowers && /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.nbrOfTowers"),
          description: numberOfTowers
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.buildingType"),
          description: buildingTypes?.length && buildingTypes.map((b) => t(`forms:labels.buildingTypes.${(0, import_lodash14.camelCase)(b)}`)).join(", ")
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.leadArchitect"),
          description: leadArchitect
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.landscapeArchitect"),
          description: landscapeArchitect
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.interiorDesigner"),
          description: interiorDesigner
        }
      ),
      !isViewAsClient && /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("pages:propertyPreviewPage.websiteLink"),
          children: website && /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(Box_default, { w: "100%", overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(Text_default, { ellipsis: true, children: /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(A_default, { target: "_blank", href: website || "", children: website }) }) })
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime115.jsx)(
        TextBlock_default,
        {
          title: t("forms:labels.taxInformation"),
          description: taxInformation
        }
      )
    ] })
  ] });
};
var AdditionalInfoSection_default = AdditionalInfoSection;

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/DeveloperInfoSection.tsx
var import_react79 = require("react");
var import_react_i18next29 = require("react-i18next");
var import_styled_components117 = __toESM(require("styled-components"));

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/DeveloperInfoSection.helpers.ts
var import_dash_common33 = require("dash-common");
var formatPhoneNumberByDialCode = (phone) => {
  const phoneNumber = (phone?.dialCode || "") + (phone?.number || "");
  const dialCodeMask = Array.from({ length: phone?.dialCode?.length || 0 }).fill("#").join("");
  return (0, import_dash_common33.formatByMask)(phoneNumber, `${dialCodeMask} ### ### ####`);
};

// src/components/molecules/PropertyPreviewComponents/DeveloperInfoSection/DeveloperInfoSection.tsx
var import_dash_common34 = require("dash-common");
var import_jsx_runtime116 = require("react/jsx-runtime");
var Container6 = (0, import_styled_components117.default)(Flex_default)`
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    align-items: stretch;
    & > div:last-child {
      margin-top: ${({ theme }) => theme.space * 6}px;
    }
  }
  flex-direction: row;
`;
var StyledCard = (0, import_styled_components117.default)(Card_default)`
  @media ${({ theme }) => theme.devices.mobile} {
    width: 100%;
    margin-right: 0;
  }
  width: unset;
`;
var ImageContainer = (0, import_styled_components117.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.n10};
`;
var DeveloperInfoSection = ({
  property,
  isSaleTeamVisible = true
}) => {
  const { t } = (0, import_react_i18next29.useTranslation)(["common", "pages"]);
  const [organizationIndex, setOrganizationIndex] = (0, import_react79.useState)(0);
  const [saleTeamsIndex, setSaleTeamsIndex] = (0, import_react79.useState)(0);
  const theme = (0, import_styled_components117.useTheme)();
  const { primaryOrganization, organizations } = property;
  const organizationsToShow = (0, import_react79.useMemo)(
    () => [primaryOrganization, ...organizations || []],
    [primaryOrganization, organizations]
  );
  const organization = organizationsToShow?.[organizationIndex];
  const orgInfoList = (0, import_react79.useMemo)(
    () => [
      {
        title: t("common:labels:name"),
        subtitle: organization?.name
      },
      {
        title: t("common:labels:website"),
        subtitle: organization?.website ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(A_default, { href: organization?.website, target: "_blank", children: organization?.website }) : t("common:labels.noValue")
      }
    ],
    [property, organization]
  );
  const saleTeam = (0, import_react79.useMemo)(() => {
    return property.saleTeams ? property.saleTeams[saleTeamsIndex] : null;
  }, [saleTeamsIndex]);
  const saleTeamsInfoList = (0, import_react79.useMemo)(
    () => saleTeam ? [
      {
        title: t("common:labels:name"),
        subtitle: saleTeam.saleTeam.name || t("common:labels.noValue")
      },
      {
        title: t("common:labels:website"),
        subtitle: saleTeam.saleTeam.website ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(A_default, { target: "_blank", href: saleTeam.saleTeam.website, children: saleTeam.saleTeam.website }) : t("common:labels.noValue")
      },
      ...saleTeam.saleAssociates ? saleTeam.saleAssociates.map((item) => ({
        title: t("forms:labels:salesAssociate"),
        subtitle: item.profile.firstName + " " + item.profile.lastName || t("common:labels.noValue")
      })) : [],
      {
        title: t("forms:labels:phoneNumber"),
        subtitle: saleTeam.saleTeam.phone ? formatPhoneNumberByDialCode(saleTeam.saleTeam.phone) : t("common:labels.noValue")
      }
    ] : [],
    [saleTeam]
  );
  const isRent = property?.transactionType === import_dash_common34.PropertyTransactionTypesEnum.FOR_RENT;
  return /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Container6, { mt: 6, children: [
    /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Flex_default, { flex: 1, flexDirection: "column", alignItems: "stretch", children: [
      /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Flex_default, { flexGrow: 1, flex: 1, w: "100%", children: [
        /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
          Text_default,
          {
            color: theme.colors.n90,
            xl: true,
            semibold: true,
            children: t`pages:propertyPreviewPage:developerInfoLabel`
          }
        ),
        organizationsToShow && organizationsToShow.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Flex_default, { flex: 1, alignItems: "center", justifyContent: "flex-end", children: [
          /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
            Button_default,
            {
              w: 32,
              h: 32,
              variation: "flat",
              icon: "chevronLeft",
              iconProps: {
                size: 32,
                color: organizationIndex === 0 ? theme.colors.n70 : theme.colors.n90
              },
              disabled: organizationIndex === 0,
              onClick: () => setOrganizationIndex((prevIndex) => prevIndex - 1)
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { color: theme.colors.n90, children: `${organizationIndex + 1}/${organizationsToShow?.length || 1}` }),
          /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
            Button_default,
            {
              w: 32,
              h: 32,
              variation: "flat",
              icon: "chevronRight",
              iconProps: {
                size: 32,
                color: organizationIndex + 1 === organizationsToShow.length ? theme.colors.n70 : theme.colors.n90
              },
              disabled: organizationIndex + 1 === organizationsToShow.length,
              onClick: () => setOrganizationIndex((prevIndex) => prevIndex + 1)
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(
        StyledCard,
        {
          flex: 1,
          mt: 3,
          flexDirection: "column",
          flexGrow: 1,
          alignItems: "stretch",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
              ImageContainer,
              {
                h: 165,
                alignItems: "center",
                justifyContent: "center",
                w: "100%",
                children: /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { children: organization?.logoUrl ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
                  Image_default,
                  {
                    maxHeight: 165,
                    size: "unset",
                    src: organization?.logoUrl
                  }
                ) : /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(DashPlaceholder_default, { mr: 2 }) })
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Devider_default, { w: "100%" }),
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { p: 6, flexDirection: "column", children: orgInfoList.map(
              ({ title, subtitle }, index2) => subtitle ? /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(
                Flex_default,
                {
                  flexDirection: "column",
                  mt: index2 ? 4 : 0,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { color: theme.colors.n80, children: title }) }),
                    /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { mt: 1, children: typeof subtitle === "string" ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { children: subtitle }) : subtitle })
                  ]
                },
                `org-${title}`
              ) : null
            ) })
          ]
        }
      )
    ] }),
    property.saleTeams && property.saleTeams?.length > 0 && isSaleTeamVisible && /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(
      Flex_default,
      {
        flex: 1,
        flexDirection: "column",
        alignItems: "stretch",
        ml: [0, 6, 6, 6],
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Flex_default, { flexGrow: 1, flex: 1, children: [
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { flex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { color: theme.colors.n90, xl: true, semibold: true, children: isRent ? t`pages:propertyPreviewPage:propertyManagementLabel` : t`pages:propertyPreviewPage:salesTeamLabel` }) }),
            property.saleTeams && property.saleTeams?.length > 1 && /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Flex_default, { flex: 1, alignItems: "center", justifyContent: "flex-end", children: [
              /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
                Button_default,
                {
                  w: 32,
                  h: 32,
                  variation: "flat",
                  icon: "chevronLeft",
                  iconProps: {
                    size: 32,
                    color: saleTeamsIndex === 0 ? theme.colors.n70 : theme.colors.n90
                  },
                  disabled: saleTeamsIndex === 0,
                  onClick: () => setSaleTeamsIndex((prevIndex) => prevIndex - 1)
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { color: theme.colors.n90, children: `${saleTeamsIndex + 1}/${property.saleTeams?.length}` }),
              /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
                Button_default,
                {
                  w: 32,
                  h: 32,
                  variation: "flat",
                  icon: "chevronRight",
                  iconProps: {
                    size: 32,
                    color: saleTeamsIndex + 1 === property.saleTeams.length ? theme.colors.n70 : theme.colors.n90
                  },
                  disabled: saleTeamsIndex + 1 === property.saleTeams.length,
                  onClick: () => setSaleTeamsIndex((prevIndex) => prevIndex + 1)
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(Card_default, { flex: 1, mt: 3, flexDirection: "column", children: [
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
              ImageContainer,
              {
                h: 165,
                alignItems: "center",
                justifyContent: "center",
                w: "100%",
                children: /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { children: saleTeam?.saleTeam.logoFile ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(
                  Image_default,
                  {
                    maxHeight: 165,
                    size: "unset",
                    src: saleTeam.saleTeam.logoFile.publicUrl
                  }
                ) : /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(DashPlaceholder_default, { mr: 2 }) })
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Devider_default, { w: "100%" }),
            /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { p: 6, w: "100%", flexDirection: "column", children: saleTeamsInfoList.map(({ title, subtitle }, index2) => /* @__PURE__ */ (0, import_jsx_runtime116.jsxs)(
              Flex_default,
              {
                w: "100%",
                flexDirection: "column",
                mt: index2 ? 4 : 0,
                children: [
                  /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { color: theme.colors.n80, children: title }) }),
                  /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Flex_default, { mt: 1, w: "100%", children: typeof subtitle === "string" ? /* @__PURE__ */ (0, import_jsx_runtime116.jsx)(Text_default, { children: subtitle }) : subtitle })
                ]
              },
              `sale-tema-${title}-${index2}`
            )) })
          ] })
        ]
      }
    )
  ] });
};
var DeveloperInfoSection_default = DeveloperInfoSection;

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/FeaturesAndAmenitiesList.tsx
var import_react80 = require("react");
var import_styled_components119 = __toESM(require("styled-components"));
var import_react_i18next31 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/components/FeatureAndAmenitiesModal/FeatureAndAmenitiesModal.tsx
var import_react_i18next30 = require("react-i18next");
var import_styled_components118 = __toESM(require("styled-components"));
var import_jsx_runtime117 = require("react/jsx-runtime");
var StyledBox4 = (0, import_styled_components118.default)(Box_default)`
  overflow: auto;
`;
var FeatureAndAmenitiesModal = ({ amenities, isOpen, onRequestClose }) => {
  const theme = (0, import_styled_components118.useTheme)();
  const { t } = (0, import_react_i18next30.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(
    Modal3,
    {
      closeIcon: true,
      isOpen,
      onRequestClose,
      title: t("propertyPage.amenitiesTabLabel") || "",
      children: /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(StyledBox4, { h: 420, mt: 6, children: amenities.map((amenity) => /* @__PURE__ */ (0, import_jsx_runtime117.jsxs)(Flex_default, { alignItems: "center", mb: 5, w: 250, children: [
        /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Image_default, { mr: 3, src: amenity.imageUrl || "", alt: amenity.name, size: 24 }),
        /* @__PURE__ */ (0, import_jsx_runtime117.jsx)(Text_default, { color: theme.colors.n80, children: amenity.name })
      ] }, amenity._id)) })
    }
  );
};
var FeatureAndAmenitiesModal_default = FeatureAndAmenitiesModal;

// src/components/molecules/PropertyPreviewComponents/FeaturesAndAmenitiesList/FeaturesAndAmenitiesList.tsx
var import_jsx_runtime118 = require("react/jsx-runtime");
var GridBox = (0, import_styled_components119.default)(Box_default)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(256px, 1fr));
`;
var StyledButton4 = (0, import_styled_components119.default)(Button_default)`
  background-color: transparent;
  border-color: ${({ theme }) => theme.colors.n90};

  & p {
    color: ${({ theme }) => theme.colors.n90};
  }

  :hover {
    border-color: ${({ theme }) => theme.colors.b50};
  }
`;
var FeatureAndAmenitiesList = ({ amenities, loading }) => {
  const [isOpen, setIsOpen] = (0, import_react80.useState)(false);
  const { t } = (0, import_react_i18next31.useTranslation)("pages");
  const theme = (0, import_styled_components119.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { slicedAmenitiesList, fullAmenitiesList } = (0, import_react80.useMemo)(
    () => ({
      slicedAmenitiesList: isMobile ? amenities.slice(0, 5) : amenities,
      fullAmenitiesList: amenities
    }),
    [amenities, isMobile]
  );
  if (!loading && !amenities.length) {
    return /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(Box_default, { mt: 8, pos: "relative", children: [
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Text_default, { semibold: true, xl: true, color: theme.colors.n90, children: t("propertyPage.amenitiesTabLabel") }),
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Box_default, { mt: 2, children: /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Text_default, { children: t("common:labels.noValue") }) })
    ] });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(Box_default, { mt: 8, pos: "relative", children: [
    isMobile && /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(
      FeatureAndAmenitiesModal_default,
      {
        isOpen,
        onRequestClose: () => setIsOpen(false),
        amenities: fullAmenitiesList
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Text_default, { semibold: true, xl: true, color: theme.colors.n90, children: t("propertyPage.amenitiesTabLabel") }),
    /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(GridBox, { mt: 7, children: slicedAmenitiesList.map((amenity) => /* @__PURE__ */ (0, import_jsx_runtime118.jsxs)(Flex_default, { alignItems: "center", w: 256, mb: 5.5, children: [
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(
        Image_default,
        {
          mr: 3,
          src: amenity.imageUrl || "",
          alt: amenity.name,
          size: 24,
          fit: "scale-down"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Text_default, { color: theme.colors.n80, children: amenity.name })
    ] }, amenity._id)) }),
    isMobile && /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(StyledButton4, { onClick: () => setIsOpen(true), mb: 6, variation: "outline", minWidth: "100%", children: t("propertyPage.showFeaturesAndAmenities") }),
    loading && /* @__PURE__ */ (0, import_jsx_runtime118.jsx)(Spinner_default, { fullContent: true, bgColor: theme.colors.n20, size: 32 })
  ] });
};
var FeaturesAndAmenitiesList_default = FeatureAndAmenitiesList;

// src/components/molecules/PropertyPreviewComponents/GeneralInfoSection/GeneralInfoSection.tsx
var import_react_i18next32 = require("react-i18next");
var import_styled_components120 = require("styled-components");
var import_jsx_runtime119 = require("react/jsx-runtime");
var GeneralInfoSection = ({
  property,
  containerRef
}) => {
  const { t } = (0, import_react_i18next32.useTranslation)(["common"]);
  const theme = (0, import_styled_components120.useTheme)();
  const { projectDetails, overview } = property;
  return /* @__PURE__ */ (0, import_jsx_runtime119.jsxs)(Flex_default, { flexDirection: "column", ref: containerRef, children: [
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Flex_default, { mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Text_default, { color: theme.colors.n90, xl: true, semibold: true, children: t`common:labels:highlights` }) }),
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Flex_default, { mt: 2, flexDirection: "column", children: /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(ExpandableText_default, { lineClamp: 6, color: theme.colors.n80, children: overview || t("common:labels.noValue") }) }),
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Flex_default, { mt: 8, children: /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Text_default, { color: theme.colors.n90, xl: true, semibold: true, children: t`forms:labels:projectDetails` }) }),
    /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(Flex_default, { mt: 2, flexDirection: "column", children: /* @__PURE__ */ (0, import_jsx_runtime119.jsx)(ExpandableText_default, { lineClamp: 6, color: theme.colors.n80, children: projectDetails || t("common:labels.noValue") }) })
  ] });
};
var GeneralInfoSection_default = GeneralInfoSection;

// src/components/molecules/PropertyPreviewComponents/MapSection/MapSection.tsx
var import_styled_components121 = __toESM(require("styled-components"));
var import_jsx_runtime120 = require("react/jsx-runtime");
var Container7 = (0, import_styled_components121.default)(Box_default)`
  border-radius: ${({ theme }) => theme.space}px;
  overflow: hidden;
`;
var MapSection = ({ property }) => {
  const isReady = useGoogleApiLoader();
  const [lng, lat] = property.location.geoLocation?.coordinates || [];
  const position = lat && lng ? { lat, lng } : void 0;
  return isReady ? /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Container7, { children: /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(GoogleMap_default, { h: 400, center: position, children: position && /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Marker_default, { position }) }) }) : /* @__PURE__ */ (0, import_jsx_runtime120.jsx)(Spinner_default, {});
};
var MapSection_default = MapSection;

// src/components/molecules/PropertyPreviewComponents/NameSection/NameSection.tsx
var import_lodash15 = require("lodash");
var import_styled_components122 = require("styled-components");
var import_react_i18next33 = require("react-i18next");
var import_dash_common35 = require("dash-common");
var import_react81 = require("react");
var import_jsx_runtime121 = require("react/jsx-runtime");
function NameSection({ property }) {
  const { t } = (0, import_react_i18next33.useTranslation)(["common", "pages", "forms"]);
  const theme = (0, import_styled_components122.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const {
    location,
    priceRange,
    marketArea,
    projectStatus,
    yearBuilt,
    averageBedroomsNumberValue,
    averageBathroomsNumberValue
  } = property;
  const isComingSoon = (0, import_react81.useMemo)(
    () => projectStatus === import_dash_common35.ProjectStatusesEnum.COMING_SOON,
    [property]
  );
  const isCompleted = (0, import_react81.useMemo)(
    () => projectStatus === import_dash_common35.ProjectStatusesEnum.COMPLETED,
    [property]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { flexDirection: "column", flex: 1, children: [
    /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { mt: 2, alignItems: "center", flexWrap: "wrap-reverse", children: [
      /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Box_default, { mr: 3, children: /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Text_default, { xl: true, bold: true, color: theme.colors.n90, children: property.name }) }),
      /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { mb: [1, 0, 0, 0], children: [
        isComingSoon && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Badge_default,
          {
            title: t("common:labels.comingSoon"),
            bgColor: theme.colors.setOpacity(theme.colors.b30, 70),
            titleColor: theme.colors.b50,
            mr: 3,
            square: true
          }
        ),
        projectStatus === "PROPOSED" && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Badge_default,
          {
            title: "Proposed",
            square: true,
            mr: 3,
            bgColor: theme.colors.setOpacity(theme.colors.b30, 70),
            titleColor: theme.colors.b50
          }
        ),
        property.transactionType && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Badge_default,
          {
            type: "neutralSolid",
            mr: 3,
            square: true,
            bgColor: theme.colors.setOpacity(theme.colors.b60, 70),
            title: t(
              `forms:labels.propertyTransactionTypes.${(0, import_lodash15.camelCase)(
                property.transactionType
              )}`
            )
          }
        ),
        marketArea && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Badge_default,
          {
            type: "neutralSolid",
            square: true,
            bgColor: theme.colors.setOpacity(theme.colors.b50, 70),
            title: marketArea?.name || ""
          }
        ),
        property.isMarkedAsVerified && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Badge_default,
          {
            type: "neutralSolid",
            ml: 3,
            square: true,
            bgColor: theme.colors.setOpacity(theme.colors.g20, 70),
            title: t("common:labels.developerVerified")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { w: "100%", alignItems: "center", mt: 2, flexWrap: "wrap", children: [
      !isComingSoon && /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(import_jsx_runtime121.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Text_default,
          {
            lg: true,
            color: theme.colors.n90,
            ellipsis: true,
            "data-tooltip-id": `price-${property._id}`,
            children: (0, import_dash_common35.formatPriceRange)(
              priceRange?.min || 0,
              priceRange?.max || 0,
              {
                shortMin: true,
                shortMax: true,
                prefix: t("common:labels:from") || ""
              },
              {
                maximumFractionDigits: 2
              }
            ) || t("common:labels:noValue")
          }
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Devider_default,
          {
            mx: 2,
            h: 10,
            size: 2,
            orientation: "vertical",
            color: theme.colors.n60
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Icon_default, { name: "bedroom", mr: 1, size: 24, color: theme.colors.n90 }),
          /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Text_default, { lg: true, ellipsis: true, "data-testid": "bedrooms", children: formatBedroomsRangeValues(averageBedroomsNumberValue, {
            isNullable: averageBedroomsNumberValue?.min === 0,
            t
          }) || t("common:labels:noValue") })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Devider_default,
          {
            mx: 2,
            h: 10,
            size: 2,
            orientation: "vertical",
            color: theme.colors.n60
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { alignItems: "center", children: [
          /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Icon_default, { name: "bathroom", mr: 1, size: 24, color: theme.colors.n80 }),
          /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Text_default, { lg: true, ellipsis: true, "data-testid": "bathrooms", children: formatBathroomsRangeValues(averageBathroomsNumberValue, {
            isNullable: averageBathroomsNumberValue?.min === 0,
            t
          }) || t("common:labels:noValue") })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Devider_default,
          {
            mx: 2,
            h: 10,
            size: 2,
            orientation: "vertical",
            color: theme.colors.n60
          }
        )
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Flex_default, { overflow: "hidden", alignItems: isMobile ? "flex-start" : "center", children: [
        /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Flex_default, { alignItems: "center", mt: [1, 0, 0, 0], children: /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Icon_default, { color: theme.colors.n90, name: "pin", mr: [1, 2, 2, 2] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(
          Text_default,
          {
            ellipsis: false,
            lg: true,
            color: theme.colors.n90,
            "data-testid": "address",
            children: location?.address ? (0, import_dash_common35.formatAddress)(location.address) : ""
          }
        )
      ] })
    ] }),
    projectStatus && /* @__PURE__ */ (0, import_jsx_runtime121.jsx)(Flex_default, { mt: 2, children: /* @__PURE__ */ (0, import_jsx_runtime121.jsxs)(Text_default, { color: theme.colors.n70, "data-testid": "project-status", children: [
      !isComingSoon && !isCompleted && t(`forms:labels:projectStatuses:${(0, import_lodash15.camelCase)(projectStatus)}`),
      yearBuilt ? isComingSoon || isCompleted ? t(
        `pages:propertyPage:${projectStatus === import_dash_common35.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
        {
          date: yearBuilt
        }
      ) : `, ${t(
        `pages:propertyPage:${projectStatus === import_dash_common35.ProjectStatusesEnum.NEW_CONSTRUCTION || isCompleted ? "completedIn" : "estCompletion"}`,
        {
          date: yearBuilt
        }
      )}` : ""
    ] }) })
  ] });
}
var NameSection_default = NameSection;

// src/components/molecules/PropertyPreviewComponents/PropertyNavigationTabs/PropertyNavigationTabs.tsx
var import_react82 = require("react");
var import_react_i18next34 = require("react-i18next");
var import_styled_components123 = __toESM(require("styled-components"));
var import_jsx_runtime122 = require("react/jsx-runtime");
var TabsWrapper = import_styled_components123.default.div`
  background-color: ${({ theme }) => theme.colors.n20};
  width: 100%;
  top: ${({ isViewAsClient, top }) => top ? `${top}px` : isViewAsClient ? "50px" : "107px"};
  position: sticky;
  margin-top: 12px;
  z-index: 3;
  background-color: transparent;
`;
var PropertyNavigationTabs = ({
  isViewAsClient,
  navigationElementsRefs,
  top
}) => {
  const { t } = (0, import_react_i18next34.useTranslation)(["common", "pages"]);
  const [activeTab, setActiveTab] = (0, import_react82.useState)("GENERAL" /* GENERAL */);
  const { devices } = useScreenResolution();
  const [generalInfoRef, additionalInfoRef, marketingFilesInfoRef] = navigationElementsRefs;
  const visibleElements = {
    ["GENERAL" /* GENERAL */]: useIsVisible(generalInfoRef, "-50px"),
    ["ADDITIONAL" /* ADDITIONAL */]: useIsVisible(additionalInfoRef, "-50px"),
    ["MARKETING" /* MARKETING */]: useIsVisible(marketingFilesInfoRef, "-50px")
  };
  const tabElementsRefs = {
    ["GENERAL" /* GENERAL */]: generalInfoRef,
    ["ADDITIONAL" /* ADDITIONAL */]: additionalInfoRef,
    ["MARKETING" /* MARKETING */]: marketingFilesInfoRef
  };
  const onTabClick = (tabKey) => {
    const targetElementOffsetTop = tabElementsRefs[tabKey]?.current?.offsetTop;
    if (targetElementOffsetTop) {
      window.scrollTo({
        top: targetElementOffsetTop - 180,
        behavior: "smooth"
      });
    }
  };
  (0, import_react82.useEffect)(() => {
    const firstVisibleKey = Object.keys(visibleElements).find(
      (key) => !!visibleElements[key]
    );
    if (firstVisibleKey) {
      setActiveTab(firstVisibleKey);
    }
  }, [visibleElements]);
  return /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(TabsWrapper, { isViewAsClient, top, children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
    Tabs_default,
    {
      w: "100%",
      isFullWidthTabs: true,
      variation: "primaryRounded",
      tabs: [
        {
          key: "GENERAL" /* GENERAL */,
          label: t`pages:propertyPreviewPage:generalTabLabel`
        },
        {
          key: "ADDITIONAL" /* ADDITIONAL */,
          label: devices.isMobile ? t`pages:propertyPreviewPage:additionalInformationShort` || "" : t`pages:propertyPreviewPage:additionalTabLabel` || ""
        },
        ...isViewAsClient ? [] : [
          {
            key: "MARKETING" /* MARKETING */,
            label: t`pages:propertyPreviewPage:marketingTabLabel`
          }
        ]
      ],
      activeTab,
      onClick: onTabClick
    }
  ) });
};
var PropertyNavigationTabs_default = PropertyNavigationTabs;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.tsx
var import_react86 = require("react");
var import_styled_components128 = __toESM(require("styled-components"));
var import_react_i18next37 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryCard.tsx
var import_react_i18next36 = require("react-i18next");
var import_styled_components125 = __toESM(require("styled-components"));
var import_dash_common36 = require("dash-common");

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/components/UnitInventoryRow.tsx
var import_lodash16 = require("lodash");
var import_styled_components124 = require("styled-components");
var import_react_i18next35 = require("react-i18next");
var import_react83 = require("react");
var import_jsx_runtime123 = require("react/jsx-runtime");
var UnitInventoryRow = ({ unit }) => {
  const theme = (0, import_styled_components124.useTheme)();
  const { t: tDefault } = (0, import_react_i18next35.useTranslation)();
  const {
    averageBedroomsNumber,
    averageBathroomsNumber,
    averageTotalSqft,
    averageInteriorSqft,
    averageExteriorSqft
  } = unit;
  const { hasBeds, hasBaths } = (0, import_react83.useMemo)(() => {
    return {
      hasBeds: !!((0, import_lodash16.isNumber)(averageBedroomsNumber?.min) || (0, import_lodash16.isNumber)(averageBedroomsNumber?.max)),
      hasBaths: !!(averageBathroomsNumber?.min || averageBathroomsNumber?.max),
      hasInterior: !!(averageInteriorSqft?.min || averageInteriorSqft?.max),
      hasExterior: !!(averageExteriorSqft?.min || averageExteriorSqft?.max),
      hasTotal: !!(averageTotalSqft?.min || averageTotalSqft?.max)
    };
  }, [unit]);
  return /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(Flex_default, { alignItems: "center", children: [
    hasBeds && /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(
      TooltipWrapper_default,
      {
        content: formatBedroomsRangeValues(averageBedroomsNumber, {
          isNullable: (averageBedroomsNumber?.min || 0) === 0 && !averageBedroomsNumber?.max,
          t: tDefault
        }),
        children: /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(
          Flex_default,
          {
            alignItems: "center",
            overflow: "hidden",
            "data-tooltip-id": `${unit._id}-bedrooms`,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Icon_default, { name: "bedroom", size: 24, mr: 1, color: theme.colors.n80 }) }),
              /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Text_default, { smplus: true, semibold: true, children: formatBedroomsRangeValues(averageBedroomsNumber, {
                isNullable: (averageBedroomsNumber?.min || 0) === 0 && !averageBedroomsNumber?.max,
                t: tDefault
              }) })
            ]
          }
        )
      }
    ),
    hasBaths && /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(import_jsx_runtime123.Fragment, { children: [
      hasBeds && /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Devider_default, { orientation: "vertical", h: 16, mx: 2, color: theme.colors.n50 }),
      " ",
      /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(
        TooltipWrapper_default,
        {
          content: formatBathroomsRangeValues(averageBathroomsNumber, {
            t: tDefault
          }),
          children: /* @__PURE__ */ (0, import_jsx_runtime123.jsxs)(
            Flex_default,
            {
              alignItems: "center",
              overflow: "hidden",
              "data-tooltip-id": `${unit._id}-bathrooms`,
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Icon_default, { name: "bathroom", size: 24, mr: 1, color: theme.colors.n80 }) }),
                /* @__PURE__ */ (0, import_jsx_runtime123.jsx)(Text_default, { smplus: true, semibold: true, children: formatBathroomsRangeValues(averageBathroomsNumber, {
                  t: tDefault
                }) })
              ]
            }
          )
        }
      )
    ] })
  ] });
};
var UnitInventoryRow_default = UnitInventoryRow;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/components/InventoryCard.tsx
var import_react84 = require("react");
var import_jsx_runtime124 = require("react/jsx-runtime");
var CardWrapper = (0, import_styled_components125.default)(Box_default)`
  p,
  button {
    white-space: nowrap;
  }
`;
var BorderContainer = (0, import_styled_components125.default)(Flex_default)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  width: 100%;
`;
var ViewButton = (0, import_styled_components125.default)(Button_default)`
  text-underline-offset: ${({ theme }) => theme.space * 2}px;
`;
var ImageWrapper2 = (0, import_styled_components125.default)(Box_default)`
  left: 0;
  background-color: ${({ theme }) => theme.colors.white};
`;
var InventoryCard = ({
  unit,
  onViewButtonClick
}) => {
  const theme = (0, import_styled_components125.useTheme)();
  const { t } = (0, import_react_i18next36.useTranslation)("tables", {
    keyPrefix: "inventory"
  });
  const { t: tLabels } = (0, import_react_i18next36.useTranslation)("common", {
    keyPrefix: "labels"
  });
  const { t: tDefault } = (0, import_react_i18next36.useTranslation)();
  const {
    devices: { isLaptop }
  } = useScreenResolution();
  const {
    name,
    type,
    startingPrice,
    highestPrice,
    floorPlanFile,
    customRooms,
    ...rest
  } = unit;
  const { averageTotalSqft, averageExteriorSqft, averageInteriorSqft } = rest;
  const hasTotal = (0, import_react84.useMemo)(
    () => !!(averageTotalSqft?.min || averageTotalSqft?.max),
    [unit]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(CardWrapper, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(BorderContainer, { alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(ImageWrapper2, { p: 3, minWidth: 88, children: floorPlanFile && floorPlanFile.thumbnailFileUrl ? /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Image_default, { src: floorPlanFile.thumbnailFileUrl, size: 88 }) : /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(DashPlaceholder_default, { size: 88 }) }),
    /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(
      Flex_default,
      {
        w: "100%",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Flex_default, { flexDirection: "column", py: 3, children: [
            /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Text_default, { lg: true, semibold: true, children: name }),
            /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Text_default, { lg: true, semibold: true, children: type }),
            /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Flex_default, { mt: 1, children: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(UnitInventoryRow_default, { unit: rest }) }),
            /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Flex_default, { alignItems: "center", children: [
              (startingPrice || highestPrice) && /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Flex_default, { children: [
                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { mr: 1.5, children: /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Text_default, { smplus: true, color: theme.colors.n70, children: [
                  t`lastListedFromShortened`,
                  ":"
                ] }) }),
                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                  TooltipWrapper_default,
                  {
                    content: (0, import_dash_common36.formatPriceRange)(startingPrice, highestPrice, {
                      shortMax: false,
                      shortMin: false,
                      prefix: tLabels("from") || ""
                    }),
                    children: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                      Box_default,
                      {
                        maxWidth: isLaptop ? 106 : 180,
                        "data-tooltip-id": `price-${unit._id}`,
                        children: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Text_default, { smplus: true, semibold: true, ellipsis: true, children: (0, import_dash_common36.formatPriceRange)(
                          startingPrice,
                          highestPrice,
                          {
                            shortMin: true,
                            shortMax: true,
                            prefix: tLabels("from") || ""
                          },
                          {
                            maximumFractionDigits: 2
                          }
                        ) })
                      }
                    )
                  }
                )
              ] }),
              customRooms && /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(import_jsx_runtime124.Fragment, { children: [
                (startingPrice || highestPrice) && /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                  Devider_default,
                  {
                    orientation: "vertical",
                    h: 16,
                    mx: 2,
                    color: theme.colors.n50
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Flex_default, { children: [
                  /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { mr: 1.5, children: /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Text_default, { smplus: true, color: theme.colors.n70, children: [
                    t`customRoomsShortened`,
                    ":"
                  ] }) }),
                  /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(TooltipWrapper_default, { content: customRooms, children: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                    Box_default,
                    {
                      maxWidth: !(startingPrice || highestPrice) ? 150 : isLaptop ? 70 : 95,
                      "data-tooltip-id": `customRooms-${unit._id}`,
                      children: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Text_default, { smplus: true, semibold: true, ellipsis: true, children: customRooms })
                    }
                  ) })
                ] })
              ] }),
              hasTotal && /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(import_jsx_runtime124.Fragment, { children: [
                (customRooms || startingPrice || highestPrice) && /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                  Devider_default,
                  {
                    orientation: "vertical",
                    h: 16,
                    mx: 2,
                    color: theme.colors.n50
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                  TooltipWrapper_default,
                  {
                    py: 0,
                    content: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { minWidth: "fit-content", w: "100%", px: 2, children: /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(
                      Flex_default,
                      {
                        minWidth: "fit-content",
                        flexDirection: "column",
                        w: "100%",
                        children: [
                          /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(
                            Flex_default,
                            {
                              minWidth: "fit-content",
                              justifyContent: "space-between",
                              w: "100%",
                              children: [
                                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                                  Text_default,
                                  {
                                    color: theme.colors.white,
                                    whiteSpace: "nowrap",
                                    children: "Int. SQFT:"
                                  }
                                ),
                                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { mx: 1 }),
                                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                                  Text_default,
                                  {
                                    color: theme.colors.white,
                                    whiteSpace: "nowrap",
                                    children: formatGeneralRangeValues(averageInteriorSqft)
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(
                            Flex_default,
                            {
                              color: theme.colors.white,
                              justifyContent: "space-between",
                              w: "100%",
                              children: [
                                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                                  Text_default,
                                  {
                                    color: theme.colors.white,
                                    whiteSpace: "nowrap",
                                    children: "Ext. SQFT:"
                                  }
                                ),
                                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { mx: 1 }),
                                /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                                  Text_default,
                                  {
                                    color: theme.colors.white,
                                    whiteSpace: "nowrap",
                                    children: formatGeneralRangeValues(averageExteriorSqft)
                                  }
                                )
                              ]
                            }
                          ),
                          /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Flex_default, { justifyContent: "space-between", w: "100%", children: [
                            /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                              Text_default,
                              {
                                color: theme.colors.white,
                                whiteSpace: "nowrap",
                                children: "Total. SQFT:"
                              }
                            ),
                            /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { mx: 1 }),
                            /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                              Text_default,
                              {
                                color: theme.colors.white,
                                whiteSpace: "nowrap",
                                children: formatGeneralRangeValues(averageTotalSqft)
                              }
                            )
                          ] })
                        ]
                      }
                    ) }),
                    children: /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Flex_default, { "data-tooltip-id": `totalSqft-${unit._id}`, children: [
                      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Box_default, { mr: 2, children: /* @__PURE__ */ (0, import_jsx_runtime124.jsxs)(Text_default, { smplus: true, color: theme.colors.n70, children: [
                        t`totalSqft`.toUpperCase(),
                        ":"
                      ] }) }),
                      /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
                        Box_default,
                        {
                          maxWidth: !(customRooms && (startingPrice || highestPrice)) ? 120 : isLaptop ? 90 : 96,
                          overflow: "hidden",
                          children: /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(Text_default, { smplus: true, semibold: true, ellipsis: true, children: formatGeneralRangeValues(averageTotalSqft, {
                            t: tDefault
                          }) })
                        }
                      )
                    ] })
                  }
                )
              ] })
            ] })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime124.jsx)(
            ViewButton,
            {
              mr: 3,
              mb: 3,
              ml: 3,
              medium: true,
              md: true,
              lg: true,
              semibold: true,
              variation: "outline",
              disabled: !floorPlanFile,
              onClick: onViewButtonClick,
              children: tLabels`view`
            }
          )
        ]
      }
    )
  ] }) });
};
var InventoryCard_default = InventoryCard;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.styles.ts
var import_styled_components127 = __toESM(require("styled-components"));

// src/components/organisms/ListWithPagination/ListWithPagination.tsx
var import_react85 = require("react");
var import_styled_components126 = __toESM(require("styled-components"));
var import_jsx_runtime125 = require("react/jsx-runtime");
var Wrapper = (0, import_styled_components126.default)(Flex_default)`
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  padding-bottom: 8px;
`;
var ListWithPagination = ({
  listProps,
  paginationProps,
  children,
  ...args
}) => {
  const theme = (0, import_styled_components126.useTheme)();
  const { data, loading } = listProps;
  const { state, goToPage, setTotal } = (0, import_react85.useContext)(PaginationContext);
  (0, import_react85.useEffect)(() => {
    if (!data.length && !loading && state.currentPage >= 1) {
      goToPage(state.currentPage - 1);
      setTotal(state.perPage * (state.currentPage - 1));
    }
  }, [data, state, loading]);
  return /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(Wrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(List_default, { ...listProps, children }) }),
    /* @__PURE__ */ (0, import_jsx_runtime125.jsxs)(
      Flex_default,
      {
        flex: 1,
        w: "100%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        px: 8,
        children: [
          paginationProps.label && /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(Flex_default, { my: 4, children: /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
            PaginationInfoLabel,
            {
              label: paginationProps.label || "",
              color: theme.colors.n70
            }
          ) }),
          data.length ? /* @__PURE__ */ (0, import_jsx_runtime125.jsx)(
            Pagination_default,
            {
              my: 4,
              previousButtonLabel: paginationProps.previousButtonLabel,
              nextButtonLabel: paginationProps.nextButtonLabel,
              paginationAction: paginationProps.paginationAction
            }
          ) : null
        ]
      }
    )
  ] });
};
var ListWithPagination_default = ListWithPagination;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.styles.ts
var containerStyles = import_styled_components127.css`
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
`;
var StyledList = (0, import_styled_components127.default)(ListWithPagination_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  box-shadow: ${({ theme }) => theme.shadows.shadow1};
  display: grid;
  grid-template-columns: 1fr;

  & > div:first-child {
    border-bottom: none;
    padding-bottom: 0;
    overflow: auto;
  }

  & > div:last-child {
    padding: 0 ${({ theme }) => theme.space * 3}px;
  }
`;
var StyledCard2 = (0, import_styled_components127.default)(Flex_default)`
  ${containerStyles}
`;

// src/components/molecules/PropertyPreviewComponents/InventoryTable/InventoryTable.tsx
var import_dash_common37 = require("dash-common");
var import_jsx_runtime126 = require("react/jsx-runtime");
var StyledTabs = (0, import_styled_components128.default)(Tabs_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
`;
var InventoryTable = ({
  data,
  loading,
  emptyStateText,
  onViewButtonClick,
  onDownloadButtonClick,
  isPortfolioView,
  isRent,
  ...props
}) => {
  const theme = (0, import_styled_components128.useTheme)();
  const { setSortState } = (0, import_react86.useContext)(SortContext);
  const [fileToPreview, setFileToPreview] = (0, import_react86.useState)(
    null
  );
  const { t } = (0, import_react_i18next37.useTranslation)("tables", {
    keyPrefix: "inventory"
  });
  const { activeTab, setActiveTab } = (0, import_react86.useContext)(InventorySectionContext);
  const { resetPagination } = (0, import_react86.useContext)(PaginationContext);
  const { t: tLabels } = (0, import_react_i18next37.useTranslation)("common", { keyPrefix: "labels" });
  const { t: tForms } = (0, import_react_i18next37.useTranslation)("forms");
  const setSort = (fieldName, sortOrder) => () => {
    setSortState({ sortOrder, fieldName });
  };
  const InventoryComponent = (0, import_react86.useMemo)(
    () => ({ inventories }) => inventories.length ? /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
      StyledList,
      {
        listProps: { data: inventories, loading, flexDirection: "column" },
        paginationProps: {
          label: t`paginationLabel` || "",
          previousButtonLabel: tLabels`previous`,
          nextButtonLabel: tLabels`next`
        },
        children: (unit) => /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
          InventoryCard_default,
          {
            unit,
            onViewButtonClick: () => {
              setFileToPreview(unit.floorPlanFile);
              if (onViewButtonClick) {
                onViewButtonClick();
              }
            }
          }
        )
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(
      StyledCard2,
      {
        minHeight: 198,
        w: "100%",
        justifyContent: "center",
        alignItems: "center",
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
            Icon_default,
            {
              name: "building",
              size: 48,
              color: theme.colors.setOpacity(theme.colors.b50, 20),
              mr: 6.5
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Box_default, { maxWidth: 360, children: /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
            "p",
            {
              className: "prose",
              style: { color: theme.colors.n80 },
              dangerouslySetInnerHTML: { __html: emptyStateText ?? "" }
            }
          ) })
        ]
      }
    ),
    [data]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(Box_default, { ...props, pos: "relative", w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(Flex_default, { justifyContent: "space-between", w: "100%", alignItems: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Text_default, { semibold: true, xl: true, children: tLabels`inventory` }),
      /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
        DropDown_default,
        {
          placementHorizontal: "left",
          Anchor: ({ isOpen }) => /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
            Button_default,
            {
              p: 0,
              variation: "flat",
              iconRight: isOpen ? "arrowUp" : "arrowDown",
              iconRightProps: { size: 24 },
              children: tLabels`sortBy`
            }
          ),
          items: [
            {
              children: t`recent`,
              key: "recent",
              contentCentered: false,
              w: 250,
              onClick: setSort("createdAt", -1)
            },
            {
              children: t`priceDown`,
              key: "priceDown",
              contentCentered: false,
              w: 250,
              onClick: setSort("startingPrice", -1)
            },
            {
              children: t`priceUp`,
              key: "priceUp",
              contentCentered: false,
              w: 250,
              onClick: setSort("startingPrice", 1)
            }
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime126.jsxs)(Box_default, { w: "100%", mt: 1.5, children: [
      /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
        StyledTabs,
        {
          variation: "secondary",
          tabs: [
            {
              key: import_dash_common37.InventoryTypeEnum.MODEL,
              label: import_dash_common37.mapInventoryTypeToLabel[import_dash_common37.InventoryTypeEnum.MODEL]
            },
            {
              key: import_dash_common37.InventoryTypeEnum.FOR_SALE,
              label: isRent ? tForms("labels.propertyTransactionTypes.forRent") : import_dash_common37.mapInventoryTypeToLabel[import_dash_common37.InventoryTypeEnum.FOR_SALE]
            }
          ],
          activeTab,
          onClick: (tab) => {
            setActiveTab(tab);
            resetPagination();
          },
          w: "100%"
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(InventoryComponent, { inventories: data })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime126.jsx)(
      FilePreviewModal_default,
      {
        isOpened: Boolean(fileToPreview),
        onClose: () => setFileToPreview(null),
        files: fileToPreview ? [fileToPreview] : [],
        defaultIndex: 0,
        isPortfolioView,
        onDownloadButtonClick: () => {
          if (onDownloadButtonClick) {
            onDownloadButtonClick();
          } else if (fileToPreview) {
            downloadFile([fileToPreview?._id]);
          }
        },
        isDownloadButtonVisible: props.allowDownloads
      }
    )
  ] });
};
var InventoryTable_default = InventoryTable;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.tsx
var import_dash_common40 = require("dash-common");
var import_react89 = require("react");
var import_styled_components136 = require("styled-components");
var import_react_i18next39 = require("react-i18next");

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/MediaFileCard/MediaFileCard.tsx
var import_moment7 = __toESM(require("moment"));
var import_react_i18next38 = require("react-i18next");
var import_react88 = require("react");
var import_styled_components132 = require("styled-components");
var import_dash_common39 = require("dash-common");

// src/components/organisms/SlideshowPreview/components/Thumbnail/Thumbnail.tsx
var import_dash_common38 = require("dash-common");
var import_styled_components130 = require("styled-components");

// src/components/organisms/SlideshowPreview/components/Thumbnail/Thumbnail.styles.ts
var import_styled_components129 = __toESM(require("styled-components"));
var import_isNumber = __toESM(require("lodash/isNumber"));
var ThumbnailWrapper = (0, import_styled_components129.default)(Box_default)`
  position: relative;
  overflow: hidden;
  height: 100%;
  width: 100%;
  cursor: pointer;
`;
var StyledImage2 = (0, import_styled_components129.default)(Image_default)`
  height: 100%;
  width: 100%;
  border-top-left-radius: ${({ theme }) => theme.space}px;
  border-top-right-radius: ${({ theme }) => theme.space}px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  ${({ borderRadius }) => (0, import_isNumber.default)(borderRadius) && `border-radius: ${borderRadius}px`};
`;
var BackGroundMask = (0, import_styled_components129.default)(Flex_default)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.b50, 60)};
  width: inherit;
  height: inherit;
  top: 0;
`;
var TextMaskMobile = (0, import_styled_components129.default)(Flex_default)`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.setOpacity(theme.colors.n90, 60)};
  border-radius: ${({ theme }) => theme.space}px;
  bottom: ${({ theme }) => theme.space * 4}px;
  right: ${({ theme }) => theme.space * 4}px;
`;

// src/components/organisms/SlideshowPreview/components/Thumbnail/Thumbnail.tsx
var import_jsx_runtime127 = require("react/jsx-runtime");
var Thumbnail = ({
  file,
  label,
  totalCount,
  placeholderProps,
  borderRadius,
  imagePlaceholder,
  ...args
}) => {
  const theme = (0, import_styled_components130.useTheme)();
  const isVideo = file && import_dash_common38.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isImage = file && (import_dash_common38.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type) || file.type === import_dash_common38.ALLOWED_MEDIA_TYPE_MIMES.pdf);
  const ViewComponent2 = () => {
    if (isVideo) {
      return /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(Video_default, { src: file.thumbnailFileUrl || file.publicUrl });
    }
    if (isImage) {
      if (!file.thumbnailFileUrl) {
        return imagePlaceholder || /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(FileTypeIcon_default, { file, lg: true });
      }
      return /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(
        StyledImage2,
        {
          src: file.thumbnailFileUrl || file.publicUrl,
          alt: file.name,
          borderRadius
        }
      );
    }
    return imagePlaceholder || /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(FileTypeIcon_default, { file, lg: true });
  };
  return file ? /* @__PURE__ */ (0, import_jsx_runtime127.jsxs)(ThumbnailWrapper, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", w: "100%", h: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(ViewComponent2, {}) }),
    label && /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(BackGroundMask, { alignItems: "center", justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(H_default, { lg: true, semibold: true, color: theme.colors.white, children: label }) }),
    totalCount && /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(TextMaskMobile, { py: 1, px: 2, children: /* @__PURE__ */ (0, import_jsx_runtime127.jsxs)(Text_default, { semibold: true, color: theme.colors.white, children: [
      "1/",
      totalCount
    ] }) })
  ] }) : /* @__PURE__ */ (0, import_jsx_runtime127.jsx)(DashPlaceholder_default, { variation: "secondary", w: "100%", h: "100%", ...placeholderProps });
};
var Thumbnail_default = Thumbnail;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.context.tsx
var import_react87 = require("react");
var import_jsx_runtime128 = require("react/jsx-runtime");
var MarketingFilesContext = (0, import_react87.createContext)({
  selected: {},
  setSelected: () => null
});
var MarketingFilesProvider = ({ children }) => {
  const [selected, setSelected] = (0, import_react87.useState)({});
  return /* @__PURE__ */ (0, import_jsx_runtime128.jsx)(MarketingFilesContext.Provider, { value: { selected, setSelected }, children });
};

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/MediaFileCard/MediaFileCard.styles.ts
var import_styled_components131 = __toESM(require("styled-components"));
var MediaFileCardWrapper = (0, import_styled_components131.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.n30};
  cursor: pointer;

  :hover {
    & > div:first-child > div:first-child {
      display: block;
    }
  }
`;
var CheckboxWrapper2 = (0, import_styled_components131.default)(Box_default)`
  top: 5px;
  left: 5px;
  z-index: 2;
  display: ${({ isSelected, isList }) => isSelected || isList ? "block" : "none"};

  @media ${({ theme }) => theme.devices.mobile} {
    display: block;
  }
`;
var ThumbnailWrapper2 = (0, import_styled_components131.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.b10};
  ${({ isBorder, theme }) => isBorder ? `border: 1px solid ${theme.colors.n30}` : `border-bottom: 1px solid ${theme.colors.n30}`};
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/components/MediaFileCard/MediaFileCard.tsx
var import_jsx_runtime129 = require("react/jsx-runtime");
var MediaFileCard = ({
  file,
  isList,
  onClick,
  isMediaKit,
  compact = false,
  addToMediaKit,
  removeFromMediaKit,
  index: index2
}) => {
  const theme = (0, import_styled_components132.useTheme)();
  const { t } = (0, import_react_i18next38.useTranslation)();
  const { selected, setSelected } = (0, import_react88.useContext)(MarketingFilesContext);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const onSelectItem = (0, import_react88.useCallback)(
    (value) => {
      setSelected((previous) => ({ ...previous, [file._id]: value }));
    },
    [setSelected]
  );
  const containerOptions = isList ? { w: "unset", mr: !compact ? 4 : 0, ml: [3, 0, 0, 0] } : { mt: 1, px: 3, pb: 4, w: "100%" };
  return /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(
    MediaFileCardWrapper,
    {
      onClick,
      flexDirection: isList ? "row" : "column",
      w: "100%",
      justifyContent: "space-between",
      alignItems: "center",
      pos: "relative",
      ...isMobile && { flexWrap: "wrap" },
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(
          Flex_default,
          {
            flexDirection: isList ? "row" : "column",
            alignItems: isList ? "center" : "flex-start",
            w: "100%",
            children: [
              !isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                CheckboxWrapper2,
                {
                  isList,
                  isSelected: selected[file._id],
                  pos: isList ? "static" : "absolute",
                  mx: isList ? 1 : 0,
                  children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Checkbox_default, { onChange: onSelectItem, checked: selected[file._id] })
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                ThumbnailWrapper2,
                {
                  isBorder: !import_dash_common39.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type),
                  alignItems: "center",
                  justifyContent: "center",
                  w: isList ? 56 : "100%",
                  h: isList ? 56 : 170,
                  children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                    Thumbnail_default,
                    {
                      file,
                      ...isList && {
                        borderRadius: 0,
                        imagePlaceholder: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Icon_default, { name: "filePlaceholder", size: 45, color: theme.colors.n20 })
                      }
                    }
                  )
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                TooltipWrapper_default,
                {
                  content: file.name,
                  placement: compact && index2 === 0 ? "bottom" : "top",
                  children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Box_default, { style: { display: "grid" }, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Box_default, { px: 3, mb: 1, mt: 1.5, w: "100%", overflow: "hidden", children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Text_default, { lg: !compact, semibold: true, ellipsis: true, children: file.name }) }) })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime129.jsxs)(
          Flex_default,
          {
            alignItems: "center",
            mt: [2, 0, 0, 0],
            justifyContent: "space-between",
            flexWrap: "wrap",
            ...containerOptions,
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Text_default, { sm: compact, whiteSpace: "nowrap", color: theme.colors.n70, children: (0, import_moment7.default)(file.createdAt).format(import_dash_common39.DATE_FORMAT) }),
              /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                Flex_default,
                {
                  minWidth: isList && !compact ? 100 : 0,
                  justifyContent: "flex-end",
                  mr: isMediaKit ? 3 : 0,
                  children: /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(Text_default, { sm: compact, whiteSpace: "nowrap", color: theme.colors.n70, children: (0, import_dash_common39.bytesToMBytes)(file.size) > 1 ? t("common:labels.mBytes", {
                    size: (0, import_dash_common39.bytesToMBytes)(file.size)
                  }) : t("common:labels.kBytes", {
                    size: (0, import_dash_common39.bytesToKBytes)(file.size)
                  }) })
                }
              ),
              isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(import_jsx_runtime129.Fragment, { children: file.isAddedToMediaKit ? /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                Button_default,
                {
                  variation: "flat",
                  icon: "fillTrash",
                  whiteSpace: "nowrap",
                  type: "button",
                  colorVariation: "danger",
                  onClick: (event) => {
                    event.stopPropagation();
                    if (file.isAddedToMediaKit && removeFromMediaKit) {
                      return removeFromMediaKit({ ...file, isAddedToMediaKit: false });
                    }
                  },
                  children: t("common:labels.delete")
                }
              ) : /* @__PURE__ */ (0, import_jsx_runtime129.jsx)(
                Button_default,
                {
                  variation: "flat",
                  icon: file.isCurrentItemAdded ? "check" : "addCircleOutline",
                  whiteSpace: "nowrap",
                  type: "button",
                  colorVariation: file.isCurrentItemAdded ? "success" : "default",
                  onClick: (event) => {
                    event.stopPropagation();
                    if (addToMediaKit) {
                      return addToMediaKit({ ...file, isAddedToMediaKit: true });
                    }
                  },
                  children: file.isCurrentItemAdded ? t("pages:mediaKit.added") : t("pages:mediaKit.addToMedia")
                }
              ) })
            ]
          }
        )
      ]
    }
  );
};
var MediaFileCard_default = MediaFileCard;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.styles.ts
var import_styled_components133 = __toESM(require("styled-components"));
var TabsWrapper2 = (0, import_styled_components133.default)(Flex_default)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
`;
var MediaListWrapper = import_styled_components133.default.div`
  width: 100%;
  height: ${({ compact }) => compact && "198px"};
  overflow-y: ${({ compact }) => compact && "scroll"};
  height: 250px;
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MediaFilesViewButton/MediaFilesViewButton.tsx
var import_styled_components135 = require("styled-components");

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MediaFilesViewButton/MediaFilesViewButton.styles.ts
var import_styled_components134 = __toESM(require("styled-components"));
var SwitchButton = (0, import_styled_components134.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space}px;
  border: 1px solid ${({ theme }) => theme.colors.b20};
`;
var StyledButton5 = (0, import_styled_components134.default)(Flex_default)`
  background-color: ${({ theme, isActive }) => isActive ? theme.colors.b20 : theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  cursor: pointer;
`;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MediaFilesViewButton/MediaFilesViewButton.tsx
var import_jsx_runtime130 = require("react/jsx-runtime");
var MediaFilesViewButton = ({
  setButtonType,
  isCard,
  isList
}) => {
  const theme = (0, import_styled_components135.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime130.jsxs)(SwitchButton, { ml: 6, children: [
    /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
      StyledButton5,
      {
        alignItems: "center",
        justifyContent: "center",
        isActive: isCard,
        onClick: () => setButtonType("Card" /* Card */),
        w: 32,
        h: 32,
        children: /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Icon_default, { name: "dashboard", color: isCard ? theme.colors.b50 : theme.colors.b40, size: 24 })
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(
      StyledButton5,
      {
        alignItems: "center",
        justifyContent: "center",
        w: 32,
        h: 32,
        isActive: isList,
        onClick: () => setButtonType("List" /* List */),
        children: /* @__PURE__ */ (0, import_jsx_runtime130.jsx)(Icon_default, { name: "list", color: isList ? theme.colors.b50 : theme.colors.b40, size: 24 })
      }
    )
  ] });
};
var MediaFilesViewButton_default = MediaFilesViewButton;

// src/components/molecules/PropertyPreviewComponents/MarketingFiles/MarketingFiles.tsx
var import_jsx_runtime131 = require("react/jsx-runtime");
var MarketingFiles = ({
  tabs,
  files,
  folders = [],
  activeTab,
  setActiveTab,
  onDownloadClick,
  fetchMoreProps,
  loading,
  isMediaKit,
  compactMediaList = false,
  addToMediaKit,
  removeFromMediaKit,
  isPortfolioView = false,
  allowDownloads = true
}) => {
  const theme = (0, import_styled_components136.useTheme)();
  const { t } = (0, import_react_i18next39.useTranslation)();
  const { setUpgradeSubscriptionModal } = (0, import_react89.useContext)(ModalContext);
  const [fileIdToPreview, setFileIdToPreview] = (0, import_react89.useState)(-1);
  const { selected, setSelected } = (0, import_react89.useContext)(MarketingFilesContext);
  const [buttonType, setButtonType] = (0, import_react89.useState)(isMediaKit ? "List" /* List */ : "Card" /* Card */);
  const { setFilterState, state: filterState } = (0, import_react89.useContext)(FilterContext);
  const isList = buttonType === "List" /* List */;
  const isCard = buttonType === "Card" /* Card */;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const { checkFeatureAccess } = useCheckIfSubscriptionFeatureActiveBroker([
    import_dash_common40.DashFeaturesEnum.DOWNLOAD_UNBRANDED_CONTENT
  ]);
  const listOptions = (0, import_react89.useMemo)(() => {
    if (isMobile) {
      return { w: "100%", flexWrap: "wrap", flexDirection: "row", overflow: "auto", maxHeight: "100%" };
    }
    if (isList) {
      return { flexDirection: "column", h: "100%", overflow: "auto" };
    }
    return { grid: 184, overflow: "auto", maxHeight: "100%" };
  }, [isMobile, isList]);
  const onSelectAll = (0, import_react89.useCallback)(
    (value) => {
      setSelected(files.reduce((obj, item) => ({ ...obj, [item._id]: value }), {}));
    },
    [files, setSelected]
  );
  const totalSelected = (0, import_react89.useMemo)(
    () => Object.values(selected).filter((value) => value).length,
    [selected]
  );
  const tabsFolders = (0, import_react89.useMemo)(
    () => tabs.map(
      (item) => item.label === import_dash_common40.DEFAULT_ROOT_MEDIA_FOLDER_NAME ? { ...item, label: import_dash_common40.RESERVED_MEDIA_FOLDER_NAME } : item
    ),
    [tabs]
  );
  const setFolderIds = (folderId) => {
    setFilterState("foldersIds", handleNestedFolderSelection(folderId));
  };
  const handleNestedFolderSelection = (folderId) => {
    const foldersIds = filterState.foldersIds || [];
    const isActive = foldersIds.includes(folderId);
    if (isActive) {
      let idsToUncheck = [folderId];
      folders?.forEach((folder) => {
        const { parentMediaFoldersIds } = folder;
        if (parentMediaFoldersIds.includes(folderId))
          idsToUncheck.push(folder._id);
      });
      return foldersIds.filter((id2) => !idsToUncheck.includes(id2));
    } else {
      const folder = folders.find(({ _id }) => _id === folderId);
      if (!folder)
        return [...foldersIds, folderId];
      const { parentMediaFoldersIds } = folder;
      let newSelectedFolders = [...foldersIds, folderId];
      parentMediaFoldersIds?.forEach((parentId) => {
        if (folders.find((folder2) => folder2._id === parentId))
          newSelectedFolders.push(parentId);
      });
      folders?.forEach((folder2) => {
        const { parentMediaFoldersIds: parentMediaFoldersIds2 } = folder2;
        if (parentMediaFoldersIds2.includes(folderId))
          newSelectedFolders.push(folder2._id);
      });
      return newSelectedFolders;
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(Box_default, { pos: "relative", w: "100%", children: [
    !isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(import_jsx_runtime131.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Text_default, { semibold: true, xl: true, children: t("pages:propertyPreviewPage.marketingFilesLabel") }),
      /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Box_default, { maxWidth: 500, mt: 0.5, children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Text_default, { children: t("pages:propertyPreviewPage.marketingFilesSecondLabel") }) })
    ] }),
    !isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(
      Card_default,
      {
        mt: 4.5,
        mb: 3,
        p: 3,
        shadow: theme.shadows.shadow1,
        borderRadius: theme.space,
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          !isMobile && /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(Flex_default, { alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Checkbox_default, { size: 18, checked: totalSelected > 0, mr: 2, onChange: onSelectAll }),
            /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Text_default, { children: t("tables:marketingFiles:filesSelectedLabel", {
              totalCount: totalSelected
            }) })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
            Button_default,
            {
              w: ["100%", "unset", "unset", "unset"],
              variation: "outline",
              icon: "download",
              medium: true,
              onClick: () => {
                setUpgradeSubscriptionModal({ type: "DOWNLOAD" /* DOWNLOAD */ });
                const isActive = checkFeatureAccess({ disableModal: isPortfolioView });
                if ((0, import_dash_common40.nor)(isActive, isPortfolioView))
                  return;
                if (onDownloadClick) {
                  onDownloadClick(selected);
                }
              },
              disabled: !allowDownloads,
              children: totalSelected > 0 ? t("tables:marketingFiles:downloadSelectedLabel") : t("tables:marketingFiles:downloadAllLabel")
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(
      Card_default,
      {
        p: isMediaKit ? 0 : 4.5,
        shadow: isMediaKit ? "none" : theme.shadows.shadow1,
        borderRadius: theme.space,
        flexDirection: "column",
        w: "100%",
        children: [
          isMobile && /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", mb: 4, w: "100%", children: [
            /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(Flex_default, { alignItems: "center", children: [
              /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Checkbox_default, { size: 18, checked: totalSelected > 0, mr: 2, onChange: onSelectAll }),
              /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Text_default, { children: t("tables:marketingFiles:filesSelectedLabel", {
                totalCount: totalSelected
              }) })
            ] }),
            /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(MediaFilesViewButton_default, { setButtonType, isCard, isList })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { w: "100%", maxWidth: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime131.jsxs)(TabsWrapper2, { justifyContent: "space-between", w: "100%", alignItems: "center", children: [
            /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
              Tabs_default,
              {
                withScrollButtons: true,
                activeTab: activeTab || (tabs.length > 0 ? tabs[0].key : ""),
                tabs: tabsFolders,
                onClick: (tab) => {
                  setFilterState("foldersIds", []);
                  setActiveTab(tab);
                },
                variation: "secondary",
                activeButtonColor: theme.colors.b50
              }
            ),
            !isMobile && !isMediaKit && /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(MediaFilesViewButton_default, { setButtonType, isCard, isList })
          ] }) }),
          /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { mt: 4, mb: 2, flexWrap: "wrap", children: folders.map((folder) => {
            const isActive = (filterState.foldersIds || []).includes(folder._id);
            return /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
              Button_default,
              {
                variation: isActive ? "primary" : "outline",
                medium: true,
                borderRadius: 24,
                mr: 2,
                mt: 2,
                type: "button",
                iconRight: isActive ? "close" : "plus",
                onClick: () => setFolderIds(folder._id),
                children: folder.folderName
              },
              folder._id
            );
          }) }),
          files.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(MediaListWrapper, { compact: compactMediaList, children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(List_default, { w: "100%", gap: 12, ...listOptions, data: files, children: (file, index2 = -1) => /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
            MediaFileCard_default,
            {
              file,
              isList,
              index: index2,
              onClick: () => setFileIdToPreview(index2),
              isMediaKit,
              compact: compactMediaList,
              addToMediaKit,
              removeFromMediaKit
            }
          ) }) }) : /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
            Flex_default,
            {
              w: "100%",
              h: compactMediaList ? 214 : 250,
              justifyContent: "center",
              alignItems: "center",
              children: /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Text_default, { children: t("pages:propertyPage.mediaEmptyState") })
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Flex_default, { w: "100%", justifyContent: "center", mt: 2, children: isMediaKit ? /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
            Pagination_default,
            {
              previousButtonLabel: t("common:labels.previous"),
              nextButtonLabel: t("common:labels.next")
            }
          ) : /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(PaginationLoadMore, { medium: true, variation: "outline", fetchMoreProps, children: t("common:labels.showMore") }) })
        ]
      }
    ),
    loading && /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(Spinner_default, { fullContent: true }),
    /* @__PURE__ */ (0, import_jsx_runtime131.jsx)(
      FilePreviewModal_default,
      {
        isPortfolioView,
        isOpened: fileIdToPreview >= 0,
        onClose: () => setFileIdToPreview(-1),
        defaultIndex: fileIdToPreview,
        files,
        isDownloadButtonVisible: allowDownloads
      }
    )
  ] });
};
var MarketingFiles_default = MarketingFiles;

// src/components/molecules/InfoCard/InfoCard.tsx
var import_styled_components140 = require("styled-components");

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.enums.ts
var DatePeriodTypesEnum = /* @__PURE__ */ ((DatePeriodTypesEnum3) => {
  DatePeriodTypesEnum3["CURRENT_YEAR"] = "CURRENT_YEAR";
  DatePeriodTypesEnum3["CURRENT_WEEK"] = "CURRENT_WEEK";
  DatePeriodTypesEnum3["PAST_WEEK"] = "PAST_WEEK";
  DatePeriodTypesEnum3["CURRENT_MONTH"] = "CURRENT_MONTH";
  DatePeriodTypesEnum3["PAST_MONTH"] = "PAST_MONTH";
  DatePeriodTypesEnum3["THREE_MONTH"] = "THREE_MONTH";
  DatePeriodTypesEnum3["CUSTOM"] = "CUSTOM";
  return DatePeriodTypesEnum3;
})(DatePeriodTypesEnum || {});

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.helpers.ts
var import_moment8 = __toESM(require("moment"));
var import_dash_common41 = require("dash-common");
var getPeriodRangeByPeriodType = (type) => {
  if (type === "CURRENT_WEEK" /* CURRENT_WEEK */) {
    return (0, import_dash_common41.getDateRangeByPeriod)("week");
  }
  if (type === "CURRENT_MONTH" /* CURRENT_MONTH */) {
    return (0, import_dash_common41.getDateRangeByPeriod)("month");
  }
  if (type === "CURRENT_YEAR" /* CURRENT_YEAR */) {
    return (0, import_dash_common41.getDateRangeByPeriod)("year");
  }
  if (type === "PAST_WEEK" /* PAST_WEEK */) {
    const lastWeekDate = (0, import_moment8.default)().subtract(1, "week").toDate();
    return (0, import_dash_common41.getDateRangeByPeriod)("week", lastWeekDate);
  }
  if (type === "PAST_MONTH" /* PAST_MONTH */) {
    const lastWeekDate = (0, import_moment8.default)().subtract(1, "month").toDate();
    return (0, import_dash_common41.getDateRangeByPeriod)("month", lastWeekDate);
  }
  const startOfThreeMonth = (0, import_moment8.default)().subtract(2, "month").startOf("month").toDate();
  const endOfThreeMonth = (0, import_moment8.default)().endOf("month").toDate();
  return { startDate: startOfThreeMonth, endDate: endOfThreeMonth };
};

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.tsx
var import_lodash17 = require("lodash");
var import_react90 = require("react");
var import_styled_components138 = require("styled-components");
var import_react_i18next40 = require("react-i18next");

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.styles.tsx
var import_styled_components137 = __toESM(require("styled-components"));
var PeriodButton = (0, import_styled_components137.default)(Button_default)`
  border-radius: 0px;
  background-color: ${({ theme, active }) => active && theme.colors.b20};
  justify-content: left;
  white-space: nowrap;

  & p {
    color: ${({ theme }) => theme.colors.n90} !important;
  }
  :hover {
    background-color: ${({ theme }) => theme.colors.b20};
  }
`;

// src/components/molecules/DatePeriodPicker/DatePeriodPicker.tsx
var import_jsx_runtime132 = require("react/jsx-runtime");
var DatePeriodPicker = ({
  color: color2,
  customEnabled,
  defaultType,
  anchorTextProps = { sm: true },
  anchorIconProps = { size: 16 },
  onChange,
  placementHorizontal = "right",
  hidePeriodTypes = [],
  ...args
}) => {
  const theme = (0, import_styled_components138.useTheme)();
  const { t } = (0, import_react_i18next40.useTranslation)("common");
  const [type, setType] = (0, import_react90.useState)(
    defaultType || "CURRENT_WEEK" /* CURRENT_WEEK */
  );
  const [dateRange, setDateRange] = (0, import_react90.useState)({
    startDate: /* @__PURE__ */ new Date()
  });
  const datePeriodTypes = Object.values(DatePeriodTypesEnum).filter(
    (value) => !hidePeriodTypes.includes(value)
  );
  const periodOptions = customEnabled ? datePeriodTypes : datePeriodTypes.filter((type2) => type2 !== "CUSTOM" /* CUSTOM */);
  (0, import_react90.useEffect)(() => {
    if (type !== "CUSTOM" /* CUSTOM */) {
      setDateRange(getPeriodRangeByPeriodType(type));
    }
  }, [type]);
  (0, import_react90.useEffect)(() => {
    if (dateRange.startDate && dateRange.endDate) {
      onChange(dateRange, type);
    }
  }, [dateRange]);
  return /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
    DropDown_default,
    {
      rerender: type,
      placementHorizontal,
      w: "100%",
      ...args,
      Anchor: ({ isOpen }) => /* @__PURE__ */ (0, import_jsx_runtime132.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
        /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(Text_default, { ellipsis: true, color: color2 || theme.colors.n90, ...anchorTextProps, children: (0, import_lodash17.capitalize)(
          t(`labels.dateRangePeriods.${(0, import_lodash17.camelCase)(type)}`)
        ) }),
        /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
          Icon_default,
          {
            color: color2 || theme.colors.n90,
            name: isOpen ? "arrowUp" : "arrowDown",
            ...anchorIconProps
          }
        )
      ] }),
      children: ({ closeDropdown }) => /* @__PURE__ */ (0, import_jsx_runtime132.jsxs)(Flex_default, { flexDirection: "column", children: [
        periodOptions.map((periodType) => /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
          PeriodButton,
          {
            active: type === periodType,
            w: "100%",
            variation: "flat",
            onClick: () => {
              setType(periodType);
              if (periodType !== "CUSTOM" /* CUSTOM */) {
                closeDropdown();
              }
            },
            children: t(`labels.dateRangePeriods.${(0, import_lodash17.camelCase)(periodType)}`)
          },
          periodType
        )),
        type === "CUSTOM" /* CUSTOM */ && /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(Box_default, { pt: 2, p: 4, minWidth: 276, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime132.jsx)(
          DateRangePicker_default,
          {
            popperProps: { strategy: "fixed" },
            selected: dateRange.startDate,
            onChange: (range) => {
              setDateRange(range);
            },
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
          }
        ) })
      ] })
    }
  );
};
var DatePeriodPicker_default = DatePeriodPicker;

// src/components/molecules/InfoCard/InfoCard.styles.tsx
var import_styled_components139 = __toESM(require("styled-components"));
var StyledInfoCard = (0, import_styled_components139.default)(Flex_default)`
  flex-direction: column;
  box-shadow: none;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${({ theme }) => theme.space * 3}px;
  color: ${({ theme }) => theme.colors.white};
  ${({ bgImgSrc }) => bgImgSrc && `
      background-repeat: no-repeat;
      background-size: contain;
      background-position-y: 20px;
      background-position-x: calc(100% - 15px);
      background-image: url(${bgImgSrc});
    `};
`;
var ItemsGroupStyle = (0, import_styled_components139.default)(Flex_default)`
  & > div {
    margin: 0 ${({ theme }) => theme.space * 3}px;
    padding: 0 ${({ theme }) => theme.space * 3}px;
    justify-content: center;
    border-left: ${({ theme }) => `1px solid ${theme.colors.setOpacity(theme.colors.white, 20)};`}
    border-right: ${({ theme }) => `1px solid ${theme.colors.setOpacity(theme.colors.white, 20)};`}

    :first-child, :last-child {
      margin: 0;
      padding: 0;
      border: none;
      justify-content: left;
    }
  }
`;
var DisableWrapper = (0, import_styled_components139.default)(Flex_default)`
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: ${({ theme }) => `${theme.colors.setOpacity(theme.colors.white, 60)};`};
  cursor: not-allowed;
`;
var DropdownContainer = (0, import_styled_components139.default)(Box_default)`
  & div > div {
    left: 0;
    min-width: fit-content;
  }
`;

// src/components/molecules/InfoCard/InfoCard.tsx
var import_jsx_runtime133 = require("react/jsx-runtime");
var InfoCard = ({
  hasInfoData,
  infoPlaceholderDescription,
  infoDescription,
  infoPlaceholder,
  itemsInfo,
  buttonTitle,
  disabled,
  loading,
  buttonDisabled,
  onButtonClick,
  onRangeChange,
  range,
  ...args
}) => {
  const theme = (0, import_styled_components140.useTheme)();
  return /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(StyledInfoCard, { w: "100%", h: 211, pos: "relative", p: 4, ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(DropdownContainer, { children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(DatePeriodPicker_default, { color: theme.colors.n30, onChange: onRangeChange }) }),
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Box_default, { ml: 2, children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { sm: true, color: theme.colors.white, children: range.startDate && range.endDate ? `${range.startDate.toLocaleDateString()} - ${range.endDate.toLocaleDateString()}` : "" }) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Flex_default, { mt: 6, mb: 2, alignItems: "center", children: hasInfoData && itemsInfo?.length ? /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(ItemsGroupStyle, { children: itemsInfo.map(({ key, info, iconName, iconProps, tooltipText }) => /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(Flex_default, { alignItems: "center", flex: 1, children: [
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { ellipsis: true, xxl: true, bold: true, color: theme.colors.white, children: info }),
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(TooltipWrapper_default, { placement: "bottom", content: tooltipText, children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Icon_default, { ml: 3, size: 24, name: iconName, ...iconProps }) })
    ] }, key)) }) : /* @__PURE__ */ (0, import_jsx_runtime133.jsxs)(import_jsx_runtime133.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Icon_default, { name: infoPlaceholder.iconName, size: 24, mr: 3, ...infoPlaceholder.iconProps }),
      /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { ellipsis: true, lg: true, bold: true, color: theme.colors.white, children: infoPlaceholder.info })
    ] }) }),
    /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Box_default, { children: hasInfoData ? /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { color: theme.colors.white, children: infoDescription }) : /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Text_default, { sm: true, color: theme.colors.n30, children: infoPlaceholderDescription }) }),
    /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(Flex_default, { flex: 1, alignItems: "end", pb: 1, children: /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
      Button_default,
      {
        lg: true,
        disabled: disabled || buttonDisabled,
        minWidth: 147,
        variation: "outline",
        colorVariation: "light",
        onClick: onButtonClick,
        children: buttonTitle
      }
    ) }),
    disabled && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(DisableWrapper, { pos: "absolute" }),
    loading && /* @__PURE__ */ (0, import_jsx_runtime133.jsx)(
      Spinner_default,
      {
        fullContent: true,
        size: 26,
        bgColor: args.bgColor,
        color: theme.colors.white,
        opacity: 70
      }
    )
  ] });
};
var InfoCard_default = InfoCard;

// src/components/molecules/AddressLabel/AddressLabel.tsx
var import_dash_common42 = require("dash-common");
var import_jsx_runtime134 = require("react/jsx-runtime");
function AddressLabel({
  address,
  tooltip = true,
  ellipsis = true,
  ...args
}) {
  const addressLabel = address ? (0, import_dash_common42.formatAddress)(address) : "";
  const content = /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(Box_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(Text_default, { ellipsis, ...args, children: addressLabel }) });
  return /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(import_jsx_runtime134.Fragment, { children: tooltip ? /* @__PURE__ */ (0, import_jsx_runtime134.jsx)(TooltipWrapper_default, { content: addressLabel, ...args, children: content }) : content });
}
var AddressLabel_default = AddressLabel;

// src/components/molecules/DashboardBanner/DashboardBanner.tsx
var import_react92 = require("react");

// src/components/molecules/DashboardBanner/DashboardBanner.context.tsx
var import_react91 = require("react");
var import_jsx_runtime135 = require("react/jsx-runtime");
var DashboardNotificationBannerContext = (0, import_react91.createContext)({
  notifications: [],
  setNotification: () => {
  },
  setNotifications: () => {
  },
  removeNotification: () => {
  }
});
var DashboardNotificationBannerProvider = ({ children }) => {
  const [notifications, setStateNotifications] = (0, import_react91.useState)([]);
  const setNotifications = (items) => {
    setStateNotifications((prev) => [...prev, ...items]);
  };
  const setNotification = (item) => {
    setStateNotifications((prev) => {
      const isNotificationExist = prev.some(({ itemId }) => itemId === item.itemId);
      return isNotificationExist ? prev : [...prev, item];
    });
  };
  const removeNotification = (notificationId) => {
    setStateNotifications((prev) => prev.filter(({ itemId }) => itemId !== notificationId));
  };
  const sortedNotifications = (0, import_react91.useMemo)(
    () => notifications.sort(
      (prev, curr) => BANNER_SORT_ORDER[prev.type || "success" /* SUCCESS */] - BANNER_SORT_ORDER[curr.type || "success" /* SUCCESS */]
    ),
    [notifications]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime135.jsx)(
    DashboardNotificationBannerContext.Provider,
    {
      value: {
        notifications: sortedNotifications,
        removeNotification,
        setNotifications,
        setNotification
      },
      children
    }
  );
};

// src/components/molecules/DashboardBanner/DashboardBanner.tsx
var import_jsx_runtime136 = require("react/jsx-runtime");
var DashboardBanner = ({ ...props }) => {
  const [currentIndex, setCurrentIndex] = (0, import_react92.useState)(0);
  const { notifications } = (0, import_react92.useContext)(DashboardNotificationBannerContext);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const countPerPage = 5;
  const shift = currentIndex - countPerPage + 1 > 0 ? currentIndex - countPerPage + 1 : 0;
  return /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(Flex_default, { flexDirection: "column", w: "100%", alignItems: "center", ...props, children: [
    notifications.map(
      ({ type, message, onViewClick, itemId, onDismissClick, submitButtonLabel }, index2) => {
        const { background, color: color2 } = BANNER_OPTIONS[type || "success" /* SUCCESS */];
        return index2 === currentIndex ? /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(Flex_default, { w: "100%", alignItems: "stretch", children: [
          /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
            Banner_default,
            {
              message,
              type: type || "success" /* SUCCESS */,
              onDismissClick: onDismissClick ? () => onDismissClick(itemId) : onDismissClick,
              onViewClick: onViewClick ? () => onViewClick(itemId) : onViewClick,
              submitButtonLabel
            }
          ),
          notifications.length > 1 && !isMobile && /* @__PURE__ */ (0, import_jsx_runtime136.jsxs)(import_jsx_runtime136.Fragment, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
              PaginationButton,
              {
                w: 48,
                h: "unset",
                icon: "chevronLeft",
                background,
                color: color2,
                mx: 2,
                disabled: !(currentIndex > 0),
                onClick: () => setCurrentIndex((prevIndex) => prevIndex - 1)
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
              PaginationButton,
              {
                w: 48,
                h: "unset",
                icon: "chevronRight",
                color: color2,
                background,
                disabled: !(currentIndex < notifications.length - 1),
                onClick: () => setCurrentIndex((prevIndex) => prevIndex + 1)
              }
            )
          ] })
        ] }, `${itemId}-${index2}`) : null;
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(Flex_default, { mt: 2, children: Array.from({
      length: notifications.length > countPerPage ? countPerPage : notifications.length
    }).map((_, index2) => /* @__PURE__ */ (0, import_jsx_runtime136.jsx)(
      PaginationDot,
      {
        mr: 2,
        w: 8,
        h: 8,
        isActive: shift + index2 === currentIndex,
        onClick: () => setCurrentIndex(index2 + shift)
      },
      index2
    )) })
  ] });
};
var DashboardBanner_default = DashboardBanner;

// src/components/molecules/WasDeleted/WasDeleted.tsx
var import_styled_components142 = require("styled-components");
var import_react_i18next41 = require("react-i18next");

// src/components/molecules/WasDeleted/WasDeleted.styles.ts
var import_styled_components141 = __toESM(require("styled-components"));
var PageWrapper2 = (0, import_styled_components141.default)(Flex_default)`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
var VerticalDevider2 = (0, import_styled_components141.default)(Box_default)`
  background: ${({ theme }) => theme.colors.n90};
  border-radius: ${({ theme }) => theme.space * 2}px;
`;
var StyledHeading2 = (0, import_styled_components141.default)(H_default)`
  display: flex;
  align-items: center;
`;

// src/components/molecules/WasDeleted/WasDeleted.tsx
var import_jsx_runtime137 = require("react/jsx-runtime");
var WasDeleted = ({ onRedirect, entityName }) => {
  const theme = (0, import_styled_components142.useTheme)();
  const { t } = (0, import_react_i18next41.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(PageWrapper2, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(Flex_default, { w: 443, flexDirection: "column", justifyContent: "center", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime137.jsxs)(StyledHeading2, { lg: true, bold: true, color: theme.colors.n90, children: [
      "404",
      /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(VerticalDevider2, { h: 38, w: 4, mx: 8 }),
      t("wasDeleted.title", {
        entityName
      })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime137.jsx)(Button_default, { h: 40, minWidth: 153, onClick: onRedirect, children: t("notFoundPage.buttonLabel") })
  ] }) });
};
var WasDeleted_default = WasDeleted;

// src/components/molecules/ScrollDragable/ScrollDragable.tsx
var import_react93 = require("react");
var import_styled_components143 = __toESM(require("styled-components"));
var import_jsx_runtime138 = require("react/jsx-runtime");
var DivStyles = import_styled_components143.default.div`
  cursor: pointer;
  width: 100%;
  overflow: auto;
  touchaction: none;
  ::-webkit-scrollbar {
    height: 2px;
    width: 3px;
  }
  ::-webkit-scrollbar-track:horizontal {
    box-shadow: inset 0 0 6px ${({ theme }) => theme.colors.n60};
  }
  ::-webkit-scrollbar-thumb:horizontal {
    background-color: ${({ theme }) => theme.colors.g20};
  }
  ::-webkit-scrollbar-thumb:vertical {
    background-color: ${({ theme }) => theme.colors.n60};
  }
`;
var ScrollDragable = ({ children }) => {
  const ref = (0, import_react93.useRef)(null);
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;
  (0, import_react93.useEffect)(() => {
    const slider = ref.current;
    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      slider.classList.add("active");
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });
    slider.addEventListener("mouseleave", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mouseup", () => {
      isDown = false;
      slider.classList.remove("active");
    });
    slider.addEventListener("mousemove", (e) => {
      if (!isDown)
        return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = x - startX;
      slider.scrollLeft = scrollLeft - walk;
    });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime138.jsx)(DivStyles, { ref, children });
};
var ScrollDragable_default = ScrollDragable;

// src/components/molecules/UnauthorizedIDX/UnauthorizedPage.tsx
var import_styled_components145 = require("styled-components");
var import_react_i18next42 = require("react-i18next");

// src/components/molecules/UnauthorizedIDX/UnauthorizedPage.style.ts
var import_styled_components144 = __toESM(require("styled-components"));
var PageWrapper3 = (0, import_styled_components144.default)(Flex_default)`
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
var VerticalDevider3 = (0, import_styled_components144.default)(Box_default)`
  background: ${({ theme }) => theme.colors.n90};
  border-radius: ${({ theme }) => theme.space * 2}px;
`;
var StyledHeading3 = (0, import_styled_components144.default)(H_default)`
  display: flex;
  align-items: center;
`;

// src/components/molecules/UnauthorizedIDX/UnauthorizedPage.tsx
var import_jsx_runtime139 = require("react/jsx-runtime");
var UnauthorizedPage = ({ onRedirect }) => {
  const theme = (0, import_styled_components145.useTheme)();
  const { t } = (0, import_react_i18next42.useTranslation)("pages");
  return /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(PageWrapper3, { justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(
    Flex_default,
    {
      w: 443,
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime139.jsxs)(StyledHeading3, { lg: true, bold: true, color: theme.colors.n90, children: [
          "401",
          /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(VerticalDevider3, { h: 38, w: 4, mx: 8 }),
          t("idx.unauthorizedTitle")
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Box_default, { mb: 4, mt: 6, children: /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Text_default, { color: theme.colors.n80, children: t("idx.unauthorizedSubtitle") }) }),
        /* @__PURE__ */ (0, import_jsx_runtime139.jsx)(Button_default, { h: 40, minWidth: 153, onClick: onRedirect, children: t("idx.visitDash") })
      ]
    }
  ) });
};
var UnauthorizedPage_default = UnauthorizedPage;

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/ApiAccessChart.tsx
var import_react97 = require("react");
var import_styled_components147 = __toESM(require("styled-components"));

// ../../node_modules/react-chartjs-2/dist/index.js
var import_react94 = __toESM(require("react"), 1);

// ../../node_modules/@kurkle/color/dist/color.esm.js
function round(v) {
  return v + 0.5 | 0;
}
var lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}
var map$1 = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 };
var hex = [..."0123456789ABCDEF"];
var h1 = (b) => hex[b & 15];
var h2 = (b) => hex[(b & 240) >> 4] + hex[b & 15];
var eq = (b) => (b & 240) >> 4 === (b & 15);
var isShort = (v) => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === "#") {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? map$1[str[7]] << 4 | map$1[str[8]] : 255
      };
    }
  }
  return ret;
}
var alpha = (a, f) => a < 255 ? f(a) : "";
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v ? "#" + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f) : void 0;
}
var HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
  const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
  const rgb = hsl2rgbn(h, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }
  return rgb;
}
function hueValue(r, g, b, d, max) {
  if (r === max) {
    return (g - b) / d + (g < b ? 6 : 0);
  }
  if (g === max) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s, d;
  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }
  return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (Array.isArray(a) ? f(a[0], a[1], a[2]) : f(a, b, c)).map(n2b);
}
function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
  return (h % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === "hwb") {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === "hsv") {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a
  };
}
function rotate(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255 ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})` : `hsl(${h}, ${s}%, ${l}%)`;
}
var map = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
};
var names$1 = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map[k]);
    }
    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 255, k >> 8 & 255, k & 255];
  }
  return unpacked;
}
var names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}
var RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r,
    g,
    b,
    a
  };
}
function rgbString(v) {
  return v && (v.a < 255 ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})` : `rgb(${v.r}, ${v.g}, ${v.b})`);
}
var to = (v) => v <= 31308e-7 ? v * 12.92 : Math.pow(v, 1 / 2.4) * 1.055 - 0.055;
var from = (v) => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}
function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = { r: 0, g: 0, b: 0, a: 255 };
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = { r: input[0], g: input[1], b: input[2], a: 255 };
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone(input, { r: 0, g: 0, b: 0, a: 1 });
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === "r") {
    return rgbParse(str);
  }
  return hueParse(str);
}
var Color = class _Color {
  constructor(input) {
    if (input instanceof _Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === "object") {
      v = fromObject(input);
    } else if (type === "string") {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : void 0;
  }
  mix(color2, weight) {
    if (color2) {
      const c1 = this.rgb;
      const c2 = color2.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
      w2 = 1 - w1;
      c1.r = 255 & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 255 & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 255 & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color2, t) {
    if (color2) {
      this._rgb = interpolate(this._rgb, color2._rgb, t);
    }
    return this;
  }
  clone() {
    return new _Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
};

// ../../node_modules/chart.js/dist/chunks/helpers.segment.js
function noop() {
}
var uid = (() => {
  let id2 = 0;
  return () => id2++;
})();
function isNullOrUndef(value) {
  return value === null || typeof value === "undefined";
}
function isArray(value) {
  if (Array.isArray && Array.isArray(value)) {
    return true;
  }
  const type = Object.prototype.toString.call(value);
  if (type.slice(0, 7) === "[object" && type.slice(-6) === "Array]") {
    return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && Object.prototype.toString.call(value) === "[object Object]";
}
function isNumberFinite(value) {
  return (typeof value === "number" || value instanceof Number) && isFinite(+value);
}
function finiteOrDefault(value, defaultValue) {
  return isNumberFinite(value) ? value : defaultValue;
}
function valueOrDefault(value, defaultValue) {
  return typeof value === "undefined" ? defaultValue : value;
}
var toDimension = (value, dimension) => typeof value === "string" && value.endsWith("%") ? parseFloat(value) / 100 * dimension : +value;
function callback(fn, args, thisArg) {
  if (fn && typeof fn.call === "function") {
    return fn.apply(thisArg, args);
  }
}
function each(loopable, fn, thisArg, reverse) {
  let i, len, keys;
  if (isArray(loopable)) {
    len = loopable.length;
    if (reverse) {
      for (i = len - 1; i >= 0; i--) {
        fn.call(thisArg, loopable[i], i);
      }
    } else {
      for (i = 0; i < len; i++) {
        fn.call(thisArg, loopable[i], i);
      }
    }
  } else if (isObject(loopable)) {
    keys = Object.keys(loopable);
    len = keys.length;
    for (i = 0; i < len; i++) {
      fn.call(thisArg, loopable[keys[i]], keys[i]);
    }
  }
}
function _elementsEqual(a0, a1) {
  let i, ilen, v0, v1;
  if (!a0 || !a1 || a0.length !== a1.length) {
    return false;
  }
  for (i = 0, ilen = a0.length; i < ilen; ++i) {
    v0 = a0[i];
    v1 = a1[i];
    if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
      return false;
    }
  }
  return true;
}
function clone2(source) {
  if (isArray(source)) {
    return source.map(clone2);
  }
  if (isObject(source)) {
    const target = /* @__PURE__ */ Object.create(null);
    const keys = Object.keys(source);
    const klen = keys.length;
    let k = 0;
    for (; k < klen; ++k) {
      target[keys[k]] = clone2(source[keys[k]]);
    }
    return target;
  }
  return source;
}
function isValidKey(key) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(key) === -1;
}
function _merger(key, target, source, options) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    merge(tval, sval, options);
  } else {
    target[key] = clone2(sval);
  }
}
function merge(target, source, options) {
  const sources = isArray(source) ? source : [
    source
  ];
  const ilen = sources.length;
  if (!isObject(target)) {
    return target;
  }
  options = options || {};
  const merger = options.merger || _merger;
  let current;
  for (let i = 0; i < ilen; ++i) {
    current = sources[i];
    if (!isObject(current)) {
      continue;
    }
    const keys = Object.keys(current);
    for (let k = 0, klen = keys.length; k < klen; ++k) {
      merger(keys[k], target, current, options);
    }
  }
  return target;
}
function mergeIf(target, source) {
  return merge(target, source, {
    merger: _mergerIf
  });
}
function _mergerIf(key, target, source) {
  if (!isValidKey(key)) {
    return;
  }
  const tval = target[key];
  const sval = source[key];
  if (isObject(tval) && isObject(sval)) {
    mergeIf(tval, sval);
  } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
    target[key] = clone2(sval);
  }
}
var keyResolvers = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (v) => v,
  // default resolvers
  x: (o) => o.x,
  y: (o) => o.y
};
function _splitKey(key) {
  const parts = key.split(".");
  const keys = [];
  let tmp = "";
  for (const part of parts) {
    tmp += part;
    if (tmp.endsWith("\\")) {
      tmp = tmp.slice(0, -1) + ".";
    } else {
      keys.push(tmp);
      tmp = "";
    }
  }
  return keys;
}
function _getKeyResolver(key) {
  const keys = _splitKey(key);
  return (obj) => {
    for (const k of keys) {
      if (k === "") {
        break;
      }
      obj = obj && obj[k];
    }
    return obj;
  };
}
function resolveObjectKey(obj, key) {
  const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
  return resolver(obj);
}
function _capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
var defined = (value) => typeof value !== "undefined";
var isFunction = (value) => typeof value === "function";
var setsEqual = (a, b) => {
  if (a.size !== b.size) {
    return false;
  }
  for (const item of a) {
    if (!b.has(item)) {
      return false;
    }
  }
  return true;
};
function _isClickEvent(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
var PI = Math.PI;
var TAU = 2 * PI;
var PITAU = TAU + PI;
var INFINITY = Number.POSITIVE_INFINITY;
var RAD_PER_DEG = PI / 180;
var HALF_PI = PI / 2;
var QUARTER_PI = PI / 4;
var TWO_THIRDS_PI = PI * 2 / 3;
var log10 = Math.log10;
var sign = Math.sign;
function almostEquals(x, y, epsilon) {
  return Math.abs(x - y) < epsilon;
}
function niceNum(range) {
  const roundedRange = Math.round(range);
  range = almostEquals(range, roundedRange, range / 1e3) ? roundedRange : range;
  const niceRange = Math.pow(10, Math.floor(log10(range)));
  const fraction = range / niceRange;
  const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
  return niceFraction * niceRange;
}
function _factorize(value) {
  const result = [];
  const sqrt = Math.sqrt(value);
  let i;
  for (i = 1; i < sqrt; i++) {
    if (value % i === 0) {
      result.push(i);
      result.push(value / i);
    }
  }
  if (sqrt === (sqrt | 0)) {
    result.push(sqrt);
  }
  result.sort((a, b) => a - b).pop();
  return result;
}
function isNumber5(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
  const rounded = Math.round(x);
  return rounded - epsilon <= x && rounded + epsilon >= x;
}
function _setMinAndMaxByKey(array, target, property) {
  let i, ilen, value;
  for (i = 0, ilen = array.length; i < ilen; i++) {
    value = array[i][property];
    if (!isNaN(value)) {
      target.min = Math.min(target.min, value);
      target.max = Math.max(target.max, value);
    }
  }
}
function toRadians(degrees) {
  return degrees * (PI / 180);
}
function toDegrees(radians) {
  return radians * (180 / PI);
}
function _decimalPlaces(x) {
  if (!isNumberFinite(x)) {
    return;
  }
  let e = 1;
  let p = 0;
  while (Math.round(x * e) / e !== x) {
    e *= 10;
    p++;
  }
  return p;
}
function getAngleFromPoint(centrePoint, anglePoint) {
  const distanceFromXCenter = anglePoint.x - centrePoint.x;
  const distanceFromYCenter = anglePoint.y - centrePoint.y;
  const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
  let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
  if (angle < -0.5 * PI) {
    angle += TAU;
  }
  return {
    angle,
    distance: radialDistanceFromCenter
  };
}
function distanceBetweenPoints(pt1, pt2) {
  return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
function _angleDiff(a, b) {
  return (a - b + PITAU) % TAU - PI;
}
function _normalizeAngle(a) {
  return (a % TAU + TAU) % TAU;
}
function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
  const a = _normalizeAngle(angle);
  const s = _normalizeAngle(start);
  const e = _normalizeAngle(end);
  const angleToStart = _normalizeAngle(s - a);
  const angleToEnd = _normalizeAngle(e - a);
  const startToAngle = _normalizeAngle(a - s);
  const endToAngle = _normalizeAngle(a - e);
  return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
function _limitValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function _int16Range(value) {
  return _limitValue(value, -32768, 32767);
}
function _isBetween(value, start, end, epsilon = 1e-6) {
  return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}
function _lookup(table, value, cmp) {
  cmp = cmp || ((index2) => table[index2] < value);
  let hi = table.length - 1;
  let lo = 0;
  let mid;
  while (hi - lo > 1) {
    mid = lo + hi >> 1;
    if (cmp(mid)) {
      lo = mid;
    } else {
      hi = mid;
    }
  }
  return {
    lo,
    hi
  };
}
var _lookupByKey = (table, key, value, last) => _lookup(table, value, last ? (index2) => {
  const ti = table[index2][key];
  return ti < value || ti === value && table[index2 + 1][key] === value;
} : (index2) => table[index2][key] < value);
var _rlookupByKey = (table, key, value) => _lookup(table, value, (index2) => table[index2][key] >= value);
function _filterBetween(values, min, max) {
  let start = 0;
  let end = values.length;
  while (start < end && values[start] < min) {
    start++;
  }
  while (end > start && values[end - 1] > max) {
    end--;
  }
  return start > 0 || end < values.length ? values.slice(start, end) : values;
}
var arrayEvents = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function listenArrayEvents(array, listener) {
  if (array._chartjs) {
    array._chartjs.listeners.push(listener);
    return;
  }
  Object.defineProperty(array, "_chartjs", {
    configurable: true,
    enumerable: false,
    value: {
      listeners: [
        listener
      ]
    }
  });
  arrayEvents.forEach((key) => {
    const method = "_onData" + _capitalize(key);
    const base = array[key];
    Object.defineProperty(array, key, {
      configurable: true,
      enumerable: false,
      value(...args) {
        const res = base.apply(this, args);
        array._chartjs.listeners.forEach((object) => {
          if (typeof object[method] === "function") {
            object[method](...args);
          }
        });
        return res;
      }
    });
  });
}
function unlistenArrayEvents(array, listener) {
  const stub = array._chartjs;
  if (!stub) {
    return;
  }
  const listeners = stub.listeners;
  const index2 = listeners.indexOf(listener);
  if (index2 !== -1) {
    listeners.splice(index2, 1);
  }
  if (listeners.length > 0) {
    return;
  }
  arrayEvents.forEach((key) => {
    delete array[key];
  });
  delete array._chartjs;
}
function _arrayUnique(items) {
  const set2 = new Set(items);
  if (set2.size === items.length) {
    return items;
  }
  return Array.from(set2);
}
var requestAnimFrame = function() {
  if (typeof window === "undefined") {
    return function(callback2) {
      return callback2();
    };
  }
  return window.requestAnimationFrame;
}();
function throttled(fn, thisArg) {
  let argsToUse = [];
  let ticking = false;
  return function(...args) {
    argsToUse = args;
    if (!ticking) {
      ticking = true;
      requestAnimFrame.call(window, () => {
        ticking = false;
        fn.apply(thisArg, argsToUse);
      });
    }
  };
}
function debounce(fn, delay) {
  let timeout;
  return function(...args) {
    if (delay) {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay, args);
    } else {
      fn.apply(this, args);
    }
    return delay;
  };
}
var _toLeftRightCenter = (align) => align === "start" ? "left" : align === "end" ? "right" : "center";
var _alignStartEnd = (align, start, end) => align === "start" ? start : align === "end" ? end : (start + end) / 2;
function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
  const pointCount = points.length;
  let start = 0;
  let count = pointCount;
  if (meta._sorted) {
    const { iScale, _parsed } = meta;
    const axis = iScale.axis;
    const { min, max, minDefined, maxDefined } = iScale.getUserBounds();
    if (minDefined) {
      start = _limitValue(Math.min(
        // @ts-expect-error Need to type _parsed
        _lookupByKey(_parsed, axis, min).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo
      ), 0, pointCount - 1);
    }
    if (maxDefined) {
      count = _limitValue(Math.max(
        // @ts-expect-error Need to type _parsed
        _lookupByKey(_parsed, iScale.axis, max, true).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1
      ), start, pointCount) - start;
    } else {
      count = pointCount - start;
    }
  }
  return {
    start,
    count
  };
}
function _scaleRangesChanged(meta) {
  const { xScale, yScale, _scaleRanges } = meta;
  const newRanges = {
    xmin: xScale.min,
    xmax: xScale.max,
    ymin: yScale.min,
    ymax: yScale.max
  };
  if (!_scaleRanges) {
    meta._scaleRanges = newRanges;
    return true;
  }
  const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
  Object.assign(_scaleRanges, newRanges);
  return changed;
}
var atEdge = (t) => t === 0 || t === 1;
var elasticIn = (t, s, p) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
var elasticOut = (t, s, p) => Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
var effects = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * HALF_PI) + 1,
  easeOutSine: (t) => Math.sin(t * HALF_PI),
  easeInOutSine: (t) => -0.5 * (Math.cos(PI * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
  easeOutElastic: (t) => atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
  easeInOutElastic(t) {
    const s = 0.1125;
    const p = 0.45;
    return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
  },
  easeInBack(t) {
    const s = 1.70158;
    return t * t * ((s + 1) * t - s);
  },
  easeOutBack(t) {
    const s = 1.70158;
    return (t -= 1) * t * ((s + 1) * t + s) + 1;
  },
  easeInOutBack(t) {
    let s = 1.70158;
    if ((t /= 0.5) < 1) {
      return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
    }
    return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
  },
  easeInBounce: (t) => 1 - effects.easeOutBounce(1 - t),
  easeOutBounce(t) {
    const m = 7.5625;
    const d = 2.75;
    if (t < 1 / d) {
      return m * t * t;
    }
    if (t < 2 / d) {
      return m * (t -= 1.5 / d) * t + 0.75;
    }
    if (t < 2.5 / d) {
      return m * (t -= 2.25 / d) * t + 0.9375;
    }
    return m * (t -= 2.625 / d) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function isPatternOrGradient(value) {
  if (value && typeof value === "object") {
    const type = value.toString();
    return type === "[object CanvasPattern]" || type === "[object CanvasGradient]";
  }
  return false;
}
function color(value) {
  return isPatternOrGradient(value) ? value : new Color(value);
}
function getHoverColor(value) {
  return isPatternOrGradient(value) ? value : new Color(value).saturate(0.5).darken(0.1).hexString();
}
var numbers = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
];
var colors = [
  "color",
  "borderColor",
  "backgroundColor"
];
function applyAnimationsDefaults(defaults2) {
  defaults2.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  });
  defaults2.describe("animation", {
    _fallback: false,
    _indexable: false,
    _scriptable: (name) => name !== "onProgress" && name !== "onComplete" && name !== "fn"
  });
  defaults2.set("animations", {
    colors: {
      type: "color",
      properties: colors
    },
    numbers: {
      type: "number",
      properties: numbers
    }
  });
  defaults2.describe("animations", {
    _fallback: "animation"
  });
  defaults2.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (v) => v | 0
        }
      }
    }
  });
}
function applyLayoutsDefaults(defaults2) {
  defaults2.set("layout", {
    autoPadding: true,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
var intlCache = /* @__PURE__ */ new Map();
function getNumberFormat(locale, options) {
  options = options || {};
  const cacheKey = locale + JSON.stringify(options);
  let formatter = intlCache.get(cacheKey);
  if (!formatter) {
    formatter = new Intl.NumberFormat(locale, options);
    intlCache.set(cacheKey, formatter);
  }
  return formatter;
}
function formatNumber(num, locale, options) {
  return getNumberFormat(locale, options).format(num);
}
var formatters = {
  values(value) {
    return isArray(value) ? value : "" + value;
  },
  numeric(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const locale = this.chart.options.locale;
    let notation;
    let delta = tickValue;
    if (ticks.length > 1) {
      const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
      if (maxTick < 1e-4 || maxTick > 1e15) {
        notation = "scientific";
      }
      delta = calculateDelta(tickValue, ticks);
    }
    const logDelta = log10(Math.abs(delta));
    const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
    const options = {
      notation,
      minimumFractionDigits: numDecimal,
      maximumFractionDigits: numDecimal
    };
    Object.assign(options, this.options.ticks.format);
    return formatNumber(tickValue, locale, options);
  },
  logarithmic(tickValue, index2, ticks) {
    if (tickValue === 0) {
      return "0";
    }
    const remain = ticks[index2].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
    if ([
      1,
      2,
      3,
      5,
      10,
      15
    ].includes(remain) || index2 > 0.8 * ticks.length) {
      return formatters.numeric.call(this, tickValue, index2, ticks);
    }
    return "";
  }
};
function calculateDelta(tickValue, ticks) {
  let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
  if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
    delta = tickValue - Math.floor(tickValue);
  }
  return delta;
}
var Ticks = {
  formatters
};
function applyScaleDefaults(defaults2) {
  defaults2.set("scale", {
    display: true,
    offset: false,
    reverse: false,
    beginAtZero: false,
    bounds: "ticks",
    clip: true,
    grace: 0,
    grid: {
      display: true,
      lineWidth: 1,
      drawOnChartArea: true,
      drawTicks: true,
      tickLength: 8,
      tickWidth: (_ctx, options) => options.lineWidth,
      tickColor: (_ctx, options) => options.color,
      offset: false
    },
    border: {
      display: true,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: false,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: false,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: true,
      autoSkip: true,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: Ticks.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: false,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  });
  defaults2.route("scale.ticks", "color", "", "color");
  defaults2.route("scale.grid", "color", "", "borderColor");
  defaults2.route("scale.border", "color", "", "borderColor");
  defaults2.route("scale.title", "color", "", "color");
  defaults2.describe("scale", {
    _fallback: false,
    _scriptable: (name) => !name.startsWith("before") && !name.startsWith("after") && name !== "callback" && name !== "parser",
    _indexable: (name) => name !== "borderDash" && name !== "tickBorderDash" && name !== "dash"
  });
  defaults2.describe("scales", {
    _fallback: "scale"
  });
  defaults2.describe("scale.ticks", {
    _scriptable: (name) => name !== "backdropPadding" && name !== "callback",
    _indexable: (name) => name !== "backdropPadding"
  });
}
var overrides = /* @__PURE__ */ Object.create(null);
var descriptors = /* @__PURE__ */ Object.create(null);
function getScope$1(node, key) {
  if (!key) {
    return node;
  }
  const keys = key.split(".");
  for (let i = 0, n = keys.length; i < n; ++i) {
    const k = keys[i];
    node = node[k] || (node[k] = /* @__PURE__ */ Object.create(null));
  }
  return node;
}
function set(root, scope, values) {
  if (typeof scope === "string") {
    return merge(getScope$1(root, scope), values);
  }
  return merge(getScope$1(root, ""), scope);
}
var Defaults = class {
  constructor(_descriptors2, _appliers) {
    this.animation = void 0;
    this.backgroundColor = "rgba(0,0,0,0.1)";
    this.borderColor = "rgba(0,0,0,0.1)";
    this.color = "#666";
    this.datasets = {};
    this.devicePixelRatio = (context) => context.chart.platform.getDevicePixelRatio();
    this.elements = {};
    this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ];
    this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    };
    this.hover = {};
    this.hoverBackgroundColor = (ctx, options) => getHoverColor(options.backgroundColor);
    this.hoverBorderColor = (ctx, options) => getHoverColor(options.borderColor);
    this.hoverColor = (ctx, options) => getHoverColor(options.color);
    this.indexAxis = "x";
    this.interaction = {
      mode: "nearest",
      intersect: true,
      includeInvisible: false
    };
    this.maintainAspectRatio = true;
    this.onHover = null;
    this.onClick = null;
    this.parsing = true;
    this.plugins = {};
    this.responsive = true;
    this.scale = void 0;
    this.scales = {};
    this.showLine = true;
    this.drawActiveElementsOnTop = true;
    this.describe(_descriptors2);
    this.apply(_appliers);
  }
  set(scope, values) {
    return set(this, scope, values);
  }
  get(scope) {
    return getScope$1(this, scope);
  }
  describe(scope, values) {
    return set(descriptors, scope, values);
  }
  override(scope, values) {
    return set(overrides, scope, values);
  }
  route(scope, name, targetScope, targetName) {
    const scopeObject = getScope$1(this, scope);
    const targetScopeObject = getScope$1(this, targetScope);
    const privateName = "_" + name;
    Object.defineProperties(scopeObject, {
      [privateName]: {
        value: scopeObject[name],
        writable: true
      },
      [name]: {
        enumerable: true,
        get() {
          const local = this[privateName];
          const target = targetScopeObject[targetName];
          if (isObject(local)) {
            return Object.assign({}, target, local);
          }
          return valueOrDefault(local, target);
        },
        set(value) {
          this[privateName] = value;
        }
      }
    });
  }
  apply(appliers) {
    appliers.forEach((apply) => apply(this));
  }
};
var defaults = /* @__PURE__ */ new Defaults({
  _scriptable: (name) => !name.startsWith("on"),
  _indexable: (name) => name !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: false,
    _indexable: false
  }
}, [
  applyAnimationsDefaults,
  applyLayoutsDefaults,
  applyScaleDefaults
]);
function toFontString(font) {
  if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
    return null;
  }
  return (font.style ? font.style + " " : "") + (font.weight ? font.weight + " " : "") + font.size + "px " + font.family;
}
function _measureText(ctx, data, gc, longest, string) {
  let textWidth = data[string];
  if (!textWidth) {
    textWidth = data[string] = ctx.measureText(string).width;
    gc.push(string);
  }
  if (textWidth > longest) {
    longest = textWidth;
  }
  return longest;
}
function _longestText(ctx, font, arrayOfThings, cache) {
  cache = cache || {};
  let data = cache.data = cache.data || {};
  let gc = cache.garbageCollect = cache.garbageCollect || [];
  if (cache.font !== font) {
    data = cache.data = {};
    gc = cache.garbageCollect = [];
    cache.font = font;
  }
  ctx.save();
  ctx.font = font;
  let longest = 0;
  const ilen = arrayOfThings.length;
  let i, j, jlen, thing, nestedThing;
  for (i = 0; i < ilen; i++) {
    thing = arrayOfThings[i];
    if (thing !== void 0 && thing !== null && !isArray(thing)) {
      longest = _measureText(ctx, data, gc, longest, thing);
    } else if (isArray(thing)) {
      for (j = 0, jlen = thing.length; j < jlen; j++) {
        nestedThing = thing[j];
        if (nestedThing !== void 0 && nestedThing !== null && !isArray(nestedThing)) {
          longest = _measureText(ctx, data, gc, longest, nestedThing);
        }
      }
    }
  }
  ctx.restore();
  const gcLen = gc.length / 2;
  if (gcLen > arrayOfThings.length) {
    for (i = 0; i < gcLen; i++) {
      delete data[gc[i]];
    }
    gc.splice(0, gcLen);
  }
  return longest;
}
function _alignPixel(chart, pixel, width) {
  const devicePixelRatio = chart.currentDevicePixelRatio;
  const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
  return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
function clearCanvas(canvas, ctx) {
  ctx = ctx || canvas.getContext("2d");
  ctx.save();
  ctx.resetTransform();
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.restore();
}
function drawPoint(ctx, options, x, y) {
  drawPointLegend(ctx, options, x, y, null);
}
function drawPointLegend(ctx, options, x, y, w) {
  let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
  const style = options.pointStyle;
  const rotation = options.rotation;
  const radius = options.radius;
  let rad = (rotation || 0) * RAD_PER_DEG;
  if (style && typeof style === "object") {
    type = style.toString();
    if (type === "[object HTMLImageElement]" || type === "[object HTMLCanvasElement]") {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rad);
      ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
      ctx.restore();
      return;
    }
  }
  if (isNaN(radius) || radius <= 0) {
    return;
  }
  ctx.beginPath();
  switch (style) {
    default:
      if (w) {
        ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
      } else {
        ctx.arc(x, y, radius, 0, TAU);
      }
      ctx.closePath();
      break;
    case "triangle":
      width = w ? w / 2 : radius;
      ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      rad += TWO_THIRDS_PI;
      ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
      ctx.closePath();
      break;
    case "rectRounded":
      cornerRadius = radius * 0.516;
      size = radius - cornerRadius;
      xOffset = Math.cos(rad + QUARTER_PI) * size;
      xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      yOffset = Math.sin(rad + QUARTER_PI) * size;
      yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
      ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
      ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
      ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
      ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
      ctx.closePath();
      break;
    case "rect":
      if (!rotation) {
        size = Math.SQRT1_2 * radius;
        width = w ? w / 2 : size;
        ctx.rect(x - width, y - size, 2 * width, 2 * size);
        break;
      }
      rad += QUARTER_PI;
    case "rectRot":
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      ctx.closePath();
      break;
    case "crossRot":
      rad += QUARTER_PI;
    case "cross":
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case "star":
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      rad += QUARTER_PI;
      xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
      xOffset = Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
      ctx.moveTo(x - xOffsetW, y - yOffset);
      ctx.lineTo(x + xOffsetW, y + yOffset);
      ctx.moveTo(x + yOffsetW, y - xOffset);
      ctx.lineTo(x - yOffsetW, y + xOffset);
      break;
    case "line":
      xOffset = w ? w / 2 : Math.cos(rad) * radius;
      yOffset = Math.sin(rad) * radius;
      ctx.moveTo(x - xOffset, y - yOffset);
      ctx.lineTo(x + xOffset, y + yOffset);
      break;
    case "dash":
      ctx.moveTo(x, y);
      ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
      break;
    case false:
      ctx.closePath();
      break;
  }
  ctx.fill();
  if (options.borderWidth > 0) {
    ctx.stroke();
  }
}
function _isPointInArea(point, area, margin) {
  margin = margin || 0.5;
  return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
  ctx.save();
  ctx.beginPath();
  ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
  ctx.clip();
}
function unclipArea(ctx) {
  ctx.restore();
}
function _steppedLineTo(ctx, previous, target, flip, mode) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  if (mode === "middle") {
    const midpoint = (previous.x + target.x) / 2;
    ctx.lineTo(midpoint, previous.y);
    ctx.lineTo(midpoint, target.y);
  } else if (mode === "after" !== !!flip) {
    ctx.lineTo(previous.x, target.y);
  } else {
    ctx.lineTo(target.x, previous.y);
  }
  ctx.lineTo(target.x, target.y);
}
function _bezierCurveTo(ctx, previous, target, flip) {
  if (!previous) {
    return ctx.lineTo(target.x, target.y);
  }
  ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
  if (opts.translation) {
    ctx.translate(opts.translation[0], opts.translation[1]);
  }
  if (!isNullOrUndef(opts.rotation)) {
    ctx.rotate(opts.rotation);
  }
  if (opts.color) {
    ctx.fillStyle = opts.color;
  }
  if (opts.textAlign) {
    ctx.textAlign = opts.textAlign;
  }
  if (opts.textBaseline) {
    ctx.textBaseline = opts.textBaseline;
  }
}
function decorateText(ctx, x, y, line, opts) {
  if (opts.strikethrough || opts.underline) {
    const metrics = ctx.measureText(line);
    const left = x - metrics.actualBoundingBoxLeft;
    const right = x + metrics.actualBoundingBoxRight;
    const top = y - metrics.actualBoundingBoxAscent;
    const bottom = y + metrics.actualBoundingBoxDescent;
    const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
    ctx.strokeStyle = ctx.fillStyle;
    ctx.beginPath();
    ctx.lineWidth = opts.decorationWidth || 2;
    ctx.moveTo(left, yDecoration);
    ctx.lineTo(right, yDecoration);
    ctx.stroke();
  }
}
function drawBackdrop(ctx, opts) {
  const oldColor = ctx.fillStyle;
  ctx.fillStyle = opts.color;
  ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
  ctx.fillStyle = oldColor;
}
function renderText(ctx, text, x, y, font, opts = {}) {
  const lines = isArray(text) ? text : [
    text
  ];
  const stroke = opts.strokeWidth > 0 && opts.strokeColor !== "";
  let i, line;
  ctx.save();
  ctx.font = font.string;
  setRenderOpts(ctx, opts);
  for (i = 0; i < lines.length; ++i) {
    line = lines[i];
    if (opts.backdrop) {
      drawBackdrop(ctx, opts.backdrop);
    }
    if (stroke) {
      if (opts.strokeColor) {
        ctx.strokeStyle = opts.strokeColor;
      }
      if (!isNullOrUndef(opts.strokeWidth)) {
        ctx.lineWidth = opts.strokeWidth;
      }
      ctx.strokeText(line, x, y, opts.maxWidth);
    }
    ctx.fillText(line, x, y, opts.maxWidth);
    decorateText(ctx, x, y, line, opts);
    y += Number(font.lineHeight);
  }
  ctx.restore();
}
function addRoundedRectPath(ctx, rect) {
  const { x, y, w, h, radius } = rect;
  ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
  ctx.lineTo(x, y + h - radius.bottomLeft);
  ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
  ctx.lineTo(x + w - radius.bottomRight, y + h);
  ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
  ctx.lineTo(x + w, y + radius.topRight);
  ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
  ctx.lineTo(x + radius.topLeft, y);
}
var LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
var FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function toLineHeight(value, size) {
  const matches = ("" + value).match(LINE_HEIGHT);
  if (!matches || matches[1] === "normal") {
    return size * 1.2;
  }
  value = +matches[2];
  switch (matches[3]) {
    case "px":
      return value;
    case "%":
      value /= 100;
      break;
  }
  return size * value;
}
var numberOrZero = (v) => +v || 0;
function _readValueToProps(value, props) {
  const ret = {};
  const objProps = isObject(props);
  const keys = objProps ? Object.keys(props) : props;
  const read = isObject(value) ? objProps ? (prop) => valueOrDefault(value[prop], value[props[prop]]) : (prop) => value[prop] : () => value;
  for (const prop of keys) {
    ret[prop] = numberOrZero(read(prop));
  }
  return ret;
}
function toTRBL(value) {
  return _readValueToProps(value, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function toTRBLCorners(value) {
  return _readValueToProps(value, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function toPadding(value) {
  const obj = toTRBL(value);
  obj.width = obj.left + obj.right;
  obj.height = obj.top + obj.bottom;
  return obj;
}
function toFont(options, fallback) {
  options = options || {};
  fallback = fallback || defaults.font;
  let size = valueOrDefault(options.size, fallback.size);
  if (typeof size === "string") {
    size = parseInt(size, 10);
  }
  let style = valueOrDefault(options.style, fallback.style);
  if (style && !("" + style).match(FONT_STYLE)) {
    console.warn('Invalid font style specified: "' + style + '"');
    style = void 0;
  }
  const font = {
    family: valueOrDefault(options.family, fallback.family),
    lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
    size,
    style,
    weight: valueOrDefault(options.weight, fallback.weight),
    string: ""
  };
  font.string = toFontString(font);
  return font;
}
function resolve(inputs, context, index2, info) {
  let cacheable = true;
  let i, ilen, value;
  for (i = 0, ilen = inputs.length; i < ilen; ++i) {
    value = inputs[i];
    if (value === void 0) {
      continue;
    }
    if (context !== void 0 && typeof value === "function") {
      value = value(context);
      cacheable = false;
    }
    if (index2 !== void 0 && isArray(value)) {
      value = value[index2 % value.length];
      cacheable = false;
    }
    if (value !== void 0) {
      if (info && !cacheable) {
        info.cacheable = false;
      }
      return value;
    }
  }
}
function _addGrace(minmax, grace, beginAtZero) {
  const { min, max } = minmax;
  const change = toDimension(grace, (max - min) / 2);
  const keepZero = (value, add) => beginAtZero && value === 0 ? 0 : value + add;
  return {
    min: keepZero(min, -Math.abs(change)),
    max: keepZero(max, change)
  };
}
function createContext20(parentContext, context) {
  return Object.assign(Object.create(parentContext), context);
}
function _createResolver(scopes, prefixes = [
  ""
], rootScopes, fallback, getTarget = () => scopes[0]) {
  const finalRootScopes = rootScopes || scopes;
  if (typeof fallback === "undefined") {
    fallback = _resolve("_fallback", scopes);
  }
  const cache = {
    [Symbol.toStringTag]: "Object",
    _cacheable: true,
    _scopes: scopes,
    _rootScopes: finalRootScopes,
    _fallback: fallback,
    _getTarget: getTarget,
    override: (scope) => _createResolver([
      scope,
      ...scopes
    ], prefixes, finalRootScopes, fallback)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop];
      delete target._keys;
      delete scopes[0][prop];
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop) {
      return _cached(target, prop, () => _resolveWithPrefixes(prop, prefixes, scopes, target));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(scopes[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return getKeysFromAllScopes(target).includes(prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(target) {
      return getKeysFromAllScopes(target);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      const storage = target._storage || (target._storage = getTarget());
      target[prop] = storage[prop] = value;
      delete target._keys;
      return true;
    }
  });
}
function _attachContext(proxy, context, subProxy, descriptorDefaults) {
  const cache = {
    _cacheable: false,
    _proxy: proxy,
    _context: context,
    _subProxy: subProxy,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _descriptors(proxy, descriptorDefaults),
    setContext: (ctx) => _attachContext(proxy, ctx, subProxy, descriptorDefaults),
    override: (scope) => _attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
  };
  return new Proxy(cache, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(target, prop) {
      delete target[prop];
      delete proxy[prop];
      return true;
    },
    /**
    * A trap for getting property values.
    */
    get(target, prop, receiver) {
      return _cached(target, prop, () => _resolveWithContext(target, prop, receiver));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(target, prop) {
      return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
        enumerable: true,
        configurable: true
      } : void 0 : Reflect.getOwnPropertyDescriptor(proxy, prop);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(proxy);
    },
    /**
    * A trap for the in operator.
    */
    has(target, prop) {
      return Reflect.has(proxy, prop);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(proxy);
    },
    /**
    * A trap for setting property values.
    */
    set(target, prop, value) {
      proxy[prop] = value;
      delete target[prop];
      return true;
    }
  });
}
function _descriptors(proxy, defaults2 = {
  scriptable: true,
  indexable: true
}) {
  const { _scriptable = defaults2.scriptable, _indexable = defaults2.indexable, _allKeys = defaults2.allKeys } = proxy;
  return {
    allKeys: _allKeys,
    scriptable: _scriptable,
    indexable: _indexable,
    isScriptable: isFunction(_scriptable) ? _scriptable : () => _scriptable,
    isIndexable: isFunction(_indexable) ? _indexable : () => _indexable
  };
}
var readKey = (prefix, name) => prefix ? prefix + _capitalize(name) : name;
var needsSubResolver = (prop, value) => isObject(value) && prop !== "adapters" && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve2) {
  if (Object.prototype.hasOwnProperty.call(target, prop)) {
    return target[prop];
  }
  const value = resolve2();
  target[prop] = value;
  return value;
}
function _resolveWithContext(target, prop, receiver) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  let value = _proxy[prop];
  if (isFunction(value) && descriptors2.isScriptable(prop)) {
    value = _resolveScriptable(prop, value, target, receiver);
  }
  if (isArray(value) && value.length) {
    value = _resolveArray(prop, value, target, descriptors2.isIndexable);
  }
  if (needsSubResolver(prop, value)) {
    value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors2);
  }
  return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
  const { _proxy, _context, _subProxy, _stack } = target;
  if (_stack.has(prop)) {
    throw new Error("Recursion detected: " + Array.from(_stack).join("->") + "->" + prop);
  }
  _stack.add(prop);
  let value = getValue(_context, _subProxy || receiver);
  _stack.delete(prop);
  if (needsSubResolver(prop, value)) {
    value = createSubResolver(_proxy._scopes, _proxy, prop, value);
  }
  return value;
}
function _resolveArray(prop, value, target, isIndexable) {
  const { _proxy, _context, _subProxy, _descriptors: descriptors2 } = target;
  if (typeof _context.index !== "undefined" && isIndexable(prop)) {
    return value[_context.index % value.length];
  } else if (isObject(value[0])) {
    const arr = value;
    const scopes = _proxy._scopes.filter((s) => s !== arr);
    value = [];
    for (const item of arr) {
      const resolver = createSubResolver(scopes, _proxy, prop, item);
      value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors2));
    }
  }
  return value;
}
function resolveFallback(fallback, prop, value) {
  return isFunction(fallback) ? fallback(prop, value) : fallback;
}
var getScope = (key, parent) => key === true ? parent : typeof key === "string" ? resolveObjectKey(parent, key) : void 0;
function addScopes(set2, parentScopes, key, parentFallback, value) {
  for (const parent of parentScopes) {
    const scope = getScope(key, parent);
    if (scope) {
      set2.add(scope);
      const fallback = resolveFallback(scope._fallback, key, value);
      if (typeof fallback !== "undefined" && fallback !== key && fallback !== parentFallback) {
        return fallback;
      }
    } else if (scope === false && typeof parentFallback !== "undefined" && key !== parentFallback) {
      return null;
    }
  }
  return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
  const rootScopes = resolver._rootScopes;
  const fallback = resolveFallback(resolver._fallback, prop, value);
  const allScopes = [
    ...parentScopes,
    ...rootScopes
  ];
  const set2 = /* @__PURE__ */ new Set();
  set2.add(value);
  let key = addScopesFromKey(set2, allScopes, prop, fallback || prop, value);
  if (key === null) {
    return false;
  }
  if (typeof fallback !== "undefined" && fallback !== prop) {
    key = addScopesFromKey(set2, allScopes, fallback, key, value);
    if (key === null) {
      return false;
    }
  }
  return _createResolver(Array.from(set2), [
    ""
  ], rootScopes, fallback, () => subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set2, allScopes, key, fallback, item) {
  while (key) {
    key = addScopes(set2, allScopes, key, fallback, item);
  }
  return key;
}
function subGetTarget(resolver, prop, value) {
  const parent = resolver._getTarget();
  if (!(prop in parent)) {
    parent[prop] = {};
  }
  const target = parent[prop];
  if (isArray(target) && isObject(value)) {
    return value;
  }
  return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
  let value;
  for (const prefix of prefixes) {
    value = _resolve(readKey(prefix, prop), scopes);
    if (typeof value !== "undefined") {
      return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
    }
  }
}
function _resolve(key, scopes) {
  for (const scope of scopes) {
    if (!scope) {
      continue;
    }
    const value = scope[key];
    if (typeof value !== "undefined") {
      return value;
    }
  }
}
function getKeysFromAllScopes(target) {
  let keys = target._keys;
  if (!keys) {
    keys = target._keys = resolveKeysFromAllScopes(target._scopes);
  }
  return keys;
}
function resolveKeysFromAllScopes(scopes) {
  const set2 = /* @__PURE__ */ new Set();
  for (const scope of scopes) {
    for (const key of Object.keys(scope).filter((k) => !k.startsWith("_"))) {
      set2.add(key);
    }
  }
  return Array.from(set2);
}
var EPSILON = Number.EPSILON || 1e-14;
var getPoint = (points, i) => i < points.length && !points[i].skip && points[i];
var getValueAxis = (indexAxis) => indexAxis === "x" ? "y" : "x";
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
  const previous = firstPoint.skip ? middlePoint : firstPoint;
  const current = middlePoint;
  const next = afterPoint.skip ? middlePoint : afterPoint;
  const d01 = distanceBetweenPoints(current, previous);
  const d12 = distanceBetweenPoints(next, current);
  let s01 = d01 / (d01 + d12);
  let s12 = d12 / (d01 + d12);
  s01 = isNaN(s01) ? 0 : s01;
  s12 = isNaN(s12) ? 0 : s12;
  const fa = t * s01;
  const fb = t * s12;
  return {
    previous: {
      x: current.x - fa * (next.x - previous.x),
      y: current.y - fa * (next.y - previous.y)
    },
    next: {
      x: current.x + fb * (next.x - previous.x),
      y: current.y + fb * (next.y - previous.y)
    }
  };
}
function monotoneAdjust(points, deltaK, mK) {
  const pointsLen = points.length;
  let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen - 1; ++i) {
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent || !pointAfter) {
      continue;
    }
    if (almostEquals(deltaK[i], 0, EPSILON)) {
      mK[i] = mK[i + 1] = 0;
      continue;
    }
    alphaK = mK[i] / deltaK[i];
    betaK = mK[i + 1] / deltaK[i];
    squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
    if (squaredMagnitude <= 9) {
      continue;
    }
    tauK = 3 / Math.sqrt(squaredMagnitude);
    mK[i] = alphaK * tauK * deltaK[i];
    mK[i + 1] = betaK * tauK * deltaK[i];
  }
}
function monotoneCompute(points, mK, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  let delta, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (let i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    const iPixel = pointCurrent[indexAxis];
    const vPixel = pointCurrent[valueAxis];
    if (pointBefore) {
      delta = (iPixel - pointBefore[indexAxis]) / 3;
      pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
      pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
    }
    if (pointAfter) {
      delta = (pointAfter[indexAxis] - iPixel) / 3;
      pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
      pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
    }
  }
}
function splineCurveMonotone(points, indexAxis = "x") {
  const valueAxis = getValueAxis(indexAxis);
  const pointsLen = points.length;
  const deltaK = Array(pointsLen).fill(0);
  const mK = Array(pointsLen);
  let i, pointBefore, pointCurrent;
  let pointAfter = getPoint(points, 0);
  for (i = 0; i < pointsLen; ++i) {
    pointBefore = pointCurrent;
    pointCurrent = pointAfter;
    pointAfter = getPoint(points, i + 1);
    if (!pointCurrent) {
      continue;
    }
    if (pointAfter) {
      const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
      deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
    }
    mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
  }
  monotoneAdjust(points, deltaK, mK);
  monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
  return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
  let i, ilen, point, inArea, inAreaPrev;
  let inAreaNext = _isPointInArea(points[0], area);
  for (i = 0, ilen = points.length; i < ilen; ++i) {
    inAreaPrev = inArea;
    inArea = inAreaNext;
    inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
    if (!inArea) {
      continue;
    }
    point = points[i];
    if (inAreaPrev) {
      point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
      point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
    }
    if (inAreaNext) {
      point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
      point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
    }
  }
}
function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
  let i, ilen, point, controlPoints;
  if (options.spanGaps) {
    points = points.filter((pt) => !pt.skip);
  }
  if (options.cubicInterpolationMode === "monotone") {
    splineCurveMonotone(points, indexAxis);
  } else {
    let prev = loop ? points[points.length - 1] : points[0];
    for (i = 0, ilen = points.length; i < ilen; ++i) {
      point = points[i];
      controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
      point.cp1x = controlPoints.previous.x;
      point.cp1y = controlPoints.previous.y;
      point.cp2x = controlPoints.next.x;
      point.cp2y = controlPoints.next.y;
      prev = point;
    }
  }
  if (options.capBezierPoints) {
    capBezierPoints(points, area);
  }
}
function _isDomSupported() {
  return typeof window !== "undefined" && typeof document !== "undefined";
}
function _getParentNode(domNode) {
  let parent = domNode.parentNode;
  if (parent && parent.toString() === "[object ShadowRoot]") {
    parent = parent.host;
  }
  return parent;
}
function parseMaxStyle(styleValue, node, parentProperty) {
  let valueInPixels;
  if (typeof styleValue === "string") {
    valueInPixels = parseInt(styleValue, 10);
    if (styleValue.indexOf("%") !== -1) {
      valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
    }
  } else {
    valueInPixels = styleValue;
  }
  return valueInPixels;
}
var getComputedStyle = (element) => element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
  return getComputedStyle(el).getPropertyValue(property);
}
var positions = [
  "top",
  "right",
  "bottom",
  "left"
];
function getPositionedStyle(styles, style, suffix) {
  const result = {};
  suffix = suffix ? "-" + suffix : "";
  for (let i = 0; i < 4; i++) {
    const pos = positions[i];
    result[pos] = parseFloat(styles[style + "-" + pos + suffix]) || 0;
  }
  result.width = result.left + result.right;
  result.height = result.top + result.bottom;
  return result;
}
var useOffsetPos = (x, y, target) => (x > 0 || y > 0) && (!target || !target.shadowRoot);
function getCanvasPosition(e, canvas) {
  const touches = e.touches;
  const source = touches && touches.length ? touches[0] : e;
  const { offsetX, offsetY } = source;
  let box = false;
  let x, y;
  if (useOffsetPos(offsetX, offsetY, e.target)) {
    x = offsetX;
    y = offsetY;
  } else {
    const rect = canvas.getBoundingClientRect();
    x = source.clientX - rect.left;
    y = source.clientY - rect.top;
    box = true;
  }
  return {
    x,
    y,
    box
  };
}
function getRelativePosition(event, chart) {
  if ("native" in event) {
    return event;
  }
  const { canvas, currentDevicePixelRatio } = chart;
  const style = getComputedStyle(canvas);
  const borderBox = style.boxSizing === "border-box";
  const paddings = getPositionedStyle(style, "padding");
  const borders = getPositionedStyle(style, "border", "width");
  const { x, y, box } = getCanvasPosition(event, canvas);
  const xOffset = paddings.left + (box && borders.left);
  const yOffset = paddings.top + (box && borders.top);
  let { width, height } = chart;
  if (borderBox) {
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  return {
    x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
    y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
  };
}
function getContainerSize(canvas, width, height) {
  let maxWidth, maxHeight;
  if (width === void 0 || height === void 0) {
    const container = _getParentNode(canvas);
    if (!container) {
      width = canvas.clientWidth;
      height = canvas.clientHeight;
    } else {
      const rect = container.getBoundingClientRect();
      const containerStyle = getComputedStyle(container);
      const containerBorder = getPositionedStyle(containerStyle, "border", "width");
      const containerPadding = getPositionedStyle(containerStyle, "padding");
      width = rect.width - containerPadding.width - containerBorder.width;
      height = rect.height - containerPadding.height - containerBorder.height;
      maxWidth = parseMaxStyle(containerStyle.maxWidth, container, "clientWidth");
      maxHeight = parseMaxStyle(containerStyle.maxHeight, container, "clientHeight");
    }
  }
  return {
    width,
    height,
    maxWidth: maxWidth || INFINITY,
    maxHeight: maxHeight || INFINITY
  };
}
var round1 = (v) => Math.round(v * 10) / 10;
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
  const style = getComputedStyle(canvas);
  const margins = getPositionedStyle(style, "margin");
  const maxWidth = parseMaxStyle(style.maxWidth, canvas, "clientWidth") || INFINITY;
  const maxHeight = parseMaxStyle(style.maxHeight, canvas, "clientHeight") || INFINITY;
  const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
  let { width, height } = containerSize;
  if (style.boxSizing === "content-box") {
    const borders = getPositionedStyle(style, "border", "width");
    const paddings = getPositionedStyle(style, "padding");
    width -= paddings.width + borders.width;
    height -= paddings.height + borders.height;
  }
  width = Math.max(0, width - margins.width);
  height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
  width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
  height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
  if (width && !height) {
    height = round1(width / 2);
  }
  const maintainHeight = bbWidth !== void 0 || bbHeight !== void 0;
  if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
    height = containerSize.height;
    width = round1(Math.floor(height * aspectRatio));
  }
  return {
    width,
    height
  };
}
function retinaScale(chart, forceRatio, forceStyle) {
  const pixelRatio = forceRatio || 1;
  const deviceHeight = Math.floor(chart.height * pixelRatio);
  const deviceWidth = Math.floor(chart.width * pixelRatio);
  chart.height = Math.floor(chart.height);
  chart.width = Math.floor(chart.width);
  const canvas = chart.canvas;
  if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
    canvas.style.height = `${chart.height}px`;
    canvas.style.width = `${chart.width}px`;
  }
  if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
    chart.currentDevicePixelRatio = pixelRatio;
    canvas.height = deviceHeight;
    canvas.width = deviceWidth;
    chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
    return true;
  }
  return false;
}
var supportsEventListenerOptions = function() {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener("test", null, options);
    window.removeEventListener("test", null, options);
  } catch (e) {
  }
  return passiveSupported;
}();
function readUsedSize(element, property) {
  const value = getStyle(element, property);
  const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
  return matches ? +matches[1] : void 0;
}
function _pointInLine(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: p1.y + t * (p2.y - p1.y)
  };
}
function _steppedInterpolation(p1, p2, t, mode) {
  return {
    x: p1.x + t * (p2.x - p1.x),
    y: mode === "middle" ? t < 0.5 ? p1.y : p2.y : mode === "after" ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
  };
}
function _bezierInterpolation(p1, p2, t, mode) {
  const cp1 = {
    x: p1.cp2x,
    y: p1.cp2y
  };
  const cp2 = {
    x: p2.cp1x,
    y: p2.cp1y
  };
  const a = _pointInLine(p1, cp1, t);
  const b = _pointInLine(cp1, cp2, t);
  const c = _pointInLine(cp2, p2, t);
  const d = _pointInLine(a, b, t);
  const e = _pointInLine(b, c, t);
  return _pointInLine(d, e, t);
}
var getRightToLeftAdapter = function(rectX, width) {
  return {
    x(x) {
      return rectX + rectX + width - x;
    },
    setWidth(w) {
      width = w;
    },
    textAlign(align) {
      if (align === "center") {
        return align;
      }
      return align === "right" ? "left" : "right";
    },
    xPlus(x, value) {
      return x - value;
    },
    leftForLtr(x, itemWidth) {
      return x - itemWidth;
    }
  };
};
var getLeftToRightAdapter = function() {
  return {
    x(x) {
      return x;
    },
    setWidth(w) {
    },
    textAlign(align) {
      return align;
    },
    xPlus(x, value) {
      return x + value;
    },
    leftForLtr(x, _itemWidth) {
      return x;
    }
  };
};
function getRtlAdapter(rtl, rectX, width) {
  return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
  let style, original;
  if (direction === "ltr" || direction === "rtl") {
    style = ctx.canvas.style;
    original = [
      style.getPropertyValue("direction"),
      style.getPropertyPriority("direction")
    ];
    style.setProperty("direction", direction, "important");
    ctx.prevTextDirection = original;
  }
}
function restoreTextDirection(ctx, original) {
  if (original !== void 0) {
    delete ctx.prevTextDirection;
    ctx.canvas.style.setProperty("direction", original[0], original[1]);
  }
}
function propertyFn(property) {
  if (property === "angle") {
    return {
      between: _angleBetween,
      compare: _angleDiff,
      normalize: _normalizeAngle
    };
  }
  return {
    between: _isBetween,
    compare: (a, b) => a - b,
    normalize: (x) => x
  };
}
function normalizeSegment({ start, end, count, loop, style }) {
  return {
    start: start % count,
    end: end % count,
    loop: loop && (end - start + 1) % count === 0,
    style
  };
}
function getSegment(segment, points, bounds) {
  const { property, start: startBound, end: endBound } = bounds;
  const { between, normalize } = propertyFn(property);
  const count = points.length;
  let { start, end, loop } = segment;
  let i, ilen;
  if (loop) {
    start += count;
    end += count;
    for (i = 0, ilen = count; i < ilen; ++i) {
      if (!between(normalize(points[start % count][property]), startBound, endBound)) {
        break;
      }
      start--;
      end--;
    }
    start %= count;
    end %= count;
  }
  if (end < start) {
    end += count;
  }
  return {
    start,
    end,
    loop,
    style: segment.style
  };
}
function _boundSegment(segment, points, bounds) {
  if (!bounds) {
    return [
      segment
    ];
  }
  const { property, start: startBound, end: endBound } = bounds;
  const count = points.length;
  const { compare, between, normalize } = propertyFn(property);
  const { start, end, loop, style } = getSegment(segment, points, bounds);
  const result = [];
  let inside = false;
  let subStart = null;
  let value, point, prevValue;
  const startIsBefore = () => between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
  const endIsBefore = () => compare(endBound, value) === 0 || between(endBound, prevValue, value);
  const shouldStart = () => inside || startIsBefore();
  const shouldStop = () => !inside || endIsBefore();
  for (let i = start, prev = start; i <= end; ++i) {
    point = points[i % count];
    if (point.skip) {
      continue;
    }
    value = normalize(point[property]);
    if (value === prevValue) {
      continue;
    }
    inside = between(value, startBound, endBound);
    if (subStart === null && shouldStart()) {
      subStart = compare(value, startBound) === 0 ? i : prev;
    }
    if (subStart !== null && shouldStop()) {
      result.push(normalizeSegment({
        start: subStart,
        end: i,
        loop,
        count,
        style
      }));
      subStart = null;
    }
    prev = i;
    prevValue = value;
  }
  if (subStart !== null) {
    result.push(normalizeSegment({
      start: subStart,
      end,
      loop,
      count,
      style
    }));
  }
  return result;
}
function _boundSegments(line, bounds) {
  const result = [];
  const segments = line.segments;
  for (let i = 0; i < segments.length; i++) {
    const sub = _boundSegment(segments[i], line.points, bounds);
    if (sub.length) {
      result.push(...sub);
    }
  }
  return result;
}
function findStartAndEnd(points, count, loop, spanGaps) {
  let start = 0;
  let end = count - 1;
  if (loop && !spanGaps) {
    while (start < count && !points[start].skip) {
      start++;
    }
  }
  while (start < count && points[start].skip) {
    start++;
  }
  start %= count;
  if (loop) {
    end += start;
  }
  while (end > start && points[end % count].skip) {
    end--;
  }
  end %= count;
  return {
    start,
    end
  };
}
function solidSegments(points, start, max, loop) {
  const count = points.length;
  const result = [];
  let last = start;
  let prev = points[start];
  let end;
  for (end = start + 1; end <= max; ++end) {
    const cur = points[end % count];
    if (cur.skip || cur.stop) {
      if (!prev.skip) {
        loop = false;
        result.push({
          start: start % count,
          end: (end - 1) % count,
          loop
        });
        start = last = cur.stop ? end : null;
      }
    } else {
      last = end;
      if (prev.skip) {
        start = end;
      }
    }
    prev = cur;
  }
  if (last !== null) {
    result.push({
      start: start % count,
      end: last % count,
      loop
    });
  }
  return result;
}
function _computeSegments(line, segmentOptions) {
  const points = line.points;
  const spanGaps = line.options.spanGaps;
  const count = points.length;
  if (!count) {
    return [];
  }
  const loop = !!line._loop;
  const { start, end } = findStartAndEnd(points, count, loop, spanGaps);
  if (spanGaps === true) {
    return splitByStyles(line, [
      {
        start,
        end,
        loop
      }
    ], points, segmentOptions);
  }
  const max = end < start ? end + count : end;
  const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
  return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
function splitByStyles(line, segments, points, segmentOptions) {
  if (!segmentOptions || !segmentOptions.setContext || !points) {
    return segments;
  }
  return doSplitByStyles(line, segments, points, segmentOptions);
}
function doSplitByStyles(line, segments, points, segmentOptions) {
  const chartContext = line._chart.getContext();
  const baseStyle = readStyle(line.options);
  const { _datasetIndex: datasetIndex, options: { spanGaps } } = line;
  const count = points.length;
  const result = [];
  let prevStyle = baseStyle;
  let start = segments[0].start;
  let i = start;
  function addStyle(s, e, l, st) {
    const dir = spanGaps ? -1 : 1;
    if (s === e) {
      return;
    }
    s += count;
    while (points[s % count].skip) {
      s -= dir;
    }
    while (points[e % count].skip) {
      e += dir;
    }
    if (s % count !== e % count) {
      result.push({
        start: s % count,
        end: e % count,
        loop: l,
        style: st
      });
      prevStyle = st;
      start = e % count;
    }
  }
  for (const segment of segments) {
    start = spanGaps ? start : segment.start;
    let prev = points[start % count];
    let style;
    for (i = start + 1; i <= segment.end; i++) {
      const pt = points[i % count];
      style = readStyle(segmentOptions.setContext(createContext20(chartContext, {
        type: "segment",
        p0: prev,
        p1: pt,
        p0DataIndex: (i - 1) % count,
        p1DataIndex: i % count,
        datasetIndex
      })));
      if (styleChanged(style, prevStyle)) {
        addStyle(start, i - 1, segment.loop, prevStyle);
      }
      prev = pt;
      prevStyle = style;
    }
    if (start < i - 1) {
      addStyle(start, i - 1, segment.loop, prevStyle);
    }
  }
  return result;
}
function readStyle(options) {
  return {
    backgroundColor: options.backgroundColor,
    borderCapStyle: options.borderCapStyle,
    borderDash: options.borderDash,
    borderDashOffset: options.borderDashOffset,
    borderJoinStyle: options.borderJoinStyle,
    borderWidth: options.borderWidth,
    borderColor: options.borderColor
  };
}
function styleChanged(style, prevStyle) {
  if (!prevStyle) {
    return false;
  }
  const cache = [];
  const replacer = function(key, value) {
    if (!isPatternOrGradient(value)) {
      return value;
    }
    if (!cache.includes(value)) {
      cache.push(value);
    }
    return cache.indexOf(value);
  };
  return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

// ../../node_modules/chart.js/dist/chart.js
var Animator = class {
  constructor() {
    this._request = null;
    this._charts = /* @__PURE__ */ new Map();
    this._running = false;
    this._lastDate = void 0;
  }
  _notify(chart, anims, date, type) {
    const callbacks = anims.listeners[type];
    const numSteps = anims.duration;
    callbacks.forEach((fn) => fn({
      chart,
      initial: anims.initial,
      numSteps,
      currentStep: Math.min(date - anims.start, numSteps)
    }));
  }
  _refresh() {
    if (this._request) {
      return;
    }
    this._running = true;
    this._request = requestAnimFrame.call(window, () => {
      this._update();
      this._request = null;
      if (this._running) {
        this._refresh();
      }
    });
  }
  _update(date = Date.now()) {
    let remaining = 0;
    this._charts.forEach((anims, chart) => {
      if (!anims.running || !anims.items.length) {
        return;
      }
      const items = anims.items;
      let i = items.length - 1;
      let draw2 = false;
      let item;
      for (; i >= 0; --i) {
        item = items[i];
        if (item._active) {
          if (item._total > anims.duration) {
            anims.duration = item._total;
          }
          item.tick(date);
          draw2 = true;
        } else {
          items[i] = items[items.length - 1];
          items.pop();
        }
      }
      if (draw2) {
        chart.draw();
        this._notify(chart, anims, date, "progress");
      }
      if (!items.length) {
        anims.running = false;
        this._notify(chart, anims, date, "complete");
        anims.initial = false;
      }
      remaining += items.length;
    });
    this._lastDate = date;
    if (remaining === 0) {
      this._running = false;
    }
  }
  _getAnims(chart) {
    const charts = this._charts;
    let anims = charts.get(chart);
    if (!anims) {
      anims = {
        running: false,
        initial: true,
        items: [],
        listeners: {
          complete: [],
          progress: []
        }
      };
      charts.set(chart, anims);
    }
    return anims;
  }
  listen(chart, event, cb) {
    this._getAnims(chart).listeners[event].push(cb);
  }
  add(chart, items) {
    if (!items || !items.length) {
      return;
    }
    this._getAnims(chart).items.push(...items);
  }
  has(chart) {
    return this._getAnims(chart).items.length > 0;
  }
  start(chart) {
    const anims = this._charts.get(chart);
    if (!anims) {
      return;
    }
    anims.running = true;
    anims.start = Date.now();
    anims.duration = anims.items.reduce((acc, cur) => Math.max(acc, cur._duration), 0);
    this._refresh();
  }
  running(chart) {
    if (!this._running) {
      return false;
    }
    const anims = this._charts.get(chart);
    if (!anims || !anims.running || !anims.items.length) {
      return false;
    }
    return true;
  }
  stop(chart) {
    const anims = this._charts.get(chart);
    if (!anims || !anims.items.length) {
      return;
    }
    const items = anims.items;
    let i = items.length - 1;
    for (; i >= 0; --i) {
      items[i].cancel();
    }
    anims.items = [];
    this._notify(chart, anims, Date.now(), "complete");
  }
  remove(chart) {
    return this._charts.delete(chart);
  }
};
var animator = /* @__PURE__ */ new Animator();
var transparent = "transparent";
var interpolators = {
  boolean(from2, to2, factor) {
    return factor > 0.5 ? to2 : from2;
  },
  color(from2, to2, factor) {
    const c0 = color(from2 || transparent);
    const c1 = c0.valid && color(to2 || transparent);
    return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to2;
  },
  number(from2, to2, factor) {
    return from2 + (to2 - from2) * factor;
  }
};
var Animation = class {
  constructor(cfg, target, prop, to2) {
    const currentValue = target[prop];
    to2 = resolve([
      cfg.to,
      to2,
      currentValue,
      cfg.from
    ]);
    const from2 = resolve([
      cfg.from,
      currentValue,
      to2
    ]);
    this._active = true;
    this._fn = cfg.fn || interpolators[cfg.type || typeof from2];
    this._easing = effects[cfg.easing] || effects.linear;
    this._start = Math.floor(Date.now() + (cfg.delay || 0));
    this._duration = this._total = Math.floor(cfg.duration);
    this._loop = !!cfg.loop;
    this._target = target;
    this._prop = prop;
    this._from = from2;
    this._to = to2;
    this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(cfg, to2, date) {
    if (this._active) {
      this._notify(false);
      const currentValue = this._target[this._prop];
      const elapsed = date - this._start;
      const remain = this._duration - elapsed;
      this._start = date;
      this._duration = Math.floor(Math.max(remain, cfg.duration));
      this._total += elapsed;
      this._loop = !!cfg.loop;
      this._to = resolve([
        cfg.to,
        to2,
        currentValue,
        cfg.from
      ]);
      this._from = resolve([
        cfg.from,
        currentValue,
        to2
      ]);
    }
  }
  cancel() {
    if (this._active) {
      this.tick(Date.now());
      this._active = false;
      this._notify(false);
    }
  }
  tick(date) {
    const elapsed = date - this._start;
    const duration = this._duration;
    const prop = this._prop;
    const from2 = this._from;
    const loop = this._loop;
    const to2 = this._to;
    let factor;
    this._active = from2 !== to2 && (loop || elapsed < duration);
    if (!this._active) {
      this._target[prop] = to2;
      this._notify(true);
      return;
    }
    if (elapsed < 0) {
      this._target[prop] = from2;
      return;
    }
    factor = elapsed / duration % 2;
    factor = loop && factor > 1 ? 2 - factor : factor;
    factor = this._easing(Math.min(1, Math.max(0, factor)));
    this._target[prop] = this._fn(from2, to2, factor);
  }
  wait() {
    const promises = this._promises || (this._promises = []);
    return new Promise((res, rej) => {
      promises.push({
        res,
        rej
      });
    });
  }
  _notify(resolved) {
    const method = resolved ? "res" : "rej";
    const promises = this._promises || [];
    for (let i = 0; i < promises.length; i++) {
      promises[i][method]();
    }
  }
};
var Animations = class {
  constructor(chart, config) {
    this._chart = chart;
    this._properties = /* @__PURE__ */ new Map();
    this.configure(config);
  }
  configure(config) {
    if (!isObject(config)) {
      return;
    }
    const animationOptions = Object.keys(defaults.animation);
    const animatedProps = this._properties;
    Object.getOwnPropertyNames(config).forEach((key) => {
      const cfg = config[key];
      if (!isObject(cfg)) {
        return;
      }
      const resolved = {};
      for (const option of animationOptions) {
        resolved[option] = cfg[option];
      }
      (isArray(cfg.properties) && cfg.properties || [
        key
      ]).forEach((prop) => {
        if (prop === key || !animatedProps.has(prop)) {
          animatedProps.set(prop, resolved);
        }
      });
    });
  }
  _animateOptions(target, values) {
    const newOptions = values.options;
    const options = resolveTargetOptions(target, newOptions);
    if (!options) {
      return [];
    }
    const animations = this._createAnimations(options, newOptions);
    if (newOptions.$shared) {
      awaitAll(target.options.$animations, newOptions).then(() => {
        target.options = newOptions;
      }, () => {
      });
    }
    return animations;
  }
  _createAnimations(target, values) {
    const animatedProps = this._properties;
    const animations = [];
    const running = target.$animations || (target.$animations = {});
    const props = Object.keys(values);
    const date = Date.now();
    let i;
    for (i = props.length - 1; i >= 0; --i) {
      const prop = props[i];
      if (prop.charAt(0) === "$") {
        continue;
      }
      if (prop === "options") {
        animations.push(...this._animateOptions(target, values));
        continue;
      }
      const value = values[prop];
      let animation = running[prop];
      const cfg = animatedProps.get(prop);
      if (animation) {
        if (cfg && animation.active()) {
          animation.update(cfg, value, date);
          continue;
        } else {
          animation.cancel();
        }
      }
      if (!cfg || !cfg.duration) {
        target[prop] = value;
        continue;
      }
      running[prop] = animation = new Animation(cfg, target, prop, value);
      animations.push(animation);
    }
    return animations;
  }
  update(target, values) {
    if (this._properties.size === 0) {
      Object.assign(target, values);
      return;
    }
    const animations = this._createAnimations(target, values);
    if (animations.length) {
      animator.add(this._chart, animations);
      return true;
    }
  }
};
function awaitAll(animations, properties) {
  const running = [];
  const keys = Object.keys(properties);
  for (let i = 0; i < keys.length; i++) {
    const anim = animations[keys[i]];
    if (anim && anim.active()) {
      running.push(anim.wait());
    }
  }
  return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
  if (!newOptions) {
    return;
  }
  let options = target.options;
  if (!options) {
    target.options = newOptions;
    return;
  }
  if (options.$shared) {
    target.options = options = Object.assign({}, options, {
      $shared: false,
      $animations: {}
    });
  }
  return options;
}
function scaleClip(scale, allowedOverflow) {
  const opts = scale && scale.options || {};
  const reverse = opts.reverse;
  const min = opts.min === void 0 ? allowedOverflow : 0;
  const max = opts.max === void 0 ? allowedOverflow : 0;
  return {
    start: reverse ? max : min,
    end: reverse ? min : max
  };
}
function defaultClip(xScale, yScale, allowedOverflow) {
  if (allowedOverflow === false) {
    return false;
  }
  const x = scaleClip(xScale, allowedOverflow);
  const y = scaleClip(yScale, allowedOverflow);
  return {
    top: y.end,
    right: x.end,
    bottom: y.start,
    left: x.start
  };
}
function toClip(value) {
  let t, r, b, l;
  if (isObject(value)) {
    t = value.top;
    r = value.right;
    b = value.bottom;
    l = value.left;
  } else {
    t = r = b = l = value;
  }
  return {
    top: t,
    right: r,
    bottom: b,
    left: l,
    disabled: value === false
  };
}
function getSortedDatasetIndices(chart, filterVisible) {
  const keys = [];
  const metasets = chart._getSortedDatasetMetas(filterVisible);
  let i, ilen;
  for (i = 0, ilen = metasets.length; i < ilen; ++i) {
    keys.push(metasets[i].index);
  }
  return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
  const keys = stack.keys;
  const singleMode = options.mode === "single";
  let i, ilen, datasetIndex, otherValue;
  if (value === null) {
    return;
  }
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    datasetIndex = +keys[i];
    if (datasetIndex === dsIndex) {
      if (options.all) {
        continue;
      }
      break;
    }
    otherValue = stack.values[datasetIndex];
    if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
      value += otherValue;
    }
  }
  return value;
}
function convertObjectDataToArray(data) {
  const keys = Object.keys(data);
  const adata = new Array(keys.length);
  let i, ilen, key;
  for (i = 0, ilen = keys.length; i < ilen; ++i) {
    key = keys[i];
    adata[i] = {
      x: key,
      y: data[key]
    };
  }
  return adata;
}
function isStacked(scale, meta) {
  const stacked = scale && scale.options.stacked;
  return stacked || stacked === void 0 && meta.stack !== void 0;
}
function getStackKey(indexScale, valueScale, meta) {
  return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
  const { min, max, minDefined, maxDefined } = scale.getUserBounds();
  return {
    min: minDefined ? min : Number.NEGATIVE_INFINITY,
    max: maxDefined ? max : Number.POSITIVE_INFINITY
  };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
  const subStack = stacks[stackKey] || (stacks[stackKey] = {});
  return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
  for (const meta of vScale.getMatchingVisibleMetas(type).reverse()) {
    const value = stack[meta.index];
    if (positive && value > 0 || !positive && value < 0) {
      return meta.index;
    }
  }
  return null;
}
function updateStacks(controller, parsed) {
  const { chart, _cachedMeta: meta } = controller;
  const stacks = chart._stacks || (chart._stacks = {});
  const { iScale, vScale, index: datasetIndex } = meta;
  const iAxis = iScale.axis;
  const vAxis = vScale.axis;
  const key = getStackKey(iScale, vScale, meta);
  const ilen = parsed.length;
  let stack;
  for (let i = 0; i < ilen; ++i) {
    const item = parsed[i];
    const { [iAxis]: index2, [vAxis]: value } = item;
    const itemStacks = item._stacks || (item._stacks = {});
    stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index2);
    stack[datasetIndex] = value;
    stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
    stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
    const visualValues = stack._visualValues || (stack._visualValues = {});
    visualValues[datasetIndex] = value;
  }
}
function getFirstScaleId(chart, axis) {
  const scales = chart.scales;
  return Object.keys(scales).filter((key) => scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index2) {
  return createContext20(parent, {
    active: false,
    dataset: void 0,
    datasetIndex: index2,
    index: index2,
    mode: "default",
    type: "dataset"
  });
}
function createDataContext(parent, index2, element) {
  return createContext20(parent, {
    active: false,
    dataIndex: index2,
    parsed: void 0,
    raw: void 0,
    element,
    index: index2,
    mode: "default",
    type: "data"
  });
}
function clearStacks(meta, items) {
  const datasetIndex = meta.controller.index;
  const axis = meta.vScale && meta.vScale.axis;
  if (!axis) {
    return;
  }
  items = items || meta._parsed;
  for (const parsed of items) {
    const stacks = parsed._stacks;
    if (!stacks || stacks[axis] === void 0 || stacks[axis][datasetIndex] === void 0) {
      return;
    }
    delete stacks[axis][datasetIndex];
    if (stacks[axis]._visualValues !== void 0 && stacks[axis]._visualValues[datasetIndex] !== void 0) {
      delete stacks[axis]._visualValues[datasetIndex];
    }
  }
}
var isDirectUpdateMode = (mode) => mode === "reset" || mode === "none";
var cloneIfNotShared = (cached, shared) => shared ? cached : Object.assign({}, cached);
var createStack = (canStack, meta, chart) => canStack && !meta.hidden && meta._stacked && {
  keys: getSortedDatasetIndices(chart, true),
  values: null
};
var DatasetController = class {
  static defaults = {};
  static datasetElementType = null;
  static dataElementType = null;
  constructor(chart, datasetIndex) {
    this.chart = chart;
    this._ctx = chart.ctx;
    this.index = datasetIndex;
    this._cachedDataOpts = {};
    this._cachedMeta = this.getMeta();
    this._type = this._cachedMeta.type;
    this.options = void 0;
    this._parsing = false;
    this._data = void 0;
    this._objectData = void 0;
    this._sharedOptions = void 0;
    this._drawStart = void 0;
    this._drawCount = void 0;
    this.enableOptionSharing = false;
    this.supportsDecimation = false;
    this.$context = void 0;
    this._syncList = [];
    this.datasetElementType = new.target.datasetElementType;
    this.dataElementType = new.target.dataElementType;
    this.initialize();
  }
  initialize() {
    const meta = this._cachedMeta;
    this.configure();
    this.linkScales();
    meta._stacked = isStacked(meta.vScale, meta);
    this.addElements();
    if (this.options.fill && !this.chart.isPluginEnabled("filler")) {
      console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
    }
  }
  updateIndex(datasetIndex) {
    if (this.index !== datasetIndex) {
      clearStacks(this._cachedMeta);
    }
    this.index = datasetIndex;
  }
  linkScales() {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    const chooseId = (axis, x, y, r) => axis === "x" ? x : axis === "r" ? r : y;
    const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, "x"));
    const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, "y"));
    const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, "r"));
    const indexAxis = meta.indexAxis;
    const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
    const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
    meta.xScale = this.getScaleForId(xid);
    meta.yScale = this.getScaleForId(yid);
    meta.rScale = this.getScaleForId(rid);
    meta.iScale = this.getScaleForId(iid);
    meta.vScale = this.getScaleForId(vid);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(scaleID) {
    return this.chart.scales[scaleID];
  }
  _getOtherScale(scale) {
    const meta = this._cachedMeta;
    return scale === meta.iScale ? meta.vScale : meta.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const meta = this._cachedMeta;
    if (this._data) {
      unlistenArrayEvents(this._data, this);
    }
    if (meta._stacked) {
      clearStacks(meta);
    }
  }
  _dataCheck() {
    const dataset = this.getDataset();
    const data = dataset.data || (dataset.data = []);
    const _data = this._data;
    if (isObject(data)) {
      this._data = convertObjectDataToArray(data);
    } else if (_data !== data) {
      if (_data) {
        unlistenArrayEvents(_data, this);
        const meta = this._cachedMeta;
        clearStacks(meta);
        meta._parsed = [];
      }
      if (data && Object.isExtensible(data)) {
        listenArrayEvents(data, this);
      }
      this._syncList = [];
      this._data = data;
    }
  }
  addElements() {
    const meta = this._cachedMeta;
    this._dataCheck();
    if (this.datasetElementType) {
      meta.dataset = new this.datasetElementType();
    }
  }
  buildOrUpdateElements(resetNewElements) {
    const meta = this._cachedMeta;
    const dataset = this.getDataset();
    let stackChanged = false;
    this._dataCheck();
    const oldStacked = meta._stacked;
    meta._stacked = isStacked(meta.vScale, meta);
    if (meta.stack !== dataset.stack) {
      stackChanged = true;
      clearStacks(meta);
      meta.stack = dataset.stack;
    }
    this._resyncElements(resetNewElements);
    if (stackChanged || oldStacked !== meta._stacked) {
      updateStacks(this, meta._parsed);
    }
  }
  configure() {
    const config = this.chart.config;
    const scopeKeys = config.datasetScopeKeys(this._type);
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
    this.options = config.createResolver(scopes, this.getContext());
    this._parsing = this.options.parsing;
    this._cachedDataOpts = {};
  }
  parse(start, count) {
    const { _cachedMeta: meta, _data: data } = this;
    const { iScale, _stacked } = meta;
    const iAxis = iScale.axis;
    let sorted = start === 0 && count === data.length ? true : meta._sorted;
    let prev = start > 0 && meta._parsed[start - 1];
    let i, cur, parsed;
    if (this._parsing === false) {
      meta._parsed = data;
      meta._sorted = true;
      parsed = data;
    } else {
      if (isArray(data[start])) {
        parsed = this.parseArrayData(meta, data, start, count);
      } else if (isObject(data[start])) {
        parsed = this.parseObjectData(meta, data, start, count);
      } else {
        parsed = this.parsePrimitiveData(meta, data, start, count);
      }
      const isNotInOrderComparedToPrev = () => cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
      for (i = 0; i < count; ++i) {
        meta._parsed[i + start] = cur = parsed[i];
        if (sorted) {
          if (isNotInOrderComparedToPrev()) {
            sorted = false;
          }
          prev = cur;
        }
      }
      meta._sorted = sorted;
    }
    if (_stacked) {
      updateStacks(this, parsed);
    }
  }
  parsePrimitiveData(meta, data, start, count) {
    const { iScale, vScale } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = new Array(count);
    let i, ilen, index2;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      parsed[i] = {
        [iAxis]: singleScale || iScale.parse(labels[index2], index2),
        [vAxis]: vScale.parse(data[index2], index2)
      };
    }
    return parsed;
  }
  parseArrayData(meta, data, start, count) {
    const { xScale, yScale } = meta;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      item = data[index2];
      parsed[i] = {
        x: xScale.parse(item[0], index2),
        y: yScale.parse(item[1], index2)
      };
    }
    return parsed;
  }
  parseObjectData(meta, data, start, count) {
    const { xScale, yScale } = meta;
    const { xAxisKey = "x", yAxisKey = "y" } = this._parsing;
    const parsed = new Array(count);
    let i, ilen, index2, item;
    for (i = 0, ilen = count; i < ilen; ++i) {
      index2 = i + start;
      item = data[index2];
      parsed[i] = {
        x: xScale.parse(resolveObjectKey(item, xAxisKey), index2),
        y: yScale.parse(resolveObjectKey(item, yAxisKey), index2)
      };
    }
    return parsed;
  }
  getParsed(index2) {
    return this._cachedMeta._parsed[index2];
  }
  getDataElement(index2) {
    return this._cachedMeta.data[index2];
  }
  applyStack(scale, parsed, mode) {
    const chart = this.chart;
    const meta = this._cachedMeta;
    const value = parsed[scale.axis];
    const stack = {
      keys: getSortedDatasetIndices(chart, true),
      values: parsed._stacks[scale.axis]._visualValues
    };
    return applyStack(stack, value, meta.index, {
      mode
    });
  }
  updateRangeFromParsed(range, scale, parsed, stack) {
    const parsedValue = parsed[scale.axis];
    let value = parsedValue === null ? NaN : parsedValue;
    const values = stack && parsed._stacks[scale.axis];
    if (stack && values) {
      stack.values = values;
      value = applyStack(stack, parsedValue, this._cachedMeta.index);
    }
    range.min = Math.min(range.min, value);
    range.max = Math.max(range.max, value);
  }
  getMinMax(scale, canStack) {
    const meta = this._cachedMeta;
    const _parsed = meta._parsed;
    const sorted = meta._sorted && scale === meta.iScale;
    const ilen = _parsed.length;
    const otherScale = this._getOtherScale(scale);
    const stack = createStack(canStack, meta, this.chart);
    const range = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    };
    const { min: otherMin, max: otherMax } = getUserBounds(otherScale);
    let i, parsed;
    function _skip() {
      parsed = _parsed[i];
      const otherValue = parsed[otherScale.axis];
      return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
    }
    for (i = 0; i < ilen; ++i) {
      if (_skip()) {
        continue;
      }
      this.updateRangeFromParsed(range, scale, parsed, stack);
      if (sorted) {
        break;
      }
    }
    if (sorted) {
      for (i = ilen - 1; i >= 0; --i) {
        if (_skip()) {
          continue;
        }
        this.updateRangeFromParsed(range, scale, parsed, stack);
        break;
      }
    }
    return range;
  }
  getAllParsedValues(scale) {
    const parsed = this._cachedMeta._parsed;
    const values = [];
    let i, ilen, value;
    for (i = 0, ilen = parsed.length; i < ilen; ++i) {
      value = parsed[i][scale.axis];
      if (isNumberFinite(value)) {
        values.push(value);
      }
    }
    return values;
  }
  getMaxOverflow() {
    return false;
  }
  getLabelAndValue(index2) {
    const meta = this._cachedMeta;
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const parsed = this.getParsed(index2);
    return {
      label: iScale ? "" + iScale.getLabelForValue(parsed[iScale.axis]) : "",
      value: vScale ? "" + vScale.getLabelForValue(parsed[vScale.axis]) : ""
    };
  }
  _update(mode) {
    const meta = this._cachedMeta;
    this.update(mode || "default");
    meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
  }
  update(mode) {
  }
  draw() {
    const ctx = this._ctx;
    const chart = this.chart;
    const meta = this._cachedMeta;
    const elements = meta.data || [];
    const area = chart.chartArea;
    const active = [];
    const start = this._drawStart || 0;
    const count = this._drawCount || elements.length - start;
    const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
    let i;
    if (meta.dataset) {
      meta.dataset.draw(ctx, area, start, count);
    }
    for (i = start; i < start + count; ++i) {
      const element = elements[i];
      if (element.hidden) {
        continue;
      }
      if (element.active && drawActiveElementsOnTop) {
        active.push(element);
      } else {
        element.draw(ctx, area);
      }
    }
    for (i = 0; i < active.length; ++i) {
      active[i].draw(ctx, area);
    }
  }
  getStyle(index2, active) {
    const mode = active ? "active" : "default";
    return index2 === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index2 || 0, mode);
  }
  getContext(index2, active, mode) {
    const dataset = this.getDataset();
    let context;
    if (index2 >= 0 && index2 < this._cachedMeta.data.length) {
      const element = this._cachedMeta.data[index2];
      context = element.$context || (element.$context = createDataContext(this.getContext(), index2, element));
      context.parsed = this.getParsed(index2);
      context.raw = dataset.data[index2];
      context.index = context.dataIndex = index2;
    } else {
      context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
      context.dataset = dataset;
      context.index = context.datasetIndex = this.index;
    }
    context.active = !!active;
    context.mode = mode;
    return context;
  }
  resolveDatasetElementOptions(mode) {
    return this._resolveElementOptions(this.datasetElementType.id, mode);
  }
  resolveDataElementOptions(index2, mode) {
    return this._resolveElementOptions(this.dataElementType.id, mode, index2);
  }
  _resolveElementOptions(elementType, mode = "default", index2) {
    const active = mode === "active";
    const cache = this._cachedDataOpts;
    const cacheKey = elementType + "-" + mode;
    const cached = cache[cacheKey];
    const sharing = this.enableOptionSharing && defined(index2);
    if (cached) {
      return cloneIfNotShared(cached, sharing);
    }
    const config = this.chart.config;
    const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
    const prefixes = active ? [
      `${elementType}Hover`,
      "hover",
      elementType,
      ""
    ] : [
      elementType,
      ""
    ];
    const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
    const names2 = Object.keys(defaults.elements[elementType]);
    const context = () => this.getContext(index2, active, mode);
    const values = config.resolveNamedOptions(scopes, names2, context, prefixes);
    if (values.$shared) {
      values.$shared = sharing;
      cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
    }
    return values;
  }
  _resolveAnimations(index2, transition, active) {
    const chart = this.chart;
    const cache = this._cachedDataOpts;
    const cacheKey = `animation-${transition}`;
    const cached = cache[cacheKey];
    if (cached) {
      return cached;
    }
    let options;
    if (chart.options.animation !== false) {
      const config = this.chart.config;
      const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
      const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
      options = config.createResolver(scopes, this.getContext(index2, active, transition));
    }
    const animations = new Animations(chart, options && options.animations);
    if (options && options._cacheable) {
      cache[cacheKey] = Object.freeze(animations);
    }
    return animations;
  }
  getSharedOptions(options) {
    if (!options.$shared) {
      return;
    }
    return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
  }
  includeOptions(mode, sharedOptions) {
    return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
  }
  _getSharedOptions(start, mode) {
    const firstOpts = this.resolveDataElementOptions(start, mode);
    const previouslySharedOptions = this._sharedOptions;
    const sharedOptions = this.getSharedOptions(firstOpts);
    const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
    this.updateSharedOptions(sharedOptions, mode, firstOpts);
    return {
      sharedOptions,
      includeOptions
    };
  }
  updateElement(element, index2, properties, mode) {
    if (isDirectUpdateMode(mode)) {
      Object.assign(element, properties);
    } else {
      this._resolveAnimations(index2, mode).update(element, properties);
    }
  }
  updateSharedOptions(sharedOptions, mode, newOptions) {
    if (sharedOptions && !isDirectUpdateMode(mode)) {
      this._resolveAnimations(void 0, mode).update(sharedOptions, newOptions);
    }
  }
  _setStyle(element, index2, mode, active) {
    element.active = active;
    const options = this.getStyle(index2, active);
    this._resolveAnimations(index2, mode, active).update(element, {
      options: !active && this.getSharedOptions(options) || options
    });
  }
  removeHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", false);
  }
  setHoverStyle(element, datasetIndex, index2) {
    this._setStyle(element, index2, "active", true);
  }
  _removeDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", false);
    }
  }
  _setDatasetHoverStyle() {
    const element = this._cachedMeta.dataset;
    if (element) {
      this._setStyle(element, void 0, "active", true);
    }
  }
  _resyncElements(resetNewElements) {
    const data = this._data;
    const elements = this._cachedMeta.data;
    for (const [method, arg1, arg2] of this._syncList) {
      this[method](arg1, arg2);
    }
    this._syncList = [];
    const numMeta = elements.length;
    const numData = data.length;
    const count = Math.min(numData, numMeta);
    if (count) {
      this.parse(0, count);
    }
    if (numData > numMeta) {
      this._insertElements(numMeta, numData - numMeta, resetNewElements);
    } else if (numData < numMeta) {
      this._removeElements(numData, numMeta - numData);
    }
  }
  _insertElements(start, count, resetNewElements = true) {
    const meta = this._cachedMeta;
    const data = meta.data;
    const end = start + count;
    let i;
    const move = (arr) => {
      arr.length += count;
      for (i = arr.length - 1; i >= end; i--) {
        arr[i] = arr[i - count];
      }
    };
    move(data);
    for (i = start; i < end; ++i) {
      data[i] = new this.dataElementType();
    }
    if (this._parsing) {
      move(meta._parsed);
    }
    this.parse(start, count);
    if (resetNewElements) {
      this.updateElements(data, start, count, "reset");
    }
  }
  updateElements(element, start, count, mode) {
  }
  _removeElements(start, count) {
    const meta = this._cachedMeta;
    if (this._parsing) {
      const removed = meta._parsed.splice(start, count);
      if (meta._stacked) {
        clearStacks(meta, removed);
      }
    }
    meta.data.splice(start, count);
  }
  _sync(args) {
    if (this._parsing) {
      this._syncList.push(args);
    } else {
      const [method, arg1, arg2] = args;
      this[method](arg1, arg2);
    }
    this.chart._dataChanges.push([
      this.index,
      ...args
    ]);
  }
  _onDataPush() {
    const count = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - count,
      count
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(start, count) {
    if (count) {
      this._sync([
        "_removeElements",
        start,
        count
      ]);
    }
    const newCount = arguments.length - 2;
    if (newCount) {
      this._sync([
        "_insertElements",
        start,
        newCount
      ]);
    }
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
};
var LineController = class extends DatasetController {
  static id = "line";
  static defaults = {
    datasetElementType: "line",
    dataElementType: "point",
    showLine: true,
    spanGaps: false
  };
  static overrides = {
    scales: {
      _index_: {
        type: "category"
      },
      _value_: {
        type: "linear"
      }
    }
  };
  initialize() {
    this.enableOptionSharing = true;
    this.supportsDecimation = true;
    super.initialize();
  }
  update(mode) {
    const meta = this._cachedMeta;
    const { dataset: line, data: points = [], _dataset } = meta;
    const animationsDisabled = this.chart._animationsDisabled;
    let { start, count } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
    this._drawStart = start;
    this._drawCount = count;
    if (_scaleRangesChanged(meta)) {
      start = 0;
      count = points.length;
    }
    line._chart = this.chart;
    line._datasetIndex = this.index;
    line._decimated = !!_dataset._decimated;
    line.points = points;
    const options = this.resolveDatasetElementOptions(mode);
    if (!this.options.showLine) {
      options.borderWidth = 0;
    }
    options.segment = this.options.segment;
    this.updateElement(line, void 0, {
      animated: !animationsDisabled,
      options
    }, mode);
    this.updateElements(points, start, count, mode);
  }
  updateElements(points, start, count, mode) {
    const reset = mode === "reset";
    const { iScale, vScale, _stacked, _dataset } = this._cachedMeta;
    const { sharedOptions, includeOptions } = this._getSharedOptions(start, mode);
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const { spanGaps, segment } = this.options;
    const maxGapLength = isNumber5(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
    const directUpdate = this.chart._animationsDisabled || reset || mode === "none";
    const end = start + count;
    const pointsCount = points.length;
    let prevParsed = start > 0 && this.getParsed(start - 1);
    for (let i = 0; i < pointsCount; ++i) {
      const point = points[i];
      const properties = directUpdate ? point : {};
      if (i < start || i >= end) {
        properties.skip = true;
        continue;
      }
      const parsed = this.getParsed(i);
      const nullData = isNullOrUndef(parsed[vAxis]);
      const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
      const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
      properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
      properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
      if (segment) {
        properties.parsed = parsed;
        properties.raw = _dataset.data[i];
      }
      if (includeOptions) {
        properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? "active" : mode);
      }
      if (!directUpdate) {
        this.updateElement(point, i, properties, mode);
      }
      prevParsed = parsed;
    }
  }
  getMaxOverflow() {
    const meta = this._cachedMeta;
    const dataset = meta.dataset;
    const border = dataset.options && dataset.options.borderWidth || 0;
    const data = meta.data || [];
    if (!data.length) {
      return border;
    }
    const firstPoint = data[0].size(this.resolveDataElementOptions(0));
    const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
    return Math.max(border, firstPoint, lastPoint) / 2;
  }
  draw() {
    const meta = this._cachedMeta;
    meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
    super.draw();
  }
};
function abstract() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
var DateAdapterBase = class _DateAdapterBase {
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(members) {
    Object.assign(_DateAdapterBase.prototype, members);
  }
  options;
  constructor(options) {
    this.options = options || {};
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return abstract();
  }
  parse() {
    return abstract();
  }
  format() {
    return abstract();
  }
  add() {
    return abstract();
  }
  diff() {
    return abstract();
  }
  startOf() {
    return abstract();
  }
  endOf() {
    return abstract();
  }
};
var adapters = {
  _date: DateAdapterBase
};
function binarySearch(metaset, axis, value, intersect) {
  const { controller, data, _sorted } = metaset;
  const iScale = controller._cachedMeta.iScale;
  if (iScale && axis === iScale.axis && axis !== "r" && _sorted && data.length) {
    const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
    if (!intersect) {
      return lookupMethod(data, axis, value);
    } else if (controller._sharedOptions) {
      const el = data[0];
      const range = typeof el.getRange === "function" && el.getRange(axis);
      if (range) {
        const start = lookupMethod(data, axis, value - range);
        const end = lookupMethod(data, axis, value + range);
        return {
          lo: start.lo,
          hi: end.hi
        };
      }
    }
  }
  return {
    lo: 0,
    hi: data.length - 1
  };
}
function evaluateInteractionItems(chart, axis, position, handler, intersect) {
  const metasets = chart.getSortedVisibleDatasetMetas();
  const value = position[axis];
  for (let i = 0, ilen = metasets.length; i < ilen; ++i) {
    const { index: index2, data } = metasets[i];
    const { lo, hi } = binarySearch(metasets[i], axis, value, intersect);
    for (let j = lo; j <= hi; ++j) {
      const element = data[j];
      if (!element.skip) {
        handler(element, index2, j);
      }
    }
  }
}
function getDistanceMetricForAxis(axis) {
  const useX = axis.indexOf("x") !== -1;
  const useY = axis.indexOf("y") !== -1;
  return function(pt1, pt2) {
    const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
    const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
    return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
  };
}
function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
  const items = [];
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return items;
  }
  const evaluationFunc = function(element, datasetIndex, index2) {
    if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
      return;
    }
    if (element.inRange(position.x, position.y, useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  };
  evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
  return items;
}
function getNearestRadialItems(chart, position, axis, useFinalPosition) {
  let items = [];
  function evaluationFunc(element, datasetIndex, index2) {
    const { startAngle, endAngle } = element.getProps([
      "startAngle",
      "endAngle"
    ], useFinalPosition);
    const { angle } = getAngleFromPoint(element, {
      x: position.x,
      y: position.y
    });
    if (_angleBetween(angle, startAngle, endAngle)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  let items = [];
  const distanceMetric = getDistanceMetricForAxis(axis);
  let minDistance = Number.POSITIVE_INFINITY;
  function evaluationFunc(element, datasetIndex, index2) {
    const inRange = element.inRange(position.x, position.y, useFinalPosition);
    if (intersect && !inRange) {
      return;
    }
    const center = element.getCenterPoint(useFinalPosition);
    const pointInArea = !!includeInvisible || chart.isPointInArea(center);
    if (!pointInArea && !inRange) {
      return;
    }
    const distance = distanceMetric(position, center);
    if (distance < minDistance) {
      items = [
        {
          element,
          datasetIndex,
          index: index2
        }
      ];
      minDistance = distance;
    } else if (distance === minDistance) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
    }
  }
  evaluateInteractionItems(chart, axis, position, evaluationFunc);
  return items;
}
function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
  if (!includeInvisible && !chart.isPointInArea(position)) {
    return [];
  }
  return axis === "r" && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
  const items = [];
  const rangeMethod = axis === "x" ? "inXRange" : "inYRange";
  let intersectsItem = false;
  evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index2) => {
    if (element[rangeMethod](position[axis], useFinalPosition)) {
      items.push({
        element,
        datasetIndex,
        index: index2
      });
      intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
    }
  });
  if (intersect && !intersectsItem) {
    return [];
  }
  return items;
}
var Interaction = {
  evaluateInteractionItems,
  modes: {
    index(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "x";
      const includeInvisible = options.includeInvisible || false;
      const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      const elements = [];
      if (!items.length) {
        return [];
      }
      chart.getSortedVisibleDatasetMetas().forEach((meta) => {
        const index2 = items[0].index;
        const element = meta.data[index2];
        if (element && !element.skip) {
          elements.push({
            element,
            datasetIndex: meta.index,
            index: index2
          });
        }
      });
      return elements;
    },
    dataset(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
      if (items.length > 0) {
        const datasetIndex = items[0].datasetIndex;
        const data = chart.getDatasetMeta(datasetIndex).data;
        items = [];
        for (let i = 0; i < data.length; ++i) {
          items.push({
            element: data[i],
            datasetIndex,
            index: i
          });
        }
      }
      return items;
    },
    point(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
    },
    nearest(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      const axis = options.axis || "xy";
      const includeInvisible = options.includeInvisible || false;
      return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
    },
    x(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, "x", options.intersect, useFinalPosition);
    },
    y(chart, e, options, useFinalPosition) {
      const position = getRelativePosition(e, chart);
      return getAxisItems(chart, position, "y", options.intersect, useFinalPosition);
    }
  }
};
var STATIC_POSITIONS = [
  "left",
  "top",
  "right",
  "bottom"
];
function filterByPosition(array, position) {
  return array.filter((v) => v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
  return array.filter((v) => STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
  return array.sort((a, b) => {
    const v0 = reverse ? b : a;
    const v1 = reverse ? a : b;
    return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
  });
}
function wrapBoxes(boxes) {
  const layoutBoxes = [];
  let i, ilen, box, pos, stack, stackWeight;
  for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
    box = boxes[i];
    ({ position: pos, options: { stack, stackWeight = 1 } } = box);
    layoutBoxes.push({
      index: i,
      box,
      pos,
      horizontal: box.isHorizontal(),
      weight: box.weight,
      stack: stack && pos + stack,
      stackWeight
    });
  }
  return layoutBoxes;
}
function buildStacks(layouts2) {
  const stacks = {};
  for (const wrap of layouts2) {
    const { stack, pos, stackWeight } = wrap;
    if (!stack || !STATIC_POSITIONS.includes(pos)) {
      continue;
    }
    const _stack = stacks[stack] || (stacks[stack] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    _stack.count++;
    _stack.weight += stackWeight;
  }
  return stacks;
}
function setLayoutDims(layouts2, params) {
  const stacks = buildStacks(layouts2);
  const { vBoxMaxWidth, hBoxMaxHeight } = params;
  let i, ilen, layout;
  for (i = 0, ilen = layouts2.length; i < ilen; ++i) {
    layout = layouts2[i];
    const { fullSize } = layout.box;
    const stack = stacks[layout.stack];
    const factor = stack && layout.stackWeight / stack.weight;
    if (layout.horizontal) {
      layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
      layout.height = hBoxMaxHeight;
    } else {
      layout.width = vBoxMaxWidth;
      layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
    }
  }
  return stacks;
}
function buildLayoutBoxes(boxes) {
  const layoutBoxes = wrapBoxes(boxes);
  const fullSize = sortByWeight(layoutBoxes.filter((wrap) => wrap.box.fullSize), true);
  const left = sortByWeight(filterByPosition(layoutBoxes, "left"), true);
  const right = sortByWeight(filterByPosition(layoutBoxes, "right"));
  const top = sortByWeight(filterByPosition(layoutBoxes, "top"), true);
  const bottom = sortByWeight(filterByPosition(layoutBoxes, "bottom"));
  const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, "x");
  const centerVertical = filterDynamicPositionByAxis(layoutBoxes, "y");
  return {
    fullSize,
    leftAndTop: left.concat(top),
    rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
    chartArea: filterByPosition(layoutBoxes, "chartArea"),
    vertical: left.concat(right).concat(centerVertical),
    horizontal: top.concat(bottom).concat(centerHorizontal)
  };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
  return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
  maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
  maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
  maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
  maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
  const { pos, box } = layout;
  const maxPadding = chartArea.maxPadding;
  if (!isObject(pos)) {
    if (layout.size) {
      chartArea[pos] -= layout.size;
    }
    const stack = stacks[layout.stack] || {
      size: 0,
      count: 1
    };
    stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
    layout.size = stack.size / stack.count;
    chartArea[pos] += layout.size;
  }
  if (box.getPadding) {
    updateMaxPadding(maxPadding, box.getPadding());
  }
  const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, "left", "right"));
  const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, "top", "bottom"));
  const widthChanged = newWidth !== chartArea.w;
  const heightChanged = newHeight !== chartArea.h;
  chartArea.w = newWidth;
  chartArea.h = newHeight;
  return layout.horizontal ? {
    same: widthChanged,
    other: heightChanged
  } : {
    same: heightChanged,
    other: widthChanged
  };
}
function handleMaxPadding(chartArea) {
  const maxPadding = chartArea.maxPadding;
  function updatePos(pos) {
    const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
    chartArea[pos] += change;
    return change;
  }
  chartArea.y += updatePos("top");
  chartArea.x += updatePos("left");
  updatePos("right");
  updatePos("bottom");
}
function getMargins(horizontal, chartArea) {
  const maxPadding = chartArea.maxPadding;
  function marginForPositions(positions2) {
    const margin = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    positions2.forEach((pos) => {
      margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
    });
    return margin;
  }
  return horizontal ? marginForPositions([
    "left",
    "right"
  ]) : marginForPositions([
    "top",
    "bottom"
  ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
  const refitBoxes = [];
  let i, ilen, layout, box, refit, changed;
  for (i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i) {
    layout = boxes[i];
    box = layout.box;
    box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
    const { same, other } = updateDims(chartArea, params, layout, stacks);
    refit |= same && refitBoxes.length;
    changed = changed || other;
    if (!box.fullSize) {
      refitBoxes.push(layout);
    }
  }
  return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
  box.top = top;
  box.left = left;
  box.right = left + width;
  box.bottom = top + height;
  box.width = width;
  box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
  const userPadding = params.padding;
  let { x, y } = chartArea;
  for (const layout of boxes) {
    const box = layout.box;
    const stack = stacks[layout.stack] || {
      count: 1,
      placed: 0,
      weight: 1
    };
    const weight = layout.stackWeight / stack.weight || 1;
    if (layout.horizontal) {
      const width = chartArea.w * weight;
      const height = stack.size || box.height;
      if (defined(stack.start)) {
        y = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
      } else {
        setBoxDims(box, chartArea.left + stack.placed, y, width, height);
      }
      stack.start = y;
      stack.placed += width;
      y = box.bottom;
    } else {
      const height = chartArea.h * weight;
      const width = stack.size || box.width;
      if (defined(stack.start)) {
        x = stack.start;
      }
      if (box.fullSize) {
        setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
      } else {
        setBoxDims(box, x, chartArea.top + stack.placed, width, height);
      }
      stack.start = x;
      stack.placed += height;
      x = box.right;
    }
  }
  chartArea.x = x;
  chartArea.y = y;
}
var layouts = {
  addBox(chart, item) {
    if (!chart.boxes) {
      chart.boxes = [];
    }
    item.fullSize = item.fullSize || false;
    item.position = item.position || "top";
    item.weight = item.weight || 0;
    item._layers = item._layers || function() {
      return [
        {
          z: 0,
          draw(chartArea) {
            item.draw(chartArea);
          }
        }
      ];
    };
    chart.boxes.push(item);
  },
  removeBox(chart, layoutItem) {
    const index2 = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
    if (index2 !== -1) {
      chart.boxes.splice(index2, 1);
    }
  },
  configure(chart, item, options) {
    item.fullSize = options.fullSize;
    item.position = options.position;
    item.weight = options.weight;
  },
  update(chart, width, height, minPadding) {
    if (!chart) {
      return;
    }
    const padding = toPadding(chart.options.layout.padding);
    const availableWidth = Math.max(width - padding.width, 0);
    const availableHeight = Math.max(height - padding.height, 0);
    const boxes = buildLayoutBoxes(chart.boxes);
    const verticalBoxes = boxes.vertical;
    const horizontalBoxes = boxes.horizontal;
    each(chart.boxes, (box) => {
      if (typeof box.beforeLayout === "function") {
        box.beforeLayout();
      }
    });
    const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap) => wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
    const params = Object.freeze({
      outerWidth: width,
      outerHeight: height,
      padding,
      availableWidth,
      availableHeight,
      vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
      hBoxMaxHeight: availableHeight / 2
    });
    const maxPadding = Object.assign({}, padding);
    updateMaxPadding(maxPadding, toPadding(minPadding));
    const chartArea = Object.assign({
      maxPadding,
      w: availableWidth,
      h: availableHeight,
      x: padding.left,
      y: padding.top
    }, padding);
    const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
    fitBoxes(boxes.fullSize, chartArea, params, stacks);
    fitBoxes(verticalBoxes, chartArea, params, stacks);
    if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
      fitBoxes(verticalBoxes, chartArea, params, stacks);
    }
    handleMaxPadding(chartArea);
    placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
    chartArea.x += chartArea.w;
    chartArea.y += chartArea.h;
    placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
    chart.chartArea = {
      left: chartArea.left,
      top: chartArea.top,
      right: chartArea.left + chartArea.w,
      bottom: chartArea.top + chartArea.h,
      height: chartArea.h,
      width: chartArea.w
    };
    each(boxes.chartArea, (layout) => {
      const box = layout.box;
      Object.assign(box, chart.chartArea);
      box.update(chartArea.w, chartArea.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
var BasePlatform = class {
  acquireContext(canvas, aspectRatio) {
  }
  releaseContext(context) {
    return false;
  }
  addEventListener(chart, type, listener) {
  }
  removeEventListener(chart, type, listener) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(element, width, height, aspectRatio) {
    width = Math.max(0, width || element.width);
    height = height || element.height;
    return {
      width,
      height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
    };
  }
  isAttached(canvas) {
    return true;
  }
  updateConfig(config) {
  }
};
var BasicPlatform = class extends BasePlatform {
  acquireContext(item) {
    return item && item.getContext && item.getContext("2d") || null;
  }
  updateConfig(config) {
    config.options.animation = false;
  }
};
var EXPANDO_KEY = "$chartjs";
var EVENT_TYPES = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
};
var isNullOrEmpty = (value) => value === null || value === "";
function initCanvas(canvas, aspectRatio) {
  const style = canvas.style;
  const renderHeight = canvas.getAttribute("height");
  const renderWidth = canvas.getAttribute("width");
  canvas[EXPANDO_KEY] = {
    initial: {
      height: renderHeight,
      width: renderWidth,
      style: {
        display: style.display,
        height: style.height,
        width: style.width
      }
    }
  };
  style.display = style.display || "block";
  style.boxSizing = style.boxSizing || "border-box";
  if (isNullOrEmpty(renderWidth)) {
    const displayWidth = readUsedSize(canvas, "width");
    if (displayWidth !== void 0) {
      canvas.width = displayWidth;
    }
  }
  if (isNullOrEmpty(renderHeight)) {
    if (canvas.style.height === "") {
      canvas.height = canvas.width / (aspectRatio || 2);
    } else {
      const displayHeight = readUsedSize(canvas, "height");
      if (displayHeight !== void 0) {
        canvas.height = displayHeight;
      }
    }
  }
  return canvas;
}
var eventListenerOptions = supportsEventListenerOptions ? {
  passive: true
} : false;
function addListener(node, type, listener) {
  node.addEventListener(type, listener, eventListenerOptions);
}
function removeListener(chart, type, listener) {
  chart.canvas.removeEventListener(type, listener, eventListenerOptions);
}
function fromNativeEvent(event, chart) {
  const type = EVENT_TYPES[event.type] || event.type;
  const { x, y } = getRelativePosition(event, chart);
  return {
    type,
    chart,
    native: event,
    x: x !== void 0 ? x : null,
    y: y !== void 0 ? y : null
  };
}
function nodeListContains(nodeList, canvas) {
  for (const node of nodeList) {
    if (node === canvas || node.contains(canvas)) {
      return true;
    }
  }
}
function createAttachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.addedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
function createDetachObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const observer = new MutationObserver((entries) => {
    let trigger = false;
    for (const entry of entries) {
      trigger = trigger || nodeListContains(entry.removedNodes, canvas);
      trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
    }
    if (trigger) {
      listener();
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
  return observer;
}
var drpListeningCharts = /* @__PURE__ */ new Map();
var oldDevicePixelRatio = 0;
function onWindowResize() {
  const dpr = window.devicePixelRatio;
  if (dpr === oldDevicePixelRatio) {
    return;
  }
  oldDevicePixelRatio = dpr;
  drpListeningCharts.forEach((resize, chart) => {
    if (chart.currentDevicePixelRatio !== dpr) {
      resize();
    }
  });
}
function listenDevicePixelRatioChanges(chart, resize) {
  if (!drpListeningCharts.size) {
    window.addEventListener("resize", onWindowResize);
  }
  drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
  drpListeningCharts.delete(chart);
  if (!drpListeningCharts.size) {
    window.removeEventListener("resize", onWindowResize);
  }
}
function createResizeObserver(chart, type, listener) {
  const canvas = chart.canvas;
  const container = canvas && _getParentNode(canvas);
  if (!container) {
    return;
  }
  const resize = throttled((width, height) => {
    const w = container.clientWidth;
    listener(width, height);
    if (w < container.clientWidth) {
      listener();
    }
  }, window);
  const observer = new ResizeObserver((entries) => {
    const entry = entries[0];
    const width = entry.contentRect.width;
    const height = entry.contentRect.height;
    if (width === 0 && height === 0) {
      return;
    }
    resize(width, height);
  });
  observer.observe(container);
  listenDevicePixelRatioChanges(chart, resize);
  return observer;
}
function releaseObserver(chart, type, observer) {
  if (observer) {
    observer.disconnect();
  }
  if (type === "resize") {
    unlistenDevicePixelRatioChanges(chart);
  }
}
function createProxyAndListen(chart, type, listener) {
  const canvas = chart.canvas;
  const proxy = throttled((event) => {
    if (chart.ctx !== null) {
      listener(fromNativeEvent(event, chart));
    }
  }, chart);
  addListener(canvas, type, proxy);
  return proxy;
}
var DomPlatform = class extends BasePlatform {
  acquireContext(canvas, aspectRatio) {
    const context = canvas && canvas.getContext && canvas.getContext("2d");
    if (context && context.canvas === canvas) {
      initCanvas(canvas, aspectRatio);
      return context;
    }
    return null;
  }
  releaseContext(context) {
    const canvas = context.canvas;
    if (!canvas[EXPANDO_KEY]) {
      return false;
    }
    const initial = canvas[EXPANDO_KEY].initial;
    [
      "height",
      "width"
    ].forEach((prop) => {
      const value = initial[prop];
      if (isNullOrUndef(value)) {
        canvas.removeAttribute(prop);
      } else {
        canvas.setAttribute(prop, value);
      }
    });
    const style = initial.style || {};
    Object.keys(style).forEach((key) => {
      canvas.style[key] = style[key];
    });
    canvas.width = canvas.width;
    delete canvas[EXPANDO_KEY];
    return true;
  }
  addEventListener(chart, type, listener) {
    this.removeEventListener(chart, type);
    const proxies = chart.$proxies || (chart.$proxies = {});
    const handlers = {
      attach: createAttachObserver,
      detach: createDetachObserver,
      resize: createResizeObserver
    };
    const handler = handlers[type] || createProxyAndListen;
    proxies[type] = handler(chart, type, listener);
  }
  removeEventListener(chart, type) {
    const proxies = chart.$proxies || (chart.$proxies = {});
    const proxy = proxies[type];
    if (!proxy) {
      return;
    }
    const handlers = {
      attach: releaseObserver,
      detach: releaseObserver,
      resize: releaseObserver
    };
    const handler = handlers[type] || removeListener;
    handler(chart, type, proxy);
    proxies[type] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(canvas, width, height, aspectRatio) {
    return getMaximumSize(canvas, width, height, aspectRatio);
  }
  isAttached(canvas) {
    const container = _getParentNode(canvas);
    return !!(container && container.isConnected);
  }
};
function _detectPlatform(canvas) {
  if (!_isDomSupported() || typeof OffscreenCanvas !== "undefined" && canvas instanceof OffscreenCanvas) {
    return BasicPlatform;
  }
  return DomPlatform;
}
var Element = class {
  static defaults = {};
  static defaultRoutes = void 0;
  x;
  y;
  active = false;
  options;
  $animations;
  tooltipPosition(useFinalPosition) {
    const { x, y } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return {
      x,
      y
    };
  }
  hasValue() {
    return isNumber5(this.x) && isNumber5(this.y);
  }
  getProps(props, final) {
    const anims = this.$animations;
    if (!final || !anims) {
      return this;
    }
    const ret = {};
    props.forEach((prop) => {
      ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
    });
    return ret;
  }
};
function autoSkip(scale, ticks) {
  const tickOpts = scale.options.ticks;
  const determinedMaxTicks = determineMaxTicks(scale);
  const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
  const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
  const numMajorIndices = majorIndices.length;
  const first = majorIndices[0];
  const last = majorIndices[numMajorIndices - 1];
  const newTicks = [];
  if (numMajorIndices > ticksLimit) {
    skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
    return newTicks;
  }
  const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
  if (numMajorIndices > 0) {
    let i, ilen;
    const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
    skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
    for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
      skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
    }
    skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
    return newTicks;
  }
  skip(ticks, newTicks, spacing);
  return newTicks;
}
function determineMaxTicks(scale) {
  const offset = scale.options.offset;
  const tickLength = scale._tickSize();
  const maxScale = scale._length / tickLength + (offset ? 0 : 1);
  const maxChart = scale._maxLength / tickLength;
  return Math.floor(Math.min(maxScale, maxChart));
}
function calculateSpacing(majorIndices, ticks, ticksLimit) {
  const evenMajorSpacing = getEvenSpacing(majorIndices);
  const spacing = ticks.length / ticksLimit;
  if (!evenMajorSpacing) {
    return Math.max(spacing, 1);
  }
  const factors = _factorize(evenMajorSpacing);
  for (let i = 0, ilen = factors.length - 1; i < ilen; i++) {
    const factor = factors[i];
    if (factor > spacing) {
      return factor;
    }
  }
  return Math.max(spacing, 1);
}
function getMajorIndices(ticks) {
  const result = [];
  let i, ilen;
  for (i = 0, ilen = ticks.length; i < ilen; i++) {
    if (ticks[i].major) {
      result.push(i);
    }
  }
  return result;
}
function skipMajors(ticks, newTicks, majorIndices, spacing) {
  let count = 0;
  let next = majorIndices[0];
  let i;
  spacing = Math.ceil(spacing);
  for (i = 0; i < ticks.length; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = majorIndices[count * spacing];
    }
  }
}
function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
  const start = valueOrDefault(majorStart, 0);
  const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
  let count = 0;
  let length, i, next;
  spacing = Math.ceil(spacing);
  if (majorEnd) {
    length = majorEnd - majorStart;
    spacing = length / Math.floor(length / spacing);
  }
  next = start;
  while (next < 0) {
    count++;
    next = Math.round(start + count * spacing);
  }
  for (i = Math.max(start, 0); i < end; i++) {
    if (i === next) {
      newTicks.push(ticks[i]);
      count++;
      next = Math.round(start + count * spacing);
    }
  }
}
function getEvenSpacing(arr) {
  const len = arr.length;
  let i, diff;
  if (len < 2) {
    return false;
  }
  for (diff = arr[0], i = 1; i < len; ++i) {
    if (arr[i] - arr[i - 1] !== diff) {
      return false;
    }
  }
  return diff;
}
var reverseAlign = (align) => align === "left" ? "right" : align === "right" ? "left" : align;
var offsetFromEdge = (scale, edge, offset) => edge === "top" || edge === "left" ? scale[edge] + offset : scale[edge] - offset;
var getTicksLimit = (ticksLength, maxTicksLimit) => Math.min(maxTicksLimit || ticksLength, ticksLength);
function sample(arr, numItems) {
  const result = [];
  const increment = arr.length / numItems;
  const len = arr.length;
  let i = 0;
  for (; i < len; i += increment) {
    result.push(arr[Math.floor(i)]);
  }
  return result;
}
function getPixelForGridLine(scale, index2, offsetGridLines) {
  const length = scale.ticks.length;
  const validIndex2 = Math.min(index2, length - 1);
  const start = scale._startPixel;
  const end = scale._endPixel;
  const epsilon = 1e-6;
  let lineValue = scale.getPixelForTick(validIndex2);
  let offset;
  if (offsetGridLines) {
    if (length === 1) {
      offset = Math.max(lineValue - start, end - lineValue);
    } else if (index2 === 0) {
      offset = (scale.getPixelForTick(1) - lineValue) / 2;
    } else {
      offset = (lineValue - scale.getPixelForTick(validIndex2 - 1)) / 2;
    }
    lineValue += validIndex2 < index2 ? offset : -offset;
    if (lineValue < start - epsilon || lineValue > end + epsilon) {
      return;
    }
  }
  return lineValue;
}
function garbageCollect(caches, length) {
  each(caches, (cache) => {
    const gc = cache.gc;
    const gcLen = gc.length / 2;
    let i;
    if (gcLen > length) {
      for (i = 0; i < gcLen; ++i) {
        delete cache.data[gc[i]];
      }
      gc.splice(0, gcLen);
    }
  });
}
function getTickMarkLength(options) {
  return options.drawTicks ? options.tickLength : 0;
}
function getTitleHeight(options, fallback) {
  if (!options.display) {
    return 0;
  }
  const font = toFont(options.font, fallback);
  const padding = toPadding(options.padding);
  const lines = isArray(options.text) ? options.text.length : 1;
  return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
  return createContext20(parent, {
    scale,
    type: "scale"
  });
}
function createTickContext(parent, index2, tick) {
  return createContext20(parent, {
    tick,
    index: index2,
    type: "tick"
  });
}
function titleAlign(align, position, reverse) {
  let ret = _toLeftRightCenter(align);
  if (reverse && position !== "right" || !reverse && position === "right") {
    ret = reverseAlign(ret);
  }
  return ret;
}
function titleArgs(scale, offset, position, align) {
  const { top, left, bottom, right, chart } = scale;
  const { chartArea, scales } = chart;
  let rotation = 0;
  let maxWidth, titleX, titleY;
  const height = bottom - top;
  const width = right - left;
  if (scale.isHorizontal()) {
    titleX = _alignStartEnd(align, left, right);
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
    } else if (position === "center") {
      titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
    } else {
      titleY = offsetFromEdge(scale, position, offset);
    }
    maxWidth = right - left;
  } else {
    if (isObject(position)) {
      const positionAxisID = Object.keys(position)[0];
      const value = position[positionAxisID];
      titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
    } else if (position === "center") {
      titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
    } else {
      titleX = offsetFromEdge(scale, position, offset);
    }
    titleY = _alignStartEnd(align, bottom, top);
    rotation = position === "left" ? -HALF_PI : HALF_PI;
  }
  return {
    titleX,
    titleY,
    maxWidth,
    rotation
  };
}
var Scale = class _Scale extends Element {
  constructor(cfg) {
    super();
    this.id = cfg.id;
    this.type = cfg.type;
    this.options = void 0;
    this.ctx = cfg.ctx;
    this.chart = cfg.chart;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
    this.maxWidth = void 0;
    this.maxHeight = void 0;
    this.paddingTop = void 0;
    this.paddingBottom = void 0;
    this.paddingLeft = void 0;
    this.paddingRight = void 0;
    this.axis = void 0;
    this.labelRotation = void 0;
    this.min = void 0;
    this.max = void 0;
    this._range = void 0;
    this.ticks = [];
    this._gridLineItems = null;
    this._labelItems = null;
    this._labelSizes = null;
    this._length = 0;
    this._maxLength = 0;
    this._longestTextCache = {};
    this._startPixel = void 0;
    this._endPixel = void 0;
    this._reversePixels = false;
    this._userMax = void 0;
    this._userMin = void 0;
    this._suggestedMax = void 0;
    this._suggestedMin = void 0;
    this._ticksLength = 0;
    this._borderValue = 0;
    this._cache = {};
    this._dataLimitsCached = false;
    this.$context = void 0;
  }
  init(options) {
    this.options = options.setContext(this.getContext());
    this.axis = options.axis;
    this._userMin = this.parse(options.min);
    this._userMax = this.parse(options.max);
    this._suggestedMin = this.parse(options.suggestedMin);
    this._suggestedMax = this.parse(options.suggestedMax);
  }
  parse(raw, index2) {
    return raw;
  }
  getUserBounds() {
    let { _userMin, _userMax, _suggestedMin, _suggestedMax } = this;
    _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
    _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
    _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
    _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
    return {
      min: finiteOrDefault(_userMin, _suggestedMin),
      max: finiteOrDefault(_userMax, _suggestedMax),
      minDefined: isNumberFinite(_userMin),
      maxDefined: isNumberFinite(_userMax)
    };
  }
  getMinMax(canStack) {
    let { min, max, minDefined, maxDefined } = this.getUserBounds();
    let range;
    if (minDefined && maxDefined) {
      return {
        min,
        max
      };
    }
    const metas = this.getMatchingVisibleMetas();
    for (let i = 0, ilen = metas.length; i < ilen; ++i) {
      range = metas[i].controller.getMinMax(this, canStack);
      if (!minDefined) {
        min = Math.min(min, range.min);
      }
      if (!maxDefined) {
        max = Math.max(max, range.max);
      }
    }
    min = maxDefined && min > max ? max : min;
    max = minDefined && min > max ? min : max;
    return {
      min: finiteOrDefault(min, finiteOrDefault(max, min)),
      max: finiteOrDefault(max, finiteOrDefault(min, max))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const data = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
  }
  getLabelItems(chartArea = this.chart.chartArea) {
    const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
    return items;
  }
  beforeLayout() {
    this._cache = {};
    this._dataLimitsCached = false;
  }
  beforeUpdate() {
    callback(this.options.beforeUpdate, [
      this
    ]);
  }
  update(maxWidth, maxHeight, margins) {
    const { beginAtZero, grace, ticks: tickOpts } = this.options;
    const sampleSize = tickOpts.sampleSize;
    this.beforeUpdate();
    this.maxWidth = maxWidth;
    this.maxHeight = maxHeight;
    this._margins = margins = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, margins);
    this.ticks = null;
    this._labelSizes = null;
    this._gridLineItems = null;
    this._labelItems = null;
    this.beforeSetDimensions();
    this.setDimensions();
    this.afterSetDimensions();
    this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
    if (!this._dataLimitsCached) {
      this.beforeDataLimits();
      this.determineDataLimits();
      this.afterDataLimits();
      this._range = _addGrace(this, grace, beginAtZero);
      this._dataLimitsCached = true;
    }
    this.beforeBuildTicks();
    this.ticks = this.buildTicks() || [];
    this.afterBuildTicks();
    const samplingEnabled = sampleSize < this.ticks.length;
    this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
    this.configure();
    this.beforeCalculateLabelRotation();
    this.calculateLabelRotation();
    this.afterCalculateLabelRotation();
    if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === "auto")) {
      this.ticks = autoSkip(this, this.ticks);
      this._labelSizes = null;
      this.afterAutoSkip();
    }
    if (samplingEnabled) {
      this._convertTicksToLabels(this.ticks);
    }
    this.beforeFit();
    this.fit();
    this.afterFit();
    this.afterUpdate();
  }
  configure() {
    let reversePixels = this.options.reverse;
    let startPixel, endPixel;
    if (this.isHorizontal()) {
      startPixel = this.left;
      endPixel = this.right;
    } else {
      startPixel = this.top;
      endPixel = this.bottom;
      reversePixels = !reversePixels;
    }
    this._startPixel = startPixel;
    this._endPixel = endPixel;
    this._reversePixels = reversePixels;
    this._length = endPixel - startPixel;
    this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    callback(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    callback(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    if (this.isHorizontal()) {
      this.width = this.maxWidth;
      this.left = 0;
      this.right = this.width;
    } else {
      this.height = this.maxHeight;
      this.top = 0;
      this.bottom = this.height;
    }
    this.paddingLeft = 0;
    this.paddingTop = 0;
    this.paddingRight = 0;
    this.paddingBottom = 0;
  }
  afterSetDimensions() {
    callback(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(name) {
    this.chart.notifyPlugins(name, this.getContext());
    callback(this.options[name], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    callback(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(ticks) {
    const tickOpts = this.options.ticks;
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      tick = ticks[i];
      tick.label = callback(tickOpts.callback, [
        tick.value,
        i,
        ticks
      ], this);
    }
  }
  afterTickToLabelConversion() {
    callback(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    callback(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const options = this.options;
    const tickOpts = options.ticks;
    const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
    const minRotation = tickOpts.minRotation || 0;
    const maxRotation = tickOpts.maxRotation;
    let labelRotation = minRotation;
    let tickWidth, maxHeight, maxLabelDiagonal;
    if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
      this.labelRotation = minRotation;
      return;
    }
    const labelSizes = this._getLabelSizes();
    const maxLabelWidth = labelSizes.widest.width;
    const maxLabelHeight = labelSizes.highest.height;
    const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
    tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
    if (maxLabelWidth + 6 > tickWidth) {
      tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
      maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
      maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
      labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
      labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
    }
    this.labelRotation = labelRotation;
  }
  afterCalculateLabelRotation() {
    callback(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    callback(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const minSize = {
      width: 0,
      height: 0
    };
    const { chart, options: { ticks: tickOpts, title: titleOpts, grid: gridOpts } } = this;
    const display = this._isVisible();
    const isHorizontal = this.isHorizontal();
    if (display) {
      const titleHeight = getTitleHeight(titleOpts, chart.options.font);
      if (isHorizontal) {
        minSize.width = this.maxWidth;
        minSize.height = getTickMarkLength(gridOpts) + titleHeight;
      } else {
        minSize.height = this.maxHeight;
        minSize.width = getTickMarkLength(gridOpts) + titleHeight;
      }
      if (tickOpts.display && this.ticks.length) {
        const { first, last, widest, highest } = this._getLabelSizes();
        const tickPadding = tickOpts.padding * 2;
        const angleRadians = toRadians(this.labelRotation);
        const cos = Math.cos(angleRadians);
        const sin = Math.sin(angleRadians);
        if (isHorizontal) {
          const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
          minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
        } else {
          const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
          minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
        }
        this._calculatePadding(first, last, sin, cos);
      }
    }
    this._handleMargins();
    if (isHorizontal) {
      this.width = this._length = chart.width - this._margins.left - this._margins.right;
      this.height = minSize.height;
    } else {
      this.width = minSize.width;
      this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
    }
  }
  _calculatePadding(first, last, sin, cos) {
    const { ticks: { align, padding }, position } = this.options;
    const isRotated = this.labelRotation !== 0;
    const labelsBelowTicks = position !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const offsetLeft = this.getPixelForTick(0) - this.left;
      const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
      let paddingLeft = 0;
      let paddingRight = 0;
      if (isRotated) {
        if (labelsBelowTicks) {
          paddingLeft = cos * first.width;
          paddingRight = sin * last.height;
        } else {
          paddingLeft = sin * first.height;
          paddingRight = cos * last.width;
        }
      } else if (align === "start") {
        paddingRight = last.width;
      } else if (align === "end") {
        paddingLeft = first.width;
      } else if (align !== "inner") {
        paddingLeft = first.width / 2;
        paddingRight = last.width / 2;
      }
      this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
      this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
    } else {
      let paddingTop = last.height / 2;
      let paddingBottom = first.height / 2;
      if (align === "start") {
        paddingTop = 0;
        paddingBottom = first.height;
      } else if (align === "end") {
        paddingTop = last.height;
        paddingBottom = 0;
      }
      this.paddingTop = paddingTop + padding;
      this.paddingBottom = paddingBottom + padding;
    }
  }
  _handleMargins() {
    if (this._margins) {
      this._margins.left = Math.max(this.paddingLeft, this._margins.left);
      this._margins.top = Math.max(this.paddingTop, this._margins.top);
      this._margins.right = Math.max(this.paddingRight, this._margins.right);
      this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
    }
  }
  afterFit() {
    callback(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis, position } = this.options;
    return position === "top" || position === "bottom" || axis === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(ticks) {
    this.beforeTickToLabelConversion();
    this.generateTickLabels(ticks);
    let i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (isNullOrUndef(ticks[i].label)) {
        ticks.splice(i, 1);
        ilen--;
        i--;
      }
    }
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let labelSizes = this._labelSizes;
    if (!labelSizes) {
      const sampleSize = this.options.ticks.sampleSize;
      let ticks = this.ticks;
      if (sampleSize < ticks.length) {
        ticks = sample(ticks, sampleSize);
      }
      this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
    }
    return labelSizes;
  }
  _computeLabelSizes(ticks, length, maxTicksLimit) {
    const { ctx, _longestTextCache: caches } = this;
    const widths = [];
    const heights = [];
    const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
    let widestLabelSize = 0;
    let highestLabelSize = 0;
    let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
    for (i = 0; i < length; i += increment) {
      label = ticks[i].label;
      tickFont = this._resolveTickFontOptions(i);
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {
        data: {},
        gc: []
      };
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = _measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    const widest = widths.indexOf(widestLabelSize);
    const highest = heights.indexOf(highestLabelSize);
    const valueAt = (idx) => ({
      width: widths[idx] || 0,
      height: heights[idx] || 0
    });
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest),
      widths,
      heights
    };
  }
  getLabelForValue(value) {
    return value;
  }
  getPixelForValue(value, index2) {
    return NaN;
  }
  getValueForPixel(pixel) {
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getPixelForDecimal(decimal) {
    if (this._reversePixels) {
      decimal = 1 - decimal;
    }
    const pixel = this._startPixel + decimal * this._length;
    return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
  }
  getDecimalForPixel(pixel) {
    const decimal = (pixel - this._startPixel) / this._length;
    return this._reversePixels ? 1 - decimal : decimal;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min, max } = this;
    return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
  }
  getContext(index2) {
    const ticks = this.ticks || [];
    if (index2 >= 0 && index2 < ticks.length) {
      const tick = ticks[index2];
      return tick.$context || (tick.$context = createTickContext(this.getContext(), index2, tick));
    }
    return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
  }
  _tickSize() {
    const optionTicks = this.options.ticks;
    const rot = toRadians(this.labelRotation);
    const cos = Math.abs(Math.cos(rot));
    const sin = Math.abs(Math.sin(rot));
    const labelSizes = this._getLabelSizes();
    const padding = optionTicks.autoSkipPadding || 0;
    const w = labelSizes ? labelSizes.widest.width + padding : 0;
    const h = labelSizes ? labelSizes.highest.height + padding : 0;
    return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
  }
  _isVisible() {
    const display = this.options.display;
    if (display !== "auto") {
      return !!display;
    }
    return this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(chartArea) {
    const axis = this.axis;
    const chart = this.chart;
    const options = this.options;
    const { grid, position, border } = options;
    const offset = grid.offset;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const ticksLength = ticks.length + (offset ? 1 : 0);
    const tl = getTickMarkLength(grid);
    const items = [];
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = borderOpts.display ? borderOpts.width : 0;
    const axisHalfWidth = axisWidth / 2;
    const alignBorderValue = function(pixel) {
      return _alignPixel(chart, pixel, axisWidth);
    };
    let borderValue, i, lineValue, alignedLineValue;
    let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
    if (position === "top") {
      borderValue = alignBorderValue(this.bottom);
      ty1 = this.bottom - tl;
      ty2 = borderValue - axisHalfWidth;
      y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
      y2 = chartArea.bottom;
    } else if (position === "bottom") {
      borderValue = alignBorderValue(this.top);
      y1 = chartArea.top;
      y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
      ty1 = borderValue + axisHalfWidth;
      ty2 = this.top + tl;
    } else if (position === "left") {
      borderValue = alignBorderValue(this.right);
      tx1 = this.right - tl;
      tx2 = borderValue - axisHalfWidth;
      x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
      x2 = chartArea.right;
    } else if (position === "right") {
      borderValue = alignBorderValue(this.left);
      x1 = chartArea.left;
      x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
      tx1 = borderValue + axisHalfWidth;
      tx2 = this.left + tl;
    } else if (axis === "x") {
      if (position === "center") {
        borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      y1 = chartArea.top;
      y2 = chartArea.bottom;
      ty1 = borderValue + axisHalfWidth;
      ty2 = ty1 + tl;
    } else if (axis === "y") {
      if (position === "center") {
        borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
      }
      tx1 = borderValue - axisHalfWidth;
      tx2 = tx1 - tl;
      x1 = chartArea.left;
      x2 = chartArea.right;
    }
    const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
    const step = Math.max(1, Math.ceil(ticksLength / limit));
    for (i = 0; i < ticksLength; i += step) {
      const context = this.getContext(i);
      const optsAtIndex = grid.setContext(context);
      const optsAtIndexBorder = border.setContext(context);
      const lineWidth = optsAtIndex.lineWidth;
      const lineColor = optsAtIndex.color;
      const borderDash = optsAtIndexBorder.dash || [];
      const borderDashOffset = optsAtIndexBorder.dashOffset;
      const tickWidth = optsAtIndex.tickWidth;
      const tickColor = optsAtIndex.tickColor;
      const tickBorderDash = optsAtIndex.tickBorderDash || [];
      const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
      lineValue = getPixelForGridLine(this, i, offset);
      if (lineValue === void 0) {
        continue;
      }
      alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
      if (isHorizontal) {
        tx1 = tx2 = x1 = x2 = alignedLineValue;
      } else {
        ty1 = ty2 = y1 = y2 = alignedLineValue;
      }
      items.push({
        tx1,
        ty1,
        tx2,
        ty2,
        x1,
        y1,
        x2,
        y2,
        width: lineWidth,
        color: lineColor,
        borderDash,
        borderDashOffset,
        tickWidth,
        tickColor,
        tickBorderDash,
        tickBorderDashOffset
      });
    }
    this._ticksLength = ticksLength;
    this._borderValue = borderValue;
    return items;
  }
  _computeLabelItems(chartArea) {
    const axis = this.axis;
    const options = this.options;
    const { position, ticks: optionTicks } = options;
    const isHorizontal = this.isHorizontal();
    const ticks = this.ticks;
    const { align, crossAlign, padding, mirror } = optionTicks;
    const tl = getTickMarkLength(options.grid);
    const tickAndPadding = tl + padding;
    const hTickAndPadding = mirror ? -padding : tickAndPadding;
    const rotation = -toRadians(this.labelRotation);
    const items = [];
    let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
    let textBaseline = "middle";
    if (position === "top") {
      y = this.bottom - hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === "bottom") {
      y = this.top + hTickAndPadding;
      textAlign = this._getXAxisLabelAlignment();
    } else if (position === "left") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (position === "right") {
      const ret = this._getYAxisLabelAlignment(tl);
      textAlign = ret.textAlign;
      x = ret.x;
    } else if (axis === "x") {
      if (position === "center") {
        y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
      }
      textAlign = this._getXAxisLabelAlignment();
    } else if (axis === "y") {
      if (position === "center") {
        x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
      } else if (isObject(position)) {
        const positionAxisID = Object.keys(position)[0];
        const value = position[positionAxisID];
        x = this.chart.scales[positionAxisID].getPixelForValue(value);
      }
      textAlign = this._getYAxisLabelAlignment(tl).textAlign;
    }
    if (axis === "y") {
      if (align === "start") {
        textBaseline = "top";
      } else if (align === "end") {
        textBaseline = "bottom";
      }
    }
    const labelSizes = this._getLabelSizes();
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      label = tick.label;
      const optsAtIndex = optionTicks.setContext(this.getContext(i));
      pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
      font = this._resolveTickFontOptions(i);
      lineHeight = font.lineHeight;
      lineCount = isArray(label) ? label.length : 1;
      const halfCount = lineCount / 2;
      const color2 = optsAtIndex.color;
      const strokeColor = optsAtIndex.textStrokeColor;
      const strokeWidth = optsAtIndex.textStrokeWidth;
      let tickTextAlign = textAlign;
      if (isHorizontal) {
        x = pixel;
        if (textAlign === "inner") {
          if (i === ilen - 1) {
            tickTextAlign = !this.options.reverse ? "right" : "left";
          } else if (i === 0) {
            tickTextAlign = !this.options.reverse ? "left" : "right";
          } else {
            tickTextAlign = "center";
          }
        }
        if (position === "top") {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = -lineCount * lineHeight + lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
          } else {
            textOffset = -labelSizes.highest.height + lineHeight / 2;
          }
        } else {
          if (crossAlign === "near" || rotation !== 0) {
            textOffset = lineHeight / 2;
          } else if (crossAlign === "center") {
            textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
          } else {
            textOffset = labelSizes.highest.height - lineCount * lineHeight;
          }
        }
        if (mirror) {
          textOffset *= -1;
        }
        if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
          x += lineHeight / 2 * Math.sin(rotation);
        }
      } else {
        y = pixel;
        textOffset = (1 - lineCount) * lineHeight / 2;
      }
      let backdrop;
      if (optsAtIndex.showLabelBackdrop) {
        const labelPadding = toPadding(optsAtIndex.backdropPadding);
        const height = labelSizes.heights[i];
        const width = labelSizes.widths[i];
        let top = textOffset - labelPadding.top;
        let left = 0 - labelPadding.left;
        switch (textBaseline) {
          case "middle":
            top -= height / 2;
            break;
          case "bottom":
            top -= height;
            break;
        }
        switch (textAlign) {
          case "center":
            left -= width / 2;
            break;
          case "right":
            left -= width;
            break;
        }
        backdrop = {
          left,
          top,
          width: width + labelPadding.width,
          height: height + labelPadding.height,
          color: optsAtIndex.backdropColor
        };
      }
      items.push({
        label,
        font,
        textOffset,
        options: {
          rotation,
          color: color2,
          strokeColor,
          strokeWidth,
          textAlign: tickTextAlign,
          textBaseline,
          translation: [
            x,
            y
          ],
          backdrop
        }
      });
    }
    return items;
  }
  _getXAxisLabelAlignment() {
    const { position, ticks } = this.options;
    const rotation = -toRadians(this.labelRotation);
    if (rotation) {
      return position === "top" ? "left" : "right";
    }
    let align = "center";
    if (ticks.align === "start") {
      align = "left";
    } else if (ticks.align === "end") {
      align = "right";
    } else if (ticks.align === "inner") {
      align = "inner";
    }
    return align;
  }
  _getYAxisLabelAlignment(tl) {
    const { position, ticks: { crossAlign, mirror, padding } } = this.options;
    const labelSizes = this._getLabelSizes();
    const tickAndPadding = tl + padding;
    const widest = labelSizes.widest.width;
    let textAlign;
    let x;
    if (position === "left") {
      if (mirror) {
        x = this.right + padding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x += widest / 2;
        } else {
          textAlign = "right";
          x += widest;
        }
      } else {
        x = this.right - tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x -= widest / 2;
        } else {
          textAlign = "left";
          x = this.left;
        }
      }
    } else if (position === "right") {
      if (mirror) {
        x = this.left + padding;
        if (crossAlign === "near") {
          textAlign = "right";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x -= widest / 2;
        } else {
          textAlign = "left";
          x -= widest;
        }
      } else {
        x = this.left + tickAndPadding;
        if (crossAlign === "near") {
          textAlign = "left";
        } else if (crossAlign === "center") {
          textAlign = "center";
          x += widest / 2;
        } else {
          textAlign = "right";
          x = this.right;
        }
      }
    } else {
      textAlign = "right";
    }
    return {
      textAlign,
      x
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror) {
      return;
    }
    const chart = this.chart;
    const position = this.options.position;
    if (position === "left" || position === "right") {
      return {
        top: 0,
        left: this.left,
        bottom: chart.height,
        right: this.right
      };
    }
    if (position === "top" || position === "bottom") {
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: chart.width
      };
    }
  }
  drawBackground() {
    const { ctx, options: { backgroundColor }, left, top, width, height } = this;
    if (backgroundColor) {
      ctx.save();
      ctx.fillStyle = backgroundColor;
      ctx.fillRect(left, top, width, height);
      ctx.restore();
    }
  }
  getLineWidthForValue(value) {
    const grid = this.options.grid;
    if (!this._isVisible() || !grid.display) {
      return 0;
    }
    const ticks = this.ticks;
    const index2 = ticks.findIndex((t) => t.value === value);
    if (index2 >= 0) {
      const opts = grid.setContext(this.getContext(index2));
      return opts.lineWidth;
    }
    return 0;
  }
  drawGrid(chartArea) {
    const grid = this.options.grid;
    const ctx = this.ctx;
    const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
    let i, ilen;
    const drawLine = (p1, p2, style) => {
      if (!style.width || !style.color) {
        return;
      }
      ctx.save();
      ctx.lineWidth = style.width;
      ctx.strokeStyle = style.color;
      ctx.setLineDash(style.borderDash || []);
      ctx.lineDashOffset = style.borderDashOffset;
      ctx.beginPath();
      ctx.moveTo(p1.x, p1.y);
      ctx.lineTo(p2.x, p2.y);
      ctx.stroke();
      ctx.restore();
    };
    if (grid.display) {
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        const item = items[i];
        if (grid.drawOnChartArea) {
          drawLine({
            x: item.x1,
            y: item.y1
          }, {
            x: item.x2,
            y: item.y2
          }, item);
        }
        if (grid.drawTicks) {
          drawLine({
            x: item.tx1,
            y: item.ty1
          }, {
            x: item.tx2,
            y: item.ty2
          }, {
            color: item.tickColor,
            width: item.tickWidth,
            borderDash: item.tickBorderDash,
            borderDashOffset: item.tickBorderDashOffset
          });
        }
      }
    }
  }
  drawBorder() {
    const { chart, ctx, options: { border, grid } } = this;
    const borderOpts = border.setContext(this.getContext());
    const axisWidth = border.display ? borderOpts.width : 0;
    if (!axisWidth) {
      return;
    }
    const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
    const borderValue = this._borderValue;
    let x1, x2, y1, y2;
    if (this.isHorizontal()) {
      x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
      x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
      y1 = y2 = borderValue;
    } else {
      y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
      y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
      x1 = x2 = borderValue;
    }
    ctx.save();
    ctx.lineWidth = borderOpts.width;
    ctx.strokeStyle = borderOpts.color;
    ctx.beginPath();
    ctx.moveTo(x1, y1);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.restore();
  }
  drawLabels(chartArea) {
    const optionTicks = this.options.ticks;
    if (!optionTicks.display) {
      return;
    }
    const ctx = this.ctx;
    const area = this._computeLabelArea();
    if (area) {
      clipArea(ctx, area);
    }
    const items = this.getLabelItems(chartArea);
    for (const item of items) {
      const renderTextOptions = item.options;
      const tickFont = item.font;
      const label = item.label;
      const y = item.textOffset;
      renderText(ctx, label, 0, y, tickFont, renderTextOptions);
    }
    if (area) {
      unclipArea(ctx);
    }
  }
  drawTitle() {
    const { ctx, options: { position, title, reverse } } = this;
    if (!title.display) {
      return;
    }
    const font = toFont(title.font);
    const padding = toPadding(title.padding);
    const align = title.align;
    let offset = font.lineHeight / 2;
    if (position === "bottom" || position === "center" || isObject(position)) {
      offset += padding.bottom;
      if (isArray(title.text)) {
        offset += font.lineHeight * (title.text.length - 1);
      }
    } else {
      offset += padding.top;
    }
    const { titleX, titleY, maxWidth, rotation } = titleArgs(this, offset, position, align);
    renderText(ctx, title.text, 0, 0, font, {
      color: title.color,
      maxWidth,
      rotation,
      textAlign: titleAlign(align, position, reverse),
      textBaseline: "middle",
      translation: [
        titleX,
        titleY
      ]
    });
  }
  draw(chartArea) {
    if (!this._isVisible()) {
      return;
    }
    this.drawBackground();
    this.drawGrid(chartArea);
    this.drawBorder();
    this.drawTitle();
    this.drawLabels(chartArea);
  }
  _layers() {
    const opts = this.options;
    const tz = opts.ticks && opts.ticks.z || 0;
    const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
    const bz = valueOrDefault(opts.border && opts.border.z, 0);
    if (!this._isVisible() || this.draw !== _Scale.prototype.draw) {
      return [
        {
          z: tz,
          draw: (chartArea) => {
            this.draw(chartArea);
          }
        }
      ];
    }
    return [
      {
        z: gz,
        draw: (chartArea) => {
          this.drawBackground();
          this.drawGrid(chartArea);
          this.drawTitle();
        }
      },
      {
        z: bz,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: tz,
        draw: (chartArea) => {
          this.drawLabels(chartArea);
        }
      }
    ];
  }
  getMatchingVisibleMetas(type) {
    const metas = this.chart.getSortedVisibleDatasetMetas();
    const axisID = this.axis + "AxisID";
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      const meta = metas[i];
      if (meta[axisID] === this.id && (!type || meta.type === type)) {
        result.push(meta);
      }
    }
    return result;
  }
  _resolveTickFontOptions(index2) {
    const opts = this.options.ticks.setContext(this.getContext(index2));
    return toFont(opts.font);
  }
  _maxDigits() {
    const fontSize = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / fontSize;
  }
};
var TypedRegistry = class {
  constructor(type, scope, override) {
    this.type = type;
    this.scope = scope;
    this.override = override;
    this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(type) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
  }
  register(item) {
    const proto = Object.getPrototypeOf(item);
    let parentScope;
    if (isIChartComponent(proto)) {
      parentScope = this.register(proto);
    }
    const items = this.items;
    const id2 = item.id;
    const scope = this.scope + "." + id2;
    if (!id2) {
      throw new Error("class does not have id: " + item);
    }
    if (id2 in items) {
      return scope;
    }
    items[id2] = item;
    registerDefaults(item, scope, parentScope);
    if (this.override) {
      defaults.override(item.id, item.overrides);
    }
    return scope;
  }
  get(id2) {
    return this.items[id2];
  }
  unregister(item) {
    const items = this.items;
    const id2 = item.id;
    const scope = this.scope;
    if (id2 in items) {
      delete items[id2];
    }
    if (scope && id2 in defaults[scope]) {
      delete defaults[scope][id2];
      if (this.override) {
        delete overrides[id2];
      }
    }
  }
};
function registerDefaults(item, scope, parentScope) {
  const itemDefaults = merge(/* @__PURE__ */ Object.create(null), [
    parentScope ? defaults.get(parentScope) : {},
    defaults.get(scope),
    item.defaults
  ]);
  defaults.set(scope, itemDefaults);
  if (item.defaultRoutes) {
    routeDefaults(scope, item.defaultRoutes);
  }
  if (item.descriptors) {
    defaults.describe(scope, item.descriptors);
  }
}
function routeDefaults(scope, routes) {
  Object.keys(routes).forEach((property) => {
    const propertyParts = property.split(".");
    const sourceName = propertyParts.pop();
    const sourceScope = [
      scope
    ].concat(propertyParts).join(".");
    const parts = routes[property].split(".");
    const targetName = parts.pop();
    const targetScope = parts.join(".");
    defaults.route(sourceScope, sourceName, targetScope, targetName);
  });
}
function isIChartComponent(proto) {
  return "id" in proto && "defaults" in proto;
}
var Registry = class {
  constructor() {
    this.controllers = new TypedRegistry(DatasetController, "datasets", true);
    this.elements = new TypedRegistry(Element, "elements");
    this.plugins = new TypedRegistry(Object, "plugins");
    this.scales = new TypedRegistry(Scale, "scales");
    this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...args) {
    this._each("register", args);
  }
  remove(...args) {
    this._each("unregister", args);
  }
  addControllers(...args) {
    this._each("register", args, this.controllers);
  }
  addElements(...args) {
    this._each("register", args, this.elements);
  }
  addPlugins(...args) {
    this._each("register", args, this.plugins);
  }
  addScales(...args) {
    this._each("register", args, this.scales);
  }
  getController(id2) {
    return this._get(id2, this.controllers, "controller");
  }
  getElement(id2) {
    return this._get(id2, this.elements, "element");
  }
  getPlugin(id2) {
    return this._get(id2, this.plugins, "plugin");
  }
  getScale(id2) {
    return this._get(id2, this.scales, "scale");
  }
  removeControllers(...args) {
    this._each("unregister", args, this.controllers);
  }
  removeElements(...args) {
    this._each("unregister", args, this.elements);
  }
  removePlugins(...args) {
    this._each("unregister", args, this.plugins);
  }
  removeScales(...args) {
    this._each("unregister", args, this.scales);
  }
  _each(method, args, typedRegistry) {
    [
      ...args
    ].forEach((arg) => {
      const reg = typedRegistry || this._getRegistryForType(arg);
      if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
        this._exec(method, reg, arg);
      } else {
        each(arg, (item) => {
          const itemReg = typedRegistry || this._getRegistryForType(item);
          this._exec(method, itemReg, item);
        });
      }
    });
  }
  _exec(method, registry2, component) {
    const camelMethod = _capitalize(method);
    callback(component["before" + camelMethod], [], component);
    registry2[method](component);
    callback(component["after" + camelMethod], [], component);
  }
  _getRegistryForType(type) {
    for (let i = 0; i < this._typedRegistries.length; i++) {
      const reg = this._typedRegistries[i];
      if (reg.isForType(type)) {
        return reg;
      }
    }
    return this.plugins;
  }
  _get(id2, typedRegistry, type) {
    const item = typedRegistry.get(id2);
    if (item === void 0) {
      throw new Error('"' + id2 + '" is not a registered ' + type + ".");
    }
    return item;
  }
};
var registry = /* @__PURE__ */ new Registry();
var PluginService = class {
  constructor() {
    this._init = [];
  }
  notify(chart, hook, args, filter) {
    if (hook === "beforeInit") {
      this._init = this._createDescriptors(chart, true);
      this._notify(this._init, chart, "install");
    }
    const descriptors2 = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
    const result = this._notify(descriptors2, chart, hook, args);
    if (hook === "afterDestroy") {
      this._notify(descriptors2, chart, "stop");
      this._notify(this._init, chart, "uninstall");
    }
    return result;
  }
  _notify(descriptors2, chart, hook, args) {
    args = args || {};
    for (const descriptor of descriptors2) {
      const plugin = descriptor.plugin;
      const method = plugin[hook];
      const params = [
        chart,
        args,
        descriptor.options
      ];
      if (callback(method, params, plugin) === false && args.cancelable) {
        return false;
      }
    }
    return true;
  }
  invalidate() {
    if (!isNullOrUndef(this._cache)) {
      this._oldCache = this._cache;
      this._cache = void 0;
    }
  }
  _descriptors(chart) {
    if (this._cache) {
      return this._cache;
    }
    const descriptors2 = this._cache = this._createDescriptors(chart);
    this._notifyStateChanges(chart);
    return descriptors2;
  }
  _createDescriptors(chart, all) {
    const config = chart && chart.config;
    const options = valueOrDefault(config.options && config.options.plugins, {});
    const plugins = allPlugins(config);
    return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
  }
  _notifyStateChanges(chart) {
    const previousDescriptors = this._oldCache || [];
    const descriptors2 = this._cache;
    const diff = (a, b) => a.filter((x) => !b.some((y) => x.plugin.id === y.plugin.id));
    this._notify(diff(previousDescriptors, descriptors2), chart, "stop");
    this._notify(diff(descriptors2, previousDescriptors), chart, "start");
  }
};
function allPlugins(config) {
  const localIds = {};
  const plugins = [];
  const keys = Object.keys(registry.plugins.items);
  for (let i = 0; i < keys.length; i++) {
    plugins.push(registry.getPlugin(keys[i]));
  }
  const local = config.plugins || [];
  for (let i = 0; i < local.length; i++) {
    const plugin = local[i];
    if (plugins.indexOf(plugin) === -1) {
      plugins.push(plugin);
      localIds[plugin.id] = true;
    }
  }
  return {
    plugins,
    localIds
  };
}
function getOpts(options, all) {
  if (!all && options === false) {
    return null;
  }
  if (options === true) {
    return {};
  }
  return options;
}
function createDescriptors(chart, { plugins, localIds }, options, all) {
  const result = [];
  const context = chart.getContext();
  for (const plugin of plugins) {
    const id2 = plugin.id;
    const opts = getOpts(options[id2], all);
    if (opts === null) {
      continue;
    }
    result.push({
      plugin,
      options: pluginOpts(chart.config, {
        plugin,
        local: localIds[id2]
      }, opts, context)
    });
  }
  return result;
}
function pluginOpts(config, { plugin, local }, opts, context) {
  const keys = config.pluginScopeKeys(plugin);
  const scopes = config.getOptionScopes(opts, keys);
  if (local && plugin.defaults) {
    scopes.push(plugin.defaults);
  }
  return config.createResolver(scopes, context, [
    ""
  ], {
    scriptable: false,
    indexable: false,
    allKeys: true
  });
}
function getIndexAxis(type, options) {
  const datasetDefaults = defaults.datasets[type] || {};
  const datasetOptions = (options.datasets || {})[type] || {};
  return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || "x";
}
function getAxisFromDefaultScaleID(id2, indexAxis) {
  let axis = id2;
  if (id2 === "_index_") {
    axis = indexAxis;
  } else if (id2 === "_value_") {
    axis = indexAxis === "x" ? "y" : "x";
  }
  return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
  return axis === indexAxis ? "_index_" : "_value_";
}
function idMatchesAxis(id2) {
  if (id2 === "x" || id2 === "y" || id2 === "r") {
    return id2;
  }
}
function axisFromPosition(position) {
  if (position === "top" || position === "bottom") {
    return "x";
  }
  if (position === "left" || position === "right") {
    return "y";
  }
}
function determineAxis(id2, ...scaleOptions) {
  if (idMatchesAxis(id2)) {
    return id2;
  }
  for (const opts of scaleOptions) {
    const axis = opts.axis || axisFromPosition(opts.position) || id2.length > 1 && idMatchesAxis(id2[0].toLowerCase());
    if (axis) {
      return axis;
    }
  }
  throw new Error(`Cannot determine type of '${id2}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id2, axis, dataset) {
  if (dataset[axis + "AxisID"] === id2) {
    return {
      axis
    };
  }
}
function retrieveAxisFromDatasets(id2, config) {
  if (config.data && config.data.datasets) {
    const boundDs = config.data.datasets.filter((d) => d.xAxisID === id2 || d.yAxisID === id2);
    if (boundDs.length) {
      return getAxisFromDataset(id2, "x", boundDs[0]) || getAxisFromDataset(id2, "y", boundDs[0]);
    }
  }
  return {};
}
function mergeScaleConfig(config, options) {
  const chartDefaults = overrides[config.type] || {
    scales: {}
  };
  const configScales = options.scales || {};
  const chartIndexAxis = getIndexAxis(config.type, options);
  const scales = /* @__PURE__ */ Object.create(null);
  Object.keys(configScales).forEach((id2) => {
    const scaleConf = configScales[id2];
    if (!isObject(scaleConf)) {
      return console.error(`Invalid scale configuration for scale: ${id2}`);
    }
    if (scaleConf._proxy) {
      return console.warn(`Ignoring resolver passed as options for scale: ${id2}`);
    }
    const axis = determineAxis(id2, scaleConf, retrieveAxisFromDatasets(id2, config), defaults.scales[scaleConf.type]);
    const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
    const defaultScaleOptions = chartDefaults.scales || {};
    scales[id2] = mergeIf(/* @__PURE__ */ Object.create(null), [
      {
        axis
      },
      scaleConf,
      defaultScaleOptions[axis],
      defaultScaleOptions[defaultId]
    ]);
  });
  config.data.datasets.forEach((dataset) => {
    const type = dataset.type || config.type;
    const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
    const datasetDefaults = overrides[type] || {};
    const defaultScaleOptions = datasetDefaults.scales || {};
    Object.keys(defaultScaleOptions).forEach((defaultID) => {
      const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
      const id2 = dataset[axis + "AxisID"] || axis;
      scales[id2] = scales[id2] || /* @__PURE__ */ Object.create(null);
      mergeIf(scales[id2], [
        {
          axis
        },
        configScales[id2],
        defaultScaleOptions[defaultID]
      ]);
    });
  });
  Object.keys(scales).forEach((key) => {
    const scale = scales[key];
    mergeIf(scale, [
      defaults.scales[scale.type],
      defaults.scale
    ]);
  });
  return scales;
}
function initOptions(config) {
  const options = config.options || (config.options = {});
  options.plugins = valueOrDefault(options.plugins, {});
  options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
  data = data || {};
  data.datasets = data.datasets || [];
  data.labels = data.labels || [];
  return data;
}
function initConfig(config) {
  config = config || {};
  config.data = initData(config.data);
  initOptions(config);
  return config;
}
var keyCache = /* @__PURE__ */ new Map();
var keysCached = /* @__PURE__ */ new Set();
function cachedKeys(cacheKey, generate) {
  let keys = keyCache.get(cacheKey);
  if (!keys) {
    keys = generate();
    keyCache.set(cacheKey, keys);
    keysCached.add(keys);
  }
  return keys;
}
var addIfFound = (set2, obj, key) => {
  const opts = resolveObjectKey(obj, key);
  if (opts !== void 0) {
    set2.add(opts);
  }
};
var Config = class {
  constructor(config) {
    this._config = initConfig(config);
    this._scopeCache = /* @__PURE__ */ new Map();
    this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(type) {
    this._config.type = type;
  }
  get data() {
    return this._config.data;
  }
  set data(data) {
    this._config.data = initData(data);
  }
  get options() {
    return this._config.options;
  }
  set options(options) {
    this._config.options = options;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const config = this._config;
    this.clearCache();
    initOptions(config);
  }
  clearCache() {
    this._scopeCache.clear();
    this._resolverCache.clear();
  }
  datasetScopeKeys(datasetType) {
    return cachedKeys(datasetType, () => [
      [
        `datasets.${datasetType}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(datasetType, transition) {
    return cachedKeys(`${datasetType}.transition.${transition}`, () => [
      [
        `datasets.${datasetType}.transitions.${transition}`,
        `transitions.${transition}`
      ],
      [
        `datasets.${datasetType}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(datasetType, elementType) {
    return cachedKeys(`${datasetType}-${elementType}`, () => [
      [
        `datasets.${datasetType}.elements.${elementType}`,
        `datasets.${datasetType}`,
        `elements.${elementType}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(plugin) {
    const id2 = plugin.id;
    const type = this.type;
    return cachedKeys(`${type}-plugin-${id2}`, () => [
      [
        `plugins.${id2}`,
        ...plugin.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(mainScope, resetCache) {
    const _scopeCache = this._scopeCache;
    let cache = _scopeCache.get(mainScope);
    if (!cache || resetCache) {
      cache = /* @__PURE__ */ new Map();
      _scopeCache.set(mainScope, cache);
    }
    return cache;
  }
  getOptionScopes(mainScope, keyLists, resetCache) {
    const { options, type } = this;
    const cache = this._cachedScopes(mainScope, resetCache);
    const cached = cache.get(keyLists);
    if (cached) {
      return cached;
    }
    const scopes = /* @__PURE__ */ new Set();
    keyLists.forEach((keys) => {
      if (mainScope) {
        scopes.add(mainScope);
        keys.forEach((key) => addIfFound(scopes, mainScope, key));
      }
      keys.forEach((key) => addIfFound(scopes, options, key));
      keys.forEach((key) => addIfFound(scopes, overrides[type] || {}, key));
      keys.forEach((key) => addIfFound(scopes, defaults, key));
      keys.forEach((key) => addIfFound(scopes, descriptors, key));
    });
    const array = Array.from(scopes);
    if (array.length === 0) {
      array.push(/* @__PURE__ */ Object.create(null));
    }
    if (keysCached.has(keyLists)) {
      cache.set(keyLists, array);
    }
    return array;
  }
  chartOptionScopes() {
    const { options, type } = this;
    return [
      options,
      overrides[type] || {},
      defaults.datasets[type] || {},
      {
        type
      },
      defaults,
      descriptors
    ];
  }
  resolveNamedOptions(scopes, names2, context, prefixes = [
    ""
  ]) {
    const result = {
      $shared: true
    };
    const { resolver, subPrefixes } = getResolver(this._resolverCache, scopes, prefixes);
    let options = resolver;
    if (needContext(resolver, names2)) {
      result.$shared = false;
      context = isFunction(context) ? context() : context;
      const subResolver = this.createResolver(scopes, context, subPrefixes);
      options = _attachContext(resolver, context, subResolver);
    }
    for (const prop of names2) {
      result[prop] = options[prop];
    }
    return result;
  }
  createResolver(scopes, context, prefixes = [
    ""
  ], descriptorDefaults) {
    const { resolver } = getResolver(this._resolverCache, scopes, prefixes);
    return isObject(context) ? _attachContext(resolver, context, void 0, descriptorDefaults) : resolver;
  }
};
function getResolver(resolverCache, scopes, prefixes) {
  let cache = resolverCache.get(scopes);
  if (!cache) {
    cache = /* @__PURE__ */ new Map();
    resolverCache.set(scopes, cache);
  }
  const cacheKey = prefixes.join();
  let cached = cache.get(cacheKey);
  if (!cached) {
    const resolver = _createResolver(scopes, prefixes);
    cached = {
      resolver,
      subPrefixes: prefixes.filter((p) => !p.toLowerCase().includes("hover"))
    };
    cache.set(cacheKey, cached);
  }
  return cached;
}
var hasFunction = (value) => isObject(value) && Object.getOwnPropertyNames(value).reduce((acc, key) => acc || isFunction(value[key]), false);
function needContext(proxy, names2) {
  const { isScriptable, isIndexable } = _descriptors(proxy);
  for (const prop of names2) {
    const scriptable = isScriptable(prop);
    const indexable = isIndexable(prop);
    const value = (indexable || scriptable) && proxy[prop];
    if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
      return true;
    }
  }
  return false;
}
var version = "4.4.0";
var KNOWN_POSITIONS = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function positionIsHorizontal(position, axis) {
  return position === "top" || position === "bottom" || KNOWN_POSITIONS.indexOf(position) === -1 && axis === "x";
}
function compare2Level(l1, l2) {
  return function(a, b) {
    return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
  };
}
function onAnimationsComplete(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  chart.notifyPlugins("afterRender");
  callback(animationOptions && animationOptions.onComplete, [
    context
  ], chart);
}
function onAnimationProgress(context) {
  const chart = context.chart;
  const animationOptions = chart.options.animation;
  callback(animationOptions && animationOptions.onProgress, [
    context
  ], chart);
}
function getCanvas(item) {
  if (_isDomSupported() && typeof item === "string") {
    item = document.getElementById(item);
  } else if (item && item.length) {
    item = item[0];
  }
  if (item && item.canvas) {
    item = item.canvas;
  }
  return item;
}
var instances = {};
var getChart = (key) => {
  const canvas = getCanvas(key);
  return Object.values(instances).filter((c) => c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
  const keys = Object.keys(obj);
  for (const key of keys) {
    const intKey = +key;
    if (intKey >= start) {
      const value = obj[key];
      delete obj[key];
      if (move > 0 || intKey > start) {
        obj[intKey + move] = value;
      }
    }
  }
}
function determineLastEvent(e, lastEvent, inChartArea, isClick) {
  if (!inChartArea || e.type === "mouseout") {
    return null;
  }
  if (isClick) {
    return lastEvent;
  }
  return e;
}
function getSizeForArea(scale, chartArea, field) {
  return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
  const { xScale, yScale } = meta;
  if (xScale && yScale) {
    return {
      left: getSizeForArea(xScale, chartArea, "left"),
      right: getSizeForArea(xScale, chartArea, "right"),
      top: getSizeForArea(yScale, chartArea, "top"),
      bottom: getSizeForArea(yScale, chartArea, "bottom")
    };
  }
  return chartArea;
}
var Chart = class {
  static defaults = defaults;
  static instances = instances;
  static overrides = overrides;
  static registry = registry;
  static version = version;
  static getChart = getChart;
  static register(...items) {
    registry.add(...items);
    invalidatePlugins();
  }
  static unregister(...items) {
    registry.remove(...items);
    invalidatePlugins();
  }
  constructor(item, userConfig) {
    const config = this.config = new Config(userConfig);
    const initialCanvas = getCanvas(item);
    const existingChart = getChart(initialCanvas);
    if (existingChart) {
      throw new Error("Canvas is already in use. Chart with ID '" + existingChart.id + "' must be destroyed before the canvas with ID '" + existingChart.canvas.id + "' can be reused.");
    }
    const options = config.createResolver(config.chartOptionScopes(), this.getContext());
    this.platform = new (config.platform || _detectPlatform(initialCanvas))();
    this.platform.updateConfig(config);
    const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
    const canvas = context && context.canvas;
    const height = canvas && canvas.height;
    const width = canvas && canvas.width;
    this.id = uid();
    this.ctx = context;
    this.canvas = canvas;
    this.width = width;
    this.height = height;
    this._options = options;
    this._aspectRatio = this.aspectRatio;
    this._layers = [];
    this._metasets = [];
    this._stacks = void 0;
    this.boxes = [];
    this.currentDevicePixelRatio = void 0;
    this.chartArea = void 0;
    this._active = [];
    this._lastEvent = void 0;
    this._listeners = {};
    this._responsiveListeners = void 0;
    this._sortedMetasets = [];
    this.scales = {};
    this._plugins = new PluginService();
    this.$proxies = {};
    this._hiddenIndices = {};
    this.attached = false;
    this._animationsDisabled = void 0;
    this.$context = void 0;
    this._doResize = debounce((mode) => this.update(mode), options.resizeDelay || 0);
    this._dataChanges = [];
    instances[this.id] = this;
    if (!context || !canvas) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    animator.listen(this, "complete", onAnimationsComplete);
    animator.listen(this, "progress", onAnimationProgress);
    this._initialize();
    if (this.attached) {
      this.update();
    }
  }
  get aspectRatio() {
    const { options: { aspectRatio, maintainAspectRatio }, width, height, _aspectRatio } = this;
    if (!isNullOrUndef(aspectRatio)) {
      return aspectRatio;
    }
    if (maintainAspectRatio && _aspectRatio) {
      return _aspectRatio;
    }
    return height ? width / height : null;
  }
  get data() {
    return this.config.data;
  }
  set data(data) {
    this.config.data = data;
  }
  get options() {
    return this._options;
  }
  set options(options) {
    this.config.options = options;
  }
  get registry() {
    return registry;
  }
  _initialize() {
    this.notifyPlugins("beforeInit");
    if (this.options.responsive) {
      this.resize();
    } else {
      retinaScale(this, this.options.devicePixelRatio);
    }
    this.bindEvents();
    this.notifyPlugins("afterInit");
    return this;
  }
  clear() {
    clearCanvas(this.canvas, this.ctx);
    return this;
  }
  stop() {
    animator.stop(this);
    return this;
  }
  resize(width, height) {
    if (!animator.running(this)) {
      this._resize(width, height);
    } else {
      this._resizeBeforeDraw = {
        width,
        height
      };
    }
  }
  _resize(width, height) {
    const options = this.options;
    const canvas = this.canvas;
    const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
    const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
    const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
    const mode = this.width ? "resize" : "attach";
    this.width = newSize.width;
    this.height = newSize.height;
    this._aspectRatio = this.aspectRatio;
    if (!retinaScale(this, newRatio, true)) {
      return;
    }
    this.notifyPlugins("resize", {
      size: newSize
    });
    callback(options.onResize, [
      this,
      newSize
    ], this);
    if (this.attached) {
      if (this._doResize(mode)) {
        this.render();
      }
    }
  }
  ensureScalesHaveIDs() {
    const options = this.options;
    const scalesOptions = options.scales || {};
    each(scalesOptions, (axisOptions, axisID) => {
      axisOptions.id = axisID;
    });
  }
  buildOrUpdateScales() {
    const options = this.options;
    const scaleOpts = options.scales;
    const scales = this.scales;
    const updated = Object.keys(scales).reduce((obj, id2) => {
      obj[id2] = false;
      return obj;
    }, {});
    let items = [];
    if (scaleOpts) {
      items = items.concat(Object.keys(scaleOpts).map((id2) => {
        const scaleOptions = scaleOpts[id2];
        const axis = determineAxis(id2, scaleOptions);
        const isRadial = axis === "r";
        const isHorizontal = axis === "x";
        return {
          options: scaleOptions,
          dposition: isRadial ? "chartArea" : isHorizontal ? "bottom" : "left",
          dtype: isRadial ? "radialLinear" : isHorizontal ? "category" : "linear"
        };
      }));
    }
    each(items, (item) => {
      const scaleOptions = item.options;
      const id2 = scaleOptions.id;
      const axis = determineAxis(id2, scaleOptions);
      const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
      if (scaleOptions.position === void 0 || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
        scaleOptions.position = item.dposition;
      }
      updated[id2] = true;
      let scale = null;
      if (id2 in scales && scales[id2].type === scaleType) {
        scale = scales[id2];
      } else {
        const scaleClass = registry.getScale(scaleType);
        scale = new scaleClass({
          id: id2,
          type: scaleType,
          ctx: this.ctx,
          chart: this
        });
        scales[scale.id] = scale;
      }
      scale.init(scaleOptions, options);
    });
    each(updated, (hasUpdated, id2) => {
      if (!hasUpdated) {
        delete scales[id2];
      }
    });
    each(scales, (scale) => {
      layouts.configure(this, scale, scale.options);
      layouts.addBox(this, scale);
    });
  }
  _updateMetasets() {
    const metasets = this._metasets;
    const numData = this.data.datasets.length;
    const numMeta = metasets.length;
    metasets.sort((a, b) => a.index - b.index);
    if (numMeta > numData) {
      for (let i = numData; i < numMeta; ++i) {
        this._destroyDatasetMeta(i);
      }
      metasets.splice(numData, numMeta - numData);
    }
    this._sortedMetasets = metasets.slice(0).sort(compare2Level("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: metasets, data: { datasets } } = this;
    if (metasets.length > datasets.length) {
      delete this._stacks;
    }
    metasets.forEach((meta, index2) => {
      if (datasets.filter((x) => x === meta._dataset).length === 0) {
        this._destroyDatasetMeta(index2);
      }
    });
  }
  buildOrUpdateControllers() {
    const newControllers = [];
    const datasets = this.data.datasets;
    let i, ilen;
    this._removeUnreferencedMetasets();
    for (i = 0, ilen = datasets.length; i < ilen; i++) {
      const dataset = datasets[i];
      let meta = this.getDatasetMeta(i);
      const type = dataset.type || this.config.type;
      if (meta.type && meta.type !== type) {
        this._destroyDatasetMeta(i);
        meta = this.getDatasetMeta(i);
      }
      meta.type = type;
      meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
      meta.order = dataset.order || 0;
      meta.index = i;
      meta.label = "" + dataset.label;
      meta.visible = this.isDatasetVisible(i);
      if (meta.controller) {
        meta.controller.updateIndex(i);
        meta.controller.linkScales();
      } else {
        const ControllerClass = registry.getController(type);
        const { datasetElementType, dataElementType } = defaults.datasets[type];
        Object.assign(ControllerClass, {
          dataElementType: registry.getElement(dataElementType),
          datasetElementType: datasetElementType && registry.getElement(datasetElementType)
        });
        meta.controller = new ControllerClass(this, i);
        newControllers.push(meta.controller);
      }
    }
    this._updateMetasets();
    return newControllers;
  }
  _resetElements() {
    each(this.data.datasets, (dataset, datasetIndex) => {
      this.getDatasetMeta(datasetIndex).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements();
    this.notifyPlugins("reset");
  }
  update(mode) {
    const config = this.config;
    config.update();
    const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
    const animsDisabled = this._animationsDisabled = !options.animation;
    this._updateScales();
    this._checkEventBindings();
    this._updateHiddenIndices();
    this._plugins.invalidate();
    if (this.notifyPlugins("beforeUpdate", {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    const newControllers = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let minPadding = 0;
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; i++) {
      const { controller } = this.getDatasetMeta(i);
      const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
      controller.buildOrUpdateElements(reset);
      minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
    }
    minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
    this._updateLayout(minPadding);
    if (!animsDisabled) {
      each(newControllers, (controller) => {
        controller.reset();
      });
    }
    this._updateDatasets(mode);
    this.notifyPlugins("afterUpdate", {
      mode
    });
    this._layers.sort(compare2Level("z", "_idx"));
    const { _active, _lastEvent } = this;
    if (_lastEvent) {
      this._eventHandler(_lastEvent, true);
    } else if (_active.length) {
      this._updateHoverStyles(_active, _active, true);
    }
    this.render();
  }
  _updateScales() {
    each(this.scales, (scale) => {
      layouts.removeBox(this, scale);
    });
    this.ensureScalesHaveIDs();
    this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const options = this.options;
    const existingEvents = new Set(Object.keys(this._listeners));
    const newEvents = new Set(options.events);
    if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
      this.unbindEvents();
      this.bindEvents();
    }
  }
  _updateHiddenIndices() {
    const { _hiddenIndices } = this;
    const changes = this._getUniformDataChanges() || [];
    for (const { method, start, count } of changes) {
      const move = method === "_removeElements" ? -count : count;
      moveNumericKeys(_hiddenIndices, start, move);
    }
  }
  _getUniformDataChanges() {
    const _dataChanges = this._dataChanges;
    if (!_dataChanges || !_dataChanges.length) {
      return;
    }
    this._dataChanges = [];
    const datasetCount = this.data.datasets.length;
    const makeSet = (idx) => new Set(_dataChanges.filter((c) => c[0] === idx).map((c, i) => i + "," + c.splice(1).join(",")));
    const changeSet = makeSet(0);
    for (let i = 1; i < datasetCount; i++) {
      if (!setsEqual(changeSet, makeSet(i))) {
        return;
      }
    }
    return Array.from(changeSet).map((c) => c.split(",")).map((a) => ({
      method: a[1],
      start: +a[2],
      count: +a[3]
    }));
  }
  _updateLayout(minPadding) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: true
    }) === false) {
      return;
    }
    layouts.update(this, this.width, this.height, minPadding);
    const area = this.chartArea;
    const noArea = area.width <= 0 || area.height <= 0;
    this._layers = [];
    each(this.boxes, (box) => {
      if (noArea && box.position === "chartArea") {
        return;
      }
      if (box.configure) {
        box.configure();
      }
      this._layers.push(...box._layers());
    }, this);
    this._layers.forEach((item, index2) => {
      item._idx = index2;
    });
    this.notifyPlugins("afterLayout");
  }
  _updateDatasets(mode) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode,
      cancelable: true
    }) === false) {
      return;
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this.getDatasetMeta(i).controller.configure();
    }
    for (let i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._updateDataset(i, isFunction(mode) ? mode({
        datasetIndex: i
      }) : mode);
    }
    this.notifyPlugins("afterDatasetsUpdate", {
      mode
    });
  }
  _updateDataset(index2, mode) {
    const meta = this.getDatasetMeta(index2);
    const args = {
      meta,
      index: index2,
      mode,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetUpdate", args) === false) {
      return;
    }
    meta.controller._update(mode);
    args.cancelable = false;
    this.notifyPlugins("afterDatasetUpdate", args);
  }
  render() {
    if (this.notifyPlugins("beforeRender", {
      cancelable: true
    }) === false) {
      return;
    }
    if (animator.has(this)) {
      if (this.attached && !animator.running(this)) {
        animator.start(this);
      }
    } else {
      this.draw();
      onAnimationsComplete({
        chart: this
      });
    }
  }
  draw() {
    let i;
    if (this._resizeBeforeDraw) {
      const { width, height } = this._resizeBeforeDraw;
      this._resize(width, height);
      this._resizeBeforeDraw = null;
    }
    this.clear();
    if (this.width <= 0 || this.height <= 0) {
      return;
    }
    if (this.notifyPlugins("beforeDraw", {
      cancelable: true
    }) === false) {
      return;
    }
    const layers = this._layers;
    for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
      layers[i].draw(this.chartArea);
    }
    this._drawDatasets();
    for (; i < layers.length; ++i) {
      layers[i].draw(this.chartArea);
    }
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(filterVisible) {
    const metasets = this._sortedMetasets;
    const result = [];
    let i, ilen;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      const meta = metasets[i];
      if (!filterVisible || meta.visible) {
        result.push(meta);
      }
    }
    return result;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(true);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: true
    }) === false) {
      return;
    }
    const metasets = this.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      this._drawDataset(metasets[i]);
    }
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(meta) {
    const ctx = this.ctx;
    const clip = meta._clip;
    const useClip = !clip.disabled;
    const area = getDatasetArea(meta, this.chartArea);
    const args = {
      meta,
      index: meta.index,
      cancelable: true
    };
    if (this.notifyPlugins("beforeDatasetDraw", args) === false) {
      return;
    }
    if (useClip) {
      clipArea(ctx, {
        left: clip.left === false ? 0 : area.left - clip.left,
        right: clip.right === false ? this.width : area.right + clip.right,
        top: clip.top === false ? 0 : area.top - clip.top,
        bottom: clip.bottom === false ? this.height : area.bottom + clip.bottom
      });
    }
    meta.controller.draw();
    if (useClip) {
      unclipArea(ctx);
    }
    args.cancelable = false;
    this.notifyPlugins("afterDatasetDraw", args);
  }
  isPointInArea(point) {
    return _isPointInArea(point, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, mode, options, useFinalPosition) {
    const method = Interaction.modes[mode];
    if (typeof method === "function") {
      return method(this, e, options, useFinalPosition);
    }
    return [];
  }
  getDatasetMeta(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    const metasets = this._metasets;
    let meta = metasets.filter((x) => x && x._dataset === dataset).pop();
    if (!meta) {
      meta = {
        type: null,
        data: [],
        dataset: null,
        controller: null,
        hidden: null,
        xAxisID: null,
        yAxisID: null,
        order: dataset && dataset.order || 0,
        index: datasetIndex,
        _dataset: dataset,
        _parsed: [],
        _sorted: false
      };
      metasets.push(meta);
    }
    return meta;
  }
  getContext() {
    return this.$context || (this.$context = createContext20(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(datasetIndex) {
    const dataset = this.data.datasets[datasetIndex];
    if (!dataset) {
      return false;
    }
    const meta = this.getDatasetMeta(datasetIndex);
    return typeof meta.hidden === "boolean" ? !meta.hidden : !dataset.hidden;
  }
  setDatasetVisibility(datasetIndex, visible) {
    const meta = this.getDatasetMeta(datasetIndex);
    meta.hidden = !visible;
  }
  toggleDataVisibility(index2) {
    this._hiddenIndices[index2] = !this._hiddenIndices[index2];
  }
  getDataVisibility(index2) {
    return !this._hiddenIndices[index2];
  }
  _updateVisibility(datasetIndex, dataIndex, visible) {
    const mode = visible ? "show" : "hide";
    const meta = this.getDatasetMeta(datasetIndex);
    const anims = meta.controller._resolveAnimations(void 0, mode);
    if (defined(dataIndex)) {
      meta.data[dataIndex].hidden = !visible;
      this.update();
    } else {
      this.setDatasetVisibility(datasetIndex, visible);
      anims.update(meta, {
        visible
      });
      this.update((ctx) => ctx.datasetIndex === datasetIndex ? mode : void 0);
    }
  }
  hide(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, false);
  }
  show(datasetIndex, dataIndex) {
    this._updateVisibility(datasetIndex, dataIndex, true);
  }
  _destroyDatasetMeta(datasetIndex) {
    const meta = this._metasets[datasetIndex];
    if (meta && meta.controller) {
      meta.controller._destroy();
    }
    delete this._metasets[datasetIndex];
  }
  _stop() {
    let i, ilen;
    this.stop();
    animator.remove(this);
    for (i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
      this._destroyDatasetMeta(i);
    }
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas, ctx } = this;
    this._stop();
    this.config.clearCache();
    if (canvas) {
      this.unbindEvents();
      clearCanvas(canvas, ctx);
      this.platform.releaseContext(ctx);
      this.canvas = null;
      this.ctx = null;
    }
    delete instances[this.id];
    this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...args) {
    return this.canvas.toDataURL(...args);
  }
  bindEvents() {
    this.bindUserEvents();
    if (this.options.responsive) {
      this.bindResponsiveEvents();
    } else {
      this.attached = true;
    }
  }
  bindUserEvents() {
    const listeners = this._listeners;
    const platform = this.platform;
    const _add = (type, listener2) => {
      platform.addEventListener(this, type, listener2);
      listeners[type] = listener2;
    };
    const listener = (e, x, y) => {
      e.offsetX = x;
      e.offsetY = y;
      this._eventHandler(e);
    };
    each(this.options.events, (type) => _add(type, listener));
  }
  bindResponsiveEvents() {
    if (!this._responsiveListeners) {
      this._responsiveListeners = {};
    }
    const listeners = this._responsiveListeners;
    const platform = this.platform;
    const _add = (type, listener2) => {
      platform.addEventListener(this, type, listener2);
      listeners[type] = listener2;
    };
    const _remove = (type, listener2) => {
      if (listeners[type]) {
        platform.removeEventListener(this, type, listener2);
        delete listeners[type];
      }
    };
    const listener = (width, height) => {
      if (this.canvas) {
        this.resize(width, height);
      }
    };
    let detached;
    const attached = () => {
      _remove("attach", attached);
      this.attached = true;
      this.resize();
      _add("resize", listener);
      _add("detach", detached);
    };
    detached = () => {
      this.attached = false;
      _remove("resize", listener);
      this._stop();
      this._resize(0, 0);
      _add("attach", attached);
    };
    if (platform.isAttached(this.canvas)) {
      attached();
    } else {
      detached();
    }
  }
  unbindEvents() {
    each(this._listeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._listeners = {};
    each(this._responsiveListeners, (listener, type) => {
      this.platform.removeEventListener(this, type, listener);
    });
    this._responsiveListeners = void 0;
  }
  updateHoverStyle(items, mode, enabled) {
    const prefix = enabled ? "set" : "remove";
    let meta, item, i, ilen;
    if (mode === "dataset") {
      meta = this.getDatasetMeta(items[0].datasetIndex);
      meta.controller["_" + prefix + "DatasetHoverStyle"]();
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
      if (controller) {
        controller[prefix + "HoverStyle"](item.element, item.datasetIndex, item.index);
      }
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements) {
    const lastActive = this._active || [];
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("No dataset found at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(active, lastActive);
    if (changed) {
      this._active = active;
      this._lastEvent = null;
      this._updateHoverStyles(active, lastActive);
    }
  }
  notifyPlugins(hook, args, filter) {
    return this._plugins.notify(this, hook, args, filter);
  }
  isPluginEnabled(pluginId) {
    return this._plugins._cache.filter((p) => p.plugin.id === pluginId).length === 1;
  }
  _updateHoverStyles(active, lastActive, replay) {
    const hoverOptions = this.options.hover;
    const diff = (a, b) => a.filter((x) => !b.some((y) => x.datasetIndex === y.datasetIndex && x.index === y.index));
    const deactivated = diff(lastActive, active);
    const activated = replay ? active : diff(active, lastActive);
    if (deactivated.length) {
      this.updateHoverStyle(deactivated, hoverOptions.mode, false);
    }
    if (activated.length && hoverOptions.mode) {
      this.updateHoverStyle(activated, hoverOptions.mode, true);
    }
  }
  _eventHandler(e, replay) {
    const args = {
      event: e,
      replay,
      cancelable: true,
      inChartArea: this.isPointInArea(e)
    };
    const eventFilter = (plugin) => (plugin.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", args, eventFilter) === false) {
      return;
    }
    const changed = this._handleEvent(e, replay, args.inChartArea);
    args.cancelable = false;
    this.notifyPlugins("afterEvent", args, eventFilter);
    if (changed || args.changed) {
      this.render();
    }
    return this;
  }
  _handleEvent(e, replay, inChartArea) {
    const { _active: lastActive = [], options } = this;
    const useFinalPosition = replay;
    const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
    const isClick = _isClickEvent(e);
    const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
    if (inChartArea) {
      this._lastEvent = null;
      callback(options.onHover, [
        e,
        active,
        this
      ], this);
      if (isClick) {
        callback(options.onClick, [
          e,
          active,
          this
        ], this);
      }
    }
    const changed = !_elementsEqual(active, lastActive);
    if (changed || replay) {
      this._active = active;
      this._updateHoverStyles(active, lastActive, replay);
    }
    this._lastEvent = lastEvent;
    return changed;
  }
  _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
    if (e.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const hoverOptions = this.options.hover;
    return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
  }
};
function invalidatePlugins() {
  return each(Chart.instances, (chart) => chart._plugins.invalidate());
}
function setStyle(ctx, options, style = options) {
  ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
  ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
  ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
  ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
  ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
  ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
  ctx.lineTo(target.x, target.y);
}
function getLineMethod(options) {
  if (options.stepped) {
    return _steppedLineTo;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierCurveTo;
  }
  return lineTo;
}
function pathVars(points, segment, params = {}) {
  const count = points.length;
  const { start: paramsStart = 0, end: paramsEnd = count - 1 } = params;
  const { start: segmentStart, end: segmentEnd } = segment;
  const start = Math.max(paramsStart, segmentStart);
  const end = Math.min(paramsEnd, segmentEnd);
  const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
  return {
    count,
    start,
    loop: segment.loop,
    ilen: end < start && !outside ? count + end - start : end - start
  };
}
function pathSegment(ctx, line, segment, params) {
  const { points, options } = line;
  const { count, start, loop, ilen } = pathVars(points, segment, params);
  const lineMethod = getLineMethod(options);
  let { move = true, reverse } = params || {};
  let i, point, prev;
  for (i = 0; i <= ilen; ++i) {
    point = points[(start + (reverse ? ilen - i : i)) % count];
    if (point.skip) {
      continue;
    } else if (move) {
      ctx.moveTo(point.x, point.y);
      move = false;
    } else {
      lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    prev = point;
  }
  if (loop) {
    point = points[(start + (reverse ? ilen : 0)) % count];
    lineMethod(ctx, prev, point, reverse, options.stepped);
  }
  return !!loop;
}
function fastPathSegment(ctx, line, segment, params) {
  const points = line.points;
  const { count, start, ilen } = pathVars(points, segment, params);
  const { move = true, reverse } = params || {};
  let avgX = 0;
  let countX = 0;
  let i, point, prevX, minY, maxY, lastY;
  const pointIndex = (index2) => (start + (reverse ? ilen - index2 : index2)) % count;
  const drawX = () => {
    if (minY !== maxY) {
      ctx.lineTo(avgX, maxY);
      ctx.lineTo(avgX, minY);
      ctx.lineTo(avgX, lastY);
    }
  };
  if (move) {
    point = points[pointIndex(0)];
    ctx.moveTo(point.x, point.y);
  }
  for (i = 0; i <= ilen; ++i) {
    point = points[pointIndex(i)];
    if (point.skip) {
      continue;
    }
    const x = point.x;
    const y = point.y;
    const truncX = x | 0;
    if (truncX === prevX) {
      if (y < minY) {
        minY = y;
      } else if (y > maxY) {
        maxY = y;
      }
      avgX = (countX * avgX + x) / ++countX;
    } else {
      drawX();
      ctx.lineTo(x, y);
      prevX = truncX;
      countX = 0;
      minY = maxY = y;
    }
    lastY = y;
  }
  drawX();
}
function _getSegmentMethod(line) {
  const opts = line.options;
  const borderDash = opts.borderDash && opts.borderDash.length;
  const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== "monotone" && !opts.stepped && !borderDash;
  return useFastPath ? fastPathSegment : pathSegment;
}
function _getInterpolationMethod(options) {
  if (options.stepped) {
    return _steppedInterpolation;
  }
  if (options.tension || options.cubicInterpolationMode === "monotone") {
    return _bezierInterpolation;
  }
  return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
  let path = line._path;
  if (!path) {
    path = line._path = new Path2D();
    if (line.path(path, start, count)) {
      path.closePath();
    }
  }
  setStyle(ctx, line.options);
  ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
  const { segments, options } = line;
  const segmentMethod = _getSegmentMethod(line);
  for (const segment of segments) {
    setStyle(ctx, options, segment.style);
    ctx.beginPath();
    if (segmentMethod(ctx, line, segment, {
      start,
      end: start + count - 1
    })) {
      ctx.closePath();
    }
    ctx.stroke();
  }
}
var usePath2D = typeof Path2D === "function";
function draw(ctx, line, start, count) {
  if (usePath2D && !line.options.segment) {
    strokePathWithCache(ctx, line, start, count);
  } else {
    strokePathDirect(ctx, line, start, count);
  }
}
var LineElement = class extends Element {
  static id = "line";
  static defaults = {
    borderCapStyle: "butt",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 3,
    capBezierPoints: true,
    cubicInterpolationMode: "default",
    fill: false,
    spanGaps: false,
    stepped: false,
    tension: 0
  };
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  static descriptors = {
    _scriptable: true,
    _indexable: (name) => name !== "borderDash" && name !== "fill"
  };
  constructor(cfg) {
    super();
    this.animated = true;
    this.options = void 0;
    this._chart = void 0;
    this._loop = void 0;
    this._fullLoop = void 0;
    this._path = void 0;
    this._points = void 0;
    this._segments = void 0;
    this._decimated = false;
    this._pointsUpdated = false;
    this._datasetIndex = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  updateControlPoints(chartArea, indexAxis) {
    const options = this.options;
    if ((options.tension || options.cubicInterpolationMode === "monotone") && !options.stepped && !this._pointsUpdated) {
      const loop = options.spanGaps ? this._loop : this._fullLoop;
      _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
      this._pointsUpdated = true;
    }
  }
  set points(points) {
    this._points = points;
    delete this._segments;
    delete this._path;
    this._pointsUpdated = false;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = _computeSegments(this, this.options.segment));
  }
  first() {
    const segments = this.segments;
    const points = this.points;
    return segments.length && points[segments[0].start];
  }
  last() {
    const segments = this.segments;
    const points = this.points;
    const count = segments.length;
    return count && points[segments[count - 1].end];
  }
  interpolate(point, property) {
    const options = this.options;
    const value = point[property];
    const points = this.points;
    const segments = _boundSegments(this, {
      property,
      start: value,
      end: value
    });
    if (!segments.length) {
      return;
    }
    const result = [];
    const _interpolate = _getInterpolationMethod(options);
    let i, ilen;
    for (i = 0, ilen = segments.length; i < ilen; ++i) {
      const { start, end } = segments[i];
      const p1 = points[start];
      const p2 = points[end];
      if (p1 === p2) {
        result.push(p1);
        continue;
      }
      const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
      const interpolated = _interpolate(p1, p2, t, options.stepped);
      interpolated[property] = point[property];
      result.push(interpolated);
    }
    return result.length === 1 ? result[0] : result;
  }
  pathSegment(ctx, segment, params) {
    const segmentMethod = _getSegmentMethod(this);
    return segmentMethod(ctx, this, segment, params);
  }
  path(ctx, start, count) {
    const segments = this.segments;
    const segmentMethod = _getSegmentMethod(this);
    let loop = this._loop;
    start = start || 0;
    count = count || this.points.length - start;
    for (const segment of segments) {
      loop &= segmentMethod(ctx, this, segment, {
        start,
        end: start + count - 1
      });
    }
    return !!loop;
  }
  draw(ctx, chartArea, start, count) {
    const options = this.options || {};
    const points = this.points || [];
    if (points.length && options.borderWidth) {
      ctx.save();
      draw(ctx, this, start, count);
      ctx.restore();
    }
    if (this.animated) {
      this._pointsUpdated = false;
      this._path = void 0;
    }
  }
};
function inRange$1(el, pos, axis, useFinalPosition) {
  const options = el.options;
  const { [axis]: value } = el.getProps([
    axis
  ], useFinalPosition);
  return Math.abs(pos - value) < options.radius + options.hitRadius;
}
var PointElement = class extends Element {
  static id = "point";
  parsed;
  skip;
  stop;
  /**
  * @type {any}
  */
  static defaults = {
    borderWidth: 1,
    hitRadius: 1,
    hoverBorderWidth: 1,
    hoverRadius: 4,
    pointStyle: "circle",
    radius: 3,
    rotation: 0
  };
  /**
  * @type {any}
  */
  static defaultRoutes = {
    backgroundColor: "backgroundColor",
    borderColor: "borderColor"
  };
  constructor(cfg) {
    super();
    this.options = void 0;
    this.parsed = void 0;
    this.skip = void 0;
    this.stop = void 0;
    if (cfg) {
      Object.assign(this, cfg);
    }
  }
  inRange(mouseX, mouseY, useFinalPosition) {
    const options = this.options;
    const { x, y } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
  }
  inXRange(mouseX, useFinalPosition) {
    return inRange$1(this, mouseX, "x", useFinalPosition);
  }
  inYRange(mouseY, useFinalPosition) {
    return inRange$1(this, mouseY, "y", useFinalPosition);
  }
  getCenterPoint(useFinalPosition) {
    const { x, y } = this.getProps([
      "x",
      "y"
    ], useFinalPosition);
    return {
      x,
      y
    };
  }
  size(options) {
    options = options || this.options || {};
    let radius = options.radius || 0;
    radius = Math.max(radius, radius && options.hoverRadius || 0);
    const borderWidth = radius && options.borderWidth || 0;
    return (radius + borderWidth) * 2;
  }
  draw(ctx, area) {
    const options = this.options;
    if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
      return;
    }
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.fillStyle = options.backgroundColor;
    drawPoint(ctx, options, this.x, this.y);
  }
  getRange() {
    const options = this.options || {};
    return options.radius + options.hitRadius;
  }
};
function _segments(line, target, property) {
  const segments = line.segments;
  const points = line.points;
  const tpoints = target.points;
  const parts = [];
  for (const segment of segments) {
    let { start, end } = segment;
    end = _findSegmentEnd(start, end, points);
    const bounds = _getBounds(property, points[start], points[end], segment.loop);
    if (!target.segments) {
      parts.push({
        source: segment,
        target: bounds,
        start: points[start],
        end: points[end]
      });
      continue;
    }
    const targetSegments = _boundSegments(target, bounds);
    for (const tgt of targetSegments) {
      const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
      const fillSources = _boundSegment(segment, points, subBounds);
      for (const fillSource of fillSources) {
        parts.push({
          source: fillSource,
          target: tgt,
          start: {
            [property]: _getEdge(bounds, subBounds, "start", Math.max)
          },
          end: {
            [property]: _getEdge(bounds, subBounds, "end", Math.min)
          }
        });
      }
    }
  }
  return parts;
}
function _getBounds(property, first, last, loop) {
  if (loop) {
    return;
  }
  let start = first[property];
  let end = last[property];
  if (property === "angle") {
    start = _normalizeAngle(start);
    end = _normalizeAngle(end);
  }
  return {
    property,
    start,
    end
  };
}
function _pointsFromSegments(boundary, line) {
  const { x = null, y = null } = boundary || {};
  const linePoints = line.points;
  const points = [];
  line.segments.forEach(({ start, end }) => {
    end = _findSegmentEnd(start, end, linePoints);
    const first = linePoints[start];
    const last = linePoints[end];
    if (y !== null) {
      points.push({
        x: first.x,
        y
      });
      points.push({
        x: last.x,
        y
      });
    } else if (x !== null) {
      points.push({
        x,
        y: first.y
      });
      points.push({
        x,
        y: last.y
      });
    }
  });
  return points;
}
function _findSegmentEnd(start, end, points) {
  for (; end > start; end--) {
    const point = points[end];
    if (!isNaN(point.x) && !isNaN(point.y)) {
      break;
    }
  }
  return end;
}
function _getEdge(a, b, prop, fn) {
  if (a && b) {
    return fn(a[prop], b[prop]);
  }
  return a ? a[prop] : b ? b[prop] : 0;
}
function _createBoundaryLine(boundary, line) {
  let points = [];
  let _loop = false;
  if (isArray(boundary)) {
    _loop = true;
    points = boundary;
  } else {
    points = _pointsFromSegments(boundary, line);
  }
  return points.length ? new LineElement({
    points,
    options: {
      tension: 0
    },
    _loop,
    _fullLoop: _loop
  }) : null;
}
function _shouldApplyFill(source) {
  return source && source.fill !== false;
}
function _resolveTarget(sources, index2, propagate) {
  const source = sources[index2];
  let fill2 = source.fill;
  const visited = [
    index2
  ];
  let target;
  if (!propagate) {
    return fill2;
  }
  while (fill2 !== false && visited.indexOf(fill2) === -1) {
    if (!isNumberFinite(fill2)) {
      return fill2;
    }
    target = sources[fill2];
    if (!target) {
      return false;
    }
    if (target.visible) {
      return fill2;
    }
    visited.push(fill2);
    fill2 = target.fill;
  }
  return false;
}
function _decodeFill(line, index2, count) {
  const fill2 = parseFillOption(line);
  if (isObject(fill2)) {
    return isNaN(fill2.value) ? false : fill2;
  }
  let target = parseFloat(fill2);
  if (isNumberFinite(target) && Math.floor(target) === target) {
    return decodeTargetIndex(fill2[0], index2, target, count);
  }
  return [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(fill2) >= 0 && fill2;
}
function decodeTargetIndex(firstCh, index2, target, count) {
  if (firstCh === "-" || firstCh === "+") {
    target = index2 + target;
  }
  if (target === index2 || target < 0 || target >= count) {
    return false;
  }
  return target;
}
function _getTargetPixel(fill2, scale) {
  let pixel = null;
  if (fill2 === "start") {
    pixel = scale.bottom;
  } else if (fill2 === "end") {
    pixel = scale.top;
  } else if (isObject(fill2)) {
    pixel = scale.getPixelForValue(fill2.value);
  } else if (scale.getBasePixel) {
    pixel = scale.getBasePixel();
  }
  return pixel;
}
function _getTargetValue(fill2, scale, startValue) {
  let value;
  if (fill2 === "start") {
    value = startValue;
  } else if (fill2 === "end") {
    value = scale.options.reverse ? scale.min : scale.max;
  } else if (isObject(fill2)) {
    value = fill2.value;
  } else {
    value = scale.getBaseValue();
  }
  return value;
}
function parseFillOption(line) {
  const options = line.options;
  const fillOption = options.fill;
  let fill2 = valueOrDefault(fillOption && fillOption.target, fillOption);
  if (fill2 === void 0) {
    fill2 = !!options.backgroundColor;
  }
  if (fill2 === false || fill2 === null) {
    return false;
  }
  if (fill2 === true) {
    return "origin";
  }
  return fill2;
}
function _buildStackLine(source) {
  const { scale, index: index2, line } = source;
  const points = [];
  const segments = line.segments;
  const sourcePoints = line.points;
  const linesBelow = getLinesBelow(scale, index2);
  linesBelow.push(_createBoundaryLine({
    x: null,
    y: scale.bottom
  }, line));
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    for (let j = segment.start; j <= segment.end; j++) {
      addPointsBelow(points, sourcePoints[j], linesBelow);
    }
  }
  return new LineElement({
    points,
    options: {}
  });
}
function getLinesBelow(scale, index2) {
  const below = [];
  const metas = scale.getMatchingVisibleMetas("line");
  for (let i = 0; i < metas.length; i++) {
    const meta = metas[i];
    if (meta.index === index2) {
      break;
    }
    if (!meta.hidden) {
      below.unshift(meta.dataset);
    }
  }
  return below;
}
function addPointsBelow(points, sourcePoint, linesBelow) {
  const postponed = [];
  for (let j = 0; j < linesBelow.length; j++) {
    const line = linesBelow[j];
    const { first, last, point } = findPoint(line, sourcePoint, "x");
    if (!point || first && last) {
      continue;
    }
    if (first) {
      postponed.unshift(point);
    } else {
      points.push(point);
      if (!last) {
        break;
      }
    }
  }
  points.push(...postponed);
}
function findPoint(line, sourcePoint, property) {
  const point = line.interpolate(sourcePoint, property);
  if (!point) {
    return {};
  }
  const pointValue = point[property];
  const segments = line.segments;
  const linePoints = line.points;
  let first = false;
  let last = false;
  for (let i = 0; i < segments.length; i++) {
    const segment = segments[i];
    const firstValue = linePoints[segment.start][property];
    const lastValue = linePoints[segment.end][property];
    if (_isBetween(pointValue, firstValue, lastValue)) {
      first = pointValue === firstValue;
      last = pointValue === lastValue;
      break;
    }
  }
  return {
    first,
    last,
    point
  };
}
var simpleArc = class {
  constructor(opts) {
    this.x = opts.x;
    this.y = opts.y;
    this.radius = opts.radius;
  }
  pathSegment(ctx, bounds, opts) {
    const { x, y, radius } = this;
    bounds = bounds || {
      start: 0,
      end: TAU
    };
    ctx.arc(x, y, radius, bounds.end, bounds.start, true);
    return !opts.bounds;
  }
  interpolate(point) {
    const { x, y, radius } = this;
    const angle = point.angle;
    return {
      x: x + Math.cos(angle) * radius,
      y: y + Math.sin(angle) * radius,
      angle
    };
  }
};
function _getTarget(source) {
  const { chart, fill: fill2, line } = source;
  if (isNumberFinite(fill2)) {
    return getLineByIndex(chart, fill2);
  }
  if (fill2 === "stack") {
    return _buildStackLine(source);
  }
  if (fill2 === "shape") {
    return true;
  }
  const boundary = computeBoundary(source);
  if (boundary instanceof simpleArc) {
    return boundary;
  }
  return _createBoundaryLine(boundary, line);
}
function getLineByIndex(chart, index2) {
  const meta = chart.getDatasetMeta(index2);
  const visible = meta && chart.isDatasetVisible(index2);
  return visible ? meta.dataset : null;
}
function computeBoundary(source) {
  const scale = source.scale || {};
  if (scale.getPointPositionForValue) {
    return computeCircularBoundary(source);
  }
  return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
  const { scale = {}, fill: fill2 } = source;
  const pixel = _getTargetPixel(fill2, scale);
  if (isNumberFinite(pixel)) {
    const horizontal = scale.isHorizontal();
    return {
      x: horizontal ? pixel : null,
      y: horizontal ? null : pixel
    };
  }
  return null;
}
function computeCircularBoundary(source) {
  const { scale, fill: fill2 } = source;
  const options = scale.options;
  const length = scale.getLabels().length;
  const start = options.reverse ? scale.max : scale.min;
  const value = _getTargetValue(fill2, scale, start);
  const target = [];
  if (options.grid.circular) {
    const center = scale.getPointPositionForValue(0, start);
    return new simpleArc({
      x: center.x,
      y: center.y,
      radius: scale.getDistanceFromCenterForValue(value)
    });
  }
  for (let i = 0; i < length; ++i) {
    target.push(scale.getPointPositionForValue(i, value));
  }
  return target;
}
function _drawfill(ctx, source, area) {
  const target = _getTarget(source);
  const { line, scale, axis } = source;
  const lineOpts = line.options;
  const fillOption = lineOpts.fill;
  const color2 = lineOpts.backgroundColor;
  const { above = color2, below = color2 } = fillOption || {};
  if (target && line.points.length) {
    clipArea(ctx, area);
    doFill(ctx, {
      line,
      target,
      above,
      below,
      area,
      scale,
      axis
    });
    unclipArea(ctx);
  }
}
function doFill(ctx, cfg) {
  const { line, target, above, below, area, scale } = cfg;
  const property = line._loop ? "angle" : cfg.axis;
  ctx.save();
  if (property === "x" && below !== above) {
    clipVertical(ctx, target, area.top);
    fill(ctx, {
      line,
      target,
      color: above,
      scale,
      property
    });
    ctx.restore();
    ctx.save();
    clipVertical(ctx, target, area.bottom);
  }
  fill(ctx, {
    line,
    target,
    color: below,
    scale,
    property
  });
  ctx.restore();
}
function clipVertical(ctx, target, clipY) {
  const { segments, points } = target;
  let first = true;
  let lineLoop = false;
  ctx.beginPath();
  for (const segment of segments) {
    const { start, end } = segment;
    const firstPoint = points[start];
    const lastPoint = points[_findSegmentEnd(start, end, points)];
    if (first) {
      ctx.moveTo(firstPoint.x, firstPoint.y);
      first = false;
    } else {
      ctx.lineTo(firstPoint.x, clipY);
      ctx.lineTo(firstPoint.x, firstPoint.y);
    }
    lineLoop = !!target.pathSegment(ctx, segment, {
      move: lineLoop
    });
    if (lineLoop) {
      ctx.closePath();
    } else {
      ctx.lineTo(lastPoint.x, clipY);
    }
  }
  ctx.lineTo(target.first().x, clipY);
  ctx.closePath();
  ctx.clip();
}
function fill(ctx, cfg) {
  const { line, target, property, color: color2, scale } = cfg;
  const segments = _segments(line, target, property);
  for (const { source: src, target: tgt, start, end } of segments) {
    const { style: { backgroundColor = color2 } = {} } = src;
    const notShape = target !== true;
    ctx.save();
    ctx.fillStyle = backgroundColor;
    clipBounds(ctx, scale, notShape && _getBounds(property, start, end));
    ctx.beginPath();
    const lineLoop = !!line.pathSegment(ctx, src);
    let loop;
    if (notShape) {
      if (lineLoop) {
        ctx.closePath();
      } else {
        interpolatedLineTo(ctx, target, end, property);
      }
      const targetLoop = !!target.pathSegment(ctx, tgt, {
        move: lineLoop,
        reverse: true
      });
      loop = lineLoop && targetLoop;
      if (!loop) {
        interpolatedLineTo(ctx, target, start, property);
      }
    }
    ctx.closePath();
    ctx.fill(loop ? "evenodd" : "nonzero");
    ctx.restore();
  }
}
function clipBounds(ctx, scale, bounds) {
  const { top, bottom } = scale.chart.chartArea;
  const { property, start, end } = bounds || {};
  if (property === "x") {
    ctx.beginPath();
    ctx.rect(start, top, end - start, bottom - top);
    ctx.clip();
  }
}
function interpolatedLineTo(ctx, target, point, property) {
  const interpolatedPoint = target.interpolate(point, property);
  if (interpolatedPoint) {
    ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
  }
}
var index = {
  id: "filler",
  afterDatasetsUpdate(chart, _args, options) {
    const count = (chart.data.datasets || []).length;
    const sources = [];
    let meta, i, line, source;
    for (i = 0; i < count; ++i) {
      meta = chart.getDatasetMeta(i);
      line = meta.dataset;
      source = null;
      if (line && line.options && line instanceof LineElement) {
        source = {
          visible: chart.isDatasetVisible(i),
          index: i,
          fill: _decodeFill(line, i, count),
          chart,
          axis: meta.controller.options.indexAxis,
          scale: meta.vScale,
          line
        };
      }
      meta.$filler = source;
      sources.push(source);
    }
    for (i = 0; i < count; ++i) {
      source = sources[i];
      if (!source || source.fill === false) {
        continue;
      }
      source.fill = _resolveTarget(sources, i, options.propagate);
    }
  },
  beforeDraw(chart, _args, options) {
    const draw2 = options.drawTime === "beforeDraw";
    const metasets = chart.getSortedVisibleDatasetMetas();
    const area = chart.chartArea;
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (!source) {
        continue;
      }
      source.line.updateControlPoints(area, source.axis);
      if (draw2 && source.fill) {
        _drawfill(chart.ctx, source, area);
      }
    }
  },
  beforeDatasetsDraw(chart, _args, options) {
    if (options.drawTime !== "beforeDatasetsDraw") {
      return;
    }
    const metasets = chart.getSortedVisibleDatasetMetas();
    for (let i = metasets.length - 1; i >= 0; --i) {
      const source = metasets[i].$filler;
      if (_shouldApplyFill(source)) {
        _drawfill(chart.ctx, source, chart.chartArea);
      }
    }
  },
  beforeDatasetDraw(chart, args, options) {
    const source = args.meta.$filler;
    if (!_shouldApplyFill(source) || options.drawTime !== "beforeDatasetDraw") {
      return;
    }
    _drawfill(chart.ctx, source, chart.chartArea);
  },
  defaults: {
    propagate: true,
    drawTime: "beforeDatasetDraw"
  }
};
var Title = class extends Element {
  constructor(config) {
    super();
    this.chart = config.chart;
    this.options = config.options;
    this.ctx = config.ctx;
    this._padding = void 0;
    this.top = void 0;
    this.bottom = void 0;
    this.left = void 0;
    this.right = void 0;
    this.width = void 0;
    this.height = void 0;
    this.position = void 0;
    this.weight = void 0;
    this.fullSize = void 0;
  }
  update(maxWidth, maxHeight) {
    const opts = this.options;
    this.left = 0;
    this.top = 0;
    if (!opts.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = maxWidth;
    this.height = this.bottom = maxHeight;
    const lineCount = isArray(opts.text) ? opts.text.length : 1;
    this._padding = toPadding(opts.padding);
    const textSize = lineCount * toFont(opts.font).lineHeight + this._padding.height;
    if (this.isHorizontal()) {
      this.height = textSize;
    } else {
      this.width = textSize;
    }
  }
  isHorizontal() {
    const pos = this.options.position;
    return pos === "top" || pos === "bottom";
  }
  _drawArgs(offset) {
    const { top, left, bottom, right, options } = this;
    const align = options.align;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    if (this.isHorizontal()) {
      titleX = _alignStartEnd(align, left, right);
      titleY = top + offset;
      maxWidth = right - left;
    } else {
      if (options.position === "left") {
        titleX = left + offset;
        titleY = _alignStartEnd(align, bottom, top);
        rotation = PI * -0.5;
      } else {
        titleX = right - offset;
        titleY = _alignStartEnd(align, top, bottom);
        rotation = PI * 0.5;
      }
      maxWidth = bottom - top;
    }
    return {
      titleX,
      titleY,
      maxWidth,
      rotation
    };
  }
  draw() {
    const ctx = this.ctx;
    const opts = this.options;
    if (!opts.display) {
      return;
    }
    const fontOpts = toFont(opts.font);
    const lineHeight = fontOpts.lineHeight;
    const offset = lineHeight / 2 + this._padding.top;
    const { titleX, titleY, maxWidth, rotation } = this._drawArgs(offset);
    renderText(ctx, opts.text, 0, 0, fontOpts, {
      color: opts.color,
      maxWidth,
      rotation,
      textAlign: _toLeftRightCenter(opts.align),
      textBaseline: "middle",
      translation: [
        titleX,
        titleY
      ]
    });
  }
};
function createTitle(chart, titleOpts) {
  const title = new Title({
    ctx: chart.ctx,
    options: titleOpts,
    chart
  });
  layouts.configure(chart, title, titleOpts);
  layouts.addBox(chart, title);
  chart.titleBlock = title;
}
var plugin_title = {
  id: "title",
  _element: Title,
  start(chart, _args, options) {
    createTitle(chart, options);
  },
  stop(chart) {
    const titleBlock = chart.titleBlock;
    layouts.removeBox(chart, titleBlock);
    delete chart.titleBlock;
  },
  beforeUpdate(chart, _args, options) {
    const title = chart.titleBlock;
    layouts.configure(chart, title, options);
    title.options = options;
  },
  defaults: {
    align: "center",
    display: false,
    font: {
      weight: "bold"
    },
    fullSize: true,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: true,
    _indexable: false
  }
};
var positioners = {
  average(items) {
    if (!items.length) {
      return false;
    }
    let i, len;
    let x = 0;
    let y = 0;
    let count = 0;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const pos = el.tooltipPosition();
        x += pos.x;
        y += pos.y;
        ++count;
      }
    }
    return {
      x: x / count,
      y: y / count
    };
  },
  nearest(items, eventPosition) {
    if (!items.length) {
      return false;
    }
    let x = eventPosition.x;
    let y = eventPosition.y;
    let minDistance = Number.POSITIVE_INFINITY;
    let i, len, nearestElement;
    for (i = 0, len = items.length; i < len; ++i) {
      const el = items[i].element;
      if (el && el.hasValue()) {
        const center = el.getCenterPoint();
        const d = distanceBetweenPoints(eventPosition, center);
        if (d < minDistance) {
          minDistance = d;
          nearestElement = el;
        }
      }
    }
    if (nearestElement) {
      const tp = nearestElement.tooltipPosition();
      x = tp.x;
      y = tp.y;
    }
    return {
      x,
      y
    };
  }
};
function pushOrConcat(base, toPush) {
  if (toPush) {
    if (isArray(toPush)) {
      Array.prototype.push.apply(base, toPush);
    } else {
      base.push(toPush);
    }
  }
  return base;
}
function splitNewlines(str) {
  if ((typeof str === "string" || str instanceof String) && str.indexOf("\n") > -1) {
    return str.split("\n");
  }
  return str;
}
function createTooltipItem(chart, item) {
  const { element, datasetIndex, index: index2 } = item;
  const controller = chart.getDatasetMeta(datasetIndex).controller;
  const { label, value } = controller.getLabelAndValue(index2);
  return {
    chart,
    label,
    parsed: controller.getParsed(index2),
    raw: chart.data.datasets[datasetIndex].data[index2],
    formattedValue: value,
    dataset: controller.getDataset(),
    dataIndex: index2,
    datasetIndex,
    element
  };
}
function getTooltipSize(tooltip, options) {
  const ctx = tooltip.chart.ctx;
  const { body, footer, title } = tooltip;
  const { boxWidth, boxHeight } = options;
  const bodyFont = toFont(options.bodyFont);
  const titleFont = toFont(options.titleFont);
  const footerFont = toFont(options.footerFont);
  const titleLineCount = title.length;
  const footerLineCount = footer.length;
  const bodyLineItemCount = body.length;
  const padding = toPadding(options.padding);
  let height = padding.height;
  let width = 0;
  let combinedBodyLength = body.reduce((count, bodyItem) => count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
  combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
  if (titleLineCount) {
    height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
  }
  if (combinedBodyLength) {
    const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
    height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
  }
  if (footerLineCount) {
    height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
  }
  let widthPadding = 0;
  const maxLineWidth = function(line) {
    width = Math.max(width, ctx.measureText(line).width + widthPadding);
  };
  ctx.save();
  ctx.font = titleFont.string;
  each(tooltip.title, maxLineWidth);
  ctx.font = bodyFont.string;
  each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
  widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
  each(body, (bodyItem) => {
    each(bodyItem.before, maxLineWidth);
    each(bodyItem.lines, maxLineWidth);
    each(bodyItem.after, maxLineWidth);
  });
  widthPadding = 0;
  ctx.font = footerFont.string;
  each(tooltip.footer, maxLineWidth);
  ctx.restore();
  width += padding.width;
  return {
    width,
    height
  };
}
function determineYAlign(chart, size) {
  const { y, height } = size;
  if (y < height / 2) {
    return "top";
  } else if (y > chart.height - height / 2) {
    return "bottom";
  }
  return "center";
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
  const { x, width } = size;
  const caret = options.caretSize + options.caretPadding;
  if (xAlign === "left" && x + width + caret > chart.width) {
    return true;
  }
  if (xAlign === "right" && x - width - caret < 0) {
    return true;
  }
}
function determineXAlign(chart, options, size, yAlign) {
  const { x, width } = size;
  const { width: chartWidth, chartArea: { left, right } } = chart;
  let xAlign = "center";
  if (yAlign === "center") {
    xAlign = x <= (left + right) / 2 ? "left" : "right";
  } else if (x <= width / 2) {
    xAlign = "left";
  } else if (x >= chartWidth - width / 2) {
    xAlign = "right";
  }
  if (doesNotFitWithAlign(xAlign, chart, options, size)) {
    xAlign = "center";
  }
  return xAlign;
}
function determineAlignment(chart, options, size) {
  const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
  return {
    xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
    yAlign
  };
}
function alignX(size, xAlign) {
  let { x, width } = size;
  if (xAlign === "right") {
    x -= width;
  } else if (xAlign === "center") {
    x -= width / 2;
  }
  return x;
}
function alignY(size, yAlign, paddingAndSize) {
  let { y, height } = size;
  if (yAlign === "top") {
    y += paddingAndSize;
  } else if (yAlign === "bottom") {
    y -= height + paddingAndSize;
  } else {
    y -= height / 2;
  }
  return y;
}
function getBackgroundPoint(options, size, alignment, chart) {
  const { caretSize, caretPadding, cornerRadius } = options;
  const { xAlign, yAlign } = alignment;
  const paddingAndSize = caretSize + caretPadding;
  const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
  let x = alignX(size, xAlign);
  const y = alignY(size, yAlign, paddingAndSize);
  if (yAlign === "center") {
    if (xAlign === "left") {
      x += paddingAndSize;
    } else if (xAlign === "right") {
      x -= paddingAndSize;
    }
  } else if (xAlign === "left") {
    x -= Math.max(topLeft, bottomLeft) + caretSize;
  } else if (xAlign === "right") {
    x += Math.max(topRight, bottomRight) + caretSize;
  }
  return {
    x: _limitValue(x, 0, chart.width - size.width),
    y: _limitValue(y, 0, chart.height - size.height)
  };
}
function getAlignedX(tooltip, align, options) {
  const padding = toPadding(options.padding);
  return align === "center" ? tooltip.x + tooltip.width / 2 : align === "right" ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
function getBeforeAfterBodyLines(callback2) {
  return pushOrConcat([], splitNewlines(callback2));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
  return createContext20(parent, {
    tooltip,
    tooltipItems,
    type: "tooltip"
  });
}
function overrideCallbacks(callbacks, context) {
  const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
  return override ? callbacks.override(override) : callbacks;
}
var defaultCallbacks = {
  beforeTitle: noop,
  title(tooltipItems) {
    if (tooltipItems.length > 0) {
      const item = tooltipItems[0];
      const labels = item.chart.data.labels;
      const labelCount = labels ? labels.length : 0;
      if (this && this.options && this.options.mode === "dataset") {
        return item.dataset.label || "";
      } else if (item.label) {
        return item.label;
      } else if (labelCount > 0 && item.dataIndex < labelCount) {
        return labels[item.dataIndex];
      }
    }
    return "";
  },
  afterTitle: noop,
  beforeBody: noop,
  beforeLabel: noop,
  label(tooltipItem) {
    if (this && this.options && this.options.mode === "dataset") {
      return tooltipItem.label + ": " + tooltipItem.formattedValue || tooltipItem.formattedValue;
    }
    let label = tooltipItem.dataset.label || "";
    if (label) {
      label += ": ";
    }
    const value = tooltipItem.formattedValue;
    if (!isNullOrUndef(value)) {
      label += value;
    }
    return label;
  },
  labelColor(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      borderColor: options.borderColor,
      backgroundColor: options.backgroundColor,
      borderWidth: options.borderWidth,
      borderDash: options.borderDash,
      borderDashOffset: options.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(tooltipItem) {
    const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
    const options = meta.controller.getStyle(tooltipItem.dataIndex);
    return {
      pointStyle: options.pointStyle,
      rotation: options.rotation
    };
  },
  afterLabel: noop,
  afterBody: noop,
  beforeFooter: noop,
  footer: noop,
  afterFooter: noop
};
function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
  const result = callbacks[name].call(ctx, arg);
  if (typeof result === "undefined") {
    return defaultCallbacks[name].call(ctx, arg);
  }
  return result;
}
var Tooltip = class extends Element {
  static positioners = positioners;
  constructor(config) {
    super();
    this.opacity = 0;
    this._active = [];
    this._eventPosition = void 0;
    this._size = void 0;
    this._cachedAnimations = void 0;
    this._tooltipItems = [];
    this.$animations = void 0;
    this.$context = void 0;
    this.chart = config.chart;
    this.options = config.options;
    this.dataPoints = void 0;
    this.title = void 0;
    this.beforeBody = void 0;
    this.body = void 0;
    this.afterBody = void 0;
    this.footer = void 0;
    this.xAlign = void 0;
    this.yAlign = void 0;
    this.x = void 0;
    this.y = void 0;
    this.height = void 0;
    this.width = void 0;
    this.caretX = void 0;
    this.caretY = void 0;
    this.labelColors = void 0;
    this.labelPointStyles = void 0;
    this.labelTextColors = void 0;
  }
  initialize(options) {
    this.options = options;
    this._cachedAnimations = void 0;
    this.$context = void 0;
  }
  _resolveAnimations() {
    const cached = this._cachedAnimations;
    if (cached) {
      return cached;
    }
    const chart = this.chart;
    const options = this.options.setContext(this.getContext());
    const opts = options.enabled && chart.options.animation && options.animations;
    const animations = new Animations(this.chart, opts);
    if (opts._cacheable) {
      this._cachedAnimations = Object.freeze(animations);
    }
    return animations;
  }
  getContext() {
    return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(context, options) {
    const { callbacks } = options;
    const beforeTitle = invokeCallbackWithFallback(callbacks, "beforeTitle", this, context);
    const title = invokeCallbackWithFallback(callbacks, "title", this, context);
    const afterTitle = invokeCallbackWithFallback(callbacks, "afterTitle", this, context);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeTitle));
    lines = pushOrConcat(lines, splitNewlines(title));
    lines = pushOrConcat(lines, splitNewlines(afterTitle));
    return lines;
  }
  getBeforeBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "beforeBody", this, tooltipItems));
  }
  getBody(tooltipItems, options) {
    const { callbacks } = options;
    const bodyItems = [];
    each(tooltipItems, (context) => {
      const bodyItem = {
        before: [],
        lines: [],
        after: []
      };
      const scoped = overrideCallbacks(callbacks, context);
      pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, "beforeLabel", this, context)));
      pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, "label", this, context));
      pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, "afterLabel", this, context)));
      bodyItems.push(bodyItem);
    });
    return bodyItems;
  }
  getAfterBody(tooltipItems, options) {
    return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, "afterBody", this, tooltipItems));
  }
  getFooter(tooltipItems, options) {
    const { callbacks } = options;
    const beforeFooter = invokeCallbackWithFallback(callbacks, "beforeFooter", this, tooltipItems);
    const footer = invokeCallbackWithFallback(callbacks, "footer", this, tooltipItems);
    const afterFooter = invokeCallbackWithFallback(callbacks, "afterFooter", this, tooltipItems);
    let lines = [];
    lines = pushOrConcat(lines, splitNewlines(beforeFooter));
    lines = pushOrConcat(lines, splitNewlines(footer));
    lines = pushOrConcat(lines, splitNewlines(afterFooter));
    return lines;
  }
  _createItems(options) {
    const active = this._active;
    const data = this.chart.data;
    const labelColors = [];
    const labelPointStyles = [];
    const labelTextColors = [];
    let tooltipItems = [];
    let i, len;
    for (i = 0, len = active.length; i < len; ++i) {
      tooltipItems.push(createTooltipItem(this.chart, active[i]));
    }
    if (options.filter) {
      tooltipItems = tooltipItems.filter((element, index2, array) => options.filter(element, index2, array, data));
    }
    if (options.itemSort) {
      tooltipItems = tooltipItems.sort((a, b) => options.itemSort(a, b, data));
    }
    each(tooltipItems, (context) => {
      const scoped = overrideCallbacks(options.callbacks, context);
      labelColors.push(invokeCallbackWithFallback(scoped, "labelColor", this, context));
      labelPointStyles.push(invokeCallbackWithFallback(scoped, "labelPointStyle", this, context));
      labelTextColors.push(invokeCallbackWithFallback(scoped, "labelTextColor", this, context));
    });
    this.labelColors = labelColors;
    this.labelPointStyles = labelPointStyles;
    this.labelTextColors = labelTextColors;
    this.dataPoints = tooltipItems;
    return tooltipItems;
  }
  update(changed, replay) {
    const options = this.options.setContext(this.getContext());
    const active = this._active;
    let properties;
    let tooltipItems = [];
    if (!active.length) {
      if (this.opacity !== 0) {
        properties = {
          opacity: 0
        };
      }
    } else {
      const position = positioners[options.position].call(this, active, this._eventPosition);
      tooltipItems = this._createItems(options);
      this.title = this.getTitle(tooltipItems, options);
      this.beforeBody = this.getBeforeBody(tooltipItems, options);
      this.body = this.getBody(tooltipItems, options);
      this.afterBody = this.getAfterBody(tooltipItems, options);
      this.footer = this.getFooter(tooltipItems, options);
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, size);
      const alignment = determineAlignment(this.chart, options, positionAndSize);
      const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
      this.xAlign = alignment.xAlign;
      this.yAlign = alignment.yAlign;
      properties = {
        opacity: 1,
        x: backgroundPoint.x,
        y: backgroundPoint.y,
        width: size.width,
        height: size.height,
        caretX: position.x,
        caretY: position.y
      };
    }
    this._tooltipItems = tooltipItems;
    this.$context = void 0;
    if (properties) {
      this._resolveAnimations().update(this, properties);
    }
    if (changed && options.external) {
      options.external.call(this, {
        chart: this.chart,
        tooltip: this,
        replay
      });
    }
  }
  drawCaret(tooltipPoint, ctx, size, options) {
    const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
    ctx.lineTo(caretPosition.x1, caretPosition.y1);
    ctx.lineTo(caretPosition.x2, caretPosition.y2);
    ctx.lineTo(caretPosition.x3, caretPosition.y3);
  }
  getCaretPosition(tooltipPoint, size, options) {
    const { xAlign, yAlign } = this;
    const { caretSize, cornerRadius } = options;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(cornerRadius);
    const { x: ptX, y: ptY } = tooltipPoint;
    const { width, height } = size;
    let x1, x2, x3, y1, y2, y3;
    if (yAlign === "center") {
      y2 = ptY + height / 2;
      if (xAlign === "left") {
        x1 = ptX;
        x2 = x1 - caretSize;
        y1 = y2 + caretSize;
        y3 = y2 - caretSize;
      } else {
        x1 = ptX + width;
        x2 = x1 + caretSize;
        y1 = y2 - caretSize;
        y3 = y2 + caretSize;
      }
      x3 = x1;
    } else {
      if (xAlign === "left") {
        x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
      } else if (xAlign === "right") {
        x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
      } else {
        x2 = this.caretX;
      }
      if (yAlign === "top") {
        y1 = ptY;
        y2 = y1 - caretSize;
        x1 = x2 - caretSize;
        x3 = x2 + caretSize;
      } else {
        y1 = ptY + height;
        y2 = y1 + caretSize;
        x1 = x2 + caretSize;
        x3 = x2 - caretSize;
      }
      y3 = y1;
    }
    return {
      x1,
      x2,
      x3,
      y1,
      y2,
      y3
    };
  }
  drawTitle(pt, ctx, options) {
    const title = this.title;
    const length = title.length;
    let titleFont, titleSpacing, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.titleAlign, options);
      ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
      ctx.textBaseline = "middle";
      titleFont = toFont(options.titleFont);
      titleSpacing = options.titleSpacing;
      ctx.fillStyle = options.titleColor;
      ctx.font = titleFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
        pt.y += titleFont.lineHeight + titleSpacing;
        if (i + 1 === length) {
          pt.y += options.titleMarginBottom - titleSpacing;
        }
      }
    }
  }
  _drawColorBox(ctx, pt, i, rtlHelper, options) {
    const labelColor = this.labelColors[i];
    const labelPointStyle = this.labelPointStyles[i];
    const { boxHeight, boxWidth } = options;
    const bodyFont = toFont(options.bodyFont);
    const colorX = getAlignedX(this, "left", options);
    const rtlColorX = rtlHelper.x(colorX);
    const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
    const colorY = pt.y + yOffSet;
    if (options.usePointStyle) {
      const drawOptions = {
        radius: Math.min(boxWidth, boxHeight) / 2,
        pointStyle: labelPointStyle.pointStyle,
        rotation: labelPointStyle.rotation,
        borderWidth: 1
      };
      const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
      const centerY = colorY + boxHeight / 2;
      ctx.strokeStyle = options.multiKeyBackground;
      ctx.fillStyle = options.multiKeyBackground;
      drawPoint(ctx, drawOptions, centerX, centerY);
      ctx.strokeStyle = labelColor.borderColor;
      ctx.fillStyle = labelColor.backgroundColor;
      drawPoint(ctx, drawOptions, centerX, centerY);
    } else {
      ctx.lineWidth = isObject(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
      ctx.strokeStyle = labelColor.borderColor;
      ctx.setLineDash(labelColor.borderDash || []);
      ctx.lineDashOffset = labelColor.borderDashOffset || 0;
      const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
      const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
      const borderRadius = toTRBLCorners(labelColor.borderRadius);
      if (Object.values(borderRadius).some((v) => v !== 0)) {
        ctx.beginPath();
        ctx.fillStyle = options.multiKeyBackground;
        addRoundedRectPath(ctx, {
          x: outerX,
          y: colorY,
          w: boxWidth,
          h: boxHeight,
          radius: borderRadius
        });
        ctx.fill();
        ctx.stroke();
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.beginPath();
        addRoundedRectPath(ctx, {
          x: innerX,
          y: colorY + 1,
          w: boxWidth - 2,
          h: boxHeight - 2,
          radius: borderRadius
        });
        ctx.fill();
      } else {
        ctx.fillStyle = options.multiKeyBackground;
        ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
        ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
        ctx.fillStyle = labelColor.backgroundColor;
        ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
      }
    }
    ctx.fillStyle = this.labelTextColors[i];
  }
  drawBody(pt, ctx, options) {
    const { body } = this;
    const { bodySpacing, bodyAlign, displayColors, boxHeight, boxWidth, boxPadding } = options;
    const bodyFont = toFont(options.bodyFont);
    let bodyLineHeight = bodyFont.lineHeight;
    let xLinePadding = 0;
    const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
    const fillLineOfText = function(line) {
      ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
      pt.y += bodyLineHeight + bodySpacing;
    };
    const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
    let bodyItem, textColor, lines, i, j, ilen, jlen;
    ctx.textAlign = bodyAlign;
    ctx.textBaseline = "middle";
    ctx.font = bodyFont.string;
    pt.x = getAlignedX(this, bodyAlignForCalculation, options);
    ctx.fillStyle = options.bodyColor;
    each(this.beforeBody, fillLineOfText);
    xLinePadding = displayColors && bodyAlignForCalculation !== "right" ? bodyAlign === "center" ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
    for (i = 0, ilen = body.length; i < ilen; ++i) {
      bodyItem = body[i];
      textColor = this.labelTextColors[i];
      ctx.fillStyle = textColor;
      each(bodyItem.before, fillLineOfText);
      lines = bodyItem.lines;
      if (displayColors && lines.length) {
        this._drawColorBox(ctx, pt, i, rtlHelper, options);
        bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
      }
      for (j = 0, jlen = lines.length; j < jlen; ++j) {
        fillLineOfText(lines[j]);
        bodyLineHeight = bodyFont.lineHeight;
      }
      each(bodyItem.after, fillLineOfText);
    }
    xLinePadding = 0;
    bodyLineHeight = bodyFont.lineHeight;
    each(this.afterBody, fillLineOfText);
    pt.y -= bodySpacing;
  }
  drawFooter(pt, ctx, options) {
    const footer = this.footer;
    const length = footer.length;
    let footerFont, i;
    if (length) {
      const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
      pt.x = getAlignedX(this, options.footerAlign, options);
      pt.y += options.footerMarginTop;
      ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
      ctx.textBaseline = "middle";
      footerFont = toFont(options.footerFont);
      ctx.fillStyle = options.footerColor;
      ctx.font = footerFont.string;
      for (i = 0; i < length; ++i) {
        ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
        pt.y += footerFont.lineHeight + options.footerSpacing;
      }
    }
  }
  drawBackground(pt, ctx, tooltipSize, options) {
    const { xAlign, yAlign } = this;
    const { x, y } = pt;
    const { width, height } = tooltipSize;
    const { topLeft, topRight, bottomLeft, bottomRight } = toTRBLCorners(options.cornerRadius);
    ctx.fillStyle = options.backgroundColor;
    ctx.strokeStyle = options.borderColor;
    ctx.lineWidth = options.borderWidth;
    ctx.beginPath();
    ctx.moveTo(x + topLeft, y);
    if (yAlign === "top") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width - topRight, y);
    ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
    if (yAlign === "center" && xAlign === "right") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + width, y + height - bottomRight);
    ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
    if (yAlign === "bottom") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x + bottomLeft, y + height);
    ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
    if (yAlign === "center" && xAlign === "left") {
      this.drawCaret(pt, ctx, tooltipSize, options);
    }
    ctx.lineTo(x, y + topLeft);
    ctx.quadraticCurveTo(x, y, x + topLeft, y);
    ctx.closePath();
    ctx.fill();
    if (options.borderWidth > 0) {
      ctx.stroke();
    }
  }
  _updateAnimationTarget(options) {
    const chart = this.chart;
    const anims = this.$animations;
    const animX = anims && anims.x;
    const animY = anims && anims.y;
    if (animX || animY) {
      const position = positioners[options.position].call(this, this._active, this._eventPosition);
      if (!position) {
        return;
      }
      const size = this._size = getTooltipSize(this, options);
      const positionAndSize = Object.assign({}, position, this._size);
      const alignment = determineAlignment(chart, options, positionAndSize);
      const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
      if (animX._to !== point.x || animY._to !== point.y) {
        this.xAlign = alignment.xAlign;
        this.yAlign = alignment.yAlign;
        this.width = size.width;
        this.height = size.height;
        this.caretX = position.x;
        this.caretY = position.y;
        this._resolveAnimations().update(this, point);
      }
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(ctx) {
    const options = this.options.setContext(this.getContext());
    let opacity = this.opacity;
    if (!opacity) {
      return;
    }
    this._updateAnimationTarget(options);
    const tooltipSize = {
      width: this.width,
      height: this.height
    };
    const pt = {
      x: this.x,
      y: this.y
    };
    opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
    const padding = toPadding(options.padding);
    const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    if (options.enabled && hasTooltipContent) {
      ctx.save();
      ctx.globalAlpha = opacity;
      this.drawBackground(pt, ctx, tooltipSize, options);
      overrideTextDirection(ctx, options.textDirection);
      pt.y += padding.top;
      this.drawTitle(pt, ctx, options);
      this.drawBody(pt, ctx, options);
      this.drawFooter(pt, ctx, options);
      restoreTextDirection(ctx, options.textDirection);
      ctx.restore();
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(activeElements, eventPosition) {
    const lastActive = this._active;
    const active = activeElements.map(({ datasetIndex, index: index2 }) => {
      const meta = this.chart.getDatasetMeta(datasetIndex);
      if (!meta) {
        throw new Error("Cannot find a dataset at index " + datasetIndex);
      }
      return {
        datasetIndex,
        element: meta.data[index2],
        index: index2
      };
    });
    const changed = !_elementsEqual(lastActive, active);
    const positionChanged = this._positionChanged(active, eventPosition);
    if (changed || positionChanged) {
      this._active = active;
      this._eventPosition = eventPosition;
      this._ignoreReplayEvents = true;
      this.update(true);
    }
  }
  handleEvent(e, replay, inChartArea = true) {
    if (replay && this._ignoreReplayEvents) {
      return false;
    }
    this._ignoreReplayEvents = false;
    const options = this.options;
    const lastActive = this._active || [];
    const active = this._getActiveElements(e, lastActive, replay, inChartArea);
    const positionChanged = this._positionChanged(active, e);
    const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
    if (changed) {
      this._active = active;
      if (options.enabled || options.external) {
        this._eventPosition = {
          x: e.x,
          y: e.y
        };
        this.update(true, replay);
      }
    }
    return changed;
  }
  _getActiveElements(e, lastActive, replay, inChartArea) {
    const options = this.options;
    if (e.type === "mouseout") {
      return [];
    }
    if (!inChartArea) {
      return lastActive;
    }
    const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
    if (options.reverse) {
      active.reverse();
    }
    return active;
  }
  _positionChanged(active, e) {
    const { caretX, caretY, options } = this;
    const position = positioners[options.position].call(this, active, e);
    return position !== false && (caretX !== position.x || caretY !== position.y);
  }
};
var plugin_tooltip = {
  id: "tooltip",
  _element: Tooltip,
  positioners,
  afterInit(chart, _args, options) {
    if (options) {
      chart.tooltip = new Tooltip({
        chart,
        options
      });
    }
  },
  beforeUpdate(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  reset(chart, _args, options) {
    if (chart.tooltip) {
      chart.tooltip.initialize(options);
    }
  },
  afterDraw(chart) {
    const tooltip = chart.tooltip;
    if (tooltip && tooltip._willRender()) {
      const args = {
        tooltip
      };
      if (chart.notifyPlugins("beforeTooltipDraw", {
        ...args,
        cancelable: true
      }) === false) {
        return;
      }
      tooltip.draw(chart.ctx);
      chart.notifyPlugins("afterTooltipDraw", args);
    }
  },
  afterEvent(chart, args) {
    if (chart.tooltip) {
      const useFinalPosition = args.replay;
      if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
        args.changed = true;
      }
    }
  },
  defaults: {
    enabled: true,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (ctx, opts) => opts.bodyFont.size,
    boxWidth: (ctx, opts) => opts.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: true,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: defaultCallbacks
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (name) => name !== "filter" && name !== "itemSort" && name !== "external",
    _indexable: false,
    callbacks: {
      _scriptable: false,
      _indexable: false
    },
    animation: {
      _fallback: false
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
var addIfString = (labels, raw, index2, addedLabels) => {
  if (typeof raw === "string") {
    index2 = labels.push(raw) - 1;
    addedLabels.unshift({
      index: index2,
      label: raw
    });
  } else if (isNaN(raw)) {
    index2 = null;
  }
  return index2;
};
function findOrAddLabel(labels, raw, index2, addedLabels) {
  const first = labels.indexOf(raw);
  if (first === -1) {
    return addIfString(labels, raw, index2, addedLabels);
  }
  const last = labels.lastIndexOf(raw);
  return first !== last ? index2 : first;
}
var validIndex = (index2, max) => index2 === null ? null : _limitValue(Math.round(index2), 0, max);
function _getLabelForValue(value) {
  const labels = this.getLabels();
  if (value >= 0 && value < labels.length) {
    return labels[value];
  }
  return value;
}
var CategoryScale = class extends Scale {
  static id = "category";
  static defaults = {
    ticks: {
      callback: _getLabelForValue
    }
  };
  constructor(cfg) {
    super(cfg);
    this._startValue = void 0;
    this._valueRange = 0;
    this._addedLabels = [];
  }
  init(scaleOptions) {
    const added = this._addedLabels;
    if (added.length) {
      const labels = this.getLabels();
      for (const { index: index2, label } of added) {
        if (labels[index2] === label) {
          labels.splice(index2, 1);
        }
      }
      this._addedLabels = [];
    }
    super.init(scaleOptions);
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    const labels = this.getLabels();
    index2 = isFinite(index2) && labels[index2] === raw ? index2 : findOrAddLabel(labels, raw, valueOrDefault(index2, raw), this._addedLabels);
    return validIndex(index2, labels.length - 1);
  }
  determineDataLimits() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min, max } = this.getMinMax(true);
    if (this.options.bounds === "ticks") {
      if (!minDefined) {
        min = 0;
      }
      if (!maxDefined) {
        max = this.getLabels().length - 1;
      }
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const min = this.min;
    const max = this.max;
    const offset = this.options.offset;
    const ticks = [];
    let labels = this.getLabels();
    labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
    this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
    this._startValue = this.min - (offset ? 0.5 : 0);
    for (let value = min; value <= max; value++) {
      ticks.push({
        value
      });
    }
    return ticks;
  }
  getLabelForValue(value) {
    return _getLabelForValue.call(this, value);
  }
  configure() {
    super.configure();
    if (!this.isHorizontal()) {
      this._reversePixels = !this._reversePixels;
    }
  }
  getPixelForValue(value) {
    if (typeof value !== "number") {
      value = this.parse(value);
    }
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getPixelForTick(index2) {
    const ticks = this.ticks;
    if (index2 < 0 || index2 > ticks.length - 1) {
      return null;
    }
    return this.getPixelForValue(ticks[index2].value);
  }
  getValueForPixel(pixel) {
    return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
};
function generateTicks$1(generationOptions, dataRange) {
  const ticks = [];
  const MIN_SPACING = 1e-14;
  const { bounds, step, min, max, precision, count, maxTicks, maxDigits, includeBounds } = generationOptions;
  const unit = step || 1;
  const maxSpaces = maxTicks - 1;
  const { min: rmin, max: rmax } = dataRange;
  const minDefined = !isNullOrUndef(min);
  const maxDefined = !isNullOrUndef(max);
  const countDefined = !isNullOrUndef(count);
  const minSpacing = (rmax - rmin) / (maxDigits + 1);
  let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
  let factor, niceMin, niceMax, numSpaces;
  if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
    return [
      {
        value: rmin
      },
      {
        value: rmax
      }
    ];
  }
  numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
  if (numSpaces > maxSpaces) {
    spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
  }
  if (!isNullOrUndef(precision)) {
    factor = Math.pow(10, precision);
    spacing = Math.ceil(spacing * factor) / factor;
  }
  if (bounds === "ticks") {
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;
  } else {
    niceMin = rmin;
    niceMax = rmax;
  }
  if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1e3)) {
    numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
    spacing = (max - min) / numSpaces;
    niceMin = min;
    niceMax = max;
  } else if (countDefined) {
    niceMin = minDefined ? min : niceMin;
    niceMax = maxDefined ? max : niceMax;
    numSpaces = count - 1;
    spacing = (niceMax - niceMin) / numSpaces;
  } else {
    numSpaces = (niceMax - niceMin) / spacing;
    if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1e3)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
  }
  const decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
  factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
  niceMin = Math.round(niceMin * factor) / factor;
  niceMax = Math.round(niceMax * factor) / factor;
  let j = 0;
  if (minDefined) {
    if (includeBounds && niceMin !== min) {
      ticks.push({
        value: min
      });
      if (niceMin < min) {
        j++;
      }
      if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
        j++;
      }
    } else if (niceMin < min) {
      j++;
    }
  }
  for (; j < numSpaces; ++j) {
    const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
    if (maxDefined && tickValue > max) {
      break;
    }
    ticks.push({
      value: tickValue
    });
  }
  if (maxDefined && includeBounds && niceMax !== max) {
    if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
      ticks[ticks.length - 1].value = max;
    } else {
      ticks.push({
        value: max
      });
    }
  } else if (!maxDefined || niceMax === max) {
    ticks.push({
      value: niceMax
    });
  }
  return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal, minRotation }) {
  const rad = toRadians(minRotation);
  const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 1e-3;
  const length = 0.75 * minSpacing * ("" + value).length;
  return Math.min(minSpacing / ratio, length);
}
var LinearScaleBase = class extends Scale {
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._endValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    if (isNullOrUndef(raw)) {
      return null;
    }
    if ((typeof raw === "number" || raw instanceof Number) && !isFinite(+raw)) {
      return null;
    }
    return +raw;
  }
  handleTickRangeOptions() {
    const { beginAtZero } = this.options;
    const { minDefined, maxDefined } = this.getUserBounds();
    let { min, max } = this;
    const setMin = (v) => min = minDefined ? min : v;
    const setMax = (v) => max = maxDefined ? max : v;
    if (beginAtZero) {
      const minSign = sign(min);
      const maxSign = sign(max);
      if (minSign < 0 && maxSign < 0) {
        setMax(0);
      } else if (minSign > 0 && maxSign > 0) {
        setMin(0);
      }
    }
    if (min === max) {
      let offset = max === 0 ? 1 : Math.abs(max * 0.05);
      setMax(max + offset);
      if (!beginAtZero) {
        setMin(min - offset);
      }
    }
    this.min = min;
    this.max = max;
  }
  getTickLimit() {
    const tickOpts = this.options.ticks;
    let { maxTicksLimit, stepSize } = tickOpts;
    let maxTicks;
    if (stepSize) {
      maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
      if (maxTicks > 1e3) {
        console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
        maxTicks = 1e3;
      }
    } else {
      maxTicks = this.computeTickLimit();
      maxTicksLimit = maxTicksLimit || 11;
    }
    if (maxTicksLimit) {
      maxTicks = Math.min(maxTicksLimit, maxTicks);
    }
    return maxTicks;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const opts = this.options;
    const tickOpts = opts.ticks;
    let maxTicks = this.getTickLimit();
    maxTicks = Math.max(2, maxTicks);
    const numericGeneratorOptions = {
      maxTicks,
      bounds: opts.bounds,
      min: opts.min,
      max: opts.max,
      precision: tickOpts.precision,
      step: tickOpts.stepSize,
      count: tickOpts.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: tickOpts.minRotation || 0,
      includeBounds: tickOpts.includeBounds !== false
    };
    const dataRange = this._range || this;
    const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  configure() {
    const ticks = this.ticks;
    let start = this.min;
    let end = this.max;
    super.configure();
    if (this.options.offset && ticks.length) {
      const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
      start -= offset;
      end += offset;
    }
    this._startValue = start;
    this._endValue = end;
    this._valueRange = end - start;
  }
  getLabelForValue(value) {
    return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
};
var LinearScale = class extends LinearScaleBase {
  static id = "linear";
  static defaults = {
    ticks: {
      callback: Ticks.formatters.numeric
    }
  };
  determineDataLimits() {
    const { min, max } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? min : 0;
    this.max = isNumberFinite(max) ? max : 1;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const horizontal = this.isHorizontal();
    const length = horizontal ? this.width : this.height;
    const minRotation = toRadians(this.options.ticks.minRotation);
    const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 1e-3;
    const tickFont = this._resolveTickFontOptions(0);
    return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
  }
  getPixelForValue(value) {
    return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
  }
};
var log10Floor = (v) => Math.floor(log10(v));
var changeExponent = (v, m) => Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
  const remain = tickVal / Math.pow(10, log10Floor(tickVal));
  return remain === 1;
}
function steps(min, max, rangeExp) {
  const rangeStep = Math.pow(10, rangeExp);
  const start = Math.floor(min / rangeStep);
  const end = Math.ceil(max / rangeStep);
  return end - start;
}
function startExp(min, max) {
  const range = max - min;
  let rangeExp = log10Floor(range);
  while (steps(min, max, rangeExp) > 10) {
    rangeExp++;
  }
  while (steps(min, max, rangeExp) < 10) {
    rangeExp--;
  }
  return Math.min(rangeExp, log10Floor(min));
}
function generateTicks(generationOptions, { min, max }) {
  min = finiteOrDefault(generationOptions.min, min);
  const ticks = [];
  const minExp = log10Floor(min);
  let exp = startExp(min, max);
  let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
  const stepSize = Math.pow(10, exp);
  const base = minExp > exp ? Math.pow(10, minExp) : 0;
  const start = Math.round((min - base) * precision) / precision;
  const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
  let significand = Math.floor((start - offset) / Math.pow(10, exp));
  let value = finiteOrDefault(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
  while (value < max) {
    ticks.push({
      value,
      major: isMajor(value),
      significand
    });
    if (significand >= 10) {
      significand = significand < 15 ? 15 : 20;
    } else {
      significand++;
    }
    if (significand >= 20) {
      exp++;
      significand = 2;
      precision = exp >= 0 ? 1 : precision;
    }
    value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
  }
  const lastTick = finiteOrDefault(generationOptions.max, value);
  ticks.push({
    value: lastTick,
    major: isMajor(lastTick),
    significand
  });
  return ticks;
}
var LogarithmicScale = class extends Scale {
  static id = "logarithmic";
  static defaults = {
    ticks: {
      callback: Ticks.formatters.logarithmic,
      major: {
        enabled: true
      }
    }
  };
  constructor(cfg) {
    super(cfg);
    this.start = void 0;
    this.end = void 0;
    this._startValue = void 0;
    this._valueRange = 0;
  }
  parse(raw, index2) {
    const value = LinearScaleBase.prototype.parse.apply(this, [
      raw,
      index2
    ]);
    if (value === 0) {
      this._zero = true;
      return void 0;
    }
    return isNumberFinite(value) && value > 0 ? value : null;
  }
  determineDataLimits() {
    const { min, max } = this.getMinMax(true);
    this.min = isNumberFinite(min) ? Math.max(0, min) : null;
    this.max = isNumberFinite(max) ? Math.max(0, max) : null;
    if (this.options.beginAtZero) {
      this._zero = true;
    }
    if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
      this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
    }
    this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined, maxDefined } = this.getUserBounds();
    let min = this.min;
    let max = this.max;
    const setMin = (v) => min = minDefined ? min : v;
    const setMax = (v) => max = maxDefined ? max : v;
    if (min === max) {
      if (min <= 0) {
        setMin(1);
        setMax(10);
      } else {
        setMin(changeExponent(min, -1));
        setMax(changeExponent(max, 1));
      }
    }
    if (min <= 0) {
      setMin(changeExponent(max, -1));
    }
    if (max <= 0) {
      setMax(changeExponent(min, 1));
    }
    this.min = min;
    this.max = max;
  }
  buildTicks() {
    const opts = this.options;
    const generationOptions = {
      min: this._userMin,
      max: this._userMax
    };
    const ticks = generateTicks(generationOptions, this);
    if (opts.bounds === "ticks") {
      _setMinAndMaxByKey(ticks, this, "value");
    }
    if (opts.reverse) {
      ticks.reverse();
      this.start = this.max;
      this.end = this.min;
    } else {
      this.start = this.min;
      this.end = this.max;
    }
    return ticks;
  }
  getLabelForValue(value) {
    return value === void 0 ? "0" : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const start = this.min;
    super.configure();
    this._startValue = log10(start);
    this._valueRange = log10(this.max) - log10(start);
  }
  getPixelForValue(value) {
    if (value === void 0 || value === 0) {
      value = this.min;
    }
    if (value === null || isNaN(value)) {
      return NaN;
    }
    return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
  }
  getValueForPixel(pixel) {
    const decimal = this.getDecimalForPixel(pixel);
    return Math.pow(10, this._startValue + decimal * this._valueRange);
  }
};
function getTickBackdropHeight(opts) {
  const tickOpts = opts.ticks;
  if (tickOpts.display && opts.display) {
    const padding = toPadding(tickOpts.backdropPadding);
    return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
  }
  return 0;
}
function measureLabelSize(ctx, font, label) {
  label = isArray(label) ? label : [
    label
  ];
  return {
    w: _longestText(ctx, font.string, label),
    h: label.length * font.lineHeight
  };
}
function determineLimits(angle, pos, size, min, max) {
  if (angle === min || angle === max) {
    return {
      start: pos - size / 2,
      end: pos + size / 2
    };
  } else if (angle < min || angle > max) {
    return {
      start: pos - size,
      end: pos
    };
  }
  return {
    start: pos,
    end: pos + size
  };
}
function fitWithPointLabels(scale) {
  const orig = {
    l: scale.left + scale._padding.left,
    r: scale.right - scale._padding.right,
    t: scale.top + scale._padding.top,
    b: scale.bottom - scale._padding.bottom
  };
  const limits = Object.assign({}, orig);
  const labelSizes = [];
  const padding = [];
  const valueCount = scale._pointLabels.length;
  const pointLabelOpts = scale.options.pointLabels;
  const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
  for (let i = 0; i < valueCount; i++) {
    const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
    padding[i] = opts.padding;
    const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
    const plFont = toFont(opts.font);
    const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
    labelSizes[i] = textSize;
    const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
    const angle = Math.round(toDegrees(angleRadians));
    const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
    const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
    updateLimits(limits, orig, angleRadians, hLimits, vLimits);
  }
  scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
  scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
  const sin = Math.abs(Math.sin(angle));
  const cos = Math.abs(Math.cos(angle));
  let x = 0;
  let y = 0;
  if (hLimits.start < orig.l) {
    x = (orig.l - hLimits.start) / sin;
    limits.l = Math.min(limits.l, orig.l - x);
  } else if (hLimits.end > orig.r) {
    x = (hLimits.end - orig.r) / sin;
    limits.r = Math.max(limits.r, orig.r + x);
  }
  if (vLimits.start < orig.t) {
    y = (orig.t - vLimits.start) / cos;
    limits.t = Math.min(limits.t, orig.t - y);
  } else if (vLimits.end > orig.b) {
    y = (vLimits.end - orig.b) / cos;
    limits.b = Math.max(limits.b, orig.b + y);
  }
}
function createPointLabelItem(scale, index2, itemOpts) {
  const outerDistance = scale.drawingArea;
  const { extra, additionalAngle, padding, size } = itemOpts;
  const pointLabelPosition = scale.getPointPosition(index2, outerDistance + extra + padding, additionalAngle);
  const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
  const y = yForAngle(pointLabelPosition.y, size.h, angle);
  const textAlign = getTextAlignForAngle(angle);
  const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
  return {
    visible: true,
    x: pointLabelPosition.x,
    y,
    textAlign,
    left,
    top: y,
    right: left + size.w,
    bottom: y + size.h
  };
}
function isNotOverlapped(item, area) {
  if (!area) {
    return true;
  }
  const { left, top, right, bottom } = item;
  const apexesInArea = _isPointInArea({
    x: left,
    y: top
  }, area) || _isPointInArea({
    x: left,
    y: bottom
  }, area) || _isPointInArea({
    x: right,
    y: top
  }, area) || _isPointInArea({
    x: right,
    y: bottom
  }, area);
  return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
  const items = [];
  const valueCount = scale._pointLabels.length;
  const opts = scale.options;
  const { centerPointLabels, display } = opts.pointLabels;
  const itemOpts = {
    extra: getTickBackdropHeight(opts) / 2,
    additionalAngle: centerPointLabels ? PI / valueCount : 0
  };
  let area;
  for (let i = 0; i < valueCount; i++) {
    itemOpts.padding = padding[i];
    itemOpts.size = labelSizes[i];
    const item = createPointLabelItem(scale, i, itemOpts);
    items.push(item);
    if (display === "auto") {
      item.visible = isNotOverlapped(item, area);
      if (item.visible) {
        area = item;
      }
    }
  }
  return items;
}
function getTextAlignForAngle(angle) {
  if (angle === 0 || angle === 180) {
    return "center";
  } else if (angle < 180) {
    return "left";
  }
  return "right";
}
function leftForTextAlign(x, w, align) {
  if (align === "right") {
    x -= w;
  } else if (align === "center") {
    x -= w / 2;
  }
  return x;
}
function yForAngle(y, h, angle) {
  if (angle === 90 || angle === 270) {
    y -= h / 2;
  } else if (angle > 270 || angle < 90) {
    y -= h;
  }
  return y;
}
function drawPointLabelBox(ctx, opts, item) {
  const { left, top, right, bottom } = item;
  const { backdropColor } = opts;
  if (!isNullOrUndef(backdropColor)) {
    const borderRadius = toTRBLCorners(opts.borderRadius);
    const padding = toPadding(opts.backdropPadding);
    ctx.fillStyle = backdropColor;
    const backdropLeft = left - padding.left;
    const backdropTop = top - padding.top;
    const backdropWidth = right - left + padding.width;
    const backdropHeight = bottom - top + padding.height;
    if (Object.values(borderRadius).some((v) => v !== 0)) {
      ctx.beginPath();
      addRoundedRectPath(ctx, {
        x: backdropLeft,
        y: backdropTop,
        w: backdropWidth,
        h: backdropHeight,
        radius: borderRadius
      });
      ctx.fill();
    } else {
      ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
    }
  }
}
function drawPointLabels(scale, labelCount) {
  const { ctx, options: { pointLabels } } = scale;
  for (let i = labelCount - 1; i >= 0; i--) {
    const item = scale._pointLabelItems[i];
    if (!item.visible) {
      continue;
    }
    const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
    drawPointLabelBox(ctx, optsAtIndex, item);
    const plFont = toFont(optsAtIndex.font);
    const { x, y, textAlign } = item;
    renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
      color: optsAtIndex.color,
      textAlign,
      textBaseline: "middle"
    });
  }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
  const { ctx } = scale;
  if (circular) {
    ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
  } else {
    let pointPosition = scale.getPointPosition(0, radius);
    ctx.moveTo(pointPosition.x, pointPosition.y);
    for (let i = 1; i < labelCount; i++) {
      pointPosition = scale.getPointPosition(i, radius);
      ctx.lineTo(pointPosition.x, pointPosition.y);
    }
  }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
  const ctx = scale.ctx;
  const circular = gridLineOpts.circular;
  const { color: color2, lineWidth } = gridLineOpts;
  if (!circular && !labelCount || !color2 || !lineWidth || radius < 0) {
    return;
  }
  ctx.save();
  ctx.strokeStyle = color2;
  ctx.lineWidth = lineWidth;
  ctx.setLineDash(borderOpts.dash);
  ctx.lineDashOffset = borderOpts.dashOffset;
  ctx.beginPath();
  pathRadiusLine(scale, radius, circular, labelCount);
  ctx.closePath();
  ctx.stroke();
  ctx.restore();
}
function createPointLabelContext(parent, index2, label) {
  return createContext20(parent, {
    label,
    index: index2,
    type: "pointLabel"
  });
}
var RadialLinearScale = class extends LinearScaleBase {
  static id = "radialLinear";
  static defaults = {
    display: true,
    animate: true,
    position: "chartArea",
    angleLines: {
      display: true,
      lineWidth: 1,
      borderDash: [],
      borderDashOffset: 0
    },
    grid: {
      circular: false
    },
    startAngle: 0,
    ticks: {
      showLabelBackdrop: true,
      callback: Ticks.formatters.numeric
    },
    pointLabels: {
      backdropColor: void 0,
      backdropPadding: 2,
      display: true,
      font: {
        size: 10
      },
      callback(label) {
        return label;
      },
      padding: 5,
      centerPointLabels: false
    }
  };
  static defaultRoutes = {
    "angleLines.color": "borderColor",
    "pointLabels.color": "color",
    "ticks.color": "color"
  };
  static descriptors = {
    angleLines: {
      _fallback: "grid"
    }
  };
  constructor(cfg) {
    super(cfg);
    this.xCenter = void 0;
    this.yCenter = void 0;
    this.drawingArea = void 0;
    this._pointLabels = [];
    this._pointLabelItems = [];
  }
  setDimensions() {
    const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
    const w = this.width = this.maxWidth - padding.width;
    const h = this.height = this.maxHeight - padding.height;
    this.xCenter = Math.floor(this.left + w / 2 + padding.left);
    this.yCenter = Math.floor(this.top + h / 2 + padding.top);
    this.drawingArea = Math.floor(Math.min(w, h) / 2);
  }
  determineDataLimits() {
    const { min, max } = this.getMinMax(false);
    this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
    this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
    this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
  }
  generateTickLabels(ticks) {
    LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
    this._pointLabels = this.getLabels().map((value, index2) => {
      const label = callback(this.options.pointLabels.callback, [
        value,
        index2
      ], this);
      return label || label === 0 ? label : "";
    }).filter((v, i) => this.chart.getDataVisibility(i));
  }
  fit() {
    const opts = this.options;
    if (opts.display && opts.pointLabels.display) {
      fitWithPointLabels(this);
    } else {
      this.setCenterPoint(0, 0, 0, 0);
    }
  }
  setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
    this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
    this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
    this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
  }
  getIndexAngle(index2) {
    const angleMultiplier = TAU / (this._pointLabels.length || 1);
    const startAngle = this.options.startAngle || 0;
    return _normalizeAngle(index2 * angleMultiplier + toRadians(startAngle));
  }
  getDistanceFromCenterForValue(value) {
    if (isNullOrUndef(value)) {
      return NaN;
    }
    const scalingFactor = this.drawingArea / (this.max - this.min);
    if (this.options.reverse) {
      return (this.max - value) * scalingFactor;
    }
    return (value - this.min) * scalingFactor;
  }
  getValueForDistanceFromCenter(distance) {
    if (isNullOrUndef(distance)) {
      return NaN;
    }
    const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
  }
  getPointLabelContext(index2) {
    const pointLabels = this._pointLabels || [];
    if (index2 >= 0 && index2 < pointLabels.length) {
      const pointLabel = pointLabels[index2];
      return createPointLabelContext(this.getContext(), index2, pointLabel);
    }
  }
  getPointPosition(index2, distanceFromCenter, additionalAngle = 0) {
    const angle = this.getIndexAngle(index2) - HALF_PI + additionalAngle;
    return {
      x: Math.cos(angle) * distanceFromCenter + this.xCenter,
      y: Math.sin(angle) * distanceFromCenter + this.yCenter,
      angle
    };
  }
  getPointPositionForValue(index2, value) {
    return this.getPointPosition(index2, this.getDistanceFromCenterForValue(value));
  }
  getBasePosition(index2) {
    return this.getPointPositionForValue(index2 || 0, this.getBaseValue());
  }
  getPointLabelPosition(index2) {
    const { left, top, right, bottom } = this._pointLabelItems[index2];
    return {
      left,
      top,
      right,
      bottom
    };
  }
  drawBackground() {
    const { backgroundColor, grid: { circular } } = this.options;
    if (backgroundColor) {
      const ctx = this.ctx;
      ctx.save();
      ctx.beginPath();
      pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
      ctx.closePath();
      ctx.fillStyle = backgroundColor;
      ctx.fill();
      ctx.restore();
    }
  }
  drawGrid() {
    const ctx = this.ctx;
    const opts = this.options;
    const { angleLines, grid, border } = opts;
    const labelCount = this._pointLabels.length;
    let i, offset, position;
    if (opts.pointLabels.display) {
      drawPointLabels(this, labelCount);
    }
    if (grid.display) {
      this.ticks.forEach((tick, index2) => {
        if (index2 !== 0) {
          offset = this.getDistanceFromCenterForValue(tick.value);
          const context = this.getContext(index2);
          const optsAtIndex = grid.setContext(context);
          const optsAtIndexBorder = border.setContext(context);
          drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
        }
      });
    }
    if (angleLines.display) {
      ctx.save();
      for (i = labelCount - 1; i >= 0; i--) {
        const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
        const { color: color2, lineWidth } = optsAtIndex;
        if (!lineWidth || !color2) {
          continue;
        }
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = color2;
        ctx.setLineDash(optsAtIndex.borderDash);
        ctx.lineDashOffset = optsAtIndex.borderDashOffset;
        offset = this.getDistanceFromCenterForValue(opts.ticks.reverse ? this.min : this.max);
        position = this.getPointPosition(i, offset);
        ctx.beginPath();
        ctx.moveTo(this.xCenter, this.yCenter);
        ctx.lineTo(position.x, position.y);
        ctx.stroke();
      }
      ctx.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const ctx = this.ctx;
    const opts = this.options;
    const tickOpts = opts.ticks;
    if (!tickOpts.display) {
      return;
    }
    const startAngle = this.getIndexAngle(0);
    let offset, width;
    ctx.save();
    ctx.translate(this.xCenter, this.yCenter);
    ctx.rotate(startAngle);
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    this.ticks.forEach((tick, index2) => {
      if (index2 === 0 && !opts.reverse) {
        return;
      }
      const optsAtIndex = tickOpts.setContext(this.getContext(index2));
      const tickFont = toFont(optsAtIndex.font);
      offset = this.getDistanceFromCenterForValue(this.ticks[index2].value);
      if (optsAtIndex.showLabelBackdrop) {
        ctx.font = tickFont.string;
        width = ctx.measureText(tick.label).width;
        ctx.fillStyle = optsAtIndex.backdropColor;
        const padding = toPadding(optsAtIndex.backdropPadding);
        ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
      }
      renderText(ctx, tick.label, 0, -offset, tickFont, {
        color: optsAtIndex.color,
        strokeColor: optsAtIndex.textStrokeColor,
        strokeWidth: optsAtIndex.textStrokeWidth
      });
    });
    ctx.restore();
  }
  drawTitle() {
  }
};
var INTERVALS = {
  millisecond: {
    common: true,
    size: 1,
    steps: 1e3
  },
  second: {
    common: true,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: true,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: true,
    size: 36e5,
    steps: 24
  },
  day: {
    common: true,
    size: 864e5,
    steps: 30
  },
  week: {
    common: false,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: true,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: false,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: true,
    size: 3154e7
  }
};
var UNITS = /* @__PURE__ */ Object.keys(INTERVALS);
function sorter(a, b) {
  return a - b;
}
function parse(scale, input) {
  if (isNullOrUndef(input)) {
    return null;
  }
  const adapter = scale._adapter;
  const { parser, round: round2, isoWeekday } = scale._parseOpts;
  let value = input;
  if (typeof parser === "function") {
    value = parser(value);
  }
  if (!isNumberFinite(value)) {
    value = typeof parser === "string" ? adapter.parse(value, parser) : adapter.parse(value);
  }
  if (value === null) {
    return null;
  }
  if (round2) {
    value = round2 === "week" && (isNumber5(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, "isoWeek", isoWeekday) : adapter.startOf(value, round2);
  }
  return +value;
}
function determineUnitForAutoTicks(minUnit, min, max, capacity) {
  const ilen = UNITS.length;
  for (let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
    const interval = INTERVALS[UNITS[i]];
    const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
    if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
      return UNITS[i];
    }
  }
  return UNITS[ilen - 1];
}
function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
  for (let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
    const unit = UNITS[i];
    if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
      return unit;
    }
  }
  return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
function determineMajorUnit(unit) {
  for (let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
    if (INTERVALS[UNITS[i]].common) {
      return UNITS[i];
    }
  }
}
function addTick(ticks, time, timestamps) {
  if (!timestamps) {
    ticks[time] = true;
  } else if (timestamps.length) {
    const { lo, hi } = _lookup(timestamps, time);
    const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
    ticks[timestamp] = true;
  }
}
function setMajorTicks(scale, ticks, map2, majorUnit) {
  const adapter = scale._adapter;
  const first = +adapter.startOf(ticks[0].value, majorUnit);
  const last = ticks[ticks.length - 1].value;
  let major, index2;
  for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
    index2 = map2[major];
    if (index2 >= 0) {
      ticks[index2].major = true;
    }
  }
  return ticks;
}
function ticksFromTimestamps(scale, values, majorUnit) {
  const ticks = [];
  const map2 = {};
  const ilen = values.length;
  let i, value;
  for (i = 0; i < ilen; ++i) {
    value = values[i];
    map2[value] = i;
    ticks.push({
      value,
      major: false
    });
  }
  return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map2, majorUnit);
}
var TimeScale = class extends Scale {
  static id = "time";
  static defaults = {
    bounds: "data",
    adapters: {},
    time: {
      parser: false,
      unit: false,
      round: false,
      isoWeekday: false,
      minUnit: "millisecond",
      displayFormats: {}
    },
    ticks: {
      source: "auto",
      callback: false,
      major: {
        enabled: false
      }
    }
  };
  constructor(props) {
    super(props);
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
    this._unit = "day";
    this._majorUnit = void 0;
    this._offsets = {};
    this._normalized = false;
    this._parseOpts = void 0;
  }
  init(scaleOpts, opts = {}) {
    const time = scaleOpts.time || (scaleOpts.time = {});
    const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
    adapter.init(opts);
    mergeIf(time.displayFormats, adapter.formats());
    this._parseOpts = {
      parser: time.parser,
      round: time.round,
      isoWeekday: time.isoWeekday
    };
    super.init(scaleOpts);
    this._normalized = opts.normalized;
  }
  parse(raw, index2) {
    if (raw === void 0) {
      return null;
    }
    return parse(this, raw);
  }
  beforeLayout() {
    super.beforeLayout();
    this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const options = this.options;
    const adapter = this._adapter;
    const unit = options.time.unit || "day";
    let { min, max, minDefined, maxDefined } = this.getUserBounds();
    function _applyBounds(bounds) {
      if (!minDefined && !isNaN(bounds.min)) {
        min = Math.min(min, bounds.min);
      }
      if (!maxDefined && !isNaN(bounds.max)) {
        max = Math.max(max, bounds.max);
      }
    }
    if (!minDefined || !maxDefined) {
      _applyBounds(this._getLabelBounds());
      if (options.bounds !== "ticks" || options.ticks.source !== "labels") {
        _applyBounds(this.getMinMax(false));
      }
    }
    min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
    max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
    this.min = Math.min(min, max - 1);
    this.max = Math.max(min + 1, max);
  }
  _getLabelBounds() {
    const arr = this.getLabelTimestamps();
    let min = Number.POSITIVE_INFINITY;
    let max = Number.NEGATIVE_INFINITY;
    if (arr.length) {
      min = arr[0];
      max = arr[arr.length - 1];
    }
    return {
      min,
      max
    };
  }
  buildTicks() {
    const options = this.options;
    const timeOpts = options.time;
    const tickOpts = options.ticks;
    const timestamps = tickOpts.source === "labels" ? this.getLabelTimestamps() : this._generate();
    if (options.bounds === "ticks" && timestamps.length) {
      this.min = this._userMin || timestamps[0];
      this.max = this._userMax || timestamps[timestamps.length - 1];
    }
    const min = this.min;
    const max = this.max;
    const ticks = _filterBetween(timestamps, min, max);
    this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
    this._majorUnit = !tickOpts.major.enabled || this._unit === "year" ? void 0 : determineMajorUnit(this._unit);
    this.initOffsets(timestamps);
    if (options.reverse) {
      ticks.reverse();
    }
    return ticksFromTimestamps(this, ticks, this._majorUnit);
  }
  afterAutoSkip() {
    if (this.options.offsetAfterAutoskip) {
      this.initOffsets(this.ticks.map((tick) => +tick.value));
    }
  }
  initOffsets(timestamps = []) {
    let start = 0;
    let end = 0;
    let first, last;
    if (this.options.offset && timestamps.length) {
      first = this.getDecimalForValue(timestamps[0]);
      if (timestamps.length === 1) {
        start = 1 - first;
      } else {
        start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
      }
      last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
      if (timestamps.length === 1) {
        end = last;
      } else {
        end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
      }
    }
    const limit = timestamps.length < 3 ? 0.5 : 0.25;
    start = _limitValue(start, 0, limit);
    end = _limitValue(end, 0, limit);
    this._offsets = {
      start,
      end,
      factor: 1 / (start + 1 + end)
    };
  }
  _generate() {
    const adapter = this._adapter;
    const min = this.min;
    const max = this.max;
    const options = this.options;
    const timeOpts = options.time;
    const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
    const stepSize = valueOrDefault(options.ticks.stepSize, 1);
    const weekday = minor === "week" ? timeOpts.isoWeekday : false;
    const hasWeekday = isNumber5(weekday) || weekday === true;
    const ticks = {};
    let first = min;
    let time, count;
    if (hasWeekday) {
      first = +adapter.startOf(first, "isoWeek", weekday);
    }
    first = +adapter.startOf(first, hasWeekday ? "day" : minor);
    if (adapter.diff(max, min, minor) > 1e5 * stepSize) {
      throw new Error(min + " and " + max + " are too far apart with stepSize of " + stepSize + " " + minor);
    }
    const timestamps = options.ticks.source === "data" && this.getDataTimestamps();
    for (time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++) {
      addTick(ticks, time, timestamps);
    }
    if (time === max || options.bounds === "ticks" || count === 1) {
      addTick(ticks, time, timestamps);
    }
    return Object.keys(ticks).sort(sorter).map((x) => +x);
  }
  getLabelForValue(value) {
    const adapter = this._adapter;
    const timeOpts = this.options.time;
    if (timeOpts.tooltipFormat) {
      return adapter.format(value, timeOpts.tooltipFormat);
    }
    return adapter.format(value, timeOpts.displayFormats.datetime);
  }
  format(value, format) {
    const options = this.options;
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const fmt = format || formats[unit];
    return this._adapter.format(value, fmt);
  }
  _tickFormatFunction(time, index2, ticks, format) {
    const options = this.options;
    const formatter = options.ticks.callback;
    if (formatter) {
      return callback(formatter, [
        time,
        index2,
        ticks
      ], this);
    }
    const formats = options.time.displayFormats;
    const unit = this._unit;
    const majorUnit = this._majorUnit;
    const minorFormat = unit && formats[unit];
    const majorFormat = majorUnit && formats[majorUnit];
    const tick = ticks[index2];
    const major = majorUnit && majorFormat && tick && tick.major;
    return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
  }
  generateTickLabels(ticks) {
    let i, ilen, tick;
    for (i = 0, ilen = ticks.length; i < ilen; ++i) {
      tick = ticks[i];
      tick.label = this._tickFormatFunction(tick.value, i, ticks);
    }
  }
  getDecimalForValue(value) {
    return value === null ? NaN : (value - this.min) / (this.max - this.min);
  }
  getPixelForValue(value) {
    const offsets = this._offsets;
    const pos = this.getDecimalForValue(value);
    return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return this.min + pos * (this.max - this.min);
  }
  _getLabelSize(label) {
    const ticksOpts = this.options.ticks;
    const tickLabelWidth = this.ctx.measureText(label).width;
    const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
    const cosRotation = Math.cos(angle);
    const sinRotation = Math.sin(angle);
    const tickFontSize = this._resolveTickFontOptions(0).size;
    return {
      w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
      h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
    };
  }
  _getLabelCapacity(exampleTime) {
    const timeOpts = this.options.time;
    const displayFormats = timeOpts.displayFormats;
    const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
    const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
      exampleTime
    ], this._majorUnit), format);
    const size = this._getLabelSize(exampleLabel);
    const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
    return capacity > 0 ? capacity : 1;
  }
  getDataTimestamps() {
    let timestamps = this._cache.data || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const metas = this.getMatchingVisibleMetas();
    if (this._normalized && metas.length) {
      return this._cache.data = metas[0].controller.getAllParsedValues(this);
    }
    for (i = 0, ilen = metas.length; i < ilen; ++i) {
      timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
    }
    return this._cache.data = this.normalize(timestamps);
  }
  getLabelTimestamps() {
    const timestamps = this._cache.labels || [];
    let i, ilen;
    if (timestamps.length) {
      return timestamps;
    }
    const labels = this.getLabels();
    for (i = 0, ilen = labels.length; i < ilen; ++i) {
      timestamps.push(parse(this, labels[i]));
    }
    return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
  }
  normalize(values) {
    return _arrayUnique(values.sort(sorter));
  }
};
function interpolate2(table, val, reverse) {
  let lo = 0;
  let hi = table.length - 1;
  let prevSource, nextSource, prevTarget, nextTarget;
  if (reverse) {
    if (val >= table[lo].pos && val <= table[hi].pos) {
      ({ lo, hi } = _lookupByKey(table, "pos", val));
    }
    ({ pos: prevSource, time: prevTarget } = table[lo]);
    ({ pos: nextSource, time: nextTarget } = table[hi]);
  } else {
    if (val >= table[lo].time && val <= table[hi].time) {
      ({ lo, hi } = _lookupByKey(table, "time", val));
    }
    ({ time: prevSource, pos: prevTarget } = table[lo]);
    ({ time: nextSource, pos: nextTarget } = table[hi]);
  }
  const span = nextSource - prevSource;
  return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
var TimeSeriesScale = class extends TimeScale {
  static id = "timeseries";
  static defaults = TimeScale.defaults;
  constructor(props) {
    super(props);
    this._table = [];
    this._minPos = void 0;
    this._tableRange = void 0;
  }
  initOffsets() {
    const timestamps = this._getTimestampsForTable();
    const table = this._table = this.buildLookupTable(timestamps);
    this._minPos = interpolate2(table, this.min);
    this._tableRange = interpolate2(table, this.max) - this._minPos;
    super.initOffsets(timestamps);
  }
  buildLookupTable(timestamps) {
    const { min, max } = this;
    const items = [];
    const table = [];
    let i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr >= min && curr <= max) {
        items.push(curr);
      }
    }
    if (items.length < 2) {
      return [
        {
          time: min,
          pos: 0
        },
        {
          time: max,
          pos: 1
        }
      ];
    }
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];
      if (Math.round((next + prev) / 2) !== curr) {
        table.push({
          time: curr,
          pos: i / (ilen - 1)
        });
      }
    }
    return table;
  }
  _generate() {
    const min = this.min;
    const max = this.max;
    let timestamps = super.getDataTimestamps();
    if (!timestamps.includes(min) || !timestamps.length) {
      timestamps.splice(0, 0, min);
    }
    if (!timestamps.includes(max) || timestamps.length === 1) {
      timestamps.push(max);
    }
    return timestamps.sort((a, b) => a - b);
  }
  _getTimestampsForTable() {
    let timestamps = this._cache.all || [];
    if (timestamps.length) {
      return timestamps;
    }
    const data = this.getDataTimestamps();
    const label = this.getLabelTimestamps();
    if (data.length && label.length) {
      timestamps = this.normalize(data.concat(label));
    } else {
      timestamps = data.length ? data : label;
    }
    timestamps = this._cache.all = timestamps;
    return timestamps;
  }
  getDecimalForValue(value) {
    return (interpolate2(this._table, value) - this._minPos) / this._tableRange;
  }
  getValueForPixel(pixel) {
    const offsets = this._offsets;
    const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
    return interpolate2(this._table, decimal * this._tableRange + this._minPos, true);
  }
};

// ../../node_modules/react-chartjs-2/dist/index.js
var defaultDatasetIdKey = "label";
function reforwardRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}
function setOptions(chart, nextOptions) {
  const options = chart.options;
  if (options && nextOptions) {
    Object.assign(options, nextOptions);
  }
}
function setLabels(currentData, nextLabels) {
  currentData.labels = nextLabels;
}
function setDatasets(currentData, nextDatasets) {
  let datasetIdKey = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : defaultDatasetIdKey;
  const addedDatasets = [];
  currentData.datasets = nextDatasets.map((nextDataset) => {
    const currentDataset = currentData.datasets.find((dataset) => dataset[datasetIdKey] === nextDataset[datasetIdKey]);
    if (!currentDataset || !nextDataset.data || addedDatasets.includes(currentDataset)) {
      return {
        ...nextDataset
      };
    }
    addedDatasets.push(currentDataset);
    Object.assign(currentDataset, nextDataset);
    return currentDataset;
  });
}
function cloneData(data) {
  let datasetIdKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultDatasetIdKey;
  const nextData = {
    labels: [],
    datasets: []
  };
  setLabels(nextData, data.labels);
  setDatasets(nextData, data.datasets, datasetIdKey);
  return nextData;
}
function ChartComponent(props, ref) {
  const { height = 150, width = 300, redraw = false, datasetIdKey, type, data, options, plugins = [], fallbackContent, updateMode, ...canvasProps } = props;
  const canvasRef = (0, import_react94.useRef)(null);
  const chartRef = (0, import_react94.useRef)();
  const renderChart = () => {
    if (!canvasRef.current)
      return;
    chartRef.current = new Chart(canvasRef.current, {
      type,
      data: cloneData(data, datasetIdKey),
      options: options && {
        ...options
      },
      plugins
    });
    reforwardRef(ref, chartRef.current);
  };
  const destroyChart = () => {
    reforwardRef(ref, null);
    if (chartRef.current) {
      chartRef.current.destroy();
      chartRef.current = null;
    }
  };
  (0, import_react94.useEffect)(() => {
    if (!redraw && chartRef.current && options) {
      setOptions(chartRef.current, options);
    }
  }, [
    redraw,
    options
  ]);
  (0, import_react94.useEffect)(() => {
    if (!redraw && chartRef.current) {
      setLabels(chartRef.current.config.data, data.labels);
    }
  }, [
    redraw,
    data.labels
  ]);
  (0, import_react94.useEffect)(() => {
    if (!redraw && chartRef.current && data.datasets) {
      setDatasets(chartRef.current.config.data, data.datasets, datasetIdKey);
    }
  }, [
    redraw,
    data.datasets
  ]);
  (0, import_react94.useEffect)(() => {
    if (!chartRef.current)
      return;
    if (redraw) {
      destroyChart();
      setTimeout(renderChart);
    } else {
      chartRef.current.update(updateMode);
    }
  }, [
    redraw,
    options,
    data.labels,
    data.datasets,
    updateMode
  ]);
  (0, import_react94.useEffect)(() => {
    if (!chartRef.current)
      return;
    destroyChart();
    setTimeout(renderChart);
  }, [
    type
  ]);
  (0, import_react94.useEffect)(() => {
    renderChart();
    return () => destroyChart();
  }, []);
  return /* @__PURE__ */ import_react94.default.createElement("canvas", Object.assign({
    ref: canvasRef,
    role: "img",
    height,
    width
  }, canvasProps), fallbackContent);
}
var Chart2 = /* @__PURE__ */ (0, import_react94.forwardRef)(ChartComponent);
function createTypedChart(type, registerables) {
  Chart.register(registerables);
  return /* @__PURE__ */ (0, import_react94.forwardRef)((props, ref) => /* @__PURE__ */ import_react94.default.createElement(Chart2, Object.assign({}, props, {
    ref,
    type
  })));
}
var Line2 = /* @__PURE__ */ createTypedChart("line", LineController);

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/ApiAccessChart.tsx
var import_react_i18next44 = require("react-i18next");

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessPlaceholder/ApiAccessPlaceholder.tsx
var import_react_i18next43 = require("react-i18next");
var import_styled_components146 = __toESM(require("styled-components"));
var import_jsx_runtime140 = require("react/jsx-runtime");
var Container8 = (0, import_styled_components146.default)(Flex_default)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;
function ApiAccessPlaceholder({ message }) {
  const { t } = (0, import_react_i18next43.useTranslation)(["pages"]);
  const theme = (0, import_styled_components146.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime140.jsxs)(Container8, { p: [8, 0, 0, 0], flex: 1, w: "100%", h: "100%", alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(
      Flex_default,
      {
        w: "100%",
        flex: 1,
        alignItems: "center",
        justifyContent: isMobile ? "flex-start" : "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(
          Icon_default,
          {
            name: "presentation",
            size: isMobile ? 50 : 126,
            color: theme.colors.b30
          }
        )
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime140.jsxs)(Flex_default, { flex: 2, flexDirection: "column", justifyContent: "center", children: [
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Text_default, { lg: true, semibold: true, children: t(
        "pages:dashboardPage:portfoliosWidget:noPortfoliosPlaceholderTitle"
      ) }) }),
      /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Flex_default, { mt: 0.5, children: /* @__PURE__ */ (0, import_jsx_runtime140.jsx)(Text_default, { color: theme.colors.n80, children: message }) })
    ] })
  ] });
}
var ApiAccessPlaceholder_default = ApiAccessPlaceholder;

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/hooks/useContainerWidth.ts
var import_react95 = require("react");
function useContainerWidth(ref) {
  const [width, setWidth] = (0, import_react95.useState)(0);
  (0, import_react95.useLayoutEffect)(() => {
    const element = ref.current;
    if (!element)
      return;
    setWidth(element.offsetWidth);
    const observer = new window.ResizeObserver((entries) => {
      for (let entry of entries) {
        if (entry.target === element) {
          setWidth(entry.contentRect.width);
        }
      }
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, [ref.current]);
  return width;
}

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/hooks/useChartData.ts
var import_moment9 = __toESM(require("moment"));
var import_react96 = require("react");
var import_lodash18 = require("lodash");
function useChartData(list, groupOption) {
  return (0, import_react96.useMemo)(() => {
    if (groupOption === "HOURLY" /* HOURLY */) {
      const allDataPoints = list.flatMap(
        (item) => item.dataPoints ?? []
      );
      const groupedByHour = (0, import_lodash18.groupBy)(
        allDataPoints,
        (dp) => (0, import_moment9.default)(dp.timestamp).format("YYYY-MM-DD HH:00")
      );
      const sortedHours = Object.keys(groupedByHour).sort();
      const aggregatedData2 = sortedHours.map((hourGroup) => {
        const pointsInGroup = groupedByHour[hourGroup];
        const totalRequests = pointsInGroup.reduce(
          (sum, dp) => sum + (dp.requestCount || 0),
          0
        );
        const representativeDate = (0, import_moment9.default)(pointsInGroup[0].timestamp);
        return {
          hourGroup,
          representativeDate,
          totalRequests
        };
      });
      const suggestedMax2 = Math.max(
        ...aggregatedData2.map((d) => d.totalRequests),
        0
      );
      const labels2 = aggregatedData2.map(
        (d) => d.representativeDate.format("DD-MMM-YYYY HH:00")
      );
      const datasets2 = [
        {
          label: "API Requests",
          data: aggregatedData2.map((d) => d.totalRequests),
          borderColor: "#1b75bb",
          backgroundColor: "transparent",
          pointBackgroundColor: "#293c75",
          fill: false
        }
      ];
      return {
        data: { labels: labels2, datasets: datasets2 },
        suggestedMax: suggestedMax2
      };
    }
    const formattedData = list.map((item) => {
      const date = (0, import_moment9.default)(item.endDate);
      let formattedDate;
      switch (groupOption) {
        case "WEEKLY" /* WEEKLY */:
          formattedDate = date.format("YYYY-[W]WW");
          break;
        case "MONTHLY" /* MONTHLY */:
          formattedDate = date.format("YYYY-MM");
          break;
        case "DAILY" /* DAILY */:
        default:
          formattedDate = date.format("YYYY-MM-DD");
          break;
      }
      return {
        ...item,
        formattedDate,
        momentDate: date
      };
    });
    const groupedByDate = (0, import_lodash18.groupBy)(formattedData, "formattedDate");
    const sortedDates = Object.keys(groupedByDate).sort();
    const aggregatedData = sortedDates.map((dateGroup) => {
      const itemsInGroup = groupedByDate[dateGroup];
      const totalRequests = itemsInGroup.reduce(
        (sum, item) => sum + (item.totalRequests || 0),
        0
      );
      const representativeDate = itemsInGroup[0].momentDate;
      return {
        dateGroup,
        representativeDate,
        totalRequests
      };
    });
    const suggestedMax = Math.max(
      ...aggregatedData.map((d) => d.totalRequests),
      0
    );
    const labels = aggregatedData.map((d) => {
      switch (groupOption) {
        case "WEEKLY" /* WEEKLY */:
          return d.representativeDate.clone().startOf("isoWeek").format("DD-MMM-YYYY");
        case "MONTHLY" /* MONTHLY */:
          return d.representativeDate.format("MMM YYYY");
        case "DAILY" /* DAILY */:
        default:
          return d.representativeDate.format("DD-MMM-YYYY");
      }
    });
    const datasets = [
      {
        label: "API Requests",
        data: aggregatedData.map((d) => d.totalRequests),
        borderColor: "#1b75bb",
        backgroundColor: "transparent",
        pointBackgroundColor: "#293c75",
        fill: false
      }
    ];
    return {
      data: { labels, datasets },
      suggestedMax
    };
  }, [list, groupOption]);
}

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessChart/ApiAccessChart.tsx
var import_jsx_runtime141 = require("react/jsx-runtime");
Chart.register(
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
  index,
  plugin_tooltip,
  plugin_title
);
var GroupOptionEnum = /* @__PURE__ */ ((GroupOptionEnum2) => {
  GroupOptionEnum2["HOURLY"] = "HOURLY";
  GroupOptionEnum2["DAILY"] = "DAILY";
  GroupOptionEnum2["WEEKLY"] = "WEEKLY";
  GroupOptionEnum2["MONTHLY"] = "MONTHLY";
  return GroupOptionEnum2;
})(GroupOptionEnum || {});
var ChartContainer = (0, import_styled_components147.default)(Flex_default)`
  width: 100%;
  min-width: 0;
  @media ${({ theme }) => theme.devices.mobile} {
    overflow-x: scroll;
  }
`;
var getChartOptions = (suggestedMax) => ({
  responsive: true,
  aspectRatio: 2,
  maintainAspectRatio: true,
  plugins: {
    legend: {
      display: false
    },
    tooltip: {
      mode: "index"
    }
  },
  interaction: {
    mode: "nearest",
    axis: "x",
    intersect: false
  },
  scales: {
    y: {
      suggestedMin: 0,
      suggestedMax: Math.max(suggestedMax + Math.round(suggestedMax * 0.3), 2)
    }
  }
});
function ApiAccessChart({
  fetchFunction
}) {
  const { t } = (0, import_react_i18next44.useTranslation)(["pages"]);
  const { state: filterState } = (0, import_react97.useContext)(FilterContext);
  const { dateRange, groupOption } = filterState;
  const chartContainerRef = (0, import_react97.useRef)(null);
  const containerWidth = useContainerWidth(chartContainerRef);
  const { data: fetchData, loading } = fetchFunction(dateRange);
  const { data, suggestedMax } = useChartData(fetchData, groupOption);
  if (loading) {
    return /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
      Flex_default,
      {
        minHeight: "200px",
        w: "100%",
        justifyContent: "center",
        alignItems: "center",
        children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(Spinner_default, {})
      }
    );
  }
  if (fetchData.length === 0) {
    return /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
      ApiAccessPlaceholder_default,
      {
        message: t(
          "pages:dashboardPage:portfoliosWidget:noPortfoliosPlaceholderMatches"
        )
      }
    );
  }
  return /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(ChartContainer, { w: "100%", ref: chartContainerRef, children: /* @__PURE__ */ (0, import_jsx_runtime141.jsx)(
    Line2,
    {
      data,
      options: getChartOptions(suggestedMax)
    },
    containerWidth
  ) });
}
var ApiAccessChart_default = ApiAccessChart;

// src/components/organisms/ApiAccessChartWidget/components/ApiAccessHeader/ApiAccessHeader.tsx
var import_react98 = require("react");
var import_react_i18next45 = require("react-i18next");
var import_styled_components148 = require("styled-components");
var import_lodash19 = require("lodash");
var import_styled_components149 = __toESM(require("styled-components"));
var import_jsx_runtime142 = require("react/jsx-runtime");
var PeriodButton2 = (0, import_styled_components149.default)(Button_default)`
  border-radius: 0px;
  background-color: ${({ theme, active }) => active && theme.colors.b20};
  justify-content: left;
  white-space: nowrap;

  & p {
    color: ${({ theme }) => theme.colors.n90} !important;
  }
  :hover {
    background-color: ${({ theme }) => theme.colors.b20};
  }
`;
function ApiAccessHeader({
  title,
  hidePeriodTypes
}) {
  const { t } = (0, import_react_i18next45.useTranslation)(["pages", "common"]);
  const theme = (0, import_styled_components148.useTheme)();
  const { setFilterState } = (0, import_react98.useContext)(FilterContext);
  (0, import_react98.useContext)(ColorContext);
  const periodOptions = Object.values(GroupOptionEnum);
  const [type, setType] = (0, import_react98.useState)("DAILY");
  return /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(Flex_default, { w: "100%", pos: "sticky", children: [
    /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Flex_default, { flex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Text_default, { lg: true, semibold: true, children: title }) }),
    /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Flex_default, { flex: 1, justifyContent: "flex-end", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(Flex_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Flex_default, { mr: 6, children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
        DatePeriodPicker_default,
        {
          placementHorizontal: "left",
          customEnabled: true,
          anchorIconProps: { ml: 1, size: 16 },
          onChange: (dateRange) => {
            setFilterState("dateRange", dateRange);
          },
          hidePeriodTypes
        }
      ) }),
      /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
        DropDown_default,
        {
          rerender: type,
          placementHorizontal: "left",
          w: "100%",
          Anchor: ({ isOpen }) => /* @__PURE__ */ (0, import_jsx_runtime142.jsxs)(Flex_default, { alignItems: "center", justifyContent: "space-between", children: [
            /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Text_default, { ellipsis: true, color: theme.colors.n90, ...{ sm: true }, children: (0, import_lodash19.capitalize)(
              t(
                `common:labels.dateRangeGroups.${(0, import_lodash19.camelCase)(type)}`
              )
            ) }),
            /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
              Icon_default,
              {
                color: theme.colors.n90,
                name: isOpen ? "arrowUp" : "arrowDown",
                ...{ ml: 1, size: 16 }
              }
            )
          ] }),
          children: ({ closeDropdown }) => /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(Flex_default, { flexDirection: "column", children: periodOptions.map((periodType) => /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
            PeriodButton2,
            {
              active: type === periodType,
              w: "100%",
              variation: "flat",
              onClick: () => {
                setType(periodType);
                setFilterState("groupOption", periodType);
                closeDropdown();
              },
              children: t(
                `common:labels.dateRangeGroups.${(0, import_lodash19.camelCase)(periodType)}`
              )
            },
            periodType
          )) })
        }
      )
    ] }) })
  ] });
}
var ApiAccessHeader_default = ApiAccessHeader;

// src/components/organisms/ApiAccessChartWidget/ApiAccessChartWidget.tsx
var import_jsx_runtime143 = require("react/jsx-runtime");
function ApiAccessChartWidget({
  title,
  fetchFunction,
  hidePeriodTypes
}) {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(import_jsx_runtime143.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(FilterProvider, { children: /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(Card_default, { p: 4, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime143.jsxs)(
    Flex_default,
    {
      w: "100%",
      minHeight: 272,
      flexDirection: "column",
      overflow: isMobile ? "scroll" : "unset",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(ApiAccessHeader_default, { title, hidePeriodTypes }),
        /* @__PURE__ */ (0, import_jsx_runtime143.jsx)(ApiAccessChart_default, { fetchFunction })
      ]
    }
  ) }) }) });
}
var ApiAccessChartWidget_default = ApiAccessChartWidget;

// src/components/organisms/DeleteModal/DeleteModal.tsx
var import_react99 = require("react");
var import_react_i18next46 = require("react-i18next");
var import_jsx_runtime144 = require("react/jsx-runtime");
function DeleteModal({
  w,
  entity,
  name,
  modalName,
  onClick,
  message,
  title,
  note,
  isLoading = false,
  colorVariation = "danger"
}) {
  const translateServerResponse = useServerResponseTranslation();
  const { t: tModal } = (0, import_react_i18next46.useTranslation)("common", {
    keyPrefix: "modalDelete"
  });
  const { t: tLabels } = (0, import_react_i18next46.useTranslation)("common", {
    keyPrefix: "labels"
  });
  const { t: tM } = (0, import_react_i18next46.useTranslation)("common", {
    keyPrefix: "serverMessages"
  });
  const { isOpenCurrent, toggleModal, setPayload } = (0, import_react99.useContext)(ModalContext);
  const isOpen = isOpenCurrent[modalName];
  function closeModal() {
    setPayload(null);
    toggleModal(false, modalName);
  }
  return /* @__PURE__ */ (0, import_jsx_runtime144.jsx)(
    Modal3,
    {
      w,
      isOpen,
      title: title ? title : tModal("title", { entity }) || "",
      onRequestClose: closeModal,
      cancelButton: {
        title: tLabels`cancel`,
        onClick: closeModal
      },
      submitButton: {
        title: tLabels`delete`,
        onClick: async () => {
          try {
            await onClick();
            toast.success(`${entity} has been deleted`);
          } catch (error) {
            const translateMessage = translateServerResponse(error);
            const errorMessage = translateMessage !== tM("unknown") ? translateMessage : error.message;
            toast.error(errorMessage);
          } finally {
            setPayload(null);
            toggleModal(false, modalName);
          }
        },
        colorVariation,
        isLoading
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)(Flex_default, { flexDirection: "column", children: [
        message ? message : /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)(Text_default, { children: [
          tModal("confirmationText") || "",
          " ",
          /* @__PURE__ */ (0, import_jsx_runtime144.jsx)("strong", { children: name }),
          " ",
          entity,
          "?"
        ] }),
        note && /* @__PURE__ */ (0, import_jsx_runtime144.jsxs)(Text_default, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime144.jsx)("strong", { children: "Note:" }),
          " ",
          note
        ] })
      ] })
    }
  );
}
var DeleteModal_default = DeleteModal;

// src/components/organisms/TableWitPagination/TableWitPagination.tsx
var import_styled_components150 = require("styled-components");
var import_jsx_runtime145 = require("react/jsx-runtime");
function TableWithPagination({
  tableProps,
  paginationProps: {
    countPerPage,
    label,
    nextButtonLabel,
    previousButtonLabel,
    showPagination = true
  },
  overflow,
  ...args
}) {
  const theme = (0, import_styled_components150.useTheme)();
  const { data } = tableProps;
  return /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Flex_default, { flexDirection: "column", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(ScrollDragable_default, { children: /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(Table_default, { ...tableProps }) }),
    /* @__PURE__ */ (0, import_jsx_runtime145.jsxs)(
      Flex_default,
      {
        flex: 1,
        w: "100%",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: showPagination ? "space-between" : "flex-end",
        my: 4,
        pl: 6,
        pr: 2,
        children: [
          showPagination && /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(PaginationInfoLabel, { label, color: theme.colors.n70 }),
          data?.length ? /* @__PURE__ */ (0, import_jsx_runtime145.jsx)(
            Pagination_default,
            {
              countPerPage,
              previousButtonLabel,
              nextButtonLabel
            }
          ) : null
        ]
      }
    )
  ] }) });
}
var TableWitPagination_default = TableWithPagination;

// src/components/organisms/SideBar/SideBar.tsx
var import_styled_components151 = __toESM(require("styled-components"));
var import_dash_common43 = require("dash-common");
var import_jsx_runtime146 = require("react/jsx-runtime");
var RightPanelStyle = (0, import_styled_components151.default)(Flex_default)`
  position: fixed;
  min-height: calc(100vh - 50px);
  background-color: ${({ theme, variation }) => variation === "primary" ? theme.colors.white : theme.colors.b10};
  border-right: ${({ variation, theme }) => variation === "primary" ? `1px solid ${theme.colors.n30}` : "none"};

  @media ${({ theme }) => `${theme.devices.tablet}, ${theme.devices.mobile}`} {
    min-height: 56px;
    overflow: auto;
    bottom: 0;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.sidebarShadow};
  }
`;
var ButtonStyle4 = (0, import_styled_components151.default)(Button_default)`
  @media ${({ theme }) => `${theme.devices.tablet}, ${theme.devices.mobile}`} {
    justify-content: center;
    & > div {
      flex-direction: column;
    }
  }
  text-align: left;
  svg {
    width: 24px;
  }
  justify-content: flex-start;
  white-space: nowrap;
  ${({ transparent: transparent2, isActive }) => transparent2 && !isActive && "background-color: transparent"}

  ${({ isActive, theme }) => isActive && `&, :hover {
      background-color: ${theme.colors.b50};
      color: ${theme.colors.white};
      p {
        color: ${theme.colors.white};
      }
    }`}
`;
var StyledWrapper5 = (0, import_styled_components151.default)(Box_default)`
  @media ${({ theme }) => `${theme.devices.tablet}, ${theme.devices.mobile}`} {
    width: 100%;
    position: fixed;
    z-index: 100;
    bottom: 0;
  }
`;
function Sidebar({ items, variation = "primary" }) {
  const {
    devices: { isTablet, isMobile }
  } = useScreenResolution();
  const isResponsive = isTablet || isMobile;
  return /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(StyledWrapper5, { w: 248, children: /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(
    RightPanelStyle,
    {
      px: [2, 6, 4, 4],
      w: ["100%", "100%", 248, 248],
      flexDirection: "column",
      variation,
      children: /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(Flex_default, { flex: 1, flexDirection: isResponsive ? "row" : "column", w: "100%", mt: [0, 0, 7, 7], children: items.map(({ icon, label, onClick, isActive, disabled = false }) => /* @__PURE__ */ (0, import_jsx_runtime146.jsx)(
        ButtonStyle4,
        {
          disabled,
          icon,
          p: 2,
          w: "100%",
          mt: [2, 2, 3, 3],
          variation: "flat",
          iconProps: { px: 1, size: 16, mb: [1, 1, 0, 0] },
          onClick,
          isActive,
          transparent: variation === "secondary",
          sm: isResponsive,
          children: label
        },
        (0, import_dash_common43.RandomId)()
      )) })
    }
  ) });
}
var SideBar_default = Sidebar;

// src/components/organisms/Slideshow/Slideshow.tsx
var import_react100 = require("react");
var import_react_i18next48 = require("react-i18next");
var import_styled_components155 = require("styled-components");

// src/components/organisms/Slideshow/components/Thumbnail/Thumbnail.tsx
var import_react_i18next47 = require("react-i18next");
var import_dash_common44 = require("dash-common");
var import_styled_components153 = require("styled-components");

// src/components/organisms/Slideshow/components/Thumbnail/Thumbnail.styles.ts
var import_styled_components152 = __toESM(require("styled-components"));
var StyledPreviewButton = (0, import_styled_components152.default)(Button_default)`
  display: none;
  position: absolute;
  bottom: ${({ theme }) => theme.space * 2}px;
  right: ${({ theme }) => theme.space * 2}px;
`;
var StyledMainButton = (0, import_styled_components152.default)(Badge_default)`
  position: absolute;
  display: ${({ isMain }) => isMain ? "flex" : "none"};
  border-radius: ${({ theme }) => theme.space * 4}px;
  top: ${({ theme }) => theme.space * 2}px;
  left: ${({ theme }) => theme.space * 2}px;
`;
var ThumbnailWrapper3 = (0, import_styled_components152.default)(Box_default)`
  position: relative;
  border-radius: ${({ theme }) => theme.space * 2}px;
  background-color: ${({ theme }) => theme.colors.n30};
  cursor: pointer;

  :hover {
    & > :not(:first-child) {
      display: flex;
    }
  }
`;
var StyledImage3 = (0, import_styled_components152.default)(Image_default)`
  height: 100%;
  border-radius: 0;
  width: 100%;
`;

// src/components/organisms/Slideshow/components/Thumbnail/Thumbnail.tsx
var import_jsx_runtime147 = require("react/jsx-runtime");
var ViewComponent = ({ file }) => {
  const theme = (0, import_styled_components153.useTheme)();
  const isVideo = import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isImage = import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type);
  if (isVideo) {
    return /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(Video_default, { src: file.thumbnailFileUrl || file.publicUrl });
  }
  if (isImage) {
    return /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(StyledImage3, { src: file.thumbnailFileUrl || file.publicUrl, alt: file.name, fit: "cover" });
  }
  if (import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES.pdf === file.type) {
    return /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(FileTypeIcon_default, { file });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(Icon_default, { name: "filePlaceholder", size: 45, color: theme.colors.n20 });
};
var Thumbnail2 = ({ file, openPreview, setMain, isMain }) => {
  const { t } = (0, import_react_i18next47.useTranslation)("pages");
  const isVideo = import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isImage = import_dash_common44.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type);
  return /* @__PURE__ */ (0, import_jsx_runtime147.jsxs)(ThumbnailWrapper3, { py: 9.25, w: 224, h: 212, pos: "relative", children: [
    /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(Flex_default, { justifyContent: "center", alignItems: "center", w: "100%", h: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(ViewComponent, { file }) }),
    setMain && (isImage || isVideo) && /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(
      StyledMainButton,
      {
        semibold: true,
        isMain,
        onClick: () => setMain(file._id),
        title: t("propertyPage.main")
      }
    ),
    openPreview && /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(StyledPreviewButton, { square: true, variation: "primary", onClick: () => openPreview(file._id), children: /* @__PURE__ */ (0, import_jsx_runtime147.jsx)(Icon_default, { name: "show" }) })
  ] });
};
var Thumbnail_default2 = Thumbnail2;

// src/components/organisms/Slideshow/Slideshow.styles.ts
var import_styled_components154 = __toESM(require("styled-components"));
var StyledList2 = (0, import_styled_components154.default)(ListWithPagination_default)`
  & > div:first-child {
    padding: 0;
    padding-bottom: 8px;
  }

  & > div:last-child {
    padding: 0;
  }
`;
var EmptyContainer = (0, import_styled_components154.default)(Flex_default)`
  border-radius: ${({ theme }) => theme.space * 2}px;
  border: 1px solid ${({ theme }) => theme.colors.n30};
  text-align: center;
`;

// src/components/organisms/Slideshow/Slideshow.tsx
var import_jsx_runtime148 = require("react/jsx-runtime");
var Slideshow = ({
  files,
  paginationProps,
  setMainFile,
  mainFileId,
  onDownloadButtonClick,
  loading,
  onItemDrop,
  ...args
}) => {
  const theme = (0, import_styled_components155.useTheme)();
  const { t } = (0, import_react_i18next48.useTranslation)("pages");
  const [fileIdToOpen, setFileIdToOpen] = (0, import_react100.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime148.jsxs)(Box_default, { ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
      FilePreviewModal_default,
      {
        isOpened: !!fileIdToOpen,
        onClose: () => setFileIdToOpen(""),
        files,
        onDownloadButtonClick,
        defaultIndex: files.findIndex((item) => item._id === fileIdToOpen)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Box_default, { mb: 8, children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Text_default, { semibold: true, lg: true, children: t("propertyPage.slideshow") }) }),
    files.length > 0 ? /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
      StyledList2,
      {
        mt: 8,
        listProps: {
          data: files,
          flexWrap: "wrap",
          onItemDrop,
          isDraggable: true,
          gap: 40,
          loading
        },
        paginationProps,
        children: (file) => /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(
          Thumbnail_default2,
          {
            file,
            openPreview: setFileIdToOpen,
            isMain: file._id === mainFileId,
            setMain: setMainFile
          }
        )
      }
    ) : /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(EmptyContainer, { alignItems: "center", h: 240, justifyContent: "center", children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Box_default, { w: 440, children: /* @__PURE__ */ (0, import_jsx_runtime148.jsx)(Text_default, { color: theme.colors.n80, children: t("propertyPage.noFilesPlaceholder") }) }) })
  ] });
};
var Slideshow_default = Slideshow;

// src/components/organisms/SlideshowPreview/SlideshowPreview.tsx
var import_react101 = require("react");
var import_styled_components157 = require("styled-components");

// src/components/organisms/SlideshowPreview/SlideshowPreview.styles.ts
var import_styled_components156 = __toESM(require("styled-components"));
var LeftContainer2 = (0, import_styled_components156.default)(Flex_default)`
  border-top-left-radius: ${({ theme }) => theme.space}px;
  border-bottom-left-radius: ${({ theme }) => theme.space}px;
  overflow: hidden;
`;
var RightContainer = (0, import_styled_components156.default)(Flex_default)`
  border-top-right-radius: ${({ theme }) => theme.space}px;
  border-bottom-right-radius: ${({ theme }) => theme.space}px;
  overflow: hidden;
`;
var SingleContainer = (0, import_styled_components156.default)(Flex_default)`
  & > div {
    border-radius: ${({ theme }) => theme.space}px;
  }
`;

// src/components/organisms/SlideshowPreview/SlideshowPreview.tsx
var import_jsx_runtime149 = require("react/jsx-runtime");
var SlideshowPreview = ({
  files: currentFiles,
  h = 376,
  totalCount,
  mainFileId,
  loading,
  ...args
}) => {
  const theme = (0, import_styled_components157.useTheme)();
  const [fileIdToOpen, setFileIdToOpen] = (0, import_react101.useState)(-1);
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const halfHeight = h / 2 - theme.space * 1.5;
  const files = (0, import_react101.useMemo)(() => {
    const copy = [...currentFiles];
    const index2 = copy.findIndex((item) => item._id === mainFileId);
    copy.splice(2, 0, copy.splice(index2, 1)[0]);
    return copy;
  }, [currentFiles, mainFileId]);
  const onItemClick = (index2) => () => {
    setFileIdToOpen(files[index2] ? index2 : -1);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)(Flex_default, { flexDirection: "row", h, pos: "relative", ...args, children: [
    /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(
      FilePreviewModal_default,
      {
        isOpened: fileIdToOpen >= 0,
        onClose: () => setFileIdToOpen(-1),
        files,
        defaultIndex: fileIdToOpen,
        isDownloadButtonVisible: false
      }
    ),
    isMobile ? /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(SingleContainer, { onClick: onItemClick(mainFileId ? 2 : 0), h, w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Thumbnail_default, { file: files[mainFileId ? 2 : 0], totalCount }) }) : /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)(import_jsx_runtime149.Fragment, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(LeftContainer2, { h: halfHeight, w: "100%", onClick: onItemClick(0), children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Thumbnail_default, { file: files[0] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(LeftContainer2, { h: halfHeight, w: "100%", mt: 3, onClick: onItemClick(1), children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Thumbnail_default, { file: files[1] }) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Flex_default, { flex: 2, h, mx: 3, onClick: onItemClick(2), children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Thumbnail_default, { file: files[2] }) }),
      /* @__PURE__ */ (0, import_jsx_runtime149.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
        /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(RightContainer, { h: halfHeight, w: "100%", onClick: onItemClick(3), children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Thumbnail_default, { file: files[3] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(RightContainer, { h: halfHeight, w: "100%", mt: 3, onClick: onItemClick(4), children: /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Thumbnail_default, { file: files[4], label: totalCount - 5 > 0 ? `+${totalCount - 5}` : "" }) })
      ] })
    ] }),
    loading && /* @__PURE__ */ (0, import_jsx_runtime149.jsx)(Spinner_default, { fullContent: true, size: 32 })
  ] });
};
var SlideshowPreview_default = SlideshowPreview;

// src/components/organisms/TableView/TableView.tsx
var import_react103 = require("react");
var import_styled_components158 = __toESM(require("styled-components"));

// src/components/organisms/TableView/context.tsx
var import_react102 = require("react");

// src/components/organisms/TableView/constants.ts
var TableViewType = /* @__PURE__ */ ((TableViewType2) => {
  TableViewType2["Table"] = "Table";
  TableViewType2["List"] = "List";
  return TableViewType2;
})(TableViewType || {});

// src/components/organisms/TableView/context.tsx
var import_jsx_runtime150 = require("react/jsx-runtime");
var TableViewContext = (0, import_react102.createContext)({
  viewType: "List" /* List */,
  setViewType: () => null
});
function TableViewProvider({ children }) {
  const [tableViewType, setTableViewType] = (0, import_react102.useState)("List" /* List */);
  return /* @__PURE__ */ (0, import_jsx_runtime150.jsx)(TableViewContext.Provider, { value: { viewType: tableViewType, setViewType: setTableViewType }, children });
}

// src/components/organisms/TableView/TableView.tsx
var import_jsx_runtime151 = require("react/jsx-runtime");
var ListStyle = (0, import_styled_components158.default)(List_default)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.n30};
  width: 100%;
`;
function TableViewToggle() {
  const { viewType, setViewType } = (0, import_react103.useContext)(TableViewContext);
  return /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Flex_default, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
      Button_default,
      {
        h: 40,
        square: true,
        variation: viewType === "List" /* List */ ? "primary" : "flat",
        icon: "dashboard",
        onClick: () => setViewType("List" /* List */)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
      Button_default,
      {
        h: 40,
        square: true,
        variation: viewType === "Table" /* Table */ ? "primary" : "flat",
        icon: "list",
        onClick: () => setViewType("Table" /* Table */)
      }
    )
  ] });
}
function TableView({
  data,
  tableProps,
  placeholder,
  listProps,
  loading,
  paginationProps,
  ...args
}) {
  const { viewType } = (0, import_react103.useContext)(TableViewContext);
  const { setSortState } = (0, import_react103.useContext)(SortContext);
  const theme = (0, import_styled_components158.useTheme)();
  const {
    devices: { isMobile }
  } = useScreenResolution();
  (0, import_react103.useEffect)(() => {
    setSortState({ fieldName: "name", sortOrder: 1 });
  }, []);
  return /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Flex_default, { flexDirection: "column", w: "100%", ...args, children: /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Flex_default, { flexDirection: "column", flex: 1, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(Box_default, { pos: "relative", w: "100%", overflow: "auto", children: [
      viewType === "Table" /* Table */ && /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Table_default, { w: "100%", placeholder, data, ...tableProps }),
      viewType === "List" /* List */ && /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(import_jsx_runtime151.Fragment, { children: [
        /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
          Table_default,
          {
            data,
            placeholder,
            withHeader: false,
            renderBody: () => null,
            ...tableProps
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(ListStyle, { data, grid: [153, 148, 196, 196], ...listProps, children: (item, index2) => listProps.renderItem(item, index2) })
      ] }),
      loading && /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(Spinner_default, { size: 32, fullContent: true })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime151.jsxs)(
      Flex_default,
      {
        flex: 1,
        w: "100%",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        justifyContent: "space-between",
        my: 4,
        pl: 6,
        pr: 2,
        children: [
          /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(PaginationInfoLabel, { label: paginationProps.label, color: theme.colors.n70 }),
          data?.length ? /* @__PURE__ */ (0, import_jsx_runtime151.jsx)(
            Pagination_default,
            {
              mt: [4, 0, 0, 0],
              previousButtonLabel: paginationProps.previousButtonLabel,
              nextButtonLabel: paginationProps.nextButtonLabel
            }
          ) : null
        ]
      }
    )
  ] }) });
}
var TableView_default = TableView;

// src/components/organisms/MediaFilePreviewCard/MediaFilePreviewCard.tsx
var import_moment10 = __toESM(require("moment"));
var import_react_i18next49 = require("react-i18next");
var import_styled_components161 = require("styled-components");
var import_dash_common46 = require("dash-common");

// src/components/organisms/MediaFilePreviewCard/MediaFilePreviewCard.styles.ts
var import_styled_components159 = __toESM(require("styled-components"));
var MediaFilterItemWrapper = (0, import_styled_components159.default)(Flex_default)`
  border: 1px solid ${({ theme }) => theme.colors.n30};
  border-radius: ${({ theme }) => theme.space * 2}px;
  cursor: pointer;
  position: relative;
  width: 100%;
`;
var ImageWrapper3 = (0, import_styled_components159.default)(Flex_default)`
  background: ${({ theme }) => theme.colors.b10};
  border-radius: ${({ theme }) => {
  const radius = theme.space * 2;
  return `${radius}px ${radius}px 0 0`;
}};
`;
var Overlay = (0, import_styled_components159.default)(Box_default)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 2;
`;
var StyledTopContainer = (0, import_styled_components159.default)(Flex_default)`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space}px;
  bottom: unset;
  right: 12px;
  top: 12px;
  position: absolute;
  z-index: 3;
`;

// src/components/organisms/MediaFilePreviewCard/components/ViewFileContainer.tsx
var import_styled_components160 = __toESM(require("styled-components"));
var import_dash_common45 = require("dash-common");
var import_jsx_runtime152 = require("react/jsx-runtime");
var ThumbnailView = (0, import_styled_components160.default)(Image_default)`
  border-radius: 8px 8px 0 0;
`;
var ViewFileContainer = ({
  file,
  mediaType
}) => {
  const theme = (0, import_styled_components160.useTheme)();
  const isVideo = file && import_dash_common45.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.VIDEOS.includes(file.type);
  const isPdf = file?.type === import_dash_common45.ALLOWED_MEDIA_TYPE_MIMES.pdf;
  const isImage = file && import_dash_common45.ALLOWED_MEDIA_TYPE_MIMES_IN_FILTER.IMAGES.includes(file.type);
  if (mediaType === import_dash_common45.MediaTypesEnum.FOLDER) {
    return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Icon_default, { name: "mediaFolderPlaceholder", size: 96, color: theme.colors.b50Hover });
  }
  if (isVideo) {
    return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(Video_default, { src: file.publicUrl });
  }
  if (isImage) {
    return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(
      ThumbnailView,
      {
        w: "100%",
        h: "100%",
        fit: "cover",
        src: file.thumbnailFile?.publicUrl || file.publicUrl
      }
    );
  }
  if (isPdf) {
    return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(FileTypeIcon_default, { lg: true, file });
  }
  return /* @__PURE__ */ (0, import_jsx_runtime152.jsx)(FileTypeIcon_default, { lg: true, file });
};
var ViewFileContainer_default = ViewFileContainer;

// src/components/organisms/MediaFilePreviewCard/MediaFilePreviewCard.tsx
var import_jsx_runtime153 = require("react/jsx-runtime");
var MediaFilePreviewCard = ({
  media,
  onClick,
  selectItemProps,
  ...args
}) => {
  const { t } = (0, import_react_i18next49.useTranslation)(["common", "pages"]);
  const theme = (0, import_styled_components161.useTheme)();
  const { devices } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)(
    MediaFilterItemWrapper,
    {
      flex: 1,
      flexDirection: "column",
      justifyContent: "space-between",
      ...args,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(Overlay, { onClick }),
        /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(ImageWrapper3, { w: "100%", h: 112, justifyContent: "center", alignItems: "center", children: /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(ViewFileContainer_default, { mediaType: media.type, file: media?.files[0] }) }),
        /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)(
          Flex_default,
          {
            flex: 1,
            flexDirection: "column",
            p: 3.5,
            alignItems: "flex-start",
            justifyContent: "space-between",
            w: "inherit",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(Flex_default, { w: "100%", children: /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
                Text_default,
                {
                  ellipsis: true,
                  medium: devices.isDesktop || devices.isLaptop,
                  sm: devices.isMobile || devices.isTablet,
                  color: theme.colors.n90,
                  semibold: true,
                  children: media.folderName ? `${media.folderName} (${media.files.length})` : media.files.length && media.files[0].name
                }
              ) }),
              /* @__PURE__ */ (0, import_jsx_runtime153.jsxs)(
                Flex_default,
                {
                  w: "100%",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: 1,
                  children: [
                    /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
                      Text_default,
                      {
                        medium: devices.isDesktop || devices.isLaptop,
                        sm: devices.isMobile || devices.isTablet,
                        color: theme.colors.n70,
                        children: (0, import_moment10.default)(media.updatedAt).format(import_dash_common46.DATE_FORMAT)
                      }
                    ),
                    /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(
                      Text_default,
                      {
                        medium: devices.isDesktop || devices.isLaptop,
                        sm: devices.isMobile || devices.isTablet,
                        color: theme.colors.n70,
                        children: (0, import_dash_common46.bytesToMBytes)(media.sizeInBytes) > 1 ? t("common:labels.mBytes", {
                          size: (0, import_dash_common46.bytesToMBytes)(media.sizeInBytes)
                        }) : t("common:labels.kBytes", {
                          size: (0, import_dash_common46.bytesToKBytes)(media.sizeInBytes)
                        })
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(StyledTopContainer, { children: selectItemProps ? /* @__PURE__ */ (0, import_jsx_runtime153.jsx)(Checkbox_default, { onChange: selectItemProps.onSelect, checked: selectItemProps.checked }) : null })
      ]
    }
  );
};
var MediaFilePreviewCard_default = MediaFilePreviewCard;

// src/components/organisms/TableWithFlatPagination/TableWithFlatPagination.helpers.tsx
var getFlatPaginationPointsProps = (targetPaginationField, data) => {
  const points = {
    currentEndingBefore: "",
    currentStartingAfter: ""
  };
  if (data.length) {
    const firstFieldId = data[0][targetPaginationField];
    const lastFieldId = data[data.length - 1][targetPaginationField];
    if (firstFieldId) {
      points.currentEndingBefore = firstFieldId;
    }
    if (lastFieldId) {
      points.currentStartingAfter = lastFieldId;
    }
  }
  return points;
};

// src/components/organisms/TableWithFlatPagination/TableWithFlatPagination.tsx
var import_jsx_runtime154 = require("react/jsx-runtime");
function TableWithFlatPagination({
  targetPaginationField,
  tableProps,
  paginationProps,
  ...args
}) {
  const { data = [] } = tableProps;
  return /* @__PURE__ */ (0, import_jsx_runtime154.jsxs)(Flex_default, { flexDirection: "column", ...args, flex: 1, w: "100%", children: [
    /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(Table_default, { ...tableProps }),
    !!data?.length && /* @__PURE__ */ (0, import_jsx_runtime154.jsx)(
      FlatPagination_default,
      {
        w: "100%",
        alignItems: "center",
        justifyContent: "right",
        my: 4,
        pl: 6,
        pr: 2,
        ...paginationProps,
        ...getFlatPaginationPointsProps(targetPaginationField, data)
      }
    )
  ] });
}
var TableWithFlatPagination_default = TableWithFlatPagination;

// src/components/organisms/ModalWitBrokerBanner/ModalWithBrokerBanner.tsx
var import_react_modal4 = __toESM(require("react-modal"));
var import_styled_components163 = __toESM(require("styled-components"));

// src/components/organisms/ModalWitBrokerBanner/ModalWithBrokerBanner.styles.ts
var import_styled_components162 = __toESM(require("styled-components"));
var ContentWrapper = (0, import_styled_components162.default)(Box_default)`
  position: relative;
`;
var CloseIconContainer = (0, import_styled_components162.default)(Box_default)`
  position: absolute;
  cursor: pointer;
  top: ${({ theme }) => theme.space * 4}px;
  right: ${({ theme }) => theme.space * 4}px;
  z-index: 3;
`;

// src/components/organisms/ModalWitBrokerBanner/ModalWithBrokerBanner.tsx
var import_jsx_runtime155 = require("react/jsx-runtime");
var UnstyledModal = ({
  className,
  isOpen,
  onRequestClose,
  children,
  broker,
  closeIcon = true
}) => {
  const theme = (0, import_styled_components163.useTheme)();
  const contentClassName = `${className}__content`;
  const overlayClassName = `${className}__overlay`;
  const {
    devices: { isMobile }
  } = useScreenResolution();
  return /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(
    import_react_modal4.default,
    {
      className: contentClassName,
      overlayClassName: {
        base: overlayClassName,
        afterOpen: `${overlayClassName}--after-open`,
        beforeClose: `${overlayClassName}--before-close`
      },
      isOpen,
      onRequestClose,
      children: /* @__PURE__ */ (0, import_jsx_runtime155.jsxs)(ContentWrapper, { children: [
        isMobile ? /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(BrokersBanner_default, { variation: "vertical", broker }) : /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(BrokersBanner_default, { variation: "horizontal", broker }),
        children,
        /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(CloseIconContainer, { children: closeIcon && /* @__PURE__ */ (0, import_jsx_runtime155.jsx)(Icon_default, { onClick: onRequestClose, name: "close", size: 24, color: theme.colors.white }) })
      ] })
    }
  );
};
var ModalWithBrokerBanner = (0, import_styled_components163.default)(UnstyledModal)`
  &${({ className }) => className ? `.${className}` : ""}__overlay {
    position: fixed;
    inset: 0px;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 0;
    overflow: auto;
    z-index: 100;
    padding-left: ${({ theme }) => theme.space * 4}px;
    padding-right: ${({ theme }) => theme.space * 4}px;
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--after-open {
    opacity: 1;
    transition: opacity 150ms ease-out;
  }

  &${({ className }) => className ? `.${className}` : ""}__overlay--before-close {
    opacity: 0;
  }

  &__content {
    background-color: ${({ theme }) => theme.colors.white};
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 16px;
    box-sizing: border-box;
    outline: none;
    max-width: 1054px;
    width: 100%;
    margin: 265px auto 24px;

    @media ${({ theme }) => theme.devices.mobile} {
      margin-top: 165px;
    }
  }
`;
var ModalWithBrokerBanner_default = ModalWithBrokerBanner;

// src/components/organisms/PropertiesTable/PropertiesTable.tsx
var import_react109 = require("react");
var import_react_i18next55 = require("react-i18next");

// src/components/organisms/PropertiesTable/PropertiesTableActions/PropertiesTableActions.tsx
var import_noop = __toESM(require("lodash/noop"));
var import_isEmpty = __toESM(require("lodash/isEmpty"));
var import_react_i18next54 = require("react-i18next");
var import_dash_common50 = require("dash-common");
var import_react108 = require("react");

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/AddPropertyModal.tsx
var import_react_i18next53 = require("react-i18next");
var import_react107 = require("react");
var import_dash_common49 = require("dash-common");

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/constants/constants.ts
var NON_MANUAL_FIELDS = ["name" /* Name */, "primaryOrganizationId" /* PrimaryOrganizationId */, "place" /* Place */];

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/hooks/useValidation.ts
var import_react104 = require("react");
var import_react_i18next50 = require("react-i18next");
var import_dash_common47 = require("dash-common");
var useValidation2 = () => {
  const { formState, errorHandlers } = (0, import_react104.useContext)(FormContext);
  const { t } = (0, import_react_i18next50.useTranslation)(["forms", "common", "pages"]);
  const isMarketOptional = (0, import_dash_common47.getIsMarketOptional)(formState.state);
  const validateFieldByName = (fieldName, value) => {
    const setInvalid = (message, values) => {
      errorHandlers[fieldName]({
        type: "invalid" /* Invalid */,
        message: t(message, values || {})
      });
    };
    switch (fieldName) {
      case "name" /* Name */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.nameBlank");
          return false;
        }
        if (!(0, import_dash_common47.isNameLengthValid)(value)) {
          setInvalid("forms:messages.maxCharacterLimit", {
            number: import_dash_common47.DashValidation.MaxNameLength.toString()
          });
          return false;
        }
        break;
      }
      case "primaryOrganizationId" /* PrimaryOrganizationId */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.organizationBlank");
          return false;
        }
        if (!(0, import_dash_common47.isNameLengthValid)(value)) {
          setInvalid("forms:messages.maxCharacterLimit", {
            number: import_dash_common47.DashValidation.MaxNameLength.toString()
          });
          return false;
        }
        break;
      }
      case "place" /* Place */: {
        if (!value) {
          setInvalid("forms:messages.mapBlank");
          return false;
        }
        break;
      }
      case "street" /* Street */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.streetBlank");
          return false;
        }
        break;
      }
      case "city" /* City */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.cityBlank");
          return false;
        }
        break;
      }
      case "zipCode" /* ZipCode */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.streetBlank");
          return false;
        }
        break;
      }
      case "state" /* State */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.stateBlank");
          return false;
        }
        break;
      }
      case "county" /* County */: {
        if ((0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.countyBlank");
          return false;
        }
        break;
      }
      case "market" /* Market */: {
        if (!isMarketOptional && (0, import_dash_common47.isEmptyOrNil)(value)) {
          setInvalid("forms:messages.marketBlank");
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };
  return validateFieldByName;
};
var useValidation_default2 = useValidation2;

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/components/PlaceSection/PlaceSection.tsx
var import_react_i18next51 = require("react-i18next");
var import_react105 = require("react");
var import_jsx_runtime156 = require("react/jsx-runtime");
var PlaceSection = () => {
  const { t } = (0, import_react_i18next51.useTranslation)(["forms", "common", "pages"]);
  const isGoogleApiReady = useGoogleApiLoader();
  const googleAutocompleteContainerRef = (0, import_react105.useRef)(null);
  const { formState, formErrors, stateHandlers } = (0, import_react105.useContext)(FormContext);
  const { place } = formState;
  const center = place?.geometry?.location ?? void 0;
  const geocoder = isGoogleApiReady ? new google.maps.Geocoder() : null;
  const onPlaceSelected = (place2) => {
    const address = googlePlaceToAddress(place2);
    stateHandlers["place" /* Place */](place2);
    stateHandlers["street" /* Street */](address.street);
    stateHandlers["city" /* City */](address.city);
    stateHandlers["zipCode" /* ZipCode */](address.zipCode);
    stateHandlers["state" /* State */](address.state);
    stateHandlers["county" /* County */](address.county);
  };
  const onShowAddress = () => {
    stateHandlers["isShowAddress" /* IsShowAddress */](!formState.isShowAddress);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime156.jsxs)(import_jsx_runtime156.Fragment, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime156.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
      /* @__PURE__ */ (0, import_jsx_runtime156.jsxs)(Flex_default, { justifyContent: "space-between", children: [
        /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Form_default.Label, { required: true, children: t("forms:labels.map") }) }),
        /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
          Button_default,
          {
            type: "button",
            onClick: onShowAddress,
            variation: "flat",
            minWidth: "unset",
            h: "unset",
            children: t("forms:labels.addManually")
          }
        ) })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Box_default, { w: "100%", ref: googleAutocompleteContainerRef, children: isGoogleApiReady ? /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
        GoogleAutocomplete_default,
        {
          menuPortalTarget: googleAutocompleteContainerRef.current,
          onPlaceSelected,
          defaultValue: place?.formatted_address || "",
          placeholder: t("forms:placeholders:map") || "",
          $errorType: formErrors["place" /* Place */]?.type
        }
      ) : /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Spinner_default, {}) }),
      /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Form_default.Feedback, { $errorType: formErrors["place" /* Place */]?.type, children: formErrors["place" /* Place */]?.message })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Form_default.Group, { w: "100%", mt: 3, children: isGoogleApiReady && /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(
      GoogleMap_default,
      {
        h: 208,
        center,
        onClick: (e) => {
          if (e.latLng && geocoder) {
            geocoder.geocode(
              { location: { lat: e.latLng.lat(), lng: e.latLng.lng() } },
              (result) => {
                if (result?.length) {
                  onPlaceSelected(result[0]);
                }
              }
            );
          }
        },
        children: center && /* @__PURE__ */ (0, import_jsx_runtime156.jsx)(Marker_default, { position: center })
      }
    ) })
  ] });
};
var PlaceSection_default = PlaceSection;

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/components/AddressSection/AddressSection.tsx
var import_react106 = require("react");
var import_react_i18next52 = require("react-i18next");
var import_styled_components164 = __toESM(require("styled-components"));
var import_dash_common48 = require("dash-common");
var import_jsx_runtime157 = require("react/jsx-runtime");
var NumberInput2 = (0, import_styled_components164.default)(Input_default)`
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }
`;
var AddressSection = ({ statesOptions, marketOptions }) => {
  const { t } = (0, import_react_i18next52.useTranslation)(["forms", "common", "pages"]);
  const { formState, formErrors, stateHandlers } = (0, import_react106.useContext)(FormContext);
  const validateFieldByName = useValidation_default2();
  const handleTextInputs = (fieldName) => (e) => {
    const { value } = e.target;
    if (fieldName === "zipCode" /* ZipCode */) {
      if (value.length <= import_dash_common48.DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](value);
        validateFieldByName(fieldName, value);
      }
      return;
    }
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleSelectInputs = (fieldName) => (value) => {
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
    if (fieldName === "state" /* State */) {
      stateHandlers["county" /* County */](null);
      stateHandlers["market" /* Market */](null);
    }
  };
  const stateName = formState.state || "";
  const countiesOptions = (0, import_react106.useMemo)(() => {
    const counties = (0, import_dash_common48.getCountiesByStateName)(stateName);
    return counties.map((value) => ({
      label: value,
      value
    }));
  }, [stateName]);
  const handleCountySelect = (value) => {
    if (value) {
      stateHandlers["county" /* County */](value);
      validateFieldByName("county" /* County */, value);
    }
  };
  const isMarketOptional = (0, import_dash_common48.getIsMarketOptional)(stateName);
  return formState.isShowAddress ? /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Flex_default, { flex: 1, flexDirection: "row", children: [
    /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Flex_default, { flex: 1, flexDirection: "column", mr: 4, children: [
      /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Label, { required: true, children: t("forms:labels.streetName") }),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
          Form_default.Input,
          {
            placeholder: t("forms:placeholders.nameOfStreet") || "",
            onChange: handleTextInputs("street" /* Street */),
            value: formState.street || "",
            $errorType: formErrors["street" /* Street */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Feedback, { $errorType: formErrors["street" /* Street */]?.type, children: formErrors["street" /* Street */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Label, { required: true, children: t("forms:labels.zipCode") }),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
          NumberInput2,
          {
            value: formState.zipCode || "",
            placeholder: t("forms:placeholders.digits", { number: 5 }) || "",
            type: "number",
            onChange: handleTextInputs("zipCode" /* ZipCode */),
            $errorType: formErrors["zipCode" /* ZipCode */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Feedback, { $errorType: formErrors["zipCode" /* ZipCode */]?.type, children: formErrors["zipCode" /* ZipCode */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Label, { required: true, children: t("forms:labels.county") }),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
          Form_default.Select,
          {
            disabled: !formState.state || !countiesOptions.length,
            options: countiesOptions,
            value: formState.county,
            menuPlacement: "top",
            menuPosition: "fixed",
            placeholder: t("forms:placeholders.selectOne"),
            onChanged: handleCountySelect,
            w: "100%",
            $errorType: formErrors["county" /* County */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Feedback, { $errorType: formErrors["county" /* County */]?.type, children: formErrors["county" /* County */]?.message })
      ] })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Flex_default, { flex: 1, flexDirection: "column", children: [
      /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Label, { required: true, children: t("forms:labels.city") }),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
          Form_default.Input,
          {
            placeholder: t("forms:placeholders.nameOfCity") || "",
            onChange: handleTextInputs("city" /* City */),
            $errorType: formErrors["city" /* City */]?.type,
            value: formState.city
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Feedback, { $errorType: formErrors["city" /* City */]?.type, children: formErrors["city" /* City */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Label, { required: true, children: t("forms:labels.state") }),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
          Form_default.Select,
          {
            options: statesOptions,
            menuPlacement: "top",
            menuPosition: "fixed",
            placeholder: t("forms:placeholders.selectOne"),
            w: "100%",
            onChanged: handleSelectInputs("state" /* State */),
            $errorType: formErrors["state" /* State */]?.type,
            value: formState.state
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Feedback, { $errorType: formErrors["state" /* State */]?.type, children: formErrors["state" /* State */]?.message })
      ] }),
      /* @__PURE__ */ (0, import_jsx_runtime157.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Label, { required: !isMarketOptional, children: t("forms:labels.marketArea") }),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(
          Form_default.Select,
          {
            menuPlacement: "top",
            menuPosition: "fixed",
            options: marketOptions,
            disabled: isMarketOptional,
            placeholder: t("forms:placeholders.selectOne"),
            w: "100%",
            onChanged: handleSelectInputs("market" /* Market */),
            $errorType: formErrors["market" /* Market */]?.type
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime157.jsx)(Form_default.Feedback, { $errorType: formErrors["market" /* Market */]?.type, children: formErrors["market" /* Market */]?.message })
      ] })
    ] })
  ] }) : null;
};
var AddressSection_default2 = AddressSection;

// src/components/organisms/PropertiesTable/PropertiesTableActions/AddPropertyModal/AddPropertyModal.tsx
var import_jsx_runtime158 = require("react/jsx-runtime");
var AddPropertyModal = ({
  isOpened,
  onClose,
  organizations,
  handleCreateProperty,
  loadingCreateProperty,
  loadingOrganizations,
  statesOptions,
  marketOptions
}) => {
  const { t } = (0, import_react_i18next53.useTranslation)(["forms", "common", "pages"]);
  const {
    formState,
    formErrors,
    formOnSubmit,
    formOnError,
    resetForm,
    resetFormErrors,
    stateHandlers,
    errorHandlers
  } = (0, import_react107.useContext)(FormContext);
  const formRef = (0, import_react107.useRef)(null);
  const validateFieldByName = useValidation_default2();
  const translateServerError = useServerResponseTranslation();
  const closeModal = () => {
    resetForm();
    resetFormErrors();
    onClose();
  };
  const handleTextInputs = (fieldName) => (e) => {
    const { value } = e.target;
    if (fieldName === "zipCode" /* ZipCode */) {
      if (value.length <= import_dash_common49.DashValidation.MaxZipCodeLength) {
        stateHandlers[fieldName](value);
        validateFieldByName(fieldName, value);
      }
      return;
    }
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const handleSelectInputs = (fieldName) => (value) => {
    stateHandlers[fieldName](value);
    validateFieldByName(fieldName, value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    formOnSubmit();
    const { isLoading, errorSlug, ...formValues } = formState;
    const invalidFields = Object.entries(formValues).map(([name, value]) => !validateFieldByName(name, value) && name).filter(Boolean);
    if (invalidFields.length) {
      if (invalidFields.some((field) => !NON_MANUAL_FIELDS.includes(field))) {
        stateHandlers["isShowAddress" /* IsShowAddress */](true);
      }
      return null;
    }
    handleCreateProperty(
      formValues,
      () => {
        closeModal();
      },
      (error) => {
        if (error.message === import_dash_common49.ServerErrors.PROPERTY_NAME_EXISTS) {
          return errorHandlers["name" /* Name */]({
            type: "invalid" /* Invalid */,
            message: translateServerError(error)
          });
        }
        formOnError(translateServerError(error));
      }
    );
  };
  return /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(
    Modal3,
    {
      title: t("pages:propertyPage.propertyCreateModalTitle") || "",
      isOpen: isOpened,
      onRequestClose: closeModal,
      submitButton: {
        title: t("common:labels.add"),
        isLoading: loadingCreateProperty,
        disabled: loadingCreateProperty,
        onClick: () => {
          if (formRef.current) {
            formRef.current.requestSubmit();
          }
        }
      },
      cancelButton: {
        title: t("common:labels.cancel"),
        onClick: closeModal
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime158.jsxs)(Form_default, { ref: formRef, onSubmit, children: [
        /* @__PURE__ */ (0, import_jsx_runtime158.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(Form_default.Label, { required: true, children: t("forms:labels.name") }),
          /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(
            Form_default.Input,
            {
              placeholder: t("forms:placeholders.nameOfProperty") || "",
              onChange: handleTextInputs("name" /* Name */),
              $errorType: formErrors["name" /* Name */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(Form_default.Feedback, { $errorType: formErrors["name" /* Name */]?.type, children: formErrors["name" /* Name */]?.message })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime158.jsxs)(Form_default.Group, { w: "100%", mt: 3, children: [
          /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(Form_default.Label, { required: true, children: t("forms:labels.organization") }),
          /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(
            Form_default.Select,
            {
              options: organizations.map((item) => ({
                value: item._id,
                label: item.name
              })),
              isLoading: loadingOrganizations,
              menuPosition: "fixed",
              placeholder: t("forms:placeholders.selectOne"),
              w: "100%",
              onChanged: handleSelectInputs("primaryOrganizationId" /* PrimaryOrganizationId */),
              $errorType: formErrors["primaryOrganizationId" /* PrimaryOrganizationId */]?.type
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(Form_default.Feedback, { $errorType: formErrors["primaryOrganizationId" /* PrimaryOrganizationId */]?.type, children: formErrors["primaryOrganizationId" /* PrimaryOrganizationId */]?.message })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(PlaceSection_default, {}),
        /* @__PURE__ */ (0, import_jsx_runtime158.jsx)(AddressSection_default2, { statesOptions, marketOptions })
      ] })
    }
  );
};
var AddPropertyModal_default = AddPropertyModal;

// src/components/organisms/PropertiesTable/PropertiesTableActions/PropertiesTableActions.tsx
var import_jsx_runtime159 = require("react/jsx-runtime");
function PropertiesTableActions({
  excludeStatuses = [],
  withStatusFilter,
  withCreateAction = true,
  withOrganizationsFilter,
  handleCreateProperty = import_noop.default,
  organizations = [],
  loadingCreateProperty = false,
  loadingOrganizations = false,
  filterTableName = "PROPERTIES" /* PROPERTIES */,
  statesOptions = [],
  marketOptions
}) {
  const { t } = (0, import_react_i18next54.useTranslation)("tables", { keyPrefix: "properties" });
  const { t: tLabels } = (0, import_react_i18next54.useTranslation)("common", { keyPrefix: "labels" });
  const { setSearchSlug } = (0, import_react108.useContext)(SearchContext);
  const { state: paginationState, resetPagination } = (0, import_react108.useContext)(PaginationContext);
  const { state, setFilterState } = (0, import_react108.useContext)(FilterContext);
  const [search, setSearch] = (0, import_react108.useState)("");
  const [isOpenedCreateModal, setIsOpenedCreateModal] = (0, import_react108.useState)(false);
  const statusOptions = (0, import_react108.useMemo)(
    () => [
      {
        value: import_dash_common50.PropertyStatusesEnum.PRIVATE,
        label: tLabels`private`
      },
      {
        value: import_dash_common50.PropertyStatusesEnum.PUBLIC,
        label: tLabels`public`
      },
      {
        value: import_dash_common50.PropertyStatusesEnum.DRAFT,
        label: tLabels`draft`
      }
    ].filter(({ value }) => !excludeStatuses.includes(value)),
    [tLabels, excludeStatuses]
  );
  const organizationOptions = (0, import_react108.useMemo)(
    () => organizations.map(({ _id: value, name }) => ({ value, label: name })),
    [organizations]
  );
  (0, import_react108.useEffect)(() => {
    const localFilter = localStorage2.getTableFilter(filterTableName) && JSON.parse(localStorage2.getTableFilter(filterTableName));
    if (localFilter) {
      setFilterState("statuses", localFilter.statuses);
      setFilterState("organizationId", localFilter.organizationId);
    }
  }, []);
  (0, import_react108.useEffect)(() => {
    if (!(0, import_isEmpty.default)(state)) {
      localStorage2.setTableFilter(filterTableName, state);
    }
  }, [state]);
  return /* @__PURE__ */ (0, import_jsx_runtime159.jsxs)(Flex_default, { w: "100%", px: 6, py: 4, justifyContent: "space-between", flexDirection: "row", flex: 1, children: [
    withCreateAction && /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
      AddPropertyModal_default,
      {
        marketOptions,
        isOpened: isOpenedCreateModal,
        onClose: () => setIsOpenedCreateModal(false),
        handleCreateProperty,
        organizations,
        loadingCreateProperty,
        loadingOrganizations,
        statesOptions
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(Flex_default, { flex: 1, flexDirection: "row", children: /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
      InputSearch_default,
      {
        w: "100%",
        css: "height: 40px",
        onClear: () => {
          setSearch("");
          setSearchSlug("");
          resetPagination();
        },
        value: search,
        placeholder: t`searchInputPlaceholder` || "",
        onChange: (event) => {
          resetPagination();
          setSearch(event.target.value);
          setSearchSlug(event.target.value);
        }
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime159.jsxs)(Flex_default, { children: [
      withOrganizationsFilter && /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
        Select_default,
        {
          ml: 4,
          w: 140,
          isClearable: true,
          options: organizationOptions,
          value: state.organizationId || "",
          onChanged: (organizationId) => {
            setFilterState("organizationId", organizationId);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t`organizationSelectPlaceholder`
        }
      ),
      withStatusFilter && /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
        Select_default,
        {
          ml: 4,
          w: 200,
          isMulti: true,
          options: statusOptions,
          value: state.statuses || [],
          onChanged: (_, values) => {
            setFilterState("statuses", values);
            if (paginationState.currentPage !== 0)
              resetPagination();
          },
          placeholder: t`statusSelectPlaceholder`
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(PaginationPerPageSelect, { defaultValue: null, label: `${tLabels`show`} `, w: 130, ml: 4 }),
      withCreateAction && /* @__PURE__ */ (0, import_jsx_runtime159.jsx)(
        Button_default,
        {
          ml: 4,
          icon: "plus",
          px: 5.5,
          onClick: () => setIsOpenedCreateModal(true),
          children: t`addNewButtonLabel`
        }
      )
    ] })
  ] });
}
var PropertiesTableActions_default = PropertiesTableActions;

// src/components/organisms/PropertiesTable/PropertiesTable.tsx
var import_jsx_runtime160 = require("react/jsx-runtime");
function PropertiesTable({
  actionProps,
  columns,
  data,
  loading,
  placeholder,
  placeholderImage,
  searchPlaceholder,
  searchPlaceholderImage
}) {
  const { t } = (0, import_react_i18next55.useTranslation)("tables", {
    keyPrefix: "properties"
  });
  const { t: tLabels } = (0, import_react_i18next55.useTranslation)("common", { keyPrefix: "labels" });
  const { searchSlug } = (0, import_react109.useContext)(SearchContext);
  const labelToShow = !loading ? (searchSlug ? searchPlaceholder : placeholder) || t`placeholder` || "" : "";
  const imageToShow = !loading ? searchSlug ? searchPlaceholderImage : placeholderImage : void 0;
  return /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(import_jsx_runtime160.Fragment, { children: /* @__PURE__ */ (0, import_jsx_runtime160.jsxs)("div", { style: { overflowX: "auto", width: "100%" }, children: [
    /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(PropertiesTableActions_default, { ...actionProps }),
    /* @__PURE__ */ (0, import_jsx_runtime160.jsx)(
      TableWitPagination_default,
      {
        w: "100%",
        m: 0,
        tableProps: {
          loading,
          data,
          columns,
          maxHeight: "calc(100vh - 350px)",
          stickyHeader: true,
          placeholderProps: {
            label: labelToShow,
            image: imageToShow
          }
        },
        paginationProps: {
          label: t`paginationLabel`,
          previousButtonLabel: tLabels`previous`,
          nextButtonLabel: tLabels`next`
        }
      }
    )
  ] }) });
}
var PropertiesTable_default = PropertiesTable;

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModal.tsx
var import_moment11 = __toESM(require("moment"));
var import_react110 = require("react");
var import_styled_components167 = require("styled-components");
var import_react_i18next57 = require("react-i18next");
var import_dash_common52 = require("dash-common");

// src/components/organisms/PropertyHistoryModal/components/PropertyThumbnail.tsx
var import_styled_components165 = require("styled-components");

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModel.helpers.ts
var import_react_i18next56 = require("react-i18next");
var import_dash_common51 = require("dash-common");
var getChangelogHistoryLabel = (changelog) => {
  const { t } = (0, import_react_i18next56.useTranslation)(["common"]);
  const type = changelog.type;
  if (type === import_dash_common51.PropertyChangelogTypesEnum.PROPERTY_MEDIA_UPLOADED) {
    const changelogFolderName = changelog?.afterUpdate?.folderName;
    return t(`common:historyTypesMessages.${type}`, {
      folderName: !changelogFolderName || changelogFolderName === import_dash_common51.DEFAULT_ROOT_MEDIA_FOLDER_NAME ? t("common:labels.rootMediaFolder").toLowerCase() : changelogFolderName
    });
  }
  return t(`common:historyTypesMessages.${type}`);
};

// src/components/organisms/PropertyHistoryModal/components/PropertyThumbnail.tsx
var import_jsx_runtime161 = require("react/jsx-runtime");
var PropertyThumbnail = ({ history }) => {
  const theme = (0, import_styled_components165.useTheme)();
  const file = history.property.mainPropertyMediaFile?.files[0];
  return /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)(Flex_default, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Flex_default, { minWidth: 40, w: 40, h: 40, mr: 3, children: /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Thumbnail_default, { file }) }),
    /* @__PURE__ */ (0, import_jsx_runtime161.jsxs)(Box_default, { maxWidth: [164, 264, "unset", "unset"], children: [
      /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Text_default, { ellipsis: true, semibold: true, children: history.property.name }),
      /* @__PURE__ */ (0, import_jsx_runtime161.jsx)(Text_default, { ellipsis: true, sm: true, color: theme.colors.n80, children: getChangelogHistoryLabel(history) })
    ] })
  ] });
};
var PropertyThumbnail_default = PropertyThumbnail;

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModal.styles.tsx
var import_styled_components166 = __toESM(require("styled-components"));
var HistoryTable = (0, import_styled_components166.default)(TableWitPagination_default)`
  ${({ isSecondary, theme }) => isSecondary && `
      margin-top: ${theme.space * 2}px;
      td:first-child {
        padding-left: ${theme.space * 2}px !important;
      }
      td:last-child {
        vertical-align: bottom;
        text-align: right;
      }
    `}

  @media ${({ theme }) => theme.devices.mobile} {
    & > div > div:last-child {
      justify-content: center;
    }
    tbody tr td:last-child {
      padding-right: unset;
    }
  }
`;

// src/components/organisms/PropertyHistoryModal/PropertyHistoryModal.tsx
var import_jsx_runtime162 = require("react/jsx-runtime");
var PropertyHistoryModal = ({
  data,
  loading,
  onClose,
  isOpen,
  variation = "primary",
  onRowClick,
  placeholder,
  datePeriodPickerProps
}) => {
  const {
    devices: { isMobile }
  } = useScreenResolution();
  const theme = (0, import_styled_components167.useTheme)();
  const { t } = (0, import_react_i18next57.useTranslation)(["common"]);
  const isSecondary = variation === "secondary";
  const columns = (0, import_react110.useMemo)(() => {
    return [
      {
        Header: () => t("common:labels.update"),
        accessor: "type",
        Cell: ({ row: { original } }) => /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
          Flex_default,
          {
            onClick: () => {
              if (onRowClick) {
                onRowClick(original.property._id);
              }
            },
            children: isSecondary ? /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(PropertyThumbnail_default, { history: original }) : /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(Text_default, { children: getChangelogHistoryLabel(original) })
          }
        )
      },
      {
        Header: () => t("common:labels.date"),
        accessor: "updatedAt",
        Cell: ({ value }) => {
          return /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(Text_default, { ...isSecondary && { sm: true, color: theme.colors.n80 }, children: (0, import_moment11.default)(value).format(`hh:mm, ${import_dash_common52.DATE_FORMAT}`) });
        }
      }
    ];
  }, [isSecondary]);
  return /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
    Modal3,
    {
      title: isSecondary ? t("common:history.propertyUpdates") || "" : t("common:history.historyUpdates") || "",
      isOpen,
      onRequestClose: onClose,
      closeIcon: true,
      w: [343, 576, 576, 576],
      ...datePeriodPickerProps && {
        AdditionalHeader: () => /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(Flex_default, { alignItems: "center", flex: 1, children: /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(Box_default, { children: /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(DatePeriodPicker_default, { ...datePeriodPickerProps }) }) })
      },
      children: /* @__PURE__ */ (0, import_jsx_runtime162.jsx)(
        HistoryTable,
        {
          isSecondary,
          tableProps: { data, columns, withHeader: !isSecondary, loading, placeholder },
          paginationProps: {
            nextButtonLabel: t("common:labels.next"),
            previousButtonLabel: t("common:labels.previous"),
            countPerPage: isMobile ? 3 : 7,
            label: t("tables:properties.updatePaginationLabel"),
            showPagination: false
          }
        }
      )
    }
  );
};
var PropertyHistoryModal_default = PropertyHistoryModal;

// src/components/organisms/PortfoliosTreeSelect/PortfoliosTreeSelect.tsx
var import_react_select6 = require("react-select");
var import_react111 = require("react");

// src/components/organisms/PortfoliosTreeSelect/PortfolioTreeSelect.styles.ts
var import_styled_components168 = __toESM(require("styled-components"));
var styledSelectWrapper = import_styled_components168.css`
  .select__control {
    border: unset;
    box-shadow: none;
    height: 16px;
    min-height: inherit;
    width: inherit;
    font-size: 12px;
    line-height: 16px;

    :hover {
      border-color: unset;
      box-shadow: unset;
      cursor: pointer;
    }
  }
  .select__control--is-focused {
    border-color: unset;
  }
  .select__indicator-separator {
    display: none;
  }

  .select__indicators {
    margin: unset;
    margin-left: ${({ theme }) => theme.space * 2}px;
    height: 16px;
  }

  .select__placeholder {
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.n70};
  }
`;
var Dot2 = (0, import_styled_components168.default)(Box_default)`
  border-radius: 50%;
  background-color: ${({ color: color2 }) => color2};
`;

// src/components/organisms/PortfoliosTreeSelect/components/OptionsMenu/OptionsMenu.tsx
var import_jsx_runtime163 = require("react/jsx-runtime");
var Option5 = ({ option, onClick, isSelected }) => {
  const { isVisible = true, treeIndex, label, color: color2, disabled } = option;
  return isVisible && /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Box_default, { mb: 4, children: /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)(Flex_default, { flexDirection: "row", ml: treeIndex * 8, alignItems: "center", children: [
    /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Flex_default, { children: /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
      Checkbox_default,
      {
        disabled,
        checked: isSelected,
        onChange: onClick,
        mr: 2,
        label
      }
    ) }),
    /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Flex_default, { alignItems: "center", children: !disabled && /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Dot2, { ml: 1.5, w: 8, h: 8, color: color2 }) })
  ] }) });
};
var OptionsMenu = ({
  options,
  selectedValues,
  setSelectedValues,
  setSelectedFoldersIds,
  selectedFoldersIds
}) => {
  const setValues = (option) => (checked) => {
    if (option.children) {
      if (checked) {
        setSelectedFoldersIds((prev) => [...prev, option.value]);
        return setSelectedValues((prev) => [
          ...prev,
          ...option.children.map((child) => ({
            itemId: child.value,
            parentFolderId: child.parentFolderId
          }))
        ]);
      } else {
        setSelectedFoldersIds((prev) => prev.filter((id2) => id2 !== option.value));
        return setSelectedValues(
          (prev) => prev.filter((value) => value.parentFolderId !== option.value)
        );
      }
    }
    if (checked) {
      setSelectedValues((prev) => [...prev, { itemId: option.value }]);
    } else {
      setSelectedValues((prev) => prev.filter((value) => value.itemId !== option.value));
    }
  };
  return /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(Box_default, { p: 4, pb: 0, children: options?.map((option) => {
    const isSelectedParent = selectedValues.some((value) => value.itemId === option.value);
    const isSelectedFolder = selectedFoldersIds.some((id2) => id2 === option.value);
    return /* @__PURE__ */ (0, import_jsx_runtime163.jsxs)(Box_default, { children: [
      /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
        Option5,
        {
          option,
          isSelected: isSelectedParent || isSelectedFolder,
          onClick: setValues(option)
        }
      ),
      option.children && option.children.map((child) => {
        const isSelectedChild = selectedValues.some((item) => item.itemId === child.value);
        return /* @__PURE__ */ (0, import_jsx_runtime163.jsx)(
          Option5,
          {
            option: child,
            isSelected: isSelectedChild,
            onClick: (checked) => {
              if (checked) {
                setSelectedValues((prev) => [
                  ...prev,
                  { itemId: child.value, parentFolderId: child.parentFolderId }
                ]);
              } else {
                setSelectedValues(
                  (prev) => prev.filter((value) => value.itemId !== child.value)
                );
              }
            }
          },
          child.value
        );
      })
    ] }, option.value);
  }) });
};
var OptionsMenu_default = OptionsMenu;

// src/components/organisms/PortfoliosTreeSelect/PortfoliosTreeSelect.tsx
var import_jsx_runtime164 = require("react/jsx-runtime");
var { Menu: Menu3 } = import_react_select6.components;
var ChevronUp2 = () => /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(Icon_default, { name: "arrowUp", size: 16 });
var ChevronDown2 = () => /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(Icon_default, { name: "arrowDown", size: 16 });
var PortfoliosTreeSelect = ({
  handleSelectedValues,
  options,
  selectedValues,
  setSelectedValues,
  selectedFoldersIds,
  setSelectedFoldersIds,
  ...props
}) => {
  (0, import_react111.useEffect)(() => {
    if (handleSelectedValues) {
      const values = [...selectedValues.map((value) => value.itemId), ...selectedFoldersIds];
      handleSelectedValues(values);
    }
  }, [selectedValues]);
  return /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(
    Select_default,
    {
      isMulti: true,
      isSearchable: false,
      css: styledSelectWrapper,
      options,
      components: {
        Input: () => null,
        // @ts-ignore
        DropdownIndicator: ({ isOpen }) => isOpen ? /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(ChevronUp2, {}) : /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(ChevronDown2, {}),
        Menu: (args) => /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(Menu3, { ...args, children: /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(
          OptionsMenu_default,
          {
            setSelectedFoldersIds,
            selectedFoldersIds,
            setSelectedValues,
            selectedValues,
            options
          }
        ) })
      },
      ...props,
      menuFixedWidth: false
    }
  );
};
var PortfoliosTreeSelect_default = PortfoliosTreeSelect;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  A,
  AdditionalInfoSection,
  AddressLabel,
  Alert,
  Alerts,
  AlertsContext,
  AlertsProvider,
  ApiAccessChartWidget,
  Avatar,
  AvatarUpload,
  Badge,
  Banner,
  BannerTypesEnum,
  BathsAndBedsSelect,
  Box,
  Breadcrumb,
  BrokersBanner,
  BulkActionsContext,
  BulkActionsProvider,
  Button,
  ButtonGroups,
  Card,
  CardPaymentForm,
  Checkbox,
  ColorContext,
  ColorProvider,
  CopyToClipboardButton,
  DashPlaceholder,
  DashboardBanner,
  DashboardNotificationBannerContext,
  DashboardNotificationBannerProvider,
  DatePeriodPicker,
  DatePeriodTypesEnum,
  DatePicker,
  DatePickerTimeRangeEnum,
  DatePickerWithTimeRange,
  DateRangePicker,
  DefaultPaginationValues,
  DeleteModal,
  DevelopInfoSection,
  Devider,
  Drawer,
  DropDown,
  DropdownContext,
  DropdownOptions,
  DropdownProvider,
  ExpandableText,
  FeaturesAndAmenitiesList,
  Feedback,
  FileInput,
  FileList,
  FilePreviewModal,
  FileTypeIcon,
  FileUpload,
  FilterContext,
  FilterProvider,
  FlatPagination,
  FlatPaginationContext,
  FlatPaginationProvider,
  Flex,
  Form,
  FormContext,
  FormErrorMessages,
  FormErrorTypes,
  FormProvider,
  GeneralInfoSection,
  GoogleAutocomplete,
  GoogleMap,
  Group,
  H,
  Icon,
  IconBadge,
  Image,
  InfoCard,
  Input,
  InputAutocomplete,
  InputGroup,
  InputNumber,
  InputPassword,
  InputPercentage,
  InputPhone,
  InputPrice,
  InputSearch,
  InventorySectionContext,
  InventorySectionProvider,
  InventoryTable,
  Label,
  List,
  ListWithPagination,
  LocalCashTables,
  MapSection,
  Marker,
  MarketingFiles,
  MarketingFilesContext,
  MarketingFilesProvider,
  MediaDragAndDropContext,
  MediaDragAndDropProvider,
  MediaFilePreviewCard,
  Modal,
  ModalContext,
  ModalProvider,
  ModalWithBrokerBanner,
  MultiFileUploadContext,
  MultiFileUploadProvider,
  NameSection,
  NotFoundPage,
  PageViewContext,
  PageViewProvider,
  PageViewToggle,
  PageViewTypeEnum,
  Pagination,
  PaginationContext,
  PaginationInfoLabel,
  PaginationLoadMore,
  PaginationPerPageSelect,
  PaginationProvider,
  PhoneInputMask,
  PortfoliosTreeSelect,
  PriceInputWithDropDown,
  PriceRange,
  ProgressBar,
  PropertiesTable,
  PropertyHistoryModal,
  PropertyMarker,
  PropertyPreviewNavigationTabs,
  RadioInput,
  RawNumberSelect,
  ScrollDragable,
  SearchContext,
  SearchProvider,
  Select,
  SelectPrice,
  SelectTree,
  SideBar,
  Slider,
  Slideshow,
  SlideshowPreview,
  SortByEnum,
  SortContext,
  SortHeader,
  SortProvider,
  Spinner,
  Stepper,
  Steps,
  SubscriptionRecurringSwitch,
  Table,
  TableView,
  TableViewContext,
  TableViewProvider,
  TableViewToggle,
  TableViewType,
  TableWitPagination,
  TableWithFlatPagination,
  Tabs,
  Tag,
  TagSelect,
  Text,
  Textarea,
  ThemeProvider,
  Thumbnail,
  TimePicker,
  ToastContainer,
  Toggle,
  TooltipContext,
  TooltipPopup,
  TooltipProvider,
  TooltipWrapper,
  UnauthorizedPage,
  UpgradeSubscriptionModalType,
  UploadMediaContainer,
  Video,
  ViewerContext,
  ViewerProvider,
  WasDeleted,
  WorkingHoursInput,
  WorkingWeekHoursInput,
  dictionary,
  downloadFile,
  downloadMedia,
  fetchAccessToken,
  fileUploadFetch,
  formatBathroomsRangeValues,
  formatBedroomsRangeValues,
  formatGeneralRangeValues,
  getPeriodRangeByPeriodType,
  googlePlaceToAddress,
  googleZoomLevelToMiles,
  i18next,
  isAccessTokenExpired,
  jwtDecodeSafely,
  localStorage,
  mainTheme,
  mortgage,
  priceMaxRange,
  priceMaxRangeRent,
  priceMinRange,
  priceMinRangeRent,
  toast,
  useAsyncState,
  useCheckIfSubscriptionFeatureActiveBroker,
  useFormState,
  useFormValidation,
  useFromNow,
  useGoogleApiLoader,
  useIsVisible,
  useOnClickOutside,
  useScreenResolution,
  useServerResponseTranslation,
  validatePrice
});
/*! Bundled license information:

@kurkle/color/dist/color.esm.js:
  (*!
   * @kurkle/color v0.3.2
   * https://github.com/kurkle/color#readme
   * (c) 2023 Jukka Kurkela
   * Released under the MIT License
   *)

chart.js/dist/chunks/helpers.segment.js:
  (*!
   * Chart.js v4.4.0
   * https://www.chartjs.org
   * (c) 2023 Chart.js Contributors
   * Released under the MIT License
   *)

chart.js/dist/chart.js:
  (*!
   * Chart.js v4.4.0
   * https://www.chartjs.org
   * (c) 2023 Chart.js Contributors
   * Released under the MIT License
   *)
*/
